/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from 'protobufjs/minimal';

// Common aliases
const $Reader = $protobuf.Reader,
  $Writer = $protobuf.Writer,
  $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots.scanner || ($protobuf.roots.scanner = {});

export const ScannerProtos = ($root.ScannerProtos = (() => {
  /**
   * Namespace ScannerProtos.
   * @exports ScannerProtos
   * @namespace
   */
  const ScannerProtos = {};

  ScannerProtos.ScannerService = (function () {
    /**
     * Constructs a new ScannerService service.
     * @memberof ScannerProtos
     * @classdesc Represents a ScannerService
     * @extends $protobuf.rpc.Service
     * @constructor
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     */
    function ScannerService(rpcImpl, requestDelimited, responseDelimited) {
      $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
    }

    (ScannerService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ScannerService;

    /**
     * Creates new ScannerService service using the specified rpc implementation.
     * @function create
     * @memberof ScannerProtos.ScannerService
     * @static
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     * @returns {ScannerService} RPC service. Useful where requests and/or responses are streamed.
     */
    ScannerService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
      return new this(rpcImpl, requestDelimited, responseDelimited);
    };

    /**
     * Callback as used by {@link ScannerProtos.ScannerService#executeQuery}.
     * @memberof ScannerProtos.ScannerService
     * @typedef executeQueryCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {ScannerProtos.QueryResponse} [response] QueryResponse
     */

    /**
     * Calls executeQuery.
     * @function executeQuery
     * @memberof ScannerProtos.ScannerService
     * @instance
     * @param {ScannerProtos.IQuery} request Query message or plain object
     * @param {ScannerProtos.ScannerService.executeQueryCallback} callback Node-style callback called with the error, if any, and QueryResponse
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (ScannerService.prototype.executeQuery = function executeQuery(request, callback) {
        return this.rpcCall(
          executeQuery,
          $root.ScannerProtos.Query,
          $root.ScannerProtos.QueryResponse,
          request,
          callback,
        );
      }),
      'name',
      { value: 'executeQuery' },
    );

    /**
     * Calls executeQuery.
     * @function executeQuery
     * @memberof ScannerProtos.ScannerService
     * @instance
     * @param {ScannerProtos.IQuery} request Query message or plain object
     * @returns {Promise<ScannerProtos.QueryResponse>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link ScannerProtos.ScannerService#executeQueryString}.
     * @memberof ScannerProtos.ScannerService
     * @typedef executeQueryStringCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {ScannerProtos.QueryResponse} [response] QueryResponse
     */

    /**
     * * Query using simplified, a human readable format.
     * @function executeQueryString
     * @memberof ScannerProtos.ScannerService
     * @instance
     * @param {ScannerProtos.IQueryString} request QueryString message or plain object
     * @param {ScannerProtos.ScannerService.executeQueryStringCallback} callback Node-style callback called with the error, if any, and QueryResponse
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(
      (ScannerService.prototype.executeQueryString = function executeQueryString(request, callback) {
        return this.rpcCall(
          executeQueryString,
          $root.ScannerProtos.QueryString,
          $root.ScannerProtos.QueryResponse,
          request,
          callback,
        );
      }),
      'name',
      { value: 'executeQueryString' },
    );

    /**
     * * Query using simplified, a human readable format.
     * @function executeQueryString
     * @memberof ScannerProtos.ScannerService
     * @instance
     * @param {ScannerProtos.IQueryString} request QueryString message or plain object
     * @returns {Promise<ScannerProtos.QueryResponse>} Promise
     * @variation 2
     */

    return ScannerService;
  })();

  ScannerProtos.QueryString = (function () {
    /**
     * Properties of a QueryString.
     * @memberof ScannerProtos
     * @interface IQueryString
     * @property {string|null} [query] QueryString query
     * @property {string|null} [sortField] QueryString sortField
     * @property {string|null} [fields] QueryString fields
     * @property {number|null} [limit] QueryString limit
     * @property {ScannerProtos.SortDir|null} [sortDir] QueryString sortDir
     */

    /**
     * Constructs a new QueryString.
     * @memberof ScannerProtos
     * @classdesc An alternative to using Query.
     * This is a simplified way to building a query and using the gRPC method executeQueryString()
     * See scanner_fields.json for a list of field names.
     * @implements IQueryString
     * @constructor
     * @param {ScannerProtos.IQueryString=} [properties] Properties to set
     */
    function QueryString(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * QueryString query.
     * @member {string} query
     * @memberof ScannerProtos.QueryString
     * @instance
     */
    QueryString.prototype.query = '';

    /**
     * QueryString sortField.
     * @member {string} sortField
     * @memberof ScannerProtos.QueryString
     * @instance
     */
    QueryString.prototype.sortField = '';

    /**
     * QueryString fields.
     * @member {string} fields
     * @memberof ScannerProtos.QueryString
     * @instance
     */
    QueryString.prototype.fields = '';

    /**
     * QueryString limit.
     * @member {number} limit
     * @memberof ScannerProtos.QueryString
     * @instance
     */
    QueryString.prototype.limit = 0;

    /**
     * QueryString sortDir.
     * @member {ScannerProtos.SortDir} sortDir
     * @memberof ScannerProtos.QueryString
     * @instance
     */
    QueryString.prototype.sortDir = 0;

    /**
     * Creates a new QueryString instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.QueryString
     * @static
     * @param {ScannerProtos.IQueryString=} [properties] Properties to set
     * @returns {ScannerProtos.QueryString} QueryString instance
     */
    QueryString.create = function create(properties) {
      return new QueryString(properties);
    };

    /**
     * Encodes the specified QueryString message. Does not implicitly {@link ScannerProtos.QueryString.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.QueryString
     * @static
     * @param {ScannerProtos.IQueryString} message QueryString message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QueryString.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.query != null && Object.hasOwnProperty.call(message, 'query'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.query);
      if (message.sortField != null && Object.hasOwnProperty.call(message, 'sortField'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.sortField);
      if (message.fields != null && Object.hasOwnProperty.call(message, 'fields'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.fields);
      if (message.limit != null && Object.hasOwnProperty.call(message, 'limit'))
        writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.limit);
      if (message.sortDir != null && Object.hasOwnProperty.call(message, 'sortDir'))
        writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.sortDir);
      return writer;
    };

    /**
     * Encodes the specified QueryString message, length delimited. Does not implicitly {@link ScannerProtos.QueryString.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.QueryString
     * @static
     * @param {ScannerProtos.IQueryString} message QueryString message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QueryString.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a QueryString message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.QueryString
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.QueryString} QueryString
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QueryString.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.QueryString();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.query = reader.string();
            break;
          }
          case 2: {
            message.sortField = reader.string();
            break;
          }
          case 3: {
            message.fields = reader.string();
            break;
          }
          case 4: {
            message.limit = reader.int32();
            break;
          }
          case 5: {
            message.sortDir = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a QueryString message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.QueryString
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.QueryString} QueryString
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QueryString.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a QueryString message.
     * @function verify
     * @memberof ScannerProtos.QueryString
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    QueryString.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.query != null && message.hasOwnProperty('query'))
        if (!$util.isString(message.query)) return 'query: string expected';
      if (message.sortField != null && message.hasOwnProperty('sortField'))
        if (!$util.isString(message.sortField)) return 'sortField: string expected';
      if (message.fields != null && message.hasOwnProperty('fields'))
        if (!$util.isString(message.fields)) return 'fields: string expected';
      if (message.limit != null && message.hasOwnProperty('limit'))
        if (!$util.isInteger(message.limit)) return 'limit: integer expected';
      if (message.sortDir != null && message.hasOwnProperty('sortDir'))
        switch (message.sortDir) {
          default:
            return 'sortDir: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      return null;
    };

    /**
     * Creates a QueryString message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.QueryString
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.QueryString} QueryString
     */
    QueryString.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.QueryString) return object;
      let message = new $root.ScannerProtos.QueryString();
      if (object.query != null) message.query = String(object.query);
      if (object.sortField != null) message.sortField = String(object.sortField);
      if (object.fields != null) message.fields = String(object.fields);
      if (object.limit != null) message.limit = object.limit | 0;
      switch (object.sortDir) {
        default:
          if (typeof object.sortDir === 'number') {
            message.sortDir = object.sortDir;
            break;
          }
          break;
        case 'ASC':
        case 0:
          message.sortDir = 0;
          break;
        case 'DESC':
        case 1:
          message.sortDir = 1;
          break;
        case 'DESC_ABS':
        case 2:
          message.sortDir = 2;
          break;
        case 'NONE':
        case 3:
          message.sortDir = 3;
          break;
      }
      return message;
    };

    /**
     * Creates a plain object from a QueryString message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.QueryString
     * @static
     * @param {ScannerProtos.QueryString} message QueryString
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    QueryString.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.query = '';
        object.sortField = '';
        object.fields = '';
        object.limit = 0;
        object.sortDir = options.enums === String ? 'ASC' : 0;
      }
      if (message.query != null && message.hasOwnProperty('query')) object.query = message.query;
      if (message.sortField != null && message.hasOwnProperty('sortField')) object.sortField = message.sortField;
      if (message.fields != null && message.hasOwnProperty('fields')) object.fields = message.fields;
      if (message.limit != null && message.hasOwnProperty('limit')) object.limit = message.limit;
      if (message.sortDir != null && message.hasOwnProperty('sortDir'))
        object.sortDir =
          options.enums === String
            ? $root.ScannerProtos.SortDir[message.sortDir] === undefined
              ? message.sortDir
              : $root.ScannerProtos.SortDir[message.sortDir]
            : message.sortDir;
      return object;
    };

    /**
     * Converts this QueryString to JSON.
     * @function toJSON
     * @memberof ScannerProtos.QueryString
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    QueryString.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return QueryString;
  })();

  /**
   * By default the first (none) sort is used.
   * DESC_ABS, is a special sort for showing Gainers & Losers.
   * @name ScannerProtos.SortDir
   * @enum {number}
   * @property {number} ASC=0 ASC value
   * @property {number} DESC=1 DESC value
   * @property {number} DESC_ABS=2 DESC_ABS value
   * @property {number} NONE=3 NONE value
   */
  ScannerProtos.SortDir = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'ASC')] = 0;
    values[(valuesById[1] = 'DESC')] = 1;
    values[(valuesById[2] = 'DESC_ABS')] = 2;
    values[(valuesById[3] = 'NONE')] = 3;
    return values;
  })();

  ScannerProtos.Query = (function () {
    /**
     * Properties of a Query.
     * @memberof ScannerProtos
     * @interface IQuery
     * @property {Array.<ScannerProtos.IFilter>|null} [filters] Query filters
     * @property {Array.<string>|null} [fields] Query fields
     * @property {string|null} [sortField] Query sortField
     * @property {ScannerProtos.SortDir|null} [sortDir] Query sortDir
     * @property {string|null} [filtersAsString] * Filters as a string, i.e., price_gt_1,5;exchanges_in_NYSE.
     * * If this is set, then filters is ignored.
     * @property {number|null} [limit] Query limit
     * @property {number|null} [offset] Query offset
     */

    /**
     * Constructs a new Query.
     * @memberof ScannerProtos
     * @classdesc Represents a Query.
     * @implements IQuery
     * @constructor
     * @param {ScannerProtos.IQuery=} [properties] Properties to set
     */
    function Query(properties) {
      this.filters = [];
      this.fields = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Query filters.
     * @member {Array.<ScannerProtos.IFilter>} filters
     * @memberof ScannerProtos.Query
     * @instance
     */
    Query.prototype.filters = $util.emptyArray;

    /**
     * Query fields.
     * @member {Array.<string>} fields
     * @memberof ScannerProtos.Query
     * @instance
     */
    Query.prototype.fields = $util.emptyArray;

    /**
     * Query sortField.
     * @member {string} sortField
     * @memberof ScannerProtos.Query
     * @instance
     */
    Query.prototype.sortField = '';

    /**
     * Query sortDir.
     * @member {ScannerProtos.SortDir} sortDir
     * @memberof ScannerProtos.Query
     * @instance
     */
    Query.prototype.sortDir = 0;

    /**
     * * Filters as a string, i.e., price_gt_1,5;exchanges_in_NYSE.
     * * If this is set, then filters is ignored.
     * @member {string} filtersAsString
     * @memberof ScannerProtos.Query
     * @instance
     */
    Query.prototype.filtersAsString = '';

    /**
     * Query limit.
     * @member {number} limit
     * @memberof ScannerProtos.Query
     * @instance
     */
    Query.prototype.limit = 0;

    /**
     * Query offset.
     * @member {number} offset
     * @memberof ScannerProtos.Query
     * @instance
     */
    Query.prototype.offset = 0;

    /**
     * Creates a new Query instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.Query
     * @static
     * @param {ScannerProtos.IQuery=} [properties] Properties to set
     * @returns {ScannerProtos.Query} Query instance
     */
    Query.create = function create(properties) {
      return new Query(properties);
    };

    /**
     * Encodes the specified Query message. Does not implicitly {@link ScannerProtos.Query.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.Query
     * @static
     * @param {ScannerProtos.IQuery} message Query message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Query.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.filters != null && message.filters.length)
        for (let i = 0; i < message.filters.length; ++i)
          $root.ScannerProtos.Filter.encode(
            message.filters[i],
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
          ).ldelim();
      if (message.fields != null && message.fields.length)
        for (let i = 0; i < message.fields.length; ++i)
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.fields[i]);
      if (message.sortField != null && Object.hasOwnProperty.call(message, 'sortField'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.sortField);
      if (message.sortDir != null && Object.hasOwnProperty.call(message, 'sortDir'))
        writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.sortDir);
      if (message.filtersAsString != null && Object.hasOwnProperty.call(message, 'filtersAsString'))
        writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.filtersAsString);
      if (message.limit != null && Object.hasOwnProperty.call(message, 'limit'))
        writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.limit);
      if (message.offset != null && Object.hasOwnProperty.call(message, 'offset'))
        writer.uint32(/* id 7, wireType 0 =*/ 56).int32(message.offset);
      return writer;
    };

    /**
     * Encodes the specified Query message, length delimited. Does not implicitly {@link ScannerProtos.Query.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.Query
     * @static
     * @param {ScannerProtos.IQuery} message Query message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Query.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Query message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.Query
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.Query} Query
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Query.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.Query();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (!(message.filters && message.filters.length)) message.filters = [];
            message.filters.push($root.ScannerProtos.Filter.decode(reader, reader.uint32()));
            break;
          }
          case 2: {
            if (!(message.fields && message.fields.length)) message.fields = [];
            message.fields.push(reader.string());
            break;
          }
          case 3: {
            message.sortField = reader.string();
            break;
          }
          case 4: {
            message.sortDir = reader.int32();
            break;
          }
          case 5: {
            message.filtersAsString = reader.string();
            break;
          }
          case 6: {
            message.limit = reader.int32();
            break;
          }
          case 7: {
            message.offset = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Query message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.Query
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.Query} Query
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Query.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Query message.
     * @function verify
     * @memberof ScannerProtos.Query
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Query.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.filters != null && message.hasOwnProperty('filters')) {
        if (!Array.isArray(message.filters)) return 'filters: array expected';
        for (let i = 0; i < message.filters.length; ++i) {
          let error = $root.ScannerProtos.Filter.verify(message.filters[i]);
          if (error) return 'filters.' + error;
        }
      }
      if (message.fields != null && message.hasOwnProperty('fields')) {
        if (!Array.isArray(message.fields)) return 'fields: array expected';
        for (let i = 0; i < message.fields.length; ++i)
          if (!$util.isString(message.fields[i])) return 'fields: string[] expected';
      }
      if (message.sortField != null && message.hasOwnProperty('sortField'))
        if (!$util.isString(message.sortField)) return 'sortField: string expected';
      if (message.sortDir != null && message.hasOwnProperty('sortDir'))
        switch (message.sortDir) {
          default:
            return 'sortDir: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.filtersAsString != null && message.hasOwnProperty('filtersAsString'))
        if (!$util.isString(message.filtersAsString)) return 'filtersAsString: string expected';
      if (message.limit != null && message.hasOwnProperty('limit'))
        if (!$util.isInteger(message.limit)) return 'limit: integer expected';
      if (message.offset != null && message.hasOwnProperty('offset'))
        if (!$util.isInteger(message.offset)) return 'offset: integer expected';
      return null;
    };

    /**
     * Creates a Query message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.Query
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.Query} Query
     */
    Query.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.Query) return object;
      let message = new $root.ScannerProtos.Query();
      if (object.filters) {
        if (!Array.isArray(object.filters)) throw TypeError('.ScannerProtos.Query.filters: array expected');
        message.filters = [];
        for (let i = 0; i < object.filters.length; ++i) {
          if (typeof object.filters[i] !== 'object') throw TypeError('.ScannerProtos.Query.filters: object expected');
          message.filters[i] = $root.ScannerProtos.Filter.fromObject(object.filters[i]);
        }
      }
      if (object.fields) {
        if (!Array.isArray(object.fields)) throw TypeError('.ScannerProtos.Query.fields: array expected');
        message.fields = [];
        for (let i = 0; i < object.fields.length; ++i) message.fields[i] = String(object.fields[i]);
      }
      if (object.sortField != null) message.sortField = String(object.sortField);
      switch (object.sortDir) {
        default:
          if (typeof object.sortDir === 'number') {
            message.sortDir = object.sortDir;
            break;
          }
          break;
        case 'ASC':
        case 0:
          message.sortDir = 0;
          break;
        case 'DESC':
        case 1:
          message.sortDir = 1;
          break;
        case 'DESC_ABS':
        case 2:
          message.sortDir = 2;
          break;
        case 'NONE':
        case 3:
          message.sortDir = 3;
          break;
      }
      if (object.filtersAsString != null) message.filtersAsString = String(object.filtersAsString);
      if (object.limit != null) message.limit = object.limit | 0;
      if (object.offset != null) message.offset = object.offset | 0;
      return message;
    };

    /**
     * Creates a plain object from a Query message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.Query
     * @static
     * @param {ScannerProtos.Query} message Query
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Query.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.filters = [];
        object.fields = [];
      }
      if (options.defaults) {
        object.sortField = '';
        object.sortDir = options.enums === String ? 'ASC' : 0;
        object.filtersAsString = '';
        object.limit = 0;
        object.offset = 0;
      }
      if (message.filters && message.filters.length) {
        object.filters = [];
        for (let j = 0; j < message.filters.length; ++j)
          object.filters[j] = $root.ScannerProtos.Filter.toObject(message.filters[j], options);
      }
      if (message.fields && message.fields.length) {
        object.fields = [];
        for (let j = 0; j < message.fields.length; ++j) object.fields[j] = message.fields[j];
      }
      if (message.sortField != null && message.hasOwnProperty('sortField')) object.sortField = message.sortField;
      if (message.sortDir != null && message.hasOwnProperty('sortDir'))
        object.sortDir =
          options.enums === String
            ? $root.ScannerProtos.SortDir[message.sortDir] === undefined
              ? message.sortDir
              : $root.ScannerProtos.SortDir[message.sortDir]
            : message.sortDir;
      if (message.filtersAsString != null && message.hasOwnProperty('filtersAsString'))
        object.filtersAsString = message.filtersAsString;
      if (message.limit != null && message.hasOwnProperty('limit')) object.limit = message.limit;
      if (message.offset != null && message.hasOwnProperty('offset')) object.offset = message.offset;
      return object;
    };

    /**
     * Converts this Query to JSON.
     * @function toJSON
     * @memberof ScannerProtos.Query
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Query.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Query;
  })();

  ScannerProtos.QueryResponse = (function () {
    /**
     * Properties of a QueryResponse.
     * @memberof ScannerProtos
     * @interface IQueryResponse
     * @property {CommonProtos.IErr|null} [error] QueryResponse error
     * @property {number|null} [totalInstruments] QueryResponse totalInstruments
     * @property {Array.<LastProtos.IQuote>|null} [instruments] QueryResponse instruments
     */

    /**
     * Constructs a new QueryResponse.
     * @memberof ScannerProtos
     * @classdesc Represents a QueryResponse.
     * @implements IQueryResponse
     * @constructor
     * @param {ScannerProtos.IQueryResponse=} [properties] Properties to set
     */
    function QueryResponse(properties) {
      this.instruments = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * QueryResponse error.
     * @member {CommonProtos.IErr|null|undefined} error
     * @memberof ScannerProtos.QueryResponse
     * @instance
     */
    QueryResponse.prototype.error = null;

    /**
     * QueryResponse totalInstruments.
     * @member {number} totalInstruments
     * @memberof ScannerProtos.QueryResponse
     * @instance
     */
    QueryResponse.prototype.totalInstruments = 0;

    /**
     * QueryResponse instruments.
     * @member {Array.<LastProtos.IQuote>} instruments
     * @memberof ScannerProtos.QueryResponse
     * @instance
     */
    QueryResponse.prototype.instruments = $util.emptyArray;

    /**
     * Creates a new QueryResponse instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.QueryResponse
     * @static
     * @param {ScannerProtos.IQueryResponse=} [properties] Properties to set
     * @returns {ScannerProtos.QueryResponse} QueryResponse instance
     */
    QueryResponse.create = function create(properties) {
      return new QueryResponse(properties);
    };

    /**
     * Encodes the specified QueryResponse message. Does not implicitly {@link ScannerProtos.QueryResponse.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.QueryResponse
     * @static
     * @param {ScannerProtos.IQueryResponse} message QueryResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QueryResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.error != null && Object.hasOwnProperty.call(message, 'error'))
        $root.CommonProtos.Err.encode(message.error, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
      if (message.totalInstruments != null && Object.hasOwnProperty.call(message, 'totalInstruments'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.totalInstruments);
      if (message.instruments != null && message.instruments.length)
        for (let i = 0; i < message.instruments.length; ++i)
          $root.LastProtos.Quote.encode(
            message.instruments[i],
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork(),
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified QueryResponse message, length delimited. Does not implicitly {@link ScannerProtos.QueryResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.QueryResponse
     * @static
     * @param {ScannerProtos.IQueryResponse} message QueryResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QueryResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a QueryResponse message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.QueryResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.QueryResponse} QueryResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QueryResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.QueryResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.error = $root.CommonProtos.Err.decode(reader, reader.uint32());
            break;
          }
          case 2: {
            message.totalInstruments = reader.int32();
            break;
          }
          case 3: {
            if (!(message.instruments && message.instruments.length)) message.instruments = [];
            message.instruments.push($root.LastProtos.Quote.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a QueryResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.QueryResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.QueryResponse} QueryResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QueryResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a QueryResponse message.
     * @function verify
     * @memberof ScannerProtos.QueryResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    QueryResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.error != null && message.hasOwnProperty('error')) {
        let error = $root.CommonProtos.Err.verify(message.error);
        if (error) return 'error.' + error;
      }
      if (message.totalInstruments != null && message.hasOwnProperty('totalInstruments'))
        if (!$util.isInteger(message.totalInstruments)) return 'totalInstruments: integer expected';
      if (message.instruments != null && message.hasOwnProperty('instruments')) {
        if (!Array.isArray(message.instruments)) return 'instruments: array expected';
        for (let i = 0; i < message.instruments.length; ++i) {
          let error = $root.LastProtos.Quote.verify(message.instruments[i]);
          if (error) return 'instruments.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a QueryResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.QueryResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.QueryResponse} QueryResponse
     */
    QueryResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.QueryResponse) return object;
      let message = new $root.ScannerProtos.QueryResponse();
      if (object.error != null) {
        if (typeof object.error !== 'object') throw TypeError('.ScannerProtos.QueryResponse.error: object expected');
        message.error = $root.CommonProtos.Err.fromObject(object.error);
      }
      if (object.totalInstruments != null) message.totalInstruments = object.totalInstruments | 0;
      if (object.instruments) {
        if (!Array.isArray(object.instruments))
          throw TypeError('.ScannerProtos.QueryResponse.instruments: array expected');
        message.instruments = [];
        for (let i = 0; i < object.instruments.length; ++i) {
          if (typeof object.instruments[i] !== 'object')
            throw TypeError('.ScannerProtos.QueryResponse.instruments: object expected');
          message.instruments[i] = $root.LastProtos.Quote.fromObject(object.instruments[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a QueryResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.QueryResponse
     * @static
     * @param {ScannerProtos.QueryResponse} message QueryResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    QueryResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.instruments = [];
      if (options.defaults) {
        object.error = null;
        object.totalInstruments = 0;
      }
      if (message.error != null && message.hasOwnProperty('error'))
        object.error = $root.CommonProtos.Err.toObject(message.error, options);
      if (message.totalInstruments != null && message.hasOwnProperty('totalInstruments'))
        object.totalInstruments = message.totalInstruments;
      if (message.instruments && message.instruments.length) {
        object.instruments = [];
        for (let j = 0; j < message.instruments.length; ++j)
          object.instruments[j] = $root.LastProtos.Quote.toObject(message.instruments[j], options);
      }
      return object;
    };

    /**
     * Converts this QueryResponse to JSON.
     * @function toJSON
     * @memberof ScannerProtos.QueryResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    QueryResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return QueryResponse;
  })();

  ScannerProtos.SnapshotRequest = (function () {
    /**
     * Properties of a SnapshotRequest.
     * @memberof ScannerProtos
     * @interface ISnapshotRequest
     */

    /**
     * Constructs a new SnapshotRequest.
     * @memberof ScannerProtos
     * @classdesc Represents a SnapshotRequest.
     * @implements ISnapshotRequest
     * @constructor
     * @param {ScannerProtos.ISnapshotRequest=} [properties] Properties to set
     */
    function SnapshotRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new SnapshotRequest instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.SnapshotRequest
     * @static
     * @param {ScannerProtos.ISnapshotRequest=} [properties] Properties to set
     * @returns {ScannerProtos.SnapshotRequest} SnapshotRequest instance
     */
    SnapshotRequest.create = function create(properties) {
      return new SnapshotRequest(properties);
    };

    /**
     * Encodes the specified SnapshotRequest message. Does not implicitly {@link ScannerProtos.SnapshotRequest.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.SnapshotRequest
     * @static
     * @param {ScannerProtos.ISnapshotRequest} message SnapshotRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SnapshotRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      return writer;
    };

    /**
     * Encodes the specified SnapshotRequest message, length delimited. Does not implicitly {@link ScannerProtos.SnapshotRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.SnapshotRequest
     * @static
     * @param {ScannerProtos.ISnapshotRequest} message SnapshotRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SnapshotRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SnapshotRequest message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.SnapshotRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.SnapshotRequest} SnapshotRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SnapshotRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.SnapshotRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SnapshotRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.SnapshotRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.SnapshotRequest} SnapshotRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SnapshotRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SnapshotRequest message.
     * @function verify
     * @memberof ScannerProtos.SnapshotRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SnapshotRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      return null;
    };

    /**
     * Creates a SnapshotRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.SnapshotRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.SnapshotRequest} SnapshotRequest
     */
    SnapshotRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.SnapshotRequest) return object;
      return new $root.ScannerProtos.SnapshotRequest();
    };

    /**
     * Creates a plain object from a SnapshotRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.SnapshotRequest
     * @static
     * @param {ScannerProtos.SnapshotRequest} message SnapshotRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SnapshotRequest.toObject = function toObject() {
      return {};
    };

    /**
     * Converts this SnapshotRequest to JSON.
     * @function toJSON
     * @memberof ScannerProtos.SnapshotRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SnapshotRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SnapshotRequest;
  })();

  ScannerProtos.SnapshotResponse = (function () {
    /**
     * Properties of a SnapshotResponse.
     * @memberof ScannerProtos
     * @interface ISnapshotResponse
     * @property {ScannerProtos.ISnapshot|null} [snapshot] SnapshotResponse snapshot
     */

    /**
     * Constructs a new SnapshotResponse.
     * @memberof ScannerProtos
     * @classdesc Represents a SnapshotResponse.
     * @implements ISnapshotResponse
     * @constructor
     * @param {ScannerProtos.ISnapshotResponse=} [properties] Properties to set
     */
    function SnapshotResponse(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * SnapshotResponse snapshot.
     * @member {ScannerProtos.ISnapshot|null|undefined} snapshot
     * @memberof ScannerProtos.SnapshotResponse
     * @instance
     */
    SnapshotResponse.prototype.snapshot = null;

    /**
     * Creates a new SnapshotResponse instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.SnapshotResponse
     * @static
     * @param {ScannerProtos.ISnapshotResponse=} [properties] Properties to set
     * @returns {ScannerProtos.SnapshotResponse} SnapshotResponse instance
     */
    SnapshotResponse.create = function create(properties) {
      return new SnapshotResponse(properties);
    };

    /**
     * Encodes the specified SnapshotResponse message. Does not implicitly {@link ScannerProtos.SnapshotResponse.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.SnapshotResponse
     * @static
     * @param {ScannerProtos.ISnapshotResponse} message SnapshotResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SnapshotResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.snapshot != null && Object.hasOwnProperty.call(message, 'snapshot'))
        $root.ScannerProtos.Snapshot.encode(
          message.snapshot,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified SnapshotResponse message, length delimited. Does not implicitly {@link ScannerProtos.SnapshotResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.SnapshotResponse
     * @static
     * @param {ScannerProtos.ISnapshotResponse} message SnapshotResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SnapshotResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SnapshotResponse message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.SnapshotResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.SnapshotResponse} SnapshotResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SnapshotResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.SnapshotResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.snapshot = $root.ScannerProtos.Snapshot.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a SnapshotResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.SnapshotResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.SnapshotResponse} SnapshotResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SnapshotResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SnapshotResponse message.
     * @function verify
     * @memberof ScannerProtos.SnapshotResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SnapshotResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.snapshot != null && message.hasOwnProperty('snapshot')) {
        let error = $root.ScannerProtos.Snapshot.verify(message.snapshot);
        if (error) return 'snapshot.' + error;
      }
      return null;
    };

    /**
     * Creates a SnapshotResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.SnapshotResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.SnapshotResponse} SnapshotResponse
     */
    SnapshotResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.SnapshotResponse) return object;
      let message = new $root.ScannerProtos.SnapshotResponse();
      if (object.snapshot != null) {
        if (typeof object.snapshot !== 'object')
          throw TypeError('.ScannerProtos.SnapshotResponse.snapshot: object expected');
        message.snapshot = $root.ScannerProtos.Snapshot.fromObject(object.snapshot);
      }
      return message;
    };

    /**
     * Creates a plain object from a SnapshotResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.SnapshotResponse
     * @static
     * @param {ScannerProtos.SnapshotResponse} message SnapshotResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SnapshotResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.snapshot = null;
      if (message.snapshot != null && message.hasOwnProperty('snapshot'))
        object.snapshot = $root.ScannerProtos.Snapshot.toObject(message.snapshot, options);
      return object;
    };

    /**
     * Converts this SnapshotResponse to JSON.
     * @function toJSON
     * @memberof ScannerProtos.SnapshotResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SnapshotResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SnapshotResponse;
  })();

  /**
   * Operator enum.
   * @name ScannerProtos.Operator
   * @enum {number}
   * @property {number} UNKNOWN_OPERATOR=0 UNKNOWN_OPERATOR value
   * @property {number} LT=1 LT value
   * @property {number} GT=2 GT value
   * @property {number} GTE=3 GTE value
   * @property {number} LTE=4 LTE value
   * @property {number} EQ=5 EQ value
   * @property {number} NE=6 NE value
   * @property {number} IN=7 IN value
   * @property {number} BETWEEN=8 BETWEEN value
   * @property {number} REGEEX=9 REGEEX value
   * @property {number} NOTIN=10 NOTIN value
   * @property {number} BEGINSWITH=11 BEGINSWITH value
   * @property {number} ENDSWITH=12 ENDSWITH value
   * @property {number} CONTAINS=13 CONTAINS value
   * @property {number} NOTEMPTY=14 NOTEMPTY value
   * @property {number} ISEMPTY=15 ISEMPTY value
   */
  ScannerProtos.Operator = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNKNOWN_OPERATOR')] = 0;
    values[(valuesById[1] = 'LT')] = 1;
    values[(valuesById[2] = 'GT')] = 2;
    values[(valuesById[3] = 'GTE')] = 3;
    values[(valuesById[4] = 'LTE')] = 4;
    values[(valuesById[5] = 'EQ')] = 5;
    values[(valuesById[6] = 'NE')] = 6;
    values[(valuesById[7] = 'IN')] = 7;
    values[(valuesById[8] = 'BETWEEN')] = 8;
    values[(valuesById[9] = 'REGEEX')] = 9;
    values[(valuesById[10] = 'NOTIN')] = 10;
    values[(valuesById[11] = 'BEGINSWITH')] = 11;
    values[(valuesById[12] = 'ENDSWITH')] = 12;
    values[(valuesById[13] = 'CONTAINS')] = 13;
    values[(valuesById[14] = 'NOTEMPTY')] = 14;
    values[(valuesById[15] = 'ISEMPTY')] = 15;
    return values;
  })();

  ScannerProtos.Filter = (function () {
    /**
     * Properties of a Filter.
     * @memberof ScannerProtos
     * @interface IFilter
     * @property {string|null} [dataFieldName] Filter dataFieldName
     * @property {ScannerProtos.IDoubleFilter|null} [doubleFilter] Filter doubleFilter
     * @property {ScannerProtos.ILongFilter|null} [longFilter] Filter longFilter
     * @property {ScannerProtos.IContainsFilter|null} [containsFilter] Filter containsFilter
     * @property {ScannerProtos.IEqualsFilter|null} [equalsFilter] Filter equalsFilter
     * @property {ScannerProtos.IIntFilter|null} [intFilter] Filter intFilter
     * @property {ScannerProtos.IDateFilter|null} [dateFilter] Filter dateFilter
     * @property {ScannerProtos.IGreaterThanDoubleFilter|null} [greaterThanDoubleFilter] Filter greaterThanDoubleFilter
     * @property {ScannerProtos.ILessThanDoubleFilter|null} [lessThanDoubleFilter] Filter lessThanDoubleFilter
     * @property {ScannerProtos.IGreaterThanLongFilter|null} [greaterThanLongFilter] Filter greaterThanLongFilter
     * @property {ScannerProtos.ILessThanLongFilter|null} [lessThanLongFilter] Filter lessThanLongFilter
     * @property {ScannerProtos.Operator|null} [operator] Filter operator
     * @property {Array.<string>|null} ["arguments"] Filter arguments
     */

    /**
     * Constructs a new Filter.
     * @memberof ScannerProtos
     * @classdesc Represents a Filter.
     * @implements IFilter
     * @constructor
     * @param {ScannerProtos.IFilter=} [properties] Properties to set
     */
    function Filter(properties) {
      this['arguments'] = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Filter dataFieldName.
     * @member {string} dataFieldName
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype.dataFieldName = '';

    /**
     * Filter doubleFilter.
     * @member {ScannerProtos.IDoubleFilter|null|undefined} doubleFilter
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype.doubleFilter = null;

    /**
     * Filter longFilter.
     * @member {ScannerProtos.ILongFilter|null|undefined} longFilter
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype.longFilter = null;

    /**
     * Filter containsFilter.
     * @member {ScannerProtos.IContainsFilter|null|undefined} containsFilter
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype.containsFilter = null;

    /**
     * Filter equalsFilter.
     * @member {ScannerProtos.IEqualsFilter|null|undefined} equalsFilter
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype.equalsFilter = null;

    /**
     * Filter intFilter.
     * @member {ScannerProtos.IIntFilter|null|undefined} intFilter
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype.intFilter = null;

    /**
     * Filter dateFilter.
     * @member {ScannerProtos.IDateFilter|null|undefined} dateFilter
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype.dateFilter = null;

    /**
     * Filter greaterThanDoubleFilter.
     * @member {ScannerProtos.IGreaterThanDoubleFilter|null|undefined} greaterThanDoubleFilter
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype.greaterThanDoubleFilter = null;

    /**
     * Filter lessThanDoubleFilter.
     * @member {ScannerProtos.ILessThanDoubleFilter|null|undefined} lessThanDoubleFilter
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype.lessThanDoubleFilter = null;

    /**
     * Filter greaterThanLongFilter.
     * @member {ScannerProtos.IGreaterThanLongFilter|null|undefined} greaterThanLongFilter
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype.greaterThanLongFilter = null;

    /**
     * Filter lessThanLongFilter.
     * @member {ScannerProtos.ILessThanLongFilter|null|undefined} lessThanLongFilter
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype.lessThanLongFilter = null;

    /**
     * Filter operator.
     * @member {ScannerProtos.Operator} operator
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype.operator = 0;

    /**
     * Filter arguments.
     * @member {Array.<string>} arguments
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Filter.prototype['arguments'] = $util.emptyArray;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Filter type.
     * @member {"doubleFilter"|"longFilter"|"containsFilter"|"equalsFilter"|"intFilter"|"dateFilter"|"greaterThanDoubleFilter"|"lessThanDoubleFilter"|"greaterThanLongFilter"|"lessThanLongFilter"|undefined} type
     * @memberof ScannerProtos.Filter
     * @instance
     */
    Object.defineProperty(Filter.prototype, 'type', {
      get: $util.oneOfGetter(
        ($oneOfFields = [
          'doubleFilter',
          'longFilter',
          'containsFilter',
          'equalsFilter',
          'intFilter',
          'dateFilter',
          'greaterThanDoubleFilter',
          'lessThanDoubleFilter',
          'greaterThanLongFilter',
          'lessThanLongFilter',
        ]),
      ),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new Filter instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.Filter
     * @static
     * @param {ScannerProtos.IFilter=} [properties] Properties to set
     * @returns {ScannerProtos.Filter} Filter instance
     */
    Filter.create = function create(properties) {
      return new Filter(properties);
    };

    /**
     * Encodes the specified Filter message. Does not implicitly {@link ScannerProtos.Filter.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.Filter
     * @static
     * @param {ScannerProtos.IFilter} message Filter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Filter.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.dataFieldName != null && Object.hasOwnProperty.call(message, 'dataFieldName'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.dataFieldName);
      if (message.doubleFilter != null && Object.hasOwnProperty.call(message, 'doubleFilter'))
        $root.ScannerProtos.DoubleFilter.encode(
          message.doubleFilter,
          writer.uint32(/* id 10, wireType 2 =*/ 82).fork(),
        ).ldelim();
      if (message.longFilter != null && Object.hasOwnProperty.call(message, 'longFilter'))
        $root.ScannerProtos.LongFilter.encode(
          message.longFilter,
          writer.uint32(/* id 11, wireType 2 =*/ 90).fork(),
        ).ldelim();
      if (message.containsFilter != null && Object.hasOwnProperty.call(message, 'containsFilter'))
        $root.ScannerProtos.ContainsFilter.encode(
          message.containsFilter,
          writer.uint32(/* id 12, wireType 2 =*/ 98).fork(),
        ).ldelim();
      if (message.equalsFilter != null && Object.hasOwnProperty.call(message, 'equalsFilter'))
        $root.ScannerProtos.EqualsFilter.encode(
          message.equalsFilter,
          writer.uint32(/* id 13, wireType 2 =*/ 106).fork(),
        ).ldelim();
      if (message.intFilter != null && Object.hasOwnProperty.call(message, 'intFilter'))
        $root.ScannerProtos.IntFilter.encode(
          message.intFilter,
          writer.uint32(/* id 14, wireType 2 =*/ 114).fork(),
        ).ldelim();
      if (message.dateFilter != null && Object.hasOwnProperty.call(message, 'dateFilter'))
        $root.ScannerProtos.DateFilter.encode(
          message.dateFilter,
          writer.uint32(/* id 15, wireType 2 =*/ 122).fork(),
        ).ldelim();
      if (message.greaterThanDoubleFilter != null && Object.hasOwnProperty.call(message, 'greaterThanDoubleFilter'))
        $root.ScannerProtos.GreaterThanDoubleFilter.encode(
          message.greaterThanDoubleFilter,
          writer.uint32(/* id 16, wireType 2 =*/ 130).fork(),
        ).ldelim();
      if (message.lessThanDoubleFilter != null && Object.hasOwnProperty.call(message, 'lessThanDoubleFilter'))
        $root.ScannerProtos.LessThanDoubleFilter.encode(
          message.lessThanDoubleFilter,
          writer.uint32(/* id 17, wireType 2 =*/ 138).fork(),
        ).ldelim();
      if (message.greaterThanLongFilter != null && Object.hasOwnProperty.call(message, 'greaterThanLongFilter'))
        $root.ScannerProtos.GreaterThanLongFilter.encode(
          message.greaterThanLongFilter,
          writer.uint32(/* id 18, wireType 2 =*/ 146).fork(),
        ).ldelim();
      if (message.lessThanLongFilter != null && Object.hasOwnProperty.call(message, 'lessThanLongFilter'))
        $root.ScannerProtos.LessThanLongFilter.encode(
          message.lessThanLongFilter,
          writer.uint32(/* id 19, wireType 2 =*/ 154).fork(),
        ).ldelim();
      if (message.operator != null && Object.hasOwnProperty.call(message, 'operator'))
        writer.uint32(/* id 20, wireType 0 =*/ 160).int32(message.operator);
      if (message['arguments'] != null && message['arguments'].length)
        for (let i = 0; i < message['arguments'].length; ++i)
          writer.uint32(/* id 21, wireType 2 =*/ 170).string(message['arguments'][i]);
      return writer;
    };

    /**
     * Encodes the specified Filter message, length delimited. Does not implicitly {@link ScannerProtos.Filter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.Filter
     * @static
     * @param {ScannerProtos.IFilter} message Filter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Filter.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Filter message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.Filter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.Filter} Filter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Filter.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.Filter();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.dataFieldName = reader.string();
            break;
          }
          case 10: {
            message.doubleFilter = $root.ScannerProtos.DoubleFilter.decode(reader, reader.uint32());
            break;
          }
          case 11: {
            message.longFilter = $root.ScannerProtos.LongFilter.decode(reader, reader.uint32());
            break;
          }
          case 12: {
            message.containsFilter = $root.ScannerProtos.ContainsFilter.decode(reader, reader.uint32());
            break;
          }
          case 13: {
            message.equalsFilter = $root.ScannerProtos.EqualsFilter.decode(reader, reader.uint32());
            break;
          }
          case 14: {
            message.intFilter = $root.ScannerProtos.IntFilter.decode(reader, reader.uint32());
            break;
          }
          case 15: {
            message.dateFilter = $root.ScannerProtos.DateFilter.decode(reader, reader.uint32());
            break;
          }
          case 16: {
            message.greaterThanDoubleFilter = $root.ScannerProtos.GreaterThanDoubleFilter.decode(
              reader,
              reader.uint32(),
            );
            break;
          }
          case 17: {
            message.lessThanDoubleFilter = $root.ScannerProtos.LessThanDoubleFilter.decode(reader, reader.uint32());
            break;
          }
          case 18: {
            message.greaterThanLongFilter = $root.ScannerProtos.GreaterThanLongFilter.decode(reader, reader.uint32());
            break;
          }
          case 19: {
            message.lessThanLongFilter = $root.ScannerProtos.LessThanLongFilter.decode(reader, reader.uint32());
            break;
          }
          case 20: {
            message.operator = reader.int32();
            break;
          }
          case 21: {
            if (!(message['arguments'] && message['arguments'].length)) message['arguments'] = [];
            message['arguments'].push(reader.string());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Filter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.Filter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.Filter} Filter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Filter.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Filter message.
     * @function verify
     * @memberof ScannerProtos.Filter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Filter.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      let properties = {};
      if (message.dataFieldName != null && message.hasOwnProperty('dataFieldName'))
        if (!$util.isString(message.dataFieldName)) return 'dataFieldName: string expected';
      if (message.doubleFilter != null && message.hasOwnProperty('doubleFilter')) {
        properties.type = 1;
        {
          let error = $root.ScannerProtos.DoubleFilter.verify(message.doubleFilter);
          if (error) return 'doubleFilter.' + error;
        }
      }
      if (message.longFilter != null && message.hasOwnProperty('longFilter')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.LongFilter.verify(message.longFilter);
          if (error) return 'longFilter.' + error;
        }
      }
      if (message.containsFilter != null && message.hasOwnProperty('containsFilter')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.ContainsFilter.verify(message.containsFilter);
          if (error) return 'containsFilter.' + error;
        }
      }
      if (message.equalsFilter != null && message.hasOwnProperty('equalsFilter')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.EqualsFilter.verify(message.equalsFilter);
          if (error) return 'equalsFilter.' + error;
        }
      }
      if (message.intFilter != null && message.hasOwnProperty('intFilter')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.IntFilter.verify(message.intFilter);
          if (error) return 'intFilter.' + error;
        }
      }
      if (message.dateFilter != null && message.hasOwnProperty('dateFilter')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.DateFilter.verify(message.dateFilter);
          if (error) return 'dateFilter.' + error;
        }
      }
      if (message.greaterThanDoubleFilter != null && message.hasOwnProperty('greaterThanDoubleFilter')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.GreaterThanDoubleFilter.verify(message.greaterThanDoubleFilter);
          if (error) return 'greaterThanDoubleFilter.' + error;
        }
      }
      if (message.lessThanDoubleFilter != null && message.hasOwnProperty('lessThanDoubleFilter')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.LessThanDoubleFilter.verify(message.lessThanDoubleFilter);
          if (error) return 'lessThanDoubleFilter.' + error;
        }
      }
      if (message.greaterThanLongFilter != null && message.hasOwnProperty('greaterThanLongFilter')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.GreaterThanLongFilter.verify(message.greaterThanLongFilter);
          if (error) return 'greaterThanLongFilter.' + error;
        }
      }
      if (message.lessThanLongFilter != null && message.hasOwnProperty('lessThanLongFilter')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.LessThanLongFilter.verify(message.lessThanLongFilter);
          if (error) return 'lessThanLongFilter.' + error;
        }
      }
      if (message.operator != null && message.hasOwnProperty('operator'))
        switch (message.operator) {
          default:
            return 'operator: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
          case 13:
          case 14:
          case 15:
            break;
        }
      if (message['arguments'] != null && message.hasOwnProperty('arguments')) {
        if (!Array.isArray(message['arguments'])) return 'arguments: array expected';
        for (let i = 0; i < message['arguments'].length; ++i)
          if (!$util.isString(message['arguments'][i])) return 'arguments: string[] expected';
      }
      return null;
    };

    /**
     * Creates a Filter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.Filter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.Filter} Filter
     */
    Filter.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.Filter) return object;
      let message = new $root.ScannerProtos.Filter();
      if (object.dataFieldName != null) message.dataFieldName = String(object.dataFieldName);
      if (object.doubleFilter != null) {
        if (typeof object.doubleFilter !== 'object')
          throw TypeError('.ScannerProtos.Filter.doubleFilter: object expected');
        message.doubleFilter = $root.ScannerProtos.DoubleFilter.fromObject(object.doubleFilter);
      }
      if (object.longFilter != null) {
        if (typeof object.longFilter !== 'object') throw TypeError('.ScannerProtos.Filter.longFilter: object expected');
        message.longFilter = $root.ScannerProtos.LongFilter.fromObject(object.longFilter);
      }
      if (object.containsFilter != null) {
        if (typeof object.containsFilter !== 'object')
          throw TypeError('.ScannerProtos.Filter.containsFilter: object expected');
        message.containsFilter = $root.ScannerProtos.ContainsFilter.fromObject(object.containsFilter);
      }
      if (object.equalsFilter != null) {
        if (typeof object.equalsFilter !== 'object')
          throw TypeError('.ScannerProtos.Filter.equalsFilter: object expected');
        message.equalsFilter = $root.ScannerProtos.EqualsFilter.fromObject(object.equalsFilter);
      }
      if (object.intFilter != null) {
        if (typeof object.intFilter !== 'object') throw TypeError('.ScannerProtos.Filter.intFilter: object expected');
        message.intFilter = $root.ScannerProtos.IntFilter.fromObject(object.intFilter);
      }
      if (object.dateFilter != null) {
        if (typeof object.dateFilter !== 'object') throw TypeError('.ScannerProtos.Filter.dateFilter: object expected');
        message.dateFilter = $root.ScannerProtos.DateFilter.fromObject(object.dateFilter);
      }
      if (object.greaterThanDoubleFilter != null) {
        if (typeof object.greaterThanDoubleFilter !== 'object')
          throw TypeError('.ScannerProtos.Filter.greaterThanDoubleFilter: object expected');
        message.greaterThanDoubleFilter = $root.ScannerProtos.GreaterThanDoubleFilter.fromObject(
          object.greaterThanDoubleFilter,
        );
      }
      if (object.lessThanDoubleFilter != null) {
        if (typeof object.lessThanDoubleFilter !== 'object')
          throw TypeError('.ScannerProtos.Filter.lessThanDoubleFilter: object expected');
        message.lessThanDoubleFilter = $root.ScannerProtos.LessThanDoubleFilter.fromObject(object.lessThanDoubleFilter);
      }
      if (object.greaterThanLongFilter != null) {
        if (typeof object.greaterThanLongFilter !== 'object')
          throw TypeError('.ScannerProtos.Filter.greaterThanLongFilter: object expected');
        message.greaterThanLongFilter = $root.ScannerProtos.GreaterThanLongFilter.fromObject(
          object.greaterThanLongFilter,
        );
      }
      if (object.lessThanLongFilter != null) {
        if (typeof object.lessThanLongFilter !== 'object')
          throw TypeError('.ScannerProtos.Filter.lessThanLongFilter: object expected');
        message.lessThanLongFilter = $root.ScannerProtos.LessThanLongFilter.fromObject(object.lessThanLongFilter);
      }
      switch (object.operator) {
        default:
          if (typeof object.operator === 'number') {
            message.operator = object.operator;
            break;
          }
          break;
        case 'UNKNOWN_OPERATOR':
        case 0:
          message.operator = 0;
          break;
        case 'LT':
        case 1:
          message.operator = 1;
          break;
        case 'GT':
        case 2:
          message.operator = 2;
          break;
        case 'GTE':
        case 3:
          message.operator = 3;
          break;
        case 'LTE':
        case 4:
          message.operator = 4;
          break;
        case 'EQ':
        case 5:
          message.operator = 5;
          break;
        case 'NE':
        case 6:
          message.operator = 6;
          break;
        case 'IN':
        case 7:
          message.operator = 7;
          break;
        case 'BETWEEN':
        case 8:
          message.operator = 8;
          break;
        case 'REGEEX':
        case 9:
          message.operator = 9;
          break;
        case 'NOTIN':
        case 10:
          message.operator = 10;
          break;
        case 'BEGINSWITH':
        case 11:
          message.operator = 11;
          break;
        case 'ENDSWITH':
        case 12:
          message.operator = 12;
          break;
        case 'CONTAINS':
        case 13:
          message.operator = 13;
          break;
        case 'NOTEMPTY':
        case 14:
          message.operator = 14;
          break;
        case 'ISEMPTY':
        case 15:
          message.operator = 15;
          break;
      }
      if (object['arguments']) {
        if (!Array.isArray(object['arguments'])) throw TypeError('.ScannerProtos.Filter.arguments: array expected');
        message['arguments'] = [];
        for (let i = 0; i < object['arguments'].length; ++i) message['arguments'][i] = String(object['arguments'][i]);
      }
      return message;
    };

    /**
     * Creates a plain object from a Filter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.Filter
     * @static
     * @param {ScannerProtos.Filter} message Filter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Filter.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object['arguments'] = [];
      if (options.defaults) {
        object.dataFieldName = '';
        object.operator = options.enums === String ? 'UNKNOWN_OPERATOR' : 0;
      }
      if (message.dataFieldName != null && message.hasOwnProperty('dataFieldName'))
        object.dataFieldName = message.dataFieldName;
      if (message.doubleFilter != null && message.hasOwnProperty('doubleFilter')) {
        object.doubleFilter = $root.ScannerProtos.DoubleFilter.toObject(message.doubleFilter, options);
        if (options.oneofs) object.type = 'doubleFilter';
      }
      if (message.longFilter != null && message.hasOwnProperty('longFilter')) {
        object.longFilter = $root.ScannerProtos.LongFilter.toObject(message.longFilter, options);
        if (options.oneofs) object.type = 'longFilter';
      }
      if (message.containsFilter != null && message.hasOwnProperty('containsFilter')) {
        object.containsFilter = $root.ScannerProtos.ContainsFilter.toObject(message.containsFilter, options);
        if (options.oneofs) object.type = 'containsFilter';
      }
      if (message.equalsFilter != null && message.hasOwnProperty('equalsFilter')) {
        object.equalsFilter = $root.ScannerProtos.EqualsFilter.toObject(message.equalsFilter, options);
        if (options.oneofs) object.type = 'equalsFilter';
      }
      if (message.intFilter != null && message.hasOwnProperty('intFilter')) {
        object.intFilter = $root.ScannerProtos.IntFilter.toObject(message.intFilter, options);
        if (options.oneofs) object.type = 'intFilter';
      }
      if (message.dateFilter != null && message.hasOwnProperty('dateFilter')) {
        object.dateFilter = $root.ScannerProtos.DateFilter.toObject(message.dateFilter, options);
        if (options.oneofs) object.type = 'dateFilter';
      }
      if (message.greaterThanDoubleFilter != null && message.hasOwnProperty('greaterThanDoubleFilter')) {
        object.greaterThanDoubleFilter = $root.ScannerProtos.GreaterThanDoubleFilter.toObject(
          message.greaterThanDoubleFilter,
          options,
        );
        if (options.oneofs) object.type = 'greaterThanDoubleFilter';
      }
      if (message.lessThanDoubleFilter != null && message.hasOwnProperty('lessThanDoubleFilter')) {
        object.lessThanDoubleFilter = $root.ScannerProtos.LessThanDoubleFilter.toObject(
          message.lessThanDoubleFilter,
          options,
        );
        if (options.oneofs) object.type = 'lessThanDoubleFilter';
      }
      if (message.greaterThanLongFilter != null && message.hasOwnProperty('greaterThanLongFilter')) {
        object.greaterThanLongFilter = $root.ScannerProtos.GreaterThanLongFilter.toObject(
          message.greaterThanLongFilter,
          options,
        );
        if (options.oneofs) object.type = 'greaterThanLongFilter';
      }
      if (message.lessThanLongFilter != null && message.hasOwnProperty('lessThanLongFilter')) {
        object.lessThanLongFilter = $root.ScannerProtos.LessThanLongFilter.toObject(
          message.lessThanLongFilter,
          options,
        );
        if (options.oneofs) object.type = 'lessThanLongFilter';
      }
      if (message.operator != null && message.hasOwnProperty('operator'))
        object.operator =
          options.enums === String
            ? $root.ScannerProtos.Operator[message.operator] === undefined
              ? message.operator
              : $root.ScannerProtos.Operator[message.operator]
            : message.operator;
      if (message['arguments'] && message['arguments'].length) {
        object['arguments'] = [];
        for (let j = 0; j < message['arguments'].length; ++j) object['arguments'][j] = message['arguments'][j];
      }
      return object;
    };

    /**
     * Converts this Filter to JSON.
     * @function toJSON
     * @memberof ScannerProtos.Filter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Filter.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Filter;
  })();

  ScannerProtos.EqualsFilter = (function () {
    /**
     * Properties of an EqualsFilter.
     * @memberof ScannerProtos
     * @interface IEqualsFilter
     * @property {string|null} [stringValue] EqualsFilter stringValue
     */

    /**
     * Constructs a new EqualsFilter.
     * @memberof ScannerProtos
     * @classdesc Represents an EqualsFilter.
     * @implements IEqualsFilter
     * @constructor
     * @param {ScannerProtos.IEqualsFilter=} [properties] Properties to set
     */
    function EqualsFilter(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * EqualsFilter stringValue.
     * @member {string} stringValue
     * @memberof ScannerProtos.EqualsFilter
     * @instance
     */
    EqualsFilter.prototype.stringValue = '';

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * EqualsFilter type.
     * @member {"stringValue"|undefined} type
     * @memberof ScannerProtos.EqualsFilter
     * @instance
     */
    Object.defineProperty(EqualsFilter.prototype, 'type', {
      get: $util.oneOfGetter(($oneOfFields = ['stringValue'])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new EqualsFilter instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.EqualsFilter
     * @static
     * @param {ScannerProtos.IEqualsFilter=} [properties] Properties to set
     * @returns {ScannerProtos.EqualsFilter} EqualsFilter instance
     */
    EqualsFilter.create = function create(properties) {
      return new EqualsFilter(properties);
    };

    /**
     * Encodes the specified EqualsFilter message. Does not implicitly {@link ScannerProtos.EqualsFilter.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.EqualsFilter
     * @static
     * @param {ScannerProtos.IEqualsFilter} message EqualsFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EqualsFilter.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.stringValue != null && Object.hasOwnProperty.call(message, 'stringValue'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.stringValue);
      return writer;
    };

    /**
     * Encodes the specified EqualsFilter message, length delimited. Does not implicitly {@link ScannerProtos.EqualsFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.EqualsFilter
     * @static
     * @param {ScannerProtos.IEqualsFilter} message EqualsFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EqualsFilter.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an EqualsFilter message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.EqualsFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.EqualsFilter} EqualsFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EqualsFilter.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.EqualsFilter();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.stringValue = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an EqualsFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.EqualsFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.EqualsFilter} EqualsFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EqualsFilter.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an EqualsFilter message.
     * @function verify
     * @memberof ScannerProtos.EqualsFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    EqualsFilter.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      let properties = {};
      if (message.stringValue != null && message.hasOwnProperty('stringValue')) {
        properties.type = 1;
        if (!$util.isString(message.stringValue)) return 'stringValue: string expected';
      }
      return null;
    };

    /**
     * Creates an EqualsFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.EqualsFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.EqualsFilter} EqualsFilter
     */
    EqualsFilter.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.EqualsFilter) return object;
      let message = new $root.ScannerProtos.EqualsFilter();
      if (object.stringValue != null) message.stringValue = String(object.stringValue);
      return message;
    };

    /**
     * Creates a plain object from an EqualsFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.EqualsFilter
     * @static
     * @param {ScannerProtos.EqualsFilter} message EqualsFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EqualsFilter.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (message.stringValue != null && message.hasOwnProperty('stringValue')) {
        object.stringValue = message.stringValue;
        if (options.oneofs) object.type = 'stringValue';
      }
      return object;
    };

    /**
     * Converts this EqualsFilter to JSON.
     * @function toJSON
     * @memberof ScannerProtos.EqualsFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EqualsFilter.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EqualsFilter;
  })();

  ScannerProtos.GreaterThanDoubleFilter = (function () {
    /**
     * Properties of a GreaterThanDoubleFilter.
     * @memberof ScannerProtos
     * @interface IGreaterThanDoubleFilter
     * @property {number|null} [value] GreaterThanDoubleFilter value
     */

    /**
     * Constructs a new GreaterThanDoubleFilter.
     * @memberof ScannerProtos
     * @classdesc Represents a GreaterThanDoubleFilter.
     * @implements IGreaterThanDoubleFilter
     * @constructor
     * @param {ScannerProtos.IGreaterThanDoubleFilter=} [properties] Properties to set
     */
    function GreaterThanDoubleFilter(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GreaterThanDoubleFilter value.
     * @member {number} value
     * @memberof ScannerProtos.GreaterThanDoubleFilter
     * @instance
     */
    GreaterThanDoubleFilter.prototype.value = 0;

    /**
     * Creates a new GreaterThanDoubleFilter instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.GreaterThanDoubleFilter
     * @static
     * @param {ScannerProtos.IGreaterThanDoubleFilter=} [properties] Properties to set
     * @returns {ScannerProtos.GreaterThanDoubleFilter} GreaterThanDoubleFilter instance
     */
    GreaterThanDoubleFilter.create = function create(properties) {
      return new GreaterThanDoubleFilter(properties);
    };

    /**
     * Encodes the specified GreaterThanDoubleFilter message. Does not implicitly {@link ScannerProtos.GreaterThanDoubleFilter.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.GreaterThanDoubleFilter
     * @static
     * @param {ScannerProtos.IGreaterThanDoubleFilter} message GreaterThanDoubleFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreaterThanDoubleFilter.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.value);
      return writer;
    };

    /**
     * Encodes the specified GreaterThanDoubleFilter message, length delimited. Does not implicitly {@link ScannerProtos.GreaterThanDoubleFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.GreaterThanDoubleFilter
     * @static
     * @param {ScannerProtos.IGreaterThanDoubleFilter} message GreaterThanDoubleFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreaterThanDoubleFilter.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GreaterThanDoubleFilter message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.GreaterThanDoubleFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.GreaterThanDoubleFilter} GreaterThanDoubleFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreaterThanDoubleFilter.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.GreaterThanDoubleFilter();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.value = reader.double();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GreaterThanDoubleFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.GreaterThanDoubleFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.GreaterThanDoubleFilter} GreaterThanDoubleFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreaterThanDoubleFilter.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GreaterThanDoubleFilter message.
     * @function verify
     * @memberof ScannerProtos.GreaterThanDoubleFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GreaterThanDoubleFilter.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (typeof message.value !== 'number') return 'value: number expected';
      return null;
    };

    /**
     * Creates a GreaterThanDoubleFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.GreaterThanDoubleFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.GreaterThanDoubleFilter} GreaterThanDoubleFilter
     */
    GreaterThanDoubleFilter.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.GreaterThanDoubleFilter) return object;
      let message = new $root.ScannerProtos.GreaterThanDoubleFilter();
      if (object.value != null) message.value = Number(object.value);
      return message;
    };

    /**
     * Creates a plain object from a GreaterThanDoubleFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.GreaterThanDoubleFilter
     * @static
     * @param {ScannerProtos.GreaterThanDoubleFilter} message GreaterThanDoubleFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GreaterThanDoubleFilter.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.value = 0;
      if (message.value != null && message.hasOwnProperty('value'))
        object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
      return object;
    };

    /**
     * Converts this GreaterThanDoubleFilter to JSON.
     * @function toJSON
     * @memberof ScannerProtos.GreaterThanDoubleFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GreaterThanDoubleFilter.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GreaterThanDoubleFilter;
  })();

  ScannerProtos.LessThanDoubleFilter = (function () {
    /**
     * Properties of a LessThanDoubleFilter.
     * @memberof ScannerProtos
     * @interface ILessThanDoubleFilter
     * @property {number|null} [value] LessThanDoubleFilter value
     */

    /**
     * Constructs a new LessThanDoubleFilter.
     * @memberof ScannerProtos
     * @classdesc Represents a LessThanDoubleFilter.
     * @implements ILessThanDoubleFilter
     * @constructor
     * @param {ScannerProtos.ILessThanDoubleFilter=} [properties] Properties to set
     */
    function LessThanDoubleFilter(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * LessThanDoubleFilter value.
     * @member {number} value
     * @memberof ScannerProtos.LessThanDoubleFilter
     * @instance
     */
    LessThanDoubleFilter.prototype.value = 0;

    /**
     * Creates a new LessThanDoubleFilter instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.LessThanDoubleFilter
     * @static
     * @param {ScannerProtos.ILessThanDoubleFilter=} [properties] Properties to set
     * @returns {ScannerProtos.LessThanDoubleFilter} LessThanDoubleFilter instance
     */
    LessThanDoubleFilter.create = function create(properties) {
      return new LessThanDoubleFilter(properties);
    };

    /**
     * Encodes the specified LessThanDoubleFilter message. Does not implicitly {@link ScannerProtos.LessThanDoubleFilter.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.LessThanDoubleFilter
     * @static
     * @param {ScannerProtos.ILessThanDoubleFilter} message LessThanDoubleFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LessThanDoubleFilter.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.value);
      return writer;
    };

    /**
     * Encodes the specified LessThanDoubleFilter message, length delimited. Does not implicitly {@link ScannerProtos.LessThanDoubleFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.LessThanDoubleFilter
     * @static
     * @param {ScannerProtos.ILessThanDoubleFilter} message LessThanDoubleFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LessThanDoubleFilter.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LessThanDoubleFilter message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.LessThanDoubleFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.LessThanDoubleFilter} LessThanDoubleFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LessThanDoubleFilter.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.LessThanDoubleFilter();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.value = reader.double();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a LessThanDoubleFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.LessThanDoubleFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.LessThanDoubleFilter} LessThanDoubleFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LessThanDoubleFilter.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LessThanDoubleFilter message.
     * @function verify
     * @memberof ScannerProtos.LessThanDoubleFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LessThanDoubleFilter.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (typeof message.value !== 'number') return 'value: number expected';
      return null;
    };

    /**
     * Creates a LessThanDoubleFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.LessThanDoubleFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.LessThanDoubleFilter} LessThanDoubleFilter
     */
    LessThanDoubleFilter.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.LessThanDoubleFilter) return object;
      let message = new $root.ScannerProtos.LessThanDoubleFilter();
      if (object.value != null) message.value = Number(object.value);
      return message;
    };

    /**
     * Creates a plain object from a LessThanDoubleFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.LessThanDoubleFilter
     * @static
     * @param {ScannerProtos.LessThanDoubleFilter} message LessThanDoubleFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LessThanDoubleFilter.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.value = 0;
      if (message.value != null && message.hasOwnProperty('value'))
        object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
      return object;
    };

    /**
     * Converts this LessThanDoubleFilter to JSON.
     * @function toJSON
     * @memberof ScannerProtos.LessThanDoubleFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LessThanDoubleFilter.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LessThanDoubleFilter;
  })();

  ScannerProtos.GreaterThanLongFilter = (function () {
    /**
     * Properties of a GreaterThanLongFilter.
     * @memberof ScannerProtos
     * @interface IGreaterThanLongFilter
     * @property {number|Long|null} [value] GreaterThanLongFilter value
     */

    /**
     * Constructs a new GreaterThanLongFilter.
     * @memberof ScannerProtos
     * @classdesc Represents a GreaterThanLongFilter.
     * @implements IGreaterThanLongFilter
     * @constructor
     * @param {ScannerProtos.IGreaterThanLongFilter=} [properties] Properties to set
     */
    function GreaterThanLongFilter(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * GreaterThanLongFilter value.
     * @member {number|Long} value
     * @memberof ScannerProtos.GreaterThanLongFilter
     * @instance
     */
    GreaterThanLongFilter.prototype.value = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Creates a new GreaterThanLongFilter instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.GreaterThanLongFilter
     * @static
     * @param {ScannerProtos.IGreaterThanLongFilter=} [properties] Properties to set
     * @returns {ScannerProtos.GreaterThanLongFilter} GreaterThanLongFilter instance
     */
    GreaterThanLongFilter.create = function create(properties) {
      return new GreaterThanLongFilter(properties);
    };

    /**
     * Encodes the specified GreaterThanLongFilter message. Does not implicitly {@link ScannerProtos.GreaterThanLongFilter.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.GreaterThanLongFilter
     * @static
     * @param {ScannerProtos.IGreaterThanLongFilter} message GreaterThanLongFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreaterThanLongFilter.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.value);
      return writer;
    };

    /**
     * Encodes the specified GreaterThanLongFilter message, length delimited. Does not implicitly {@link ScannerProtos.GreaterThanLongFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.GreaterThanLongFilter
     * @static
     * @param {ScannerProtos.IGreaterThanLongFilter} message GreaterThanLongFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GreaterThanLongFilter.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GreaterThanLongFilter message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.GreaterThanLongFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.GreaterThanLongFilter} GreaterThanLongFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreaterThanLongFilter.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.GreaterThanLongFilter();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.value = reader.int64();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a GreaterThanLongFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.GreaterThanLongFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.GreaterThanLongFilter} GreaterThanLongFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GreaterThanLongFilter.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GreaterThanLongFilter message.
     * @function verify
     * @memberof ScannerProtos.GreaterThanLongFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GreaterThanLongFilter.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (
          !$util.isInteger(message.value) &&
          !(message.value && $util.isInteger(message.value.low) && $util.isInteger(message.value.high))
        )
          return 'value: integer|Long expected';
      return null;
    };

    /**
     * Creates a GreaterThanLongFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.GreaterThanLongFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.GreaterThanLongFilter} GreaterThanLongFilter
     */
    GreaterThanLongFilter.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.GreaterThanLongFilter) return object;
      let message = new $root.ScannerProtos.GreaterThanLongFilter();
      if (object.value != null)
        if ($util.Long) (message.value = $util.Long.fromValue(object.value)).unsigned = false;
        else if (typeof object.value === 'string') message.value = parseInt(object.value, 10);
        else if (typeof object.value === 'number') message.value = object.value;
        else if (typeof object.value === 'object')
          message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber();
      return message;
    };

    /**
     * Creates a plain object from a GreaterThanLongFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.GreaterThanLongFilter
     * @static
     * @param {ScannerProtos.GreaterThanLongFilter} message GreaterThanLongFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GreaterThanLongFilter.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults)
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.value = options.longs === String ? '0' : 0;
      if (message.value != null && message.hasOwnProperty('value'))
        if (typeof message.value === 'number')
          object.value = options.longs === String ? String(message.value) : message.value;
        else
          object.value =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.value)
              : options.longs === Number
                ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber()
                : message.value;
      return object;
    };

    /**
     * Converts this GreaterThanLongFilter to JSON.
     * @function toJSON
     * @memberof ScannerProtos.GreaterThanLongFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GreaterThanLongFilter.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GreaterThanLongFilter;
  })();

  ScannerProtos.LessThanLongFilter = (function () {
    /**
     * Properties of a LessThanLongFilter.
     * @memberof ScannerProtos
     * @interface ILessThanLongFilter
     * @property {number|Long|null} [value] LessThanLongFilter value
     */

    /**
     * Constructs a new LessThanLongFilter.
     * @memberof ScannerProtos
     * @classdesc Represents a LessThanLongFilter.
     * @implements ILessThanLongFilter
     * @constructor
     * @param {ScannerProtos.ILessThanLongFilter=} [properties] Properties to set
     */
    function LessThanLongFilter(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * LessThanLongFilter value.
     * @member {number|Long} value
     * @memberof ScannerProtos.LessThanLongFilter
     * @instance
     */
    LessThanLongFilter.prototype.value = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Creates a new LessThanLongFilter instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.LessThanLongFilter
     * @static
     * @param {ScannerProtos.ILessThanLongFilter=} [properties] Properties to set
     * @returns {ScannerProtos.LessThanLongFilter} LessThanLongFilter instance
     */
    LessThanLongFilter.create = function create(properties) {
      return new LessThanLongFilter(properties);
    };

    /**
     * Encodes the specified LessThanLongFilter message. Does not implicitly {@link ScannerProtos.LessThanLongFilter.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.LessThanLongFilter
     * @static
     * @param {ScannerProtos.ILessThanLongFilter} message LessThanLongFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LessThanLongFilter.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.value);
      return writer;
    };

    /**
     * Encodes the specified LessThanLongFilter message, length delimited. Does not implicitly {@link ScannerProtos.LessThanLongFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.LessThanLongFilter
     * @static
     * @param {ScannerProtos.ILessThanLongFilter} message LessThanLongFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LessThanLongFilter.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LessThanLongFilter message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.LessThanLongFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.LessThanLongFilter} LessThanLongFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LessThanLongFilter.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.LessThanLongFilter();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.value = reader.int64();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a LessThanLongFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.LessThanLongFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.LessThanLongFilter} LessThanLongFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LessThanLongFilter.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LessThanLongFilter message.
     * @function verify
     * @memberof ScannerProtos.LessThanLongFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LessThanLongFilter.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (
          !$util.isInteger(message.value) &&
          !(message.value && $util.isInteger(message.value.low) && $util.isInteger(message.value.high))
        )
          return 'value: integer|Long expected';
      return null;
    };

    /**
     * Creates a LessThanLongFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.LessThanLongFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.LessThanLongFilter} LessThanLongFilter
     */
    LessThanLongFilter.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.LessThanLongFilter) return object;
      let message = new $root.ScannerProtos.LessThanLongFilter();
      if (object.value != null)
        if ($util.Long) (message.value = $util.Long.fromValue(object.value)).unsigned = false;
        else if (typeof object.value === 'string') message.value = parseInt(object.value, 10);
        else if (typeof object.value === 'number') message.value = object.value;
        else if (typeof object.value === 'object')
          message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber();
      return message;
    };

    /**
     * Creates a plain object from a LessThanLongFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.LessThanLongFilter
     * @static
     * @param {ScannerProtos.LessThanLongFilter} message LessThanLongFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LessThanLongFilter.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults)
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.value = options.longs === String ? '0' : 0;
      if (message.value != null && message.hasOwnProperty('value'))
        if (typeof message.value === 'number')
          object.value = options.longs === String ? String(message.value) : message.value;
        else
          object.value =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.value)
              : options.longs === Number
                ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber()
                : message.value;
      return object;
    };

    /**
     * Converts this LessThanLongFilter to JSON.
     * @function toJSON
     * @memberof ScannerProtos.LessThanLongFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LessThanLongFilter.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LessThanLongFilter;
  })();

  ScannerProtos.DateFilter = (function () {
    /**
     * Properties of a DateFilter.
     * @memberof ScannerProtos
     * @interface IDateFilter
     * @property {number|null} [from] DateFilter from
     * @property {number|null} [to] DateFilter to
     */

    /**
     * Constructs a new DateFilter.
     * @memberof ScannerProtos
     * @classdesc Represents a DateFilter.
     * @implements IDateFilter
     * @constructor
     * @param {ScannerProtos.IDateFilter=} [properties] Properties to set
     */
    function DateFilter(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * DateFilter from.
     * @member {number} from
     * @memberof ScannerProtos.DateFilter
     * @instance
     */
    DateFilter.prototype.from = 0;

    /**
     * DateFilter to.
     * @member {number} to
     * @memberof ScannerProtos.DateFilter
     * @instance
     */
    DateFilter.prototype.to = 0;

    /**
     * Creates a new DateFilter instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.DateFilter
     * @static
     * @param {ScannerProtos.IDateFilter=} [properties] Properties to set
     * @returns {ScannerProtos.DateFilter} DateFilter instance
     */
    DateFilter.create = function create(properties) {
      return new DateFilter(properties);
    };

    /**
     * Encodes the specified DateFilter message. Does not implicitly {@link ScannerProtos.DateFilter.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.DateFilter
     * @static
     * @param {ScannerProtos.IDateFilter} message DateFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DateFilter.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.from != null && Object.hasOwnProperty.call(message, 'from'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.from);
      if (message.to != null && Object.hasOwnProperty.call(message, 'to'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.to);
      return writer;
    };

    /**
     * Encodes the specified DateFilter message, length delimited. Does not implicitly {@link ScannerProtos.DateFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.DateFilter
     * @static
     * @param {ScannerProtos.IDateFilter} message DateFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DateFilter.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DateFilter message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.DateFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.DateFilter} DateFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DateFilter.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.DateFilter();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.from = reader.int32();
            break;
          }
          case 2: {
            message.to = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a DateFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.DateFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.DateFilter} DateFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DateFilter.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DateFilter message.
     * @function verify
     * @memberof ScannerProtos.DateFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DateFilter.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.from != null && message.hasOwnProperty('from'))
        if (!$util.isInteger(message.from)) return 'from: integer expected';
      if (message.to != null && message.hasOwnProperty('to'))
        if (!$util.isInteger(message.to)) return 'to: integer expected';
      return null;
    };

    /**
     * Creates a DateFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.DateFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.DateFilter} DateFilter
     */
    DateFilter.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.DateFilter) return object;
      let message = new $root.ScannerProtos.DateFilter();
      if (object.from != null) message.from = object.from | 0;
      if (object.to != null) message.to = object.to | 0;
      return message;
    };

    /**
     * Creates a plain object from a DateFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.DateFilter
     * @static
     * @param {ScannerProtos.DateFilter} message DateFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DateFilter.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.from = 0;
        object.to = 0;
      }
      if (message.from != null && message.hasOwnProperty('from')) object.from = message.from;
      if (message.to != null && message.hasOwnProperty('to')) object.to = message.to;
      return object;
    };

    /**
     * Converts this DateFilter to JSON.
     * @function toJSON
     * @memberof ScannerProtos.DateFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DateFilter.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DateFilter;
  })();

  ScannerProtos.DoubleFilter = (function () {
    /**
     * Properties of a DoubleFilter.
     * @memberof ScannerProtos
     * @interface IDoubleFilter
     * @property {number|null} [minimum] DoubleFilter minimum
     * @property {number|null} [maximum] DoubleFilter maximum
     */

    /**
     * Constructs a new DoubleFilter.
     * @memberof ScannerProtos
     * @classdesc Represents a DoubleFilter.
     * @implements IDoubleFilter
     * @constructor
     * @param {ScannerProtos.IDoubleFilter=} [properties] Properties to set
     */
    function DoubleFilter(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * DoubleFilter minimum.
     * @member {number} minimum
     * @memberof ScannerProtos.DoubleFilter
     * @instance
     */
    DoubleFilter.prototype.minimum = 0;

    /**
     * DoubleFilter maximum.
     * @member {number} maximum
     * @memberof ScannerProtos.DoubleFilter
     * @instance
     */
    DoubleFilter.prototype.maximum = 0;

    /**
     * Creates a new DoubleFilter instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.DoubleFilter
     * @static
     * @param {ScannerProtos.IDoubleFilter=} [properties] Properties to set
     * @returns {ScannerProtos.DoubleFilter} DoubleFilter instance
     */
    DoubleFilter.create = function create(properties) {
      return new DoubleFilter(properties);
    };

    /**
     * Encodes the specified DoubleFilter message. Does not implicitly {@link ScannerProtos.DoubleFilter.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.DoubleFilter
     * @static
     * @param {ScannerProtos.IDoubleFilter} message DoubleFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DoubleFilter.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.minimum != null && Object.hasOwnProperty.call(message, 'minimum'))
        writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.minimum);
      if (message.maximum != null && Object.hasOwnProperty.call(message, 'maximum'))
        writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.maximum);
      return writer;
    };

    /**
     * Encodes the specified DoubleFilter message, length delimited. Does not implicitly {@link ScannerProtos.DoubleFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.DoubleFilter
     * @static
     * @param {ScannerProtos.IDoubleFilter} message DoubleFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DoubleFilter.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DoubleFilter message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.DoubleFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.DoubleFilter} DoubleFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DoubleFilter.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.DoubleFilter();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.minimum = reader.double();
            break;
          }
          case 2: {
            message.maximum = reader.double();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a DoubleFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.DoubleFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.DoubleFilter} DoubleFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DoubleFilter.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DoubleFilter message.
     * @function verify
     * @memberof ScannerProtos.DoubleFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DoubleFilter.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.minimum != null && message.hasOwnProperty('minimum'))
        if (typeof message.minimum !== 'number') return 'minimum: number expected';
      if (message.maximum != null && message.hasOwnProperty('maximum'))
        if (typeof message.maximum !== 'number') return 'maximum: number expected';
      return null;
    };

    /**
     * Creates a DoubleFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.DoubleFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.DoubleFilter} DoubleFilter
     */
    DoubleFilter.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.DoubleFilter) return object;
      let message = new $root.ScannerProtos.DoubleFilter();
      if (object.minimum != null) message.minimum = Number(object.minimum);
      if (object.maximum != null) message.maximum = Number(object.maximum);
      return message;
    };

    /**
     * Creates a plain object from a DoubleFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.DoubleFilter
     * @static
     * @param {ScannerProtos.DoubleFilter} message DoubleFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DoubleFilter.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.minimum = 0;
        object.maximum = 0;
      }
      if (message.minimum != null && message.hasOwnProperty('minimum'))
        object.minimum = options.json && !isFinite(message.minimum) ? String(message.minimum) : message.minimum;
      if (message.maximum != null && message.hasOwnProperty('maximum'))
        object.maximum = options.json && !isFinite(message.maximum) ? String(message.maximum) : message.maximum;
      return object;
    };

    /**
     * Converts this DoubleFilter to JSON.
     * @function toJSON
     * @memberof ScannerProtos.DoubleFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DoubleFilter.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DoubleFilter;
  })();

  ScannerProtos.LongFilter = (function () {
    /**
     * Properties of a LongFilter.
     * @memberof ScannerProtos
     * @interface ILongFilter
     * @property {number|Long|null} [minimum] LongFilter minimum
     * @property {number|Long|null} [maximum] LongFilter maximum
     */

    /**
     * Constructs a new LongFilter.
     * @memberof ScannerProtos
     * @classdesc Represents a LongFilter.
     * @implements ILongFilter
     * @constructor
     * @param {ScannerProtos.ILongFilter=} [properties] Properties to set
     */
    function LongFilter(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * LongFilter minimum.
     * @member {number|Long} minimum
     * @memberof ScannerProtos.LongFilter
     * @instance
     */
    LongFilter.prototype.minimum = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LongFilter maximum.
     * @member {number|Long} maximum
     * @memberof ScannerProtos.LongFilter
     * @instance
     */
    LongFilter.prototype.maximum = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Creates a new LongFilter instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.LongFilter
     * @static
     * @param {ScannerProtos.ILongFilter=} [properties] Properties to set
     * @returns {ScannerProtos.LongFilter} LongFilter instance
     */
    LongFilter.create = function create(properties) {
      return new LongFilter(properties);
    };

    /**
     * Encodes the specified LongFilter message. Does not implicitly {@link ScannerProtos.LongFilter.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.LongFilter
     * @static
     * @param {ScannerProtos.ILongFilter} message LongFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LongFilter.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.minimum != null && Object.hasOwnProperty.call(message, 'minimum'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.minimum);
      if (message.maximum != null && Object.hasOwnProperty.call(message, 'maximum'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.maximum);
      return writer;
    };

    /**
     * Encodes the specified LongFilter message, length delimited. Does not implicitly {@link ScannerProtos.LongFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.LongFilter
     * @static
     * @param {ScannerProtos.ILongFilter} message LongFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LongFilter.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LongFilter message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.LongFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.LongFilter} LongFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LongFilter.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.LongFilter();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.minimum = reader.int64();
            break;
          }
          case 2: {
            message.maximum = reader.int64();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a LongFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.LongFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.LongFilter} LongFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LongFilter.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LongFilter message.
     * @function verify
     * @memberof ScannerProtos.LongFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LongFilter.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.minimum != null && message.hasOwnProperty('minimum'))
        if (
          !$util.isInteger(message.minimum) &&
          !(message.minimum && $util.isInteger(message.minimum.low) && $util.isInteger(message.minimum.high))
        )
          return 'minimum: integer|Long expected';
      if (message.maximum != null && message.hasOwnProperty('maximum'))
        if (
          !$util.isInteger(message.maximum) &&
          !(message.maximum && $util.isInteger(message.maximum.low) && $util.isInteger(message.maximum.high))
        )
          return 'maximum: integer|Long expected';
      return null;
    };

    /**
     * Creates a LongFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.LongFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.LongFilter} LongFilter
     */
    LongFilter.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.LongFilter) return object;
      let message = new $root.ScannerProtos.LongFilter();
      if (object.minimum != null)
        if ($util.Long) (message.minimum = $util.Long.fromValue(object.minimum)).unsigned = false;
        else if (typeof object.minimum === 'string') message.minimum = parseInt(object.minimum, 10);
        else if (typeof object.minimum === 'number') message.minimum = object.minimum;
        else if (typeof object.minimum === 'object')
          message.minimum = new $util.LongBits(object.minimum.low >>> 0, object.minimum.high >>> 0).toNumber();
      if (object.maximum != null)
        if ($util.Long) (message.maximum = $util.Long.fromValue(object.maximum)).unsigned = false;
        else if (typeof object.maximum === 'string') message.maximum = parseInt(object.maximum, 10);
        else if (typeof object.maximum === 'number') message.maximum = object.maximum;
        else if (typeof object.maximum === 'object')
          message.maximum = new $util.LongBits(object.maximum.low >>> 0, object.maximum.high >>> 0).toNumber();
      return message;
    };

    /**
     * Creates a plain object from a LongFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.LongFilter
     * @static
     * @param {ScannerProtos.LongFilter} message LongFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LongFilter.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.minimum =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.minimum = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.maximum =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.maximum = options.longs === String ? '0' : 0;
      }
      if (message.minimum != null && message.hasOwnProperty('minimum'))
        if (typeof message.minimum === 'number')
          object.minimum = options.longs === String ? String(message.minimum) : message.minimum;
        else
          object.minimum =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.minimum)
              : options.longs === Number
                ? new $util.LongBits(message.minimum.low >>> 0, message.minimum.high >>> 0).toNumber()
                : message.minimum;
      if (message.maximum != null && message.hasOwnProperty('maximum'))
        if (typeof message.maximum === 'number')
          object.maximum = options.longs === String ? String(message.maximum) : message.maximum;
        else
          object.maximum =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.maximum)
              : options.longs === Number
                ? new $util.LongBits(message.maximum.low >>> 0, message.maximum.high >>> 0).toNumber()
                : message.maximum;
      return object;
    };

    /**
     * Converts this LongFilter to JSON.
     * @function toJSON
     * @memberof ScannerProtos.LongFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LongFilter.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LongFilter;
  })();

  ScannerProtos.IntFilter = (function () {
    /**
     * Properties of an IntFilter.
     * @memberof ScannerProtos
     * @interface IIntFilter
     * @property {number|null} [minimum] IntFilter minimum
     * @property {number|null} [maximum] IntFilter maximum
     */

    /**
     * Constructs a new IntFilter.
     * @memberof ScannerProtos
     * @classdesc Represents an IntFilter.
     * @implements IIntFilter
     * @constructor
     * @param {ScannerProtos.IIntFilter=} [properties] Properties to set
     */
    function IntFilter(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * IntFilter minimum.
     * @member {number} minimum
     * @memberof ScannerProtos.IntFilter
     * @instance
     */
    IntFilter.prototype.minimum = 0;

    /**
     * IntFilter maximum.
     * @member {number} maximum
     * @memberof ScannerProtos.IntFilter
     * @instance
     */
    IntFilter.prototype.maximum = 0;

    /**
     * Creates a new IntFilter instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.IntFilter
     * @static
     * @param {ScannerProtos.IIntFilter=} [properties] Properties to set
     * @returns {ScannerProtos.IntFilter} IntFilter instance
     */
    IntFilter.create = function create(properties) {
      return new IntFilter(properties);
    };

    /**
     * Encodes the specified IntFilter message. Does not implicitly {@link ScannerProtos.IntFilter.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.IntFilter
     * @static
     * @param {ScannerProtos.IIntFilter} message IntFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    IntFilter.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.minimum != null && Object.hasOwnProperty.call(message, 'minimum'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.minimum);
      if (message.maximum != null && Object.hasOwnProperty.call(message, 'maximum'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.maximum);
      return writer;
    };

    /**
     * Encodes the specified IntFilter message, length delimited. Does not implicitly {@link ScannerProtos.IntFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.IntFilter
     * @static
     * @param {ScannerProtos.IIntFilter} message IntFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    IntFilter.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an IntFilter message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.IntFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.IntFilter} IntFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    IntFilter.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.IntFilter();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.minimum = reader.int32();
            break;
          }
          case 2: {
            message.maximum = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an IntFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.IntFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.IntFilter} IntFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    IntFilter.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an IntFilter message.
     * @function verify
     * @memberof ScannerProtos.IntFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    IntFilter.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.minimum != null && message.hasOwnProperty('minimum'))
        if (!$util.isInteger(message.minimum)) return 'minimum: integer expected';
      if (message.maximum != null && message.hasOwnProperty('maximum'))
        if (!$util.isInteger(message.maximum)) return 'maximum: integer expected';
      return null;
    };

    /**
     * Creates an IntFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.IntFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.IntFilter} IntFilter
     */
    IntFilter.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.IntFilter) return object;
      let message = new $root.ScannerProtos.IntFilter();
      if (object.minimum != null) message.minimum = object.minimum | 0;
      if (object.maximum != null) message.maximum = object.maximum | 0;
      return message;
    };

    /**
     * Creates a plain object from an IntFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.IntFilter
     * @static
     * @param {ScannerProtos.IntFilter} message IntFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    IntFilter.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.minimum = 0;
        object.maximum = 0;
      }
      if (message.minimum != null && message.hasOwnProperty('minimum')) object.minimum = message.minimum;
      if (message.maximum != null && message.hasOwnProperty('maximum')) object.maximum = message.maximum;
      return object;
    };

    /**
     * Converts this IntFilter to JSON.
     * @function toJSON
     * @memberof ScannerProtos.IntFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    IntFilter.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return IntFilter;
  })();

  ScannerProtos.ContainsFilter = (function () {
    /**
     * Properties of a ContainsFilter.
     * @memberof ScannerProtos
     * @interface IContainsFilter
     * @property {Array.<string>|null} [value] ContainsFilter value
     */

    /**
     * Constructs a new ContainsFilter.
     * @memberof ScannerProtos
     * @classdesc Represents a ContainsFilter.
     * @implements IContainsFilter
     * @constructor
     * @param {ScannerProtos.IContainsFilter=} [properties] Properties to set
     */
    function ContainsFilter(properties) {
      this.value = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * ContainsFilter value.
     * @member {Array.<string>} value
     * @memberof ScannerProtos.ContainsFilter
     * @instance
     */
    ContainsFilter.prototype.value = $util.emptyArray;

    /**
     * Creates a new ContainsFilter instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.ContainsFilter
     * @static
     * @param {ScannerProtos.IContainsFilter=} [properties] Properties to set
     * @returns {ScannerProtos.ContainsFilter} ContainsFilter instance
     */
    ContainsFilter.create = function create(properties) {
      return new ContainsFilter(properties);
    };

    /**
     * Encodes the specified ContainsFilter message. Does not implicitly {@link ScannerProtos.ContainsFilter.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.ContainsFilter
     * @static
     * @param {ScannerProtos.IContainsFilter} message ContainsFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContainsFilter.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.value != null && message.value.length)
        for (let i = 0; i < message.value.length; ++i)
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.value[i]);
      return writer;
    };

    /**
     * Encodes the specified ContainsFilter message, length delimited. Does not implicitly {@link ScannerProtos.ContainsFilter.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.ContainsFilter
     * @static
     * @param {ScannerProtos.IContainsFilter} message ContainsFilter message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContainsFilter.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ContainsFilter message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.ContainsFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.ContainsFilter} ContainsFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContainsFilter.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.ContainsFilter();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (!(message.value && message.value.length)) message.value = [];
            message.value.push(reader.string());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a ContainsFilter message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.ContainsFilter
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.ContainsFilter} ContainsFilter
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContainsFilter.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ContainsFilter message.
     * @function verify
     * @memberof ScannerProtos.ContainsFilter
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ContainsFilter.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.value != null && message.hasOwnProperty('value')) {
        if (!Array.isArray(message.value)) return 'value: array expected';
        for (let i = 0; i < message.value.length; ++i)
          if (!$util.isString(message.value[i])) return 'value: string[] expected';
      }
      return null;
    };

    /**
     * Creates a ContainsFilter message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.ContainsFilter
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.ContainsFilter} ContainsFilter
     */
    ContainsFilter.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.ContainsFilter) return object;
      let message = new $root.ScannerProtos.ContainsFilter();
      if (object.value) {
        if (!Array.isArray(object.value)) throw TypeError('.ScannerProtos.ContainsFilter.value: array expected');
        message.value = [];
        for (let i = 0; i < object.value.length; ++i) message.value[i] = String(object.value[i]);
      }
      return message;
    };

    /**
     * Creates a plain object from a ContainsFilter message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.ContainsFilter
     * @static
     * @param {ScannerProtos.ContainsFilter} message ContainsFilter
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ContainsFilter.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.value = [];
      if (message.value && message.value.length) {
        object.value = [];
        for (let j = 0; j < message.value.length; ++j) object.value[j] = message.value[j];
      }
      return object;
    };

    /**
     * Converts this ContainsFilter to JSON.
     * @function toJSON
     * @memberof ScannerProtos.ContainsFilter
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ContainsFilter.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ContainsFilter;
  })();

  ScannerProtos.ScannerResult = (function () {
    /**
     * Properties of a ScannerResult.
     * @memberof ScannerProtos
     * @interface IScannerResult
     * @property {number|null} [processingTimeMillis] ScannerResult processingTimeMillis
     * @property {number|null} [totalInstruments] ScannerResult totalInstruments
     * @property {Array.<LastProtos.IQuote>|null} [instruments] ScannerResult instruments
     * @property {Array.<string>|null} [fields] ScannerResult fields
     * @property {number|null} [maxAge] ScannerResult maxAge
     */

    /**
     * Constructs a new ScannerResult.
     * @memberof ScannerProtos
     * @classdesc Represents a ScannerResult.
     * @implements IScannerResult
     * @constructor
     * @param {ScannerProtos.IScannerResult=} [properties] Properties to set
     */
    function ScannerResult(properties) {
      this.instruments = [];
      this.fields = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * ScannerResult processingTimeMillis.
     * @member {number} processingTimeMillis
     * @memberof ScannerProtos.ScannerResult
     * @instance
     */
    ScannerResult.prototype.processingTimeMillis = 0;

    /**
     * ScannerResult totalInstruments.
     * @member {number} totalInstruments
     * @memberof ScannerProtos.ScannerResult
     * @instance
     */
    ScannerResult.prototype.totalInstruments = 0;

    /**
     * ScannerResult instruments.
     * @member {Array.<LastProtos.IQuote>} instruments
     * @memberof ScannerProtos.ScannerResult
     * @instance
     */
    ScannerResult.prototype.instruments = $util.emptyArray;

    /**
     * ScannerResult fields.
     * @member {Array.<string>} fields
     * @memberof ScannerProtos.ScannerResult
     * @instance
     */
    ScannerResult.prototype.fields = $util.emptyArray;

    /**
     * ScannerResult maxAge.
     * @member {number} maxAge
     * @memberof ScannerProtos.ScannerResult
     * @instance
     */
    ScannerResult.prototype.maxAge = 0;

    /**
     * Creates a new ScannerResult instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.ScannerResult
     * @static
     * @param {ScannerProtos.IScannerResult=} [properties] Properties to set
     * @returns {ScannerProtos.ScannerResult} ScannerResult instance
     */
    ScannerResult.create = function create(properties) {
      return new ScannerResult(properties);
    };

    /**
     * Encodes the specified ScannerResult message. Does not implicitly {@link ScannerProtos.ScannerResult.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.ScannerResult
     * @static
     * @param {ScannerProtos.IScannerResult} message ScannerResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ScannerResult.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.processingTimeMillis != null && Object.hasOwnProperty.call(message, 'processingTimeMillis'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.processingTimeMillis);
      if (message.totalInstruments != null && Object.hasOwnProperty.call(message, 'totalInstruments'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.totalInstruments);
      if (message.instruments != null && message.instruments.length)
        for (let i = 0; i < message.instruments.length; ++i)
          $root.LastProtos.Quote.encode(
            message.instruments[i],
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork(),
          ).ldelim();
      if (message.fields != null && message.fields.length)
        for (let i = 0; i < message.fields.length; ++i)
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.fields[i]);
      if (message.maxAge != null && Object.hasOwnProperty.call(message, 'maxAge'))
        writer.uint32(/* id 5, wireType 0 =*/ 40).int32(message.maxAge);
      return writer;
    };

    /**
     * Encodes the specified ScannerResult message, length delimited. Does not implicitly {@link ScannerProtos.ScannerResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.ScannerResult
     * @static
     * @param {ScannerProtos.IScannerResult} message ScannerResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ScannerResult.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ScannerResult message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.ScannerResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.ScannerResult} ScannerResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ScannerResult.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.ScannerResult();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.processingTimeMillis = reader.int32();
            break;
          }
          case 2: {
            message.totalInstruments = reader.int32();
            break;
          }
          case 3: {
            if (!(message.instruments && message.instruments.length)) message.instruments = [];
            message.instruments.push($root.LastProtos.Quote.decode(reader, reader.uint32()));
            break;
          }
          case 4: {
            if (!(message.fields && message.fields.length)) message.fields = [];
            message.fields.push(reader.string());
            break;
          }
          case 5: {
            message.maxAge = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a ScannerResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.ScannerResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.ScannerResult} ScannerResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ScannerResult.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ScannerResult message.
     * @function verify
     * @memberof ScannerProtos.ScannerResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ScannerResult.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.processingTimeMillis != null && message.hasOwnProperty('processingTimeMillis'))
        if (!$util.isInteger(message.processingTimeMillis)) return 'processingTimeMillis: integer expected';
      if (message.totalInstruments != null && message.hasOwnProperty('totalInstruments'))
        if (!$util.isInteger(message.totalInstruments)) return 'totalInstruments: integer expected';
      if (message.instruments != null && message.hasOwnProperty('instruments')) {
        if (!Array.isArray(message.instruments)) return 'instruments: array expected';
        for (let i = 0; i < message.instruments.length; ++i) {
          let error = $root.LastProtos.Quote.verify(message.instruments[i]);
          if (error) return 'instruments.' + error;
        }
      }
      if (message.fields != null && message.hasOwnProperty('fields')) {
        if (!Array.isArray(message.fields)) return 'fields: array expected';
        for (let i = 0; i < message.fields.length; ++i)
          if (!$util.isString(message.fields[i])) return 'fields: string[] expected';
      }
      if (message.maxAge != null && message.hasOwnProperty('maxAge'))
        if (!$util.isInteger(message.maxAge)) return 'maxAge: integer expected';
      return null;
    };

    /**
     * Creates a ScannerResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.ScannerResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.ScannerResult} ScannerResult
     */
    ScannerResult.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.ScannerResult) return object;
      let message = new $root.ScannerProtos.ScannerResult();
      if (object.processingTimeMillis != null) message.processingTimeMillis = object.processingTimeMillis | 0;
      if (object.totalInstruments != null) message.totalInstruments = object.totalInstruments | 0;
      if (object.instruments) {
        if (!Array.isArray(object.instruments))
          throw TypeError('.ScannerProtos.ScannerResult.instruments: array expected');
        message.instruments = [];
        for (let i = 0; i < object.instruments.length; ++i) {
          if (typeof object.instruments[i] !== 'object')
            throw TypeError('.ScannerProtos.ScannerResult.instruments: object expected');
          message.instruments[i] = $root.LastProtos.Quote.fromObject(object.instruments[i]);
        }
      }
      if (object.fields) {
        if (!Array.isArray(object.fields)) throw TypeError('.ScannerProtos.ScannerResult.fields: array expected');
        message.fields = [];
        for (let i = 0; i < object.fields.length; ++i) message.fields[i] = String(object.fields[i]);
      }
      if (object.maxAge != null) message.maxAge = object.maxAge | 0;
      return message;
    };

    /**
     * Creates a plain object from a ScannerResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.ScannerResult
     * @static
     * @param {ScannerProtos.ScannerResult} message ScannerResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ScannerResult.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.instruments = [];
        object.fields = [];
      }
      if (options.defaults) {
        object.processingTimeMillis = 0;
        object.totalInstruments = 0;
        object.maxAge = 0;
      }
      if (message.processingTimeMillis != null && message.hasOwnProperty('processingTimeMillis'))
        object.processingTimeMillis = message.processingTimeMillis;
      if (message.totalInstruments != null && message.hasOwnProperty('totalInstruments'))
        object.totalInstruments = message.totalInstruments;
      if (message.instruments && message.instruments.length) {
        object.instruments = [];
        for (let j = 0; j < message.instruments.length; ++j)
          object.instruments[j] = $root.LastProtos.Quote.toObject(message.instruments[j], options);
      }
      if (message.fields && message.fields.length) {
        object.fields = [];
        for (let j = 0; j < message.fields.length; ++j) object.fields[j] = message.fields[j];
      }
      if (message.maxAge != null && message.hasOwnProperty('maxAge')) object.maxAge = message.maxAge;
      return object;
    };

    /**
     * Converts this ScannerResult to JSON.
     * @function toJSON
     * @memberof ScannerProtos.ScannerResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ScannerResult.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ScannerResult;
  })();

  ScannerProtos.DataField = (function () {
    /**
     * Properties of a DataField.
     * @memberof ScannerProtos
     * @interface IDataField
     * @property {string|null} [name] DataField name
     * @property {string|null} [label] DataField label
     * @property {string|null} [category] DataField category
     * @property {string|null} [subCategory] DataField subCategory
     * @property {ScannerProtos.DataField.IUIFilterHint|null} [uiFilterHint] DataField uiFilterHint
     * @property {Array.<ScannerProtos.DataField.IOption>|null} [options] DataField options
     * @property {boolean|null} [filterable] DataField filterable
     * @property {boolean|null} [columnable] DataField columnable
     * @property {ScannerProtos.DataField.IUIColumnHint|null} [uiColumnHint] DataField uiColumnHint
     * @property {ScannerProtos.DataField.UpdateFrequency|null} [updateFrequency] DataField updateFrequency
     * @property {number|null} [order] DataField order
     * @property {string|null} [labelSubText] DataField labelSubText
     * @property {boolean|null} [percentage] DataField percentage
     * @property {ScannerProtos.DataField.IUIHints|null} [uiHints] DataField uiHints
     * @property {string|null} [filterOptionsName] DataField filterOptionsName
     * @property {LastProtos.QuoteSource|null} [source] DataField source
     */

    /**
     * Constructs a new DataField.
     * @memberof ScannerProtos
     * @classdesc For each field in the Instrument message there will be a DataField record.
     * scanner_datafields.json contains the fixed list of data fields and meta information.
     * @implements IDataField
     * @constructor
     * @param {ScannerProtos.IDataField=} [properties] Properties to set
     */
    function DataField(properties) {
      this.options = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * DataField name.
     * @member {string} name
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.name = '';

    /**
     * DataField label.
     * @member {string} label
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.label = '';

    /**
     * DataField category.
     * @member {string} category
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.category = '';

    /**
     * DataField subCategory.
     * @member {string} subCategory
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.subCategory = '';

    /**
     * DataField uiFilterHint.
     * @member {ScannerProtos.DataField.IUIFilterHint|null|undefined} uiFilterHint
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.uiFilterHint = null;

    /**
     * DataField options.
     * @member {Array.<ScannerProtos.DataField.IOption>} options
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.options = $util.emptyArray;

    /**
     * DataField filterable.
     * @member {boolean} filterable
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.filterable = false;

    /**
     * DataField columnable.
     * @member {boolean} columnable
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.columnable = false;

    /**
     * DataField uiColumnHint.
     * @member {ScannerProtos.DataField.IUIColumnHint|null|undefined} uiColumnHint
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.uiColumnHint = null;

    /**
     * DataField updateFrequency.
     * @member {ScannerProtos.DataField.UpdateFrequency} updateFrequency
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.updateFrequency = 0;

    /**
     * DataField order.
     * @member {number} order
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.order = 0;

    /**
     * DataField labelSubText.
     * @member {string} labelSubText
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.labelSubText = '';

    /**
     * DataField percentage.
     * @member {boolean} percentage
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.percentage = false;

    /**
     * DataField uiHints.
     * @member {ScannerProtos.DataField.IUIHints|null|undefined} uiHints
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.uiHints = null;

    /**
     * DataField filterOptionsName.
     * @member {string} filterOptionsName
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.filterOptionsName = '';

    /**
     * DataField source.
     * @member {LastProtos.QuoteSource} source
     * @memberof ScannerProtos.DataField
     * @instance
     */
    DataField.prototype.source = 0;

    /**
     * Creates a new DataField instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.DataField
     * @static
     * @param {ScannerProtos.IDataField=} [properties] Properties to set
     * @returns {ScannerProtos.DataField} DataField instance
     */
    DataField.create = function create(properties) {
      return new DataField(properties);
    };

    /**
     * Encodes the specified DataField message. Does not implicitly {@link ScannerProtos.DataField.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.DataField
     * @static
     * @param {ScannerProtos.IDataField} message DataField message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DataField.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.name != null && Object.hasOwnProperty.call(message, 'name'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
      if (message.label != null && Object.hasOwnProperty.call(message, 'label'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.label);
      if (message.category != null && Object.hasOwnProperty.call(message, 'category'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.category);
      if (message.uiFilterHint != null && Object.hasOwnProperty.call(message, 'uiFilterHint'))
        $root.ScannerProtos.DataField.UIFilterHint.encode(
          message.uiFilterHint,
          writer.uint32(/* id 4, wireType 2 =*/ 34).fork(),
        ).ldelim();
      if (message.options != null && message.options.length)
        for (let i = 0; i < message.options.length; ++i)
          $root.ScannerProtos.DataField.Option.encode(
            message.options[i],
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork(),
          ).ldelim();
      if (message.filterable != null && Object.hasOwnProperty.call(message, 'filterable'))
        writer.uint32(/* id 6, wireType 0 =*/ 48).bool(message.filterable);
      if (message.columnable != null && Object.hasOwnProperty.call(message, 'columnable'))
        writer.uint32(/* id 7, wireType 0 =*/ 56).bool(message.columnable);
      if (message.uiColumnHint != null && Object.hasOwnProperty.call(message, 'uiColumnHint'))
        $root.ScannerProtos.DataField.UIColumnHint.encode(
          message.uiColumnHint,
          writer.uint32(/* id 8, wireType 2 =*/ 66).fork(),
        ).ldelim();
      if (message.updateFrequency != null && Object.hasOwnProperty.call(message, 'updateFrequency'))
        writer.uint32(/* id 9, wireType 0 =*/ 72).int32(message.updateFrequency);
      if (message.order != null && Object.hasOwnProperty.call(message, 'order'))
        writer.uint32(/* id 10, wireType 0 =*/ 80).int32(message.order);
      if (message.labelSubText != null && Object.hasOwnProperty.call(message, 'labelSubText'))
        writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.labelSubText);
      if (message.percentage != null && Object.hasOwnProperty.call(message, 'percentage'))
        writer.uint32(/* id 12, wireType 0 =*/ 96).bool(message.percentage);
      if (message.subCategory != null && Object.hasOwnProperty.call(message, 'subCategory'))
        writer.uint32(/* id 13, wireType 2 =*/ 106).string(message.subCategory);
      if (message.uiHints != null && Object.hasOwnProperty.call(message, 'uiHints'))
        $root.ScannerProtos.DataField.UIHints.encode(
          message.uiHints,
          writer.uint32(/* id 14, wireType 2 =*/ 114).fork(),
        ).ldelim();
      if (message.filterOptionsName != null && Object.hasOwnProperty.call(message, 'filterOptionsName'))
        writer.uint32(/* id 15, wireType 2 =*/ 122).string(message.filterOptionsName);
      if (message.source != null && Object.hasOwnProperty.call(message, 'source'))
        writer.uint32(/* id 16, wireType 0 =*/ 128).int32(message.source);
      return writer;
    };

    /**
     * Encodes the specified DataField message, length delimited. Does not implicitly {@link ScannerProtos.DataField.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.DataField
     * @static
     * @param {ScannerProtos.IDataField} message DataField message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DataField.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DataField message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.DataField
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.DataField} DataField
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DataField.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.DataField();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.name = reader.string();
            break;
          }
          case 2: {
            message.label = reader.string();
            break;
          }
          case 3: {
            message.category = reader.string();
            break;
          }
          case 13: {
            message.subCategory = reader.string();
            break;
          }
          case 4: {
            message.uiFilterHint = $root.ScannerProtos.DataField.UIFilterHint.decode(reader, reader.uint32());
            break;
          }
          case 5: {
            if (!(message.options && message.options.length)) message.options = [];
            message.options.push($root.ScannerProtos.DataField.Option.decode(reader, reader.uint32()));
            break;
          }
          case 6: {
            message.filterable = reader.bool();
            break;
          }
          case 7: {
            message.columnable = reader.bool();
            break;
          }
          case 8: {
            message.uiColumnHint = $root.ScannerProtos.DataField.UIColumnHint.decode(reader, reader.uint32());
            break;
          }
          case 9: {
            message.updateFrequency = reader.int32();
            break;
          }
          case 10: {
            message.order = reader.int32();
            break;
          }
          case 11: {
            message.labelSubText = reader.string();
            break;
          }
          case 12: {
            message.percentage = reader.bool();
            break;
          }
          case 14: {
            message.uiHints = $root.ScannerProtos.DataField.UIHints.decode(reader, reader.uint32());
            break;
          }
          case 15: {
            message.filterOptionsName = reader.string();
            break;
          }
          case 16: {
            message.source = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a DataField message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.DataField
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.DataField} DataField
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DataField.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DataField message.
     * @function verify
     * @memberof ScannerProtos.DataField
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DataField.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.name != null && message.hasOwnProperty('name'))
        if (!$util.isString(message.name)) return 'name: string expected';
      if (message.label != null && message.hasOwnProperty('label'))
        if (!$util.isString(message.label)) return 'label: string expected';
      if (message.category != null && message.hasOwnProperty('category'))
        if (!$util.isString(message.category)) return 'category: string expected';
      if (message.subCategory != null && message.hasOwnProperty('subCategory'))
        if (!$util.isString(message.subCategory)) return 'subCategory: string expected';
      if (message.uiFilterHint != null && message.hasOwnProperty('uiFilterHint')) {
        let error = $root.ScannerProtos.DataField.UIFilterHint.verify(message.uiFilterHint);
        if (error) return 'uiFilterHint.' + error;
      }
      if (message.options != null && message.hasOwnProperty('options')) {
        if (!Array.isArray(message.options)) return 'options: array expected';
        for (let i = 0; i < message.options.length; ++i) {
          let error = $root.ScannerProtos.DataField.Option.verify(message.options[i]);
          if (error) return 'options.' + error;
        }
      }
      if (message.filterable != null && message.hasOwnProperty('filterable'))
        if (typeof message.filterable !== 'boolean') return 'filterable: boolean expected';
      if (message.columnable != null && message.hasOwnProperty('columnable'))
        if (typeof message.columnable !== 'boolean') return 'columnable: boolean expected';
      if (message.uiColumnHint != null && message.hasOwnProperty('uiColumnHint')) {
        let error = $root.ScannerProtos.DataField.UIColumnHint.verify(message.uiColumnHint);
        if (error) return 'uiColumnHint.' + error;
      }
      if (message.updateFrequency != null && message.hasOwnProperty('updateFrequency'))
        switch (message.updateFrequency) {
          default:
            return 'updateFrequency: enum value expected';
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.order != null && message.hasOwnProperty('order'))
        if (!$util.isInteger(message.order)) return 'order: integer expected';
      if (message.labelSubText != null && message.hasOwnProperty('labelSubText'))
        if (!$util.isString(message.labelSubText)) return 'labelSubText: string expected';
      if (message.percentage != null && message.hasOwnProperty('percentage'))
        if (typeof message.percentage !== 'boolean') return 'percentage: boolean expected';
      if (message.uiHints != null && message.hasOwnProperty('uiHints')) {
        let error = $root.ScannerProtos.DataField.UIHints.verify(message.uiHints);
        if (error) return 'uiHints.' + error;
      }
      if (message.filterOptionsName != null && message.hasOwnProperty('filterOptionsName'))
        if (!$util.isString(message.filterOptionsName)) return 'filterOptionsName: string expected';
      if (message.source != null && message.hasOwnProperty('source'))
        switch (message.source) {
          default:
            return 'source: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      return null;
    };

    /**
     * Creates a DataField message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.DataField
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.DataField} DataField
     */
    DataField.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.DataField) return object;
      let message = new $root.ScannerProtos.DataField();
      if (object.name != null) message.name = String(object.name);
      if (object.label != null) message.label = String(object.label);
      if (object.category != null) message.category = String(object.category);
      if (object.subCategory != null) message.subCategory = String(object.subCategory);
      if (object.uiFilterHint != null) {
        if (typeof object.uiFilterHint !== 'object')
          throw TypeError('.ScannerProtos.DataField.uiFilterHint: object expected');
        message.uiFilterHint = $root.ScannerProtos.DataField.UIFilterHint.fromObject(object.uiFilterHint);
      }
      if (object.options) {
        if (!Array.isArray(object.options)) throw TypeError('.ScannerProtos.DataField.options: array expected');
        message.options = [];
        for (let i = 0; i < object.options.length; ++i) {
          if (typeof object.options[i] !== 'object')
            throw TypeError('.ScannerProtos.DataField.options: object expected');
          message.options[i] = $root.ScannerProtos.DataField.Option.fromObject(object.options[i]);
        }
      }
      if (object.filterable != null) message.filterable = Boolean(object.filterable);
      if (object.columnable != null) message.columnable = Boolean(object.columnable);
      if (object.uiColumnHint != null) {
        if (typeof object.uiColumnHint !== 'object')
          throw TypeError('.ScannerProtos.DataField.uiColumnHint: object expected');
        message.uiColumnHint = $root.ScannerProtos.DataField.UIColumnHint.fromObject(object.uiColumnHint);
      }
      switch (object.updateFrequency) {
        default:
          if (typeof object.updateFrequency === 'number') {
            message.updateFrequency = object.updateFrequency;
            break;
          }
          break;
        case 'UNKNOWN':
        case 0:
          message.updateFrequency = 0;
          break;
        case 'INTRADAY':
        case 1:
          message.updateFrequency = 1;
          break;
        case 'EOD':
        case 2:
          message.updateFrequency = 2;
          break;
      }
      if (object.order != null) message.order = object.order | 0;
      if (object.labelSubText != null) message.labelSubText = String(object.labelSubText);
      if (object.percentage != null) message.percentage = Boolean(object.percentage);
      if (object.uiHints != null) {
        if (typeof object.uiHints !== 'object') throw TypeError('.ScannerProtos.DataField.uiHints: object expected');
        message.uiHints = $root.ScannerProtos.DataField.UIHints.fromObject(object.uiHints);
      }
      if (object.filterOptionsName != null) message.filterOptionsName = String(object.filterOptionsName);
      switch (object.source) {
        default:
          if (typeof object.source === 'number') {
            message.source = object.source;
            break;
          }
          break;
        case 'UNKNOWN_SOURCE':
        case 0:
          message.source = 0;
          break;
        case 'QUOTE_STORE':
        case 1:
          message.source = 1;
          break;
        case 'QUOTE_CALCULATOR':
        case 2:
          message.source = 2;
          break;
        case 'POLLED_DATA':
        case 3:
          message.source = 3;
          break;
        case 'ROLLING_FIELDS':
        case 4:
          message.source = 4;
          break;
        case 'RSI_FIELDS':
        case 5:
          message.source = 5;
          break;
        case 'CONTENT_EVENT_PUBLISHER':
        case 6:
          message.source = 6;
          break;
      }
      return message;
    };

    /**
     * Creates a plain object from a DataField message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.DataField
     * @static
     * @param {ScannerProtos.DataField} message DataField
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DataField.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.options = [];
      if (options.defaults) {
        object.name = '';
        object.label = '';
        object.category = '';
        object.uiFilterHint = null;
        object.filterable = false;
        object.columnable = false;
        object.uiColumnHint = null;
        object.updateFrequency = options.enums === String ? 'UNKNOWN' : 0;
        object.order = 0;
        object.labelSubText = '';
        object.percentage = false;
        object.subCategory = '';
        object.uiHints = null;
        object.filterOptionsName = '';
        object.source = options.enums === String ? 'UNKNOWN_SOURCE' : 0;
      }
      if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
      if (message.label != null && message.hasOwnProperty('label')) object.label = message.label;
      if (message.category != null && message.hasOwnProperty('category')) object.category = message.category;
      if (message.uiFilterHint != null && message.hasOwnProperty('uiFilterHint'))
        object.uiFilterHint = $root.ScannerProtos.DataField.UIFilterHint.toObject(message.uiFilterHint, options);
      if (message.options && message.options.length) {
        object.options = [];
        for (let j = 0; j < message.options.length; ++j)
          object.options[j] = $root.ScannerProtos.DataField.Option.toObject(message.options[j], options);
      }
      if (message.filterable != null && message.hasOwnProperty('filterable')) object.filterable = message.filterable;
      if (message.columnable != null && message.hasOwnProperty('columnable')) object.columnable = message.columnable;
      if (message.uiColumnHint != null && message.hasOwnProperty('uiColumnHint'))
        object.uiColumnHint = $root.ScannerProtos.DataField.UIColumnHint.toObject(message.uiColumnHint, options);
      if (message.updateFrequency != null && message.hasOwnProperty('updateFrequency'))
        object.updateFrequency =
          options.enums === String
            ? $root.ScannerProtos.DataField.UpdateFrequency[message.updateFrequency] === undefined
              ? message.updateFrequency
              : $root.ScannerProtos.DataField.UpdateFrequency[message.updateFrequency]
            : message.updateFrequency;
      if (message.order != null && message.hasOwnProperty('order')) object.order = message.order;
      if (message.labelSubText != null && message.hasOwnProperty('labelSubText'))
        object.labelSubText = message.labelSubText;
      if (message.percentage != null && message.hasOwnProperty('percentage')) object.percentage = message.percentage;
      if (message.subCategory != null && message.hasOwnProperty('subCategory'))
        object.subCategory = message.subCategory;
      if (message.uiHints != null && message.hasOwnProperty('uiHints'))
        object.uiHints = $root.ScannerProtos.DataField.UIHints.toObject(message.uiHints, options);
      if (message.filterOptionsName != null && message.hasOwnProperty('filterOptionsName'))
        object.filterOptionsName = message.filterOptionsName;
      if (message.source != null && message.hasOwnProperty('source'))
        object.source =
          options.enums === String
            ? $root.LastProtos.QuoteSource[message.source] === undefined
              ? message.source
              : $root.LastProtos.QuoteSource[message.source]
            : message.source;
      return object;
    };

    /**
     * Converts this DataField to JSON.
     * @function toJSON
     * @memberof ScannerProtos.DataField
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DataField.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    DataField.UIFilterHint = (function () {
      /**
       * Properties of a UIFilterHint.
       * @memberof ScannerProtos.DataField
       * @interface IUIFilterHint
       * @property {string|null} [type] UIFilterHint type
       * @property {string|null} [defaultValue] UIFilterHint defaultValue
       * @property {ScannerProtos.Operator|null} [defaultOperator] UIFilterHint defaultOperator
       * @property {number|Long|null} [multiplier] UIFilterHint multiplier
       * @property {string|null} [emptyText] UIFilterHint emptyText
       * @property {boolean|null} [slider] UIFilterHint slider
       * @property {boolean|null} [hidden] UIFilterHint hidden
       * @property {string|null} [minFrom] UIFilterHint minFrom
       * @property {string|null} [maxTo] UIFilterHint maxTo
       */

      /**
       * Constructs a new UIFilterHint.
       * @memberof ScannerProtos.DataField
       * @classdesc Represents a UIFilterHint.
       * @implements IUIFilterHint
       * @constructor
       * @param {ScannerProtos.DataField.IUIFilterHint=} [properties] Properties to set
       */
      function UIFilterHint(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * UIFilterHint type.
       * @member {string} type
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @instance
       */
      UIFilterHint.prototype.type = '';

      /**
       * UIFilterHint defaultValue.
       * @member {string} defaultValue
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @instance
       */
      UIFilterHint.prototype.defaultValue = '';

      /**
       * UIFilterHint defaultOperator.
       * @member {ScannerProtos.Operator} defaultOperator
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @instance
       */
      UIFilterHint.prototype.defaultOperator = 0;

      /**
       * UIFilterHint multiplier.
       * @member {number|Long} multiplier
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @instance
       */
      UIFilterHint.prototype.multiplier = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

      /**
       * UIFilterHint emptyText.
       * @member {string} emptyText
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @instance
       */
      UIFilterHint.prototype.emptyText = '';

      /**
       * UIFilterHint slider.
       * @member {boolean} slider
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @instance
       */
      UIFilterHint.prototype.slider = false;

      /**
       * UIFilterHint hidden.
       * @member {boolean} hidden
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @instance
       */
      UIFilterHint.prototype.hidden = false;

      /**
       * UIFilterHint minFrom.
       * @member {string} minFrom
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @instance
       */
      UIFilterHint.prototype.minFrom = '';

      /**
       * UIFilterHint maxTo.
       * @member {string} maxTo
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @instance
       */
      UIFilterHint.prototype.maxTo = '';

      /**
       * Creates a new UIFilterHint instance using the specified properties.
       * @function create
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @static
       * @param {ScannerProtos.DataField.IUIFilterHint=} [properties] Properties to set
       * @returns {ScannerProtos.DataField.UIFilterHint} UIFilterHint instance
       */
      UIFilterHint.create = function create(properties) {
        return new UIFilterHint(properties);
      };

      /**
       * Encodes the specified UIFilterHint message. Does not implicitly {@link ScannerProtos.DataField.UIFilterHint.verify|verify} messages.
       * @function encode
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @static
       * @param {ScannerProtos.DataField.IUIFilterHint} message UIFilterHint message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UIFilterHint.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, 'type'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.type);
        if (message.defaultValue != null && Object.hasOwnProperty.call(message, 'defaultValue'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.defaultValue);
        if (message.defaultOperator != null && Object.hasOwnProperty.call(message, 'defaultOperator'))
          writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.defaultOperator);
        if (message.multiplier != null && Object.hasOwnProperty.call(message, 'multiplier'))
          writer.uint32(/* id 4, wireType 0 =*/ 32).int64(message.multiplier);
        if (message.emptyText != null && Object.hasOwnProperty.call(message, 'emptyText'))
          writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.emptyText);
        if (message.slider != null && Object.hasOwnProperty.call(message, 'slider'))
          writer.uint32(/* id 10, wireType 0 =*/ 80).bool(message.slider);
        if (message.hidden != null && Object.hasOwnProperty.call(message, 'hidden'))
          writer.uint32(/* id 11, wireType 0 =*/ 88).bool(message.hidden);
        if (message.minFrom != null && Object.hasOwnProperty.call(message, 'minFrom'))
          writer.uint32(/* id 16, wireType 2 =*/ 130).string(message.minFrom);
        if (message.maxTo != null && Object.hasOwnProperty.call(message, 'maxTo'))
          writer.uint32(/* id 17, wireType 2 =*/ 138).string(message.maxTo);
        return writer;
      };

      /**
       * Encodes the specified UIFilterHint message, length delimited. Does not implicitly {@link ScannerProtos.DataField.UIFilterHint.verify|verify} messages.
       * @function encodeDelimited
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @static
       * @param {ScannerProtos.DataField.IUIFilterHint} message UIFilterHint message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UIFilterHint.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a UIFilterHint message from the specified reader or buffer.
       * @function decode
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {ScannerProtos.DataField.UIFilterHint} UIFilterHint
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UIFilterHint.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.ScannerProtos.DataField.UIFilterHint();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.type = reader.string();
              break;
            }
            case 2: {
              message.defaultValue = reader.string();
              break;
            }
            case 3: {
              message.defaultOperator = reader.int32();
              break;
            }
            case 4: {
              message.multiplier = reader.int64();
              break;
            }
            case 5: {
              message.emptyText = reader.string();
              break;
            }
            case 10: {
              message.slider = reader.bool();
              break;
            }
            case 11: {
              message.hidden = reader.bool();
              break;
            }
            case 16: {
              message.minFrom = reader.string();
              break;
            }
            case 17: {
              message.maxTo = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a UIFilterHint message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {ScannerProtos.DataField.UIFilterHint} UIFilterHint
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UIFilterHint.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a UIFilterHint message.
       * @function verify
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      UIFilterHint.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.type != null && message.hasOwnProperty('type'))
          if (!$util.isString(message.type)) return 'type: string expected';
        if (message.defaultValue != null && message.hasOwnProperty('defaultValue'))
          if (!$util.isString(message.defaultValue)) return 'defaultValue: string expected';
        if (message.defaultOperator != null && message.hasOwnProperty('defaultOperator'))
          switch (message.defaultOperator) {
            default:
              return 'defaultOperator: enum value expected';
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
              break;
          }
        if (message.multiplier != null && message.hasOwnProperty('multiplier'))
          if (
            !$util.isInteger(message.multiplier) &&
            !(message.multiplier && $util.isInteger(message.multiplier.low) && $util.isInteger(message.multiplier.high))
          )
            return 'multiplier: integer|Long expected';
        if (message.emptyText != null && message.hasOwnProperty('emptyText'))
          if (!$util.isString(message.emptyText)) return 'emptyText: string expected';
        if (message.slider != null && message.hasOwnProperty('slider'))
          if (typeof message.slider !== 'boolean') return 'slider: boolean expected';
        if (message.hidden != null && message.hasOwnProperty('hidden'))
          if (typeof message.hidden !== 'boolean') return 'hidden: boolean expected';
        if (message.minFrom != null && message.hasOwnProperty('minFrom'))
          if (!$util.isString(message.minFrom)) return 'minFrom: string expected';
        if (message.maxTo != null && message.hasOwnProperty('maxTo'))
          if (!$util.isString(message.maxTo)) return 'maxTo: string expected';
        return null;
      };

      /**
       * Creates a UIFilterHint message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {ScannerProtos.DataField.UIFilterHint} UIFilterHint
       */
      UIFilterHint.fromObject = function fromObject(object) {
        if (object instanceof $root.ScannerProtos.DataField.UIFilterHint) return object;
        let message = new $root.ScannerProtos.DataField.UIFilterHint();
        if (object.type != null) message.type = String(object.type);
        if (object.defaultValue != null) message.defaultValue = String(object.defaultValue);
        switch (object.defaultOperator) {
          default:
            if (typeof object.defaultOperator === 'number') {
              message.defaultOperator = object.defaultOperator;
              break;
            }
            break;
          case 'UNKNOWN_OPERATOR':
          case 0:
            message.defaultOperator = 0;
            break;
          case 'LT':
          case 1:
            message.defaultOperator = 1;
            break;
          case 'GT':
          case 2:
            message.defaultOperator = 2;
            break;
          case 'GTE':
          case 3:
            message.defaultOperator = 3;
            break;
          case 'LTE':
          case 4:
            message.defaultOperator = 4;
            break;
          case 'EQ':
          case 5:
            message.defaultOperator = 5;
            break;
          case 'NE':
          case 6:
            message.defaultOperator = 6;
            break;
          case 'IN':
          case 7:
            message.defaultOperator = 7;
            break;
          case 'BETWEEN':
          case 8:
            message.defaultOperator = 8;
            break;
          case 'REGEEX':
          case 9:
            message.defaultOperator = 9;
            break;
          case 'NOTIN':
          case 10:
            message.defaultOperator = 10;
            break;
          case 'BEGINSWITH':
          case 11:
            message.defaultOperator = 11;
            break;
          case 'ENDSWITH':
          case 12:
            message.defaultOperator = 12;
            break;
          case 'CONTAINS':
          case 13:
            message.defaultOperator = 13;
            break;
          case 'NOTEMPTY':
          case 14:
            message.defaultOperator = 14;
            break;
          case 'ISEMPTY':
          case 15:
            message.defaultOperator = 15;
            break;
        }
        if (object.multiplier != null)
          if ($util.Long) (message.multiplier = $util.Long.fromValue(object.multiplier)).unsigned = false;
          else if (typeof object.multiplier === 'string') message.multiplier = parseInt(object.multiplier, 10);
          else if (typeof object.multiplier === 'number') message.multiplier = object.multiplier;
          else if (typeof object.multiplier === 'object')
            message.multiplier = new $util.LongBits(
              object.multiplier.low >>> 0,
              object.multiplier.high >>> 0,
            ).toNumber();
        if (object.emptyText != null) message.emptyText = String(object.emptyText);
        if (object.slider != null) message.slider = Boolean(object.slider);
        if (object.hidden != null) message.hidden = Boolean(object.hidden);
        if (object.minFrom != null) message.minFrom = String(object.minFrom);
        if (object.maxTo != null) message.maxTo = String(object.maxTo);
        return message;
      };

      /**
       * Creates a plain object from a UIFilterHint message. Also converts values to other types if specified.
       * @function toObject
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @static
       * @param {ScannerProtos.DataField.UIFilterHint} message UIFilterHint
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      UIFilterHint.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.defaults) {
          object.type = '';
          object.defaultValue = '';
          object.defaultOperator = options.enums === String ? 'UNKNOWN_OPERATOR' : 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.multiplier =
              options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else object.multiplier = options.longs === String ? '0' : 0;
          object.emptyText = '';
          object.slider = false;
          object.hidden = false;
          object.minFrom = '';
          object.maxTo = '';
        }
        if (message.type != null && message.hasOwnProperty('type')) object.type = message.type;
        if (message.defaultValue != null && message.hasOwnProperty('defaultValue'))
          object.defaultValue = message.defaultValue;
        if (message.defaultOperator != null && message.hasOwnProperty('defaultOperator'))
          object.defaultOperator =
            options.enums === String
              ? $root.ScannerProtos.Operator[message.defaultOperator] === undefined
                ? message.defaultOperator
                : $root.ScannerProtos.Operator[message.defaultOperator]
              : message.defaultOperator;
        if (message.multiplier != null && message.hasOwnProperty('multiplier'))
          if (typeof message.multiplier === 'number')
            object.multiplier = options.longs === String ? String(message.multiplier) : message.multiplier;
          else
            object.multiplier =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.multiplier)
                : options.longs === Number
                  ? new $util.LongBits(message.multiplier.low >>> 0, message.multiplier.high >>> 0).toNumber()
                  : message.multiplier;
        if (message.emptyText != null && message.hasOwnProperty('emptyText')) object.emptyText = message.emptyText;
        if (message.slider != null && message.hasOwnProperty('slider')) object.slider = message.slider;
        if (message.hidden != null && message.hasOwnProperty('hidden')) object.hidden = message.hidden;
        if (message.minFrom != null && message.hasOwnProperty('minFrom')) object.minFrom = message.minFrom;
        if (message.maxTo != null && message.hasOwnProperty('maxTo')) object.maxTo = message.maxTo;
        return object;
      };

      /**
       * Converts this UIFilterHint to JSON.
       * @function toJSON
       * @memberof ScannerProtos.DataField.UIFilterHint
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      UIFilterHint.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return UIFilterHint;
    })();

    DataField.UIColumnHint = (function () {
      /**
       * Properties of a UIColumnHint.
       * @memberof ScannerProtos.DataField
       * @interface IUIColumnHint
       * @property {ScannerProtos.DataField.UIColumnHint.Format|null} [format] UIColumnHint format
       * @property {number|null} [decimalPlaces] UIColumnHint decimalPlaces
       * @property {boolean|null} [percentage] UIColumnHint percentage
       */

      /**
       * Constructs a new UIColumnHint.
       * @memberof ScannerProtos.DataField
       * @classdesc *
       * @implements IUIColumnHint
       * @constructor
       * @param {ScannerProtos.DataField.IUIColumnHint=} [properties] Properties to set
       */
      function UIColumnHint(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * UIColumnHint format.
       * @member {ScannerProtos.DataField.UIColumnHint.Format} format
       * @memberof ScannerProtos.DataField.UIColumnHint
       * @instance
       */
      UIColumnHint.prototype.format = 0;

      /**
       * UIColumnHint decimalPlaces.
       * @member {number} decimalPlaces
       * @memberof ScannerProtos.DataField.UIColumnHint
       * @instance
       */
      UIColumnHint.prototype.decimalPlaces = 0;

      /**
       * UIColumnHint percentage.
       * @member {boolean} percentage
       * @memberof ScannerProtos.DataField.UIColumnHint
       * @instance
       */
      UIColumnHint.prototype.percentage = false;

      /**
       * Creates a new UIColumnHint instance using the specified properties.
       * @function create
       * @memberof ScannerProtos.DataField.UIColumnHint
       * @static
       * @param {ScannerProtos.DataField.IUIColumnHint=} [properties] Properties to set
       * @returns {ScannerProtos.DataField.UIColumnHint} UIColumnHint instance
       */
      UIColumnHint.create = function create(properties) {
        return new UIColumnHint(properties);
      };

      /**
       * Encodes the specified UIColumnHint message. Does not implicitly {@link ScannerProtos.DataField.UIColumnHint.verify|verify} messages.
       * @function encode
       * @memberof ScannerProtos.DataField.UIColumnHint
       * @static
       * @param {ScannerProtos.DataField.IUIColumnHint} message UIColumnHint message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UIColumnHint.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.format != null && Object.hasOwnProperty.call(message, 'format'))
          writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.format);
        if (message.decimalPlaces != null && Object.hasOwnProperty.call(message, 'decimalPlaces'))
          writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.decimalPlaces);
        if (message.percentage != null && Object.hasOwnProperty.call(message, 'percentage'))
          writer.uint32(/* id 3, wireType 0 =*/ 24).bool(message.percentage);
        return writer;
      };

      /**
       * Encodes the specified UIColumnHint message, length delimited. Does not implicitly {@link ScannerProtos.DataField.UIColumnHint.verify|verify} messages.
       * @function encodeDelimited
       * @memberof ScannerProtos.DataField.UIColumnHint
       * @static
       * @param {ScannerProtos.DataField.IUIColumnHint} message UIColumnHint message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UIColumnHint.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a UIColumnHint message from the specified reader or buffer.
       * @function decode
       * @memberof ScannerProtos.DataField.UIColumnHint
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {ScannerProtos.DataField.UIColumnHint} UIColumnHint
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UIColumnHint.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.ScannerProtos.DataField.UIColumnHint();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.format = reader.int32();
              break;
            }
            case 2: {
              message.decimalPlaces = reader.int32();
              break;
            }
            case 3: {
              message.percentage = reader.bool();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a UIColumnHint message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof ScannerProtos.DataField.UIColumnHint
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {ScannerProtos.DataField.UIColumnHint} UIColumnHint
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UIColumnHint.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a UIColumnHint message.
       * @function verify
       * @memberof ScannerProtos.DataField.UIColumnHint
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      UIColumnHint.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.format != null && message.hasOwnProperty('format'))
          switch (message.format) {
            default:
              return 'format: enum value expected';
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
              break;
          }
        if (message.decimalPlaces != null && message.hasOwnProperty('decimalPlaces'))
          if (!$util.isInteger(message.decimalPlaces)) return 'decimalPlaces: integer expected';
        if (message.percentage != null && message.hasOwnProperty('percentage'))
          if (typeof message.percentage !== 'boolean') return 'percentage: boolean expected';
        return null;
      };

      /**
       * Creates a UIColumnHint message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof ScannerProtos.DataField.UIColumnHint
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {ScannerProtos.DataField.UIColumnHint} UIColumnHint
       */
      UIColumnHint.fromObject = function fromObject(object) {
        if (object instanceof $root.ScannerProtos.DataField.UIColumnHint) return object;
        let message = new $root.ScannerProtos.DataField.UIColumnHint();
        switch (object.format) {
          default:
            if (typeof object.format === 'number') {
              message.format = object.format;
              break;
            }
            break;
          case 'PRICE':
          case 0:
            message.format = 0;
            break;
          case 'PRICE_PERCENT':
          case 1:
            message.format = 1;
            break;
          case 'LONG_HUMAN_READABLE':
          case 2:
            message.format = 2;
            break;
          case 'PRICE_CHANGE':
          case 3:
            message.format = 3;
            break;
          case 'PERCENT':
          case 4:
            message.format = 4;
            break;
          case 'DATE':
          case 5:
            message.format = 5;
            break;
          case 'DATETIME':
          case 6:
            message.format = 6;
            break;
        }
        if (object.decimalPlaces != null) message.decimalPlaces = object.decimalPlaces | 0;
        if (object.percentage != null) message.percentage = Boolean(object.percentage);
        return message;
      };

      /**
       * Creates a plain object from a UIColumnHint message. Also converts values to other types if specified.
       * @function toObject
       * @memberof ScannerProtos.DataField.UIColumnHint
       * @static
       * @param {ScannerProtos.DataField.UIColumnHint} message UIColumnHint
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      UIColumnHint.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.defaults) {
          object.format = options.enums === String ? 'PRICE' : 0;
          object.decimalPlaces = 0;
          object.percentage = false;
        }
        if (message.format != null && message.hasOwnProperty('format'))
          object.format =
            options.enums === String
              ? $root.ScannerProtos.DataField.UIColumnHint.Format[message.format] === undefined
                ? message.format
                : $root.ScannerProtos.DataField.UIColumnHint.Format[message.format]
              : message.format;
        if (message.decimalPlaces != null && message.hasOwnProperty('decimalPlaces'))
          object.decimalPlaces = message.decimalPlaces;
        if (message.percentage != null && message.hasOwnProperty('percentage')) object.percentage = message.percentage;
        return object;
      };

      /**
       * Converts this UIColumnHint to JSON.
       * @function toJSON
       * @memberof ScannerProtos.DataField.UIColumnHint
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      UIColumnHint.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      /**
       * Format enum.
       * @name ScannerProtos.DataField.UIColumnHint.Format
       * @enum {number}
       * @property {number} PRICE=0 PRICE value
       * @property {number} PRICE_PERCENT=1 PRICE_PERCENT value
       * @property {number} LONG_HUMAN_READABLE=2 LONG_HUMAN_READABLE value
       * @property {number} PRICE_CHANGE=3 PRICE_CHANGE value
       * @property {number} PERCENT=4 PERCENT value
       * @property {number} DATE=5 DATE value
       * @property {number} DATETIME=6 DATETIME value
       */
      UIColumnHint.Format = (function () {
        const valuesById = {},
          values = Object.create(valuesById);
        values[(valuesById[0] = 'PRICE')] = 0;
        values[(valuesById[1] = 'PRICE_PERCENT')] = 1;
        values[(valuesById[2] = 'LONG_HUMAN_READABLE')] = 2;
        values[(valuesById[3] = 'PRICE_CHANGE')] = 3;
        values[(valuesById[4] = 'PERCENT')] = 4;
        values[(valuesById[5] = 'DATE')] = 5;
        values[(valuesById[6] = 'DATETIME')] = 6;
        return values;
      })();

      return UIColumnHint;
    })();

    DataField.UIHints = (function () {
      /**
       * Properties of a UIHints.
       * @memberof ScannerProtos.DataField
       * @interface IUIHints
       * @property {string|null} [noRowsWarning] UIHints noRowsWarning
       */

      /**
       * Constructs a new UIHints.
       * @memberof ScannerProtos.DataField
       * @classdesc * Hints for a ui implementing the scanner.
       * * THIS IS NOT SPECIFIC TO A UI, BUT SHOULD BE GENERIC FOR ALL
       * @implements IUIHints
       * @constructor
       * @param {ScannerProtos.DataField.IUIHints=} [properties] Properties to set
       */
      function UIHints(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * UIHints noRowsWarning.
       * @member {string} noRowsWarning
       * @memberof ScannerProtos.DataField.UIHints
       * @instance
       */
      UIHints.prototype.noRowsWarning = '';

      /**
       * Creates a new UIHints instance using the specified properties.
       * @function create
       * @memberof ScannerProtos.DataField.UIHints
       * @static
       * @param {ScannerProtos.DataField.IUIHints=} [properties] Properties to set
       * @returns {ScannerProtos.DataField.UIHints} UIHints instance
       */
      UIHints.create = function create(properties) {
        return new UIHints(properties);
      };

      /**
       * Encodes the specified UIHints message. Does not implicitly {@link ScannerProtos.DataField.UIHints.verify|verify} messages.
       * @function encode
       * @memberof ScannerProtos.DataField.UIHints
       * @static
       * @param {ScannerProtos.DataField.IUIHints} message UIHints message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UIHints.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.noRowsWarning != null && Object.hasOwnProperty.call(message, 'noRowsWarning'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.noRowsWarning);
        return writer;
      };

      /**
       * Encodes the specified UIHints message, length delimited. Does not implicitly {@link ScannerProtos.DataField.UIHints.verify|verify} messages.
       * @function encodeDelimited
       * @memberof ScannerProtos.DataField.UIHints
       * @static
       * @param {ScannerProtos.DataField.IUIHints} message UIHints message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      UIHints.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a UIHints message from the specified reader or buffer.
       * @function decode
       * @memberof ScannerProtos.DataField.UIHints
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {ScannerProtos.DataField.UIHints} UIHints
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UIHints.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.ScannerProtos.DataField.UIHints();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.noRowsWarning = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a UIHints message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof ScannerProtos.DataField.UIHints
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {ScannerProtos.DataField.UIHints} UIHints
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      UIHints.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a UIHints message.
       * @function verify
       * @memberof ScannerProtos.DataField.UIHints
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      UIHints.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.noRowsWarning != null && message.hasOwnProperty('noRowsWarning'))
          if (!$util.isString(message.noRowsWarning)) return 'noRowsWarning: string expected';
        return null;
      };

      /**
       * Creates a UIHints message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof ScannerProtos.DataField.UIHints
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {ScannerProtos.DataField.UIHints} UIHints
       */
      UIHints.fromObject = function fromObject(object) {
        if (object instanceof $root.ScannerProtos.DataField.UIHints) return object;
        let message = new $root.ScannerProtos.DataField.UIHints();
        if (object.noRowsWarning != null) message.noRowsWarning = String(object.noRowsWarning);
        return message;
      };

      /**
       * Creates a plain object from a UIHints message. Also converts values to other types if specified.
       * @function toObject
       * @memberof ScannerProtos.DataField.UIHints
       * @static
       * @param {ScannerProtos.DataField.UIHints} message UIHints
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      UIHints.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.defaults) object.noRowsWarning = '';
        if (message.noRowsWarning != null && message.hasOwnProperty('noRowsWarning'))
          object.noRowsWarning = message.noRowsWarning;
        return object;
      };

      /**
       * Converts this UIHints to JSON.
       * @function toJSON
       * @memberof ScannerProtos.DataField.UIHints
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      UIHints.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return UIHints;
    })();

    DataField.Option = (function () {
      /**
       * Properties of an Option.
       * @memberof ScannerProtos.DataField
       * @interface IOption
       * @property {string|null} [label] Option label
       * @property {string|null} [value] Option value
       */

      /**
       * Constructs a new Option.
       * @memberof ScannerProtos.DataField
       * @classdesc Represents an Option.
       * @implements IOption
       * @constructor
       * @param {ScannerProtos.DataField.IOption=} [properties] Properties to set
       */
      function Option(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Option label.
       * @member {string} label
       * @memberof ScannerProtos.DataField.Option
       * @instance
       */
      Option.prototype.label = '';

      /**
       * Option value.
       * @member {string} value
       * @memberof ScannerProtos.DataField.Option
       * @instance
       */
      Option.prototype.value = '';

      /**
       * Creates a new Option instance using the specified properties.
       * @function create
       * @memberof ScannerProtos.DataField.Option
       * @static
       * @param {ScannerProtos.DataField.IOption=} [properties] Properties to set
       * @returns {ScannerProtos.DataField.Option} Option instance
       */
      Option.create = function create(properties) {
        return new Option(properties);
      };

      /**
       * Encodes the specified Option message. Does not implicitly {@link ScannerProtos.DataField.Option.verify|verify} messages.
       * @function encode
       * @memberof ScannerProtos.DataField.Option
       * @static
       * @param {ScannerProtos.DataField.IOption} message Option message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Option.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.label != null && Object.hasOwnProperty.call(message, 'label'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.label);
        if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.value);
        return writer;
      };

      /**
       * Encodes the specified Option message, length delimited. Does not implicitly {@link ScannerProtos.DataField.Option.verify|verify} messages.
       * @function encodeDelimited
       * @memberof ScannerProtos.DataField.Option
       * @static
       * @param {ScannerProtos.DataField.IOption} message Option message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Option.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes an Option message from the specified reader or buffer.
       * @function decode
       * @memberof ScannerProtos.DataField.Option
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {ScannerProtos.DataField.Option} Option
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Option.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.ScannerProtos.DataField.Option();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.label = reader.string();
              break;
            }
            case 2: {
              message.value = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes an Option message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof ScannerProtos.DataField.Option
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {ScannerProtos.DataField.Option} Option
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Option.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies an Option message.
       * @function verify
       * @memberof ScannerProtos.DataField.Option
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Option.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.label != null && message.hasOwnProperty('label'))
          if (!$util.isString(message.label)) return 'label: string expected';
        if (message.value != null && message.hasOwnProperty('value'))
          if (!$util.isString(message.value)) return 'value: string expected';
        return null;
      };

      /**
       * Creates an Option message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof ScannerProtos.DataField.Option
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {ScannerProtos.DataField.Option} Option
       */
      Option.fromObject = function fromObject(object) {
        if (object instanceof $root.ScannerProtos.DataField.Option) return object;
        let message = new $root.ScannerProtos.DataField.Option();
        if (object.label != null) message.label = String(object.label);
        if (object.value != null) message.value = String(object.value);
        return message;
      };

      /**
       * Creates a plain object from an Option message. Also converts values to other types if specified.
       * @function toObject
       * @memberof ScannerProtos.DataField.Option
       * @static
       * @param {ScannerProtos.DataField.Option} message Option
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Option.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.defaults) {
          object.label = '';
          object.value = '';
        }
        if (message.label != null && message.hasOwnProperty('label')) object.label = message.label;
        if (message.value != null && message.hasOwnProperty('value')) object.value = message.value;
        return object;
      };

      /**
       * Converts this Option to JSON.
       * @function toJSON
       * @memberof ScannerProtos.DataField.Option
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Option.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Option;
    })();

    /**
     * UpdateFrequency enum.
     * @name ScannerProtos.DataField.UpdateFrequency
     * @enum {number}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} INTRADAY=1 INTRADAY value
     * @property {number} EOD=2 EOD value
     */
    DataField.UpdateFrequency = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'UNKNOWN')] = 0;
      values[(valuesById[1] = 'INTRADAY')] = 1;
      values[(valuesById[2] = 'EOD')] = 2;
      return values;
    })();

    return DataField;
  })();

  ScannerProtos.Datafields = (function () {
    /**
     * Properties of a Datafields.
     * @memberof ScannerProtos
     * @interface IDatafields
     * @property {Array.<ScannerProtos.IDataField>|null} [dataField] Datafields dataField
     * @property {Array.<ScannerProtos.IFilterOption>|null} [filterOptions] Datafields filterOptions
     */

    /**
     * Constructs a new Datafields.
     * @memberof ScannerProtos
     * @classdesc Used to provide meta information about datafields to UI's.
     * @implements IDatafields
     * @constructor
     * @param {ScannerProtos.IDatafields=} [properties] Properties to set
     */
    function Datafields(properties) {
      this.dataField = [];
      this.filterOptions = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Datafields dataField.
     * @member {Array.<ScannerProtos.IDataField>} dataField
     * @memberof ScannerProtos.Datafields
     * @instance
     */
    Datafields.prototype.dataField = $util.emptyArray;

    /**
     * Datafields filterOptions.
     * @member {Array.<ScannerProtos.IFilterOption>} filterOptions
     * @memberof ScannerProtos.Datafields
     * @instance
     */
    Datafields.prototype.filterOptions = $util.emptyArray;

    /**
     * Creates a new Datafields instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.Datafields
     * @static
     * @param {ScannerProtos.IDatafields=} [properties] Properties to set
     * @returns {ScannerProtos.Datafields} Datafields instance
     */
    Datafields.create = function create(properties) {
      return new Datafields(properties);
    };

    /**
     * Encodes the specified Datafields message. Does not implicitly {@link ScannerProtos.Datafields.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.Datafields
     * @static
     * @param {ScannerProtos.IDatafields} message Datafields message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Datafields.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.dataField != null && message.dataField.length)
        for (let i = 0; i < message.dataField.length; ++i)
          $root.ScannerProtos.DataField.encode(
            message.dataField[i],
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
          ).ldelim();
      if (message.filterOptions != null && message.filterOptions.length)
        for (let i = 0; i < message.filterOptions.length; ++i)
          $root.ScannerProtos.FilterOption.encode(
            message.filterOptions[i],
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork(),
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified Datafields message, length delimited. Does not implicitly {@link ScannerProtos.Datafields.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.Datafields
     * @static
     * @param {ScannerProtos.IDatafields} message Datafields message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Datafields.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Datafields message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.Datafields
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.Datafields} Datafields
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Datafields.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.Datafields();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (!(message.dataField && message.dataField.length)) message.dataField = [];
            message.dataField.push($root.ScannerProtos.DataField.decode(reader, reader.uint32()));
            break;
          }
          case 2: {
            if (!(message.filterOptions && message.filterOptions.length)) message.filterOptions = [];
            message.filterOptions.push($root.ScannerProtos.FilterOption.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Datafields message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.Datafields
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.Datafields} Datafields
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Datafields.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Datafields message.
     * @function verify
     * @memberof ScannerProtos.Datafields
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Datafields.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.dataField != null && message.hasOwnProperty('dataField')) {
        if (!Array.isArray(message.dataField)) return 'dataField: array expected';
        for (let i = 0; i < message.dataField.length; ++i) {
          let error = $root.ScannerProtos.DataField.verify(message.dataField[i]);
          if (error) return 'dataField.' + error;
        }
      }
      if (message.filterOptions != null && message.hasOwnProperty('filterOptions')) {
        if (!Array.isArray(message.filterOptions)) return 'filterOptions: array expected';
        for (let i = 0; i < message.filterOptions.length; ++i) {
          let error = $root.ScannerProtos.FilterOption.verify(message.filterOptions[i]);
          if (error) return 'filterOptions.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a Datafields message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.Datafields
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.Datafields} Datafields
     */
    Datafields.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.Datafields) return object;
      let message = new $root.ScannerProtos.Datafields();
      if (object.dataField) {
        if (!Array.isArray(object.dataField)) throw TypeError('.ScannerProtos.Datafields.dataField: array expected');
        message.dataField = [];
        for (let i = 0; i < object.dataField.length; ++i) {
          if (typeof object.dataField[i] !== 'object')
            throw TypeError('.ScannerProtos.Datafields.dataField: object expected');
          message.dataField[i] = $root.ScannerProtos.DataField.fromObject(object.dataField[i]);
        }
      }
      if (object.filterOptions) {
        if (!Array.isArray(object.filterOptions))
          throw TypeError('.ScannerProtos.Datafields.filterOptions: array expected');
        message.filterOptions = [];
        for (let i = 0; i < object.filterOptions.length; ++i) {
          if (typeof object.filterOptions[i] !== 'object')
            throw TypeError('.ScannerProtos.Datafields.filterOptions: object expected');
          message.filterOptions[i] = $root.ScannerProtos.FilterOption.fromObject(object.filterOptions[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a Datafields message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.Datafields
     * @static
     * @param {ScannerProtos.Datafields} message Datafields
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Datafields.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.dataField = [];
        object.filterOptions = [];
      }
      if (message.dataField && message.dataField.length) {
        object.dataField = [];
        for (let j = 0; j < message.dataField.length; ++j)
          object.dataField[j] = $root.ScannerProtos.DataField.toObject(message.dataField[j], options);
      }
      if (message.filterOptions && message.filterOptions.length) {
        object.filterOptions = [];
        for (let j = 0; j < message.filterOptions.length; ++j)
          object.filterOptions[j] = $root.ScannerProtos.FilterOption.toObject(message.filterOptions[j], options);
      }
      return object;
    };

    /**
     * Converts this Datafields to JSON.
     * @function toJSON
     * @memberof ScannerProtos.Datafields
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Datafields.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Datafields;
  })();

  ScannerProtos.FilterOption = (function () {
    /**
     * Properties of a FilterOption.
     * @memberof ScannerProtos
     * @interface IFilterOption
     * @property {string|null} [name] FilterOption name
     * @property {Array.<ScannerProtos.IOption>|null} [options] FilterOption options
     */

    /**
     * Constructs a new FilterOption.
     * @memberof ScannerProtos
     * @classdesc Represents a FilterOption.
     * @implements IFilterOption
     * @constructor
     * @param {ScannerProtos.IFilterOption=} [properties] Properties to set
     */
    function FilterOption(properties) {
      this.options = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * FilterOption name.
     * @member {string} name
     * @memberof ScannerProtos.FilterOption
     * @instance
     */
    FilterOption.prototype.name = '';

    /**
     * FilterOption options.
     * @member {Array.<ScannerProtos.IOption>} options
     * @memberof ScannerProtos.FilterOption
     * @instance
     */
    FilterOption.prototype.options = $util.emptyArray;

    /**
     * Creates a new FilterOption instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.FilterOption
     * @static
     * @param {ScannerProtos.IFilterOption=} [properties] Properties to set
     * @returns {ScannerProtos.FilterOption} FilterOption instance
     */
    FilterOption.create = function create(properties) {
      return new FilterOption(properties);
    };

    /**
     * Encodes the specified FilterOption message. Does not implicitly {@link ScannerProtos.FilterOption.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.FilterOption
     * @static
     * @param {ScannerProtos.IFilterOption} message FilterOption message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FilterOption.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.name != null && Object.hasOwnProperty.call(message, 'name'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
      if (message.options != null && message.options.length)
        for (let i = 0; i < message.options.length; ++i)
          $root.ScannerProtos.Option.encode(
            message.options[i],
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork(),
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified FilterOption message, length delimited. Does not implicitly {@link ScannerProtos.FilterOption.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.FilterOption
     * @static
     * @param {ScannerProtos.IFilterOption} message FilterOption message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FilterOption.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FilterOption message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.FilterOption
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.FilterOption} FilterOption
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FilterOption.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.FilterOption();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.name = reader.string();
            break;
          }
          case 2: {
            if (!(message.options && message.options.length)) message.options = [];
            message.options.push($root.ScannerProtos.Option.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a FilterOption message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.FilterOption
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.FilterOption} FilterOption
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FilterOption.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FilterOption message.
     * @function verify
     * @memberof ScannerProtos.FilterOption
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FilterOption.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.name != null && message.hasOwnProperty('name'))
        if (!$util.isString(message.name)) return 'name: string expected';
      if (message.options != null && message.hasOwnProperty('options')) {
        if (!Array.isArray(message.options)) return 'options: array expected';
        for (let i = 0; i < message.options.length; ++i) {
          let error = $root.ScannerProtos.Option.verify(message.options[i]);
          if (error) return 'options.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a FilterOption message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.FilterOption
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.FilterOption} FilterOption
     */
    FilterOption.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.FilterOption) return object;
      let message = new $root.ScannerProtos.FilterOption();
      if (object.name != null) message.name = String(object.name);
      if (object.options) {
        if (!Array.isArray(object.options)) throw TypeError('.ScannerProtos.FilterOption.options: array expected');
        message.options = [];
        for (let i = 0; i < object.options.length; ++i) {
          if (typeof object.options[i] !== 'object')
            throw TypeError('.ScannerProtos.FilterOption.options: object expected');
          message.options[i] = $root.ScannerProtos.Option.fromObject(object.options[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a FilterOption message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.FilterOption
     * @static
     * @param {ScannerProtos.FilterOption} message FilterOption
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FilterOption.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.options = [];
      if (options.defaults) object.name = '';
      if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
      if (message.options && message.options.length) {
        object.options = [];
        for (let j = 0; j < message.options.length; ++j)
          object.options[j] = $root.ScannerProtos.Option.toObject(message.options[j], options);
      }
      return object;
    };

    /**
     * Converts this FilterOption to JSON.
     * @function toJSON
     * @memberof ScannerProtos.FilterOption
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FilterOption.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FilterOption;
  })();

  ScannerProtos.Option = (function () {
    /**
     * Properties of an Option.
     * @memberof ScannerProtos
     * @interface IOption
     * @property {string|null} [label] Option label
     * @property {Array.<string>|null} [params] Option params
     */

    /**
     * Constructs a new Option.
     * @memberof ScannerProtos
     * @classdesc Represents an Option.
     * @implements IOption
     * @constructor
     * @param {ScannerProtos.IOption=} [properties] Properties to set
     */
    function Option(properties) {
      this.params = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Option label.
     * @member {string} label
     * @memberof ScannerProtos.Option
     * @instance
     */
    Option.prototype.label = '';

    /**
     * Option params.
     * @member {Array.<string>} params
     * @memberof ScannerProtos.Option
     * @instance
     */
    Option.prototype.params = $util.emptyArray;

    /**
     * Creates a new Option instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.Option
     * @static
     * @param {ScannerProtos.IOption=} [properties] Properties to set
     * @returns {ScannerProtos.Option} Option instance
     */
    Option.create = function create(properties) {
      return new Option(properties);
    };

    /**
     * Encodes the specified Option message. Does not implicitly {@link ScannerProtos.Option.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.Option
     * @static
     * @param {ScannerProtos.IOption} message Option message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Option.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.label != null && Object.hasOwnProperty.call(message, 'label'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.label);
      if (message.params != null && message.params.length)
        for (let i = 0; i < message.params.length; ++i)
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.params[i]);
      return writer;
    };

    /**
     * Encodes the specified Option message, length delimited. Does not implicitly {@link ScannerProtos.Option.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.Option
     * @static
     * @param {ScannerProtos.IOption} message Option message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Option.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Option message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.Option
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.Option} Option
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Option.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.Option();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.label = reader.string();
            break;
          }
          case 2: {
            if (!(message.params && message.params.length)) message.params = [];
            message.params.push(reader.string());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an Option message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.Option
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.Option} Option
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Option.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Option message.
     * @function verify
     * @memberof ScannerProtos.Option
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Option.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.label != null && message.hasOwnProperty('label'))
        if (!$util.isString(message.label)) return 'label: string expected';
      if (message.params != null && message.hasOwnProperty('params')) {
        if (!Array.isArray(message.params)) return 'params: array expected';
        for (let i = 0; i < message.params.length; ++i)
          if (!$util.isString(message.params[i])) return 'params: string[] expected';
      }
      return null;
    };

    /**
     * Creates an Option message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.Option
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.Option} Option
     */
    Option.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.Option) return object;
      let message = new $root.ScannerProtos.Option();
      if (object.label != null) message.label = String(object.label);
      if (object.params) {
        if (!Array.isArray(object.params)) throw TypeError('.ScannerProtos.Option.params: array expected');
        message.params = [];
        for (let i = 0; i < object.params.length; ++i) message.params[i] = String(object.params[i]);
      }
      return message;
    };

    /**
     * Creates a plain object from an Option message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.Option
     * @static
     * @param {ScannerProtos.Option} message Option
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Option.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.params = [];
      if (options.defaults) object.label = '';
      if (message.label != null && message.hasOwnProperty('label')) object.label = message.label;
      if (message.params && message.params.length) {
        object.params = [];
        for (let j = 0; j < message.params.length; ++j) object.params[j] = message.params[j];
      }
      return object;
    };

    /**
     * Converts this Option to JSON.
     * @function toJSON
     * @memberof ScannerProtos.Option
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Option.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Option;
  })();

  ScannerProtos.Snapshot = (function () {
    /**
     * Properties of a Snapshot.
     * @memberof ScannerProtos
     * @interface ISnapshot
     * @property {Array.<LastProtos.IQuote>|null} [instruments] Snapshot instruments
     */

    /**
     * Constructs a new Snapshot.
     * @memberof ScannerProtos
     * @classdesc Represents a Snapshot.
     * @implements ISnapshot
     * @constructor
     * @param {ScannerProtos.ISnapshot=} [properties] Properties to set
     */
    function Snapshot(properties) {
      this.instruments = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Snapshot instruments.
     * @member {Array.<LastProtos.IQuote>} instruments
     * @memberof ScannerProtos.Snapshot
     * @instance
     */
    Snapshot.prototype.instruments = $util.emptyArray;

    /**
     * Creates a new Snapshot instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.Snapshot
     * @static
     * @param {ScannerProtos.ISnapshot=} [properties] Properties to set
     * @returns {ScannerProtos.Snapshot} Snapshot instance
     */
    Snapshot.create = function create(properties) {
      return new Snapshot(properties);
    };

    /**
     * Encodes the specified Snapshot message. Does not implicitly {@link ScannerProtos.Snapshot.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.Snapshot
     * @static
     * @param {ScannerProtos.ISnapshot} message Snapshot message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Snapshot.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.instruments != null && message.instruments.length)
        for (let i = 0; i < message.instruments.length; ++i)
          $root.LastProtos.Quote.encode(
            message.instruments[i],
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified Snapshot message, length delimited. Does not implicitly {@link ScannerProtos.Snapshot.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.Snapshot
     * @static
     * @param {ScannerProtos.ISnapshot} message Snapshot message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Snapshot.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Snapshot message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.Snapshot
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.Snapshot} Snapshot
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Snapshot.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.Snapshot();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (!(message.instruments && message.instruments.length)) message.instruments = [];
            message.instruments.push($root.LastProtos.Quote.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Snapshot message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.Snapshot
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.Snapshot} Snapshot
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Snapshot.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Snapshot message.
     * @function verify
     * @memberof ScannerProtos.Snapshot
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Snapshot.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.instruments != null && message.hasOwnProperty('instruments')) {
        if (!Array.isArray(message.instruments)) return 'instruments: array expected';
        for (let i = 0; i < message.instruments.length; ++i) {
          let error = $root.LastProtos.Quote.verify(message.instruments[i]);
          if (error) return 'instruments.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a Snapshot message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.Snapshot
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.Snapshot} Snapshot
     */
    Snapshot.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.Snapshot) return object;
      let message = new $root.ScannerProtos.Snapshot();
      if (object.instruments) {
        if (!Array.isArray(object.instruments)) throw TypeError('.ScannerProtos.Snapshot.instruments: array expected');
        message.instruments = [];
        for (let i = 0; i < object.instruments.length; ++i) {
          if (typeof object.instruments[i] !== 'object')
            throw TypeError('.ScannerProtos.Snapshot.instruments: object expected');
          message.instruments[i] = $root.LastProtos.Quote.fromObject(object.instruments[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a Snapshot message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.Snapshot
     * @static
     * @param {ScannerProtos.Snapshot} message Snapshot
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Snapshot.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.instruments = [];
      if (message.instruments && message.instruments.length) {
        object.instruments = [];
        for (let j = 0; j < message.instruments.length; ++j)
          object.instruments[j] = $root.LastProtos.Quote.toObject(message.instruments[j], options);
      }
      return object;
    };

    /**
     * Converts this Snapshot to JSON.
     * @function toJSON
     * @memberof ScannerProtos.Snapshot
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Snapshot.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Snapshot;
  })();

  ScannerProtos.Response = (function () {
    /**
     * Properties of a Response.
     * @memberof ScannerProtos
     * @interface IResponse
     * @property {number|null} [id] Response id
     * @property {CommonProtos.IErr|null} [error] Response error
     * @property {ScannerProtos.ISnapshot|null} [snapshot] Response snapshot
     * @property {number|Long|null} [heartbeat] Response heartbeat
     * @property {ScannerProtos.IRowUpdates|null} [rowUpdates] Response rowUpdates
     * @property {LastProtos.IQuote|null} [signal] Response signal
     * @property {ScannerProtos.IRowUpdatesV2|null} [rowUpdatesV2] Response rowUpdatesV2
     */

    /**
     * Constructs a new Response.
     * @memberof ScannerProtos
     * @classdesc Part of the messages. This is the only message ever sent by the websocket server.
     * @implements IResponse
     * @constructor
     * @param {ScannerProtos.IResponse=} [properties] Properties to set
     */
    function Response(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Response id.
     * @member {number} id
     * @memberof ScannerProtos.Response
     * @instance
     */
    Response.prototype.id = 0;

    /**
     * Response error.
     * @member {CommonProtos.IErr|null|undefined} error
     * @memberof ScannerProtos.Response
     * @instance
     */
    Response.prototype.error = null;

    /**
     * Response snapshot.
     * @member {ScannerProtos.ISnapshot|null|undefined} snapshot
     * @memberof ScannerProtos.Response
     * @instance
     */
    Response.prototype.snapshot = null;

    /**
     * Response heartbeat.
     * @member {number|Long} heartbeat
     * @memberof ScannerProtos.Response
     * @instance
     */
    Response.prototype.heartbeat = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Response rowUpdates.
     * @member {ScannerProtos.IRowUpdates|null|undefined} rowUpdates
     * @memberof ScannerProtos.Response
     * @instance
     */
    Response.prototype.rowUpdates = null;

    /**
     * Response signal.
     * @member {LastProtos.IQuote|null|undefined} signal
     * @memberof ScannerProtos.Response
     * @instance
     */
    Response.prototype.signal = null;

    /**
     * Response rowUpdatesV2.
     * @member {ScannerProtos.IRowUpdatesV2|null|undefined} rowUpdatesV2
     * @memberof ScannerProtos.Response
     * @instance
     */
    Response.prototype.rowUpdatesV2 = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Response type.
     * @member {"snapshot"|"heartbeat"|"rowUpdates"|"signal"|"rowUpdatesV2"|undefined} type
     * @memberof ScannerProtos.Response
     * @instance
     */
    Object.defineProperty(Response.prototype, 'type', {
      get: $util.oneOfGetter(($oneOfFields = ['snapshot', 'heartbeat', 'rowUpdates', 'signal', 'rowUpdatesV2'])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new Response instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.Response
     * @static
     * @param {ScannerProtos.IResponse=} [properties] Properties to set
     * @returns {ScannerProtos.Response} Response instance
     */
    Response.create = function create(properties) {
      return new Response(properties);
    };

    /**
     * Encodes the specified Response message. Does not implicitly {@link ScannerProtos.Response.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.Response
     * @static
     * @param {ScannerProtos.IResponse} message Response message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Response.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, 'id'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.id);
      if (message.error != null && Object.hasOwnProperty.call(message, 'error'))
        $root.CommonProtos.Err.encode(message.error, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
      if (message.snapshot != null && Object.hasOwnProperty.call(message, 'snapshot'))
        $root.ScannerProtos.Snapshot.encode(
          message.snapshot,
          writer.uint32(/* id 10, wireType 2 =*/ 82).fork(),
        ).ldelim();
      if (message.heartbeat != null && Object.hasOwnProperty.call(message, 'heartbeat'))
        writer.uint32(/* id 11, wireType 0 =*/ 88).int64(message.heartbeat);
      if (message.rowUpdates != null && Object.hasOwnProperty.call(message, 'rowUpdates'))
        $root.ScannerProtos.RowUpdates.encode(
          message.rowUpdates,
          writer.uint32(/* id 12, wireType 2 =*/ 98).fork(),
        ).ldelim();
      if (message.signal != null && Object.hasOwnProperty.call(message, 'signal'))
        $root.LastProtos.Quote.encode(message.signal, writer.uint32(/* id 13, wireType 2 =*/ 106).fork()).ldelim();
      if (message.rowUpdatesV2 != null && Object.hasOwnProperty.call(message, 'rowUpdatesV2'))
        $root.ScannerProtos.RowUpdatesV2.encode(
          message.rowUpdatesV2,
          writer.uint32(/* id 14, wireType 2 =*/ 114).fork(),
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified Response message, length delimited. Does not implicitly {@link ScannerProtos.Response.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.Response
     * @static
     * @param {ScannerProtos.IResponse} message Response message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Response.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Response message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.Response
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.Response} Response
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Response.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.Response();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.id = reader.int32();
            break;
          }
          case 2: {
            message.error = $root.CommonProtos.Err.decode(reader, reader.uint32());
            break;
          }
          case 10: {
            message.snapshot = $root.ScannerProtos.Snapshot.decode(reader, reader.uint32());
            break;
          }
          case 11: {
            message.heartbeat = reader.int64();
            break;
          }
          case 12: {
            message.rowUpdates = $root.ScannerProtos.RowUpdates.decode(reader, reader.uint32());
            break;
          }
          case 13: {
            message.signal = $root.LastProtos.Quote.decode(reader, reader.uint32());
            break;
          }
          case 14: {
            message.rowUpdatesV2 = $root.ScannerProtos.RowUpdatesV2.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Response message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.Response
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.Response} Response
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Response.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Response message.
     * @function verify
     * @memberof ScannerProtos.Response
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Response.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      let properties = {};
      if (message.id != null && message.hasOwnProperty('id'))
        if (!$util.isInteger(message.id)) return 'id: integer expected';
      if (message.error != null && message.hasOwnProperty('error')) {
        let error = $root.CommonProtos.Err.verify(message.error);
        if (error) return 'error.' + error;
      }
      if (message.snapshot != null && message.hasOwnProperty('snapshot')) {
        properties.type = 1;
        {
          let error = $root.ScannerProtos.Snapshot.verify(message.snapshot);
          if (error) return 'snapshot.' + error;
        }
      }
      if (message.heartbeat != null && message.hasOwnProperty('heartbeat')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        if (
          !$util.isInteger(message.heartbeat) &&
          !(message.heartbeat && $util.isInteger(message.heartbeat.low) && $util.isInteger(message.heartbeat.high))
        )
          return 'heartbeat: integer|Long expected';
      }
      if (message.rowUpdates != null && message.hasOwnProperty('rowUpdates')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.RowUpdates.verify(message.rowUpdates);
          if (error) return 'rowUpdates.' + error;
        }
      }
      if (message.signal != null && message.hasOwnProperty('signal')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.LastProtos.Quote.verify(message.signal);
          if (error) return 'signal.' + error;
        }
      }
      if (message.rowUpdatesV2 != null && message.hasOwnProperty('rowUpdatesV2')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.RowUpdatesV2.verify(message.rowUpdatesV2);
          if (error) return 'rowUpdatesV2.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a Response message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.Response
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.Response} Response
     */
    Response.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.Response) return object;
      let message = new $root.ScannerProtos.Response();
      if (object.id != null) message.id = object.id | 0;
      if (object.error != null) {
        if (typeof object.error !== 'object') throw TypeError('.ScannerProtos.Response.error: object expected');
        message.error = $root.CommonProtos.Err.fromObject(object.error);
      }
      if (object.snapshot != null) {
        if (typeof object.snapshot !== 'object') throw TypeError('.ScannerProtos.Response.snapshot: object expected');
        message.snapshot = $root.ScannerProtos.Snapshot.fromObject(object.snapshot);
      }
      if (object.heartbeat != null)
        if ($util.Long) (message.heartbeat = $util.Long.fromValue(object.heartbeat)).unsigned = false;
        else if (typeof object.heartbeat === 'string') message.heartbeat = parseInt(object.heartbeat, 10);
        else if (typeof object.heartbeat === 'number') message.heartbeat = object.heartbeat;
        else if (typeof object.heartbeat === 'object')
          message.heartbeat = new $util.LongBits(object.heartbeat.low >>> 0, object.heartbeat.high >>> 0).toNumber();
      if (object.rowUpdates != null) {
        if (typeof object.rowUpdates !== 'object')
          throw TypeError('.ScannerProtos.Response.rowUpdates: object expected');
        message.rowUpdates = $root.ScannerProtos.RowUpdates.fromObject(object.rowUpdates);
      }
      if (object.signal != null) {
        if (typeof object.signal !== 'object') throw TypeError('.ScannerProtos.Response.signal: object expected');
        message.signal = $root.LastProtos.Quote.fromObject(object.signal);
      }
      if (object.rowUpdatesV2 != null) {
        if (typeof object.rowUpdatesV2 !== 'object')
          throw TypeError('.ScannerProtos.Response.rowUpdatesV2: object expected');
        message.rowUpdatesV2 = $root.ScannerProtos.RowUpdatesV2.fromObject(object.rowUpdatesV2);
      }
      return message;
    };

    /**
     * Creates a plain object from a Response message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.Response
     * @static
     * @param {ScannerProtos.Response} message Response
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Response.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.id = 0;
        object.error = null;
      }
      if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
      if (message.error != null && message.hasOwnProperty('error'))
        object.error = $root.CommonProtos.Err.toObject(message.error, options);
      if (message.snapshot != null && message.hasOwnProperty('snapshot')) {
        object.snapshot = $root.ScannerProtos.Snapshot.toObject(message.snapshot, options);
        if (options.oneofs) object.type = 'snapshot';
      }
      if (message.heartbeat != null && message.hasOwnProperty('heartbeat')) {
        if (typeof message.heartbeat === 'number')
          object.heartbeat = options.longs === String ? String(message.heartbeat) : message.heartbeat;
        else
          object.heartbeat =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.heartbeat)
              : options.longs === Number
                ? new $util.LongBits(message.heartbeat.low >>> 0, message.heartbeat.high >>> 0).toNumber()
                : message.heartbeat;
        if (options.oneofs) object.type = 'heartbeat';
      }
      if (message.rowUpdates != null && message.hasOwnProperty('rowUpdates')) {
        object.rowUpdates = $root.ScannerProtos.RowUpdates.toObject(message.rowUpdates, options);
        if (options.oneofs) object.type = 'rowUpdates';
      }
      if (message.signal != null && message.hasOwnProperty('signal')) {
        object.signal = $root.LastProtos.Quote.toObject(message.signal, options);
        if (options.oneofs) object.type = 'signal';
      }
      if (message.rowUpdatesV2 != null && message.hasOwnProperty('rowUpdatesV2')) {
        object.rowUpdatesV2 = $root.ScannerProtos.RowUpdatesV2.toObject(message.rowUpdatesV2, options);
        if (options.oneofs) object.type = 'rowUpdatesV2';
      }
      return object;
    };

    /**
     * Converts this Response to JSON.
     * @function toJSON
     * @memberof ScannerProtos.Response
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Response.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Response;
  })();

  ScannerProtos.RowUpdates = (function () {
    /**
     * Properties of a RowUpdates.
     * @memberof ScannerProtos
     * @interface IRowUpdates
     * @property {Array.<ScannerProtos.IRowUpdate>|null} [updates] RowUpdates updates
     * @property {number|Long|null} [sequence] RowUpdates sequence
     * @property {number|null} [total] RowUpdates total
     */

    /**
     * Constructs a new RowUpdates.
     * @memberof ScannerProtos
     * @classdesc Represents a RowUpdates.
     * @implements IRowUpdates
     * @constructor
     * @param {ScannerProtos.IRowUpdates=} [properties] Properties to set
     */
    function RowUpdates(properties) {
      this.updates = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * RowUpdates updates.
     * @member {Array.<ScannerProtos.IRowUpdate>} updates
     * @memberof ScannerProtos.RowUpdates
     * @instance
     */
    RowUpdates.prototype.updates = $util.emptyArray;

    /**
     * RowUpdates sequence.
     * @member {number|Long} sequence
     * @memberof ScannerProtos.RowUpdates
     * @instance
     */
    RowUpdates.prototype.sequence = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * RowUpdates total.
     * @member {number} total
     * @memberof ScannerProtos.RowUpdates
     * @instance
     */
    RowUpdates.prototype.total = 0;

    /**
     * Creates a new RowUpdates instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.RowUpdates
     * @static
     * @param {ScannerProtos.IRowUpdates=} [properties] Properties to set
     * @returns {ScannerProtos.RowUpdates} RowUpdates instance
     */
    RowUpdates.create = function create(properties) {
      return new RowUpdates(properties);
    };

    /**
     * Encodes the specified RowUpdates message. Does not implicitly {@link ScannerProtos.RowUpdates.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.RowUpdates
     * @static
     * @param {ScannerProtos.IRowUpdates} message RowUpdates message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RowUpdates.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.updates != null && message.updates.length)
        for (let i = 0; i < message.updates.length; ++i)
          $root.ScannerProtos.RowUpdate.encode(
            message.updates[i],
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
          ).ldelim();
      if (message.sequence != null && Object.hasOwnProperty.call(message, 'sequence'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.sequence);
      if (message.total != null && Object.hasOwnProperty.call(message, 'total'))
        writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.total);
      return writer;
    };

    /**
     * Encodes the specified RowUpdates message, length delimited. Does not implicitly {@link ScannerProtos.RowUpdates.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.RowUpdates
     * @static
     * @param {ScannerProtos.IRowUpdates} message RowUpdates message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RowUpdates.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RowUpdates message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.RowUpdates
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.RowUpdates} RowUpdates
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RowUpdates.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.RowUpdates();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (!(message.updates && message.updates.length)) message.updates = [];
            message.updates.push($root.ScannerProtos.RowUpdate.decode(reader, reader.uint32()));
            break;
          }
          case 2: {
            message.sequence = reader.int64();
            break;
          }
          case 3: {
            message.total = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a RowUpdates message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.RowUpdates
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.RowUpdates} RowUpdates
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RowUpdates.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RowUpdates message.
     * @function verify
     * @memberof ScannerProtos.RowUpdates
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RowUpdates.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.updates != null && message.hasOwnProperty('updates')) {
        if (!Array.isArray(message.updates)) return 'updates: array expected';
        for (let i = 0; i < message.updates.length; ++i) {
          let error = $root.ScannerProtos.RowUpdate.verify(message.updates[i]);
          if (error) return 'updates.' + error;
        }
      }
      if (message.sequence != null && message.hasOwnProperty('sequence'))
        if (
          !$util.isInteger(message.sequence) &&
          !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high))
        )
          return 'sequence: integer|Long expected';
      if (message.total != null && message.hasOwnProperty('total'))
        if (!$util.isInteger(message.total)) return 'total: integer expected';
      return null;
    };

    /**
     * Creates a RowUpdates message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.RowUpdates
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.RowUpdates} RowUpdates
     */
    RowUpdates.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.RowUpdates) return object;
      let message = new $root.ScannerProtos.RowUpdates();
      if (object.updates) {
        if (!Array.isArray(object.updates)) throw TypeError('.ScannerProtos.RowUpdates.updates: array expected');
        message.updates = [];
        for (let i = 0; i < object.updates.length; ++i) {
          if (typeof object.updates[i] !== 'object')
            throw TypeError('.ScannerProtos.RowUpdates.updates: object expected');
          message.updates[i] = $root.ScannerProtos.RowUpdate.fromObject(object.updates[i]);
        }
      }
      if (object.sequence != null)
        if ($util.Long) (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
        else if (typeof object.sequence === 'string') message.sequence = parseInt(object.sequence, 10);
        else if (typeof object.sequence === 'number') message.sequence = object.sequence;
        else if (typeof object.sequence === 'object')
          message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
      if (object.total != null) message.total = object.total | 0;
      return message;
    };

    /**
     * Creates a plain object from a RowUpdates message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.RowUpdates
     * @static
     * @param {ScannerProtos.RowUpdates} message RowUpdates
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RowUpdates.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.updates = [];
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sequence =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.sequence = options.longs === String ? '0' : 0;
        object.total = 0;
      }
      if (message.updates && message.updates.length) {
        object.updates = [];
        for (let j = 0; j < message.updates.length; ++j)
          object.updates[j] = $root.ScannerProtos.RowUpdate.toObject(message.updates[j], options);
      }
      if (message.sequence != null && message.hasOwnProperty('sequence'))
        if (typeof message.sequence === 'number')
          object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
        else
          object.sequence =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sequence)
              : options.longs === Number
                ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber()
                : message.sequence;
      if (message.total != null && message.hasOwnProperty('total')) object.total = message.total;
      return object;
    };

    /**
     * Converts this RowUpdates to JSON.
     * @function toJSON
     * @memberof ScannerProtos.RowUpdates
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RowUpdates.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RowUpdates;
  })();

  ScannerProtos.RowUpdate = (function () {
    /**
     * Properties of a RowUpdate.
     * @memberof ScannerProtos
     * @interface IRowUpdate
     * @property {ScannerProtos.RowUpdate.Type|null} [type] RowUpdate type
     * @property {number|null} [index] RowUpdate index
     * @property {string|null} [rowId] RowUpdate rowId
     * @property {LastProtos.IQuote|null} [updated] RowUpdate updated
     * @property {LastProtos.IQuote|null} [removed] RowUpdate removed
     */

    /**
     * Constructs a new RowUpdate.
     * @memberof ScannerProtos
     * @classdesc Represents a RowUpdate.
     * @implements IRowUpdate
     * @constructor
     * @param {ScannerProtos.IRowUpdate=} [properties] Properties to set
     */
    function RowUpdate(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * RowUpdate type.
     * @member {ScannerProtos.RowUpdate.Type} type
     * @memberof ScannerProtos.RowUpdate
     * @instance
     */
    RowUpdate.prototype.type = 0;

    /**
     * RowUpdate index.
     * @member {number} index
     * @memberof ScannerProtos.RowUpdate
     * @instance
     */
    RowUpdate.prototype.index = 0;

    /**
     * RowUpdate rowId.
     * @member {string} rowId
     * @memberof ScannerProtos.RowUpdate
     * @instance
     */
    RowUpdate.prototype.rowId = '';

    /**
     * RowUpdate updated.
     * @member {LastProtos.IQuote|null|undefined} updated
     * @memberof ScannerProtos.RowUpdate
     * @instance
     */
    RowUpdate.prototype.updated = null;

    /**
     * RowUpdate removed.
     * @member {LastProtos.IQuote|null|undefined} removed
     * @memberof ScannerProtos.RowUpdate
     * @instance
     */
    RowUpdate.prototype.removed = null;

    /**
     * Creates a new RowUpdate instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.RowUpdate
     * @static
     * @param {ScannerProtos.IRowUpdate=} [properties] Properties to set
     * @returns {ScannerProtos.RowUpdate} RowUpdate instance
     */
    RowUpdate.create = function create(properties) {
      return new RowUpdate(properties);
    };

    /**
     * Encodes the specified RowUpdate message. Does not implicitly {@link ScannerProtos.RowUpdate.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.RowUpdate
     * @static
     * @param {ScannerProtos.IRowUpdate} message RowUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RowUpdate.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.type != null && Object.hasOwnProperty.call(message, 'type'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.type);
      if (message.index != null && Object.hasOwnProperty.call(message, 'index'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.index);
      if (message.rowId != null && Object.hasOwnProperty.call(message, 'rowId'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.rowId);
      if (message.updated != null && Object.hasOwnProperty.call(message, 'updated'))
        $root.LastProtos.Quote.encode(message.updated, writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
      if (message.removed != null && Object.hasOwnProperty.call(message, 'removed'))
        $root.LastProtos.Quote.encode(message.removed, writer.uint32(/* id 5, wireType 2 =*/ 42).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified RowUpdate message, length delimited. Does not implicitly {@link ScannerProtos.RowUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.RowUpdate
     * @static
     * @param {ScannerProtos.IRowUpdate} message RowUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RowUpdate.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RowUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.RowUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.RowUpdate} RowUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RowUpdate.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.RowUpdate();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.type = reader.int32();
            break;
          }
          case 2: {
            message.index = reader.int32();
            break;
          }
          case 3: {
            message.rowId = reader.string();
            break;
          }
          case 4: {
            message.updated = $root.LastProtos.Quote.decode(reader, reader.uint32());
            break;
          }
          case 5: {
            message.removed = $root.LastProtos.Quote.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a RowUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.RowUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.RowUpdate} RowUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RowUpdate.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RowUpdate message.
     * @function verify
     * @memberof ScannerProtos.RowUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RowUpdate.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.type != null && message.hasOwnProperty('type'))
        switch (message.type) {
          default:
            return 'type: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.index != null && message.hasOwnProperty('index'))
        if (!$util.isInteger(message.index)) return 'index: integer expected';
      if (message.rowId != null && message.hasOwnProperty('rowId'))
        if (!$util.isString(message.rowId)) return 'rowId: string expected';
      if (message.updated != null && message.hasOwnProperty('updated')) {
        let error = $root.LastProtos.Quote.verify(message.updated);
        if (error) return 'updated.' + error;
      }
      if (message.removed != null && message.hasOwnProperty('removed')) {
        let error = $root.LastProtos.Quote.verify(message.removed);
        if (error) return 'removed.' + error;
      }
      return null;
    };

    /**
     * Creates a RowUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.RowUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.RowUpdate} RowUpdate
     */
    RowUpdate.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.RowUpdate) return object;
      let message = new $root.ScannerProtos.RowUpdate();
      switch (object.type) {
        default:
          if (typeof object.type === 'number') {
            message.type = object.type;
            break;
          }
          break;
        case 'ADD':
        case 0:
          message.type = 0;
          break;
        case 'UPDATE':
        case 1:
          message.type = 1;
          break;
        case 'REMOVE':
        case 2:
          message.type = 2;
          break;
        case 'FLUSH':
        case 3:
          message.type = 3;
          break;
      }
      if (object.index != null) message.index = object.index | 0;
      if (object.rowId != null) message.rowId = String(object.rowId);
      if (object.updated != null) {
        if (typeof object.updated !== 'object') throw TypeError('.ScannerProtos.RowUpdate.updated: object expected');
        message.updated = $root.LastProtos.Quote.fromObject(object.updated);
      }
      if (object.removed != null) {
        if (typeof object.removed !== 'object') throw TypeError('.ScannerProtos.RowUpdate.removed: object expected');
        message.removed = $root.LastProtos.Quote.fromObject(object.removed);
      }
      return message;
    };

    /**
     * Creates a plain object from a RowUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.RowUpdate
     * @static
     * @param {ScannerProtos.RowUpdate} message RowUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RowUpdate.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.type = options.enums === String ? 'ADD' : 0;
        object.index = 0;
        object.rowId = '';
        object.updated = null;
        object.removed = null;
      }
      if (message.type != null && message.hasOwnProperty('type'))
        object.type =
          options.enums === String
            ? $root.ScannerProtos.RowUpdate.Type[message.type] === undefined
              ? message.type
              : $root.ScannerProtos.RowUpdate.Type[message.type]
            : message.type;
      if (message.index != null && message.hasOwnProperty('index')) object.index = message.index;
      if (message.rowId != null && message.hasOwnProperty('rowId')) object.rowId = message.rowId;
      if (message.updated != null && message.hasOwnProperty('updated'))
        object.updated = $root.LastProtos.Quote.toObject(message.updated, options);
      if (message.removed != null && message.hasOwnProperty('removed'))
        object.removed = $root.LastProtos.Quote.toObject(message.removed, options);
      return object;
    };

    /**
     * Converts this RowUpdate to JSON.
     * @function toJSON
     * @memberof ScannerProtos.RowUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RowUpdate.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Type enum.
     * @name ScannerProtos.RowUpdate.Type
     * @enum {number}
     * @property {number} ADD=0 ADD value
     * @property {number} UPDATE=1 UPDATE value
     * @property {number} REMOVE=2 REMOVE value
     * @property {number} FLUSH=3 FLUSH value
     */
    RowUpdate.Type = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'ADD')] = 0;
      values[(valuesById[1] = 'UPDATE')] = 1;
      values[(valuesById[2] = 'REMOVE')] = 2;
      values[(valuesById[3] = 'FLUSH')] = 3;
      return values;
    })();

    return RowUpdate;
  })();

  ScannerProtos.RowUpdatesV2 = (function () {
    /**
     * Properties of a RowUpdatesV2.
     * @memberof ScannerProtos
     * @interface IRowUpdatesV2
     * @property {number|Long|null} [sequence] RowUpdatesV2 sequence
     * @property {number|null} [total] RowUpdatesV2 total
     * @property {Array.<ScannerProtos.IUpdateRowUpdate>|null} [updates] RowUpdatesV2 updates
     * @property {Array.<ScannerProtos.IAddRowUpdate>|null} [adds] RowUpdatesV2 adds
     * @property {Array.<ScannerProtos.IRemoveRowUpdate>|null} [removes] RowUpdatesV2 removes
     * @property {Array.<ScannerProtos.IMoveRowUpdate>|null} [moves] RowUpdatesV2 moves
     */

    /**
     * Constructs a new RowUpdatesV2.
     * @memberof ScannerProtos
     * @classdesc Represents a RowUpdatesV2.
     * @implements IRowUpdatesV2
     * @constructor
     * @param {ScannerProtos.IRowUpdatesV2=} [properties] Properties to set
     */
    function RowUpdatesV2(properties) {
      this.updates = [];
      this.adds = [];
      this.removes = [];
      this.moves = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * RowUpdatesV2 sequence.
     * @member {number|Long} sequence
     * @memberof ScannerProtos.RowUpdatesV2
     * @instance
     */
    RowUpdatesV2.prototype.sequence = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * RowUpdatesV2 total.
     * @member {number} total
     * @memberof ScannerProtos.RowUpdatesV2
     * @instance
     */
    RowUpdatesV2.prototype.total = 0;

    /**
     * RowUpdatesV2 updates.
     * @member {Array.<ScannerProtos.IUpdateRowUpdate>} updates
     * @memberof ScannerProtos.RowUpdatesV2
     * @instance
     */
    RowUpdatesV2.prototype.updates = $util.emptyArray;

    /**
     * RowUpdatesV2 adds.
     * @member {Array.<ScannerProtos.IAddRowUpdate>} adds
     * @memberof ScannerProtos.RowUpdatesV2
     * @instance
     */
    RowUpdatesV2.prototype.adds = $util.emptyArray;

    /**
     * RowUpdatesV2 removes.
     * @member {Array.<ScannerProtos.IRemoveRowUpdate>} removes
     * @memberof ScannerProtos.RowUpdatesV2
     * @instance
     */
    RowUpdatesV2.prototype.removes = $util.emptyArray;

    /**
     * RowUpdatesV2 moves.
     * @member {Array.<ScannerProtos.IMoveRowUpdate>} moves
     * @memberof ScannerProtos.RowUpdatesV2
     * @instance
     */
    RowUpdatesV2.prototype.moves = $util.emptyArray;

    /**
     * Creates a new RowUpdatesV2 instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.RowUpdatesV2
     * @static
     * @param {ScannerProtos.IRowUpdatesV2=} [properties] Properties to set
     * @returns {ScannerProtos.RowUpdatesV2} RowUpdatesV2 instance
     */
    RowUpdatesV2.create = function create(properties) {
      return new RowUpdatesV2(properties);
    };

    /**
     * Encodes the specified RowUpdatesV2 message. Does not implicitly {@link ScannerProtos.RowUpdatesV2.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.RowUpdatesV2
     * @static
     * @param {ScannerProtos.IRowUpdatesV2} message RowUpdatesV2 message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RowUpdatesV2.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.sequence != null && Object.hasOwnProperty.call(message, 'sequence'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int64(message.sequence);
      if (message.total != null && Object.hasOwnProperty.call(message, 'total'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.total);
      if (message.updates != null && message.updates.length)
        for (let i = 0; i < message.updates.length; ++i)
          $root.ScannerProtos.UpdateRowUpdate.encode(
            message.updates[i],
            writer.uint32(/* id 3, wireType 2 =*/ 26).fork(),
          ).ldelim();
      if (message.adds != null && message.adds.length)
        for (let i = 0; i < message.adds.length; ++i)
          $root.ScannerProtos.AddRowUpdate.encode(
            message.adds[i],
            writer.uint32(/* id 4, wireType 2 =*/ 34).fork(),
          ).ldelim();
      if (message.removes != null && message.removes.length)
        for (let i = 0; i < message.removes.length; ++i)
          $root.ScannerProtos.RemoveRowUpdate.encode(
            message.removes[i],
            writer.uint32(/* id 5, wireType 2 =*/ 42).fork(),
          ).ldelim();
      if (message.moves != null && message.moves.length)
        for (let i = 0; i < message.moves.length; ++i)
          $root.ScannerProtos.MoveRowUpdate.encode(
            message.moves[i],
            writer.uint32(/* id 6, wireType 2 =*/ 50).fork(),
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified RowUpdatesV2 message, length delimited. Does not implicitly {@link ScannerProtos.RowUpdatesV2.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.RowUpdatesV2
     * @static
     * @param {ScannerProtos.IRowUpdatesV2} message RowUpdatesV2 message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RowUpdatesV2.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RowUpdatesV2 message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.RowUpdatesV2
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.RowUpdatesV2} RowUpdatesV2
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RowUpdatesV2.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.RowUpdatesV2();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.sequence = reader.int64();
            break;
          }
          case 2: {
            message.total = reader.int32();
            break;
          }
          case 3: {
            if (!(message.updates && message.updates.length)) message.updates = [];
            message.updates.push($root.ScannerProtos.UpdateRowUpdate.decode(reader, reader.uint32()));
            break;
          }
          case 4: {
            if (!(message.adds && message.adds.length)) message.adds = [];
            message.adds.push($root.ScannerProtos.AddRowUpdate.decode(reader, reader.uint32()));
            break;
          }
          case 5: {
            if (!(message.removes && message.removes.length)) message.removes = [];
            message.removes.push($root.ScannerProtos.RemoveRowUpdate.decode(reader, reader.uint32()));
            break;
          }
          case 6: {
            if (!(message.moves && message.moves.length)) message.moves = [];
            message.moves.push($root.ScannerProtos.MoveRowUpdate.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a RowUpdatesV2 message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.RowUpdatesV2
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.RowUpdatesV2} RowUpdatesV2
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RowUpdatesV2.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RowUpdatesV2 message.
     * @function verify
     * @memberof ScannerProtos.RowUpdatesV2
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RowUpdatesV2.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.sequence != null && message.hasOwnProperty('sequence'))
        if (
          !$util.isInteger(message.sequence) &&
          !(message.sequence && $util.isInteger(message.sequence.low) && $util.isInteger(message.sequence.high))
        )
          return 'sequence: integer|Long expected';
      if (message.total != null && message.hasOwnProperty('total'))
        if (!$util.isInteger(message.total)) return 'total: integer expected';
      if (message.updates != null && message.hasOwnProperty('updates')) {
        if (!Array.isArray(message.updates)) return 'updates: array expected';
        for (let i = 0; i < message.updates.length; ++i) {
          let error = $root.ScannerProtos.UpdateRowUpdate.verify(message.updates[i]);
          if (error) return 'updates.' + error;
        }
      }
      if (message.adds != null && message.hasOwnProperty('adds')) {
        if (!Array.isArray(message.adds)) return 'adds: array expected';
        for (let i = 0; i < message.adds.length; ++i) {
          let error = $root.ScannerProtos.AddRowUpdate.verify(message.adds[i]);
          if (error) return 'adds.' + error;
        }
      }
      if (message.removes != null && message.hasOwnProperty('removes')) {
        if (!Array.isArray(message.removes)) return 'removes: array expected';
        for (let i = 0; i < message.removes.length; ++i) {
          let error = $root.ScannerProtos.RemoveRowUpdate.verify(message.removes[i]);
          if (error) return 'removes.' + error;
        }
      }
      if (message.moves != null && message.hasOwnProperty('moves')) {
        if (!Array.isArray(message.moves)) return 'moves: array expected';
        for (let i = 0; i < message.moves.length; ++i) {
          let error = $root.ScannerProtos.MoveRowUpdate.verify(message.moves[i]);
          if (error) return 'moves.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a RowUpdatesV2 message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.RowUpdatesV2
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.RowUpdatesV2} RowUpdatesV2
     */
    RowUpdatesV2.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.RowUpdatesV2) return object;
      let message = new $root.ScannerProtos.RowUpdatesV2();
      if (object.sequence != null)
        if ($util.Long) (message.sequence = $util.Long.fromValue(object.sequence)).unsigned = false;
        else if (typeof object.sequence === 'string') message.sequence = parseInt(object.sequence, 10);
        else if (typeof object.sequence === 'number') message.sequence = object.sequence;
        else if (typeof object.sequence === 'object')
          message.sequence = new $util.LongBits(object.sequence.low >>> 0, object.sequence.high >>> 0).toNumber();
      if (object.total != null) message.total = object.total | 0;
      if (object.updates) {
        if (!Array.isArray(object.updates)) throw TypeError('.ScannerProtos.RowUpdatesV2.updates: array expected');
        message.updates = [];
        for (let i = 0; i < object.updates.length; ++i) {
          if (typeof object.updates[i] !== 'object')
            throw TypeError('.ScannerProtos.RowUpdatesV2.updates: object expected');
          message.updates[i] = $root.ScannerProtos.UpdateRowUpdate.fromObject(object.updates[i]);
        }
      }
      if (object.adds) {
        if (!Array.isArray(object.adds)) throw TypeError('.ScannerProtos.RowUpdatesV2.adds: array expected');
        message.adds = [];
        for (let i = 0; i < object.adds.length; ++i) {
          if (typeof object.adds[i] !== 'object') throw TypeError('.ScannerProtos.RowUpdatesV2.adds: object expected');
          message.adds[i] = $root.ScannerProtos.AddRowUpdate.fromObject(object.adds[i]);
        }
      }
      if (object.removes) {
        if (!Array.isArray(object.removes)) throw TypeError('.ScannerProtos.RowUpdatesV2.removes: array expected');
        message.removes = [];
        for (let i = 0; i < object.removes.length; ++i) {
          if (typeof object.removes[i] !== 'object')
            throw TypeError('.ScannerProtos.RowUpdatesV2.removes: object expected');
          message.removes[i] = $root.ScannerProtos.RemoveRowUpdate.fromObject(object.removes[i]);
        }
      }
      if (object.moves) {
        if (!Array.isArray(object.moves)) throw TypeError('.ScannerProtos.RowUpdatesV2.moves: array expected');
        message.moves = [];
        for (let i = 0; i < object.moves.length; ++i) {
          if (typeof object.moves[i] !== 'object')
            throw TypeError('.ScannerProtos.RowUpdatesV2.moves: object expected');
          message.moves[i] = $root.ScannerProtos.MoveRowUpdate.fromObject(object.moves[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a RowUpdatesV2 message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.RowUpdatesV2
     * @static
     * @param {ScannerProtos.RowUpdatesV2} message RowUpdatesV2
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RowUpdatesV2.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.updates = [];
        object.adds = [];
        object.removes = [];
        object.moves = [];
      }
      if (options.defaults) {
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sequence =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.sequence = options.longs === String ? '0' : 0;
        object.total = 0;
      }
      if (message.sequence != null && message.hasOwnProperty('sequence'))
        if (typeof message.sequence === 'number')
          object.sequence = options.longs === String ? String(message.sequence) : message.sequence;
        else
          object.sequence =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sequence)
              : options.longs === Number
                ? new $util.LongBits(message.sequence.low >>> 0, message.sequence.high >>> 0).toNumber()
                : message.sequence;
      if (message.total != null && message.hasOwnProperty('total')) object.total = message.total;
      if (message.updates && message.updates.length) {
        object.updates = [];
        for (let j = 0; j < message.updates.length; ++j)
          object.updates[j] = $root.ScannerProtos.UpdateRowUpdate.toObject(message.updates[j], options);
      }
      if (message.adds && message.adds.length) {
        object.adds = [];
        for (let j = 0; j < message.adds.length; ++j)
          object.adds[j] = $root.ScannerProtos.AddRowUpdate.toObject(message.adds[j], options);
      }
      if (message.removes && message.removes.length) {
        object.removes = [];
        for (let j = 0; j < message.removes.length; ++j)
          object.removes[j] = $root.ScannerProtos.RemoveRowUpdate.toObject(message.removes[j], options);
      }
      if (message.moves && message.moves.length) {
        object.moves = [];
        for (let j = 0; j < message.moves.length; ++j)
          object.moves[j] = $root.ScannerProtos.MoveRowUpdate.toObject(message.moves[j], options);
      }
      return object;
    };

    /**
     * Converts this RowUpdatesV2 to JSON.
     * @function toJSON
     * @memberof ScannerProtos.RowUpdatesV2
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RowUpdatesV2.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RowUpdatesV2;
  })();

  ScannerProtos.UpdateRowUpdate = (function () {
    /**
     * Properties of an UpdateRowUpdate.
     * @memberof ScannerProtos
     * @interface IUpdateRowUpdate
     * @property {number|null} [index] UpdateRowUpdate index
     * @property {string|null} [rowId] UpdateRowUpdate rowId
     * @property {LastProtos.IQuote|null} [updated] UpdateRowUpdate updated
     * @property {LastProtos.IQuote|null} [removed] UpdateRowUpdate removed
     */

    /**
     * Constructs a new UpdateRowUpdate.
     * @memberof ScannerProtos
     * @classdesc Represents an UpdateRowUpdate.
     * @implements IUpdateRowUpdate
     * @constructor
     * @param {ScannerProtos.IUpdateRowUpdate=} [properties] Properties to set
     */
    function UpdateRowUpdate(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateRowUpdate index.
     * @member {number} index
     * @memberof ScannerProtos.UpdateRowUpdate
     * @instance
     */
    UpdateRowUpdate.prototype.index = 0;

    /**
     * UpdateRowUpdate rowId.
     * @member {string} rowId
     * @memberof ScannerProtos.UpdateRowUpdate
     * @instance
     */
    UpdateRowUpdate.prototype.rowId = '';

    /**
     * UpdateRowUpdate updated.
     * @member {LastProtos.IQuote|null|undefined} updated
     * @memberof ScannerProtos.UpdateRowUpdate
     * @instance
     */
    UpdateRowUpdate.prototype.updated = null;

    /**
     * UpdateRowUpdate removed.
     * @member {LastProtos.IQuote|null|undefined} removed
     * @memberof ScannerProtos.UpdateRowUpdate
     * @instance
     */
    UpdateRowUpdate.prototype.removed = null;

    /**
     * Creates a new UpdateRowUpdate instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.UpdateRowUpdate
     * @static
     * @param {ScannerProtos.IUpdateRowUpdate=} [properties] Properties to set
     * @returns {ScannerProtos.UpdateRowUpdate} UpdateRowUpdate instance
     */
    UpdateRowUpdate.create = function create(properties) {
      return new UpdateRowUpdate(properties);
    };

    /**
     * Encodes the specified UpdateRowUpdate message. Does not implicitly {@link ScannerProtos.UpdateRowUpdate.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.UpdateRowUpdate
     * @static
     * @param {ScannerProtos.IUpdateRowUpdate} message UpdateRowUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateRowUpdate.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.index != null && Object.hasOwnProperty.call(message, 'index'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.index);
      if (message.rowId != null && Object.hasOwnProperty.call(message, 'rowId'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.rowId);
      if (message.updated != null && Object.hasOwnProperty.call(message, 'updated'))
        $root.LastProtos.Quote.encode(message.updated, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
      if (message.removed != null && Object.hasOwnProperty.call(message, 'removed'))
        $root.LastProtos.Quote.encode(message.removed, writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified UpdateRowUpdate message, length delimited. Does not implicitly {@link ScannerProtos.UpdateRowUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.UpdateRowUpdate
     * @static
     * @param {ScannerProtos.IUpdateRowUpdate} message UpdateRowUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateRowUpdate.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateRowUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.UpdateRowUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.UpdateRowUpdate} UpdateRowUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateRowUpdate.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.UpdateRowUpdate();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.index = reader.int32();
            break;
          }
          case 2: {
            message.rowId = reader.string();
            break;
          }
          case 3: {
            message.updated = $root.LastProtos.Quote.decode(reader, reader.uint32());
            break;
          }
          case 4: {
            message.removed = $root.LastProtos.Quote.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an UpdateRowUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.UpdateRowUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.UpdateRowUpdate} UpdateRowUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateRowUpdate.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateRowUpdate message.
     * @function verify
     * @memberof ScannerProtos.UpdateRowUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateRowUpdate.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.index != null && message.hasOwnProperty('index'))
        if (!$util.isInteger(message.index)) return 'index: integer expected';
      if (message.rowId != null && message.hasOwnProperty('rowId'))
        if (!$util.isString(message.rowId)) return 'rowId: string expected';
      if (message.updated != null && message.hasOwnProperty('updated')) {
        let error = $root.LastProtos.Quote.verify(message.updated);
        if (error) return 'updated.' + error;
      }
      if (message.removed != null && message.hasOwnProperty('removed')) {
        let error = $root.LastProtos.Quote.verify(message.removed);
        if (error) return 'removed.' + error;
      }
      return null;
    };

    /**
     * Creates an UpdateRowUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.UpdateRowUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.UpdateRowUpdate} UpdateRowUpdate
     */
    UpdateRowUpdate.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.UpdateRowUpdate) return object;
      let message = new $root.ScannerProtos.UpdateRowUpdate();
      if (object.index != null) message.index = object.index | 0;
      if (object.rowId != null) message.rowId = String(object.rowId);
      if (object.updated != null) {
        if (typeof object.updated !== 'object')
          throw TypeError('.ScannerProtos.UpdateRowUpdate.updated: object expected');
        message.updated = $root.LastProtos.Quote.fromObject(object.updated);
      }
      if (object.removed != null) {
        if (typeof object.removed !== 'object')
          throw TypeError('.ScannerProtos.UpdateRowUpdate.removed: object expected');
        message.removed = $root.LastProtos.Quote.fromObject(object.removed);
      }
      return message;
    };

    /**
     * Creates a plain object from an UpdateRowUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.UpdateRowUpdate
     * @static
     * @param {ScannerProtos.UpdateRowUpdate} message UpdateRowUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateRowUpdate.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.index = 0;
        object.rowId = '';
        object.updated = null;
        object.removed = null;
      }
      if (message.index != null && message.hasOwnProperty('index')) object.index = message.index;
      if (message.rowId != null && message.hasOwnProperty('rowId')) object.rowId = message.rowId;
      if (message.updated != null && message.hasOwnProperty('updated'))
        object.updated = $root.LastProtos.Quote.toObject(message.updated, options);
      if (message.removed != null && message.hasOwnProperty('removed'))
        object.removed = $root.LastProtos.Quote.toObject(message.removed, options);
      return object;
    };

    /**
     * Converts this UpdateRowUpdate to JSON.
     * @function toJSON
     * @memberof ScannerProtos.UpdateRowUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateRowUpdate.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UpdateRowUpdate;
  })();

  ScannerProtos.AddRowUpdate = (function () {
    /**
     * Properties of an AddRowUpdate.
     * @memberof ScannerProtos
     * @interface IAddRowUpdate
     * @property {number|null} [index] AddRowUpdate index
     * @property {string|null} [rowId] AddRowUpdate rowId
     * @property {LastProtos.IQuote|null} [updated] AddRowUpdate updated
     */

    /**
     * Constructs a new AddRowUpdate.
     * @memberof ScannerProtos
     * @classdesc Represents an AddRowUpdate.
     * @implements IAddRowUpdate
     * @constructor
     * @param {ScannerProtos.IAddRowUpdate=} [properties] Properties to set
     */
    function AddRowUpdate(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * AddRowUpdate index.
     * @member {number} index
     * @memberof ScannerProtos.AddRowUpdate
     * @instance
     */
    AddRowUpdate.prototype.index = 0;

    /**
     * AddRowUpdate rowId.
     * @member {string} rowId
     * @memberof ScannerProtos.AddRowUpdate
     * @instance
     */
    AddRowUpdate.prototype.rowId = '';

    /**
     * AddRowUpdate updated.
     * @member {LastProtos.IQuote|null|undefined} updated
     * @memberof ScannerProtos.AddRowUpdate
     * @instance
     */
    AddRowUpdate.prototype.updated = null;

    /**
     * Creates a new AddRowUpdate instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.AddRowUpdate
     * @static
     * @param {ScannerProtos.IAddRowUpdate=} [properties] Properties to set
     * @returns {ScannerProtos.AddRowUpdate} AddRowUpdate instance
     */
    AddRowUpdate.create = function create(properties) {
      return new AddRowUpdate(properties);
    };

    /**
     * Encodes the specified AddRowUpdate message. Does not implicitly {@link ScannerProtos.AddRowUpdate.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.AddRowUpdate
     * @static
     * @param {ScannerProtos.IAddRowUpdate} message AddRowUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AddRowUpdate.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.index != null && Object.hasOwnProperty.call(message, 'index'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.index);
      if (message.rowId != null && Object.hasOwnProperty.call(message, 'rowId'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.rowId);
      if (message.updated != null && Object.hasOwnProperty.call(message, 'updated'))
        $root.LastProtos.Quote.encode(message.updated, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified AddRowUpdate message, length delimited. Does not implicitly {@link ScannerProtos.AddRowUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.AddRowUpdate
     * @static
     * @param {ScannerProtos.IAddRowUpdate} message AddRowUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AddRowUpdate.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AddRowUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.AddRowUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.AddRowUpdate} AddRowUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AddRowUpdate.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.AddRowUpdate();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.index = reader.int32();
            break;
          }
          case 2: {
            message.rowId = reader.string();
            break;
          }
          case 3: {
            message.updated = $root.LastProtos.Quote.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an AddRowUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.AddRowUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.AddRowUpdate} AddRowUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AddRowUpdate.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AddRowUpdate message.
     * @function verify
     * @memberof ScannerProtos.AddRowUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AddRowUpdate.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.index != null && message.hasOwnProperty('index'))
        if (!$util.isInteger(message.index)) return 'index: integer expected';
      if (message.rowId != null && message.hasOwnProperty('rowId'))
        if (!$util.isString(message.rowId)) return 'rowId: string expected';
      if (message.updated != null && message.hasOwnProperty('updated')) {
        let error = $root.LastProtos.Quote.verify(message.updated);
        if (error) return 'updated.' + error;
      }
      return null;
    };

    /**
     * Creates an AddRowUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.AddRowUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.AddRowUpdate} AddRowUpdate
     */
    AddRowUpdate.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.AddRowUpdate) return object;
      let message = new $root.ScannerProtos.AddRowUpdate();
      if (object.index != null) message.index = object.index | 0;
      if (object.rowId != null) message.rowId = String(object.rowId);
      if (object.updated != null) {
        if (typeof object.updated !== 'object') throw TypeError('.ScannerProtos.AddRowUpdate.updated: object expected');
        message.updated = $root.LastProtos.Quote.fromObject(object.updated);
      }
      return message;
    };

    /**
     * Creates a plain object from an AddRowUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.AddRowUpdate
     * @static
     * @param {ScannerProtos.AddRowUpdate} message AddRowUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AddRowUpdate.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.index = 0;
        object.rowId = '';
        object.updated = null;
      }
      if (message.index != null && message.hasOwnProperty('index')) object.index = message.index;
      if (message.rowId != null && message.hasOwnProperty('rowId')) object.rowId = message.rowId;
      if (message.updated != null && message.hasOwnProperty('updated'))
        object.updated = $root.LastProtos.Quote.toObject(message.updated, options);
      return object;
    };

    /**
     * Converts this AddRowUpdate to JSON.
     * @function toJSON
     * @memberof ScannerProtos.AddRowUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AddRowUpdate.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AddRowUpdate;
  })();

  ScannerProtos.RemoveRowUpdate = (function () {
    /**
     * Properties of a RemoveRowUpdate.
     * @memberof ScannerProtos
     * @interface IRemoveRowUpdate
     * @property {number|null} [previousIndex] RemoveRowUpdate previousIndex
     * @property {string|null} [rowId] RemoveRowUpdate rowId
     */

    /**
     * Constructs a new RemoveRowUpdate.
     * @memberof ScannerProtos
     * @classdesc Represents a RemoveRowUpdate.
     * @implements IRemoveRowUpdate
     * @constructor
     * @param {ScannerProtos.IRemoveRowUpdate=} [properties] Properties to set
     */
    function RemoveRowUpdate(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * RemoveRowUpdate previousIndex.
     * @member {number} previousIndex
     * @memberof ScannerProtos.RemoveRowUpdate
     * @instance
     */
    RemoveRowUpdate.prototype.previousIndex = 0;

    /**
     * RemoveRowUpdate rowId.
     * @member {string} rowId
     * @memberof ScannerProtos.RemoveRowUpdate
     * @instance
     */
    RemoveRowUpdate.prototype.rowId = '';

    /**
     * Creates a new RemoveRowUpdate instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.RemoveRowUpdate
     * @static
     * @param {ScannerProtos.IRemoveRowUpdate=} [properties] Properties to set
     * @returns {ScannerProtos.RemoveRowUpdate} RemoveRowUpdate instance
     */
    RemoveRowUpdate.create = function create(properties) {
      return new RemoveRowUpdate(properties);
    };

    /**
     * Encodes the specified RemoveRowUpdate message. Does not implicitly {@link ScannerProtos.RemoveRowUpdate.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.RemoveRowUpdate
     * @static
     * @param {ScannerProtos.IRemoveRowUpdate} message RemoveRowUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RemoveRowUpdate.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.previousIndex != null && Object.hasOwnProperty.call(message, 'previousIndex'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.previousIndex);
      if (message.rowId != null && Object.hasOwnProperty.call(message, 'rowId'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.rowId);
      return writer;
    };

    /**
     * Encodes the specified RemoveRowUpdate message, length delimited. Does not implicitly {@link ScannerProtos.RemoveRowUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.RemoveRowUpdate
     * @static
     * @param {ScannerProtos.IRemoveRowUpdate} message RemoveRowUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RemoveRowUpdate.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RemoveRowUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.RemoveRowUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.RemoveRowUpdate} RemoveRowUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RemoveRowUpdate.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.RemoveRowUpdate();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.previousIndex = reader.int32();
            break;
          }
          case 2: {
            message.rowId = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a RemoveRowUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.RemoveRowUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.RemoveRowUpdate} RemoveRowUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RemoveRowUpdate.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RemoveRowUpdate message.
     * @function verify
     * @memberof ScannerProtos.RemoveRowUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RemoveRowUpdate.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.previousIndex != null && message.hasOwnProperty('previousIndex'))
        if (!$util.isInteger(message.previousIndex)) return 'previousIndex: integer expected';
      if (message.rowId != null && message.hasOwnProperty('rowId'))
        if (!$util.isString(message.rowId)) return 'rowId: string expected';
      return null;
    };

    /**
     * Creates a RemoveRowUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.RemoveRowUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.RemoveRowUpdate} RemoveRowUpdate
     */
    RemoveRowUpdate.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.RemoveRowUpdate) return object;
      let message = new $root.ScannerProtos.RemoveRowUpdate();
      if (object.previousIndex != null) message.previousIndex = object.previousIndex | 0;
      if (object.rowId != null) message.rowId = String(object.rowId);
      return message;
    };

    /**
     * Creates a plain object from a RemoveRowUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.RemoveRowUpdate
     * @static
     * @param {ScannerProtos.RemoveRowUpdate} message RemoveRowUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RemoveRowUpdate.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.previousIndex = 0;
        object.rowId = '';
      }
      if (message.previousIndex != null && message.hasOwnProperty('previousIndex'))
        object.previousIndex = message.previousIndex;
      if (message.rowId != null && message.hasOwnProperty('rowId')) object.rowId = message.rowId;
      return object;
    };

    /**
     * Converts this RemoveRowUpdate to JSON.
     * @function toJSON
     * @memberof ScannerProtos.RemoveRowUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RemoveRowUpdate.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RemoveRowUpdate;
  })();

  ScannerProtos.MoveRowUpdate = (function () {
    /**
     * Properties of a MoveRowUpdate.
     * @memberof ScannerProtos
     * @interface IMoveRowUpdate
     * @property {number|null} [index] MoveRowUpdate index
     * @property {string|null} [rowId] MoveRowUpdate rowId
     * @property {number|null} [previousIndex] MoveRowUpdate previousIndex
     * @property {LastProtos.IQuote|null} [updated] MoveRowUpdate updated
     * @property {LastProtos.IQuote|null} [removed] MoveRowUpdate removed
     */

    /**
     * Constructs a new MoveRowUpdate.
     * @memberof ScannerProtos
     * @classdesc Represents a MoveRowUpdate.
     * @implements IMoveRowUpdate
     * @constructor
     * @param {ScannerProtos.IMoveRowUpdate=} [properties] Properties to set
     */
    function MoveRowUpdate(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * MoveRowUpdate index.
     * @member {number} index
     * @memberof ScannerProtos.MoveRowUpdate
     * @instance
     */
    MoveRowUpdate.prototype.index = 0;

    /**
     * MoveRowUpdate rowId.
     * @member {string} rowId
     * @memberof ScannerProtos.MoveRowUpdate
     * @instance
     */
    MoveRowUpdate.prototype.rowId = '';

    /**
     * MoveRowUpdate previousIndex.
     * @member {number} previousIndex
     * @memberof ScannerProtos.MoveRowUpdate
     * @instance
     */
    MoveRowUpdate.prototype.previousIndex = 0;

    /**
     * MoveRowUpdate updated.
     * @member {LastProtos.IQuote|null|undefined} updated
     * @memberof ScannerProtos.MoveRowUpdate
     * @instance
     */
    MoveRowUpdate.prototype.updated = null;

    /**
     * MoveRowUpdate removed.
     * @member {LastProtos.IQuote|null|undefined} removed
     * @memberof ScannerProtos.MoveRowUpdate
     * @instance
     */
    MoveRowUpdate.prototype.removed = null;

    /**
     * Creates a new MoveRowUpdate instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.MoveRowUpdate
     * @static
     * @param {ScannerProtos.IMoveRowUpdate=} [properties] Properties to set
     * @returns {ScannerProtos.MoveRowUpdate} MoveRowUpdate instance
     */
    MoveRowUpdate.create = function create(properties) {
      return new MoveRowUpdate(properties);
    };

    /**
     * Encodes the specified MoveRowUpdate message. Does not implicitly {@link ScannerProtos.MoveRowUpdate.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.MoveRowUpdate
     * @static
     * @param {ScannerProtos.IMoveRowUpdate} message MoveRowUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoveRowUpdate.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.index != null && Object.hasOwnProperty.call(message, 'index'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.index);
      if (message.rowId != null && Object.hasOwnProperty.call(message, 'rowId'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.rowId);
      if (message.previousIndex != null && Object.hasOwnProperty.call(message, 'previousIndex'))
        writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.previousIndex);
      if (message.updated != null && Object.hasOwnProperty.call(message, 'updated'))
        $root.LastProtos.Quote.encode(message.updated, writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
      if (message.removed != null && Object.hasOwnProperty.call(message, 'removed'))
        $root.LastProtos.Quote.encode(message.removed, writer.uint32(/* id 5, wireType 2 =*/ 42).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified MoveRowUpdate message, length delimited. Does not implicitly {@link ScannerProtos.MoveRowUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.MoveRowUpdate
     * @static
     * @param {ScannerProtos.IMoveRowUpdate} message MoveRowUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoveRowUpdate.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MoveRowUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.MoveRowUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.MoveRowUpdate} MoveRowUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoveRowUpdate.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.MoveRowUpdate();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.index = reader.int32();
            break;
          }
          case 2: {
            message.rowId = reader.string();
            break;
          }
          case 3: {
            message.previousIndex = reader.int32();
            break;
          }
          case 4: {
            message.updated = $root.LastProtos.Quote.decode(reader, reader.uint32());
            break;
          }
          case 5: {
            message.removed = $root.LastProtos.Quote.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a MoveRowUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.MoveRowUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.MoveRowUpdate} MoveRowUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoveRowUpdate.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MoveRowUpdate message.
     * @function verify
     * @memberof ScannerProtos.MoveRowUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MoveRowUpdate.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.index != null && message.hasOwnProperty('index'))
        if (!$util.isInteger(message.index)) return 'index: integer expected';
      if (message.rowId != null && message.hasOwnProperty('rowId'))
        if (!$util.isString(message.rowId)) return 'rowId: string expected';
      if (message.previousIndex != null && message.hasOwnProperty('previousIndex'))
        if (!$util.isInteger(message.previousIndex)) return 'previousIndex: integer expected';
      if (message.updated != null && message.hasOwnProperty('updated')) {
        let error = $root.LastProtos.Quote.verify(message.updated);
        if (error) return 'updated.' + error;
      }
      if (message.removed != null && message.hasOwnProperty('removed')) {
        let error = $root.LastProtos.Quote.verify(message.removed);
        if (error) return 'removed.' + error;
      }
      return null;
    };

    /**
     * Creates a MoveRowUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.MoveRowUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.MoveRowUpdate} MoveRowUpdate
     */
    MoveRowUpdate.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.MoveRowUpdate) return object;
      let message = new $root.ScannerProtos.MoveRowUpdate();
      if (object.index != null) message.index = object.index | 0;
      if (object.rowId != null) message.rowId = String(object.rowId);
      if (object.previousIndex != null) message.previousIndex = object.previousIndex | 0;
      if (object.updated != null) {
        if (typeof object.updated !== 'object')
          throw TypeError('.ScannerProtos.MoveRowUpdate.updated: object expected');
        message.updated = $root.LastProtos.Quote.fromObject(object.updated);
      }
      if (object.removed != null) {
        if (typeof object.removed !== 'object')
          throw TypeError('.ScannerProtos.MoveRowUpdate.removed: object expected');
        message.removed = $root.LastProtos.Quote.fromObject(object.removed);
      }
      return message;
    };

    /**
     * Creates a plain object from a MoveRowUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.MoveRowUpdate
     * @static
     * @param {ScannerProtos.MoveRowUpdate} message MoveRowUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MoveRowUpdate.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.index = 0;
        object.rowId = '';
        object.previousIndex = 0;
        object.updated = null;
        object.removed = null;
      }
      if (message.index != null && message.hasOwnProperty('index')) object.index = message.index;
      if (message.rowId != null && message.hasOwnProperty('rowId')) object.rowId = message.rowId;
      if (message.previousIndex != null && message.hasOwnProperty('previousIndex'))
        object.previousIndex = message.previousIndex;
      if (message.updated != null && message.hasOwnProperty('updated'))
        object.updated = $root.LastProtos.Quote.toObject(message.updated, options);
      if (message.removed != null && message.hasOwnProperty('removed'))
        object.removed = $root.LastProtos.Quote.toObject(message.removed, options);
      return object;
    };

    /**
     * Converts this MoveRowUpdate to JSON.
     * @function toJSON
     * @memberof ScannerProtos.MoveRowUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MoveRowUpdate.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoveRowUpdate;
  })();

  ScannerProtos.Column = (function () {
    /**
     * Properties of a Column.
     * @memberof ScannerProtos
     * @interface IColumn
     * @property {string|null} [dataFieldName] Column dataFieldName
     */

    /**
     * Constructs a new Column.
     * @memberof ScannerProtos
     * @classdesc Represents a Column.
     * @implements IColumn
     * @constructor
     * @param {ScannerProtos.IColumn=} [properties] Properties to set
     */
    function Column(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Column dataFieldName.
     * @member {string} dataFieldName
     * @memberof ScannerProtos.Column
     * @instance
     */
    Column.prototype.dataFieldName = '';

    /**
     * Creates a new Column instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.Column
     * @static
     * @param {ScannerProtos.IColumn=} [properties] Properties to set
     * @returns {ScannerProtos.Column} Column instance
     */
    Column.create = function create(properties) {
      return new Column(properties);
    };

    /**
     * Encodes the specified Column message. Does not implicitly {@link ScannerProtos.Column.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.Column
     * @static
     * @param {ScannerProtos.IColumn} message Column message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Column.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.dataFieldName != null && Object.hasOwnProperty.call(message, 'dataFieldName'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.dataFieldName);
      return writer;
    };

    /**
     * Encodes the specified Column message, length delimited. Does not implicitly {@link ScannerProtos.Column.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.Column
     * @static
     * @param {ScannerProtos.IColumn} message Column message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Column.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Column message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.Column
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.Column} Column
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Column.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.Column();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.dataFieldName = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Column message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.Column
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.Column} Column
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Column.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Column message.
     * @function verify
     * @memberof ScannerProtos.Column
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Column.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.dataFieldName != null && message.hasOwnProperty('dataFieldName'))
        if (!$util.isString(message.dataFieldName)) return 'dataFieldName: string expected';
      return null;
    };

    /**
     * Creates a Column message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.Column
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.Column} Column
     */
    Column.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.Column) return object;
      let message = new $root.ScannerProtos.Column();
      if (object.dataFieldName != null) message.dataFieldName = String(object.dataFieldName);
      return message;
    };

    /**
     * Creates a plain object from a Column message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.Column
     * @static
     * @param {ScannerProtos.Column} message Column
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Column.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.dataFieldName = '';
      if (message.dataFieldName != null && message.hasOwnProperty('dataFieldName'))
        object.dataFieldName = message.dataFieldName;
      return object;
    };

    /**
     * Converts this Column to JSON.
     * @function toJSON
     * @memberof ScannerProtos.Column
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Column.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Column;
  })();

  ScannerProtos.WebSocketRequest = (function () {
    /**
     * Properties of a WebSocketRequest.
     * @memberof ScannerProtos
     * @interface IWebSocketRequest
     * @property {number|null} [id] WebSocketRequest id
     * @property {ScannerProtos.IScannerRequest|null} [scannerRequest] WebSocketRequest scannerRequest
     */

    /**
     * Constructs a new WebSocketRequest.
     * @memberof ScannerProtos
     * @classdesc Represents a WebSocketRequest.
     * @implements IWebSocketRequest
     * @constructor
     * @param {ScannerProtos.IWebSocketRequest=} [properties] Properties to set
     */
    function WebSocketRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * WebSocketRequest id.
     * @member {number} id
     * @memberof ScannerProtos.WebSocketRequest
     * @instance
     */
    WebSocketRequest.prototype.id = 0;

    /**
     * WebSocketRequest scannerRequest.
     * @member {ScannerProtos.IScannerRequest|null|undefined} scannerRequest
     * @memberof ScannerProtos.WebSocketRequest
     * @instance
     */
    WebSocketRequest.prototype.scannerRequest = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * WebSocketRequest type.
     * @member {"scannerRequest"|undefined} type
     * @memberof ScannerProtos.WebSocketRequest
     * @instance
     */
    Object.defineProperty(WebSocketRequest.prototype, 'type', {
      get: $util.oneOfGetter(($oneOfFields = ['scannerRequest'])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new WebSocketRequest instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.WebSocketRequest
     * @static
     * @param {ScannerProtos.IWebSocketRequest=} [properties] Properties to set
     * @returns {ScannerProtos.WebSocketRequest} WebSocketRequest instance
     */
    WebSocketRequest.create = function create(properties) {
      return new WebSocketRequest(properties);
    };

    /**
     * Encodes the specified WebSocketRequest message. Does not implicitly {@link ScannerProtos.WebSocketRequest.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.WebSocketRequest
     * @static
     * @param {ScannerProtos.IWebSocketRequest} message WebSocketRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WebSocketRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, 'id'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.id);
      if (message.scannerRequest != null && Object.hasOwnProperty.call(message, 'scannerRequest'))
        $root.ScannerProtos.ScannerRequest.encode(
          message.scannerRequest,
          writer.uint32(/* id 10, wireType 2 =*/ 82).fork(),
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified WebSocketRequest message, length delimited. Does not implicitly {@link ScannerProtos.WebSocketRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.WebSocketRequest
     * @static
     * @param {ScannerProtos.IWebSocketRequest} message WebSocketRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WebSocketRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WebSocketRequest message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.WebSocketRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.WebSocketRequest} WebSocketRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WebSocketRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.WebSocketRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.id = reader.int32();
            break;
          }
          case 10: {
            message.scannerRequest = $root.ScannerProtos.ScannerRequest.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a WebSocketRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.WebSocketRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.WebSocketRequest} WebSocketRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WebSocketRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WebSocketRequest message.
     * @function verify
     * @memberof ScannerProtos.WebSocketRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WebSocketRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      let properties = {};
      if (message.id != null && message.hasOwnProperty('id'))
        if (!$util.isInteger(message.id)) return 'id: integer expected';
      if (message.scannerRequest != null && message.hasOwnProperty('scannerRequest')) {
        properties.type = 1;
        {
          let error = $root.ScannerProtos.ScannerRequest.verify(message.scannerRequest);
          if (error) return 'scannerRequest.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a WebSocketRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.WebSocketRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.WebSocketRequest} WebSocketRequest
     */
    WebSocketRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.WebSocketRequest) return object;
      let message = new $root.ScannerProtos.WebSocketRequest();
      if (object.id != null) message.id = object.id | 0;
      if (object.scannerRequest != null) {
        if (typeof object.scannerRequest !== 'object')
          throw TypeError('.ScannerProtos.WebSocketRequest.scannerRequest: object expected');
        message.scannerRequest = $root.ScannerProtos.ScannerRequest.fromObject(object.scannerRequest);
      }
      return message;
    };

    /**
     * Creates a plain object from a WebSocketRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.WebSocketRequest
     * @static
     * @param {ScannerProtos.WebSocketRequest} message WebSocketRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WebSocketRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.id = 0;
      if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
      if (message.scannerRequest != null && message.hasOwnProperty('scannerRequest')) {
        object.scannerRequest = $root.ScannerProtos.ScannerRequest.toObject(message.scannerRequest, options);
        if (options.oneofs) object.type = 'scannerRequest';
      }
      return object;
    };

    /**
     * Converts this WebSocketRequest to JSON.
     * @function toJSON
     * @memberof ScannerProtos.WebSocketRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WebSocketRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebSocketRequest;
  })();

  ScannerProtos.ScannerConfig = (function () {
    /**
     * Properties of a ScannerConfig.
     * @memberof ScannerProtos
     * @interface IScannerConfig
     * @property {string|null} [name] ScannerConfig name
     * @property {ScannerProtos.ScannerConfig.UpdateType|null} [updateType] ScannerConfig updateType
     * @property {ScannerProtos.IQuery|null} [query] ScannerConfig query
     * @property {Array.<ScannerProtos.SignalType>|null} [signalTypes] * List of signal types, if this is set
     */

    /**
     * Constructs a new ScannerConfig.
     * @memberof ScannerProtos
     * @classdesc Represents a ScannerConfig.
     * @implements IScannerConfig
     * @constructor
     * @param {ScannerProtos.IScannerConfig=} [properties] Properties to set
     */
    function ScannerConfig(properties) {
      this.signalTypes = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * ScannerConfig name.
     * @member {string} name
     * @memberof ScannerProtos.ScannerConfig
     * @instance
     */
    ScannerConfig.prototype.name = '';

    /**
     * ScannerConfig updateType.
     * @member {ScannerProtos.ScannerConfig.UpdateType} updateType
     * @memberof ScannerProtos.ScannerConfig
     * @instance
     */
    ScannerConfig.prototype.updateType = 0;

    /**
     * ScannerConfig query.
     * @member {ScannerProtos.IQuery|null|undefined} query
     * @memberof ScannerProtos.ScannerConfig
     * @instance
     */
    ScannerConfig.prototype.query = null;

    /**
     * * List of signal types, if this is set
     * @member {Array.<ScannerProtos.SignalType>} signalTypes
     * @memberof ScannerProtos.ScannerConfig
     * @instance
     */
    ScannerConfig.prototype.signalTypes = $util.emptyArray;

    /**
     * Creates a new ScannerConfig instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.ScannerConfig
     * @static
     * @param {ScannerProtos.IScannerConfig=} [properties] Properties to set
     * @returns {ScannerProtos.ScannerConfig} ScannerConfig instance
     */
    ScannerConfig.create = function create(properties) {
      return new ScannerConfig(properties);
    };

    /**
     * Encodes the specified ScannerConfig message. Does not implicitly {@link ScannerProtos.ScannerConfig.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.ScannerConfig
     * @static
     * @param {ScannerProtos.IScannerConfig} message ScannerConfig message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ScannerConfig.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.name != null && Object.hasOwnProperty.call(message, 'name'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
      if (message.updateType != null && Object.hasOwnProperty.call(message, 'updateType'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.updateType);
      if (message.query != null && Object.hasOwnProperty.call(message, 'query'))
        $root.ScannerProtos.Query.encode(message.query, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
      if (message.signalTypes != null && message.signalTypes.length) {
        writer.uint32(/* id 4, wireType 2 =*/ 34).fork();
        for (let i = 0; i < message.signalTypes.length; ++i) writer.int32(message.signalTypes[i]);
        writer.ldelim();
      }
      return writer;
    };

    /**
     * Encodes the specified ScannerConfig message, length delimited. Does not implicitly {@link ScannerProtos.ScannerConfig.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.ScannerConfig
     * @static
     * @param {ScannerProtos.IScannerConfig} message ScannerConfig message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ScannerConfig.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ScannerConfig message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.ScannerConfig
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.ScannerConfig} ScannerConfig
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ScannerConfig.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.ScannerConfig();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.name = reader.string();
            break;
          }
          case 2: {
            message.updateType = reader.int32();
            break;
          }
          case 3: {
            message.query = $root.ScannerProtos.Query.decode(reader, reader.uint32());
            break;
          }
          case 4: {
            if (!(message.signalTypes && message.signalTypes.length)) message.signalTypes = [];
            if ((tag & 7) === 2) {
              let end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) message.signalTypes.push(reader.int32());
            } else message.signalTypes.push(reader.int32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a ScannerConfig message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.ScannerConfig
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.ScannerConfig} ScannerConfig
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ScannerConfig.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ScannerConfig message.
     * @function verify
     * @memberof ScannerProtos.ScannerConfig
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ScannerConfig.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.name != null && message.hasOwnProperty('name'))
        if (!$util.isString(message.name)) return 'name: string expected';
      if (message.updateType != null && message.hasOwnProperty('updateType'))
        switch (message.updateType) {
          default:
            return 'updateType: enum value expected';
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.query != null && message.hasOwnProperty('query')) {
        let error = $root.ScannerProtos.Query.verify(message.query);
        if (error) return 'query.' + error;
      }
      if (message.signalTypes != null && message.hasOwnProperty('signalTypes')) {
        if (!Array.isArray(message.signalTypes)) return 'signalTypes: array expected';
        for (let i = 0; i < message.signalTypes.length; ++i)
          switch (message.signalTypes[i]) {
            default:
              return 'signalTypes: enum value[] expected';
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
              break;
          }
      }
      return null;
    };

    /**
     * Creates a ScannerConfig message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.ScannerConfig
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.ScannerConfig} ScannerConfig
     */
    ScannerConfig.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.ScannerConfig) return object;
      let message = new $root.ScannerProtos.ScannerConfig();
      if (object.name != null) message.name = String(object.name);
      switch (object.updateType) {
        default:
          if (typeof object.updateType === 'number') {
            message.updateType = object.updateType;
            break;
          }
          break;
        case 'STREAM':
        case 0:
          message.updateType = 0;
          break;
        case 'SNAPSHOTS':
        case 1:
          message.updateType = 1;
          break;
        case 'SNAPSHOT_DELTAS':
        case 2:
          message.updateType = 2;
          break;
      }
      if (object.query != null) {
        if (typeof object.query !== 'object') throw TypeError('.ScannerProtos.ScannerConfig.query: object expected');
        message.query = $root.ScannerProtos.Query.fromObject(object.query);
      }
      if (object.signalTypes) {
        if (!Array.isArray(object.signalTypes))
          throw TypeError('.ScannerProtos.ScannerConfig.signalTypes: array expected');
        message.signalTypes = [];
        for (let i = 0; i < object.signalTypes.length; ++i)
          switch (object.signalTypes[i]) {
            default:
              if (typeof object.signalTypes[i] === 'number') {
                message.signalTypes[i] = object.signalTypes[i];
                break;
              }
            case 'UNKNOWN_SIGNAL_TYPE':
            case 0:
              message.signalTypes[i] = 0;
              break;
            case 'NEW_HIGH':
            case 1:
              message.signalTypes[i] = 1;
              break;
            case 'NEW_LOW':
            case 2:
              message.signalTypes[i] = 2;
              break;
            case 'NEW_PREMARKET_HIGH':
            case 3:
              message.signalTypes[i] = 3;
              break;
            case 'NEW_PREMARKET_LOW':
            case 4:
              message.signalTypes[i] = 4;
              break;
            case 'NEW_AFTERHOURS_HIGH':
            case 5:
              message.signalTypes[i] = 5;
              break;
            case 'NEW_AFTERHOURS_LOW':
            case 6:
              message.signalTypes[i] = 6;
              break;
          }
      }
      return message;
    };

    /**
     * Creates a plain object from a ScannerConfig message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.ScannerConfig
     * @static
     * @param {ScannerProtos.ScannerConfig} message ScannerConfig
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ScannerConfig.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.signalTypes = [];
      if (options.defaults) {
        object.name = '';
        object.updateType = options.enums === String ? 'STREAM' : 0;
        object.query = null;
      }
      if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
      if (message.updateType != null && message.hasOwnProperty('updateType'))
        object.updateType =
          options.enums === String
            ? $root.ScannerProtos.ScannerConfig.UpdateType[message.updateType] === undefined
              ? message.updateType
              : $root.ScannerProtos.ScannerConfig.UpdateType[message.updateType]
            : message.updateType;
      if (message.query != null && message.hasOwnProperty('query'))
        object.query = $root.ScannerProtos.Query.toObject(message.query, options);
      if (message.signalTypes && message.signalTypes.length) {
        object.signalTypes = [];
        for (let j = 0; j < message.signalTypes.length; ++j)
          object.signalTypes[j] =
            options.enums === String
              ? $root.ScannerProtos.SignalType[message.signalTypes[j]] === undefined
                ? message.signalTypes[j]
                : $root.ScannerProtos.SignalType[message.signalTypes[j]]
              : message.signalTypes[j];
      }
      return object;
    };

    /**
     * Converts this ScannerConfig to JSON.
     * @function toJSON
     * @memberof ScannerProtos.ScannerConfig
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ScannerConfig.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * UpdateType enum.
     * @name ScannerProtos.ScannerConfig.UpdateType
     * @enum {number}
     * @property {number} STREAM=0 STREAM value
     * @property {number} SNAPSHOTS=1 SNAPSHOTS value
     * @property {number} SNAPSHOT_DELTAS=2 SNAPSHOT_DELTAS value
     */
    ScannerConfig.UpdateType = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'STREAM')] = 0;
      values[(valuesById[1] = 'SNAPSHOTS')] = 1;
      values[(valuesById[2] = 'SNAPSHOT_DELTAS')] = 2;
      return values;
    })();

    return ScannerConfig;
  })();

  ScannerProtos.ScannerRequest = (function () {
    /**
     * Properties of a ScannerRequest.
     * @memberof ScannerProtos
     * @interface IScannerRequest
     * @property {ScannerProtos.IScannerConfig|null} [scanner] ScannerRequest scanner
     */

    /**
     * Constructs a new ScannerRequest.
     * @memberof ScannerProtos
     * @classdesc Represents a ScannerRequest.
     * @implements IScannerRequest
     * @constructor
     * @param {ScannerProtos.IScannerRequest=} [properties] Properties to set
     */
    function ScannerRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * ScannerRequest scanner.
     * @member {ScannerProtos.IScannerConfig|null|undefined} scanner
     * @memberof ScannerProtos.ScannerRequest
     * @instance
     */
    ScannerRequest.prototype.scanner = null;

    /**
     * Creates a new ScannerRequest instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.ScannerRequest
     * @static
     * @param {ScannerProtos.IScannerRequest=} [properties] Properties to set
     * @returns {ScannerProtos.ScannerRequest} ScannerRequest instance
     */
    ScannerRequest.create = function create(properties) {
      return new ScannerRequest(properties);
    };

    /**
     * Encodes the specified ScannerRequest message. Does not implicitly {@link ScannerProtos.ScannerRequest.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.ScannerRequest
     * @static
     * @param {ScannerProtos.IScannerRequest} message ScannerRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ScannerRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.scanner != null && Object.hasOwnProperty.call(message, 'scanner'))
        $root.ScannerProtos.ScannerConfig.encode(
          message.scanner,
          writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified ScannerRequest message, length delimited. Does not implicitly {@link ScannerProtos.ScannerRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.ScannerRequest
     * @static
     * @param {ScannerProtos.IScannerRequest} message ScannerRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ScannerRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ScannerRequest message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.ScannerRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.ScannerRequest} ScannerRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ScannerRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.ScannerRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.scanner = $root.ScannerProtos.ScannerConfig.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a ScannerRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.ScannerRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.ScannerRequest} ScannerRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ScannerRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ScannerRequest message.
     * @function verify
     * @memberof ScannerProtos.ScannerRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ScannerRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.scanner != null && message.hasOwnProperty('scanner')) {
        let error = $root.ScannerProtos.ScannerConfig.verify(message.scanner);
        if (error) return 'scanner.' + error;
      }
      return null;
    };

    /**
     * Creates a ScannerRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.ScannerRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.ScannerRequest} ScannerRequest
     */
    ScannerRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.ScannerRequest) return object;
      let message = new $root.ScannerProtos.ScannerRequest();
      if (object.scanner != null) {
        if (typeof object.scanner !== 'object')
          throw TypeError('.ScannerProtos.ScannerRequest.scanner: object expected');
        message.scanner = $root.ScannerProtos.ScannerConfig.fromObject(object.scanner);
      }
      return message;
    };

    /**
     * Creates a plain object from a ScannerRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.ScannerRequest
     * @static
     * @param {ScannerProtos.ScannerRequest} message ScannerRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ScannerRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.scanner = null;
      if (message.scanner != null && message.hasOwnProperty('scanner'))
        object.scanner = $root.ScannerProtos.ScannerConfig.toObject(message.scanner, options);
      return object;
    };

    /**
     * Converts this ScannerRequest to JSON.
     * @function toJSON
     * @memberof ScannerProtos.ScannerRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ScannerRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ScannerRequest;
  })();

  /**
   * SignalType enum.
   * @name ScannerProtos.SignalType
   * @enum {number}
   * @property {number} UNKNOWN_SIGNAL_TYPE=0 UNKNOWN_SIGNAL_TYPE value
   * @property {number} NEW_HIGH=1 NEW_HIGH value
   * @property {number} NEW_LOW=2 NEW_LOW value
   * @property {number} NEW_PREMARKET_HIGH=3 NEW_PREMARKET_HIGH value
   * @property {number} NEW_PREMARKET_LOW=4 NEW_PREMARKET_LOW value
   * @property {number} NEW_AFTERHOURS_HIGH=5 NEW_AFTERHOURS_HIGH value
   * @property {number} NEW_AFTERHOURS_LOW=6 NEW_AFTERHOURS_LOW value
   */
  ScannerProtos.SignalType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNKNOWN_SIGNAL_TYPE')] = 0;
    values[(valuesById[1] = 'NEW_HIGH')] = 1;
    values[(valuesById[2] = 'NEW_LOW')] = 2;
    values[(valuesById[3] = 'NEW_PREMARKET_HIGH')] = 3;
    values[(valuesById[4] = 'NEW_PREMARKET_LOW')] = 4;
    values[(valuesById[5] = 'NEW_AFTERHOURS_HIGH')] = 5;
    values[(valuesById[6] = 'NEW_AFTERHOURS_LOW')] = 6;
    return values;
  })();

  ScannerProtos.Signal = (function () {
    /**
     * Properties of a Signal.
     * @memberof ScannerProtos
     * @interface ISignal
     * @property {string|null} [symbol] Signal symbol
     * @property {number|Long|null} [time] Signal time
     * @property {LastProtos.IQuote|null} [instrument] Signal instrument
     * @property {number|Long|null} [heartbeat] Signal heartbeat
     * @property {ScannerProtos.INewHigh|null} [newHigh] Signal newHigh
     * @property {ScannerProtos.INewLow|null} [newLow] Signal newLow
     * @property {ScannerProtos.INewPreMarketHigh|null} [newPreMarketHigh] Signal newPreMarketHigh
     * @property {ScannerProtos.INewPreMarketLow|null} [newPreMarketLow] Signal newPreMarketLow
     * @property {ScannerProtos.INewAfterHoursHigh|null} [newAfterHoursHigh] Signal newAfterHoursHigh
     * @property {ScannerProtos.INewAfterHoursLow|null} [newAfterHoursLow] Signal newAfterHoursLow
     */

    /**
     * Constructs a new Signal.
     * @memberof ScannerProtos
     * @classdesc Represents a Signal.
     * @implements ISignal
     * @constructor
     * @param {ScannerProtos.ISignal=} [properties] Properties to set
     */
    function Signal(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Signal symbol.
     * @member {string} symbol
     * @memberof ScannerProtos.Signal
     * @instance
     */
    Signal.prototype.symbol = '';

    /**
     * Signal time.
     * @member {number|Long} time
     * @memberof ScannerProtos.Signal
     * @instance
     */
    Signal.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Signal instrument.
     * @member {LastProtos.IQuote|null|undefined} instrument
     * @memberof ScannerProtos.Signal
     * @instance
     */
    Signal.prototype.instrument = null;

    /**
     * Signal heartbeat.
     * @member {number|Long} heartbeat
     * @memberof ScannerProtos.Signal
     * @instance
     */
    Signal.prototype.heartbeat = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Signal newHigh.
     * @member {ScannerProtos.INewHigh|null|undefined} newHigh
     * @memberof ScannerProtos.Signal
     * @instance
     */
    Signal.prototype.newHigh = null;

    /**
     * Signal newLow.
     * @member {ScannerProtos.INewLow|null|undefined} newLow
     * @memberof ScannerProtos.Signal
     * @instance
     */
    Signal.prototype.newLow = null;

    /**
     * Signal newPreMarketHigh.
     * @member {ScannerProtos.INewPreMarketHigh|null|undefined} newPreMarketHigh
     * @memberof ScannerProtos.Signal
     * @instance
     */
    Signal.prototype.newPreMarketHigh = null;

    /**
     * Signal newPreMarketLow.
     * @member {ScannerProtos.INewPreMarketLow|null|undefined} newPreMarketLow
     * @memberof ScannerProtos.Signal
     * @instance
     */
    Signal.prototype.newPreMarketLow = null;

    /**
     * Signal newAfterHoursHigh.
     * @member {ScannerProtos.INewAfterHoursHigh|null|undefined} newAfterHoursHigh
     * @memberof ScannerProtos.Signal
     * @instance
     */
    Signal.prototype.newAfterHoursHigh = null;

    /**
     * Signal newAfterHoursLow.
     * @member {ScannerProtos.INewAfterHoursLow|null|undefined} newAfterHoursLow
     * @memberof ScannerProtos.Signal
     * @instance
     */
    Signal.prototype.newAfterHoursLow = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Signal type.
     * @member {"heartbeat"|"newHigh"|"newLow"|"newPreMarketHigh"|"newPreMarketLow"|"newAfterHoursHigh"|"newAfterHoursLow"|undefined} type
     * @memberof ScannerProtos.Signal
     * @instance
     */
    Object.defineProperty(Signal.prototype, 'type', {
      get: $util.oneOfGetter(
        ($oneOfFields = [
          'heartbeat',
          'newHigh',
          'newLow',
          'newPreMarketHigh',
          'newPreMarketLow',
          'newAfterHoursHigh',
          'newAfterHoursLow',
        ]),
      ),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new Signal instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.Signal
     * @static
     * @param {ScannerProtos.ISignal=} [properties] Properties to set
     * @returns {ScannerProtos.Signal} Signal instance
     */
    Signal.create = function create(properties) {
      return new Signal(properties);
    };

    /**
     * Encodes the specified Signal message. Does not implicitly {@link ScannerProtos.Signal.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.Signal
     * @static
     * @param {ScannerProtos.ISignal} message Signal message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Signal.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
      if (message.time != null && Object.hasOwnProperty.call(message, 'time'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int64(message.time);
      if (message.instrument != null && Object.hasOwnProperty.call(message, 'instrument'))
        $root.LastProtos.Quote.encode(message.instrument, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
      if (message.heartbeat != null && Object.hasOwnProperty.call(message, 'heartbeat'))
        writer.uint32(/* id 10, wireType 0 =*/ 80).int64(message.heartbeat);
      if (message.newHigh != null && Object.hasOwnProperty.call(message, 'newHigh'))
        $root.ScannerProtos.NewHigh.encode(message.newHigh, writer.uint32(/* id 11, wireType 2 =*/ 90).fork()).ldelim();
      if (message.newLow != null && Object.hasOwnProperty.call(message, 'newLow'))
        $root.ScannerProtos.NewLow.encode(message.newLow, writer.uint32(/* id 12, wireType 2 =*/ 98).fork()).ldelim();
      if (message.newPreMarketHigh != null && Object.hasOwnProperty.call(message, 'newPreMarketHigh'))
        $root.ScannerProtos.NewPreMarketHigh.encode(
          message.newPreMarketHigh,
          writer.uint32(/* id 13, wireType 2 =*/ 106).fork(),
        ).ldelim();
      if (message.newPreMarketLow != null && Object.hasOwnProperty.call(message, 'newPreMarketLow'))
        $root.ScannerProtos.NewPreMarketLow.encode(
          message.newPreMarketLow,
          writer.uint32(/* id 14, wireType 2 =*/ 114).fork(),
        ).ldelim();
      if (message.newAfterHoursHigh != null && Object.hasOwnProperty.call(message, 'newAfterHoursHigh'))
        $root.ScannerProtos.NewAfterHoursHigh.encode(
          message.newAfterHoursHigh,
          writer.uint32(/* id 15, wireType 2 =*/ 122).fork(),
        ).ldelim();
      if (message.newAfterHoursLow != null && Object.hasOwnProperty.call(message, 'newAfterHoursLow'))
        $root.ScannerProtos.NewAfterHoursLow.encode(
          message.newAfterHoursLow,
          writer.uint32(/* id 16, wireType 2 =*/ 130).fork(),
        ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified Signal message, length delimited. Does not implicitly {@link ScannerProtos.Signal.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.Signal
     * @static
     * @param {ScannerProtos.ISignal} message Signal message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Signal.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Signal message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.Signal
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.Signal} Signal
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Signal.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.Signal();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.symbol = reader.string();
            break;
          }
          case 2: {
            message.time = reader.int64();
            break;
          }
          case 3: {
            message.instrument = $root.LastProtos.Quote.decode(reader, reader.uint32());
            break;
          }
          case 10: {
            message.heartbeat = reader.int64();
            break;
          }
          case 11: {
            message.newHigh = $root.ScannerProtos.NewHigh.decode(reader, reader.uint32());
            break;
          }
          case 12: {
            message.newLow = $root.ScannerProtos.NewLow.decode(reader, reader.uint32());
            break;
          }
          case 13: {
            message.newPreMarketHigh = $root.ScannerProtos.NewPreMarketHigh.decode(reader, reader.uint32());
            break;
          }
          case 14: {
            message.newPreMarketLow = $root.ScannerProtos.NewPreMarketLow.decode(reader, reader.uint32());
            break;
          }
          case 15: {
            message.newAfterHoursHigh = $root.ScannerProtos.NewAfterHoursHigh.decode(reader, reader.uint32());
            break;
          }
          case 16: {
            message.newAfterHoursLow = $root.ScannerProtos.NewAfterHoursLow.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Signal message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.Signal
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.Signal} Signal
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Signal.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Signal message.
     * @function verify
     * @memberof ScannerProtos.Signal
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Signal.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      let properties = {};
      if (message.symbol != null && message.hasOwnProperty('symbol'))
        if (!$util.isString(message.symbol)) return 'symbol: string expected';
      if (message.time != null && message.hasOwnProperty('time'))
        if (
          !$util.isInteger(message.time) &&
          !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high))
        )
          return 'time: integer|Long expected';
      if (message.instrument != null && message.hasOwnProperty('instrument')) {
        let error = $root.LastProtos.Quote.verify(message.instrument);
        if (error) return 'instrument.' + error;
      }
      if (message.heartbeat != null && message.hasOwnProperty('heartbeat')) {
        properties.type = 1;
        if (
          !$util.isInteger(message.heartbeat) &&
          !(message.heartbeat && $util.isInteger(message.heartbeat.low) && $util.isInteger(message.heartbeat.high))
        )
          return 'heartbeat: integer|Long expected';
      }
      if (message.newHigh != null && message.hasOwnProperty('newHigh')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.NewHigh.verify(message.newHigh);
          if (error) return 'newHigh.' + error;
        }
      }
      if (message.newLow != null && message.hasOwnProperty('newLow')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.NewLow.verify(message.newLow);
          if (error) return 'newLow.' + error;
        }
      }
      if (message.newPreMarketHigh != null && message.hasOwnProperty('newPreMarketHigh')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.NewPreMarketHigh.verify(message.newPreMarketHigh);
          if (error) return 'newPreMarketHigh.' + error;
        }
      }
      if (message.newPreMarketLow != null && message.hasOwnProperty('newPreMarketLow')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.NewPreMarketLow.verify(message.newPreMarketLow);
          if (error) return 'newPreMarketLow.' + error;
        }
      }
      if (message.newAfterHoursHigh != null && message.hasOwnProperty('newAfterHoursHigh')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.NewAfterHoursHigh.verify(message.newAfterHoursHigh);
          if (error) return 'newAfterHoursHigh.' + error;
        }
      }
      if (message.newAfterHoursLow != null && message.hasOwnProperty('newAfterHoursLow')) {
        if (properties.type === 1) return 'type: multiple values';
        properties.type = 1;
        {
          let error = $root.ScannerProtos.NewAfterHoursLow.verify(message.newAfterHoursLow);
          if (error) return 'newAfterHoursLow.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a Signal message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.Signal
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.Signal} Signal
     */
    Signal.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.Signal) return object;
      let message = new $root.ScannerProtos.Signal();
      if (object.symbol != null) message.symbol = String(object.symbol);
      if (object.time != null)
        if ($util.Long) (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === 'string') message.time = parseInt(object.time, 10);
        else if (typeof object.time === 'number') message.time = object.time;
        else if (typeof object.time === 'object')
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      if (object.instrument != null) {
        if (typeof object.instrument !== 'object') throw TypeError('.ScannerProtos.Signal.instrument: object expected');
        message.instrument = $root.LastProtos.Quote.fromObject(object.instrument);
      }
      if (object.heartbeat != null)
        if ($util.Long) (message.heartbeat = $util.Long.fromValue(object.heartbeat)).unsigned = false;
        else if (typeof object.heartbeat === 'string') message.heartbeat = parseInt(object.heartbeat, 10);
        else if (typeof object.heartbeat === 'number') message.heartbeat = object.heartbeat;
        else if (typeof object.heartbeat === 'object')
          message.heartbeat = new $util.LongBits(object.heartbeat.low >>> 0, object.heartbeat.high >>> 0).toNumber();
      if (object.newHigh != null) {
        if (typeof object.newHigh !== 'object') throw TypeError('.ScannerProtos.Signal.newHigh: object expected');
        message.newHigh = $root.ScannerProtos.NewHigh.fromObject(object.newHigh);
      }
      if (object.newLow != null) {
        if (typeof object.newLow !== 'object') throw TypeError('.ScannerProtos.Signal.newLow: object expected');
        message.newLow = $root.ScannerProtos.NewLow.fromObject(object.newLow);
      }
      if (object.newPreMarketHigh != null) {
        if (typeof object.newPreMarketHigh !== 'object')
          throw TypeError('.ScannerProtos.Signal.newPreMarketHigh: object expected');
        message.newPreMarketHigh = $root.ScannerProtos.NewPreMarketHigh.fromObject(object.newPreMarketHigh);
      }
      if (object.newPreMarketLow != null) {
        if (typeof object.newPreMarketLow !== 'object')
          throw TypeError('.ScannerProtos.Signal.newPreMarketLow: object expected');
        message.newPreMarketLow = $root.ScannerProtos.NewPreMarketLow.fromObject(object.newPreMarketLow);
      }
      if (object.newAfterHoursHigh != null) {
        if (typeof object.newAfterHoursHigh !== 'object')
          throw TypeError('.ScannerProtos.Signal.newAfterHoursHigh: object expected');
        message.newAfterHoursHigh = $root.ScannerProtos.NewAfterHoursHigh.fromObject(object.newAfterHoursHigh);
      }
      if (object.newAfterHoursLow != null) {
        if (typeof object.newAfterHoursLow !== 'object')
          throw TypeError('.ScannerProtos.Signal.newAfterHoursLow: object expected');
        message.newAfterHoursLow = $root.ScannerProtos.NewAfterHoursLow.fromObject(object.newAfterHoursLow);
      }
      return message;
    };

    /**
     * Creates a plain object from a Signal message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.Signal
     * @static
     * @param {ScannerProtos.Signal} message Signal
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Signal.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.time = options.longs === String ? '0' : 0;
        object.instrument = null;
      }
      if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
      if (message.time != null && message.hasOwnProperty('time'))
        if (typeof message.time === 'number')
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.time)
              : options.longs === Number
                ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber()
                : message.time;
      if (message.instrument != null && message.hasOwnProperty('instrument'))
        object.instrument = $root.LastProtos.Quote.toObject(message.instrument, options);
      if (message.heartbeat != null && message.hasOwnProperty('heartbeat')) {
        if (typeof message.heartbeat === 'number')
          object.heartbeat = options.longs === String ? String(message.heartbeat) : message.heartbeat;
        else
          object.heartbeat =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.heartbeat)
              : options.longs === Number
                ? new $util.LongBits(message.heartbeat.low >>> 0, message.heartbeat.high >>> 0).toNumber()
                : message.heartbeat;
        if (options.oneofs) object.type = 'heartbeat';
      }
      if (message.newHigh != null && message.hasOwnProperty('newHigh')) {
        object.newHigh = $root.ScannerProtos.NewHigh.toObject(message.newHigh, options);
        if (options.oneofs) object.type = 'newHigh';
      }
      if (message.newLow != null && message.hasOwnProperty('newLow')) {
        object.newLow = $root.ScannerProtos.NewLow.toObject(message.newLow, options);
        if (options.oneofs) object.type = 'newLow';
      }
      if (message.newPreMarketHigh != null && message.hasOwnProperty('newPreMarketHigh')) {
        object.newPreMarketHigh = $root.ScannerProtos.NewPreMarketHigh.toObject(message.newPreMarketHigh, options);
        if (options.oneofs) object.type = 'newPreMarketHigh';
      }
      if (message.newPreMarketLow != null && message.hasOwnProperty('newPreMarketLow')) {
        object.newPreMarketLow = $root.ScannerProtos.NewPreMarketLow.toObject(message.newPreMarketLow, options);
        if (options.oneofs) object.type = 'newPreMarketLow';
      }
      if (message.newAfterHoursHigh != null && message.hasOwnProperty('newAfterHoursHigh')) {
        object.newAfterHoursHigh = $root.ScannerProtos.NewAfterHoursHigh.toObject(message.newAfterHoursHigh, options);
        if (options.oneofs) object.type = 'newAfterHoursHigh';
      }
      if (message.newAfterHoursLow != null && message.hasOwnProperty('newAfterHoursLow')) {
        object.newAfterHoursLow = $root.ScannerProtos.NewAfterHoursLow.toObject(message.newAfterHoursLow, options);
        if (options.oneofs) object.type = 'newAfterHoursLow';
      }
      return object;
    };

    /**
     * Converts this Signal to JSON.
     * @function toJSON
     * @memberof ScannerProtos.Signal
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Signal.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Signal;
  })();

  ScannerProtos.NewHigh = (function () {
    /**
     * Properties of a NewHigh.
     * @memberof ScannerProtos
     * @interface INewHigh
     * @property {number|null} [value] NewHigh value
     */

    /**
     * Constructs a new NewHigh.
     * @memberof ScannerProtos
     * @classdesc Represents a NewHigh.
     * @implements INewHigh
     * @constructor
     * @param {ScannerProtos.INewHigh=} [properties] Properties to set
     */
    function NewHigh(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * NewHigh value.
     * @member {number} value
     * @memberof ScannerProtos.NewHigh
     * @instance
     */
    NewHigh.prototype.value = 0;

    /**
     * Creates a new NewHigh instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.NewHigh
     * @static
     * @param {ScannerProtos.INewHigh=} [properties] Properties to set
     * @returns {ScannerProtos.NewHigh} NewHigh instance
     */
    NewHigh.create = function create(properties) {
      return new NewHigh(properties);
    };

    /**
     * Encodes the specified NewHigh message. Does not implicitly {@link ScannerProtos.NewHigh.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.NewHigh
     * @static
     * @param {ScannerProtos.INewHigh} message NewHigh message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewHigh.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.value);
      return writer;
    };

    /**
     * Encodes the specified NewHigh message, length delimited. Does not implicitly {@link ScannerProtos.NewHigh.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.NewHigh
     * @static
     * @param {ScannerProtos.INewHigh} message NewHigh message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewHigh.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NewHigh message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.NewHigh
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.NewHigh} NewHigh
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewHigh.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.NewHigh();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.value = reader.double();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a NewHigh message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.NewHigh
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.NewHigh} NewHigh
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewHigh.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NewHigh message.
     * @function verify
     * @memberof ScannerProtos.NewHigh
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NewHigh.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (typeof message.value !== 'number') return 'value: number expected';
      return null;
    };

    /**
     * Creates a NewHigh message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.NewHigh
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.NewHigh} NewHigh
     */
    NewHigh.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.NewHigh) return object;
      let message = new $root.ScannerProtos.NewHigh();
      if (object.value != null) message.value = Number(object.value);
      return message;
    };

    /**
     * Creates a plain object from a NewHigh message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.NewHigh
     * @static
     * @param {ScannerProtos.NewHigh} message NewHigh
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NewHigh.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.value = 0;
      if (message.value != null && message.hasOwnProperty('value'))
        object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
      return object;
    };

    /**
     * Converts this NewHigh to JSON.
     * @function toJSON
     * @memberof ScannerProtos.NewHigh
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NewHigh.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NewHigh;
  })();

  ScannerProtos.NewLow = (function () {
    /**
     * Properties of a NewLow.
     * @memberof ScannerProtos
     * @interface INewLow
     * @property {number|null} [value] NewLow value
     */

    /**
     * Constructs a new NewLow.
     * @memberof ScannerProtos
     * @classdesc Represents a NewLow.
     * @implements INewLow
     * @constructor
     * @param {ScannerProtos.INewLow=} [properties] Properties to set
     */
    function NewLow(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * NewLow value.
     * @member {number} value
     * @memberof ScannerProtos.NewLow
     * @instance
     */
    NewLow.prototype.value = 0;

    /**
     * Creates a new NewLow instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.NewLow
     * @static
     * @param {ScannerProtos.INewLow=} [properties] Properties to set
     * @returns {ScannerProtos.NewLow} NewLow instance
     */
    NewLow.create = function create(properties) {
      return new NewLow(properties);
    };

    /**
     * Encodes the specified NewLow message. Does not implicitly {@link ScannerProtos.NewLow.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.NewLow
     * @static
     * @param {ScannerProtos.INewLow} message NewLow message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewLow.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.value);
      return writer;
    };

    /**
     * Encodes the specified NewLow message, length delimited. Does not implicitly {@link ScannerProtos.NewLow.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.NewLow
     * @static
     * @param {ScannerProtos.INewLow} message NewLow message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewLow.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NewLow message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.NewLow
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.NewLow} NewLow
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewLow.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.NewLow();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.value = reader.double();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a NewLow message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.NewLow
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.NewLow} NewLow
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewLow.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NewLow message.
     * @function verify
     * @memberof ScannerProtos.NewLow
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NewLow.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (typeof message.value !== 'number') return 'value: number expected';
      return null;
    };

    /**
     * Creates a NewLow message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.NewLow
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.NewLow} NewLow
     */
    NewLow.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.NewLow) return object;
      let message = new $root.ScannerProtos.NewLow();
      if (object.value != null) message.value = Number(object.value);
      return message;
    };

    /**
     * Creates a plain object from a NewLow message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.NewLow
     * @static
     * @param {ScannerProtos.NewLow} message NewLow
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NewLow.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.value = 0;
      if (message.value != null && message.hasOwnProperty('value'))
        object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
      return object;
    };

    /**
     * Converts this NewLow to JSON.
     * @function toJSON
     * @memberof ScannerProtos.NewLow
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NewLow.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NewLow;
  })();

  ScannerProtos.NewPreMarketHigh = (function () {
    /**
     * Properties of a NewPreMarketHigh.
     * @memberof ScannerProtos
     * @interface INewPreMarketHigh
     * @property {number|null} [value] NewPreMarketHigh value
     */

    /**
     * Constructs a new NewPreMarketHigh.
     * @memberof ScannerProtos
     * @classdesc Represents a NewPreMarketHigh.
     * @implements INewPreMarketHigh
     * @constructor
     * @param {ScannerProtos.INewPreMarketHigh=} [properties] Properties to set
     */
    function NewPreMarketHigh(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * NewPreMarketHigh value.
     * @member {number} value
     * @memberof ScannerProtos.NewPreMarketHigh
     * @instance
     */
    NewPreMarketHigh.prototype.value = 0;

    /**
     * Creates a new NewPreMarketHigh instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.NewPreMarketHigh
     * @static
     * @param {ScannerProtos.INewPreMarketHigh=} [properties] Properties to set
     * @returns {ScannerProtos.NewPreMarketHigh} NewPreMarketHigh instance
     */
    NewPreMarketHigh.create = function create(properties) {
      return new NewPreMarketHigh(properties);
    };

    /**
     * Encodes the specified NewPreMarketHigh message. Does not implicitly {@link ScannerProtos.NewPreMarketHigh.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.NewPreMarketHigh
     * @static
     * @param {ScannerProtos.INewPreMarketHigh} message NewPreMarketHigh message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewPreMarketHigh.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.value);
      return writer;
    };

    /**
     * Encodes the specified NewPreMarketHigh message, length delimited. Does not implicitly {@link ScannerProtos.NewPreMarketHigh.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.NewPreMarketHigh
     * @static
     * @param {ScannerProtos.INewPreMarketHigh} message NewPreMarketHigh message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewPreMarketHigh.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NewPreMarketHigh message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.NewPreMarketHigh
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.NewPreMarketHigh} NewPreMarketHigh
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewPreMarketHigh.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.NewPreMarketHigh();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.value = reader.double();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a NewPreMarketHigh message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.NewPreMarketHigh
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.NewPreMarketHigh} NewPreMarketHigh
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewPreMarketHigh.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NewPreMarketHigh message.
     * @function verify
     * @memberof ScannerProtos.NewPreMarketHigh
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NewPreMarketHigh.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (typeof message.value !== 'number') return 'value: number expected';
      return null;
    };

    /**
     * Creates a NewPreMarketHigh message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.NewPreMarketHigh
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.NewPreMarketHigh} NewPreMarketHigh
     */
    NewPreMarketHigh.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.NewPreMarketHigh) return object;
      let message = new $root.ScannerProtos.NewPreMarketHigh();
      if (object.value != null) message.value = Number(object.value);
      return message;
    };

    /**
     * Creates a plain object from a NewPreMarketHigh message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.NewPreMarketHigh
     * @static
     * @param {ScannerProtos.NewPreMarketHigh} message NewPreMarketHigh
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NewPreMarketHigh.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.value = 0;
      if (message.value != null && message.hasOwnProperty('value'))
        object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
      return object;
    };

    /**
     * Converts this NewPreMarketHigh to JSON.
     * @function toJSON
     * @memberof ScannerProtos.NewPreMarketHigh
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NewPreMarketHigh.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NewPreMarketHigh;
  })();

  ScannerProtos.NewPreMarketLow = (function () {
    /**
     * Properties of a NewPreMarketLow.
     * @memberof ScannerProtos
     * @interface INewPreMarketLow
     * @property {number|null} [value] NewPreMarketLow value
     */

    /**
     * Constructs a new NewPreMarketLow.
     * @memberof ScannerProtos
     * @classdesc Represents a NewPreMarketLow.
     * @implements INewPreMarketLow
     * @constructor
     * @param {ScannerProtos.INewPreMarketLow=} [properties] Properties to set
     */
    function NewPreMarketLow(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * NewPreMarketLow value.
     * @member {number} value
     * @memberof ScannerProtos.NewPreMarketLow
     * @instance
     */
    NewPreMarketLow.prototype.value = 0;

    /**
     * Creates a new NewPreMarketLow instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.NewPreMarketLow
     * @static
     * @param {ScannerProtos.INewPreMarketLow=} [properties] Properties to set
     * @returns {ScannerProtos.NewPreMarketLow} NewPreMarketLow instance
     */
    NewPreMarketLow.create = function create(properties) {
      return new NewPreMarketLow(properties);
    };

    /**
     * Encodes the specified NewPreMarketLow message. Does not implicitly {@link ScannerProtos.NewPreMarketLow.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.NewPreMarketLow
     * @static
     * @param {ScannerProtos.INewPreMarketLow} message NewPreMarketLow message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewPreMarketLow.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.value);
      return writer;
    };

    /**
     * Encodes the specified NewPreMarketLow message, length delimited. Does not implicitly {@link ScannerProtos.NewPreMarketLow.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.NewPreMarketLow
     * @static
     * @param {ScannerProtos.INewPreMarketLow} message NewPreMarketLow message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewPreMarketLow.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NewPreMarketLow message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.NewPreMarketLow
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.NewPreMarketLow} NewPreMarketLow
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewPreMarketLow.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.NewPreMarketLow();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.value = reader.double();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a NewPreMarketLow message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.NewPreMarketLow
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.NewPreMarketLow} NewPreMarketLow
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewPreMarketLow.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NewPreMarketLow message.
     * @function verify
     * @memberof ScannerProtos.NewPreMarketLow
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NewPreMarketLow.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (typeof message.value !== 'number') return 'value: number expected';
      return null;
    };

    /**
     * Creates a NewPreMarketLow message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.NewPreMarketLow
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.NewPreMarketLow} NewPreMarketLow
     */
    NewPreMarketLow.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.NewPreMarketLow) return object;
      let message = new $root.ScannerProtos.NewPreMarketLow();
      if (object.value != null) message.value = Number(object.value);
      return message;
    };

    /**
     * Creates a plain object from a NewPreMarketLow message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.NewPreMarketLow
     * @static
     * @param {ScannerProtos.NewPreMarketLow} message NewPreMarketLow
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NewPreMarketLow.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.value = 0;
      if (message.value != null && message.hasOwnProperty('value'))
        object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
      return object;
    };

    /**
     * Converts this NewPreMarketLow to JSON.
     * @function toJSON
     * @memberof ScannerProtos.NewPreMarketLow
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NewPreMarketLow.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NewPreMarketLow;
  })();

  ScannerProtos.NewAfterHoursHigh = (function () {
    /**
     * Properties of a NewAfterHoursHigh.
     * @memberof ScannerProtos
     * @interface INewAfterHoursHigh
     * @property {number|null} [value] NewAfterHoursHigh value
     */

    /**
     * Constructs a new NewAfterHoursHigh.
     * @memberof ScannerProtos
     * @classdesc Represents a NewAfterHoursHigh.
     * @implements INewAfterHoursHigh
     * @constructor
     * @param {ScannerProtos.INewAfterHoursHigh=} [properties] Properties to set
     */
    function NewAfterHoursHigh(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * NewAfterHoursHigh value.
     * @member {number} value
     * @memberof ScannerProtos.NewAfterHoursHigh
     * @instance
     */
    NewAfterHoursHigh.prototype.value = 0;

    /**
     * Creates a new NewAfterHoursHigh instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.NewAfterHoursHigh
     * @static
     * @param {ScannerProtos.INewAfterHoursHigh=} [properties] Properties to set
     * @returns {ScannerProtos.NewAfterHoursHigh} NewAfterHoursHigh instance
     */
    NewAfterHoursHigh.create = function create(properties) {
      return new NewAfterHoursHigh(properties);
    };

    /**
     * Encodes the specified NewAfterHoursHigh message. Does not implicitly {@link ScannerProtos.NewAfterHoursHigh.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.NewAfterHoursHigh
     * @static
     * @param {ScannerProtos.INewAfterHoursHigh} message NewAfterHoursHigh message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewAfterHoursHigh.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.value);
      return writer;
    };

    /**
     * Encodes the specified NewAfterHoursHigh message, length delimited. Does not implicitly {@link ScannerProtos.NewAfterHoursHigh.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.NewAfterHoursHigh
     * @static
     * @param {ScannerProtos.INewAfterHoursHigh} message NewAfterHoursHigh message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewAfterHoursHigh.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NewAfterHoursHigh message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.NewAfterHoursHigh
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.NewAfterHoursHigh} NewAfterHoursHigh
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewAfterHoursHigh.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.NewAfterHoursHigh();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.value = reader.double();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a NewAfterHoursHigh message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.NewAfterHoursHigh
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.NewAfterHoursHigh} NewAfterHoursHigh
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewAfterHoursHigh.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NewAfterHoursHigh message.
     * @function verify
     * @memberof ScannerProtos.NewAfterHoursHigh
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NewAfterHoursHigh.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (typeof message.value !== 'number') return 'value: number expected';
      return null;
    };

    /**
     * Creates a NewAfterHoursHigh message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.NewAfterHoursHigh
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.NewAfterHoursHigh} NewAfterHoursHigh
     */
    NewAfterHoursHigh.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.NewAfterHoursHigh) return object;
      let message = new $root.ScannerProtos.NewAfterHoursHigh();
      if (object.value != null) message.value = Number(object.value);
      return message;
    };

    /**
     * Creates a plain object from a NewAfterHoursHigh message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.NewAfterHoursHigh
     * @static
     * @param {ScannerProtos.NewAfterHoursHigh} message NewAfterHoursHigh
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NewAfterHoursHigh.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.value = 0;
      if (message.value != null && message.hasOwnProperty('value'))
        object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
      return object;
    };

    /**
     * Converts this NewAfterHoursHigh to JSON.
     * @function toJSON
     * @memberof ScannerProtos.NewAfterHoursHigh
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NewAfterHoursHigh.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NewAfterHoursHigh;
  })();

  ScannerProtos.NewAfterHoursLow = (function () {
    /**
     * Properties of a NewAfterHoursLow.
     * @memberof ScannerProtos
     * @interface INewAfterHoursLow
     * @property {number|null} [value] NewAfterHoursLow value
     */

    /**
     * Constructs a new NewAfterHoursLow.
     * @memberof ScannerProtos
     * @classdesc Represents a NewAfterHoursLow.
     * @implements INewAfterHoursLow
     * @constructor
     * @param {ScannerProtos.INewAfterHoursLow=} [properties] Properties to set
     */
    function NewAfterHoursLow(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * NewAfterHoursLow value.
     * @member {number} value
     * @memberof ScannerProtos.NewAfterHoursLow
     * @instance
     */
    NewAfterHoursLow.prototype.value = 0;

    /**
     * Creates a new NewAfterHoursLow instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.NewAfterHoursLow
     * @static
     * @param {ScannerProtos.INewAfterHoursLow=} [properties] Properties to set
     * @returns {ScannerProtos.NewAfterHoursLow} NewAfterHoursLow instance
     */
    NewAfterHoursLow.create = function create(properties) {
      return new NewAfterHoursLow(properties);
    };

    /**
     * Encodes the specified NewAfterHoursLow message. Does not implicitly {@link ScannerProtos.NewAfterHoursLow.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.NewAfterHoursLow
     * @static
     * @param {ScannerProtos.INewAfterHoursLow} message NewAfterHoursLow message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewAfterHoursLow.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.value != null && Object.hasOwnProperty.call(message, 'value'))
        writer.uint32(/* id 1, wireType 1 =*/ 9).double(message.value);
      return writer;
    };

    /**
     * Encodes the specified NewAfterHoursLow message, length delimited. Does not implicitly {@link ScannerProtos.NewAfterHoursLow.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.NewAfterHoursLow
     * @static
     * @param {ScannerProtos.INewAfterHoursLow} message NewAfterHoursLow message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewAfterHoursLow.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NewAfterHoursLow message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.NewAfterHoursLow
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.NewAfterHoursLow} NewAfterHoursLow
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewAfterHoursLow.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.NewAfterHoursLow();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.value = reader.double();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a NewAfterHoursLow message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.NewAfterHoursLow
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.NewAfterHoursLow} NewAfterHoursLow
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewAfterHoursLow.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NewAfterHoursLow message.
     * @function verify
     * @memberof ScannerProtos.NewAfterHoursLow
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NewAfterHoursLow.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.value != null && message.hasOwnProperty('value'))
        if (typeof message.value !== 'number') return 'value: number expected';
      return null;
    };

    /**
     * Creates a NewAfterHoursLow message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.NewAfterHoursLow
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.NewAfterHoursLow} NewAfterHoursLow
     */
    NewAfterHoursLow.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.NewAfterHoursLow) return object;
      let message = new $root.ScannerProtos.NewAfterHoursLow();
      if (object.value != null) message.value = Number(object.value);
      return message;
    };

    /**
     * Creates a plain object from a NewAfterHoursLow message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.NewAfterHoursLow
     * @static
     * @param {ScannerProtos.NewAfterHoursLow} message NewAfterHoursLow
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NewAfterHoursLow.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.value = 0;
      if (message.value != null && message.hasOwnProperty('value'))
        object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
      return object;
    };

    /**
     * Converts this NewAfterHoursLow to JSON.
     * @function toJSON
     * @memberof ScannerProtos.NewAfterHoursLow
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NewAfterHoursLow.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NewAfterHoursLow;
  })();

  ScannerProtos.Poller = (function () {
    /**
     * Properties of a Poller.
     * @memberof ScannerProtos
     * @interface IPoller
     * @property {string|null} [name] Poller name
     * @property {string|null} [schedule] Poller schedule
     */

    /**
     * Constructs a new Poller.
     * @memberof ScannerProtos
     * @classdesc Represents a Poller.
     * @implements IPoller
     * @constructor
     * @param {ScannerProtos.IPoller=} [properties] Properties to set
     */
    function Poller(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Poller name.
     * @member {string} name
     * @memberof ScannerProtos.Poller
     * @instance
     */
    Poller.prototype.name = '';

    /**
     * Poller schedule.
     * @member {string} schedule
     * @memberof ScannerProtos.Poller
     * @instance
     */
    Poller.prototype.schedule = '';

    /**
     * Creates a new Poller instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.Poller
     * @static
     * @param {ScannerProtos.IPoller=} [properties] Properties to set
     * @returns {ScannerProtos.Poller} Poller instance
     */
    Poller.create = function create(properties) {
      return new Poller(properties);
    };

    /**
     * Encodes the specified Poller message. Does not implicitly {@link ScannerProtos.Poller.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.Poller
     * @static
     * @param {ScannerProtos.IPoller} message Poller message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Poller.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.name != null && Object.hasOwnProperty.call(message, 'name'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
      if (message.schedule != null && Object.hasOwnProperty.call(message, 'schedule'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.schedule);
      return writer;
    };

    /**
     * Encodes the specified Poller message, length delimited. Does not implicitly {@link ScannerProtos.Poller.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.Poller
     * @static
     * @param {ScannerProtos.IPoller} message Poller message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Poller.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Poller message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.Poller
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.Poller} Poller
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Poller.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.Poller();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.name = reader.string();
            break;
          }
          case 2: {
            message.schedule = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Poller message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.Poller
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.Poller} Poller
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Poller.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Poller message.
     * @function verify
     * @memberof ScannerProtos.Poller
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Poller.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.name != null && message.hasOwnProperty('name'))
        if (!$util.isString(message.name)) return 'name: string expected';
      if (message.schedule != null && message.hasOwnProperty('schedule'))
        if (!$util.isString(message.schedule)) return 'schedule: string expected';
      return null;
    };

    /**
     * Creates a Poller message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.Poller
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.Poller} Poller
     */
    Poller.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.Poller) return object;
      let message = new $root.ScannerProtos.Poller();
      if (object.name != null) message.name = String(object.name);
      if (object.schedule != null) message.schedule = String(object.schedule);
      return message;
    };

    /**
     * Creates a plain object from a Poller message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.Poller
     * @static
     * @param {ScannerProtos.Poller} message Poller
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Poller.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.name = '';
        object.schedule = '';
      }
      if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
      if (message.schedule != null && message.hasOwnProperty('schedule')) object.schedule = message.schedule;
      return object;
    };

    /**
     * Converts this Poller to JSON.
     * @function toJSON
     * @memberof ScannerProtos.Poller
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Poller.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Poller;
  })();

  ScannerProtos.PollersConfig = (function () {
    /**
     * Properties of a PollersConfig.
     * @memberof ScannerProtos
     * @interface IPollersConfig
     * @property {Array.<ScannerProtos.IPoller>|null} [poller] PollersConfig poller
     */

    /**
     * Constructs a new PollersConfig.
     * @memberof ScannerProtos
     * @classdesc Represents a PollersConfig.
     * @implements IPollersConfig
     * @constructor
     * @param {ScannerProtos.IPollersConfig=} [properties] Properties to set
     */
    function PollersConfig(properties) {
      this.poller = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * PollersConfig poller.
     * @member {Array.<ScannerProtos.IPoller>} poller
     * @memberof ScannerProtos.PollersConfig
     * @instance
     */
    PollersConfig.prototype.poller = $util.emptyArray;

    /**
     * Creates a new PollersConfig instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.PollersConfig
     * @static
     * @param {ScannerProtos.IPollersConfig=} [properties] Properties to set
     * @returns {ScannerProtos.PollersConfig} PollersConfig instance
     */
    PollersConfig.create = function create(properties) {
      return new PollersConfig(properties);
    };

    /**
     * Encodes the specified PollersConfig message. Does not implicitly {@link ScannerProtos.PollersConfig.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.PollersConfig
     * @static
     * @param {ScannerProtos.IPollersConfig} message PollersConfig message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PollersConfig.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.poller != null && message.poller.length)
        for (let i = 0; i < message.poller.length; ++i)
          $root.ScannerProtos.Poller.encode(
            message.poller[i],
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified PollersConfig message, length delimited. Does not implicitly {@link ScannerProtos.PollersConfig.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.PollersConfig
     * @static
     * @param {ScannerProtos.IPollersConfig} message PollersConfig message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PollersConfig.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PollersConfig message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.PollersConfig
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.PollersConfig} PollersConfig
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PollersConfig.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.PollersConfig();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (!(message.poller && message.poller.length)) message.poller = [];
            message.poller.push($root.ScannerProtos.Poller.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a PollersConfig message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.PollersConfig
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.PollersConfig} PollersConfig
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PollersConfig.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PollersConfig message.
     * @function verify
     * @memberof ScannerProtos.PollersConfig
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PollersConfig.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.poller != null && message.hasOwnProperty('poller')) {
        if (!Array.isArray(message.poller)) return 'poller: array expected';
        for (let i = 0; i < message.poller.length; ++i) {
          let error = $root.ScannerProtos.Poller.verify(message.poller[i]);
          if (error) return 'poller.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a PollersConfig message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.PollersConfig
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.PollersConfig} PollersConfig
     */
    PollersConfig.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.PollersConfig) return object;
      let message = new $root.ScannerProtos.PollersConfig();
      if (object.poller) {
        if (!Array.isArray(object.poller)) throw TypeError('.ScannerProtos.PollersConfig.poller: array expected');
        message.poller = [];
        for (let i = 0; i < object.poller.length; ++i) {
          if (typeof object.poller[i] !== 'object')
            throw TypeError('.ScannerProtos.PollersConfig.poller: object expected');
          message.poller[i] = $root.ScannerProtos.Poller.fromObject(object.poller[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a PollersConfig message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.PollersConfig
     * @static
     * @param {ScannerProtos.PollersConfig} message PollersConfig
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PollersConfig.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.poller = [];
      if (message.poller && message.poller.length) {
        object.poller = [];
        for (let j = 0; j < message.poller.length; ++j)
          object.poller[j] = $root.ScannerProtos.Poller.toObject(message.poller[j], options);
      }
      return object;
    };

    /**
     * Converts this PollersConfig to JSON.
     * @function toJSON
     * @memberof ScannerProtos.PollersConfig
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PollersConfig.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PollersConfig;
  })();

  ScannerProtos.DataResponse = (function () {
    /**
     * Properties of a DataResponse.
     * @memberof ScannerProtos
     * @interface IDataResponse
     * @property {Array.<LastProtos.IQuote>|null} [quotes] DataResponse quotes
     */

    /**
     * Constructs a new DataResponse.
     * @memberof ScannerProtos
     * @classdesc Represents a DataResponse.
     * @implements IDataResponse
     * @constructor
     * @param {ScannerProtos.IDataResponse=} [properties] Properties to set
     */
    function DataResponse(properties) {
      this.quotes = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * DataResponse quotes.
     * @member {Array.<LastProtos.IQuote>} quotes
     * @memberof ScannerProtos.DataResponse
     * @instance
     */
    DataResponse.prototype.quotes = $util.emptyArray;

    /**
     * Creates a new DataResponse instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.DataResponse
     * @static
     * @param {ScannerProtos.IDataResponse=} [properties] Properties to set
     * @returns {ScannerProtos.DataResponse} DataResponse instance
     */
    DataResponse.create = function create(properties) {
      return new DataResponse(properties);
    };

    /**
     * Encodes the specified DataResponse message. Does not implicitly {@link ScannerProtos.DataResponse.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.DataResponse
     * @static
     * @param {ScannerProtos.IDataResponse} message DataResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DataResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.quotes != null && message.quotes.length)
        for (let i = 0; i < message.quotes.length; ++i)
          $root.LastProtos.Quote.encode(message.quotes[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified DataResponse message, length delimited. Does not implicitly {@link ScannerProtos.DataResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.DataResponse
     * @static
     * @param {ScannerProtos.IDataResponse} message DataResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DataResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DataResponse message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.DataResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.DataResponse} DataResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DataResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.DataResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (!(message.quotes && message.quotes.length)) message.quotes = [];
            message.quotes.push($root.LastProtos.Quote.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a DataResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.DataResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.DataResponse} DataResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DataResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DataResponse message.
     * @function verify
     * @memberof ScannerProtos.DataResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DataResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.quotes != null && message.hasOwnProperty('quotes')) {
        if (!Array.isArray(message.quotes)) return 'quotes: array expected';
        for (let i = 0; i < message.quotes.length; ++i) {
          let error = $root.LastProtos.Quote.verify(message.quotes[i]);
          if (error) return 'quotes.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a DataResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.DataResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.DataResponse} DataResponse
     */
    DataResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.DataResponse) return object;
      let message = new $root.ScannerProtos.DataResponse();
      if (object.quotes) {
        if (!Array.isArray(object.quotes)) throw TypeError('.ScannerProtos.DataResponse.quotes: array expected');
        message.quotes = [];
        for (let i = 0; i < object.quotes.length; ++i) {
          if (typeof object.quotes[i] !== 'object')
            throw TypeError('.ScannerProtos.DataResponse.quotes: object expected');
          message.quotes[i] = $root.LastProtos.Quote.fromObject(object.quotes[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a DataResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.DataResponse
     * @static
     * @param {ScannerProtos.DataResponse} message DataResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DataResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.quotes = [];
      if (message.quotes && message.quotes.length) {
        object.quotes = [];
        for (let j = 0; j < message.quotes.length; ++j)
          object.quotes[j] = $root.LastProtos.Quote.toObject(message.quotes[j], options);
      }
      return object;
    };

    /**
     * Converts this DataResponse to JSON.
     * @function toJSON
     * @memberof ScannerProtos.DataResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DataResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DataResponse;
  })();

  ScannerProtos.Wiim = (function () {
    /**
     * Properties of a Wiim.
     * @memberof ScannerProtos
     * @interface IWiim
     * @property {string|null} [id] Wiim id
     * @property {string|null} [title] Wiim title
     * @property {string|null} [asOf] Wiim asOf
     * @property {Array.<string>|null} [tickers] Wiim tickers
     */

    /**
     * Constructs a new Wiim.
     * @memberof ScannerProtos
     * @classdesc Represents a Wiim.
     * @implements IWiim
     * @constructor
     * @param {ScannerProtos.IWiim=} [properties] Properties to set
     */
    function Wiim(properties) {
      this.tickers = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Wiim id.
     * @member {string} id
     * @memberof ScannerProtos.Wiim
     * @instance
     */
    Wiim.prototype.id = '';

    /**
     * Wiim title.
     * @member {string} title
     * @memberof ScannerProtos.Wiim
     * @instance
     */
    Wiim.prototype.title = '';

    /**
     * Wiim asOf.
     * @member {string} asOf
     * @memberof ScannerProtos.Wiim
     * @instance
     */
    Wiim.prototype.asOf = '';

    /**
     * Wiim tickers.
     * @member {Array.<string>} tickers
     * @memberof ScannerProtos.Wiim
     * @instance
     */
    Wiim.prototype.tickers = $util.emptyArray;

    /**
     * Creates a new Wiim instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.Wiim
     * @static
     * @param {ScannerProtos.IWiim=} [properties] Properties to set
     * @returns {ScannerProtos.Wiim} Wiim instance
     */
    Wiim.create = function create(properties) {
      return new Wiim(properties);
    };

    /**
     * Encodes the specified Wiim message. Does not implicitly {@link ScannerProtos.Wiim.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.Wiim
     * @static
     * @param {ScannerProtos.IWiim} message Wiim message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Wiim.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, 'id'))
        writer.uint32(/* id 10, wireType 2 =*/ 82).string(message.id);
      if (message.title != null && Object.hasOwnProperty.call(message, 'title'))
        writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.title);
      if (message.asOf != null && Object.hasOwnProperty.call(message, 'asOf'))
        writer.uint32(/* id 12, wireType 2 =*/ 98).string(message.asOf);
      if (message.tickers != null && message.tickers.length)
        for (let i = 0; i < message.tickers.length; ++i)
          writer.uint32(/* id 13, wireType 2 =*/ 106).string(message.tickers[i]);
      return writer;
    };

    /**
     * Encodes the specified Wiim message, length delimited. Does not implicitly {@link ScannerProtos.Wiim.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.Wiim
     * @static
     * @param {ScannerProtos.IWiim} message Wiim message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Wiim.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Wiim message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.Wiim
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.Wiim} Wiim
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Wiim.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.Wiim();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 10: {
            message.id = reader.string();
            break;
          }
          case 11: {
            message.title = reader.string();
            break;
          }
          case 12: {
            message.asOf = reader.string();
            break;
          }
          case 13: {
            if (!(message.tickers && message.tickers.length)) message.tickers = [];
            message.tickers.push(reader.string());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Wiim message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.Wiim
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.Wiim} Wiim
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Wiim.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Wiim message.
     * @function verify
     * @memberof ScannerProtos.Wiim
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Wiim.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.id != null && message.hasOwnProperty('id'))
        if (!$util.isString(message.id)) return 'id: string expected';
      if (message.title != null && message.hasOwnProperty('title'))
        if (!$util.isString(message.title)) return 'title: string expected';
      if (message.asOf != null && message.hasOwnProperty('asOf'))
        if (!$util.isString(message.asOf)) return 'asOf: string expected';
      if (message.tickers != null && message.hasOwnProperty('tickers')) {
        if (!Array.isArray(message.tickers)) return 'tickers: array expected';
        for (let i = 0; i < message.tickers.length; ++i)
          if (!$util.isString(message.tickers[i])) return 'tickers: string[] expected';
      }
      return null;
    };

    /**
     * Creates a Wiim message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.Wiim
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.Wiim} Wiim
     */
    Wiim.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.Wiim) return object;
      let message = new $root.ScannerProtos.Wiim();
      if (object.id != null) message.id = String(object.id);
      if (object.title != null) message.title = String(object.title);
      if (object.asOf != null) message.asOf = String(object.asOf);
      if (object.tickers) {
        if (!Array.isArray(object.tickers)) throw TypeError('.ScannerProtos.Wiim.tickers: array expected');
        message.tickers = [];
        for (let i = 0; i < object.tickers.length; ++i) message.tickers[i] = String(object.tickers[i]);
      }
      return message;
    };

    /**
     * Creates a plain object from a Wiim message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.Wiim
     * @static
     * @param {ScannerProtos.Wiim} message Wiim
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Wiim.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.tickers = [];
      if (options.defaults) {
        object.id = '';
        object.title = '';
        object.asOf = '';
      }
      if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
      if (message.title != null && message.hasOwnProperty('title')) object.title = message.title;
      if (message.asOf != null && message.hasOwnProperty('asOf')) object.asOf = message.asOf;
      if (message.tickers && message.tickers.length) {
        object.tickers = [];
        for (let j = 0; j < message.tickers.length; ++j) object.tickers[j] = message.tickers[j];
      }
      return object;
    };

    /**
     * Converts this Wiim to JSON.
     * @function toJSON
     * @memberof ScannerProtos.Wiim
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Wiim.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Wiim;
  })();

  ScannerProtos.WiimStore = (function () {
    /**
     * Properties of a WiimStore.
     * @memberof ScannerProtos
     * @interface IWiimStore
     * @property {Object.<string,ScannerProtos.IWiim>|null} [data] WiimStore data
     */

    /**
     * Constructs a new WiimStore.
     * @memberof ScannerProtos
     * @classdesc Represents a WiimStore.
     * @implements IWiimStore
     * @constructor
     * @param {ScannerProtos.IWiimStore=} [properties] Properties to set
     */
    function WiimStore(properties) {
      this.data = {};
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * WiimStore data.
     * @member {Object.<string,ScannerProtos.IWiim>} data
     * @memberof ScannerProtos.WiimStore
     * @instance
     */
    WiimStore.prototype.data = $util.emptyObject;

    /**
     * Creates a new WiimStore instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.WiimStore
     * @static
     * @param {ScannerProtos.IWiimStore=} [properties] Properties to set
     * @returns {ScannerProtos.WiimStore} WiimStore instance
     */
    WiimStore.create = function create(properties) {
      return new WiimStore(properties);
    };

    /**
     * Encodes the specified WiimStore message. Does not implicitly {@link ScannerProtos.WiimStore.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.WiimStore
     * @static
     * @param {ScannerProtos.IWiimStore} message WiimStore message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WiimStore.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.data != null && Object.hasOwnProperty.call(message, 'data'))
        for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i) {
          writer.uint32(/* id 10, wireType 2 =*/ 82).fork().uint32(/* id 1, wireType 2 =*/ 10).string(keys[i]);
          $root.ScannerProtos.Wiim.encode(message.data[keys[i]], writer.uint32(/* id 2, wireType 2 =*/ 18).fork())
            .ldelim()
            .ldelim();
        }
      return writer;
    };

    /**
     * Encodes the specified WiimStore message, length delimited. Does not implicitly {@link ScannerProtos.WiimStore.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.WiimStore
     * @static
     * @param {ScannerProtos.IWiimStore} message WiimStore message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WiimStore.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WiimStore message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.WiimStore
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.WiimStore} WiimStore
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WiimStore.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.WiimStore(),
        key,
        value;
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 10: {
            if (message.data === $util.emptyObject) message.data = {};
            let end2 = reader.uint32() + reader.pos;
            key = '';
            value = null;
            while (reader.pos < end2) {
              let tag2 = reader.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  key = reader.string();
                  break;
                case 2:
                  value = $root.ScannerProtos.Wiim.decode(reader, reader.uint32());
                  break;
                default:
                  reader.skipType(tag2 & 7);
                  break;
              }
            }
            message.data[key] = value;
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a WiimStore message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.WiimStore
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.WiimStore} WiimStore
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WiimStore.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WiimStore message.
     * @function verify
     * @memberof ScannerProtos.WiimStore
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WiimStore.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.data != null && message.hasOwnProperty('data')) {
        if (!$util.isObject(message.data)) return 'data: object expected';
        let key = Object.keys(message.data);
        for (let i = 0; i < key.length; ++i) {
          let error = $root.ScannerProtos.Wiim.verify(message.data[key[i]]);
          if (error) return 'data.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a WiimStore message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.WiimStore
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.WiimStore} WiimStore
     */
    WiimStore.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.WiimStore) return object;
      let message = new $root.ScannerProtos.WiimStore();
      if (object.data) {
        if (typeof object.data !== 'object') throw TypeError('.ScannerProtos.WiimStore.data: object expected');
        message.data = {};
        for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i) {
          if (typeof object.data[keys[i]] !== 'object')
            throw TypeError('.ScannerProtos.WiimStore.data: object expected');
          message.data[keys[i]] = $root.ScannerProtos.Wiim.fromObject(object.data[keys[i]]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a WiimStore message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.WiimStore
     * @static
     * @param {ScannerProtos.WiimStore} message WiimStore
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WiimStore.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.objects || options.defaults) object.data = {};
      let keys2;
      if (message.data && (keys2 = Object.keys(message.data)).length) {
        object.data = {};
        for (let j = 0; j < keys2.length; ++j)
          object.data[keys2[j]] = $root.ScannerProtos.Wiim.toObject(message.data[keys2[j]], options);
      }
      return object;
    };

    /**
     * Converts this WiimStore to JSON.
     * @function toJSON
     * @memberof ScannerProtos.WiimStore
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WiimStore.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WiimStore;
  })();

  ScannerProtos.QuoteNotifications = (function () {
    /**
     * Properties of a QuoteNotifications.
     * @memberof ScannerProtos
     * @interface IQuoteNotifications
     * @property {Array.<number>|null} [quoteFieldNumbers] QuoteNotifications quoteFieldNumbers
     * @property {string|null} [asOf] QuoteNotifications asOf
     */

    /**
     * Constructs a new QuoteNotifications.
     * @memberof ScannerProtos
     * @classdesc Represents a QuoteNotifications.
     * @implements IQuoteNotifications
     * @constructor
     * @param {ScannerProtos.IQuoteNotifications=} [properties] Properties to set
     */
    function QuoteNotifications(properties) {
      this.quoteFieldNumbers = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * QuoteNotifications quoteFieldNumbers.
     * @member {Array.<number>} quoteFieldNumbers
     * @memberof ScannerProtos.QuoteNotifications
     * @instance
     */
    QuoteNotifications.prototype.quoteFieldNumbers = $util.emptyArray;

    /**
     * QuoteNotifications asOf.
     * @member {string} asOf
     * @memberof ScannerProtos.QuoteNotifications
     * @instance
     */
    QuoteNotifications.prototype.asOf = '';

    /**
     * Creates a new QuoteNotifications instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.QuoteNotifications
     * @static
     * @param {ScannerProtos.IQuoteNotifications=} [properties] Properties to set
     * @returns {ScannerProtos.QuoteNotifications} QuoteNotifications instance
     */
    QuoteNotifications.create = function create(properties) {
      return new QuoteNotifications(properties);
    };

    /**
     * Encodes the specified QuoteNotifications message. Does not implicitly {@link ScannerProtos.QuoteNotifications.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.QuoteNotifications
     * @static
     * @param {ScannerProtos.IQuoteNotifications} message QuoteNotifications message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QuoteNotifications.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.quoteFieldNumbers != null && message.quoteFieldNumbers.length) {
        writer.uint32(/* id 10, wireType 2 =*/ 82).fork();
        for (let i = 0; i < message.quoteFieldNumbers.length; ++i) writer.int32(message.quoteFieldNumbers[i]);
        writer.ldelim();
      }
      if (message.asOf != null && Object.hasOwnProperty.call(message, 'asOf'))
        writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.asOf);
      return writer;
    };

    /**
     * Encodes the specified QuoteNotifications message, length delimited. Does not implicitly {@link ScannerProtos.QuoteNotifications.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.QuoteNotifications
     * @static
     * @param {ScannerProtos.IQuoteNotifications} message QuoteNotifications message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QuoteNotifications.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a QuoteNotifications message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.QuoteNotifications
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.QuoteNotifications} QuoteNotifications
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QuoteNotifications.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.QuoteNotifications();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 10: {
            if (!(message.quoteFieldNumbers && message.quoteFieldNumbers.length)) message.quoteFieldNumbers = [];
            if ((tag & 7) === 2) {
              let end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) message.quoteFieldNumbers.push(reader.int32());
            } else message.quoteFieldNumbers.push(reader.int32());
            break;
          }
          case 11: {
            message.asOf = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a QuoteNotifications message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.QuoteNotifications
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.QuoteNotifications} QuoteNotifications
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QuoteNotifications.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a QuoteNotifications message.
     * @function verify
     * @memberof ScannerProtos.QuoteNotifications
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    QuoteNotifications.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.quoteFieldNumbers != null && message.hasOwnProperty('quoteFieldNumbers')) {
        if (!Array.isArray(message.quoteFieldNumbers)) return 'quoteFieldNumbers: array expected';
        for (let i = 0; i < message.quoteFieldNumbers.length; ++i)
          if (!$util.isInteger(message.quoteFieldNumbers[i])) return 'quoteFieldNumbers: integer[] expected';
      }
      if (message.asOf != null && message.hasOwnProperty('asOf'))
        if (!$util.isString(message.asOf)) return 'asOf: string expected';
      return null;
    };

    /**
     * Creates a QuoteNotifications message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.QuoteNotifications
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.QuoteNotifications} QuoteNotifications
     */
    QuoteNotifications.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.QuoteNotifications) return object;
      let message = new $root.ScannerProtos.QuoteNotifications();
      if (object.quoteFieldNumbers) {
        if (!Array.isArray(object.quoteFieldNumbers))
          throw TypeError('.ScannerProtos.QuoteNotifications.quoteFieldNumbers: array expected');
        message.quoteFieldNumbers = [];
        for (let i = 0; i < object.quoteFieldNumbers.length; ++i)
          message.quoteFieldNumbers[i] = object.quoteFieldNumbers[i] | 0;
      }
      if (object.asOf != null) message.asOf = String(object.asOf);
      return message;
    };

    /**
     * Creates a plain object from a QuoteNotifications message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.QuoteNotifications
     * @static
     * @param {ScannerProtos.QuoteNotifications} message QuoteNotifications
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    QuoteNotifications.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.quoteFieldNumbers = [];
      if (options.defaults) object.asOf = '';
      if (message.quoteFieldNumbers && message.quoteFieldNumbers.length) {
        object.quoteFieldNumbers = [];
        for (let j = 0; j < message.quoteFieldNumbers.length; ++j)
          object.quoteFieldNumbers[j] = message.quoteFieldNumbers[j];
      }
      if (message.asOf != null && message.hasOwnProperty('asOf')) object.asOf = message.asOf;
      return object;
    };

    /**
     * Converts this QuoteNotifications to JSON.
     * @function toJSON
     * @memberof ScannerProtos.QuoteNotifications
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    QuoteNotifications.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return QuoteNotifications;
  })();

  ScannerProtos.RVolAverageData = (function () {
    /**
     * Properties of a RVolAverageData.
     * @memberof ScannerProtos
     * @interface IRVolAverageData
     * @property {Object.<string,number|Long>|null} [data] RVolAverageData data
     */

    /**
     * Constructs a new RVolAverageData.
     * @memberof ScannerProtos
     * @classdesc Represents a RVolAverageData.
     * @implements IRVolAverageData
     * @constructor
     * @param {ScannerProtos.IRVolAverageData=} [properties] Properties to set
     */
    function RVolAverageData(properties) {
      this.data = {};
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * RVolAverageData data.
     * @member {Object.<string,number|Long>} data
     * @memberof ScannerProtos.RVolAverageData
     * @instance
     */
    RVolAverageData.prototype.data = $util.emptyObject;

    /**
     * Creates a new RVolAverageData instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.RVolAverageData
     * @static
     * @param {ScannerProtos.IRVolAverageData=} [properties] Properties to set
     * @returns {ScannerProtos.RVolAverageData} RVolAverageData instance
     */
    RVolAverageData.create = function create(properties) {
      return new RVolAverageData(properties);
    };

    /**
     * Encodes the specified RVolAverageData message. Does not implicitly {@link ScannerProtos.RVolAverageData.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.RVolAverageData
     * @static
     * @param {ScannerProtos.IRVolAverageData} message RVolAverageData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RVolAverageData.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.data != null && Object.hasOwnProperty.call(message, 'data'))
        for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i)
          writer
            .uint32(/* id 10, wireType 2 =*/ 82)
            .fork()
            .uint32(/* id 1, wireType 2 =*/ 10)
            .string(keys[i])
            .uint32(/* id 2, wireType 0 =*/ 16)
            .int64(message.data[keys[i]])
            .ldelim();
      return writer;
    };

    /**
     * Encodes the specified RVolAverageData message, length delimited. Does not implicitly {@link ScannerProtos.RVolAverageData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.RVolAverageData
     * @static
     * @param {ScannerProtos.IRVolAverageData} message RVolAverageData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RVolAverageData.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RVolAverageData message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.RVolAverageData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.RVolAverageData} RVolAverageData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RVolAverageData.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.RVolAverageData(),
        key,
        value;
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 10: {
            if (message.data === $util.emptyObject) message.data = {};
            let end2 = reader.uint32() + reader.pos;
            key = '';
            value = 0;
            while (reader.pos < end2) {
              let tag2 = reader.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  key = reader.string();
                  break;
                case 2:
                  value = reader.int64();
                  break;
                default:
                  reader.skipType(tag2 & 7);
                  break;
              }
            }
            message.data[key] = value;
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a RVolAverageData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.RVolAverageData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.RVolAverageData} RVolAverageData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RVolAverageData.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RVolAverageData message.
     * @function verify
     * @memberof ScannerProtos.RVolAverageData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RVolAverageData.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.data != null && message.hasOwnProperty('data')) {
        if (!$util.isObject(message.data)) return 'data: object expected';
        let key = Object.keys(message.data);
        for (let i = 0; i < key.length; ++i)
          if (
            !$util.isInteger(message.data[key[i]]) &&
            !(
              message.data[key[i]] &&
              $util.isInteger(message.data[key[i]].low) &&
              $util.isInteger(message.data[key[i]].high)
            )
          )
            return 'data: integer|Long{k:string} expected';
      }
      return null;
    };

    /**
     * Creates a RVolAverageData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.RVolAverageData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.RVolAverageData} RVolAverageData
     */
    RVolAverageData.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.RVolAverageData) return object;
      let message = new $root.ScannerProtos.RVolAverageData();
      if (object.data) {
        if (typeof object.data !== 'object') throw TypeError('.ScannerProtos.RVolAverageData.data: object expected');
        message.data = {};
        for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i)
          if ($util.Long) (message.data[keys[i]] = $util.Long.fromValue(object.data[keys[i]])).unsigned = false;
          else if (typeof object.data[keys[i]] === 'string') message.data[keys[i]] = parseInt(object.data[keys[i]], 10);
          else if (typeof object.data[keys[i]] === 'number') message.data[keys[i]] = object.data[keys[i]];
          else if (typeof object.data[keys[i]] === 'object')
            message.data[keys[i]] = new $util.LongBits(
              object.data[keys[i]].low >>> 0,
              object.data[keys[i]].high >>> 0,
            ).toNumber();
      }
      return message;
    };

    /**
     * Creates a plain object from a RVolAverageData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.RVolAverageData
     * @static
     * @param {ScannerProtos.RVolAverageData} message RVolAverageData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RVolAverageData.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.objects || options.defaults) object.data = {};
      let keys2;
      if (message.data && (keys2 = Object.keys(message.data)).length) {
        object.data = {};
        for (let j = 0; j < keys2.length; ++j)
          if (typeof message.data[keys2[j]] === 'number')
            object.data[keys2[j]] = options.longs === String ? String(message.data[keys2[j]]) : message.data[keys2[j]];
          else
            object.data[keys2[j]] =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.data[keys2[j]])
                : options.longs === Number
                  ? new $util.LongBits(message.data[keys2[j]].low >>> 0, message.data[keys2[j]].high >>> 0).toNumber()
                  : message.data[keys2[j]];
      }
      return object;
    };

    /**
     * Converts this RVolAverageData to JSON.
     * @function toJSON
     * @memberof ScannerProtos.RVolAverageData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RVolAverageData.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return RVolAverageData;
  })();

  ScannerProtos.DataStore = (function () {
    /**
     * Properties of a DataStore.
     * @memberof ScannerProtos
     * @interface IDataStore
     * @property {Object.<string,LastProtos.IQuote>|null} [data] DataStore data
     */

    /**
     * Constructs a new DataStore.
     * @memberof ScannerProtos
     * @classdesc Represents a DataStore.
     * @implements IDataStore
     * @constructor
     * @param {ScannerProtos.IDataStore=} [properties] Properties to set
     */
    function DataStore(properties) {
      this.data = {};
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * DataStore data.
     * @member {Object.<string,LastProtos.IQuote>} data
     * @memberof ScannerProtos.DataStore
     * @instance
     */
    DataStore.prototype.data = $util.emptyObject;

    /**
     * Creates a new DataStore instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.DataStore
     * @static
     * @param {ScannerProtos.IDataStore=} [properties] Properties to set
     * @returns {ScannerProtos.DataStore} DataStore instance
     */
    DataStore.create = function create(properties) {
      return new DataStore(properties);
    };

    /**
     * Encodes the specified DataStore message. Does not implicitly {@link ScannerProtos.DataStore.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.DataStore
     * @static
     * @param {ScannerProtos.IDataStore} message DataStore message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DataStore.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.data != null && Object.hasOwnProperty.call(message, 'data'))
        for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i) {
          writer.uint32(/* id 10, wireType 2 =*/ 82).fork().uint32(/* id 1, wireType 2 =*/ 10).string(keys[i]);
          $root.LastProtos.Quote.encode(message.data[keys[i]], writer.uint32(/* id 2, wireType 2 =*/ 18).fork())
            .ldelim()
            .ldelim();
        }
      return writer;
    };

    /**
     * Encodes the specified DataStore message, length delimited. Does not implicitly {@link ScannerProtos.DataStore.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.DataStore
     * @static
     * @param {ScannerProtos.IDataStore} message DataStore message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DataStore.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DataStore message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.DataStore
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.DataStore} DataStore
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DataStore.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.DataStore(),
        key,
        value;
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 10: {
            if (message.data === $util.emptyObject) message.data = {};
            let end2 = reader.uint32() + reader.pos;
            key = '';
            value = null;
            while (reader.pos < end2) {
              let tag2 = reader.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  key = reader.string();
                  break;
                case 2:
                  value = $root.LastProtos.Quote.decode(reader, reader.uint32());
                  break;
                default:
                  reader.skipType(tag2 & 7);
                  break;
              }
            }
            message.data[key] = value;
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a DataStore message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.DataStore
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.DataStore} DataStore
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DataStore.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DataStore message.
     * @function verify
     * @memberof ScannerProtos.DataStore
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DataStore.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.data != null && message.hasOwnProperty('data')) {
        if (!$util.isObject(message.data)) return 'data: object expected';
        let key = Object.keys(message.data);
        for (let i = 0; i < key.length; ++i) {
          let error = $root.LastProtos.Quote.verify(message.data[key[i]]);
          if (error) return 'data.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a DataStore message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.DataStore
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.DataStore} DataStore
     */
    DataStore.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.DataStore) return object;
      let message = new $root.ScannerProtos.DataStore();
      if (object.data) {
        if (typeof object.data !== 'object') throw TypeError('.ScannerProtos.DataStore.data: object expected');
        message.data = {};
        for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i) {
          if (typeof object.data[keys[i]] !== 'object')
            throw TypeError('.ScannerProtos.DataStore.data: object expected');
          message.data[keys[i]] = $root.LastProtos.Quote.fromObject(object.data[keys[i]]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a DataStore message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.DataStore
     * @static
     * @param {ScannerProtos.DataStore} message DataStore
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DataStore.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.objects || options.defaults) object.data = {};
      let keys2;
      if (message.data && (keys2 = Object.keys(message.data)).length) {
        object.data = {};
        for (let j = 0; j < keys2.length; ++j)
          object.data[keys2[j]] = $root.LastProtos.Quote.toObject(message.data[keys2[j]], options);
      }
      return object;
    };

    /**
     * Converts this DataStore to JSON.
     * @function toJSON
     * @memberof ScannerProtos.DataStore
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DataStore.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DataStore;
  })();

  ScannerProtos.ContentStore = (function () {
    /**
     * Properties of a ContentStore.
     * @memberof ScannerProtos
     * @interface IContentStore
     * @property {Object.<string,ScannerProtos.IContent>|null} [data] ContentStore data
     */

    /**
     * Constructs a new ContentStore.
     * @memberof ScannerProtos
     * @classdesc Represents a ContentStore.
     * @implements IContentStore
     * @constructor
     * @param {ScannerProtos.IContentStore=} [properties] Properties to set
     */
    function ContentStore(properties) {
      this.data = {};
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * ContentStore data.
     * @member {Object.<string,ScannerProtos.IContent>} data
     * @memberof ScannerProtos.ContentStore
     * @instance
     */
    ContentStore.prototype.data = $util.emptyObject;

    /**
     * Creates a new ContentStore instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.ContentStore
     * @static
     * @param {ScannerProtos.IContentStore=} [properties] Properties to set
     * @returns {ScannerProtos.ContentStore} ContentStore instance
     */
    ContentStore.create = function create(properties) {
      return new ContentStore(properties);
    };

    /**
     * Encodes the specified ContentStore message. Does not implicitly {@link ScannerProtos.ContentStore.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.ContentStore
     * @static
     * @param {ScannerProtos.IContentStore} message ContentStore message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContentStore.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.data != null && Object.hasOwnProperty.call(message, 'data'))
        for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i) {
          writer.uint32(/* id 10, wireType 2 =*/ 82).fork().uint32(/* id 1, wireType 2 =*/ 10).string(keys[i]);
          $root.ScannerProtos.Content.encode(message.data[keys[i]], writer.uint32(/* id 2, wireType 2 =*/ 18).fork())
            .ldelim()
            .ldelim();
        }
      return writer;
    };

    /**
     * Encodes the specified ContentStore message, length delimited. Does not implicitly {@link ScannerProtos.ContentStore.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.ContentStore
     * @static
     * @param {ScannerProtos.IContentStore} message ContentStore message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContentStore.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ContentStore message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.ContentStore
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.ContentStore} ContentStore
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContentStore.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.ContentStore(),
        key,
        value;
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 10: {
            if (message.data === $util.emptyObject) message.data = {};
            let end2 = reader.uint32() + reader.pos;
            key = '';
            value = null;
            while (reader.pos < end2) {
              let tag2 = reader.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  key = reader.string();
                  break;
                case 2:
                  value = $root.ScannerProtos.Content.decode(reader, reader.uint32());
                  break;
                default:
                  reader.skipType(tag2 & 7);
                  break;
              }
            }
            message.data[key] = value;
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a ContentStore message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.ContentStore
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.ContentStore} ContentStore
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContentStore.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ContentStore message.
     * @function verify
     * @memberof ScannerProtos.ContentStore
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ContentStore.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.data != null && message.hasOwnProperty('data')) {
        if (!$util.isObject(message.data)) return 'data: object expected';
        let key = Object.keys(message.data);
        for (let i = 0; i < key.length; ++i) {
          let error = $root.ScannerProtos.Content.verify(message.data[key[i]]);
          if (error) return 'data.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a ContentStore message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.ContentStore
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.ContentStore} ContentStore
     */
    ContentStore.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.ContentStore) return object;
      let message = new $root.ScannerProtos.ContentStore();
      if (object.data) {
        if (typeof object.data !== 'object') throw TypeError('.ScannerProtos.ContentStore.data: object expected');
        message.data = {};
        for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i) {
          if (typeof object.data[keys[i]] !== 'object')
            throw TypeError('.ScannerProtos.ContentStore.data: object expected');
          message.data[keys[i]] = $root.ScannerProtos.Content.fromObject(object.data[keys[i]]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a ContentStore message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.ContentStore
     * @static
     * @param {ScannerProtos.ContentStore} message ContentStore
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ContentStore.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.objects || options.defaults) object.data = {};
      let keys2;
      if (message.data && (keys2 = Object.keys(message.data)).length) {
        object.data = {};
        for (let j = 0; j < keys2.length; ++j)
          object.data[keys2[j]] = $root.ScannerProtos.Content.toObject(message.data[keys2[j]], options);
      }
      return object;
    };

    /**
     * Converts this ContentStore to JSON.
     * @function toJSON
     * @memberof ScannerProtos.ContentStore
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ContentStore.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ContentStore;
  })();

  ScannerProtos.Content = (function () {
    /**
     * Properties of a Content.
     * @memberof ScannerProtos
     * @interface IContent
     * @property {string|null} [id] Content id
     * @property {string|null} [nodeId] Content nodeId
     * @property {string|null} [title] Content title
     * @property {string|null} [asOf] Content asOf
     * @property {Array.<string>|null} [tickers] Content tickers
     */

    /**
     * Constructs a new Content.
     * @memberof ScannerProtos
     * @classdesc Represents a Content.
     * @implements IContent
     * @constructor
     * @param {ScannerProtos.IContent=} [properties] Properties to set
     */
    function Content(properties) {
      this.tickers = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Content id.
     * @member {string} id
     * @memberof ScannerProtos.Content
     * @instance
     */
    Content.prototype.id = '';

    /**
     * Content nodeId.
     * @member {string} nodeId
     * @memberof ScannerProtos.Content
     * @instance
     */
    Content.prototype.nodeId = '';

    /**
     * Content title.
     * @member {string} title
     * @memberof ScannerProtos.Content
     * @instance
     */
    Content.prototype.title = '';

    /**
     * Content asOf.
     * @member {string} asOf
     * @memberof ScannerProtos.Content
     * @instance
     */
    Content.prototype.asOf = '';

    /**
     * Content tickers.
     * @member {Array.<string>} tickers
     * @memberof ScannerProtos.Content
     * @instance
     */
    Content.prototype.tickers = $util.emptyArray;

    /**
     * Creates a new Content instance using the specified properties.
     * @function create
     * @memberof ScannerProtos.Content
     * @static
     * @param {ScannerProtos.IContent=} [properties] Properties to set
     * @returns {ScannerProtos.Content} Content instance
     */
    Content.create = function create(properties) {
      return new Content(properties);
    };

    /**
     * Encodes the specified Content message. Does not implicitly {@link ScannerProtos.Content.verify|verify} messages.
     * @function encode
     * @memberof ScannerProtos.Content
     * @static
     * @param {ScannerProtos.IContent} message Content message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Content.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.id != null && Object.hasOwnProperty.call(message, 'id'))
        writer.uint32(/* id 10, wireType 2 =*/ 82).string(message.id);
      if (message.nodeId != null && Object.hasOwnProperty.call(message, 'nodeId'))
        writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.nodeId);
      if (message.title != null && Object.hasOwnProperty.call(message, 'title'))
        writer.uint32(/* id 13, wireType 2 =*/ 106).string(message.title);
      if (message.asOf != null && Object.hasOwnProperty.call(message, 'asOf'))
        writer.uint32(/* id 14, wireType 2 =*/ 114).string(message.asOf);
      if (message.tickers != null && message.tickers.length)
        for (let i = 0; i < message.tickers.length; ++i)
          writer.uint32(/* id 15, wireType 2 =*/ 122).string(message.tickers[i]);
      return writer;
    };

    /**
     * Encodes the specified Content message, length delimited. Does not implicitly {@link ScannerProtos.Content.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScannerProtos.Content
     * @static
     * @param {ScannerProtos.IContent} message Content message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Content.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Content message from the specified reader or buffer.
     * @function decode
     * @memberof ScannerProtos.Content
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScannerProtos.Content} Content
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Content.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.ScannerProtos.Content();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 10: {
            message.id = reader.string();
            break;
          }
          case 11: {
            message.nodeId = reader.string();
            break;
          }
          case 13: {
            message.title = reader.string();
            break;
          }
          case 14: {
            message.asOf = reader.string();
            break;
          }
          case 15: {
            if (!(message.tickers && message.tickers.length)) message.tickers = [];
            message.tickers.push(reader.string());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Content message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScannerProtos.Content
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScannerProtos.Content} Content
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Content.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Content message.
     * @function verify
     * @memberof ScannerProtos.Content
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Content.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.id != null && message.hasOwnProperty('id'))
        if (!$util.isString(message.id)) return 'id: string expected';
      if (message.nodeId != null && message.hasOwnProperty('nodeId'))
        if (!$util.isString(message.nodeId)) return 'nodeId: string expected';
      if (message.title != null && message.hasOwnProperty('title'))
        if (!$util.isString(message.title)) return 'title: string expected';
      if (message.asOf != null && message.hasOwnProperty('asOf'))
        if (!$util.isString(message.asOf)) return 'asOf: string expected';
      if (message.tickers != null && message.hasOwnProperty('tickers')) {
        if (!Array.isArray(message.tickers)) return 'tickers: array expected';
        for (let i = 0; i < message.tickers.length; ++i)
          if (!$util.isString(message.tickers[i])) return 'tickers: string[] expected';
      }
      return null;
    };

    /**
     * Creates a Content message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScannerProtos.Content
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScannerProtos.Content} Content
     */
    Content.fromObject = function fromObject(object) {
      if (object instanceof $root.ScannerProtos.Content) return object;
      let message = new $root.ScannerProtos.Content();
      if (object.id != null) message.id = String(object.id);
      if (object.nodeId != null) message.nodeId = String(object.nodeId);
      if (object.title != null) message.title = String(object.title);
      if (object.asOf != null) message.asOf = String(object.asOf);
      if (object.tickers) {
        if (!Array.isArray(object.tickers)) throw TypeError('.ScannerProtos.Content.tickers: array expected');
        message.tickers = [];
        for (let i = 0; i < object.tickers.length; ++i) message.tickers[i] = String(object.tickers[i]);
      }
      return message;
    };

    /**
     * Creates a plain object from a Content message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScannerProtos.Content
     * @static
     * @param {ScannerProtos.Content} message Content
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Content.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.tickers = [];
      if (options.defaults) {
        object.id = '';
        object.nodeId = '';
        object.title = '';
        object.asOf = '';
      }
      if (message.id != null && message.hasOwnProperty('id')) object.id = message.id;
      if (message.nodeId != null && message.hasOwnProperty('nodeId')) object.nodeId = message.nodeId;
      if (message.title != null && message.hasOwnProperty('title')) object.title = message.title;
      if (message.asOf != null && message.hasOwnProperty('asOf')) object.asOf = message.asOf;
      if (message.tickers && message.tickers.length) {
        object.tickers = [];
        for (let j = 0; j < message.tickers.length; ++j) object.tickers[j] = message.tickers[j];
      }
      return object;
    };

    /**
     * Converts this Content to JSON.
     * @function toJSON
     * @memberof ScannerProtos.Content
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Content.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Content;
  })();

  return ScannerProtos;
})());

export const LastProtos = ($root.LastProtos = (() => {
  /**
   * Namespace LastProtos.
   * @exports LastProtos
   * @namespace
   */
  const LastProtos = {};

  LastProtos.Heartbeat = (function () {
    /**
     * Properties of a Heartbeat.
     * @memberof LastProtos
     * @interface IHeartbeat
     * @property {number|null} [time] Heartbeat time
     */

    /**
     * Constructs a new Heartbeat.
     * @memberof LastProtos
     * @classdesc Represents a Heartbeat.
     * @implements IHeartbeat
     * @constructor
     * @param {LastProtos.IHeartbeat=} [properties] Properties to set
     */
    function Heartbeat(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Heartbeat time.
     * @member {number} time
     * @memberof LastProtos.Heartbeat
     * @instance
     */
    Heartbeat.prototype.time = 0;

    /**
     * Creates a new Heartbeat instance using the specified properties.
     * @function create
     * @memberof LastProtos.Heartbeat
     * @static
     * @param {LastProtos.IHeartbeat=} [properties] Properties to set
     * @returns {LastProtos.Heartbeat} Heartbeat instance
     */
    Heartbeat.create = function create(properties) {
      return new Heartbeat(properties);
    };

    /**
     * Encodes the specified Heartbeat message. Does not implicitly {@link LastProtos.Heartbeat.verify|verify} messages.
     * @function encode
     * @memberof LastProtos.Heartbeat
     * @static
     * @param {LastProtos.IHeartbeat} message Heartbeat message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Heartbeat.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.time != null && Object.hasOwnProperty.call(message, 'time'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.time);
      return writer;
    };

    /**
     * Encodes the specified Heartbeat message, length delimited. Does not implicitly {@link LastProtos.Heartbeat.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LastProtos.Heartbeat
     * @static
     * @param {LastProtos.IHeartbeat} message Heartbeat message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Heartbeat.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Heartbeat message from the specified reader or buffer.
     * @function decode
     * @memberof LastProtos.Heartbeat
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LastProtos.Heartbeat} Heartbeat
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Heartbeat.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.LastProtos.Heartbeat();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.time = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Heartbeat message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LastProtos.Heartbeat
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LastProtos.Heartbeat} Heartbeat
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Heartbeat.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Heartbeat message.
     * @function verify
     * @memberof LastProtos.Heartbeat
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Heartbeat.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.time != null && message.hasOwnProperty('time'))
        if (!$util.isInteger(message.time)) return 'time: integer expected';
      return null;
    };

    /**
     * Creates a Heartbeat message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LastProtos.Heartbeat
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LastProtos.Heartbeat} Heartbeat
     */
    Heartbeat.fromObject = function fromObject(object) {
      if (object instanceof $root.LastProtos.Heartbeat) return object;
      let message = new $root.LastProtos.Heartbeat();
      if (object.time != null) message.time = object.time | 0;
      return message;
    };

    /**
     * Creates a plain object from a Heartbeat message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LastProtos.Heartbeat
     * @static
     * @param {LastProtos.Heartbeat} message Heartbeat
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Heartbeat.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.time = 0;
      if (message.time != null && message.hasOwnProperty('time')) object.time = message.time;
      return object;
    };

    /**
     * Converts this Heartbeat to JSON.
     * @function toJSON
     * @memberof LastProtos.Heartbeat
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Heartbeat.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Heartbeat;
  })();

  LastProtos.QuotesResponse = (function () {
    /**
     * Properties of a QuotesResponse.
     * @memberof LastProtos
     * @interface IQuotesResponse
     * @property {Array.<LastProtos.ILastQuote>|null} [quotes] QuotesResponse quotes
     * @property {number|null} [processTimeMillis] QuotesResponse processTimeMillis
     */

    /**
     * Constructs a new QuotesResponse.
     * @memberof LastProtos
     * @classdesc Represents a QuotesResponse.
     * @implements IQuotesResponse
     * @constructor
     * @param {LastProtos.IQuotesResponse=} [properties] Properties to set
     */
    function QuotesResponse(properties) {
      this.quotes = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * QuotesResponse quotes.
     * @member {Array.<LastProtos.ILastQuote>} quotes
     * @memberof LastProtos.QuotesResponse
     * @instance
     */
    QuotesResponse.prototype.quotes = $util.emptyArray;

    /**
     * QuotesResponse processTimeMillis.
     * @member {number} processTimeMillis
     * @memberof LastProtos.QuotesResponse
     * @instance
     */
    QuotesResponse.prototype.processTimeMillis = 0;

    /**
     * Creates a new QuotesResponse instance using the specified properties.
     * @function create
     * @memberof LastProtos.QuotesResponse
     * @static
     * @param {LastProtos.IQuotesResponse=} [properties] Properties to set
     * @returns {LastProtos.QuotesResponse} QuotesResponse instance
     */
    QuotesResponse.create = function create(properties) {
      return new QuotesResponse(properties);
    };

    /**
     * Encodes the specified QuotesResponse message. Does not implicitly {@link LastProtos.QuotesResponse.verify|verify} messages.
     * @function encode
     * @memberof LastProtos.QuotesResponse
     * @static
     * @param {LastProtos.IQuotesResponse} message QuotesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QuotesResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.quotes != null && message.quotes.length)
        for (let i = 0; i < message.quotes.length; ++i)
          $root.LastProtos.LastQuote.encode(
            message.quotes[i],
            writer.uint32(/* id 1, wireType 2 =*/ 10).fork(),
          ).ldelim();
      if (message.processTimeMillis != null && Object.hasOwnProperty.call(message, 'processTimeMillis'))
        writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.processTimeMillis);
      return writer;
    };

    /**
     * Encodes the specified QuotesResponse message, length delimited. Does not implicitly {@link LastProtos.QuotesResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LastProtos.QuotesResponse
     * @static
     * @param {LastProtos.IQuotesResponse} message QuotesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QuotesResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a QuotesResponse message from the specified reader or buffer.
     * @function decode
     * @memberof LastProtos.QuotesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LastProtos.QuotesResponse} QuotesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QuotesResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.LastProtos.QuotesResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (!(message.quotes && message.quotes.length)) message.quotes = [];
            message.quotes.push($root.LastProtos.LastQuote.decode(reader, reader.uint32()));
            break;
          }
          case 2: {
            message.processTimeMillis = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a QuotesResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LastProtos.QuotesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LastProtos.QuotesResponse} QuotesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QuotesResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a QuotesResponse message.
     * @function verify
     * @memberof LastProtos.QuotesResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    QuotesResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.quotes != null && message.hasOwnProperty('quotes')) {
        if (!Array.isArray(message.quotes)) return 'quotes: array expected';
        for (let i = 0; i < message.quotes.length; ++i) {
          let error = $root.LastProtos.LastQuote.verify(message.quotes[i]);
          if (error) return 'quotes.' + error;
        }
      }
      if (message.processTimeMillis != null && message.hasOwnProperty('processTimeMillis'))
        if (!$util.isInteger(message.processTimeMillis)) return 'processTimeMillis: integer expected';
      return null;
    };

    /**
     * Creates a QuotesResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LastProtos.QuotesResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LastProtos.QuotesResponse} QuotesResponse
     */
    QuotesResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.LastProtos.QuotesResponse) return object;
      let message = new $root.LastProtos.QuotesResponse();
      if (object.quotes) {
        if (!Array.isArray(object.quotes)) throw TypeError('.LastProtos.QuotesResponse.quotes: array expected');
        message.quotes = [];
        for (let i = 0; i < object.quotes.length; ++i) {
          if (typeof object.quotes[i] !== 'object')
            throw TypeError('.LastProtos.QuotesResponse.quotes: object expected');
          message.quotes[i] = $root.LastProtos.LastQuote.fromObject(object.quotes[i]);
        }
      }
      if (object.processTimeMillis != null) message.processTimeMillis = object.processTimeMillis | 0;
      return message;
    };

    /**
     * Creates a plain object from a QuotesResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LastProtos.QuotesResponse
     * @static
     * @param {LastProtos.QuotesResponse} message QuotesResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    QuotesResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.quotes = [];
      if (options.defaults) object.processTimeMillis = 0;
      if (message.quotes && message.quotes.length) {
        object.quotes = [];
        for (let j = 0; j < message.quotes.length; ++j)
          object.quotes[j] = $root.LastProtos.LastQuote.toObject(message.quotes[j], options);
      }
      if (message.processTimeMillis != null && message.hasOwnProperty('processTimeMillis'))
        object.processTimeMillis = message.processTimeMillis;
      return object;
    };

    /**
     * Converts this QuotesResponse to JSON.
     * @function toJSON
     * @memberof LastProtos.QuotesResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    QuotesResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return QuotesResponse;
  })();

  /**
   * SessionType enum.
   * @name LastProtos.SessionType
   * @enum {number}
   * @property {number} NA=0 NA value
   * @property {number} PRE_MARKET=1 PRE_MARKET value
   * @property {number} REGULAR=2 REGULAR value
   * @property {number} AFTER_MARKET=3 AFTER_MARKET value
   */
  LastProtos.SessionType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'NA')] = 0;
    values[(valuesById[1] = 'PRE_MARKET')] = 1;
    values[(valuesById[2] = 'REGULAR')] = 2;
    values[(valuesById[3] = 'AFTER_MARKET')] = 3;
    return values;
  })();

  LastProtos.LastQuote = (function () {
    /**
     * Properties of a LastQuote.
     * @memberof LastProtos
     * @interface ILastQuote
     * @property {string|null} [symbol] LastQuote symbol
     * @property {string|null} [currency] LastQuote currency
     * @property {number|null} [delayedMinutes] LastQuote delayedMinutes
     * @property {LastProtos.SessionType|null} [sessionType] LastQuote sessionType
     * @property {LastProtos.IError|null} [error] LastQuote error
     * @property {string|null} [name] LastQuote name
     * @property {string|null} [type] LastQuote type
     * @property {string|null} [exchange] LastQuote exchange
     * @property {number|null} [open] LastQuote open
     * @property {number|null} [dayHigh] LastQuote dayHigh
     * @property {number|null} [dayLow] LastQuote dayLow
     * @property {number|null} [close] LastQuote close
     * @property {number|null} [volume] LastQuote volume
     * @property {number|null} [vwap] LastQuote vwap
     * @property {string|null} [closeDate] LastQuote closeDate
     * @property {number|null} [bidPrice] LastQuote bidPrice
     * @property {number|null} [askPrice] LastQuote askPrice
     * @property {number|null} [lastTradePrice] LastQuote lastTradePrice
     * @property {number|Long|null} [lastTradeTime] LastQuote lastTradeTime
     * @property {number|null} [previousClose] LastQuote previousClose
     * @property {number|null} [change] LastQuote change
     * @property {number|null} [percentChange] LastQuote percentChange
     * @property {number|null} [fiftyTwoWeekHigh] LastQuote fiftyTwoWeekHigh
     * @property {number|null} [fiftyTwoWeekLow] LastQuote fiftyTwoWeekLow
     * @property {number|null} [preMarketPrice] LastQuote preMarketPrice
     * @property {number|Long|null} [preMarketVolume] LastQuote preMarketVolume
     * @property {number|null} [afterMarketPrice] LastQuote afterMarketPrice
     * @property {number|Long|null} [afterMarketVolume] LastQuote afterMarketVolume
     * @property {number|null} [preMarketOpen] LastQuote preMarketOpen
     * @property {number|Long|null} [preMarketOpenTime] LastQuote preMarketOpenTime
     * @property {number|null} [version] LastQuote version
     * @property {number|Long|null} [tradeCount] LastQuote tradeCount
     * @property {number|Long|null} [regularHighCount] LastQuote regularHighCount
     * @property {number|Long|null} [regularLowCount] LastQuote regularLowCount
     * @property {number|Long|null} [preMarketHighCount] LastQuote preMarketHighCount
     * @property {number|Long|null} [preMarketLowCount] LastQuote preMarketLowCount
     * @property {number|Long|null} [afterMarketHighCount] LastQuote afterMarketHighCount
     * @property {number|Long|null} [afterMarketLowCount] LastQuote afterMarketLowCount
     * @property {number|Long|null} [dayHighCount] LastQuote dayHighCount
     * @property {number|Long|null} [dayLowCount] LastQuote dayLowCount
     * @property {number|null} [high] LastQuote high
     * @property {number|null} [low] LastQuote low
     * @property {number|null} [preMarketHigh] LastQuote preMarketHigh
     * @property {number|null} [preMarketLow] LastQuote preMarketLow
     * @property {number|null} [afterMarketHigh] LastQuote afterMarketHigh
     * @property {number|null} [afterMarketLow] LastQuote afterMarketLow
     * @property {number|null} [regularHigh] LastQuote regularHigh
     * @property {number|null} [regularLow] LastQuote regularLow
     */

    /**
     * Constructs a new LastQuote.
     * @memberof LastProtos
     * @classdesc Represents a LastQuote.
     * @implements ILastQuote
     * @constructor
     * @param {LastProtos.ILastQuote=} [properties] Properties to set
     */
    function LastQuote(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * LastQuote symbol.
     * @member {string} symbol
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.symbol = '';

    /**
     * LastQuote currency.
     * @member {string} currency
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.currency = '';

    /**
     * LastQuote delayedMinutes.
     * @member {number} delayedMinutes
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.delayedMinutes = 0;

    /**
     * LastQuote sessionType.
     * @member {LastProtos.SessionType} sessionType
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.sessionType = 0;

    /**
     * LastQuote error.
     * @member {LastProtos.IError|null|undefined} error
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.error = null;

    /**
     * LastQuote name.
     * @member {string} name
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.name = '';

    /**
     * LastQuote type.
     * @member {string} type
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.type = '';

    /**
     * LastQuote exchange.
     * @member {string} exchange
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.exchange = '';

    /**
     * LastQuote open.
     * @member {number} open
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.open = 0;

    /**
     * LastQuote dayHigh.
     * @member {number} dayHigh
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.dayHigh = 0;

    /**
     * LastQuote dayLow.
     * @member {number} dayLow
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.dayLow = 0;

    /**
     * LastQuote close.
     * @member {number} close
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.close = 0;

    /**
     * LastQuote volume.
     * @member {number} volume
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.volume = 0;

    /**
     * LastQuote vwap.
     * @member {number} vwap
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.vwap = 0;

    /**
     * LastQuote closeDate.
     * @member {string} closeDate
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.closeDate = '';

    /**
     * LastQuote bidPrice.
     * @member {number} bidPrice
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.bidPrice = 0;

    /**
     * LastQuote askPrice.
     * @member {number} askPrice
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.askPrice = 0;

    /**
     * LastQuote lastTradePrice.
     * @member {number} lastTradePrice
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.lastTradePrice = 0;

    /**
     * LastQuote lastTradeTime.
     * @member {number|Long} lastTradeTime
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.lastTradeTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote previousClose.
     * @member {number} previousClose
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.previousClose = 0;

    /**
     * LastQuote change.
     * @member {number} change
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.change = 0;

    /**
     * LastQuote percentChange.
     * @member {number} percentChange
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.percentChange = 0;

    /**
     * LastQuote fiftyTwoWeekHigh.
     * @member {number} fiftyTwoWeekHigh
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.fiftyTwoWeekHigh = 0;

    /**
     * LastQuote fiftyTwoWeekLow.
     * @member {number} fiftyTwoWeekLow
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.fiftyTwoWeekLow = 0;

    /**
     * LastQuote preMarketPrice.
     * @member {number} preMarketPrice
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.preMarketPrice = 0;

    /**
     * LastQuote preMarketVolume.
     * @member {number|Long} preMarketVolume
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.preMarketVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote afterMarketPrice.
     * @member {number} afterMarketPrice
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.afterMarketPrice = 0;

    /**
     * LastQuote afterMarketVolume.
     * @member {number|Long} afterMarketVolume
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.afterMarketVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote preMarketOpen.
     * @member {number} preMarketOpen
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.preMarketOpen = 0;

    /**
     * LastQuote preMarketOpenTime.
     * @member {number|Long} preMarketOpenTime
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.preMarketOpenTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote version.
     * @member {number} version
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.version = 0;

    /**
     * LastQuote tradeCount.
     * @member {number|Long} tradeCount
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.tradeCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote regularHighCount.
     * @member {number|Long} regularHighCount
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.regularHighCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote regularLowCount.
     * @member {number|Long} regularLowCount
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.regularLowCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote preMarketHighCount.
     * @member {number|Long} preMarketHighCount
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.preMarketHighCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote preMarketLowCount.
     * @member {number|Long} preMarketLowCount
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.preMarketLowCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote afterMarketHighCount.
     * @member {number|Long} afterMarketHighCount
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.afterMarketHighCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote afterMarketLowCount.
     * @member {number|Long} afterMarketLowCount
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.afterMarketLowCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote dayHighCount.
     * @member {number|Long} dayHighCount
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.dayHighCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote dayLowCount.
     * @member {number|Long} dayLowCount
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.dayLowCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * LastQuote high.
     * @member {number} high
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.high = 0;

    /**
     * LastQuote low.
     * @member {number} low
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.low = 0;

    /**
     * LastQuote preMarketHigh.
     * @member {number} preMarketHigh
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.preMarketHigh = 0;

    /**
     * LastQuote preMarketLow.
     * @member {number} preMarketLow
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.preMarketLow = 0;

    /**
     * LastQuote afterMarketHigh.
     * @member {number} afterMarketHigh
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.afterMarketHigh = 0;

    /**
     * LastQuote afterMarketLow.
     * @member {number} afterMarketLow
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.afterMarketLow = 0;

    /**
     * LastQuote regularHigh.
     * @member {number} regularHigh
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.regularHigh = 0;

    /**
     * LastQuote regularLow.
     * @member {number} regularLow
     * @memberof LastProtos.LastQuote
     * @instance
     */
    LastQuote.prototype.regularLow = 0;

    /**
     * Creates a new LastQuote instance using the specified properties.
     * @function create
     * @memberof LastProtos.LastQuote
     * @static
     * @param {LastProtos.ILastQuote=} [properties] Properties to set
     * @returns {LastProtos.LastQuote} LastQuote instance
     */
    LastQuote.create = function create(properties) {
      return new LastQuote(properties);
    };

    /**
     * Encodes the specified LastQuote message. Does not implicitly {@link LastProtos.LastQuote.verify|verify} messages.
     * @function encode
     * @memberof LastProtos.LastQuote
     * @static
     * @param {LastProtos.ILastQuote} message LastQuote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LastQuote.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
      if (message.currency != null && Object.hasOwnProperty.call(message, 'currency'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.currency);
      if (message.delayedMinutes != null && Object.hasOwnProperty.call(message, 'delayedMinutes'))
        writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.delayedMinutes);
      if (message.sessionType != null && Object.hasOwnProperty.call(message, 'sessionType'))
        writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.sessionType);
      if (message.error != null && Object.hasOwnProperty.call(message, 'error'))
        $root.LastProtos.Error.encode(message.error, writer.uint32(/* id 5, wireType 2 =*/ 42).fork()).ldelim();
      if (message.name != null && Object.hasOwnProperty.call(message, 'name'))
        writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.name);
      if (message.type != null && Object.hasOwnProperty.call(message, 'type'))
        writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.type);
      if (message.exchange != null && Object.hasOwnProperty.call(message, 'exchange'))
        writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.exchange);
      if (message.bidPrice != null && Object.hasOwnProperty.call(message, 'bidPrice'))
        writer.uint32(/* id 10, wireType 1 =*/ 81).double(message.bidPrice);
      if (message.askPrice != null && Object.hasOwnProperty.call(message, 'askPrice'))
        writer.uint32(/* id 11, wireType 1 =*/ 89).double(message.askPrice);
      if (message.lastTradePrice != null && Object.hasOwnProperty.call(message, 'lastTradePrice'))
        writer.uint32(/* id 20, wireType 1 =*/ 161).double(message.lastTradePrice);
      if (message.lastTradeTime != null && Object.hasOwnProperty.call(message, 'lastTradeTime'))
        writer.uint32(/* id 21, wireType 0 =*/ 168).int64(message.lastTradeTime);
      if (message.previousClose != null && Object.hasOwnProperty.call(message, 'previousClose'))
        writer.uint32(/* id 22, wireType 1 =*/ 177).double(message.previousClose);
      if (message.change != null && Object.hasOwnProperty.call(message, 'change'))
        writer.uint32(/* id 23, wireType 1 =*/ 185).double(message.change);
      if (message.percentChange != null && Object.hasOwnProperty.call(message, 'percentChange'))
        writer.uint32(/* id 24, wireType 1 =*/ 193).double(message.percentChange);
      if (message.fiftyTwoWeekHigh != null && Object.hasOwnProperty.call(message, 'fiftyTwoWeekHigh'))
        writer.uint32(/* id 30, wireType 1 =*/ 241).double(message.fiftyTwoWeekHigh);
      if (message.fiftyTwoWeekLow != null && Object.hasOwnProperty.call(message, 'fiftyTwoWeekLow'))
        writer.uint32(/* id 31, wireType 1 =*/ 249).double(message.fiftyTwoWeekLow);
      if (message.preMarketPrice != null && Object.hasOwnProperty.call(message, 'preMarketPrice'))
        writer.uint32(/* id 40, wireType 1 =*/ 321).double(message.preMarketPrice);
      if (message.preMarketVolume != null && Object.hasOwnProperty.call(message, 'preMarketVolume'))
        writer.uint32(/* id 41, wireType 0 =*/ 328).int64(message.preMarketVolume);
      if (message.afterMarketPrice != null && Object.hasOwnProperty.call(message, 'afterMarketPrice'))
        writer.uint32(/* id 42, wireType 1 =*/ 337).double(message.afterMarketPrice);
      if (message.afterMarketVolume != null && Object.hasOwnProperty.call(message, 'afterMarketVolume'))
        writer.uint32(/* id 43, wireType 0 =*/ 344).int64(message.afterMarketVolume);
      if (message.version != null && Object.hasOwnProperty.call(message, 'version'))
        writer.uint32(/* id 44, wireType 0 =*/ 352).int32(message.version);
      if (message.preMarketOpenTime != null && Object.hasOwnProperty.call(message, 'preMarketOpenTime'))
        writer.uint32(/* id 45, wireType 0 =*/ 360).int64(message.preMarketOpenTime);
      if (message.preMarketOpen != null && Object.hasOwnProperty.call(message, 'preMarketOpen'))
        writer.uint32(/* id 47, wireType 1 =*/ 377).double(message.preMarketOpen);
      if (message.open != null && Object.hasOwnProperty.call(message, 'open'))
        writer.uint32(/* id 50, wireType 1 =*/ 401).double(message.open);
      if (message.dayHigh != null && Object.hasOwnProperty.call(message, 'dayHigh'))
        writer.uint32(/* id 51, wireType 1 =*/ 409).double(message.dayHigh);
      if (message.dayLow != null && Object.hasOwnProperty.call(message, 'dayLow'))
        writer.uint32(/* id 52, wireType 1 =*/ 417).double(message.dayLow);
      if (message.close != null && Object.hasOwnProperty.call(message, 'close'))
        writer.uint32(/* id 53, wireType 1 =*/ 425).double(message.close);
      if (message.volume != null && Object.hasOwnProperty.call(message, 'volume'))
        writer.uint32(/* id 54, wireType 0 =*/ 432).int32(message.volume);
      if (message.vwap != null && Object.hasOwnProperty.call(message, 'vwap'))
        writer.uint32(/* id 55, wireType 1 =*/ 441).double(message.vwap);
      if (message.closeDate != null && Object.hasOwnProperty.call(message, 'closeDate'))
        writer.uint32(/* id 60, wireType 2 =*/ 482).string(message.closeDate);
      if (message.tradeCount != null && Object.hasOwnProperty.call(message, 'tradeCount'))
        writer.uint32(/* id 61, wireType 0 =*/ 488).int64(message.tradeCount);
      if (message.regularHighCount != null && Object.hasOwnProperty.call(message, 'regularHighCount'))
        writer.uint32(/* id 62, wireType 0 =*/ 496).int64(message.regularHighCount);
      if (message.regularLowCount != null && Object.hasOwnProperty.call(message, 'regularLowCount'))
        writer.uint32(/* id 63, wireType 0 =*/ 504).int64(message.regularLowCount);
      if (message.preMarketHighCount != null && Object.hasOwnProperty.call(message, 'preMarketHighCount'))
        writer.uint32(/* id 64, wireType 0 =*/ 512).int64(message.preMarketHighCount);
      if (message.preMarketLowCount != null && Object.hasOwnProperty.call(message, 'preMarketLowCount'))
        writer.uint32(/* id 65, wireType 0 =*/ 520).int64(message.preMarketLowCount);
      if (message.afterMarketHighCount != null && Object.hasOwnProperty.call(message, 'afterMarketHighCount'))
        writer.uint32(/* id 66, wireType 0 =*/ 528).int64(message.afterMarketHighCount);
      if (message.afterMarketLowCount != null && Object.hasOwnProperty.call(message, 'afterMarketLowCount'))
        writer.uint32(/* id 67, wireType 0 =*/ 536).int64(message.afterMarketLowCount);
      if (message.dayHighCount != null && Object.hasOwnProperty.call(message, 'dayHighCount'))
        writer.uint32(/* id 68, wireType 0 =*/ 544).int64(message.dayHighCount);
      if (message.dayLowCount != null && Object.hasOwnProperty.call(message, 'dayLowCount'))
        writer.uint32(/* id 69, wireType 0 =*/ 552).int64(message.dayLowCount);
      if (message.high != null && Object.hasOwnProperty.call(message, 'high'))
        writer.uint32(/* id 70, wireType 1 =*/ 561).double(message.high);
      if (message.low != null && Object.hasOwnProperty.call(message, 'low'))
        writer.uint32(/* id 71, wireType 1 =*/ 569).double(message.low);
      if (message.preMarketHigh != null && Object.hasOwnProperty.call(message, 'preMarketHigh'))
        writer.uint32(/* id 72, wireType 1 =*/ 577).double(message.preMarketHigh);
      if (message.preMarketLow != null && Object.hasOwnProperty.call(message, 'preMarketLow'))
        writer.uint32(/* id 73, wireType 1 =*/ 585).double(message.preMarketLow);
      if (message.afterMarketHigh != null && Object.hasOwnProperty.call(message, 'afterMarketHigh'))
        writer.uint32(/* id 74, wireType 1 =*/ 593).double(message.afterMarketHigh);
      if (message.afterMarketLow != null && Object.hasOwnProperty.call(message, 'afterMarketLow'))
        writer.uint32(/* id 75, wireType 1 =*/ 601).double(message.afterMarketLow);
      if (message.regularHigh != null && Object.hasOwnProperty.call(message, 'regularHigh'))
        writer.uint32(/* id 76, wireType 1 =*/ 609).double(message.regularHigh);
      if (message.regularLow != null && Object.hasOwnProperty.call(message, 'regularLow'))
        writer.uint32(/* id 77, wireType 1 =*/ 617).double(message.regularLow);
      return writer;
    };

    /**
     * Encodes the specified LastQuote message, length delimited. Does not implicitly {@link LastProtos.LastQuote.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LastProtos.LastQuote
     * @static
     * @param {LastProtos.ILastQuote} message LastQuote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LastQuote.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LastQuote message from the specified reader or buffer.
     * @function decode
     * @memberof LastProtos.LastQuote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LastProtos.LastQuote} LastQuote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LastQuote.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.LastProtos.LastQuote();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.symbol = reader.string();
            break;
          }
          case 2: {
            message.currency = reader.string();
            break;
          }
          case 3: {
            message.delayedMinutes = reader.int32();
            break;
          }
          case 4: {
            message.sessionType = reader.int32();
            break;
          }
          case 5: {
            message.error = $root.LastProtos.Error.decode(reader, reader.uint32());
            break;
          }
          case 6: {
            message.name = reader.string();
            break;
          }
          case 7: {
            message.type = reader.string();
            break;
          }
          case 8: {
            message.exchange = reader.string();
            break;
          }
          case 50: {
            message.open = reader.double();
            break;
          }
          case 51: {
            message.dayHigh = reader.double();
            break;
          }
          case 52: {
            message.dayLow = reader.double();
            break;
          }
          case 53: {
            message.close = reader.double();
            break;
          }
          case 54: {
            message.volume = reader.int32();
            break;
          }
          case 55: {
            message.vwap = reader.double();
            break;
          }
          case 60: {
            message.closeDate = reader.string();
            break;
          }
          case 10: {
            message.bidPrice = reader.double();
            break;
          }
          case 11: {
            message.askPrice = reader.double();
            break;
          }
          case 20: {
            message.lastTradePrice = reader.double();
            break;
          }
          case 21: {
            message.lastTradeTime = reader.int64();
            break;
          }
          case 22: {
            message.previousClose = reader.double();
            break;
          }
          case 23: {
            message.change = reader.double();
            break;
          }
          case 24: {
            message.percentChange = reader.double();
            break;
          }
          case 30: {
            message.fiftyTwoWeekHigh = reader.double();
            break;
          }
          case 31: {
            message.fiftyTwoWeekLow = reader.double();
            break;
          }
          case 40: {
            message.preMarketPrice = reader.double();
            break;
          }
          case 41: {
            message.preMarketVolume = reader.int64();
            break;
          }
          case 42: {
            message.afterMarketPrice = reader.double();
            break;
          }
          case 43: {
            message.afterMarketVolume = reader.int64();
            break;
          }
          case 47: {
            message.preMarketOpen = reader.double();
            break;
          }
          case 45: {
            message.preMarketOpenTime = reader.int64();
            break;
          }
          case 44: {
            message.version = reader.int32();
            break;
          }
          case 61: {
            message.tradeCount = reader.int64();
            break;
          }
          case 62: {
            message.regularHighCount = reader.int64();
            break;
          }
          case 63: {
            message.regularLowCount = reader.int64();
            break;
          }
          case 64: {
            message.preMarketHighCount = reader.int64();
            break;
          }
          case 65: {
            message.preMarketLowCount = reader.int64();
            break;
          }
          case 66: {
            message.afterMarketHighCount = reader.int64();
            break;
          }
          case 67: {
            message.afterMarketLowCount = reader.int64();
            break;
          }
          case 68: {
            message.dayHighCount = reader.int64();
            break;
          }
          case 69: {
            message.dayLowCount = reader.int64();
            break;
          }
          case 70: {
            message.high = reader.double();
            break;
          }
          case 71: {
            message.low = reader.double();
            break;
          }
          case 72: {
            message.preMarketHigh = reader.double();
            break;
          }
          case 73: {
            message.preMarketLow = reader.double();
            break;
          }
          case 74: {
            message.afterMarketHigh = reader.double();
            break;
          }
          case 75: {
            message.afterMarketLow = reader.double();
            break;
          }
          case 76: {
            message.regularHigh = reader.double();
            break;
          }
          case 77: {
            message.regularLow = reader.double();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a LastQuote message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LastProtos.LastQuote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LastProtos.LastQuote} LastQuote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LastQuote.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LastQuote message.
     * @function verify
     * @memberof LastProtos.LastQuote
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LastQuote.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.symbol != null && message.hasOwnProperty('symbol'))
        if (!$util.isString(message.symbol)) return 'symbol: string expected';
      if (message.currency != null && message.hasOwnProperty('currency'))
        if (!$util.isString(message.currency)) return 'currency: string expected';
      if (message.delayedMinutes != null && message.hasOwnProperty('delayedMinutes'))
        if (!$util.isInteger(message.delayedMinutes)) return 'delayedMinutes: integer expected';
      if (message.sessionType != null && message.hasOwnProperty('sessionType'))
        switch (message.sessionType) {
          default:
            return 'sessionType: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.error != null && message.hasOwnProperty('error')) {
        let error = $root.LastProtos.Error.verify(message.error);
        if (error) return 'error.' + error;
      }
      if (message.name != null && message.hasOwnProperty('name'))
        if (!$util.isString(message.name)) return 'name: string expected';
      if (message.type != null && message.hasOwnProperty('type'))
        if (!$util.isString(message.type)) return 'type: string expected';
      if (message.exchange != null && message.hasOwnProperty('exchange'))
        if (!$util.isString(message.exchange)) return 'exchange: string expected';
      if (message.open != null && message.hasOwnProperty('open'))
        if (typeof message.open !== 'number') return 'open: number expected';
      if (message.dayHigh != null && message.hasOwnProperty('dayHigh'))
        if (typeof message.dayHigh !== 'number') return 'dayHigh: number expected';
      if (message.dayLow != null && message.hasOwnProperty('dayLow'))
        if (typeof message.dayLow !== 'number') return 'dayLow: number expected';
      if (message.close != null && message.hasOwnProperty('close'))
        if (typeof message.close !== 'number') return 'close: number expected';
      if (message.volume != null && message.hasOwnProperty('volume'))
        if (!$util.isInteger(message.volume)) return 'volume: integer expected';
      if (message.vwap != null && message.hasOwnProperty('vwap'))
        if (typeof message.vwap !== 'number') return 'vwap: number expected';
      if (message.closeDate != null && message.hasOwnProperty('closeDate'))
        if (!$util.isString(message.closeDate)) return 'closeDate: string expected';
      if (message.bidPrice != null && message.hasOwnProperty('bidPrice'))
        if (typeof message.bidPrice !== 'number') return 'bidPrice: number expected';
      if (message.askPrice != null && message.hasOwnProperty('askPrice'))
        if (typeof message.askPrice !== 'number') return 'askPrice: number expected';
      if (message.lastTradePrice != null && message.hasOwnProperty('lastTradePrice'))
        if (typeof message.lastTradePrice !== 'number') return 'lastTradePrice: number expected';
      if (message.lastTradeTime != null && message.hasOwnProperty('lastTradeTime'))
        if (
          !$util.isInteger(message.lastTradeTime) &&
          !(
            message.lastTradeTime &&
            $util.isInteger(message.lastTradeTime.low) &&
            $util.isInteger(message.lastTradeTime.high)
          )
        )
          return 'lastTradeTime: integer|Long expected';
      if (message.previousClose != null && message.hasOwnProperty('previousClose'))
        if (typeof message.previousClose !== 'number') return 'previousClose: number expected';
      if (message.change != null && message.hasOwnProperty('change'))
        if (typeof message.change !== 'number') return 'change: number expected';
      if (message.percentChange != null && message.hasOwnProperty('percentChange'))
        if (typeof message.percentChange !== 'number') return 'percentChange: number expected';
      if (message.fiftyTwoWeekHigh != null && message.hasOwnProperty('fiftyTwoWeekHigh'))
        if (typeof message.fiftyTwoWeekHigh !== 'number') return 'fiftyTwoWeekHigh: number expected';
      if (message.fiftyTwoWeekLow != null && message.hasOwnProperty('fiftyTwoWeekLow'))
        if (typeof message.fiftyTwoWeekLow !== 'number') return 'fiftyTwoWeekLow: number expected';
      if (message.preMarketPrice != null && message.hasOwnProperty('preMarketPrice'))
        if (typeof message.preMarketPrice !== 'number') return 'preMarketPrice: number expected';
      if (message.preMarketVolume != null && message.hasOwnProperty('preMarketVolume'))
        if (
          !$util.isInteger(message.preMarketVolume) &&
          !(
            message.preMarketVolume &&
            $util.isInteger(message.preMarketVolume.low) &&
            $util.isInteger(message.preMarketVolume.high)
          )
        )
          return 'preMarketVolume: integer|Long expected';
      if (message.afterMarketPrice != null && message.hasOwnProperty('afterMarketPrice'))
        if (typeof message.afterMarketPrice !== 'number') return 'afterMarketPrice: number expected';
      if (message.afterMarketVolume != null && message.hasOwnProperty('afterMarketVolume'))
        if (
          !$util.isInteger(message.afterMarketVolume) &&
          !(
            message.afterMarketVolume &&
            $util.isInteger(message.afterMarketVolume.low) &&
            $util.isInteger(message.afterMarketVolume.high)
          )
        )
          return 'afterMarketVolume: integer|Long expected';
      if (message.preMarketOpen != null && message.hasOwnProperty('preMarketOpen'))
        if (typeof message.preMarketOpen !== 'number') return 'preMarketOpen: number expected';
      if (message.preMarketOpenTime != null && message.hasOwnProperty('preMarketOpenTime'))
        if (
          !$util.isInteger(message.preMarketOpenTime) &&
          !(
            message.preMarketOpenTime &&
            $util.isInteger(message.preMarketOpenTime.low) &&
            $util.isInteger(message.preMarketOpenTime.high)
          )
        )
          return 'preMarketOpenTime: integer|Long expected';
      if (message.version != null && message.hasOwnProperty('version'))
        if (!$util.isInteger(message.version)) return 'version: integer expected';
      if (message.tradeCount != null && message.hasOwnProperty('tradeCount'))
        if (
          !$util.isInteger(message.tradeCount) &&
          !(message.tradeCount && $util.isInteger(message.tradeCount.low) && $util.isInteger(message.tradeCount.high))
        )
          return 'tradeCount: integer|Long expected';
      if (message.regularHighCount != null && message.hasOwnProperty('regularHighCount'))
        if (
          !$util.isInteger(message.regularHighCount) &&
          !(
            message.regularHighCount &&
            $util.isInteger(message.regularHighCount.low) &&
            $util.isInteger(message.regularHighCount.high)
          )
        )
          return 'regularHighCount: integer|Long expected';
      if (message.regularLowCount != null && message.hasOwnProperty('regularLowCount'))
        if (
          !$util.isInteger(message.regularLowCount) &&
          !(
            message.regularLowCount &&
            $util.isInteger(message.regularLowCount.low) &&
            $util.isInteger(message.regularLowCount.high)
          )
        )
          return 'regularLowCount: integer|Long expected';
      if (message.preMarketHighCount != null && message.hasOwnProperty('preMarketHighCount'))
        if (
          !$util.isInteger(message.preMarketHighCount) &&
          !(
            message.preMarketHighCount &&
            $util.isInteger(message.preMarketHighCount.low) &&
            $util.isInteger(message.preMarketHighCount.high)
          )
        )
          return 'preMarketHighCount: integer|Long expected';
      if (message.preMarketLowCount != null && message.hasOwnProperty('preMarketLowCount'))
        if (
          !$util.isInteger(message.preMarketLowCount) &&
          !(
            message.preMarketLowCount &&
            $util.isInteger(message.preMarketLowCount.low) &&
            $util.isInteger(message.preMarketLowCount.high)
          )
        )
          return 'preMarketLowCount: integer|Long expected';
      if (message.afterMarketHighCount != null && message.hasOwnProperty('afterMarketHighCount'))
        if (
          !$util.isInteger(message.afterMarketHighCount) &&
          !(
            message.afterMarketHighCount &&
            $util.isInteger(message.afterMarketHighCount.low) &&
            $util.isInteger(message.afterMarketHighCount.high)
          )
        )
          return 'afterMarketHighCount: integer|Long expected';
      if (message.afterMarketLowCount != null && message.hasOwnProperty('afterMarketLowCount'))
        if (
          !$util.isInteger(message.afterMarketLowCount) &&
          !(
            message.afterMarketLowCount &&
            $util.isInteger(message.afterMarketLowCount.low) &&
            $util.isInteger(message.afterMarketLowCount.high)
          )
        )
          return 'afterMarketLowCount: integer|Long expected';
      if (message.dayHighCount != null && message.hasOwnProperty('dayHighCount'))
        if (
          !$util.isInteger(message.dayHighCount) &&
          !(
            message.dayHighCount &&
            $util.isInteger(message.dayHighCount.low) &&
            $util.isInteger(message.dayHighCount.high)
          )
        )
          return 'dayHighCount: integer|Long expected';
      if (message.dayLowCount != null && message.hasOwnProperty('dayLowCount'))
        if (
          !$util.isInteger(message.dayLowCount) &&
          !(
            message.dayLowCount &&
            $util.isInteger(message.dayLowCount.low) &&
            $util.isInteger(message.dayLowCount.high)
          )
        )
          return 'dayLowCount: integer|Long expected';
      if (message.high != null && message.hasOwnProperty('high'))
        if (typeof message.high !== 'number') return 'high: number expected';
      if (message.low != null && message.hasOwnProperty('low'))
        if (typeof message.low !== 'number') return 'low: number expected';
      if (message.preMarketHigh != null && message.hasOwnProperty('preMarketHigh'))
        if (typeof message.preMarketHigh !== 'number') return 'preMarketHigh: number expected';
      if (message.preMarketLow != null && message.hasOwnProperty('preMarketLow'))
        if (typeof message.preMarketLow !== 'number') return 'preMarketLow: number expected';
      if (message.afterMarketHigh != null && message.hasOwnProperty('afterMarketHigh'))
        if (typeof message.afterMarketHigh !== 'number') return 'afterMarketHigh: number expected';
      if (message.afterMarketLow != null && message.hasOwnProperty('afterMarketLow'))
        if (typeof message.afterMarketLow !== 'number') return 'afterMarketLow: number expected';
      if (message.regularHigh != null && message.hasOwnProperty('regularHigh'))
        if (typeof message.regularHigh !== 'number') return 'regularHigh: number expected';
      if (message.regularLow != null && message.hasOwnProperty('regularLow'))
        if (typeof message.regularLow !== 'number') return 'regularLow: number expected';
      return null;
    };

    /**
     * Creates a LastQuote message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LastProtos.LastQuote
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LastProtos.LastQuote} LastQuote
     */
    LastQuote.fromObject = function fromObject(object) {
      if (object instanceof $root.LastProtos.LastQuote) return object;
      let message = new $root.LastProtos.LastQuote();
      if (object.symbol != null) message.symbol = String(object.symbol);
      if (object.currency != null) message.currency = String(object.currency);
      if (object.delayedMinutes != null) message.delayedMinutes = object.delayedMinutes | 0;
      switch (object.sessionType) {
        default:
          if (typeof object.sessionType === 'number') {
            message.sessionType = object.sessionType;
            break;
          }
          break;
        case 'NA':
        case 0:
          message.sessionType = 0;
          break;
        case 'PRE_MARKET':
        case 1:
          message.sessionType = 1;
          break;
        case 'REGULAR':
        case 2:
          message.sessionType = 2;
          break;
        case 'AFTER_MARKET':
        case 3:
          message.sessionType = 3;
          break;
      }
      if (object.error != null) {
        if (typeof object.error !== 'object') throw TypeError('.LastProtos.LastQuote.error: object expected');
        message.error = $root.LastProtos.Error.fromObject(object.error);
      }
      if (object.name != null) message.name = String(object.name);
      if (object.type != null) message.type = String(object.type);
      if (object.exchange != null) message.exchange = String(object.exchange);
      if (object.open != null) message.open = Number(object.open);
      if (object.dayHigh != null) message.dayHigh = Number(object.dayHigh);
      if (object.dayLow != null) message.dayLow = Number(object.dayLow);
      if (object.close != null) message.close = Number(object.close);
      if (object.volume != null) message.volume = object.volume | 0;
      if (object.vwap != null) message.vwap = Number(object.vwap);
      if (object.closeDate != null) message.closeDate = String(object.closeDate);
      if (object.bidPrice != null) message.bidPrice = Number(object.bidPrice);
      if (object.askPrice != null) message.askPrice = Number(object.askPrice);
      if (object.lastTradePrice != null) message.lastTradePrice = Number(object.lastTradePrice);
      if (object.lastTradeTime != null)
        if ($util.Long) (message.lastTradeTime = $util.Long.fromValue(object.lastTradeTime)).unsigned = false;
        else if (typeof object.lastTradeTime === 'string') message.lastTradeTime = parseInt(object.lastTradeTime, 10);
        else if (typeof object.lastTradeTime === 'number') message.lastTradeTime = object.lastTradeTime;
        else if (typeof object.lastTradeTime === 'object')
          message.lastTradeTime = new $util.LongBits(
            object.lastTradeTime.low >>> 0,
            object.lastTradeTime.high >>> 0,
          ).toNumber();
      if (object.previousClose != null) message.previousClose = Number(object.previousClose);
      if (object.change != null) message.change = Number(object.change);
      if (object.percentChange != null) message.percentChange = Number(object.percentChange);
      if (object.fiftyTwoWeekHigh != null) message.fiftyTwoWeekHigh = Number(object.fiftyTwoWeekHigh);
      if (object.fiftyTwoWeekLow != null) message.fiftyTwoWeekLow = Number(object.fiftyTwoWeekLow);
      if (object.preMarketPrice != null) message.preMarketPrice = Number(object.preMarketPrice);
      if (object.preMarketVolume != null)
        if ($util.Long) (message.preMarketVolume = $util.Long.fromValue(object.preMarketVolume)).unsigned = false;
        else if (typeof object.preMarketVolume === 'string')
          message.preMarketVolume = parseInt(object.preMarketVolume, 10);
        else if (typeof object.preMarketVolume === 'number') message.preMarketVolume = object.preMarketVolume;
        else if (typeof object.preMarketVolume === 'object')
          message.preMarketVolume = new $util.LongBits(
            object.preMarketVolume.low >>> 0,
            object.preMarketVolume.high >>> 0,
          ).toNumber();
      if (object.afterMarketPrice != null) message.afterMarketPrice = Number(object.afterMarketPrice);
      if (object.afterMarketVolume != null)
        if ($util.Long) (message.afterMarketVolume = $util.Long.fromValue(object.afterMarketVolume)).unsigned = false;
        else if (typeof object.afterMarketVolume === 'string')
          message.afterMarketVolume = parseInt(object.afterMarketVolume, 10);
        else if (typeof object.afterMarketVolume === 'number') message.afterMarketVolume = object.afterMarketVolume;
        else if (typeof object.afterMarketVolume === 'object')
          message.afterMarketVolume = new $util.LongBits(
            object.afterMarketVolume.low >>> 0,
            object.afterMarketVolume.high >>> 0,
          ).toNumber();
      if (object.preMarketOpen != null) message.preMarketOpen = Number(object.preMarketOpen);
      if (object.preMarketOpenTime != null)
        if ($util.Long) (message.preMarketOpenTime = $util.Long.fromValue(object.preMarketOpenTime)).unsigned = false;
        else if (typeof object.preMarketOpenTime === 'string')
          message.preMarketOpenTime = parseInt(object.preMarketOpenTime, 10);
        else if (typeof object.preMarketOpenTime === 'number') message.preMarketOpenTime = object.preMarketOpenTime;
        else if (typeof object.preMarketOpenTime === 'object')
          message.preMarketOpenTime = new $util.LongBits(
            object.preMarketOpenTime.low >>> 0,
            object.preMarketOpenTime.high >>> 0,
          ).toNumber();
      if (object.version != null) message.version = object.version | 0;
      if (object.tradeCount != null)
        if ($util.Long) (message.tradeCount = $util.Long.fromValue(object.tradeCount)).unsigned = false;
        else if (typeof object.tradeCount === 'string') message.tradeCount = parseInt(object.tradeCount, 10);
        else if (typeof object.tradeCount === 'number') message.tradeCount = object.tradeCount;
        else if (typeof object.tradeCount === 'object')
          message.tradeCount = new $util.LongBits(object.tradeCount.low >>> 0, object.tradeCount.high >>> 0).toNumber();
      if (object.regularHighCount != null)
        if ($util.Long) (message.regularHighCount = $util.Long.fromValue(object.regularHighCount)).unsigned = false;
        else if (typeof object.regularHighCount === 'string')
          message.regularHighCount = parseInt(object.regularHighCount, 10);
        else if (typeof object.regularHighCount === 'number') message.regularHighCount = object.regularHighCount;
        else if (typeof object.regularHighCount === 'object')
          message.regularHighCount = new $util.LongBits(
            object.regularHighCount.low >>> 0,
            object.regularHighCount.high >>> 0,
          ).toNumber();
      if (object.regularLowCount != null)
        if ($util.Long) (message.regularLowCount = $util.Long.fromValue(object.regularLowCount)).unsigned = false;
        else if (typeof object.regularLowCount === 'string')
          message.regularLowCount = parseInt(object.regularLowCount, 10);
        else if (typeof object.regularLowCount === 'number') message.regularLowCount = object.regularLowCount;
        else if (typeof object.regularLowCount === 'object')
          message.regularLowCount = new $util.LongBits(
            object.regularLowCount.low >>> 0,
            object.regularLowCount.high >>> 0,
          ).toNumber();
      if (object.preMarketHighCount != null)
        if ($util.Long) (message.preMarketHighCount = $util.Long.fromValue(object.preMarketHighCount)).unsigned = false;
        else if (typeof object.preMarketHighCount === 'string')
          message.preMarketHighCount = parseInt(object.preMarketHighCount, 10);
        else if (typeof object.preMarketHighCount === 'number') message.preMarketHighCount = object.preMarketHighCount;
        else if (typeof object.preMarketHighCount === 'object')
          message.preMarketHighCount = new $util.LongBits(
            object.preMarketHighCount.low >>> 0,
            object.preMarketHighCount.high >>> 0,
          ).toNumber();
      if (object.preMarketLowCount != null)
        if ($util.Long) (message.preMarketLowCount = $util.Long.fromValue(object.preMarketLowCount)).unsigned = false;
        else if (typeof object.preMarketLowCount === 'string')
          message.preMarketLowCount = parseInt(object.preMarketLowCount, 10);
        else if (typeof object.preMarketLowCount === 'number') message.preMarketLowCount = object.preMarketLowCount;
        else if (typeof object.preMarketLowCount === 'object')
          message.preMarketLowCount = new $util.LongBits(
            object.preMarketLowCount.low >>> 0,
            object.preMarketLowCount.high >>> 0,
          ).toNumber();
      if (object.afterMarketHighCount != null)
        if ($util.Long)
          (message.afterMarketHighCount = $util.Long.fromValue(object.afterMarketHighCount)).unsigned = false;
        else if (typeof object.afterMarketHighCount === 'string')
          message.afterMarketHighCount = parseInt(object.afterMarketHighCount, 10);
        else if (typeof object.afterMarketHighCount === 'number')
          message.afterMarketHighCount = object.afterMarketHighCount;
        else if (typeof object.afterMarketHighCount === 'object')
          message.afterMarketHighCount = new $util.LongBits(
            object.afterMarketHighCount.low >>> 0,
            object.afterMarketHighCount.high >>> 0,
          ).toNumber();
      if (object.afterMarketLowCount != null)
        if ($util.Long)
          (message.afterMarketLowCount = $util.Long.fromValue(object.afterMarketLowCount)).unsigned = false;
        else if (typeof object.afterMarketLowCount === 'string')
          message.afterMarketLowCount = parseInt(object.afterMarketLowCount, 10);
        else if (typeof object.afterMarketLowCount === 'number')
          message.afterMarketLowCount = object.afterMarketLowCount;
        else if (typeof object.afterMarketLowCount === 'object')
          message.afterMarketLowCount = new $util.LongBits(
            object.afterMarketLowCount.low >>> 0,
            object.afterMarketLowCount.high >>> 0,
          ).toNumber();
      if (object.dayHighCount != null)
        if ($util.Long) (message.dayHighCount = $util.Long.fromValue(object.dayHighCount)).unsigned = false;
        else if (typeof object.dayHighCount === 'string') message.dayHighCount = parseInt(object.dayHighCount, 10);
        else if (typeof object.dayHighCount === 'number') message.dayHighCount = object.dayHighCount;
        else if (typeof object.dayHighCount === 'object')
          message.dayHighCount = new $util.LongBits(
            object.dayHighCount.low >>> 0,
            object.dayHighCount.high >>> 0,
          ).toNumber();
      if (object.dayLowCount != null)
        if ($util.Long) (message.dayLowCount = $util.Long.fromValue(object.dayLowCount)).unsigned = false;
        else if (typeof object.dayLowCount === 'string') message.dayLowCount = parseInt(object.dayLowCount, 10);
        else if (typeof object.dayLowCount === 'number') message.dayLowCount = object.dayLowCount;
        else if (typeof object.dayLowCount === 'object')
          message.dayLowCount = new $util.LongBits(
            object.dayLowCount.low >>> 0,
            object.dayLowCount.high >>> 0,
          ).toNumber();
      if (object.high != null) message.high = Number(object.high);
      if (object.low != null) message.low = Number(object.low);
      if (object.preMarketHigh != null) message.preMarketHigh = Number(object.preMarketHigh);
      if (object.preMarketLow != null) message.preMarketLow = Number(object.preMarketLow);
      if (object.afterMarketHigh != null) message.afterMarketHigh = Number(object.afterMarketHigh);
      if (object.afterMarketLow != null) message.afterMarketLow = Number(object.afterMarketLow);
      if (object.regularHigh != null) message.regularHigh = Number(object.regularHigh);
      if (object.regularLow != null) message.regularLow = Number(object.regularLow);
      return message;
    };

    /**
     * Creates a plain object from a LastQuote message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LastProtos.LastQuote
     * @static
     * @param {LastProtos.LastQuote} message LastQuote
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LastQuote.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.symbol = '';
        object.currency = '';
        object.delayedMinutes = 0;
        object.sessionType = options.enums === String ? 'NA' : 0;
        object.error = null;
        object.name = '';
        object.type = '';
        object.exchange = '';
        object.bidPrice = 0;
        object.askPrice = 0;
        object.lastTradePrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.lastTradeTime =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.lastTradeTime = options.longs === String ? '0' : 0;
        object.previousClose = 0;
        object.change = 0;
        object.percentChange = 0;
        object.fiftyTwoWeekHigh = 0;
        object.fiftyTwoWeekLow = 0;
        object.preMarketPrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.preMarketVolume =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.preMarketVolume = options.longs === String ? '0' : 0;
        object.afterMarketPrice = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.afterMarketVolume =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.afterMarketVolume = options.longs === String ? '0' : 0;
        object.version = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.preMarketOpenTime =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.preMarketOpenTime = options.longs === String ? '0' : 0;
        object.preMarketOpen = 0;
        object.open = 0;
        object.dayHigh = 0;
        object.dayLow = 0;
        object.close = 0;
        object.volume = 0;
        object.vwap = 0;
        object.closeDate = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.tradeCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.tradeCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.regularHighCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.regularHighCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.regularLowCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.regularLowCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.preMarketHighCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.preMarketHighCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.preMarketLowCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.preMarketLowCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.afterMarketHighCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.afterMarketHighCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.afterMarketLowCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.afterMarketLowCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dayHighCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.dayHighCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dayLowCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.dayLowCount = options.longs === String ? '0' : 0;
        object.high = 0;
        object.low = 0;
        object.preMarketHigh = 0;
        object.preMarketLow = 0;
        object.afterMarketHigh = 0;
        object.afterMarketLow = 0;
        object.regularHigh = 0;
        object.regularLow = 0;
      }
      if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
      if (message.currency != null && message.hasOwnProperty('currency')) object.currency = message.currency;
      if (message.delayedMinutes != null && message.hasOwnProperty('delayedMinutes'))
        object.delayedMinutes = message.delayedMinutes;
      if (message.sessionType != null && message.hasOwnProperty('sessionType'))
        object.sessionType =
          options.enums === String
            ? $root.LastProtos.SessionType[message.sessionType] === undefined
              ? message.sessionType
              : $root.LastProtos.SessionType[message.sessionType]
            : message.sessionType;
      if (message.error != null && message.hasOwnProperty('error'))
        object.error = $root.LastProtos.Error.toObject(message.error, options);
      if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
      if (message.type != null && message.hasOwnProperty('type')) object.type = message.type;
      if (message.exchange != null && message.hasOwnProperty('exchange')) object.exchange = message.exchange;
      if (message.bidPrice != null && message.hasOwnProperty('bidPrice'))
        object.bidPrice = options.json && !isFinite(message.bidPrice) ? String(message.bidPrice) : message.bidPrice;
      if (message.askPrice != null && message.hasOwnProperty('askPrice'))
        object.askPrice = options.json && !isFinite(message.askPrice) ? String(message.askPrice) : message.askPrice;
      if (message.lastTradePrice != null && message.hasOwnProperty('lastTradePrice'))
        object.lastTradePrice =
          options.json && !isFinite(message.lastTradePrice) ? String(message.lastTradePrice) : message.lastTradePrice;
      if (message.lastTradeTime != null && message.hasOwnProperty('lastTradeTime'))
        if (typeof message.lastTradeTime === 'number')
          object.lastTradeTime = options.longs === String ? String(message.lastTradeTime) : message.lastTradeTime;
        else
          object.lastTradeTime =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.lastTradeTime)
              : options.longs === Number
                ? new $util.LongBits(message.lastTradeTime.low >>> 0, message.lastTradeTime.high >>> 0).toNumber()
                : message.lastTradeTime;
      if (message.previousClose != null && message.hasOwnProperty('previousClose'))
        object.previousClose =
          options.json && !isFinite(message.previousClose) ? String(message.previousClose) : message.previousClose;
      if (message.change != null && message.hasOwnProperty('change'))
        object.change = options.json && !isFinite(message.change) ? String(message.change) : message.change;
      if (message.percentChange != null && message.hasOwnProperty('percentChange'))
        object.percentChange =
          options.json && !isFinite(message.percentChange) ? String(message.percentChange) : message.percentChange;
      if (message.fiftyTwoWeekHigh != null && message.hasOwnProperty('fiftyTwoWeekHigh'))
        object.fiftyTwoWeekHigh =
          options.json && !isFinite(message.fiftyTwoWeekHigh)
            ? String(message.fiftyTwoWeekHigh)
            : message.fiftyTwoWeekHigh;
      if (message.fiftyTwoWeekLow != null && message.hasOwnProperty('fiftyTwoWeekLow'))
        object.fiftyTwoWeekLow =
          options.json && !isFinite(message.fiftyTwoWeekLow)
            ? String(message.fiftyTwoWeekLow)
            : message.fiftyTwoWeekLow;
      if (message.preMarketPrice != null && message.hasOwnProperty('preMarketPrice'))
        object.preMarketPrice =
          options.json && !isFinite(message.preMarketPrice) ? String(message.preMarketPrice) : message.preMarketPrice;
      if (message.preMarketVolume != null && message.hasOwnProperty('preMarketVolume'))
        if (typeof message.preMarketVolume === 'number')
          object.preMarketVolume = options.longs === String ? String(message.preMarketVolume) : message.preMarketVolume;
        else
          object.preMarketVolume =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.preMarketVolume)
              : options.longs === Number
                ? new $util.LongBits(message.preMarketVolume.low >>> 0, message.preMarketVolume.high >>> 0).toNumber()
                : message.preMarketVolume;
      if (message.afterMarketPrice != null && message.hasOwnProperty('afterMarketPrice'))
        object.afterMarketPrice =
          options.json && !isFinite(message.afterMarketPrice)
            ? String(message.afterMarketPrice)
            : message.afterMarketPrice;
      if (message.afterMarketVolume != null && message.hasOwnProperty('afterMarketVolume'))
        if (typeof message.afterMarketVolume === 'number')
          object.afterMarketVolume =
            options.longs === String ? String(message.afterMarketVolume) : message.afterMarketVolume;
        else
          object.afterMarketVolume =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.afterMarketVolume)
              : options.longs === Number
                ? new $util.LongBits(
                    message.afterMarketVolume.low >>> 0,
                    message.afterMarketVolume.high >>> 0,
                  ).toNumber()
                : message.afterMarketVolume;
      if (message.version != null && message.hasOwnProperty('version')) object.version = message.version;
      if (message.preMarketOpenTime != null && message.hasOwnProperty('preMarketOpenTime'))
        if (typeof message.preMarketOpenTime === 'number')
          object.preMarketOpenTime =
            options.longs === String ? String(message.preMarketOpenTime) : message.preMarketOpenTime;
        else
          object.preMarketOpenTime =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.preMarketOpenTime)
              : options.longs === Number
                ? new $util.LongBits(
                    message.preMarketOpenTime.low >>> 0,
                    message.preMarketOpenTime.high >>> 0,
                  ).toNumber()
                : message.preMarketOpenTime;
      if (message.preMarketOpen != null && message.hasOwnProperty('preMarketOpen'))
        object.preMarketOpen =
          options.json && !isFinite(message.preMarketOpen) ? String(message.preMarketOpen) : message.preMarketOpen;
      if (message.open != null && message.hasOwnProperty('open'))
        object.open = options.json && !isFinite(message.open) ? String(message.open) : message.open;
      if (message.dayHigh != null && message.hasOwnProperty('dayHigh'))
        object.dayHigh = options.json && !isFinite(message.dayHigh) ? String(message.dayHigh) : message.dayHigh;
      if (message.dayLow != null && message.hasOwnProperty('dayLow'))
        object.dayLow = options.json && !isFinite(message.dayLow) ? String(message.dayLow) : message.dayLow;
      if (message.close != null && message.hasOwnProperty('close'))
        object.close = options.json && !isFinite(message.close) ? String(message.close) : message.close;
      if (message.volume != null && message.hasOwnProperty('volume')) object.volume = message.volume;
      if (message.vwap != null && message.hasOwnProperty('vwap'))
        object.vwap = options.json && !isFinite(message.vwap) ? String(message.vwap) : message.vwap;
      if (message.closeDate != null && message.hasOwnProperty('closeDate')) object.closeDate = message.closeDate;
      if (message.tradeCount != null && message.hasOwnProperty('tradeCount'))
        if (typeof message.tradeCount === 'number')
          object.tradeCount = options.longs === String ? String(message.tradeCount) : message.tradeCount;
        else
          object.tradeCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.tradeCount)
              : options.longs === Number
                ? new $util.LongBits(message.tradeCount.low >>> 0, message.tradeCount.high >>> 0).toNumber()
                : message.tradeCount;
      if (message.regularHighCount != null && message.hasOwnProperty('regularHighCount'))
        if (typeof message.regularHighCount === 'number')
          object.regularHighCount =
            options.longs === String ? String(message.regularHighCount) : message.regularHighCount;
        else
          object.regularHighCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.regularHighCount)
              : options.longs === Number
                ? new $util.LongBits(message.regularHighCount.low >>> 0, message.regularHighCount.high >>> 0).toNumber()
                : message.regularHighCount;
      if (message.regularLowCount != null && message.hasOwnProperty('regularLowCount'))
        if (typeof message.regularLowCount === 'number')
          object.regularLowCount = options.longs === String ? String(message.regularLowCount) : message.regularLowCount;
        else
          object.regularLowCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.regularLowCount)
              : options.longs === Number
                ? new $util.LongBits(message.regularLowCount.low >>> 0, message.regularLowCount.high >>> 0).toNumber()
                : message.regularLowCount;
      if (message.preMarketHighCount != null && message.hasOwnProperty('preMarketHighCount'))
        if (typeof message.preMarketHighCount === 'number')
          object.preMarketHighCount =
            options.longs === String ? String(message.preMarketHighCount) : message.preMarketHighCount;
        else
          object.preMarketHighCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.preMarketHighCount)
              : options.longs === Number
                ? new $util.LongBits(
                    message.preMarketHighCount.low >>> 0,
                    message.preMarketHighCount.high >>> 0,
                  ).toNumber()
                : message.preMarketHighCount;
      if (message.preMarketLowCount != null && message.hasOwnProperty('preMarketLowCount'))
        if (typeof message.preMarketLowCount === 'number')
          object.preMarketLowCount =
            options.longs === String ? String(message.preMarketLowCount) : message.preMarketLowCount;
        else
          object.preMarketLowCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.preMarketLowCount)
              : options.longs === Number
                ? new $util.LongBits(
                    message.preMarketLowCount.low >>> 0,
                    message.preMarketLowCount.high >>> 0,
                  ).toNumber()
                : message.preMarketLowCount;
      if (message.afterMarketHighCount != null && message.hasOwnProperty('afterMarketHighCount'))
        if (typeof message.afterMarketHighCount === 'number')
          object.afterMarketHighCount =
            options.longs === String ? String(message.afterMarketHighCount) : message.afterMarketHighCount;
        else
          object.afterMarketHighCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.afterMarketHighCount)
              : options.longs === Number
                ? new $util.LongBits(
                    message.afterMarketHighCount.low >>> 0,
                    message.afterMarketHighCount.high >>> 0,
                  ).toNumber()
                : message.afterMarketHighCount;
      if (message.afterMarketLowCount != null && message.hasOwnProperty('afterMarketLowCount'))
        if (typeof message.afterMarketLowCount === 'number')
          object.afterMarketLowCount =
            options.longs === String ? String(message.afterMarketLowCount) : message.afterMarketLowCount;
        else
          object.afterMarketLowCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.afterMarketLowCount)
              : options.longs === Number
                ? new $util.LongBits(
                    message.afterMarketLowCount.low >>> 0,
                    message.afterMarketLowCount.high >>> 0,
                  ).toNumber()
                : message.afterMarketLowCount;
      if (message.dayHighCount != null && message.hasOwnProperty('dayHighCount'))
        if (typeof message.dayHighCount === 'number')
          object.dayHighCount = options.longs === String ? String(message.dayHighCount) : message.dayHighCount;
        else
          object.dayHighCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.dayHighCount)
              : options.longs === Number
                ? new $util.LongBits(message.dayHighCount.low >>> 0, message.dayHighCount.high >>> 0).toNumber()
                : message.dayHighCount;
      if (message.dayLowCount != null && message.hasOwnProperty('dayLowCount'))
        if (typeof message.dayLowCount === 'number')
          object.dayLowCount = options.longs === String ? String(message.dayLowCount) : message.dayLowCount;
        else
          object.dayLowCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.dayLowCount)
              : options.longs === Number
                ? new $util.LongBits(message.dayLowCount.low >>> 0, message.dayLowCount.high >>> 0).toNumber()
                : message.dayLowCount;
      if (message.high != null && message.hasOwnProperty('high'))
        object.high = options.json && !isFinite(message.high) ? String(message.high) : message.high;
      if (message.low != null && message.hasOwnProperty('low'))
        object.low = options.json && !isFinite(message.low) ? String(message.low) : message.low;
      if (message.preMarketHigh != null && message.hasOwnProperty('preMarketHigh'))
        object.preMarketHigh =
          options.json && !isFinite(message.preMarketHigh) ? String(message.preMarketHigh) : message.preMarketHigh;
      if (message.preMarketLow != null && message.hasOwnProperty('preMarketLow'))
        object.preMarketLow =
          options.json && !isFinite(message.preMarketLow) ? String(message.preMarketLow) : message.preMarketLow;
      if (message.afterMarketHigh != null && message.hasOwnProperty('afterMarketHigh'))
        object.afterMarketHigh =
          options.json && !isFinite(message.afterMarketHigh)
            ? String(message.afterMarketHigh)
            : message.afterMarketHigh;
      if (message.afterMarketLow != null && message.hasOwnProperty('afterMarketLow'))
        object.afterMarketLow =
          options.json && !isFinite(message.afterMarketLow) ? String(message.afterMarketLow) : message.afterMarketLow;
      if (message.regularHigh != null && message.hasOwnProperty('regularHigh'))
        object.regularHigh =
          options.json && !isFinite(message.regularHigh) ? String(message.regularHigh) : message.regularHigh;
      if (message.regularLow != null && message.hasOwnProperty('regularLow'))
        object.regularLow =
          options.json && !isFinite(message.regularLow) ? String(message.regularLow) : message.regularLow;
      return object;
    };

    /**
     * Converts this LastQuote to JSON.
     * @function toJSON
     * @memberof LastProtos.LastQuote
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LastQuote.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LastQuote;
  })();

  LastProtos.Error = (function () {
    /**
     * Properties of an Error.
     * @memberof LastProtos
     * @interface IError
     * @property {LastProtos.Error.Code|null} [code] Error code
     * @property {string|null} [message] Error message
     */

    /**
     * Constructs a new Error.
     * @memberof LastProtos
     * @classdesc Represents an Error.
     * @implements IError
     * @constructor
     * @param {LastProtos.IError=} [properties] Properties to set
     */
    function Error(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Error code.
     * @member {LastProtos.Error.Code} code
     * @memberof LastProtos.Error
     * @instance
     */
    Error.prototype.code = 0;

    /**
     * Error message.
     * @member {string} message
     * @memberof LastProtos.Error
     * @instance
     */
    Error.prototype.message = '';

    /**
     * Creates a new Error instance using the specified properties.
     * @function create
     * @memberof LastProtos.Error
     * @static
     * @param {LastProtos.IError=} [properties] Properties to set
     * @returns {LastProtos.Error} Error instance
     */
    Error.create = function create(properties) {
      return new Error(properties);
    };

    /**
     * Encodes the specified Error message. Does not implicitly {@link LastProtos.Error.verify|verify} messages.
     * @function encode
     * @memberof LastProtos.Error
     * @static
     * @param {LastProtos.IError} message Error message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Error.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.code != null && Object.hasOwnProperty.call(message, 'code'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.code);
      if (message.message != null && Object.hasOwnProperty.call(message, 'message'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.message);
      return writer;
    };

    /**
     * Encodes the specified Error message, length delimited. Does not implicitly {@link LastProtos.Error.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LastProtos.Error
     * @static
     * @param {LastProtos.IError} message Error message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Error.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Error message from the specified reader or buffer.
     * @function decode
     * @memberof LastProtos.Error
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LastProtos.Error} Error
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Error.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.LastProtos.Error();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.code = reader.int32();
            break;
          }
          case 2: {
            message.message = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an Error message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LastProtos.Error
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LastProtos.Error} Error
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Error.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Error message.
     * @function verify
     * @memberof LastProtos.Error
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Error.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.code != null && message.hasOwnProperty('code'))
        switch (message.code) {
          default:
            return 'code: enum value expected';
          case 0:
          case 1:
            break;
        }
      if (message.message != null && message.hasOwnProperty('message'))
        if (!$util.isString(message.message)) return 'message: string expected';
      return null;
    };

    /**
     * Creates an Error message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LastProtos.Error
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LastProtos.Error} Error
     */
    Error.fromObject = function fromObject(object) {
      if (object instanceof $root.LastProtos.Error) return object;
      let message = new $root.LastProtos.Error();
      switch (object.code) {
        default:
          if (typeof object.code === 'number') {
            message.code = object.code;
            break;
          }
          break;
        case 'ERROR':
        case 0:
          message.code = 0;
          break;
        case 'UNKNOWN_SYMBOL':
        case 1:
          message.code = 1;
          break;
      }
      if (object.message != null) message.message = String(object.message);
      return message;
    };

    /**
     * Creates a plain object from an Error message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LastProtos.Error
     * @static
     * @param {LastProtos.Error} message Error
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Error.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.code = options.enums === String ? 'ERROR' : 0;
        object.message = '';
      }
      if (message.code != null && message.hasOwnProperty('code'))
        object.code =
          options.enums === String
            ? $root.LastProtos.Error.Code[message.code] === undefined
              ? message.code
              : $root.LastProtos.Error.Code[message.code]
            : message.code;
      if (message.message != null && message.hasOwnProperty('message')) object.message = message.message;
      return object;
    };

    /**
     * Converts this Error to JSON.
     * @function toJSON
     * @memberof LastProtos.Error
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Error.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Code enum.
     * @name LastProtos.Error.Code
     * @enum {number}
     * @property {number} ERROR=0 ERROR value
     * @property {number} UNKNOWN_SYMBOL=1 UNKNOWN_SYMBOL value
     */
    Error.Code = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'ERROR')] = 0;
      values[(valuesById[1] = 'UNKNOWN_SYMBOL')] = 1;
      return values;
    })();

    return Error;
  })();

  LastProtos.MoversRequest = (function () {
    /**
     * Properties of a MoversRequest.
     * @memberof LastProtos
     * @interface IMoversRequest
     * @property {string|null} [from] MoversRequest from
     * @property {string|null} [to] MoversRequest to
     * @property {string|null} [asOf] MoversRequest asOf
     * @property {string|null} [session] MoversRequest session
     * @property {string|null} [indexFilter] MoversRequest indexFilter
     * @property {string|null} [screenerQuery] MoversRequest screenerQuery
     * @property {number|null} [maxResults] MoversRequest maxResults
     * @property {LastProtos.MoversRequest.SortField|null} [sortField] MoversRequest sortField
     * @property {string|null} [moversQuery] MoversRequest moversQuery
     * @property {boolean|null} [gainers] MoversRequest gainers
     * @property {boolean|null} [losers] MoversRequest losers
     */

    /**
     * Constructs a new MoversRequest.
     * @memberof LastProtos
     * @classdesc Represents a MoversRequest.
     * @implements IMoversRequest
     * @constructor
     * @param {LastProtos.IMoversRequest=} [properties] Properties to set
     */
    function MoversRequest(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * MoversRequest from.
     * @member {string} from
     * @memberof LastProtos.MoversRequest
     * @instance
     */
    MoversRequest.prototype.from = '';

    /**
     * MoversRequest to.
     * @member {string} to
     * @memberof LastProtos.MoversRequest
     * @instance
     */
    MoversRequest.prototype.to = '';

    /**
     * MoversRequest asOf.
     * @member {string} asOf
     * @memberof LastProtos.MoversRequest
     * @instance
     */
    MoversRequest.prototype.asOf = '';

    /**
     * MoversRequest session.
     * @member {string} session
     * @memberof LastProtos.MoversRequest
     * @instance
     */
    MoversRequest.prototype.session = '';

    /**
     * MoversRequest indexFilter.
     * @member {string} indexFilter
     * @memberof LastProtos.MoversRequest
     * @instance
     */
    MoversRequest.prototype.indexFilter = '';

    /**
     * MoversRequest screenerQuery.
     * @member {string} screenerQuery
     * @memberof LastProtos.MoversRequest
     * @instance
     */
    MoversRequest.prototype.screenerQuery = '';

    /**
     * MoversRequest maxResults.
     * @member {number} maxResults
     * @memberof LastProtos.MoversRequest
     * @instance
     */
    MoversRequest.prototype.maxResults = 0;

    /**
     * MoversRequest sortField.
     * @member {LastProtos.MoversRequest.SortField} sortField
     * @memberof LastProtos.MoversRequest
     * @instance
     */
    MoversRequest.prototype.sortField = 0;

    /**
     * MoversRequest moversQuery.
     * @member {string} moversQuery
     * @memberof LastProtos.MoversRequest
     * @instance
     */
    MoversRequest.prototype.moversQuery = '';

    /**
     * MoversRequest gainers.
     * @member {boolean} gainers
     * @memberof LastProtos.MoversRequest
     * @instance
     */
    MoversRequest.prototype.gainers = false;

    /**
     * MoversRequest losers.
     * @member {boolean} losers
     * @memberof LastProtos.MoversRequest
     * @instance
     */
    MoversRequest.prototype.losers = false;

    /**
     * Creates a new MoversRequest instance using the specified properties.
     * @function create
     * @memberof LastProtos.MoversRequest
     * @static
     * @param {LastProtos.IMoversRequest=} [properties] Properties to set
     * @returns {LastProtos.MoversRequest} MoversRequest instance
     */
    MoversRequest.create = function create(properties) {
      return new MoversRequest(properties);
    };

    /**
     * Encodes the specified MoversRequest message. Does not implicitly {@link LastProtos.MoversRequest.verify|verify} messages.
     * @function encode
     * @memberof LastProtos.MoversRequest
     * @static
     * @param {LastProtos.IMoversRequest} message MoversRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoversRequest.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.from != null && Object.hasOwnProperty.call(message, 'from'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.from);
      if (message.to != null && Object.hasOwnProperty.call(message, 'to'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.to);
      if (message.asOf != null && Object.hasOwnProperty.call(message, 'asOf'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.asOf);
      if (message.session != null && Object.hasOwnProperty.call(message, 'session'))
        writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.session);
      if (message.indexFilter != null && Object.hasOwnProperty.call(message, 'indexFilter'))
        writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.indexFilter);
      if (message.screenerQuery != null && Object.hasOwnProperty.call(message, 'screenerQuery'))
        writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.screenerQuery);
      if (message.maxResults != null && Object.hasOwnProperty.call(message, 'maxResults'))
        writer.uint32(/* id 7, wireType 0 =*/ 56).int32(message.maxResults);
      if (message.sortField != null && Object.hasOwnProperty.call(message, 'sortField'))
        writer.uint32(/* id 8, wireType 0 =*/ 64).int32(message.sortField);
      if (message.moversQuery != null && Object.hasOwnProperty.call(message, 'moversQuery'))
        writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.moversQuery);
      if (message.gainers != null && Object.hasOwnProperty.call(message, 'gainers'))
        writer.uint32(/* id 10, wireType 0 =*/ 80).bool(message.gainers);
      if (message.losers != null && Object.hasOwnProperty.call(message, 'losers'))
        writer.uint32(/* id 11, wireType 0 =*/ 88).bool(message.losers);
      return writer;
    };

    /**
     * Encodes the specified MoversRequest message, length delimited. Does not implicitly {@link LastProtos.MoversRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LastProtos.MoversRequest
     * @static
     * @param {LastProtos.IMoversRequest} message MoversRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoversRequest.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MoversRequest message from the specified reader or buffer.
     * @function decode
     * @memberof LastProtos.MoversRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LastProtos.MoversRequest} MoversRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoversRequest.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.LastProtos.MoversRequest();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.from = reader.string();
            break;
          }
          case 2: {
            message.to = reader.string();
            break;
          }
          case 3: {
            message.asOf = reader.string();
            break;
          }
          case 4: {
            message.session = reader.string();
            break;
          }
          case 5: {
            message.indexFilter = reader.string();
            break;
          }
          case 6: {
            message.screenerQuery = reader.string();
            break;
          }
          case 7: {
            message.maxResults = reader.int32();
            break;
          }
          case 8: {
            message.sortField = reader.int32();
            break;
          }
          case 9: {
            message.moversQuery = reader.string();
            break;
          }
          case 10: {
            message.gainers = reader.bool();
            break;
          }
          case 11: {
            message.losers = reader.bool();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a MoversRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LastProtos.MoversRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LastProtos.MoversRequest} MoversRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoversRequest.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MoversRequest message.
     * @function verify
     * @memberof LastProtos.MoversRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MoversRequest.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.from != null && message.hasOwnProperty('from'))
        if (!$util.isString(message.from)) return 'from: string expected';
      if (message.to != null && message.hasOwnProperty('to'))
        if (!$util.isString(message.to)) return 'to: string expected';
      if (message.asOf != null && message.hasOwnProperty('asOf'))
        if (!$util.isString(message.asOf)) return 'asOf: string expected';
      if (message.session != null && message.hasOwnProperty('session'))
        if (!$util.isString(message.session)) return 'session: string expected';
      if (message.indexFilter != null && message.hasOwnProperty('indexFilter'))
        if (!$util.isString(message.indexFilter)) return 'indexFilter: string expected';
      if (message.screenerQuery != null && message.hasOwnProperty('screenerQuery'))
        if (!$util.isString(message.screenerQuery)) return 'screenerQuery: string expected';
      if (message.maxResults != null && message.hasOwnProperty('maxResults'))
        if (!$util.isInteger(message.maxResults)) return 'maxResults: integer expected';
      if (message.sortField != null && message.hasOwnProperty('sortField'))
        switch (message.sortField) {
          default:
            return 'sortField: enum value expected';
          case 0:
          case 1:
            break;
        }
      if (message.moversQuery != null && message.hasOwnProperty('moversQuery'))
        if (!$util.isString(message.moversQuery)) return 'moversQuery: string expected';
      if (message.gainers != null && message.hasOwnProperty('gainers'))
        if (typeof message.gainers !== 'boolean') return 'gainers: boolean expected';
      if (message.losers != null && message.hasOwnProperty('losers'))
        if (typeof message.losers !== 'boolean') return 'losers: boolean expected';
      return null;
    };

    /**
     * Creates a MoversRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LastProtos.MoversRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LastProtos.MoversRequest} MoversRequest
     */
    MoversRequest.fromObject = function fromObject(object) {
      if (object instanceof $root.LastProtos.MoversRequest) return object;
      let message = new $root.LastProtos.MoversRequest();
      if (object.from != null) message.from = String(object.from);
      if (object.to != null) message.to = String(object.to);
      if (object.asOf != null) message.asOf = String(object.asOf);
      if (object.session != null) message.session = String(object.session);
      if (object.indexFilter != null) message.indexFilter = String(object.indexFilter);
      if (object.screenerQuery != null) message.screenerQuery = String(object.screenerQuery);
      if (object.maxResults != null) message.maxResults = object.maxResults | 0;
      switch (object.sortField) {
        default:
          if (typeof object.sortField === 'number') {
            message.sortField = object.sortField;
            break;
          }
          break;
        case 'CHANGE_PERCENT':
        case 0:
          message.sortField = 0;
          break;
        case 'ATR_RATIO':
        case 1:
          message.sortField = 1;
          break;
      }
      if (object.moversQuery != null) message.moversQuery = String(object.moversQuery);
      if (object.gainers != null) message.gainers = Boolean(object.gainers);
      if (object.losers != null) message.losers = Boolean(object.losers);
      return message;
    };

    /**
     * Creates a plain object from a MoversRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LastProtos.MoversRequest
     * @static
     * @param {LastProtos.MoversRequest} message MoversRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MoversRequest.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.from = '';
        object.to = '';
        object.asOf = '';
        object.session = '';
        object.indexFilter = '';
        object.screenerQuery = '';
        object.maxResults = 0;
        object.sortField = options.enums === String ? 'CHANGE_PERCENT' : 0;
        object.moversQuery = '';
        object.gainers = false;
        object.losers = false;
      }
      if (message.from != null && message.hasOwnProperty('from')) object.from = message.from;
      if (message.to != null && message.hasOwnProperty('to')) object.to = message.to;
      if (message.asOf != null && message.hasOwnProperty('asOf')) object.asOf = message.asOf;
      if (message.session != null && message.hasOwnProperty('session')) object.session = message.session;
      if (message.indexFilter != null && message.hasOwnProperty('indexFilter'))
        object.indexFilter = message.indexFilter;
      if (message.screenerQuery != null && message.hasOwnProperty('screenerQuery'))
        object.screenerQuery = message.screenerQuery;
      if (message.maxResults != null && message.hasOwnProperty('maxResults')) object.maxResults = message.maxResults;
      if (message.sortField != null && message.hasOwnProperty('sortField'))
        object.sortField =
          options.enums === String
            ? $root.LastProtos.MoversRequest.SortField[message.sortField] === undefined
              ? message.sortField
              : $root.LastProtos.MoversRequest.SortField[message.sortField]
            : message.sortField;
      if (message.moversQuery != null && message.hasOwnProperty('moversQuery'))
        object.moversQuery = message.moversQuery;
      if (message.gainers != null && message.hasOwnProperty('gainers')) object.gainers = message.gainers;
      if (message.losers != null && message.hasOwnProperty('losers')) object.losers = message.losers;
      return object;
    };

    /**
     * Converts this MoversRequest to JSON.
     * @function toJSON
     * @memberof LastProtos.MoversRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MoversRequest.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * SortField enum.
     * @name LastProtos.MoversRequest.SortField
     * @enum {number}
     * @property {number} CHANGE_PERCENT=0 CHANGE_PERCENT value
     * @property {number} ATR_RATIO=1 ATR_RATIO value
     */
    MoversRequest.SortField = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = 'CHANGE_PERCENT')] = 0;
      values[(valuesById[1] = 'ATR_RATIO')] = 1;
      return values;
    })();

    return MoversRequest;
  })();

  LastProtos.MoversResponse = (function () {
    /**
     * Properties of a MoversResponse.
     * @memberof LastProtos
     * @interface IMoversResponse
     * @property {number|null} [processingTimeMillis] MoversResponse processingTimeMillis
     * @property {LastProtos.IError|null} [error] MoversResponse error
     * @property {LastProtos.IMoversResult|null} [result] MoversResponse result
     */

    /**
     * Constructs a new MoversResponse.
     * @memberof LastProtos
     * @classdesc Represents a MoversResponse.
     * @implements IMoversResponse
     * @constructor
     * @param {LastProtos.IMoversResponse=} [properties] Properties to set
     */
    function MoversResponse(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * MoversResponse processingTimeMillis.
     * @member {number} processingTimeMillis
     * @memberof LastProtos.MoversResponse
     * @instance
     */
    MoversResponse.prototype.processingTimeMillis = 0;

    /**
     * MoversResponse error.
     * @member {LastProtos.IError|null|undefined} error
     * @memberof LastProtos.MoversResponse
     * @instance
     */
    MoversResponse.prototype.error = null;

    /**
     * MoversResponse result.
     * @member {LastProtos.IMoversResult|null|undefined} result
     * @memberof LastProtos.MoversResponse
     * @instance
     */
    MoversResponse.prototype.result = null;

    /**
     * Creates a new MoversResponse instance using the specified properties.
     * @function create
     * @memberof LastProtos.MoversResponse
     * @static
     * @param {LastProtos.IMoversResponse=} [properties] Properties to set
     * @returns {LastProtos.MoversResponse} MoversResponse instance
     */
    MoversResponse.create = function create(properties) {
      return new MoversResponse(properties);
    };

    /**
     * Encodes the specified MoversResponse message. Does not implicitly {@link LastProtos.MoversResponse.verify|verify} messages.
     * @function encode
     * @memberof LastProtos.MoversResponse
     * @static
     * @param {LastProtos.IMoversResponse} message MoversResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoversResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.processingTimeMillis != null && Object.hasOwnProperty.call(message, 'processingTimeMillis'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.processingTimeMillis);
      if (message.error != null && Object.hasOwnProperty.call(message, 'error'))
        $root.LastProtos.Error.encode(message.error, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
      if (message.result != null && Object.hasOwnProperty.call(message, 'result'))
        $root.LastProtos.MoversResult.encode(message.result, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified MoversResponse message, length delimited. Does not implicitly {@link LastProtos.MoversResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LastProtos.MoversResponse
     * @static
     * @param {LastProtos.IMoversResponse} message MoversResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoversResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MoversResponse message from the specified reader or buffer.
     * @function decode
     * @memberof LastProtos.MoversResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LastProtos.MoversResponse} MoversResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoversResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.LastProtos.MoversResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.processingTimeMillis = reader.int32();
            break;
          }
          case 2: {
            message.error = $root.LastProtos.Error.decode(reader, reader.uint32());
            break;
          }
          case 3: {
            message.result = $root.LastProtos.MoversResult.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a MoversResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LastProtos.MoversResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LastProtos.MoversResponse} MoversResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoversResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MoversResponse message.
     * @function verify
     * @memberof LastProtos.MoversResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MoversResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.processingTimeMillis != null && message.hasOwnProperty('processingTimeMillis'))
        if (!$util.isInteger(message.processingTimeMillis)) return 'processingTimeMillis: integer expected';
      if (message.error != null && message.hasOwnProperty('error')) {
        let error = $root.LastProtos.Error.verify(message.error);
        if (error) return 'error.' + error;
      }
      if (message.result != null && message.hasOwnProperty('result')) {
        let error = $root.LastProtos.MoversResult.verify(message.result);
        if (error) return 'result.' + error;
      }
      return null;
    };

    /**
     * Creates a MoversResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LastProtos.MoversResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LastProtos.MoversResponse} MoversResponse
     */
    MoversResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.LastProtos.MoversResponse) return object;
      let message = new $root.LastProtos.MoversResponse();
      if (object.processingTimeMillis != null) message.processingTimeMillis = object.processingTimeMillis | 0;
      if (object.error != null) {
        if (typeof object.error !== 'object') throw TypeError('.LastProtos.MoversResponse.error: object expected');
        message.error = $root.LastProtos.Error.fromObject(object.error);
      }
      if (object.result != null) {
        if (typeof object.result !== 'object') throw TypeError('.LastProtos.MoversResponse.result: object expected');
        message.result = $root.LastProtos.MoversResult.fromObject(object.result);
      }
      return message;
    };

    /**
     * Creates a plain object from a MoversResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LastProtos.MoversResponse
     * @static
     * @param {LastProtos.MoversResponse} message MoversResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MoversResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.processingTimeMillis = 0;
        object.error = null;
        object.result = null;
      }
      if (message.processingTimeMillis != null && message.hasOwnProperty('processingTimeMillis'))
        object.processingTimeMillis = message.processingTimeMillis;
      if (message.error != null && message.hasOwnProperty('error'))
        object.error = $root.LastProtos.Error.toObject(message.error, options);
      if (message.result != null && message.hasOwnProperty('result'))
        object.result = $root.LastProtos.MoversResult.toObject(message.result, options);
      return object;
    };

    /**
     * Converts this MoversResponse to JSON.
     * @function toJSON
     * @memberof LastProtos.MoversResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MoversResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoversResponse;
  })();

  LastProtos.MoversResult = (function () {
    /**
     * Properties of a MoversResult.
     * @memberof LastProtos
     * @interface IMoversResult
     * @property {string|null} [fromDate] MoversResult fromDate
     * @property {string|null} [toDate] MoversResult toDate
     * @property {string|null} [snapFrom] MoversResult snapFrom
     * @property {string|null} [snapTo] MoversResult snapTo
     * @property {boolean|null} [usePreviousClose] MoversResult usePreviousClose
     * @property {boolean|null} [inReset] MoversResult inReset
     * @property {Array.<LastProtos.MoversResult.IMover>|null} [gainers] MoversResult gainers
     * @property {Array.<LastProtos.MoversResult.IMover>|null} [losers] MoversResult losers
     */

    /**
     * Constructs a new MoversResult.
     * @memberof LastProtos
     * @classdesc Represents a MoversResult.
     * @implements IMoversResult
     * @constructor
     * @param {LastProtos.IMoversResult=} [properties] Properties to set
     */
    function MoversResult(properties) {
      this.gainers = [];
      this.losers = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * MoversResult fromDate.
     * @member {string} fromDate
     * @memberof LastProtos.MoversResult
     * @instance
     */
    MoversResult.prototype.fromDate = '';

    /**
     * MoversResult toDate.
     * @member {string} toDate
     * @memberof LastProtos.MoversResult
     * @instance
     */
    MoversResult.prototype.toDate = '';

    /**
     * MoversResult snapFrom.
     * @member {string} snapFrom
     * @memberof LastProtos.MoversResult
     * @instance
     */
    MoversResult.prototype.snapFrom = '';

    /**
     * MoversResult snapTo.
     * @member {string} snapTo
     * @memberof LastProtos.MoversResult
     * @instance
     */
    MoversResult.prototype.snapTo = '';

    /**
     * MoversResult usePreviousClose.
     * @member {boolean} usePreviousClose
     * @memberof LastProtos.MoversResult
     * @instance
     */
    MoversResult.prototype.usePreviousClose = false;

    /**
     * MoversResult inReset.
     * @member {boolean} inReset
     * @memberof LastProtos.MoversResult
     * @instance
     */
    MoversResult.prototype.inReset = false;

    /**
     * MoversResult gainers.
     * @member {Array.<LastProtos.MoversResult.IMover>} gainers
     * @memberof LastProtos.MoversResult
     * @instance
     */
    MoversResult.prototype.gainers = $util.emptyArray;

    /**
     * MoversResult losers.
     * @member {Array.<LastProtos.MoversResult.IMover>} losers
     * @memberof LastProtos.MoversResult
     * @instance
     */
    MoversResult.prototype.losers = $util.emptyArray;

    /**
     * Creates a new MoversResult instance using the specified properties.
     * @function create
     * @memberof LastProtos.MoversResult
     * @static
     * @param {LastProtos.IMoversResult=} [properties] Properties to set
     * @returns {LastProtos.MoversResult} MoversResult instance
     */
    MoversResult.create = function create(properties) {
      return new MoversResult(properties);
    };

    /**
     * Encodes the specified MoversResult message. Does not implicitly {@link LastProtos.MoversResult.verify|verify} messages.
     * @function encode
     * @memberof LastProtos.MoversResult
     * @static
     * @param {LastProtos.IMoversResult} message MoversResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoversResult.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.fromDate != null && Object.hasOwnProperty.call(message, 'fromDate'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.fromDate);
      if (message.toDate != null && Object.hasOwnProperty.call(message, 'toDate'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.toDate);
      if (message.snapFrom != null && Object.hasOwnProperty.call(message, 'snapFrom'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.snapFrom);
      if (message.snapTo != null && Object.hasOwnProperty.call(message, 'snapTo'))
        writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.snapTo);
      if (message.usePreviousClose != null && Object.hasOwnProperty.call(message, 'usePreviousClose'))
        writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.usePreviousClose);
      if (message.inReset != null && Object.hasOwnProperty.call(message, 'inReset'))
        writer.uint32(/* id 6, wireType 0 =*/ 48).bool(message.inReset);
      if (message.gainers != null && message.gainers.length)
        for (let i = 0; i < message.gainers.length; ++i)
          $root.LastProtos.MoversResult.Mover.encode(
            message.gainers[i],
            writer.uint32(/* id 7, wireType 2 =*/ 58).fork(),
          ).ldelim();
      if (message.losers != null && message.losers.length)
        for (let i = 0; i < message.losers.length; ++i)
          $root.LastProtos.MoversResult.Mover.encode(
            message.losers[i],
            writer.uint32(/* id 8, wireType 2 =*/ 66).fork(),
          ).ldelim();
      return writer;
    };

    /**
     * Encodes the specified MoversResult message, length delimited. Does not implicitly {@link LastProtos.MoversResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LastProtos.MoversResult
     * @static
     * @param {LastProtos.IMoversResult} message MoversResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoversResult.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MoversResult message from the specified reader or buffer.
     * @function decode
     * @memberof LastProtos.MoversResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LastProtos.MoversResult} MoversResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoversResult.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.LastProtos.MoversResult();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.fromDate = reader.string();
            break;
          }
          case 2: {
            message.toDate = reader.string();
            break;
          }
          case 3: {
            message.snapFrom = reader.string();
            break;
          }
          case 4: {
            message.snapTo = reader.string();
            break;
          }
          case 5: {
            message.usePreviousClose = reader.bool();
            break;
          }
          case 6: {
            message.inReset = reader.bool();
            break;
          }
          case 7: {
            if (!(message.gainers && message.gainers.length)) message.gainers = [];
            message.gainers.push($root.LastProtos.MoversResult.Mover.decode(reader, reader.uint32()));
            break;
          }
          case 8: {
            if (!(message.losers && message.losers.length)) message.losers = [];
            message.losers.push($root.LastProtos.MoversResult.Mover.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a MoversResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LastProtos.MoversResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LastProtos.MoversResult} MoversResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoversResult.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MoversResult message.
     * @function verify
     * @memberof LastProtos.MoversResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MoversResult.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.fromDate != null && message.hasOwnProperty('fromDate'))
        if (!$util.isString(message.fromDate)) return 'fromDate: string expected';
      if (message.toDate != null && message.hasOwnProperty('toDate'))
        if (!$util.isString(message.toDate)) return 'toDate: string expected';
      if (message.snapFrom != null && message.hasOwnProperty('snapFrom'))
        if (!$util.isString(message.snapFrom)) return 'snapFrom: string expected';
      if (message.snapTo != null && message.hasOwnProperty('snapTo'))
        if (!$util.isString(message.snapTo)) return 'snapTo: string expected';
      if (message.usePreviousClose != null && message.hasOwnProperty('usePreviousClose'))
        if (typeof message.usePreviousClose !== 'boolean') return 'usePreviousClose: boolean expected';
      if (message.inReset != null && message.hasOwnProperty('inReset'))
        if (typeof message.inReset !== 'boolean') return 'inReset: boolean expected';
      if (message.gainers != null && message.hasOwnProperty('gainers')) {
        if (!Array.isArray(message.gainers)) return 'gainers: array expected';
        for (let i = 0; i < message.gainers.length; ++i) {
          let error = $root.LastProtos.MoversResult.Mover.verify(message.gainers[i]);
          if (error) return 'gainers.' + error;
        }
      }
      if (message.losers != null && message.hasOwnProperty('losers')) {
        if (!Array.isArray(message.losers)) return 'losers: array expected';
        for (let i = 0; i < message.losers.length; ++i) {
          let error = $root.LastProtos.MoversResult.Mover.verify(message.losers[i]);
          if (error) return 'losers.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a MoversResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LastProtos.MoversResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LastProtos.MoversResult} MoversResult
     */
    MoversResult.fromObject = function fromObject(object) {
      if (object instanceof $root.LastProtos.MoversResult) return object;
      let message = new $root.LastProtos.MoversResult();
      if (object.fromDate != null) message.fromDate = String(object.fromDate);
      if (object.toDate != null) message.toDate = String(object.toDate);
      if (object.snapFrom != null) message.snapFrom = String(object.snapFrom);
      if (object.snapTo != null) message.snapTo = String(object.snapTo);
      if (object.usePreviousClose != null) message.usePreviousClose = Boolean(object.usePreviousClose);
      if (object.inReset != null) message.inReset = Boolean(object.inReset);
      if (object.gainers) {
        if (!Array.isArray(object.gainers)) throw TypeError('.LastProtos.MoversResult.gainers: array expected');
        message.gainers = [];
        for (let i = 0; i < object.gainers.length; ++i) {
          if (typeof object.gainers[i] !== 'object')
            throw TypeError('.LastProtos.MoversResult.gainers: object expected');
          message.gainers[i] = $root.LastProtos.MoversResult.Mover.fromObject(object.gainers[i]);
        }
      }
      if (object.losers) {
        if (!Array.isArray(object.losers)) throw TypeError('.LastProtos.MoversResult.losers: array expected');
        message.losers = [];
        for (let i = 0; i < object.losers.length; ++i) {
          if (typeof object.losers[i] !== 'object') throw TypeError('.LastProtos.MoversResult.losers: object expected');
          message.losers[i] = $root.LastProtos.MoversResult.Mover.fromObject(object.losers[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a MoversResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LastProtos.MoversResult
     * @static
     * @param {LastProtos.MoversResult} message MoversResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MoversResult.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) {
        object.gainers = [];
        object.losers = [];
      }
      if (options.defaults) {
        object.fromDate = '';
        object.toDate = '';
        object.snapFrom = '';
        object.snapTo = '';
        object.usePreviousClose = false;
        object.inReset = false;
      }
      if (message.fromDate != null && message.hasOwnProperty('fromDate')) object.fromDate = message.fromDate;
      if (message.toDate != null && message.hasOwnProperty('toDate')) object.toDate = message.toDate;
      if (message.snapFrom != null && message.hasOwnProperty('snapFrom')) object.snapFrom = message.snapFrom;
      if (message.snapTo != null && message.hasOwnProperty('snapTo')) object.snapTo = message.snapTo;
      if (message.usePreviousClose != null && message.hasOwnProperty('usePreviousClose'))
        object.usePreviousClose = message.usePreviousClose;
      if (message.inReset != null && message.hasOwnProperty('inReset')) object.inReset = message.inReset;
      if (message.gainers && message.gainers.length) {
        object.gainers = [];
        for (let j = 0; j < message.gainers.length; ++j)
          object.gainers[j] = $root.LastProtos.MoversResult.Mover.toObject(message.gainers[j], options);
      }
      if (message.losers && message.losers.length) {
        object.losers = [];
        for (let j = 0; j < message.losers.length; ++j)
          object.losers[j] = $root.LastProtos.MoversResult.Mover.toObject(message.losers[j], options);
      }
      return object;
    };

    /**
     * Converts this MoversResult to JSON.
     * @function toJSON
     * @memberof LastProtos.MoversResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MoversResult.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    MoversResult.Mover = (function () {
      /**
       * Properties of a Mover.
       * @memberof LastProtos.MoversResult
       * @interface IMover
       * @property {string|null} [symbol] Mover symbol
       * @property {number|null} [price] Mover price
       * @property {number|null} [change] Mover change
       * @property {number|null} [changePercent] Mover changePercent
       * @property {number|Long|null} [volume] Mover volume
       * @property {number|null} [close] Mover close
       * @property {number|null} [atr] Mover atr
       * @property {number|null} [atrRatio] Mover atrRatio
       * @property {string|null} [companyName] Mover companyName
       * @property {number|null} [averageVolume] Mover averageVolume
       * @property {number|null} [previousClose] Mover previousClose
       * @property {string|null} [sector] Mover sector
       * @property {number|Long|null} [marketCap] Mover marketCap
       * @property {string|null} [gicsSectorName] Mover gicsSectorName
       * @property {number|Long|null} [shareFloat] Mover shareFloat
       * @property {string|null} [isin] Mover isin
       */

      /**
       * Constructs a new Mover.
       * @memberof LastProtos.MoversResult
       * @classdesc Represents a Mover.
       * @implements IMover
       * @constructor
       * @param {LastProtos.MoversResult.IMover=} [properties] Properties to set
       */
      function Mover(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
      }

      /**
       * Mover symbol.
       * @member {string} symbol
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.symbol = '';

      /**
       * Mover price.
       * @member {number} price
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.price = 0;

      /**
       * Mover change.
       * @member {number} change
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.change = 0;

      /**
       * Mover changePercent.
       * @member {number} changePercent
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.changePercent = 0;

      /**
       * Mover volume.
       * @member {number|Long} volume
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.volume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

      /**
       * Mover close.
       * @member {number} close
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.close = 0;

      /**
       * Mover atr.
       * @member {number} atr
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.atr = 0;

      /**
       * Mover atrRatio.
       * @member {number} atrRatio
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.atrRatio = 0;

      /**
       * Mover companyName.
       * @member {string} companyName
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.companyName = '';

      /**
       * Mover averageVolume.
       * @member {number} averageVolume
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.averageVolume = 0;

      /**
       * Mover previousClose.
       * @member {number} previousClose
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.previousClose = 0;

      /**
       * Mover sector.
       * @member {string} sector
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.sector = '';

      /**
       * Mover marketCap.
       * @member {number|Long} marketCap
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.marketCap = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

      /**
       * Mover gicsSectorName.
       * @member {string} gicsSectorName
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.gicsSectorName = '';

      /**
       * Mover shareFloat.
       * @member {number|Long} shareFloat
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.shareFloat = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

      /**
       * Mover isin.
       * @member {string} isin
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       */
      Mover.prototype.isin = '';

      /**
       * Creates a new Mover instance using the specified properties.
       * @function create
       * @memberof LastProtos.MoversResult.Mover
       * @static
       * @param {LastProtos.MoversResult.IMover=} [properties] Properties to set
       * @returns {LastProtos.MoversResult.Mover} Mover instance
       */
      Mover.create = function create(properties) {
        return new Mover(properties);
      };

      /**
       * Encodes the specified Mover message. Does not implicitly {@link LastProtos.MoversResult.Mover.verify|verify} messages.
       * @function encode
       * @memberof LastProtos.MoversResult.Mover
       * @static
       * @param {LastProtos.MoversResult.IMover} message Mover message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Mover.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
        if (message.price != null && Object.hasOwnProperty.call(message, 'price'))
          writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.price);
        if (message.change != null && Object.hasOwnProperty.call(message, 'change'))
          writer.uint32(/* id 3, wireType 1 =*/ 25).double(message.change);
        if (message.changePercent != null && Object.hasOwnProperty.call(message, 'changePercent'))
          writer.uint32(/* id 4, wireType 1 =*/ 33).double(message.changePercent);
        if (message.volume != null && Object.hasOwnProperty.call(message, 'volume'))
          writer.uint32(/* id 5, wireType 0 =*/ 40).int64(message.volume);
        if (message.close != null && Object.hasOwnProperty.call(message, 'close'))
          writer.uint32(/* id 6, wireType 1 =*/ 49).double(message.close);
        if (message.atr != null && Object.hasOwnProperty.call(message, 'atr'))
          writer.uint32(/* id 7, wireType 1 =*/ 57).double(message.atr);
        if (message.atrRatio != null && Object.hasOwnProperty.call(message, 'atrRatio'))
          writer.uint32(/* id 8, wireType 1 =*/ 65).double(message.atrRatio);
        if (message.companyName != null && Object.hasOwnProperty.call(message, 'companyName'))
          writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.companyName);
        if (message.averageVolume != null && Object.hasOwnProperty.call(message, 'averageVolume'))
          writer.uint32(/* id 10, wireType 0 =*/ 80).int32(message.averageVolume);
        if (message.previousClose != null && Object.hasOwnProperty.call(message, 'previousClose'))
          writer.uint32(/* id 11, wireType 1 =*/ 89).double(message.previousClose);
        if (message.sector != null && Object.hasOwnProperty.call(message, 'sector'))
          writer.uint32(/* id 12, wireType 2 =*/ 98).string(message.sector);
        if (message.marketCap != null && Object.hasOwnProperty.call(message, 'marketCap'))
          writer.uint32(/* id 13, wireType 0 =*/ 104).int64(message.marketCap);
        if (message.gicsSectorName != null && Object.hasOwnProperty.call(message, 'gicsSectorName'))
          writer.uint32(/* id 14, wireType 2 =*/ 114).string(message.gicsSectorName);
        if (message.shareFloat != null && Object.hasOwnProperty.call(message, 'shareFloat'))
          writer.uint32(/* id 15, wireType 0 =*/ 120).int64(message.shareFloat);
        if (message.isin != null && Object.hasOwnProperty.call(message, 'isin'))
          writer.uint32(/* id 16, wireType 2 =*/ 130).string(message.isin);
        return writer;
      };

      /**
       * Encodes the specified Mover message, length delimited. Does not implicitly {@link LastProtos.MoversResult.Mover.verify|verify} messages.
       * @function encodeDelimited
       * @memberof LastProtos.MoversResult.Mover
       * @static
       * @param {LastProtos.MoversResult.IMover} message Mover message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      Mover.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
      };

      /**
       * Decodes a Mover message from the specified reader or buffer.
       * @function decode
       * @memberof LastProtos.MoversResult.Mover
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {LastProtos.MoversResult.Mover} Mover
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Mover.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.LastProtos.MoversResult.Mover();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.symbol = reader.string();
              break;
            }
            case 2: {
              message.price = reader.double();
              break;
            }
            case 3: {
              message.change = reader.double();
              break;
            }
            case 4: {
              message.changePercent = reader.double();
              break;
            }
            case 5: {
              message.volume = reader.int64();
              break;
            }
            case 6: {
              message.close = reader.double();
              break;
            }
            case 7: {
              message.atr = reader.double();
              break;
            }
            case 8: {
              message.atrRatio = reader.double();
              break;
            }
            case 9: {
              message.companyName = reader.string();
              break;
            }
            case 10: {
              message.averageVolume = reader.int32();
              break;
            }
            case 11: {
              message.previousClose = reader.double();
              break;
            }
            case 12: {
              message.sector = reader.string();
              break;
            }
            case 13: {
              message.marketCap = reader.int64();
              break;
            }
            case 14: {
              message.gicsSectorName = reader.string();
              break;
            }
            case 15: {
              message.shareFloat = reader.int64();
              break;
            }
            case 16: {
              message.isin = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      /**
       * Decodes a Mover message from the specified reader or buffer, length delimited.
       * @function decodeDelimited
       * @memberof LastProtos.MoversResult.Mover
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @returns {LastProtos.MoversResult.Mover} Mover
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      Mover.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader)) reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
      };

      /**
       * Verifies a Mover message.
       * @function verify
       * @memberof LastProtos.MoversResult.Mover
       * @static
       * @param {Object.<string,*>} message Plain object to verify
       * @returns {string|null} `null` if valid, otherwise the reason why it is not
       */
      Mover.verify = function verify(message) {
        if (typeof message !== 'object' || message === null) return 'object expected';
        if (message.symbol != null && message.hasOwnProperty('symbol'))
          if (!$util.isString(message.symbol)) return 'symbol: string expected';
        if (message.price != null && message.hasOwnProperty('price'))
          if (typeof message.price !== 'number') return 'price: number expected';
        if (message.change != null && message.hasOwnProperty('change'))
          if (typeof message.change !== 'number') return 'change: number expected';
        if (message.changePercent != null && message.hasOwnProperty('changePercent'))
          if (typeof message.changePercent !== 'number') return 'changePercent: number expected';
        if (message.volume != null && message.hasOwnProperty('volume'))
          if (
            !$util.isInteger(message.volume) &&
            !(message.volume && $util.isInteger(message.volume.low) && $util.isInteger(message.volume.high))
          )
            return 'volume: integer|Long expected';
        if (message.close != null && message.hasOwnProperty('close'))
          if (typeof message.close !== 'number') return 'close: number expected';
        if (message.atr != null && message.hasOwnProperty('atr'))
          if (typeof message.atr !== 'number') return 'atr: number expected';
        if (message.atrRatio != null && message.hasOwnProperty('atrRatio'))
          if (typeof message.atrRatio !== 'number') return 'atrRatio: number expected';
        if (message.companyName != null && message.hasOwnProperty('companyName'))
          if (!$util.isString(message.companyName)) return 'companyName: string expected';
        if (message.averageVolume != null && message.hasOwnProperty('averageVolume'))
          if (!$util.isInteger(message.averageVolume)) return 'averageVolume: integer expected';
        if (message.previousClose != null && message.hasOwnProperty('previousClose'))
          if (typeof message.previousClose !== 'number') return 'previousClose: number expected';
        if (message.sector != null && message.hasOwnProperty('sector'))
          if (!$util.isString(message.sector)) return 'sector: string expected';
        if (message.marketCap != null && message.hasOwnProperty('marketCap'))
          if (
            !$util.isInteger(message.marketCap) &&
            !(message.marketCap && $util.isInteger(message.marketCap.low) && $util.isInteger(message.marketCap.high))
          )
            return 'marketCap: integer|Long expected';
        if (message.gicsSectorName != null && message.hasOwnProperty('gicsSectorName'))
          if (!$util.isString(message.gicsSectorName)) return 'gicsSectorName: string expected';
        if (message.shareFloat != null && message.hasOwnProperty('shareFloat'))
          if (
            !$util.isInteger(message.shareFloat) &&
            !(message.shareFloat && $util.isInteger(message.shareFloat.low) && $util.isInteger(message.shareFloat.high))
          )
            return 'shareFloat: integer|Long expected';
        if (message.isin != null && message.hasOwnProperty('isin'))
          if (!$util.isString(message.isin)) return 'isin: string expected';
        return null;
      };

      /**
       * Creates a Mover message from a plain object. Also converts values to their respective internal types.
       * @function fromObject
       * @memberof LastProtos.MoversResult.Mover
       * @static
       * @param {Object.<string,*>} object Plain object
       * @returns {LastProtos.MoversResult.Mover} Mover
       */
      Mover.fromObject = function fromObject(object) {
        if (object instanceof $root.LastProtos.MoversResult.Mover) return object;
        let message = new $root.LastProtos.MoversResult.Mover();
        if (object.symbol != null) message.symbol = String(object.symbol);
        if (object.price != null) message.price = Number(object.price);
        if (object.change != null) message.change = Number(object.change);
        if (object.changePercent != null) message.changePercent = Number(object.changePercent);
        if (object.volume != null)
          if ($util.Long) (message.volume = $util.Long.fromValue(object.volume)).unsigned = false;
          else if (typeof object.volume === 'string') message.volume = parseInt(object.volume, 10);
          else if (typeof object.volume === 'number') message.volume = object.volume;
          else if (typeof object.volume === 'object')
            message.volume = new $util.LongBits(object.volume.low >>> 0, object.volume.high >>> 0).toNumber();
        if (object.close != null) message.close = Number(object.close);
        if (object.atr != null) message.atr = Number(object.atr);
        if (object.atrRatio != null) message.atrRatio = Number(object.atrRatio);
        if (object.companyName != null) message.companyName = String(object.companyName);
        if (object.averageVolume != null) message.averageVolume = object.averageVolume | 0;
        if (object.previousClose != null) message.previousClose = Number(object.previousClose);
        if (object.sector != null) message.sector = String(object.sector);
        if (object.marketCap != null)
          if ($util.Long) (message.marketCap = $util.Long.fromValue(object.marketCap)).unsigned = false;
          else if (typeof object.marketCap === 'string') message.marketCap = parseInt(object.marketCap, 10);
          else if (typeof object.marketCap === 'number') message.marketCap = object.marketCap;
          else if (typeof object.marketCap === 'object')
            message.marketCap = new $util.LongBits(object.marketCap.low >>> 0, object.marketCap.high >>> 0).toNumber();
        if (object.gicsSectorName != null) message.gicsSectorName = String(object.gicsSectorName);
        if (object.shareFloat != null)
          if ($util.Long) (message.shareFloat = $util.Long.fromValue(object.shareFloat)).unsigned = false;
          else if (typeof object.shareFloat === 'string') message.shareFloat = parseInt(object.shareFloat, 10);
          else if (typeof object.shareFloat === 'number') message.shareFloat = object.shareFloat;
          else if (typeof object.shareFloat === 'object')
            message.shareFloat = new $util.LongBits(
              object.shareFloat.low >>> 0,
              object.shareFloat.high >>> 0,
            ).toNumber();
        if (object.isin != null) message.isin = String(object.isin);
        return message;
      };

      /**
       * Creates a plain object from a Mover message. Also converts values to other types if specified.
       * @function toObject
       * @memberof LastProtos.MoversResult.Mover
       * @static
       * @param {LastProtos.MoversResult.Mover} message Mover
       * @param {$protobuf.IConversionOptions} [options] Conversion options
       * @returns {Object.<string,*>} Plain object
       */
      Mover.toObject = function toObject(message, options) {
        if (!options) options = {};
        let object = {};
        if (options.defaults) {
          object.symbol = '';
          object.price = 0;
          object.change = 0;
          object.changePercent = 0;
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.volume =
              options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else object.volume = options.longs === String ? '0' : 0;
          object.close = 0;
          object.atr = 0;
          object.atrRatio = 0;
          object.companyName = '';
          object.averageVolume = 0;
          object.previousClose = 0;
          object.sector = '';
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.marketCap =
              options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else object.marketCap = options.longs === String ? '0' : 0;
          object.gicsSectorName = '';
          if ($util.Long) {
            let long = new $util.Long(0, 0, false);
            object.shareFloat =
              options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
          } else object.shareFloat = options.longs === String ? '0' : 0;
          object.isin = '';
        }
        if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
        if (message.price != null && message.hasOwnProperty('price'))
          object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
        if (message.change != null && message.hasOwnProperty('change'))
          object.change = options.json && !isFinite(message.change) ? String(message.change) : message.change;
        if (message.changePercent != null && message.hasOwnProperty('changePercent'))
          object.changePercent =
            options.json && !isFinite(message.changePercent) ? String(message.changePercent) : message.changePercent;
        if (message.volume != null && message.hasOwnProperty('volume'))
          if (typeof message.volume === 'number')
            object.volume = options.longs === String ? String(message.volume) : message.volume;
          else
            object.volume =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.volume)
                : options.longs === Number
                  ? new $util.LongBits(message.volume.low >>> 0, message.volume.high >>> 0).toNumber()
                  : message.volume;
        if (message.close != null && message.hasOwnProperty('close'))
          object.close = options.json && !isFinite(message.close) ? String(message.close) : message.close;
        if (message.atr != null && message.hasOwnProperty('atr'))
          object.atr = options.json && !isFinite(message.atr) ? String(message.atr) : message.atr;
        if (message.atrRatio != null && message.hasOwnProperty('atrRatio'))
          object.atrRatio = options.json && !isFinite(message.atrRatio) ? String(message.atrRatio) : message.atrRatio;
        if (message.companyName != null && message.hasOwnProperty('companyName'))
          object.companyName = message.companyName;
        if (message.averageVolume != null && message.hasOwnProperty('averageVolume'))
          object.averageVolume = message.averageVolume;
        if (message.previousClose != null && message.hasOwnProperty('previousClose'))
          object.previousClose =
            options.json && !isFinite(message.previousClose) ? String(message.previousClose) : message.previousClose;
        if (message.sector != null && message.hasOwnProperty('sector')) object.sector = message.sector;
        if (message.marketCap != null && message.hasOwnProperty('marketCap'))
          if (typeof message.marketCap === 'number')
            object.marketCap = options.longs === String ? String(message.marketCap) : message.marketCap;
          else
            object.marketCap =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.marketCap)
                : options.longs === Number
                  ? new $util.LongBits(message.marketCap.low >>> 0, message.marketCap.high >>> 0).toNumber()
                  : message.marketCap;
        if (message.gicsSectorName != null && message.hasOwnProperty('gicsSectorName'))
          object.gicsSectorName = message.gicsSectorName;
        if (message.shareFloat != null && message.hasOwnProperty('shareFloat'))
          if (typeof message.shareFloat === 'number')
            object.shareFloat = options.longs === String ? String(message.shareFloat) : message.shareFloat;
          else
            object.shareFloat =
              options.longs === String
                ? $util.Long.prototype.toString.call(message.shareFloat)
                : options.longs === Number
                  ? new $util.LongBits(message.shareFloat.low >>> 0, message.shareFloat.high >>> 0).toNumber()
                  : message.shareFloat;
        if (message.isin != null && message.hasOwnProperty('isin')) object.isin = message.isin;
        return object;
      };

      /**
       * Converts this Mover to JSON.
       * @function toJSON
       * @memberof LastProtos.MoversResult.Mover
       * @instance
       * @returns {Object.<string,*>} JSON object
       */
      Mover.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
      };

      return Mover;
    })();

    return MoversResult;
  })();

  /**
   * TickType enum.
   * @name LastProtos.TickType
   * @enum {number}
   * @property {number} UNKNOWN=0 UNKNOWN value
   * @property {number} VALID=1 VALID value
   * @property {number} IN_VALID=2 IN_VALID value
   */
  LastProtos.TickType = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNKNOWN')] = 0;
    values[(valuesById[1] = 'VALID')] = 1;
    values[(valuesById[2] = 'IN_VALID')] = 2;
    return values;
  })();

  /**
   * QuoteSource enum.
   * @name LastProtos.QuoteSource
   * @enum {number}
   * @property {number} UNKNOWN_SOURCE=0 UNKNOWN_SOURCE value
   * @property {number} QUOTE_STORE=1 QUOTE_STORE value
   * @property {number} QUOTE_CALCULATOR=2 QUOTE_CALCULATOR value
   * @property {number} POLLED_DATA=3 POLLED_DATA value
   * @property {number} ROLLING_FIELDS=4 ROLLING_FIELDS value
   * @property {number} RSI_FIELDS=5 RSI_FIELDS value
   * @property {number} CONTENT_EVENT_PUBLISHER=6 CONTENT_EVENT_PUBLISHER value
   */
  LastProtos.QuoteSource = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = 'UNKNOWN_SOURCE')] = 0;
    values[(valuesById[1] = 'QUOTE_STORE')] = 1;
    values[(valuesById[2] = 'QUOTE_CALCULATOR')] = 2;
    values[(valuesById[3] = 'POLLED_DATA')] = 3;
    values[(valuesById[4] = 'ROLLING_FIELDS')] = 4;
    values[(valuesById[5] = 'RSI_FIELDS')] = 5;
    values[(valuesById[6] = 'CONTENT_EVENT_PUBLISHER')] = 6;
    return values;
  })();

  LastProtos.Quote = (function () {
    /**
     * Properties of a Quote.
     * @memberof LastProtos
     * @interface IQuote
     * @property {string|null} [symbol] Quote symbol
     * @property {string|null} [opol] Quote opol
     * @property {number|null} [previousClose] Quote previousClose
     * @property {number|null} [close] Quote close
     * @property {number|null} [change] Quote change
     * @property {number|null} [changePercent] Quote changePercent
     * @property {string|null} [name] Quote name
     * @property {string|null} [ipoDate] Quote ipoDate
     * @property {string|null} [exchange] Quote exchange
     * @property {string|null} [tradeExchange] Quote tradeExchange
     * @property {number|null} [preMarketOpen] Quote preMarketOpen
     * @property {number|Long|null} [preMarketOpenTime] Quote preMarketOpenTime
     * @property {number|Long|null} [preMarketVolume] Quote preMarketVolume
     * @property {number|null} [preMarketOpenChange] Quote preMarketOpenChange
     * @property {number|null} [preMarketOpenChangePercent] Quote preMarketOpenChangePercent
     * @property {LastProtos.QuoteSource|null} [source] Quote source
     * @property {Array.<number>|null} [clearFieldNumbers] Quote clearFieldNumbers
     * @property {number|Long|null} [marketCap] Quote marketCap
     * @property {number|null} [rsi] Quote rsi
     * @property {number|null} [atr] Quote atr
     * @property {number|null} [priceToEarnings] Quote priceToEarnings
     * @property {number|Long|null} [averageVolume] Quote averageVolume
     * @property {number|Long|null} [sharesOutstanding] Quote sharesOutstanding
     * @property {string|null} [sector] Quote sector
     * @property {number|null} [sectorCode] Quote sectorCode
     * @property {string|null} [industry] Quote industry
     * @property {number|null} [industryCode] Quote industryCode
     * @property {number|null} [forwardPERatio] Quote forwardPERatio
     * @property {number|null} [pricetoEBITDA] Quote pricetoEBITDA
     * @property {number|null} [trailingDividendYield] Quote trailingDividendYield
     * @property {number|null} [PBRatio] Quote PBRatio
     * @property {number|null} [priceToSales] Quote priceToSales
     * @property {number|null} [FCFPerShare] Quote FCFPerShare
     * @property {number|null} [buyBackYield] Quote buyBackYield
     * @property {number|null} [open] Quote open
     * @property {number|null} [price] Quote price
     * @property {number|null} [high] Quote high
     * @property {number|null} [low] Quote low
     * @property {number|Long|null} [time] Quote time
     * @property {number|null} [size] Quote size
     * @property {string|null} [type] Quote type
     * @property {number|Long|null} [dayVolume] Quote dayVolume
     * @property {number|null} [askPrice] Quote askPrice
     * @property {number|null} [bidPrice] Quote bidPrice
     * @property {string|null} [shareFloatDate] Quote shareFloatDate
     * @property {string|null} [sharesOutstandingDate] Quote sharesOutstandingDate
     * @property {number|Long|null} [shareFloat] Quote shareFloat
     * @property {LastProtos.TickType|null} [updateType] Quote updateType
     * @property {string|null} [subtype] Quote subtype
     * @property {LastProtos.SessionType|null} [sessionType] Quote sessionType
     * @property {number|Long|null} [volume] Quote volume
     * @property {number|null} [changePercent1Minute] Quote changePercent1Minute
     * @property {number|null} [changePercentClose] Quote changePercentClose
     * @property {number|null} [changePercent5Minute] Quote changePercent5Minute
     * @property {number|Long|null} [volume1Minute] Quote volume1Minute
     * @property {number|null} [relativeVolume1Minute] Quote relativeVolume1Minute
     * @property {number|null} [change15Minute] Quote change15Minute
     * @property {number|null} [changePercent15Minute] Quote changePercent15Minute
     * @property {number|null} [change30Minute] Quote change30Minute
     * @property {number|null} [changePercent30Minute] Quote changePercent30Minute
     * @property {number|null} [change60Minute] Quote change60Minute
     * @property {number|null} [changePercent60Minute] Quote changePercent60Minute
     * @property {number|null} [changePercentOpen] Quote changePercentOpen
     * @property {number|null} [changeOpen] Quote changeOpen
     * @property {number|null} [gics] Quote gics
     * @property {number|null} [gicsSector] Quote gicsSector
     * @property {string|null} [gicsSectorName] Quote gicsSectorName
     * @property {number|null} [gicsIndustryGroup] Quote gicsIndustryGroup
     * @property {string|null} [gicsIndustryGroupName] Quote gicsIndustryGroupName
     * @property {number|null} [gicsIndustry] Quote gicsIndustry
     * @property {string|null} [gicsIndustryName] Quote gicsIndustryName
     * @property {number|null} [gicsSubIndustry] Quote gicsSubIndustry
     * @property {string|null} [gicsSubIndustryName] Quote gicsSubIndustryName
     * @property {number|null} [optionable] Quote optionable
     * @property {number|null} [cik] Quote cik
     * @property {string|null} [signalName] Quote signalName
     * @property {number|Long|null} [lastTradeTime] Quote lastTradeTime
     * @property {string|null} [country] Quote country
     * @property {number|Long|null} [sharesShort] Quote sharesShort
     * @property {number|null} [sharesShortPercentOfFloat] Quote sharesShortPercentOfFloat
     * @property {number|null} [sharesShortChangePercent] Quote sharesShortChangePercent
     * @property {number|Long|null} [sharesShortReceiptDate] Quote sharesShortReceiptDate
     * @property {number|Long|null} [sharesShortSettlementDate] Quote sharesShortSettlementDate
     * @property {number|null} [shortInterestRatio] Quote shortInterestRatio
     * @property {number|null} [sharesShortValue] Quote sharesShortValue
     * @property {number|Long|null} [sharesShortPrevious] Quote sharesShortPrevious
     * @property {number|null} [sharesShortPreviousValue] Quote sharesShortPreviousValue
     * @property {number|null} [sharesShortPreviousPercentOfFloat] Quote sharesShortPreviousPercentOfFloat
     * @property {number|Long|null} [sharesShortChange] Quote sharesShortChange
     * @property {number|Long|null} [sentTime] Quote sentTime
     * @property {number|Long|null} [volume5Minute] Quote volume5Minute
     * @property {number|Long|null} [volume15Minute] Quote volume15Minute
     * @property {number|Long|null} [volume30Minute] Quote volume30Minute
     * @property {number|Long|null} [volume60Minute] Quote volume60Minute
     * @property {number|null} [relativeVolume5Minute] Quote relativeVolume5Minute
     * @property {number|null} [relativeVolume90Day] Quote relativeVolume90Day
     * @property {number|null} [rvol1m10d] Quote rvol1m10d
     * @property {number|null} [rvol5m10d] Quote rvol5m10d
     * @property {number|null} [rvol5m30d] Quote rvol5m30d
     * @property {number|null} [rvol5m90d] Quote rvol5m90d
     * @property {number|Long|null} [averageVolume10Day] Quote averageVolume10Day
     * @property {number|null} [averageVolumeChangePercent10Day] Quote averageVolumeChangePercent10Day
     * @property {number|null} [high10Day] Quote high10Day
     * @property {number|null} [highChangePercent10Day] Quote highChangePercent10Day
     * @property {number|null} [low10Day] Quote low10Day
     * @property {number|null} [lowChangePercent10Day] Quote lowChangePercent10Day
     * @property {number|null} [movingAverage10Day] Quote movingAverage10Day
     * @property {number|null} [movingAverageChangePercent10Day] Quote movingAverageChangePercent10Day
     * @property {number|Long|null} [averageVolume20Day] Quote averageVolume20Day
     * @property {number|null} [averageVolumeChangePercent20Day] Quote averageVolumeChangePercent20Day
     * @property {number|null} [high20Day] Quote high20Day
     * @property {number|null} [highChangePercent20Day] Quote highChangePercent20Day
     * @property {number|null} [low20Day] Quote low20Day
     * @property {number|null} [lowChangePercent20Day] Quote lowChangePercent20Day
     * @property {number|null} [movingAverage20Day] Quote movingAverage20Day
     * @property {number|null} [movingAverageChangePercent20Day] Quote movingAverageChangePercent20Day
     * @property {number|Long|null} [averageVolume50Day] Quote averageVolume50Day
     * @property {number|null} [averageVolumeChangePercent50Day] Quote averageVolumeChangePercent50Day
     * @property {number|null} [high50Day] Quote high50Day
     * @property {number|null} [highChangePercent50Day] Quote highChangePercent50Day
     * @property {number|null} [low50Day] Quote low50Day
     * @property {number|null} [lowChangePercent50Day] Quote lowChangePercent50Day
     * @property {number|null} [movingAverage50Day] Quote movingAverage50Day
     * @property {number|null} [movingAverageChangePercent50Day] Quote movingAverageChangePercent50Day
     * @property {number|Long|null} [averageVolume100Day] Quote averageVolume100Day
     * @property {number|null} [averageVolumeChangePercent100Day] Quote averageVolumeChangePercent100Day
     * @property {number|null} [high100Day] Quote high100Day
     * @property {number|null} [highChangePercent100Day] Quote highChangePercent100Day
     * @property {number|null} [low100Day] Quote low100Day
     * @property {number|null} [lowChangePercent100Day] Quote lowChangePercent100Day
     * @property {number|null} [movingAverage100Day] Quote movingAverage100Day
     * @property {number|null} [movingAverageChangePercent100Day] Quote movingAverageChangePercent100Day
     * @property {number|Long|null} [averageVolume200Day] Quote averageVolume200Day
     * @property {number|null} [averageVolumeChangePercent200Day] Quote averageVolumeChangePercent200Day
     * @property {number|null} [high200Day] Quote high200Day
     * @property {number|null} [highChangePercent200Day] Quote highChangePercent200Day
     * @property {number|null} [low200Day] Quote low200Day
     * @property {number|null} [lowChangePercent200Day] Quote lowChangePercent200Day
     * @property {number|null} [movingAverage200Day] Quote movingAverage200Day
     * @property {number|null} [movingAverageChangePercent200Day] Quote movingAverageChangePercent200Day
     * @property {number|null} [movingAverage250Day] Quote movingAverage250Day
     * @property {number|null} [movingAverageChangePercent250Day] Quote movingAverageChangePercent250Day
     * @property {number|Long|null} [averageVolume90Day] Quote averageVolume90Day
     * @property {number|null} [nextEarningsDate] Quote nextEarningsDate
     * @property {number|null} [dividend] Quote dividend
     * @property {number|null} [dividendYield] Quote dividendYield
     * @property {number|null} [dividendExDate] Quote dividendExDate
     * @property {number|Long|null} [dividendFrequency] Quote dividendFrequency
     * @property {number|null} [forwardDividendYield] Quote forwardDividendYield
     * @property {number|null} [roe] Quote roe
     * @property {number|null} [roa] Quote roa
     * @property {number|null} [roic] Quote roic
     * @property {number|null} [currentRatio] Quote currentRatio
     * @property {number|null} [grossMargin] Quote grossMargin
     * @property {number|null} [netMargin] Quote netMargin
     * @property {number|null} [operationMargin] Quote operationMargin
     * @property {number|null} [epsMrq] Quote epsMrq
     * @property {number|null} [epsTtm] Quote epsTtm
     * @property {number|null} [dilutedEpsMrq] Quote dilutedEpsMrq
     * @property {number|null} [dilutedEpsTtm] Quote dilutedEpsTtm
     * @property {number|null} [low52Week] Quote low52Week
     * @property {number|null} [high52Week] Quote high52Week
     * @property {number|null} [revenueTtm] Quote revenueTtm
     * @property {number|null} [earningsAsOf] Quote earningsAsOf
     * @property {number|null} [price1Week] Quote price1Week
     * @property {number|null} [priceChangePercent1Week] Quote priceChangePercent1Week
     * @property {number|null} [price1Month] Quote price1Month
     * @property {number|null} [priceChangePercent1Month] Quote priceChangePercent1Month
     * @property {number|null} [priceHalfYear] Quote priceHalfYear
     * @property {number|null} [priceChangePercentHalfYear] Quote priceChangePercentHalfYear
     * @property {number|null} [priceQuarter] Quote priceQuarter
     * @property {number|null} [priceChangePercentQuarter] Quote priceChangePercentQuarter
     * @property {number|null} [price1Year] Quote price1Year
     * @property {number|null} [priceChangePercent1Year] Quote priceChangePercent1Year
     * @property {number|null} [priceYearToDate] Quote priceYearToDate
     * @property {number|null} [priceChangePercentYearToDate] Quote priceChangePercentYearToDate
     * @property {number|null} [roeMrq] Quote roeMrq
     * @property {number|null} [roaMrq] Quote roaMrq
     * @property {number|null} [roicMrq] Quote roicMrq
     * @property {number|null} [currentRatioMrq] Quote currentRatioMrq
     * @property {number|null} [grossMarginMrq] Quote grossMarginMrq
     * @property {number|null} [netMarginMrq] Quote netMarginMrq
     * @property {number|null} [operationMarginMrq] Quote operationMarginMrq
     * @property {number|Long|null} [previousDayVolume] Quote previousDayVolume
     * @property {number|null} [previousDayAtr] Quote previousDayAtr
     * @property {number|null} [previousDayAdx] Quote previousDayAdx
     * @property {number|null} [previousDayPlusDMSmoothed] Quote previousDayPlusDMSmoothed
     * @property {number|null} [previousDayMinusDMSmoothed] Quote previousDayMinusDMSmoothed
     * @property {number|null} [previousDayHigh] Quote previousDayHigh
     * @property {number|null} [previousDayLow] Quote previousDayLow
     * @property {number|null} [adx] Quote adx
     * @property {number|null} [percentInstitutionalOwnership] Quote percentInstitutionalOwnership
     * @property {string|null} [wiim] Quote wiim
     * @property {number|Long|null} [wiimAsOf] Quote wiimAsOf
     * @property {number|null} [vwap] Quote vwap
     * @property {number|null} [vwapChangePercent] Quote vwapChangePercent
     * @property {number|null} [vwapChange] Quote vwapChange
     * @property {number|null} [rsiAvgGain] Quote rsiAvgGain
     * @property {number|null} [rsiAvgLoss] Quote rsiAvgLoss
     * @property {string|null} [halted] Quote halted
     * @property {number|Long|null} [tradeCount] Quote tradeCount
     * @property {number|Long|null} [regularHighCount] Quote regularHighCount
     * @property {number|Long|null} [regularLowCount] Quote regularLowCount
     * @property {number|Long|null} [preMarketHighCount] Quote preMarketHighCount
     * @property {number|Long|null} [preMarketLowCount] Quote preMarketLowCount
     * @property {number|Long|null} [afterMarketHighCount] Quote afterMarketHighCount
     * @property {number|Long|null} [afterMarketLowCount] Quote afterMarketLowCount
     * @property {number|Long|null} [dayHighCount] Quote dayHighCount
     * @property {number|Long|null} [dayLowCount] Quote dayLowCount
     * @property {number|null} [dayHigh] Quote dayHigh
     * @property {number|null} [dayLow] Quote dayLow
     * @property {number|null} [preMarketHigh] Quote preMarketHigh
     * @property {number|null} [preMarketLow] Quote preMarketLow
     * @property {number|null} [afterMarketHigh] Quote afterMarketHigh
     * @property {number|null} [afterMarketLow] Quote afterMarketLow
     * @property {number|null} [regularHigh] Quote regularHigh
     * @property {number|null} [regularLow] Quote regularLow
     * @property {number|Long|null} [priceSpikeUpCount] Quote priceSpikeUpCount
     * @property {number|Long|null} [priceSpikeDownCount] Quote priceSpikeDownCount
     * @property {number|Long|null} [haltedCount] Quote haltedCount
     * @property {number|null} [usCongressTotal] Quote usCongressTotal
     * @property {number|null} [usCongressRepublicansTotal] Quote usCongressRepublicansTotal
     * @property {number|null} [usCongressDemocratsTotal] Quote usCongressDemocratsTotal
     * @property {number|null} [usCongressOtherTotal] Quote usCongressOtherTotal
     * @property {number|null} [volumeFloatRatio] Quote volumeFloatRatio
     * @property {number|null} [atrp] Quote atrp
     * @property {number|null} [ytdGainLoss] Quote ytdGainLoss
     * @property {number|null} [mtdGainLoss] Quote mtdGainLoss
     * @property {number|null} [yearOpen] Quote yearOpen
     * @property {number|null} [monthOpen] Quote monthOpen
     * @property {number|null} [volumeFloatPercent] Quote volumeFloatPercent
     * @property {number|null} [ytdChange] Quote ytdChange
     * @property {number|null} [mtdChange] Quote mtdChange
     * @property {number|null} [rsi1m] Quote rsi1m
     * @property {number|null} [rsi2m] Quote rsi2m
     * @property {number|null} [rsi5m] Quote rsi5m
     * @property {number|null} [rsi15m] Quote rsi15m
     * @property {number|null} [rsi30m] Quote rsi30m
     * @property {number|null} [rsi60m] Quote rsi60m
     * @property {number|null} [rsiEth1m] Quote rsiEth1m
     * @property {number|null} [rsiEth2m] Quote rsiEth2m
     * @property {number|null} [rsiEth5m] Quote rsiEth5m
     * @property {number|null} [rsiEth15m] Quote rsiEth15m
     * @property {number|null} [rsiEth30m] Quote rsiEth30m
     * @property {number|null} [rsiEth60m] Quote rsiEth60m
     * @property {number|null} [averageDollarVolume10Day] Quote averageDollarVolume10Day
     * @property {number|Long|null} [averageVolume60Day] Quote averageVolume60Day
     * @property {number|null} [relativeVolumePercent60Day] Quote relativeVolumePercent60Day
     * @property {number|null} [ema12d] Quote ema12d
     * @property {number|null} [ema26d] Quote ema26d
     * @property {number|null} [macd] Quote macd
     * @property {number|null} [macdSignalLine] Quote macdSignalLine
     * @property {number|null} [macdHistogram] Quote macdHistogram
     * @property {number|null} [macdSignalLineBase] Quote macdSignalLineBase
     * @property {number|null} [dividendGrowthRate1Year] Quote dividendGrowthRate1Year
     * @property {number|null} [dividendGrowthRate3Year] Quote dividendGrowthRate3Year
     * @property {number|null} [dividendGrowthRate5Year] Quote dividendGrowthRate5Year
     * @property {string|null} [newsBzWireTitle] Quote newsBzWireTitle
     * @property {string|null} [newsBzWireNodeId] Quote newsBzWireNodeId
     * @property {number|Long|null} [newsBzWireTimestamp] Quote newsBzWireTimestamp
     * @property {string|null} [newsPRTitle] Quote newsPRTitle
     * @property {string|null} [newsPRNodeId] Quote newsPRNodeId
     * @property {number|Long|null} [newsPRTimestamp] Quote newsPRTimestamp
     * @property {string|null} [newsSecTitle] Quote newsSecTitle
     * @property {string|null} [newsSecNodeId] Quote newsSecNodeId
     * @property {number|Long|null} [newsSecTimestamp] Quote newsSecTimestamp
     * @property {number|null} [gapChange] Quote gapChange
     * @property {number|null} [gapChangePercent] Quote gapChangePercent
     * @property {number|null} [adr14d] Quote adr14d
     * @property {number|null} [movingAverage500Day] Quote movingAverage500Day
     * @property {number|null} [dilutedEpsMrqSurprisePercent] Quote dilutedEpsMrqSurprisePercent
     * @property {number|null} [dilutedEpsTtmSurprisePercent] Quote dilutedEpsTtmSurprisePercent
     * @property {number|null} [dilutedRevenueMrqSurprisePercent] Quote dilutedRevenueMrqSurprisePercent
     * @property {number|null} [dilutedRevenueTtmSurprisePercent] Quote dilutedRevenueTtmSurprisePercent
     * @property {number|null} [epsGrowthTtm] Quote epsGrowthTtm
     * @property {number|null} [epsGrowthY2Y] Quote epsGrowthY2Y
     * @property {number|null} [epsGrowthQ2Q] Quote epsGrowthQ2Q
     * @property {number|null} [epsGrowth5Year] Quote epsGrowth5Year
     * @property {number|null} [epsGrowthYearAgoQ] Quote epsGrowthYearAgoQ
     * @property {number|null} [revenueGrowthTtm] Quote revenueGrowthTtm
     * @property {number|null} [revenueGrowthY2Y] Quote revenueGrowthY2Y
     * @property {number|null} [revenueGrowthQ2Q] Quote revenueGrowthQ2Q
     * @property {number|null} [revenueGrowth5Year] Quote revenueGrowth5Year
     * @property {number|null} [revenueGrowthYearAgoQ] Quote revenueGrowthYearAgoQ
     * @property {number|null} [ltDebtEquity] Quote ltDebtEquity
     * @property {string|null} [bullsSay] Quote bullsSay
     * @property {string|null} [bearsSay] Quote bearsSay
     * @property {number|Long|null} [ipoDateNumber] Quote ipoDateNumber
     * @property {number|null} [ffoPerShare] Quote ffoPerShare
     * @property {number|null} [quickRatioMrq] Quote quickRatioMrq
     * @property {number|null} [highAllTime] Quote highAllTime
     * @property {number|null} [lowAllTime] Quote lowAllTime
     * @property {number|null} [totalDebtEquityRatio] Quote totalDebtEquityRatio
     * @property {number|null} [dividendPayoutRatio] Quote dividendPayoutRatio
     * @property {number|null} [operatingCashFlowPerShare] Quote operatingCashFlowPerShare
     * @property {number|null} [insiderPercentage] Quote insiderPercentage
     * @property {number|null} [priceToCashFlowRatio] Quote priceToCashFlowRatio
     * @property {number|null} [netProfitMargin] Quote netProfitMargin
     * @property {number|null} [regularHoursChange] Quote regularHoursChange
     * @property {number|null} [regularHoursPercentChange] Quote regularHoursPercentChange
     * @property {number|null} [postToPreHoursChange] Quote postToPreHoursChange
     * @property {number|null} [postToPreHoursPercentChange] Quote postToPreHoursPercentChange
     * @property {number|null} [scannerClose] Quote scannerClose
     * @property {number|null} [scannerChange] Quote scannerChange
     * @property {number|null} [scannerChangePercent] Quote scannerChangePercent
     * @property {number|null} [scannerChangePercentClose] Quote scannerChangePercentClose
     * @property {number|null} [scannerPreviousClose] Quote scannerPreviousClose
     * @property {number|null} [freeCashFlow] Quote freeCashFlow
     * @property {number|null} [minPriceTarget] Quote minPriceTarget
     * @property {number|null} [maxPriceTarget] Quote maxPriceTarget
     * @property {number|null} [meanPriceTarget] Quote meanPriceTarget
     * @property {number|null} [totalNumberOfAnalyst] Quote totalNumberOfAnalyst
     * @property {string|null} [averageAnalystRecommendation] Quote averageAnalystRecommendation
     * @property {number|null} [pegRatio] Quote pegRatio
     * @property {number|null} [priceToFreeCashFlowRatio] Quote priceToFreeCashFlowRatio
     * @property {number|null} [distanceToMaxPriceTarget] Quote distanceToMaxPriceTarget
     * @property {number|null} [distanceToMinPriceTarget] Quote distanceToMinPriceTarget
     * @property {number|null} [distanceToMeanPriceTarget] Quote distanceToMeanPriceTarget
     * @property {string|null} [shortTermTrend] Quote shortTermTrend
     * @property {string|null} [mediumTermTrend] Quote mediumTermTrend
     * @property {string|null} [longTermTrend] Quote longTermTrend
     */

    /**
     * Constructs a new Quote.
     * @memberof LastProtos
     * @classdesc Represents a Quote.
     * @implements IQuote
     * @constructor
     * @param {LastProtos.IQuote=} [properties] Properties to set
     */
    function Quote(properties) {
      this.clearFieldNumbers = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Quote symbol.
     * @member {string} symbol
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.symbol = '';

    /**
     * Quote opol.
     * @member {string} opol
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.opol = '';

    /**
     * Quote previousClose.
     * @member {number} previousClose
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.previousClose = 0;

    /**
     * Quote close.
     * @member {number} close
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.close = 0;

    /**
     * Quote change.
     * @member {number} change
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.change = 0;

    /**
     * Quote changePercent.
     * @member {number} changePercent
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.changePercent = 0;

    /**
     * Quote name.
     * @member {string} name
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.name = '';

    /**
     * Quote ipoDate.
     * @member {string} ipoDate
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.ipoDate = '';

    /**
     * Quote exchange.
     * @member {string} exchange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.exchange = '';

    /**
     * Quote tradeExchange.
     * @member {string} tradeExchange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.tradeExchange = '';

    /**
     * Quote preMarketOpen.
     * @member {number} preMarketOpen
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.preMarketOpen = 0;

    /**
     * Quote preMarketOpenTime.
     * @member {number|Long} preMarketOpenTime
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.preMarketOpenTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote preMarketVolume.
     * @member {number|Long} preMarketVolume
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.preMarketVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote preMarketOpenChange.
     * @member {number} preMarketOpenChange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.preMarketOpenChange = 0;

    /**
     * Quote preMarketOpenChangePercent.
     * @member {number} preMarketOpenChangePercent
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.preMarketOpenChangePercent = 0;

    /**
     * Quote source.
     * @member {LastProtos.QuoteSource} source
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.source = 0;

    /**
     * Quote clearFieldNumbers.
     * @member {Array.<number>} clearFieldNumbers
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.clearFieldNumbers = $util.emptyArray;

    /**
     * Quote marketCap.
     * @member {number|Long} marketCap
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.marketCap = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote rsi.
     * @member {number} rsi
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsi = 0;

    /**
     * Quote atr.
     * @member {number} atr
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.atr = 0;

    /**
     * Quote priceToEarnings.
     * @member {number} priceToEarnings
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceToEarnings = 0;

    /**
     * Quote averageVolume.
     * @member {number|Long} averageVolume
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote sharesOutstanding.
     * @member {number|Long} sharesOutstanding
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sharesOutstanding = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote sector.
     * @member {string} sector
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sector = '';

    /**
     * Quote sectorCode.
     * @member {number} sectorCode
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sectorCode = 0;

    /**
     * Quote industry.
     * @member {string} industry
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.industry = '';

    /**
     * Quote industryCode.
     * @member {number} industryCode
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.industryCode = 0;

    /**
     * Quote forwardPERatio.
     * @member {number} forwardPERatio
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.forwardPERatio = 0;

    /**
     * Quote pricetoEBITDA.
     * @member {number} pricetoEBITDA
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.pricetoEBITDA = 0;

    /**
     * Quote trailingDividendYield.
     * @member {number} trailingDividendYield
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.trailingDividendYield = 0;

    /**
     * Quote PBRatio.
     * @member {number} PBRatio
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.PBRatio = 0;

    /**
     * Quote priceToSales.
     * @member {number} priceToSales
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceToSales = 0;

    /**
     * Quote FCFPerShare.
     * @member {number} FCFPerShare
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.FCFPerShare = 0;

    /**
     * Quote buyBackYield.
     * @member {number} buyBackYield
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.buyBackYield = 0;

    /**
     * Quote open.
     * @member {number} open
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.open = 0;

    /**
     * Quote price.
     * @member {number} price
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.price = 0;

    /**
     * Quote high.
     * @member {number} high
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.high = 0;

    /**
     * Quote low.
     * @member {number} low
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.low = 0;

    /**
     * Quote time.
     * @member {number|Long} time
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote size.
     * @member {number} size
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.size = 0;

    /**
     * Quote type.
     * @member {string} type
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.type = '';

    /**
     * Quote dayVolume.
     * @member {number|Long} dayVolume
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dayVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote askPrice.
     * @member {number} askPrice
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.askPrice = 0;

    /**
     * Quote bidPrice.
     * @member {number} bidPrice
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.bidPrice = 0;

    /**
     * Quote shareFloatDate.
     * @member {string} shareFloatDate
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.shareFloatDate = '';

    /**
     * Quote sharesOutstandingDate.
     * @member {string} sharesOutstandingDate
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sharesOutstandingDate = '';

    /**
     * Quote shareFloat.
     * @member {number|Long} shareFloat
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.shareFloat = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote updateType.
     * @member {LastProtos.TickType} updateType
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.updateType = 0;

    /**
     * Quote subtype.
     * @member {string} subtype
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.subtype = '';

    /**
     * Quote sessionType.
     * @member {LastProtos.SessionType} sessionType
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sessionType = 0;

    /**
     * Quote volume.
     * @member {number|Long} volume
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.volume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote changePercent1Minute.
     * @member {number} changePercent1Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.changePercent1Minute = 0;

    /**
     * Quote changePercentClose.
     * @member {number} changePercentClose
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.changePercentClose = 0;

    /**
     * Quote changePercent5Minute.
     * @member {number} changePercent5Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.changePercent5Minute = 0;

    /**
     * Quote volume1Minute.
     * @member {number|Long} volume1Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.volume1Minute = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote relativeVolume1Minute.
     * @member {number} relativeVolume1Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.relativeVolume1Minute = 0;

    /**
     * Quote change15Minute.
     * @member {number} change15Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.change15Minute = 0;

    /**
     * Quote changePercent15Minute.
     * @member {number} changePercent15Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.changePercent15Minute = 0;

    /**
     * Quote change30Minute.
     * @member {number} change30Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.change30Minute = 0;

    /**
     * Quote changePercent30Minute.
     * @member {number} changePercent30Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.changePercent30Minute = 0;

    /**
     * Quote change60Minute.
     * @member {number} change60Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.change60Minute = 0;

    /**
     * Quote changePercent60Minute.
     * @member {number} changePercent60Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.changePercent60Minute = 0;

    /**
     * Quote changePercentOpen.
     * @member {number} changePercentOpen
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.changePercentOpen = 0;

    /**
     * Quote changeOpen.
     * @member {number} changeOpen
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.changeOpen = 0;

    /**
     * Quote gics.
     * @member {number} gics
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.gics = 0;

    /**
     * Quote gicsSector.
     * @member {number} gicsSector
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.gicsSector = 0;

    /**
     * Quote gicsSectorName.
     * @member {string} gicsSectorName
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.gicsSectorName = '';

    /**
     * Quote gicsIndustryGroup.
     * @member {number} gicsIndustryGroup
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.gicsIndustryGroup = 0;

    /**
     * Quote gicsIndustryGroupName.
     * @member {string} gicsIndustryGroupName
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.gicsIndustryGroupName = '';

    /**
     * Quote gicsIndustry.
     * @member {number} gicsIndustry
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.gicsIndustry = 0;

    /**
     * Quote gicsIndustryName.
     * @member {string} gicsIndustryName
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.gicsIndustryName = '';

    /**
     * Quote gicsSubIndustry.
     * @member {number} gicsSubIndustry
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.gicsSubIndustry = 0;

    /**
     * Quote gicsSubIndustryName.
     * @member {string} gicsSubIndustryName
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.gicsSubIndustryName = '';

    /**
     * Quote optionable.
     * @member {number} optionable
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.optionable = 0;

    /**
     * Quote cik.
     * @member {number} cik
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.cik = 0;

    /**
     * Quote signalName.
     * @member {string} signalName
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.signalName = '';

    /**
     * Quote lastTradeTime.
     * @member {number|Long} lastTradeTime
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.lastTradeTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote country.
     * @member {string} country
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.country = '';

    /**
     * Quote sharesShort.
     * @member {number|Long} sharesShort
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sharesShort = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote sharesShortPercentOfFloat.
     * @member {number} sharesShortPercentOfFloat
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sharesShortPercentOfFloat = 0;

    /**
     * Quote sharesShortChangePercent.
     * @member {number} sharesShortChangePercent
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sharesShortChangePercent = 0;

    /**
     * Quote sharesShortReceiptDate.
     * @member {number|Long} sharesShortReceiptDate
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sharesShortReceiptDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote sharesShortSettlementDate.
     * @member {number|Long} sharesShortSettlementDate
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sharesShortSettlementDate = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote shortInterestRatio.
     * @member {number} shortInterestRatio
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.shortInterestRatio = 0;

    /**
     * Quote sharesShortValue.
     * @member {number} sharesShortValue
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sharesShortValue = 0;

    /**
     * Quote sharesShortPrevious.
     * @member {number|Long} sharesShortPrevious
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sharesShortPrevious = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote sharesShortPreviousValue.
     * @member {number} sharesShortPreviousValue
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sharesShortPreviousValue = 0;

    /**
     * Quote sharesShortPreviousPercentOfFloat.
     * @member {number} sharesShortPreviousPercentOfFloat
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sharesShortPreviousPercentOfFloat = 0;

    /**
     * Quote sharesShortChange.
     * @member {number|Long} sharesShortChange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sharesShortChange = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote sentTime.
     * @member {number|Long} sentTime
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.sentTime = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote volume5Minute.
     * @member {number|Long} volume5Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.volume5Minute = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote volume15Minute.
     * @member {number|Long} volume15Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.volume15Minute = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote volume30Minute.
     * @member {number|Long} volume30Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.volume30Minute = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote volume60Minute.
     * @member {number|Long} volume60Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.volume60Minute = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote relativeVolume5Minute.
     * @member {number} relativeVolume5Minute
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.relativeVolume5Minute = 0;

    /**
     * Quote relativeVolume90Day.
     * @member {number} relativeVolume90Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.relativeVolume90Day = 0;

    /**
     * Quote rvol1m10d.
     * @member {number} rvol1m10d
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rvol1m10d = 0;

    /**
     * Quote rvol5m10d.
     * @member {number} rvol5m10d
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rvol5m10d = 0;

    /**
     * Quote rvol5m30d.
     * @member {number} rvol5m30d
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rvol5m30d = 0;

    /**
     * Quote rvol5m90d.
     * @member {number} rvol5m90d
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rvol5m90d = 0;

    /**
     * Quote averageVolume10Day.
     * @member {number|Long} averageVolume10Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolume10Day = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote averageVolumeChangePercent10Day.
     * @member {number} averageVolumeChangePercent10Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolumeChangePercent10Day = 0;

    /**
     * Quote high10Day.
     * @member {number} high10Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.high10Day = 0;

    /**
     * Quote highChangePercent10Day.
     * @member {number} highChangePercent10Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.highChangePercent10Day = 0;

    /**
     * Quote low10Day.
     * @member {number} low10Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.low10Day = 0;

    /**
     * Quote lowChangePercent10Day.
     * @member {number} lowChangePercent10Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.lowChangePercent10Day = 0;

    /**
     * Quote movingAverage10Day.
     * @member {number} movingAverage10Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverage10Day = 0;

    /**
     * Quote movingAverageChangePercent10Day.
     * @member {number} movingAverageChangePercent10Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverageChangePercent10Day = 0;

    /**
     * Quote averageVolume20Day.
     * @member {number|Long} averageVolume20Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolume20Day = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote averageVolumeChangePercent20Day.
     * @member {number} averageVolumeChangePercent20Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolumeChangePercent20Day = 0;

    /**
     * Quote high20Day.
     * @member {number} high20Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.high20Day = 0;

    /**
     * Quote highChangePercent20Day.
     * @member {number} highChangePercent20Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.highChangePercent20Day = 0;

    /**
     * Quote low20Day.
     * @member {number} low20Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.low20Day = 0;

    /**
     * Quote lowChangePercent20Day.
     * @member {number} lowChangePercent20Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.lowChangePercent20Day = 0;

    /**
     * Quote movingAverage20Day.
     * @member {number} movingAverage20Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverage20Day = 0;

    /**
     * Quote movingAverageChangePercent20Day.
     * @member {number} movingAverageChangePercent20Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverageChangePercent20Day = 0;

    /**
     * Quote averageVolume50Day.
     * @member {number|Long} averageVolume50Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolume50Day = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote averageVolumeChangePercent50Day.
     * @member {number} averageVolumeChangePercent50Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolumeChangePercent50Day = 0;

    /**
     * Quote high50Day.
     * @member {number} high50Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.high50Day = 0;

    /**
     * Quote highChangePercent50Day.
     * @member {number} highChangePercent50Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.highChangePercent50Day = 0;

    /**
     * Quote low50Day.
     * @member {number} low50Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.low50Day = 0;

    /**
     * Quote lowChangePercent50Day.
     * @member {number} lowChangePercent50Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.lowChangePercent50Day = 0;

    /**
     * Quote movingAverage50Day.
     * @member {number} movingAverage50Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverage50Day = 0;

    /**
     * Quote movingAverageChangePercent50Day.
     * @member {number} movingAverageChangePercent50Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverageChangePercent50Day = 0;

    /**
     * Quote averageVolume100Day.
     * @member {number|Long} averageVolume100Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolume100Day = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote averageVolumeChangePercent100Day.
     * @member {number} averageVolumeChangePercent100Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolumeChangePercent100Day = 0;

    /**
     * Quote high100Day.
     * @member {number} high100Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.high100Day = 0;

    /**
     * Quote highChangePercent100Day.
     * @member {number} highChangePercent100Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.highChangePercent100Day = 0;

    /**
     * Quote low100Day.
     * @member {number} low100Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.low100Day = 0;

    /**
     * Quote lowChangePercent100Day.
     * @member {number} lowChangePercent100Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.lowChangePercent100Day = 0;

    /**
     * Quote movingAverage100Day.
     * @member {number} movingAverage100Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverage100Day = 0;

    /**
     * Quote movingAverageChangePercent100Day.
     * @member {number} movingAverageChangePercent100Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverageChangePercent100Day = 0;

    /**
     * Quote averageVolume200Day.
     * @member {number|Long} averageVolume200Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolume200Day = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote averageVolumeChangePercent200Day.
     * @member {number} averageVolumeChangePercent200Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolumeChangePercent200Day = 0;

    /**
     * Quote high200Day.
     * @member {number} high200Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.high200Day = 0;

    /**
     * Quote highChangePercent200Day.
     * @member {number} highChangePercent200Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.highChangePercent200Day = 0;

    /**
     * Quote low200Day.
     * @member {number} low200Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.low200Day = 0;

    /**
     * Quote lowChangePercent200Day.
     * @member {number} lowChangePercent200Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.lowChangePercent200Day = 0;

    /**
     * Quote movingAverage200Day.
     * @member {number} movingAverage200Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverage200Day = 0;

    /**
     * Quote movingAverageChangePercent200Day.
     * @member {number} movingAverageChangePercent200Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverageChangePercent200Day = 0;

    /**
     * Quote movingAverage250Day.
     * @member {number} movingAverage250Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverage250Day = 0;

    /**
     * Quote movingAverageChangePercent250Day.
     * @member {number} movingAverageChangePercent250Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverageChangePercent250Day = 0;

    /**
     * Quote averageVolume90Day.
     * @member {number|Long} averageVolume90Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolume90Day = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote nextEarningsDate.
     * @member {number} nextEarningsDate
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.nextEarningsDate = 0;

    /**
     * Quote dividend.
     * @member {number} dividend
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dividend = 0;

    /**
     * Quote dividendYield.
     * @member {number} dividendYield
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dividendYield = 0;

    /**
     * Quote dividendExDate.
     * @member {number} dividendExDate
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dividendExDate = 0;

    /**
     * Quote dividendFrequency.
     * @member {number|Long} dividendFrequency
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dividendFrequency = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote forwardDividendYield.
     * @member {number} forwardDividendYield
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.forwardDividendYield = 0;

    /**
     * Quote roe.
     * @member {number} roe
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.roe = 0;

    /**
     * Quote roa.
     * @member {number} roa
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.roa = 0;

    /**
     * Quote roic.
     * @member {number} roic
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.roic = 0;

    /**
     * Quote currentRatio.
     * @member {number} currentRatio
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.currentRatio = 0;

    /**
     * Quote grossMargin.
     * @member {number} grossMargin
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.grossMargin = 0;

    /**
     * Quote netMargin.
     * @member {number} netMargin
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.netMargin = 0;

    /**
     * Quote operationMargin.
     * @member {number} operationMargin
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.operationMargin = 0;

    /**
     * Quote epsMrq.
     * @member {number} epsMrq
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.epsMrq = 0;

    /**
     * Quote epsTtm.
     * @member {number} epsTtm
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.epsTtm = 0;

    /**
     * Quote dilutedEpsMrq.
     * @member {number} dilutedEpsMrq
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dilutedEpsMrq = 0;

    /**
     * Quote dilutedEpsTtm.
     * @member {number} dilutedEpsTtm
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dilutedEpsTtm = 0;

    /**
     * Quote low52Week.
     * @member {number} low52Week
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.low52Week = 0;

    /**
     * Quote high52Week.
     * @member {number} high52Week
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.high52Week = 0;

    /**
     * Quote revenueTtm.
     * @member {number} revenueTtm
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.revenueTtm = 0;

    /**
     * Quote earningsAsOf.
     * @member {number} earningsAsOf
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.earningsAsOf = 0;

    /**
     * Quote price1Week.
     * @member {number} price1Week
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.price1Week = 0;

    /**
     * Quote priceChangePercent1Week.
     * @member {number} priceChangePercent1Week
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceChangePercent1Week = 0;

    /**
     * Quote price1Month.
     * @member {number} price1Month
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.price1Month = 0;

    /**
     * Quote priceChangePercent1Month.
     * @member {number} priceChangePercent1Month
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceChangePercent1Month = 0;

    /**
     * Quote priceHalfYear.
     * @member {number} priceHalfYear
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceHalfYear = 0;

    /**
     * Quote priceChangePercentHalfYear.
     * @member {number} priceChangePercentHalfYear
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceChangePercentHalfYear = 0;

    /**
     * Quote priceQuarter.
     * @member {number} priceQuarter
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceQuarter = 0;

    /**
     * Quote priceChangePercentQuarter.
     * @member {number} priceChangePercentQuarter
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceChangePercentQuarter = 0;

    /**
     * Quote price1Year.
     * @member {number} price1Year
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.price1Year = 0;

    /**
     * Quote priceChangePercent1Year.
     * @member {number} priceChangePercent1Year
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceChangePercent1Year = 0;

    /**
     * Quote priceYearToDate.
     * @member {number} priceYearToDate
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceYearToDate = 0;

    /**
     * Quote priceChangePercentYearToDate.
     * @member {number} priceChangePercentYearToDate
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceChangePercentYearToDate = 0;

    /**
     * Quote roeMrq.
     * @member {number} roeMrq
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.roeMrq = 0;

    /**
     * Quote roaMrq.
     * @member {number} roaMrq
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.roaMrq = 0;

    /**
     * Quote roicMrq.
     * @member {number} roicMrq
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.roicMrq = 0;

    /**
     * Quote currentRatioMrq.
     * @member {number} currentRatioMrq
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.currentRatioMrq = 0;

    /**
     * Quote grossMarginMrq.
     * @member {number} grossMarginMrq
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.grossMarginMrq = 0;

    /**
     * Quote netMarginMrq.
     * @member {number} netMarginMrq
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.netMarginMrq = 0;

    /**
     * Quote operationMarginMrq.
     * @member {number} operationMarginMrq
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.operationMarginMrq = 0;

    /**
     * Quote previousDayVolume.
     * @member {number|Long} previousDayVolume
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.previousDayVolume = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote previousDayAtr.
     * @member {number} previousDayAtr
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.previousDayAtr = 0;

    /**
     * Quote previousDayAdx.
     * @member {number} previousDayAdx
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.previousDayAdx = 0;

    /**
     * Quote previousDayPlusDMSmoothed.
     * @member {number} previousDayPlusDMSmoothed
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.previousDayPlusDMSmoothed = 0;

    /**
     * Quote previousDayMinusDMSmoothed.
     * @member {number} previousDayMinusDMSmoothed
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.previousDayMinusDMSmoothed = 0;

    /**
     * Quote previousDayHigh.
     * @member {number} previousDayHigh
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.previousDayHigh = 0;

    /**
     * Quote previousDayLow.
     * @member {number} previousDayLow
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.previousDayLow = 0;

    /**
     * Quote adx.
     * @member {number} adx
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.adx = 0;

    /**
     * Quote percentInstitutionalOwnership.
     * @member {number} percentInstitutionalOwnership
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.percentInstitutionalOwnership = 0;

    /**
     * Quote wiim.
     * @member {string} wiim
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.wiim = '';

    /**
     * Quote wiimAsOf.
     * @member {number|Long} wiimAsOf
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.wiimAsOf = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote vwap.
     * @member {number} vwap
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.vwap = 0;

    /**
     * Quote vwapChangePercent.
     * @member {number} vwapChangePercent
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.vwapChangePercent = 0;

    /**
     * Quote vwapChange.
     * @member {number} vwapChange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.vwapChange = 0;

    /**
     * Quote rsiAvgGain.
     * @member {number} rsiAvgGain
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsiAvgGain = 0;

    /**
     * Quote rsiAvgLoss.
     * @member {number} rsiAvgLoss
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsiAvgLoss = 0;

    /**
     * Quote halted.
     * @member {string} halted
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.halted = '';

    /**
     * Quote tradeCount.
     * @member {number|Long} tradeCount
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.tradeCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote regularHighCount.
     * @member {number|Long} regularHighCount
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.regularHighCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote regularLowCount.
     * @member {number|Long} regularLowCount
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.regularLowCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote preMarketHighCount.
     * @member {number|Long} preMarketHighCount
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.preMarketHighCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote preMarketLowCount.
     * @member {number|Long} preMarketLowCount
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.preMarketLowCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote afterMarketHighCount.
     * @member {number|Long} afterMarketHighCount
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.afterMarketHighCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote afterMarketLowCount.
     * @member {number|Long} afterMarketLowCount
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.afterMarketLowCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote dayHighCount.
     * @member {number|Long} dayHighCount
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dayHighCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote dayLowCount.
     * @member {number|Long} dayLowCount
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dayLowCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote dayHigh.
     * @member {number} dayHigh
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dayHigh = 0;

    /**
     * Quote dayLow.
     * @member {number} dayLow
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dayLow = 0;

    /**
     * Quote preMarketHigh.
     * @member {number} preMarketHigh
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.preMarketHigh = 0;

    /**
     * Quote preMarketLow.
     * @member {number} preMarketLow
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.preMarketLow = 0;

    /**
     * Quote afterMarketHigh.
     * @member {number} afterMarketHigh
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.afterMarketHigh = 0;

    /**
     * Quote afterMarketLow.
     * @member {number} afterMarketLow
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.afterMarketLow = 0;

    /**
     * Quote regularHigh.
     * @member {number} regularHigh
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.regularHigh = 0;

    /**
     * Quote regularLow.
     * @member {number} regularLow
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.regularLow = 0;

    /**
     * Quote priceSpikeUpCount.
     * @member {number|Long} priceSpikeUpCount
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceSpikeUpCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote priceSpikeDownCount.
     * @member {number|Long} priceSpikeDownCount
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceSpikeDownCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote haltedCount.
     * @member {number|Long} haltedCount
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.haltedCount = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote usCongressTotal.
     * @member {number} usCongressTotal
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.usCongressTotal = 0;

    /**
     * Quote usCongressRepublicansTotal.
     * @member {number} usCongressRepublicansTotal
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.usCongressRepublicansTotal = 0;

    /**
     * Quote usCongressDemocratsTotal.
     * @member {number} usCongressDemocratsTotal
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.usCongressDemocratsTotal = 0;

    /**
     * Quote usCongressOtherTotal.
     * @member {number} usCongressOtherTotal
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.usCongressOtherTotal = 0;

    /**
     * Quote volumeFloatRatio.
     * @member {number} volumeFloatRatio
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.volumeFloatRatio = 0;

    /**
     * Quote atrp.
     * @member {number} atrp
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.atrp = 0;

    /**
     * Quote ytdGainLoss.
     * @member {number} ytdGainLoss
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.ytdGainLoss = 0;

    /**
     * Quote mtdGainLoss.
     * @member {number} mtdGainLoss
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.mtdGainLoss = 0;

    /**
     * Quote yearOpen.
     * @member {number} yearOpen
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.yearOpen = 0;

    /**
     * Quote monthOpen.
     * @member {number} monthOpen
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.monthOpen = 0;

    /**
     * Quote volumeFloatPercent.
     * @member {number} volumeFloatPercent
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.volumeFloatPercent = 0;

    /**
     * Quote ytdChange.
     * @member {number} ytdChange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.ytdChange = 0;

    /**
     * Quote mtdChange.
     * @member {number} mtdChange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.mtdChange = 0;

    /**
     * Quote rsi1m.
     * @member {number} rsi1m
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsi1m = 0;

    /**
     * Quote rsi2m.
     * @member {number} rsi2m
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsi2m = 0;

    /**
     * Quote rsi5m.
     * @member {number} rsi5m
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsi5m = 0;

    /**
     * Quote rsi15m.
     * @member {number} rsi15m
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsi15m = 0;

    /**
     * Quote rsi30m.
     * @member {number} rsi30m
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsi30m = 0;

    /**
     * Quote rsi60m.
     * @member {number} rsi60m
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsi60m = 0;

    /**
     * Quote rsiEth1m.
     * @member {number} rsiEth1m
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsiEth1m = 0;

    /**
     * Quote rsiEth2m.
     * @member {number} rsiEth2m
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsiEth2m = 0;

    /**
     * Quote rsiEth5m.
     * @member {number} rsiEth5m
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsiEth5m = 0;

    /**
     * Quote rsiEth15m.
     * @member {number} rsiEth15m
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsiEth15m = 0;

    /**
     * Quote rsiEth30m.
     * @member {number} rsiEth30m
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsiEth30m = 0;

    /**
     * Quote rsiEth60m.
     * @member {number} rsiEth60m
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.rsiEth60m = 0;

    /**
     * Quote averageDollarVolume10Day.
     * @member {number} averageDollarVolume10Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageDollarVolume10Day = 0;

    /**
     * Quote averageVolume60Day.
     * @member {number|Long} averageVolume60Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageVolume60Day = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote relativeVolumePercent60Day.
     * @member {number} relativeVolumePercent60Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.relativeVolumePercent60Day = 0;

    /**
     * Quote ema12d.
     * @member {number} ema12d
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.ema12d = 0;

    /**
     * Quote ema26d.
     * @member {number} ema26d
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.ema26d = 0;

    /**
     * Quote macd.
     * @member {number} macd
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.macd = 0;

    /**
     * Quote macdSignalLine.
     * @member {number} macdSignalLine
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.macdSignalLine = 0;

    /**
     * Quote macdHistogram.
     * @member {number} macdHistogram
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.macdHistogram = 0;

    /**
     * Quote macdSignalLineBase.
     * @member {number} macdSignalLineBase
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.macdSignalLineBase = 0;

    /**
     * Quote dividendGrowthRate1Year.
     * @member {number} dividendGrowthRate1Year
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dividendGrowthRate1Year = 0;

    /**
     * Quote dividendGrowthRate3Year.
     * @member {number} dividendGrowthRate3Year
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dividendGrowthRate3Year = 0;

    /**
     * Quote dividendGrowthRate5Year.
     * @member {number} dividendGrowthRate5Year
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dividendGrowthRate5Year = 0;

    /**
     * Quote newsBzWireTitle.
     * @member {string} newsBzWireTitle
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.newsBzWireTitle = '';

    /**
     * Quote newsBzWireNodeId.
     * @member {string} newsBzWireNodeId
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.newsBzWireNodeId = '';

    /**
     * Quote newsBzWireTimestamp.
     * @member {number|Long} newsBzWireTimestamp
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.newsBzWireTimestamp = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote newsPRTitle.
     * @member {string} newsPRTitle
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.newsPRTitle = '';

    /**
     * Quote newsPRNodeId.
     * @member {string} newsPRNodeId
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.newsPRNodeId = '';

    /**
     * Quote newsPRTimestamp.
     * @member {number|Long} newsPRTimestamp
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.newsPRTimestamp = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote newsSecTitle.
     * @member {string} newsSecTitle
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.newsSecTitle = '';

    /**
     * Quote newsSecNodeId.
     * @member {string} newsSecNodeId
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.newsSecNodeId = '';

    /**
     * Quote newsSecTimestamp.
     * @member {number|Long} newsSecTimestamp
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.newsSecTimestamp = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote gapChange.
     * @member {number} gapChange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.gapChange = 0;

    /**
     * Quote gapChangePercent.
     * @member {number} gapChangePercent
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.gapChangePercent = 0;

    /**
     * Quote adr14d.
     * @member {number} adr14d
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.adr14d = 0;

    /**
     * Quote movingAverage500Day.
     * @member {number} movingAverage500Day
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.movingAverage500Day = 0;

    /**
     * Quote dilutedEpsMrqSurprisePercent.
     * @member {number} dilutedEpsMrqSurprisePercent
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dilutedEpsMrqSurprisePercent = 0;

    /**
     * Quote dilutedEpsTtmSurprisePercent.
     * @member {number} dilutedEpsTtmSurprisePercent
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dilutedEpsTtmSurprisePercent = 0;

    /**
     * Quote dilutedRevenueMrqSurprisePercent.
     * @member {number} dilutedRevenueMrqSurprisePercent
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dilutedRevenueMrqSurprisePercent = 0;

    /**
     * Quote dilutedRevenueTtmSurprisePercent.
     * @member {number} dilutedRevenueTtmSurprisePercent
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dilutedRevenueTtmSurprisePercent = 0;

    /**
     * Quote epsGrowthTtm.
     * @member {number} epsGrowthTtm
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.epsGrowthTtm = 0;

    /**
     * Quote epsGrowthY2Y.
     * @member {number} epsGrowthY2Y
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.epsGrowthY2Y = 0;

    /**
     * Quote epsGrowthQ2Q.
     * @member {number} epsGrowthQ2Q
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.epsGrowthQ2Q = 0;

    /**
     * Quote epsGrowth5Year.
     * @member {number} epsGrowth5Year
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.epsGrowth5Year = 0;

    /**
     * Quote epsGrowthYearAgoQ.
     * @member {number} epsGrowthYearAgoQ
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.epsGrowthYearAgoQ = 0;

    /**
     * Quote revenueGrowthTtm.
     * @member {number} revenueGrowthTtm
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.revenueGrowthTtm = 0;

    /**
     * Quote revenueGrowthY2Y.
     * @member {number} revenueGrowthY2Y
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.revenueGrowthY2Y = 0;

    /**
     * Quote revenueGrowthQ2Q.
     * @member {number} revenueGrowthQ2Q
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.revenueGrowthQ2Q = 0;

    /**
     * Quote revenueGrowth5Year.
     * @member {number} revenueGrowth5Year
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.revenueGrowth5Year = 0;

    /**
     * Quote revenueGrowthYearAgoQ.
     * @member {number} revenueGrowthYearAgoQ
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.revenueGrowthYearAgoQ = 0;

    /**
     * Quote ltDebtEquity.
     * @member {number} ltDebtEquity
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.ltDebtEquity = 0;

    /**
     * Quote bullsSay.
     * @member {string} bullsSay
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.bullsSay = '';

    /**
     * Quote bearsSay.
     * @member {string} bearsSay
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.bearsSay = '';

    /**
     * Quote ipoDateNumber.
     * @member {number|Long} ipoDateNumber
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.ipoDateNumber = $util.Long ? $util.Long.fromBits(0, 0, false) : 0;

    /**
     * Quote ffoPerShare.
     * @member {number} ffoPerShare
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.ffoPerShare = 0;

    /**
     * Quote quickRatioMrq.
     * @member {number} quickRatioMrq
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.quickRatioMrq = 0;

    /**
     * Quote highAllTime.
     * @member {number} highAllTime
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.highAllTime = 0;

    /**
     * Quote lowAllTime.
     * @member {number} lowAllTime
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.lowAllTime = 0;

    /**
     * Quote totalDebtEquityRatio.
     * @member {number} totalDebtEquityRatio
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.totalDebtEquityRatio = 0;

    /**
     * Quote dividendPayoutRatio.
     * @member {number} dividendPayoutRatio
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.dividendPayoutRatio = 0;

    /**
     * Quote operatingCashFlowPerShare.
     * @member {number} operatingCashFlowPerShare
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.operatingCashFlowPerShare = 0;

    /**
     * Quote insiderPercentage.
     * @member {number} insiderPercentage
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.insiderPercentage = 0;

    /**
     * Quote priceToCashFlowRatio.
     * @member {number} priceToCashFlowRatio
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceToCashFlowRatio = 0;

    /**
     * Quote netProfitMargin.
     * @member {number} netProfitMargin
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.netProfitMargin = 0;

    /**
     * Quote regularHoursChange.
     * @member {number} regularHoursChange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.regularHoursChange = 0;

    /**
     * Quote regularHoursPercentChange.
     * @member {number} regularHoursPercentChange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.regularHoursPercentChange = 0;

    /**
     * Quote postToPreHoursChange.
     * @member {number} postToPreHoursChange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.postToPreHoursChange = 0;

    /**
     * Quote postToPreHoursPercentChange.
     * @member {number} postToPreHoursPercentChange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.postToPreHoursPercentChange = 0;

    /**
     * Quote scannerClose.
     * @member {number} scannerClose
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.scannerClose = 0;

    /**
     * Quote scannerChange.
     * @member {number} scannerChange
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.scannerChange = 0;

    /**
     * Quote scannerChangePercent.
     * @member {number} scannerChangePercent
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.scannerChangePercent = 0;

    /**
     * Quote scannerChangePercentClose.
     * @member {number} scannerChangePercentClose
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.scannerChangePercentClose = 0;

    /**
     * Quote scannerPreviousClose.
     * @member {number} scannerPreviousClose
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.scannerPreviousClose = 0;

    /**
     * Quote freeCashFlow.
     * @member {number} freeCashFlow
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.freeCashFlow = 0;

    /**
     * Quote minPriceTarget.
     * @member {number} minPriceTarget
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.minPriceTarget = 0;

    /**
     * Quote maxPriceTarget.
     * @member {number} maxPriceTarget
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.maxPriceTarget = 0;

    /**
     * Quote meanPriceTarget.
     * @member {number} meanPriceTarget
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.meanPriceTarget = 0;

    /**
     * Quote totalNumberOfAnalyst.
     * @member {number} totalNumberOfAnalyst
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.totalNumberOfAnalyst = 0;

    /**
     * Quote averageAnalystRecommendation.
     * @member {string} averageAnalystRecommendation
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.averageAnalystRecommendation = '';

    /**
     * Quote pegRatio.
     * @member {number} pegRatio
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.pegRatio = 0;

    /**
     * Quote priceToFreeCashFlowRatio.
     * @member {number} priceToFreeCashFlowRatio
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.priceToFreeCashFlowRatio = 0;

    /**
     * Quote distanceToMaxPriceTarget.
     * @member {number} distanceToMaxPriceTarget
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.distanceToMaxPriceTarget = 0;

    /**
     * Quote distanceToMinPriceTarget.
     * @member {number} distanceToMinPriceTarget
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.distanceToMinPriceTarget = 0;

    /**
     * Quote distanceToMeanPriceTarget.
     * @member {number} distanceToMeanPriceTarget
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.distanceToMeanPriceTarget = 0;

    /**
     * Quote shortTermTrend.
     * @member {string} shortTermTrend
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.shortTermTrend = '';

    /**
     * Quote mediumTermTrend.
     * @member {string} mediumTermTrend
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.mediumTermTrend = '';

    /**
     * Quote longTermTrend.
     * @member {string} longTermTrend
     * @memberof LastProtos.Quote
     * @instance
     */
    Quote.prototype.longTermTrend = '';

    /**
     * Creates a new Quote instance using the specified properties.
     * @function create
     * @memberof LastProtos.Quote
     * @static
     * @param {LastProtos.IQuote=} [properties] Properties to set
     * @returns {LastProtos.Quote} Quote instance
     */
    Quote.create = function create(properties) {
      return new Quote(properties);
    };

    /**
     * Encodes the specified Quote message. Does not implicitly {@link LastProtos.Quote.verify|verify} messages.
     * @function encode
     * @memberof LastProtos.Quote
     * @static
     * @param {LastProtos.IQuote} message Quote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Quote.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.symbol != null && Object.hasOwnProperty.call(message, 'symbol'))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.symbol);
      if (message.previousClose != null && Object.hasOwnProperty.call(message, 'previousClose'))
        writer.uint32(/* id 2, wireType 1 =*/ 17).double(message.previousClose);
      if (message.close != null && Object.hasOwnProperty.call(message, 'close'))
        writer.uint32(/* id 3, wireType 1 =*/ 25).double(message.close);
      if (message.change != null && Object.hasOwnProperty.call(message, 'change'))
        writer.uint32(/* id 4, wireType 1 =*/ 33).double(message.change);
      if (message.changePercent != null && Object.hasOwnProperty.call(message, 'changePercent'))
        writer.uint32(/* id 5, wireType 1 =*/ 41).double(message.changePercent);
      if (message.name != null && Object.hasOwnProperty.call(message, 'name'))
        writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.name);
      if (message.ipoDate != null && Object.hasOwnProperty.call(message, 'ipoDate'))
        writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.ipoDate);
      if (message.exchange != null && Object.hasOwnProperty.call(message, 'exchange'))
        writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.exchange);
      if (message.tradeExchange != null && Object.hasOwnProperty.call(message, 'tradeExchange'))
        writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.tradeExchange);
      if (message.marketCap != null && Object.hasOwnProperty.call(message, 'marketCap'))
        writer.uint32(/* id 10, wireType 0 =*/ 80).int64(message.marketCap);
      if (message.rsi != null && Object.hasOwnProperty.call(message, 'rsi'))
        writer.uint32(/* id 11, wireType 1 =*/ 89).double(message.rsi);
      if (message.atr != null && Object.hasOwnProperty.call(message, 'atr'))
        writer.uint32(/* id 12, wireType 1 =*/ 97).double(message.atr);
      if (message.priceToEarnings != null && Object.hasOwnProperty.call(message, 'priceToEarnings'))
        writer.uint32(/* id 13, wireType 1 =*/ 105).double(message.priceToEarnings);
      if (message.averageVolume != null && Object.hasOwnProperty.call(message, 'averageVolume'))
        writer.uint32(/* id 14, wireType 0 =*/ 112).int64(message.averageVolume);
      if (message.sharesOutstanding != null && Object.hasOwnProperty.call(message, 'sharesOutstanding'))
        writer.uint32(/* id 15, wireType 0 =*/ 120).int64(message.sharesOutstanding);
      if (message.sector != null && Object.hasOwnProperty.call(message, 'sector'))
        writer.uint32(/* id 16, wireType 2 =*/ 130).string(message.sector);
      if (message.sectorCode != null && Object.hasOwnProperty.call(message, 'sectorCode'))
        writer.uint32(/* id 17, wireType 0 =*/ 136).int32(message.sectorCode);
      if (message.industry != null && Object.hasOwnProperty.call(message, 'industry'))
        writer.uint32(/* id 18, wireType 2 =*/ 146).string(message.industry);
      if (message.industryCode != null && Object.hasOwnProperty.call(message, 'industryCode'))
        writer.uint32(/* id 19, wireType 0 =*/ 152).int32(message.industryCode);
      if (message.forwardPERatio != null && Object.hasOwnProperty.call(message, 'forwardPERatio'))
        writer.uint32(/* id 20, wireType 1 =*/ 161).double(message.forwardPERatio);
      if (message.pricetoEBITDA != null && Object.hasOwnProperty.call(message, 'pricetoEBITDA'))
        writer.uint32(/* id 21, wireType 1 =*/ 169).double(message.pricetoEBITDA);
      if (message.trailingDividendYield != null && Object.hasOwnProperty.call(message, 'trailingDividendYield'))
        writer.uint32(/* id 22, wireType 1 =*/ 177).double(message.trailingDividendYield);
      if (message.PBRatio != null && Object.hasOwnProperty.call(message, 'PBRatio'))
        writer.uint32(/* id 23, wireType 1 =*/ 185).double(message.PBRatio);
      if (message.priceToSales != null && Object.hasOwnProperty.call(message, 'priceToSales'))
        writer.uint32(/* id 24, wireType 1 =*/ 193).double(message.priceToSales);
      if (message.FCFPerShare != null && Object.hasOwnProperty.call(message, 'FCFPerShare'))
        writer.uint32(/* id 25, wireType 1 =*/ 201).double(message.FCFPerShare);
      if (message.buyBackYield != null && Object.hasOwnProperty.call(message, 'buyBackYield'))
        writer.uint32(/* id 26, wireType 1 =*/ 209).double(message.buyBackYield);
      if (message.open != null && Object.hasOwnProperty.call(message, 'open'))
        writer.uint32(/* id 27, wireType 1 =*/ 217).double(message.open);
      if (message.price != null && Object.hasOwnProperty.call(message, 'price'))
        writer.uint32(/* id 28, wireType 1 =*/ 225).double(message.price);
      if (message.high != null && Object.hasOwnProperty.call(message, 'high'))
        writer.uint32(/* id 29, wireType 1 =*/ 233).double(message.high);
      if (message.low != null && Object.hasOwnProperty.call(message, 'low'))
        writer.uint32(/* id 30, wireType 1 =*/ 241).double(message.low);
      if (message.time != null && Object.hasOwnProperty.call(message, 'time'))
        writer.uint32(/* id 31, wireType 0 =*/ 248).int64(message.time);
      if (message.size != null && Object.hasOwnProperty.call(message, 'size'))
        writer.uint32(/* id 32, wireType 0 =*/ 256).int32(message.size);
      if (message.type != null && Object.hasOwnProperty.call(message, 'type'))
        writer.uint32(/* id 33, wireType 2 =*/ 266).string(message.type);
      if (message.dayVolume != null && Object.hasOwnProperty.call(message, 'dayVolume'))
        writer.uint32(/* id 34, wireType 0 =*/ 272).int64(message.dayVolume);
      if (message.askPrice != null && Object.hasOwnProperty.call(message, 'askPrice'))
        writer.uint32(/* id 35, wireType 1 =*/ 281).double(message.askPrice);
      if (message.bidPrice != null && Object.hasOwnProperty.call(message, 'bidPrice'))
        writer.uint32(/* id 36, wireType 1 =*/ 289).double(message.bidPrice);
      if (message.shareFloatDate != null && Object.hasOwnProperty.call(message, 'shareFloatDate'))
        writer.uint32(/* id 37, wireType 2 =*/ 298).string(message.shareFloatDate);
      if (message.sharesOutstandingDate != null && Object.hasOwnProperty.call(message, 'sharesOutstandingDate'))
        writer.uint32(/* id 38, wireType 2 =*/ 306).string(message.sharesOutstandingDate);
      if (message.cik != null && Object.hasOwnProperty.call(message, 'cik'))
        writer.uint32(/* id 39, wireType 0 =*/ 312).int32(message.cik);
      if (message.updateType != null && Object.hasOwnProperty.call(message, 'updateType'))
        writer.uint32(/* id 40, wireType 0 =*/ 320).int32(message.updateType);
      if (message.sessionType != null && Object.hasOwnProperty.call(message, 'sessionType'))
        writer.uint32(/* id 41, wireType 0 =*/ 328).int32(message.sessionType);
      if (message.changePercent1Minute != null && Object.hasOwnProperty.call(message, 'changePercent1Minute'))
        writer.uint32(/* id 50, wireType 1 =*/ 401).double(message.changePercent1Minute);
      if (message.changePercentClose != null && Object.hasOwnProperty.call(message, 'changePercentClose'))
        writer.uint32(/* id 51, wireType 1 =*/ 409).double(message.changePercentClose);
      if (message.changePercent5Minute != null && Object.hasOwnProperty.call(message, 'changePercent5Minute'))
        writer.uint32(/* id 52, wireType 1 =*/ 417).double(message.changePercent5Minute);
      if (message.volume1Minute != null && Object.hasOwnProperty.call(message, 'volume1Minute'))
        writer.uint32(/* id 53, wireType 0 =*/ 424).int64(message.volume1Minute);
      if (message.relativeVolume1Minute != null && Object.hasOwnProperty.call(message, 'relativeVolume1Minute'))
        writer.uint32(/* id 54, wireType 1 =*/ 433).double(message.relativeVolume1Minute);
      if (message.change15Minute != null && Object.hasOwnProperty.call(message, 'change15Minute'))
        writer.uint32(/* id 55, wireType 1 =*/ 441).double(message.change15Minute);
      if (message.changePercent15Minute != null && Object.hasOwnProperty.call(message, 'changePercent15Minute'))
        writer.uint32(/* id 56, wireType 1 =*/ 449).double(message.changePercent15Minute);
      if (message.change30Minute != null && Object.hasOwnProperty.call(message, 'change30Minute'))
        writer.uint32(/* id 57, wireType 1 =*/ 457).double(message.change30Minute);
      if (message.changePercent30Minute != null && Object.hasOwnProperty.call(message, 'changePercent30Minute'))
        writer.uint32(/* id 58, wireType 1 =*/ 465).double(message.changePercent30Minute);
      if (message.change60Minute != null && Object.hasOwnProperty.call(message, 'change60Minute'))
        writer.uint32(/* id 59, wireType 1 =*/ 473).double(message.change60Minute);
      if (message.changePercent60Minute != null && Object.hasOwnProperty.call(message, 'changePercent60Minute'))
        writer.uint32(/* id 60, wireType 1 =*/ 481).double(message.changePercent60Minute);
      if (message.changePercentOpen != null && Object.hasOwnProperty.call(message, 'changePercentOpen'))
        writer.uint32(/* id 61, wireType 1 =*/ 489).double(message.changePercentOpen);
      if (message.changeOpen != null && Object.hasOwnProperty.call(message, 'changeOpen'))
        writer.uint32(/* id 62, wireType 1 =*/ 497).double(message.changeOpen);
      if (message.gics != null && Object.hasOwnProperty.call(message, 'gics'))
        writer.uint32(/* id 70, wireType 0 =*/ 560).int32(message.gics);
      if (message.gicsSector != null && Object.hasOwnProperty.call(message, 'gicsSector'))
        writer.uint32(/* id 71, wireType 0 =*/ 568).int32(message.gicsSector);
      if (message.gicsSectorName != null && Object.hasOwnProperty.call(message, 'gicsSectorName'))
        writer.uint32(/* id 72, wireType 2 =*/ 578).string(message.gicsSectorName);
      if (message.gicsIndustryGroup != null && Object.hasOwnProperty.call(message, 'gicsIndustryGroup'))
        writer.uint32(/* id 73, wireType 0 =*/ 584).int32(message.gicsIndustryGroup);
      if (message.gicsIndustryGroupName != null && Object.hasOwnProperty.call(message, 'gicsIndustryGroupName'))
        writer.uint32(/* id 74, wireType 2 =*/ 594).string(message.gicsIndustryGroupName);
      if (message.gicsIndustry != null && Object.hasOwnProperty.call(message, 'gicsIndustry'))
        writer.uint32(/* id 75, wireType 0 =*/ 600).int32(message.gicsIndustry);
      if (message.gicsIndustryName != null && Object.hasOwnProperty.call(message, 'gicsIndustryName'))
        writer.uint32(/* id 76, wireType 2 =*/ 610).string(message.gicsIndustryName);
      if (message.gicsSubIndustry != null && Object.hasOwnProperty.call(message, 'gicsSubIndustry'))
        writer.uint32(/* id 77, wireType 0 =*/ 616).int32(message.gicsSubIndustry);
      if (message.gicsSubIndustryName != null && Object.hasOwnProperty.call(message, 'gicsSubIndustryName'))
        writer.uint32(/* id 78, wireType 2 =*/ 626).string(message.gicsSubIndustryName);
      if (message.optionable != null && Object.hasOwnProperty.call(message, 'optionable'))
        writer.uint32(/* id 79, wireType 0 =*/ 632).int32(message.optionable);
      if (message.signalName != null && Object.hasOwnProperty.call(message, 'signalName'))
        writer.uint32(/* id 80, wireType 2 =*/ 642).string(message.signalName);
      if (message.shareFloat != null && Object.hasOwnProperty.call(message, 'shareFloat'))
        writer.uint32(/* id 81, wireType 0 =*/ 648).int64(message.shareFloat);
      if (message.lastTradeTime != null && Object.hasOwnProperty.call(message, 'lastTradeTime'))
        writer.uint32(/* id 82, wireType 0 =*/ 656).int64(message.lastTradeTime);
      if (message.country != null && Object.hasOwnProperty.call(message, 'country'))
        writer.uint32(/* id 83, wireType 2 =*/ 666).string(message.country);
      if (message.volume != null && Object.hasOwnProperty.call(message, 'volume'))
        writer.uint32(/* id 96, wireType 0 =*/ 768).int64(message.volume);
      if (message.opol != null && Object.hasOwnProperty.call(message, 'opol'))
        writer.uint32(/* id 100, wireType 2 =*/ 802).string(message.opol);
      if (message.subtype != null && Object.hasOwnProperty.call(message, 'subtype'))
        writer.uint32(/* id 101, wireType 2 =*/ 810).string(message.subtype);
      if (message.sharesShort != null && Object.hasOwnProperty.call(message, 'sharesShort'))
        writer.uint32(/* id 110, wireType 0 =*/ 880).int64(message.sharesShort);
      if (message.sharesShortPercentOfFloat != null && Object.hasOwnProperty.call(message, 'sharesShortPercentOfFloat'))
        writer.uint32(/* id 111, wireType 1 =*/ 889).double(message.sharesShortPercentOfFloat);
      if (message.sharesShortChangePercent != null && Object.hasOwnProperty.call(message, 'sharesShortChangePercent'))
        writer.uint32(/* id 112, wireType 1 =*/ 897).double(message.sharesShortChangePercent);
      if (message.sharesShortReceiptDate != null && Object.hasOwnProperty.call(message, 'sharesShortReceiptDate'))
        writer.uint32(/* id 113, wireType 0 =*/ 904).int64(message.sharesShortReceiptDate);
      if (message.sharesShortSettlementDate != null && Object.hasOwnProperty.call(message, 'sharesShortSettlementDate'))
        writer.uint32(/* id 114, wireType 0 =*/ 912).int64(message.sharesShortSettlementDate);
      if (message.shortInterestRatio != null && Object.hasOwnProperty.call(message, 'shortInterestRatio'))
        writer.uint32(/* id 115, wireType 1 =*/ 921).double(message.shortInterestRatio);
      if (message.sharesShortValue != null && Object.hasOwnProperty.call(message, 'sharesShortValue'))
        writer.uint32(/* id 116, wireType 1 =*/ 929).double(message.sharesShortValue);
      if (message.sharesShortPrevious != null && Object.hasOwnProperty.call(message, 'sharesShortPrevious'))
        writer.uint32(/* id 117, wireType 0 =*/ 936).int64(message.sharesShortPrevious);
      if (message.sharesShortPreviousValue != null && Object.hasOwnProperty.call(message, 'sharesShortPreviousValue'))
        writer.uint32(/* id 118, wireType 1 =*/ 945).double(message.sharesShortPreviousValue);
      if (
        message.sharesShortPreviousPercentOfFloat != null &&
        Object.hasOwnProperty.call(message, 'sharesShortPreviousPercentOfFloat')
      )
        writer.uint32(/* id 119, wireType 1 =*/ 953).double(message.sharesShortPreviousPercentOfFloat);
      if (message.sharesShortChange != null && Object.hasOwnProperty.call(message, 'sharesShortChange'))
        writer.uint32(/* id 120, wireType 0 =*/ 960).int64(message.sharesShortChange);
      if (message.sentTime != null && Object.hasOwnProperty.call(message, 'sentTime'))
        writer.uint32(/* id 200, wireType 0 =*/ 1600).int64(message.sentTime);
      if (message.volume5Minute != null && Object.hasOwnProperty.call(message, 'volume5Minute'))
        writer.uint32(/* id 300, wireType 0 =*/ 2400).int64(message.volume5Minute);
      if (message.volume15Minute != null && Object.hasOwnProperty.call(message, 'volume15Minute'))
        writer.uint32(/* id 301, wireType 0 =*/ 2408).int64(message.volume15Minute);
      if (message.volume30Minute != null && Object.hasOwnProperty.call(message, 'volume30Minute'))
        writer.uint32(/* id 302, wireType 0 =*/ 2416).int64(message.volume30Minute);
      if (message.volume60Minute != null && Object.hasOwnProperty.call(message, 'volume60Minute'))
        writer.uint32(/* id 303, wireType 0 =*/ 2424).int64(message.volume60Minute);
      if (message.relativeVolume5Minute != null && Object.hasOwnProperty.call(message, 'relativeVolume5Minute'))
        writer.uint32(/* id 304, wireType 1 =*/ 2433).double(message.relativeVolume5Minute);
      if (message.relativeVolume90Day != null && Object.hasOwnProperty.call(message, 'relativeVolume90Day'))
        writer.uint32(/* id 305, wireType 1 =*/ 2441).double(message.relativeVolume90Day);
      if (message.rvol1m10d != null && Object.hasOwnProperty.call(message, 'rvol1m10d'))
        writer.uint32(/* id 306, wireType 1 =*/ 2449).double(message.rvol1m10d);
      if (message.rvol5m10d != null && Object.hasOwnProperty.call(message, 'rvol5m10d'))
        writer.uint32(/* id 307, wireType 1 =*/ 2457).double(message.rvol5m10d);
      if (message.rvol5m30d != null && Object.hasOwnProperty.call(message, 'rvol5m30d'))
        writer.uint32(/* id 308, wireType 1 =*/ 2465).double(message.rvol5m30d);
      if (message.rvol5m90d != null && Object.hasOwnProperty.call(message, 'rvol5m90d'))
        writer.uint32(/* id 309, wireType 1 =*/ 2473).double(message.rvol5m90d);
      if (message.nextEarningsDate != null && Object.hasOwnProperty.call(message, 'nextEarningsDate'))
        writer.uint32(/* id 400, wireType 0 =*/ 3200).int32(message.nextEarningsDate);
      if (message.dividend != null && Object.hasOwnProperty.call(message, 'dividend'))
        writer.uint32(/* id 401, wireType 1 =*/ 3209).double(message.dividend);
      if (message.dividendYield != null && Object.hasOwnProperty.call(message, 'dividendYield'))
        writer.uint32(/* id 402, wireType 1 =*/ 3217).double(message.dividendYield);
      if (message.dividendExDate != null && Object.hasOwnProperty.call(message, 'dividendExDate'))
        writer.uint32(/* id 403, wireType 0 =*/ 3224).int32(message.dividendExDate);
      if (message.dividendFrequency != null && Object.hasOwnProperty.call(message, 'dividendFrequency'))
        writer.uint32(/* id 404, wireType 0 =*/ 3232).int64(message.dividendFrequency);
      if (message.forwardDividendYield != null && Object.hasOwnProperty.call(message, 'forwardDividendYield'))
        writer.uint32(/* id 405, wireType 1 =*/ 3241).double(message.forwardDividendYield);
      if (message.roe != null && Object.hasOwnProperty.call(message, 'roe'))
        writer.uint32(/* id 501, wireType 1 =*/ 4009).double(message.roe);
      if (message.roa != null && Object.hasOwnProperty.call(message, 'roa'))
        writer.uint32(/* id 502, wireType 1 =*/ 4017).double(message.roa);
      if (message.roic != null && Object.hasOwnProperty.call(message, 'roic'))
        writer.uint32(/* id 503, wireType 1 =*/ 4025).double(message.roic);
      if (message.currentRatio != null && Object.hasOwnProperty.call(message, 'currentRatio'))
        writer.uint32(/* id 504, wireType 1 =*/ 4033).double(message.currentRatio);
      if (message.grossMargin != null && Object.hasOwnProperty.call(message, 'grossMargin'))
        writer.uint32(/* id 505, wireType 1 =*/ 4041).double(message.grossMargin);
      if (message.netMargin != null && Object.hasOwnProperty.call(message, 'netMargin'))
        writer.uint32(/* id 506, wireType 1 =*/ 4049).double(message.netMargin);
      if (message.operationMargin != null && Object.hasOwnProperty.call(message, 'operationMargin'))
        writer.uint32(/* id 507, wireType 1 =*/ 4057).double(message.operationMargin);
      if (message.epsMrq != null && Object.hasOwnProperty.call(message, 'epsMrq'))
        writer.uint32(/* id 508, wireType 1 =*/ 4065).double(message.epsMrq);
      if (message.epsTtm != null && Object.hasOwnProperty.call(message, 'epsTtm'))
        writer.uint32(/* id 509, wireType 1 =*/ 4073).double(message.epsTtm);
      if (message.dilutedEpsMrq != null && Object.hasOwnProperty.call(message, 'dilutedEpsMrq'))
        writer.uint32(/* id 510, wireType 1 =*/ 4081).double(message.dilutedEpsMrq);
      if (message.dilutedEpsTtm != null && Object.hasOwnProperty.call(message, 'dilutedEpsTtm'))
        writer.uint32(/* id 511, wireType 1 =*/ 4089).double(message.dilutedEpsTtm);
      if (message.low52Week != null && Object.hasOwnProperty.call(message, 'low52Week'))
        writer.uint32(/* id 512, wireType 1 =*/ 4097).double(message.low52Week);
      if (message.high52Week != null && Object.hasOwnProperty.call(message, 'high52Week'))
        writer.uint32(/* id 513, wireType 1 =*/ 4105).double(message.high52Week);
      if (message.revenueTtm != null && Object.hasOwnProperty.call(message, 'revenueTtm'))
        writer.uint32(/* id 514, wireType 1 =*/ 4113).double(message.revenueTtm);
      if (message.earningsAsOf != null && Object.hasOwnProperty.call(message, 'earningsAsOf'))
        writer.uint32(/* id 515, wireType 0 =*/ 4120).int32(message.earningsAsOf);
      if (message.netProfitMargin != null && Object.hasOwnProperty.call(message, 'netProfitMargin'))
        writer.uint32(/* id 516, wireType 1 =*/ 4129).double(message.netProfitMargin);
      if (message.roeMrq != null && Object.hasOwnProperty.call(message, 'roeMrq'))
        writer.uint32(/* id 520, wireType 1 =*/ 4161).double(message.roeMrq);
      if (message.roaMrq != null && Object.hasOwnProperty.call(message, 'roaMrq'))
        writer.uint32(/* id 521, wireType 1 =*/ 4169).double(message.roaMrq);
      if (message.roicMrq != null && Object.hasOwnProperty.call(message, 'roicMrq'))
        writer.uint32(/* id 522, wireType 1 =*/ 4177).double(message.roicMrq);
      if (message.currentRatioMrq != null && Object.hasOwnProperty.call(message, 'currentRatioMrq'))
        writer.uint32(/* id 523, wireType 1 =*/ 4185).double(message.currentRatioMrq);
      if (message.grossMarginMrq != null && Object.hasOwnProperty.call(message, 'grossMarginMrq'))
        writer.uint32(/* id 524, wireType 1 =*/ 4193).double(message.grossMarginMrq);
      if (message.netMarginMrq != null && Object.hasOwnProperty.call(message, 'netMarginMrq'))
        writer.uint32(/* id 525, wireType 1 =*/ 4201).double(message.netMarginMrq);
      if (message.operationMarginMrq != null && Object.hasOwnProperty.call(message, 'operationMarginMrq'))
        writer.uint32(/* id 526, wireType 1 =*/ 4209).double(message.operationMarginMrq);
      if (message.previousDayVolume != null && Object.hasOwnProperty.call(message, 'previousDayVolume'))
        writer.uint32(/* id 527, wireType 0 =*/ 4216).int64(message.previousDayVolume);
      if (message.previousDayAtr != null && Object.hasOwnProperty.call(message, 'previousDayAtr'))
        writer.uint32(/* id 528, wireType 1 =*/ 4225).double(message.previousDayAtr);
      if (message.previousDayAdx != null && Object.hasOwnProperty.call(message, 'previousDayAdx'))
        writer.uint32(/* id 529, wireType 1 =*/ 4233).double(message.previousDayAdx);
      if (message.previousDayPlusDMSmoothed != null && Object.hasOwnProperty.call(message, 'previousDayPlusDMSmoothed'))
        writer.uint32(/* id 530, wireType 1 =*/ 4241).double(message.previousDayPlusDMSmoothed);
      if (
        message.previousDayMinusDMSmoothed != null &&
        Object.hasOwnProperty.call(message, 'previousDayMinusDMSmoothed')
      )
        writer.uint32(/* id 531, wireType 1 =*/ 4249).double(message.previousDayMinusDMSmoothed);
      if (message.previousDayHigh != null && Object.hasOwnProperty.call(message, 'previousDayHigh'))
        writer.uint32(/* id 532, wireType 1 =*/ 4257).double(message.previousDayHigh);
      if (message.previousDayLow != null && Object.hasOwnProperty.call(message, 'previousDayLow'))
        writer.uint32(/* id 533, wireType 1 =*/ 4265).double(message.previousDayLow);
      if (message.adx != null && Object.hasOwnProperty.call(message, 'adx'))
        writer.uint32(/* id 534, wireType 1 =*/ 4273).double(message.adx);
      if (
        message.percentInstitutionalOwnership != null &&
        Object.hasOwnProperty.call(message, 'percentInstitutionalOwnership')
      )
        writer.uint32(/* id 535, wireType 1 =*/ 4281).double(message.percentInstitutionalOwnership);
      if (message.averageVolume10Day != null && Object.hasOwnProperty.call(message, 'averageVolume10Day'))
        writer.uint32(/* id 600, wireType 0 =*/ 4800).int64(message.averageVolume10Day);
      if (
        message.averageVolumeChangePercent10Day != null &&
        Object.hasOwnProperty.call(message, 'averageVolumeChangePercent10Day')
      )
        writer.uint32(/* id 601, wireType 1 =*/ 4809).double(message.averageVolumeChangePercent10Day);
      if (message.high10Day != null && Object.hasOwnProperty.call(message, 'high10Day'))
        writer.uint32(/* id 602, wireType 1 =*/ 4817).double(message.high10Day);
      if (message.highChangePercent10Day != null && Object.hasOwnProperty.call(message, 'highChangePercent10Day'))
        writer.uint32(/* id 603, wireType 1 =*/ 4825).double(message.highChangePercent10Day);
      if (message.low10Day != null && Object.hasOwnProperty.call(message, 'low10Day'))
        writer.uint32(/* id 604, wireType 1 =*/ 4833).double(message.low10Day);
      if (message.lowChangePercent10Day != null && Object.hasOwnProperty.call(message, 'lowChangePercent10Day'))
        writer.uint32(/* id 605, wireType 1 =*/ 4841).double(message.lowChangePercent10Day);
      if (message.movingAverage10Day != null && Object.hasOwnProperty.call(message, 'movingAverage10Day'))
        writer.uint32(/* id 606, wireType 1 =*/ 4849).double(message.movingAverage10Day);
      if (
        message.movingAverageChangePercent10Day != null &&
        Object.hasOwnProperty.call(message, 'movingAverageChangePercent10Day')
      )
        writer.uint32(/* id 607, wireType 1 =*/ 4857).double(message.movingAverageChangePercent10Day);
      if (message.averageVolume20Day != null && Object.hasOwnProperty.call(message, 'averageVolume20Day'))
        writer.uint32(/* id 610, wireType 0 =*/ 4880).int64(message.averageVolume20Day);
      if (
        message.averageVolumeChangePercent20Day != null &&
        Object.hasOwnProperty.call(message, 'averageVolumeChangePercent20Day')
      )
        writer.uint32(/* id 611, wireType 1 =*/ 4889).double(message.averageVolumeChangePercent20Day);
      if (message.high20Day != null && Object.hasOwnProperty.call(message, 'high20Day'))
        writer.uint32(/* id 612, wireType 1 =*/ 4897).double(message.high20Day);
      if (message.highChangePercent20Day != null && Object.hasOwnProperty.call(message, 'highChangePercent20Day'))
        writer.uint32(/* id 613, wireType 1 =*/ 4905).double(message.highChangePercent20Day);
      if (message.low20Day != null && Object.hasOwnProperty.call(message, 'low20Day'))
        writer.uint32(/* id 614, wireType 1 =*/ 4913).double(message.low20Day);
      if (message.lowChangePercent20Day != null && Object.hasOwnProperty.call(message, 'lowChangePercent20Day'))
        writer.uint32(/* id 615, wireType 1 =*/ 4921).double(message.lowChangePercent20Day);
      if (message.movingAverage20Day != null && Object.hasOwnProperty.call(message, 'movingAverage20Day'))
        writer.uint32(/* id 616, wireType 1 =*/ 4929).double(message.movingAverage20Day);
      if (
        message.movingAverageChangePercent20Day != null &&
        Object.hasOwnProperty.call(message, 'movingAverageChangePercent20Day')
      )
        writer.uint32(/* id 617, wireType 1 =*/ 4937).double(message.movingAverageChangePercent20Day);
      if (message.averageVolume50Day != null && Object.hasOwnProperty.call(message, 'averageVolume50Day'))
        writer.uint32(/* id 620, wireType 0 =*/ 4960).int64(message.averageVolume50Day);
      if (
        message.averageVolumeChangePercent50Day != null &&
        Object.hasOwnProperty.call(message, 'averageVolumeChangePercent50Day')
      )
        writer.uint32(/* id 621, wireType 1 =*/ 4969).double(message.averageVolumeChangePercent50Day);
      if (message.high50Day != null && Object.hasOwnProperty.call(message, 'high50Day'))
        writer.uint32(/* id 622, wireType 1 =*/ 4977).double(message.high50Day);
      if (message.highChangePercent50Day != null && Object.hasOwnProperty.call(message, 'highChangePercent50Day'))
        writer.uint32(/* id 623, wireType 1 =*/ 4985).double(message.highChangePercent50Day);
      if (message.low50Day != null && Object.hasOwnProperty.call(message, 'low50Day'))
        writer.uint32(/* id 624, wireType 1 =*/ 4993).double(message.low50Day);
      if (message.lowChangePercent50Day != null && Object.hasOwnProperty.call(message, 'lowChangePercent50Day'))
        writer.uint32(/* id 625, wireType 1 =*/ 5001).double(message.lowChangePercent50Day);
      if (message.movingAverage50Day != null && Object.hasOwnProperty.call(message, 'movingAverage50Day'))
        writer.uint32(/* id 626, wireType 1 =*/ 5009).double(message.movingAverage50Day);
      if (
        message.movingAverageChangePercent50Day != null &&
        Object.hasOwnProperty.call(message, 'movingAverageChangePercent50Day')
      )
        writer.uint32(/* id 627, wireType 1 =*/ 5017).double(message.movingAverageChangePercent50Day);
      if (message.averageVolume100Day != null && Object.hasOwnProperty.call(message, 'averageVolume100Day'))
        writer.uint32(/* id 630, wireType 0 =*/ 5040).int64(message.averageVolume100Day);
      if (
        message.averageVolumeChangePercent100Day != null &&
        Object.hasOwnProperty.call(message, 'averageVolumeChangePercent100Day')
      )
        writer.uint32(/* id 631, wireType 1 =*/ 5049).double(message.averageVolumeChangePercent100Day);
      if (message.high100Day != null && Object.hasOwnProperty.call(message, 'high100Day'))
        writer.uint32(/* id 632, wireType 1 =*/ 5057).double(message.high100Day);
      if (message.highChangePercent100Day != null && Object.hasOwnProperty.call(message, 'highChangePercent100Day'))
        writer.uint32(/* id 633, wireType 1 =*/ 5065).double(message.highChangePercent100Day);
      if (message.low100Day != null && Object.hasOwnProperty.call(message, 'low100Day'))
        writer.uint32(/* id 634, wireType 1 =*/ 5073).double(message.low100Day);
      if (message.lowChangePercent100Day != null && Object.hasOwnProperty.call(message, 'lowChangePercent100Day'))
        writer.uint32(/* id 635, wireType 1 =*/ 5081).double(message.lowChangePercent100Day);
      if (message.movingAverage100Day != null && Object.hasOwnProperty.call(message, 'movingAverage100Day'))
        writer.uint32(/* id 636, wireType 1 =*/ 5089).double(message.movingAverage100Day);
      if (
        message.movingAverageChangePercent100Day != null &&
        Object.hasOwnProperty.call(message, 'movingAverageChangePercent100Day')
      )
        writer.uint32(/* id 637, wireType 1 =*/ 5097).double(message.movingAverageChangePercent100Day);
      if (message.averageVolume200Day != null && Object.hasOwnProperty.call(message, 'averageVolume200Day'))
        writer.uint32(/* id 640, wireType 0 =*/ 5120).int64(message.averageVolume200Day);
      if (
        message.averageVolumeChangePercent200Day != null &&
        Object.hasOwnProperty.call(message, 'averageVolumeChangePercent200Day')
      )
        writer.uint32(/* id 641, wireType 1 =*/ 5129).double(message.averageVolumeChangePercent200Day);
      if (message.high200Day != null && Object.hasOwnProperty.call(message, 'high200Day'))
        writer.uint32(/* id 642, wireType 1 =*/ 5137).double(message.high200Day);
      if (message.highChangePercent200Day != null && Object.hasOwnProperty.call(message, 'highChangePercent200Day'))
        writer.uint32(/* id 643, wireType 1 =*/ 5145).double(message.highChangePercent200Day);
      if (message.low200Day != null && Object.hasOwnProperty.call(message, 'low200Day'))
        writer.uint32(/* id 644, wireType 1 =*/ 5153).double(message.low200Day);
      if (message.lowChangePercent200Day != null && Object.hasOwnProperty.call(message, 'lowChangePercent200Day'))
        writer.uint32(/* id 645, wireType 1 =*/ 5161).double(message.lowChangePercent200Day);
      if (message.movingAverage200Day != null && Object.hasOwnProperty.call(message, 'movingAverage200Day'))
        writer.uint32(/* id 646, wireType 1 =*/ 5169).double(message.movingAverage200Day);
      if (
        message.movingAverageChangePercent200Day != null &&
        Object.hasOwnProperty.call(message, 'movingAverageChangePercent200Day')
      )
        writer.uint32(/* id 647, wireType 1 =*/ 5177).double(message.movingAverageChangePercent200Day);
      if (message.movingAverage250Day != null && Object.hasOwnProperty.call(message, 'movingAverage250Day'))
        writer.uint32(/* id 648, wireType 1 =*/ 5185).double(message.movingAverage250Day);
      if (
        message.movingAverageChangePercent250Day != null &&
        Object.hasOwnProperty.call(message, 'movingAverageChangePercent250Day')
      )
        writer.uint32(/* id 649, wireType 1 =*/ 5193).double(message.movingAverageChangePercent250Day);
      if (message.averageVolume90Day != null && Object.hasOwnProperty.call(message, 'averageVolume90Day'))
        writer.uint32(/* id 650, wireType 0 =*/ 5200).int64(message.averageVolume90Day);
      if (message.lowAllTime != null && Object.hasOwnProperty.call(message, 'lowAllTime'))
        writer.uint32(/* id 653, wireType 1 =*/ 5225).double(message.lowAllTime);
      if (message.highAllTime != null && Object.hasOwnProperty.call(message, 'highAllTime'))
        writer.uint32(/* id 654, wireType 1 =*/ 5233).double(message.highAllTime);
      if (message.quickRatioMrq != null && Object.hasOwnProperty.call(message, 'quickRatioMrq'))
        writer.uint32(/* id 655, wireType 1 =*/ 5241).double(message.quickRatioMrq);
      if (message.ffoPerShare != null && Object.hasOwnProperty.call(message, 'ffoPerShare'))
        writer.uint32(/* id 656, wireType 1 =*/ 5249).double(message.ffoPerShare);
      if (message.ipoDateNumber != null && Object.hasOwnProperty.call(message, 'ipoDateNumber'))
        writer.uint32(/* id 657, wireType 0 =*/ 5256).int64(message.ipoDateNumber);
      if (message.ltDebtEquity != null && Object.hasOwnProperty.call(message, 'ltDebtEquity'))
        writer.uint32(/* id 658, wireType 1 =*/ 5265).double(message.ltDebtEquity);
      if (message.epsGrowthYearAgoQ != null && Object.hasOwnProperty.call(message, 'epsGrowthYearAgoQ'))
        writer.uint32(/* id 659, wireType 1 =*/ 5273).double(message.epsGrowthYearAgoQ);
      if (message.revenueGrowthYearAgoQ != null && Object.hasOwnProperty.call(message, 'revenueGrowthYearAgoQ'))
        writer.uint32(/* id 660, wireType 1 =*/ 5281).double(message.revenueGrowthYearAgoQ);
      if (message.revenueGrowth5Year != null && Object.hasOwnProperty.call(message, 'revenueGrowth5Year'))
        writer.uint32(/* id 661, wireType 1 =*/ 5289).double(message.revenueGrowth5Year);
      if (message.revenueGrowthQ2Q != null && Object.hasOwnProperty.call(message, 'revenueGrowthQ2Q'))
        writer.uint32(/* id 662, wireType 1 =*/ 5297).double(message.revenueGrowthQ2Q);
      if (message.revenueGrowthY2Y != null && Object.hasOwnProperty.call(message, 'revenueGrowthY2Y'))
        writer.uint32(/* id 663, wireType 1 =*/ 5305).double(message.revenueGrowthY2Y);
      if (message.revenueGrowthTtm != null && Object.hasOwnProperty.call(message, 'revenueGrowthTtm'))
        writer.uint32(/* id 664, wireType 1 =*/ 5313).double(message.revenueGrowthTtm);
      if (message.epsGrowth5Year != null && Object.hasOwnProperty.call(message, 'epsGrowth5Year'))
        writer.uint32(/* id 665, wireType 1 =*/ 5321).double(message.epsGrowth5Year);
      if (message.epsGrowthQ2Q != null && Object.hasOwnProperty.call(message, 'epsGrowthQ2Q'))
        writer.uint32(/* id 666, wireType 1 =*/ 5329).double(message.epsGrowthQ2Q);
      if (message.epsGrowthY2Y != null && Object.hasOwnProperty.call(message, 'epsGrowthY2Y'))
        writer.uint32(/* id 667, wireType 1 =*/ 5337).double(message.epsGrowthY2Y);
      if (message.epsGrowthTtm != null && Object.hasOwnProperty.call(message, 'epsGrowthTtm'))
        writer.uint32(/* id 668, wireType 1 =*/ 5345).double(message.epsGrowthTtm);
      if (
        message.dilutedRevenueTtmSurprisePercent != null &&
        Object.hasOwnProperty.call(message, 'dilutedRevenueTtmSurprisePercent')
      )
        writer.uint32(/* id 669, wireType 1 =*/ 5353).double(message.dilutedRevenueTtmSurprisePercent);
      if (
        message.dilutedRevenueMrqSurprisePercent != null &&
        Object.hasOwnProperty.call(message, 'dilutedRevenueMrqSurprisePercent')
      )
        writer.uint32(/* id 670, wireType 1 =*/ 5361).double(message.dilutedRevenueMrqSurprisePercent);
      if (
        message.dilutedEpsTtmSurprisePercent != null &&
        Object.hasOwnProperty.call(message, 'dilutedEpsTtmSurprisePercent')
      )
        writer.uint32(/* id 671, wireType 1 =*/ 5369).double(message.dilutedEpsTtmSurprisePercent);
      if (
        message.dilutedEpsMrqSurprisePercent != null &&
        Object.hasOwnProperty.call(message, 'dilutedEpsMrqSurprisePercent')
      )
        writer.uint32(/* id 672, wireType 1 =*/ 5377).double(message.dilutedEpsMrqSurprisePercent);
      if (message.adr14d != null && Object.hasOwnProperty.call(message, 'adr14d'))
        writer.uint32(/* id 673, wireType 1 =*/ 5385).double(message.adr14d);
      if (message.gapChangePercent != null && Object.hasOwnProperty.call(message, 'gapChangePercent'))
        writer.uint32(/* id 674, wireType 1 =*/ 5393).double(message.gapChangePercent);
      if (message.gapChange != null && Object.hasOwnProperty.call(message, 'gapChange'))
        writer.uint32(/* id 675, wireType 1 =*/ 5401).double(message.gapChange);
      if (message.movingAverage500Day != null && Object.hasOwnProperty.call(message, 'movingAverage500Day'))
        writer.uint32(/* id 676, wireType 1 =*/ 5409).double(message.movingAverage500Day);
      if (message.dividendGrowthRate5Year != null && Object.hasOwnProperty.call(message, 'dividendGrowthRate5Year'))
        writer.uint32(/* id 677, wireType 1 =*/ 5417).double(message.dividendGrowthRate5Year);
      if (message.dividendGrowthRate3Year != null && Object.hasOwnProperty.call(message, 'dividendGrowthRate3Year'))
        writer.uint32(/* id 678, wireType 1 =*/ 5425).double(message.dividendGrowthRate3Year);
      if (message.dividendGrowthRate1Year != null && Object.hasOwnProperty.call(message, 'dividendGrowthRate1Year'))
        writer.uint32(/* id 679, wireType 1 =*/ 5433).double(message.dividendGrowthRate1Year);
      if (message.newsBzWireTitle != null && Object.hasOwnProperty.call(message, 'newsBzWireTitle'))
        writer.uint32(/* id 680, wireType 2 =*/ 5442).string(message.newsBzWireTitle);
      if (message.newsBzWireNodeId != null && Object.hasOwnProperty.call(message, 'newsBzWireNodeId'))
        writer.uint32(/* id 681, wireType 2 =*/ 5450).string(message.newsBzWireNodeId);
      if (message.newsBzWireTimestamp != null && Object.hasOwnProperty.call(message, 'newsBzWireTimestamp'))
        writer.uint32(/* id 682, wireType 0 =*/ 5456).int64(message.newsBzWireTimestamp);
      if (message.newsPRTitle != null && Object.hasOwnProperty.call(message, 'newsPRTitle'))
        writer.uint32(/* id 683, wireType 2 =*/ 5466).string(message.newsPRTitle);
      if (message.newsPRNodeId != null && Object.hasOwnProperty.call(message, 'newsPRNodeId'))
        writer.uint32(/* id 684, wireType 2 =*/ 5474).string(message.newsPRNodeId);
      if (message.newsPRTimestamp != null && Object.hasOwnProperty.call(message, 'newsPRTimestamp'))
        writer.uint32(/* id 685, wireType 0 =*/ 5480).int64(message.newsPRTimestamp);
      if (message.newsSecTitle != null && Object.hasOwnProperty.call(message, 'newsSecTitle'))
        writer.uint32(/* id 686, wireType 2 =*/ 5490).string(message.newsSecTitle);
      if (message.newsSecNodeId != null && Object.hasOwnProperty.call(message, 'newsSecNodeId'))
        writer.uint32(/* id 687, wireType 2 =*/ 5498).string(message.newsSecNodeId);
      if (message.newsSecTimestamp != null && Object.hasOwnProperty.call(message, 'newsSecTimestamp'))
        writer.uint32(/* id 688, wireType 0 =*/ 5504).int64(message.newsSecTimestamp);
      if (message.mtdChange != null && Object.hasOwnProperty.call(message, 'mtdChange'))
        writer.uint32(/* id 694, wireType 1 =*/ 5553).double(message.mtdChange);
      if (message.ytdChange != null && Object.hasOwnProperty.call(message, 'ytdChange'))
        writer.uint32(/* id 695, wireType 1 =*/ 5561).double(message.ytdChange);
      if (message.macdSignalLineBase != null && Object.hasOwnProperty.call(message, 'macdSignalLineBase'))
        writer.uint32(/* id 696, wireType 1 =*/ 5569).double(message.macdSignalLineBase);
      if (message.macdHistogram != null && Object.hasOwnProperty.call(message, 'macdHistogram'))
        writer.uint32(/* id 697, wireType 1 =*/ 5577).double(message.macdHistogram);
      if (message.macdSignalLine != null && Object.hasOwnProperty.call(message, 'macdSignalLine'))
        writer.uint32(/* id 698, wireType 1 =*/ 5585).double(message.macdSignalLine);
      if (message.macd != null && Object.hasOwnProperty.call(message, 'macd'))
        writer.uint32(/* id 699, wireType 1 =*/ 5593).double(message.macd);
      if (message.wiim != null && Object.hasOwnProperty.call(message, 'wiim'))
        writer.uint32(/* id 700, wireType 2 =*/ 5602).string(message.wiim);
      if (message.wiimAsOf != null && Object.hasOwnProperty.call(message, 'wiimAsOf'))
        writer.uint32(/* id 701, wireType 0 =*/ 5608).int64(message.wiimAsOf);
      if (message.vwap != null && Object.hasOwnProperty.call(message, 'vwap'))
        writer.uint32(/* id 702, wireType 1 =*/ 5617).double(message.vwap);
      if (message.vwapChangePercent != null && Object.hasOwnProperty.call(message, 'vwapChangePercent'))
        writer.uint32(/* id 704, wireType 1 =*/ 5633).double(message.vwapChangePercent);
      if (message.vwapChange != null && Object.hasOwnProperty.call(message, 'vwapChange'))
        writer.uint32(/* id 705, wireType 1 =*/ 5641).double(message.vwapChange);
      if (message.rsiAvgGain != null && Object.hasOwnProperty.call(message, 'rsiAvgGain'))
        writer.uint32(/* id 706, wireType 1 =*/ 5649).double(message.rsiAvgGain);
      if (message.rsiAvgLoss != null && Object.hasOwnProperty.call(message, 'rsiAvgLoss'))
        writer.uint32(/* id 707, wireType 1 =*/ 5657).double(message.rsiAvgLoss);
      if (message.halted != null && Object.hasOwnProperty.call(message, 'halted'))
        writer.uint32(/* id 708, wireType 2 =*/ 5666).string(message.halted);
      if (message.tradeCount != null && Object.hasOwnProperty.call(message, 'tradeCount'))
        writer.uint32(/* id 709, wireType 0 =*/ 5672).int64(message.tradeCount);
      if (message.regularHighCount != null && Object.hasOwnProperty.call(message, 'regularHighCount'))
        writer.uint32(/* id 710, wireType 0 =*/ 5680).int64(message.regularHighCount);
      if (message.regularLowCount != null && Object.hasOwnProperty.call(message, 'regularLowCount'))
        writer.uint32(/* id 711, wireType 0 =*/ 5688).int64(message.regularLowCount);
      if (message.preMarketHighCount != null && Object.hasOwnProperty.call(message, 'preMarketHighCount'))
        writer.uint32(/* id 712, wireType 0 =*/ 5696).int64(message.preMarketHighCount);
      if (message.preMarketLowCount != null && Object.hasOwnProperty.call(message, 'preMarketLowCount'))
        writer.uint32(/* id 713, wireType 0 =*/ 5704).int64(message.preMarketLowCount);
      if (message.afterMarketHighCount != null && Object.hasOwnProperty.call(message, 'afterMarketHighCount'))
        writer.uint32(/* id 714, wireType 0 =*/ 5712).int64(message.afterMarketHighCount);
      if (message.afterMarketLowCount != null && Object.hasOwnProperty.call(message, 'afterMarketLowCount'))
        writer.uint32(/* id 715, wireType 0 =*/ 5720).int64(message.afterMarketLowCount);
      if (message.dayHighCount != null && Object.hasOwnProperty.call(message, 'dayHighCount'))
        writer.uint32(/* id 716, wireType 0 =*/ 5728).int64(message.dayHighCount);
      if (message.dayLowCount != null && Object.hasOwnProperty.call(message, 'dayLowCount'))
        writer.uint32(/* id 717, wireType 0 =*/ 5736).int64(message.dayLowCount);
      if (message.ema12d != null && Object.hasOwnProperty.call(message, 'ema12d'))
        writer.uint32(/* id 718, wireType 1 =*/ 5745).double(message.ema12d);
      if (message.ema26d != null && Object.hasOwnProperty.call(message, 'ema26d'))
        writer.uint32(/* id 719, wireType 1 =*/ 5753).double(message.ema26d);
      if (message.dayHigh != null && Object.hasOwnProperty.call(message, 'dayHigh'))
        writer.uint32(/* id 720, wireType 1 =*/ 5761).double(message.dayHigh);
      if (message.dayLow != null && Object.hasOwnProperty.call(message, 'dayLow'))
        writer.uint32(/* id 721, wireType 1 =*/ 5769).double(message.dayLow);
      if (message.preMarketHigh != null && Object.hasOwnProperty.call(message, 'preMarketHigh'))
        writer.uint32(/* id 722, wireType 1 =*/ 5777).double(message.preMarketHigh);
      if (message.preMarketLow != null && Object.hasOwnProperty.call(message, 'preMarketLow'))
        writer.uint32(/* id 723, wireType 1 =*/ 5785).double(message.preMarketLow);
      if (message.afterMarketHigh != null && Object.hasOwnProperty.call(message, 'afterMarketHigh'))
        writer.uint32(/* id 724, wireType 1 =*/ 5793).double(message.afterMarketHigh);
      if (message.afterMarketLow != null && Object.hasOwnProperty.call(message, 'afterMarketLow'))
        writer.uint32(/* id 725, wireType 1 =*/ 5801).double(message.afterMarketLow);
      if (message.regularHigh != null && Object.hasOwnProperty.call(message, 'regularHigh'))
        writer.uint32(/* id 726, wireType 1 =*/ 5809).double(message.regularHigh);
      if (message.regularLow != null && Object.hasOwnProperty.call(message, 'regularLow'))
        writer.uint32(/* id 727, wireType 1 =*/ 5817).double(message.regularLow);
      if (message.priceSpikeUpCount != null && Object.hasOwnProperty.call(message, 'priceSpikeUpCount'))
        writer.uint32(/* id 728, wireType 0 =*/ 5824).int64(message.priceSpikeUpCount);
      if (message.priceSpikeDownCount != null && Object.hasOwnProperty.call(message, 'priceSpikeDownCount'))
        writer.uint32(/* id 729, wireType 0 =*/ 5832).int64(message.priceSpikeDownCount);
      if (message.haltedCount != null && Object.hasOwnProperty.call(message, 'haltedCount'))
        writer.uint32(/* id 730, wireType 0 =*/ 5840).int64(message.haltedCount);
      if (message.usCongressTotal != null && Object.hasOwnProperty.call(message, 'usCongressTotal'))
        writer.uint32(/* id 731, wireType 1 =*/ 5849).double(message.usCongressTotal);
      if (
        message.usCongressRepublicansTotal != null &&
        Object.hasOwnProperty.call(message, 'usCongressRepublicansTotal')
      )
        writer.uint32(/* id 732, wireType 1 =*/ 5857).double(message.usCongressRepublicansTotal);
      if (message.usCongressDemocratsTotal != null && Object.hasOwnProperty.call(message, 'usCongressDemocratsTotal'))
        writer.uint32(/* id 733, wireType 1 =*/ 5865).double(message.usCongressDemocratsTotal);
      if (message.usCongressOtherTotal != null && Object.hasOwnProperty.call(message, 'usCongressOtherTotal'))
        writer.uint32(/* id 734, wireType 1 =*/ 5873).double(message.usCongressOtherTotal);
      if (message.volumeFloatRatio != null && Object.hasOwnProperty.call(message, 'volumeFloatRatio'))
        writer.uint32(/* id 735, wireType 1 =*/ 5881).double(message.volumeFloatRatio);
      if (message.atrp != null && Object.hasOwnProperty.call(message, 'atrp'))
        writer.uint32(/* id 736, wireType 1 =*/ 5889).double(message.atrp);
      if (message.ytdGainLoss != null && Object.hasOwnProperty.call(message, 'ytdGainLoss'))
        writer.uint32(/* id 737, wireType 1 =*/ 5897).double(message.ytdGainLoss);
      if (message.mtdGainLoss != null && Object.hasOwnProperty.call(message, 'mtdGainLoss'))
        writer.uint32(/* id 738, wireType 1 =*/ 5905).double(message.mtdGainLoss);
      if (message.yearOpen != null && Object.hasOwnProperty.call(message, 'yearOpen'))
        writer.uint32(/* id 739, wireType 1 =*/ 5913).double(message.yearOpen);
      if (message.rsi1m != null && Object.hasOwnProperty.call(message, 'rsi1m'))
        writer.uint32(/* id 740, wireType 1 =*/ 5921).double(message.rsi1m);
      if (message.rsi2m != null && Object.hasOwnProperty.call(message, 'rsi2m'))
        writer.uint32(/* id 741, wireType 1 =*/ 5929).double(message.rsi2m);
      if (message.rsi5m != null && Object.hasOwnProperty.call(message, 'rsi5m'))
        writer.uint32(/* id 742, wireType 1 =*/ 5937).double(message.rsi5m);
      if (message.rsi15m != null && Object.hasOwnProperty.call(message, 'rsi15m'))
        writer.uint32(/* id 743, wireType 1 =*/ 5945).double(message.rsi15m);
      if (message.rsi30m != null && Object.hasOwnProperty.call(message, 'rsi30m'))
        writer.uint32(/* id 745, wireType 1 =*/ 5961).double(message.rsi30m);
      if (message.rsi60m != null && Object.hasOwnProperty.call(message, 'rsi60m'))
        writer.uint32(/* id 746, wireType 1 =*/ 5969).double(message.rsi60m);
      if (message.rsiEth1m != null && Object.hasOwnProperty.call(message, 'rsiEth1m'))
        writer.uint32(/* id 747, wireType 1 =*/ 5977).double(message.rsiEth1m);
      if (message.rsiEth2m != null && Object.hasOwnProperty.call(message, 'rsiEth2m'))
        writer.uint32(/* id 748, wireType 1 =*/ 5985).double(message.rsiEth2m);
      if (message.rsiEth5m != null && Object.hasOwnProperty.call(message, 'rsiEth5m'))
        writer.uint32(/* id 749, wireType 1 =*/ 5993).double(message.rsiEth5m);
      if (message.rsiEth15m != null && Object.hasOwnProperty.call(message, 'rsiEth15m'))
        writer.uint32(/* id 750, wireType 1 =*/ 6001).double(message.rsiEth15m);
      if (message.rsiEth30m != null && Object.hasOwnProperty.call(message, 'rsiEth30m'))
        writer.uint32(/* id 751, wireType 1 =*/ 6009).double(message.rsiEth30m);
      if (message.rsiEth60m != null && Object.hasOwnProperty.call(message, 'rsiEth60m'))
        writer.uint32(/* id 752, wireType 1 =*/ 6017).double(message.rsiEth60m);
      if (message.monthOpen != null && Object.hasOwnProperty.call(message, 'monthOpen'))
        writer.uint32(/* id 753, wireType 1 =*/ 6025).double(message.monthOpen);
      if (message.volumeFloatPercent != null && Object.hasOwnProperty.call(message, 'volumeFloatPercent'))
        writer.uint32(/* id 754, wireType 1 =*/ 6033).double(message.volumeFloatPercent);
      if (message.averageDollarVolume10Day != null && Object.hasOwnProperty.call(message, 'averageDollarVolume10Day'))
        writer.uint32(/* id 755, wireType 1 =*/ 6041).double(message.averageDollarVolume10Day);
      if (message.averageVolume60Day != null && Object.hasOwnProperty.call(message, 'averageVolume60Day'))
        writer.uint32(/* id 756, wireType 0 =*/ 6048).int64(message.averageVolume60Day);
      if (
        message.relativeVolumePercent60Day != null &&
        Object.hasOwnProperty.call(message, 'relativeVolumePercent60Day')
      )
        writer.uint32(/* id 757, wireType 1 =*/ 6057).double(message.relativeVolumePercent60Day);
      if (message.price1Week != null && Object.hasOwnProperty.call(message, 'price1Week'))
        writer.uint32(/* id 800, wireType 1 =*/ 6401).double(message.price1Week);
      if (message.priceChangePercent1Week != null && Object.hasOwnProperty.call(message, 'priceChangePercent1Week'))
        writer.uint32(/* id 801, wireType 1 =*/ 6409).double(message.priceChangePercent1Week);
      if (message.price1Month != null && Object.hasOwnProperty.call(message, 'price1Month'))
        writer.uint32(/* id 802, wireType 1 =*/ 6417).double(message.price1Month);
      if (message.priceChangePercent1Month != null && Object.hasOwnProperty.call(message, 'priceChangePercent1Month'))
        writer.uint32(/* id 803, wireType 1 =*/ 6425).double(message.priceChangePercent1Month);
      if (message.priceHalfYear != null && Object.hasOwnProperty.call(message, 'priceHalfYear'))
        writer.uint32(/* id 804, wireType 1 =*/ 6433).double(message.priceHalfYear);
      if (
        message.priceChangePercentHalfYear != null &&
        Object.hasOwnProperty.call(message, 'priceChangePercentHalfYear')
      )
        writer.uint32(/* id 805, wireType 1 =*/ 6441).double(message.priceChangePercentHalfYear);
      if (message.priceQuarter != null && Object.hasOwnProperty.call(message, 'priceQuarter'))
        writer.uint32(/* id 806, wireType 1 =*/ 6449).double(message.priceQuarter);
      if (message.priceChangePercentQuarter != null && Object.hasOwnProperty.call(message, 'priceChangePercentQuarter'))
        writer.uint32(/* id 807, wireType 1 =*/ 6457).double(message.priceChangePercentQuarter);
      if (message.price1Year != null && Object.hasOwnProperty.call(message, 'price1Year'))
        writer.uint32(/* id 808, wireType 1 =*/ 6465).double(message.price1Year);
      if (message.priceChangePercent1Year != null && Object.hasOwnProperty.call(message, 'priceChangePercent1Year'))
        writer.uint32(/* id 809, wireType 1 =*/ 6473).double(message.priceChangePercent1Year);
      if (message.priceYearToDate != null && Object.hasOwnProperty.call(message, 'priceYearToDate'))
        writer.uint32(/* id 810, wireType 1 =*/ 6481).double(message.priceYearToDate);
      if (
        message.priceChangePercentYearToDate != null &&
        Object.hasOwnProperty.call(message, 'priceChangePercentYearToDate')
      )
        writer.uint32(/* id 811, wireType 1 =*/ 6489).double(message.priceChangePercentYearToDate);
      if (message.bullsSay != null && Object.hasOwnProperty.call(message, 'bullsSay'))
        writer.uint32(/* id 812, wireType 2 =*/ 6498).string(message.bullsSay);
      if (message.bearsSay != null && Object.hasOwnProperty.call(message, 'bearsSay'))
        writer.uint32(/* id 813, wireType 2 =*/ 6506).string(message.bearsSay);
      if (message.preMarketOpen != null && Object.hasOwnProperty.call(message, 'preMarketOpen'))
        writer.uint32(/* id 900, wireType 1 =*/ 7201).double(message.preMarketOpen);
      if (message.preMarketOpenTime != null && Object.hasOwnProperty.call(message, 'preMarketOpenTime'))
        writer.uint32(/* id 901, wireType 0 =*/ 7208).int64(message.preMarketOpenTime);
      if (message.preMarketVolume != null && Object.hasOwnProperty.call(message, 'preMarketVolume'))
        writer.uint32(/* id 902, wireType 0 =*/ 7216).int64(message.preMarketVolume);
      if (message.preMarketOpenChange != null && Object.hasOwnProperty.call(message, 'preMarketOpenChange'))
        writer.uint32(/* id 903, wireType 1 =*/ 7225).double(message.preMarketOpenChange);
      if (
        message.preMarketOpenChangePercent != null &&
        Object.hasOwnProperty.call(message, 'preMarketOpenChangePercent')
      )
        writer.uint32(/* id 904, wireType 1 =*/ 7233).double(message.preMarketOpenChangePercent);
      if (message.source != null && Object.hasOwnProperty.call(message, 'source'))
        writer.uint32(/* id 905, wireType 0 =*/ 7240).int32(message.source);
      if (message.clearFieldNumbers != null && message.clearFieldNumbers.length) {
        writer.uint32(/* id 906, wireType 2 =*/ 7250).fork();
        for (let i = 0; i < message.clearFieldNumbers.length; ++i) writer.int32(message.clearFieldNumbers[i]);
        writer.ldelim();
      }
      if (message.totalDebtEquityRatio != null && Object.hasOwnProperty.call(message, 'totalDebtEquityRatio'))
        writer.uint32(/* id 907, wireType 1 =*/ 7257).double(message.totalDebtEquityRatio);
      if (message.dividendPayoutRatio != null && Object.hasOwnProperty.call(message, 'dividendPayoutRatio'))
        writer.uint32(/* id 908, wireType 1 =*/ 7265).double(message.dividendPayoutRatio);
      if (message.operatingCashFlowPerShare != null && Object.hasOwnProperty.call(message, 'operatingCashFlowPerShare'))
        writer.uint32(/* id 909, wireType 1 =*/ 7273).double(message.operatingCashFlowPerShare);
      if (message.insiderPercentage != null && Object.hasOwnProperty.call(message, 'insiderPercentage'))
        writer.uint32(/* id 910, wireType 1 =*/ 7281).double(message.insiderPercentage);
      if (message.priceToCashFlowRatio != null && Object.hasOwnProperty.call(message, 'priceToCashFlowRatio'))
        writer.uint32(/* id 911, wireType 1 =*/ 7289).double(message.priceToCashFlowRatio);
      if (message.regularHoursChange != null && Object.hasOwnProperty.call(message, 'regularHoursChange'))
        writer.uint32(/* id 912, wireType 1 =*/ 7297).double(message.regularHoursChange);
      if (message.regularHoursPercentChange != null && Object.hasOwnProperty.call(message, 'regularHoursPercentChange'))
        writer.uint32(/* id 913, wireType 1 =*/ 7305).double(message.regularHoursPercentChange);
      if (message.postToPreHoursChange != null && Object.hasOwnProperty.call(message, 'postToPreHoursChange'))
        writer.uint32(/* id 914, wireType 1 =*/ 7313).double(message.postToPreHoursChange);
      if (
        message.postToPreHoursPercentChange != null &&
        Object.hasOwnProperty.call(message, 'postToPreHoursPercentChange')
      )
        writer.uint32(/* id 915, wireType 1 =*/ 7321).double(message.postToPreHoursPercentChange);
      if (message.scannerClose != null && Object.hasOwnProperty.call(message, 'scannerClose'))
        writer.uint32(/* id 916, wireType 1 =*/ 7329).double(message.scannerClose);
      if (message.scannerChange != null && Object.hasOwnProperty.call(message, 'scannerChange'))
        writer.uint32(/* id 917, wireType 1 =*/ 7337).double(message.scannerChange);
      if (message.scannerChangePercent != null && Object.hasOwnProperty.call(message, 'scannerChangePercent'))
        writer.uint32(/* id 918, wireType 1 =*/ 7345).double(message.scannerChangePercent);
      if (message.scannerChangePercentClose != null && Object.hasOwnProperty.call(message, 'scannerChangePercentClose'))
        writer.uint32(/* id 919, wireType 1 =*/ 7353).double(message.scannerChangePercentClose);
      if (message.scannerPreviousClose != null && Object.hasOwnProperty.call(message, 'scannerPreviousClose'))
        writer.uint32(/* id 920, wireType 1 =*/ 7361).double(message.scannerPreviousClose);
      if (message.freeCashFlow != null && Object.hasOwnProperty.call(message, 'freeCashFlow'))
        writer.uint32(/* id 921, wireType 1 =*/ 7369).double(message.freeCashFlow);
      if (message.minPriceTarget != null && Object.hasOwnProperty.call(message, 'minPriceTarget'))
        writer.uint32(/* id 922, wireType 1 =*/ 7377).double(message.minPriceTarget);
      if (message.maxPriceTarget != null && Object.hasOwnProperty.call(message, 'maxPriceTarget'))
        writer.uint32(/* id 923, wireType 1 =*/ 7385).double(message.maxPriceTarget);
      if (message.meanPriceTarget != null && Object.hasOwnProperty.call(message, 'meanPriceTarget'))
        writer.uint32(/* id 924, wireType 1 =*/ 7393).double(message.meanPriceTarget);
      if (message.totalNumberOfAnalyst != null && Object.hasOwnProperty.call(message, 'totalNumberOfAnalyst'))
        writer.uint32(/* id 925, wireType 1 =*/ 7401).double(message.totalNumberOfAnalyst);
      if (
        message.averageAnalystRecommendation != null &&
        Object.hasOwnProperty.call(message, 'averageAnalystRecommendation')
      )
        writer.uint32(/* id 926, wireType 2 =*/ 7410).string(message.averageAnalystRecommendation);
      if (message.pegRatio != null && Object.hasOwnProperty.call(message, 'pegRatio'))
        writer.uint32(/* id 927, wireType 1 =*/ 7417).double(message.pegRatio);
      if (message.priceToFreeCashFlowRatio != null && Object.hasOwnProperty.call(message, 'priceToFreeCashFlowRatio'))
        writer.uint32(/* id 928, wireType 1 =*/ 7425).double(message.priceToFreeCashFlowRatio);
      if (message.distanceToMaxPriceTarget != null && Object.hasOwnProperty.call(message, 'distanceToMaxPriceTarget'))
        writer.uint32(/* id 929, wireType 1 =*/ 7433).double(message.distanceToMaxPriceTarget);
      if (message.distanceToMinPriceTarget != null && Object.hasOwnProperty.call(message, 'distanceToMinPriceTarget'))
        writer.uint32(/* id 930, wireType 1 =*/ 7441).double(message.distanceToMinPriceTarget);
      if (message.distanceToMeanPriceTarget != null && Object.hasOwnProperty.call(message, 'distanceToMeanPriceTarget'))
        writer.uint32(/* id 931, wireType 1 =*/ 7449).double(message.distanceToMeanPriceTarget);
      if (message.shortTermTrend != null && Object.hasOwnProperty.call(message, 'shortTermTrend'))
        writer.uint32(/* id 932, wireType 2 =*/ 7458).string(message.shortTermTrend);
      if (message.mediumTermTrend != null && Object.hasOwnProperty.call(message, 'mediumTermTrend'))
        writer.uint32(/* id 933, wireType 2 =*/ 7466).string(message.mediumTermTrend);
      if (message.longTermTrend != null && Object.hasOwnProperty.call(message, 'longTermTrend'))
        writer.uint32(/* id 934, wireType 2 =*/ 7474).string(message.longTermTrend);
      return writer;
    };

    /**
     * Encodes the specified Quote message, length delimited. Does not implicitly {@link LastProtos.Quote.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LastProtos.Quote
     * @static
     * @param {LastProtos.IQuote} message Quote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Quote.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Quote message from the specified reader or buffer.
     * @function decode
     * @memberof LastProtos.Quote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LastProtos.Quote} Quote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Quote.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.LastProtos.Quote();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.symbol = reader.string();
            break;
          }
          case 100: {
            message.opol = reader.string();
            break;
          }
          case 2: {
            message.previousClose = reader.double();
            break;
          }
          case 3: {
            message.close = reader.double();
            break;
          }
          case 4: {
            message.change = reader.double();
            break;
          }
          case 5: {
            message.changePercent = reader.double();
            break;
          }
          case 6: {
            message.name = reader.string();
            break;
          }
          case 7: {
            message.ipoDate = reader.string();
            break;
          }
          case 8: {
            message.exchange = reader.string();
            break;
          }
          case 9: {
            message.tradeExchange = reader.string();
            break;
          }
          case 900: {
            message.preMarketOpen = reader.double();
            break;
          }
          case 901: {
            message.preMarketOpenTime = reader.int64();
            break;
          }
          case 902: {
            message.preMarketVolume = reader.int64();
            break;
          }
          case 903: {
            message.preMarketOpenChange = reader.double();
            break;
          }
          case 904: {
            message.preMarketOpenChangePercent = reader.double();
            break;
          }
          case 905: {
            message.source = reader.int32();
            break;
          }
          case 906: {
            if (!(message.clearFieldNumbers && message.clearFieldNumbers.length)) message.clearFieldNumbers = [];
            if ((tag & 7) === 2) {
              let end2 = reader.uint32() + reader.pos;
              while (reader.pos < end2) message.clearFieldNumbers.push(reader.int32());
            } else message.clearFieldNumbers.push(reader.int32());
            break;
          }
          case 10: {
            message.marketCap = reader.int64();
            break;
          }
          case 11: {
            message.rsi = reader.double();
            break;
          }
          case 12: {
            message.atr = reader.double();
            break;
          }
          case 13: {
            message.priceToEarnings = reader.double();
            break;
          }
          case 14: {
            message.averageVolume = reader.int64();
            break;
          }
          case 15: {
            message.sharesOutstanding = reader.int64();
            break;
          }
          case 16: {
            message.sector = reader.string();
            break;
          }
          case 17: {
            message.sectorCode = reader.int32();
            break;
          }
          case 18: {
            message.industry = reader.string();
            break;
          }
          case 19: {
            message.industryCode = reader.int32();
            break;
          }
          case 20: {
            message.forwardPERatio = reader.double();
            break;
          }
          case 21: {
            message.pricetoEBITDA = reader.double();
            break;
          }
          case 22: {
            message.trailingDividendYield = reader.double();
            break;
          }
          case 23: {
            message.PBRatio = reader.double();
            break;
          }
          case 24: {
            message.priceToSales = reader.double();
            break;
          }
          case 25: {
            message.FCFPerShare = reader.double();
            break;
          }
          case 26: {
            message.buyBackYield = reader.double();
            break;
          }
          case 27: {
            message.open = reader.double();
            break;
          }
          case 28: {
            message.price = reader.double();
            break;
          }
          case 29: {
            message.high = reader.double();
            break;
          }
          case 30: {
            message.low = reader.double();
            break;
          }
          case 31: {
            message.time = reader.int64();
            break;
          }
          case 32: {
            message.size = reader.int32();
            break;
          }
          case 33: {
            message.type = reader.string();
            break;
          }
          case 34: {
            message.dayVolume = reader.int64();
            break;
          }
          case 35: {
            message.askPrice = reader.double();
            break;
          }
          case 36: {
            message.bidPrice = reader.double();
            break;
          }
          case 37: {
            message.shareFloatDate = reader.string();
            break;
          }
          case 38: {
            message.sharesOutstandingDate = reader.string();
            break;
          }
          case 81: {
            message.shareFloat = reader.int64();
            break;
          }
          case 40: {
            message.updateType = reader.int32();
            break;
          }
          case 101: {
            message.subtype = reader.string();
            break;
          }
          case 41: {
            message.sessionType = reader.int32();
            break;
          }
          case 96: {
            message.volume = reader.int64();
            break;
          }
          case 50: {
            message.changePercent1Minute = reader.double();
            break;
          }
          case 51: {
            message.changePercentClose = reader.double();
            break;
          }
          case 52: {
            message.changePercent5Minute = reader.double();
            break;
          }
          case 53: {
            message.volume1Minute = reader.int64();
            break;
          }
          case 54: {
            message.relativeVolume1Minute = reader.double();
            break;
          }
          case 55: {
            message.change15Minute = reader.double();
            break;
          }
          case 56: {
            message.changePercent15Minute = reader.double();
            break;
          }
          case 57: {
            message.change30Minute = reader.double();
            break;
          }
          case 58: {
            message.changePercent30Minute = reader.double();
            break;
          }
          case 59: {
            message.change60Minute = reader.double();
            break;
          }
          case 60: {
            message.changePercent60Minute = reader.double();
            break;
          }
          case 61: {
            message.changePercentOpen = reader.double();
            break;
          }
          case 62: {
            message.changeOpen = reader.double();
            break;
          }
          case 70: {
            message.gics = reader.int32();
            break;
          }
          case 71: {
            message.gicsSector = reader.int32();
            break;
          }
          case 72: {
            message.gicsSectorName = reader.string();
            break;
          }
          case 73: {
            message.gicsIndustryGroup = reader.int32();
            break;
          }
          case 74: {
            message.gicsIndustryGroupName = reader.string();
            break;
          }
          case 75: {
            message.gicsIndustry = reader.int32();
            break;
          }
          case 76: {
            message.gicsIndustryName = reader.string();
            break;
          }
          case 77: {
            message.gicsSubIndustry = reader.int32();
            break;
          }
          case 78: {
            message.gicsSubIndustryName = reader.string();
            break;
          }
          case 79: {
            message.optionable = reader.int32();
            break;
          }
          case 39: {
            message.cik = reader.int32();
            break;
          }
          case 80: {
            message.signalName = reader.string();
            break;
          }
          case 82: {
            message.lastTradeTime = reader.int64();
            break;
          }
          case 83: {
            message.country = reader.string();
            break;
          }
          case 110: {
            message.sharesShort = reader.int64();
            break;
          }
          case 111: {
            message.sharesShortPercentOfFloat = reader.double();
            break;
          }
          case 112: {
            message.sharesShortChangePercent = reader.double();
            break;
          }
          case 113: {
            message.sharesShortReceiptDate = reader.int64();
            break;
          }
          case 114: {
            message.sharesShortSettlementDate = reader.int64();
            break;
          }
          case 115: {
            message.shortInterestRatio = reader.double();
            break;
          }
          case 116: {
            message.sharesShortValue = reader.double();
            break;
          }
          case 117: {
            message.sharesShortPrevious = reader.int64();
            break;
          }
          case 118: {
            message.sharesShortPreviousValue = reader.double();
            break;
          }
          case 119: {
            message.sharesShortPreviousPercentOfFloat = reader.double();
            break;
          }
          case 120: {
            message.sharesShortChange = reader.int64();
            break;
          }
          case 200: {
            message.sentTime = reader.int64();
            break;
          }
          case 300: {
            message.volume5Minute = reader.int64();
            break;
          }
          case 301: {
            message.volume15Minute = reader.int64();
            break;
          }
          case 302: {
            message.volume30Minute = reader.int64();
            break;
          }
          case 303: {
            message.volume60Minute = reader.int64();
            break;
          }
          case 304: {
            message.relativeVolume5Minute = reader.double();
            break;
          }
          case 305: {
            message.relativeVolume90Day = reader.double();
            break;
          }
          case 306: {
            message.rvol1m10d = reader.double();
            break;
          }
          case 307: {
            message.rvol5m10d = reader.double();
            break;
          }
          case 308: {
            message.rvol5m30d = reader.double();
            break;
          }
          case 309: {
            message.rvol5m90d = reader.double();
            break;
          }
          case 600: {
            message.averageVolume10Day = reader.int64();
            break;
          }
          case 601: {
            message.averageVolumeChangePercent10Day = reader.double();
            break;
          }
          case 602: {
            message.high10Day = reader.double();
            break;
          }
          case 603: {
            message.highChangePercent10Day = reader.double();
            break;
          }
          case 604: {
            message.low10Day = reader.double();
            break;
          }
          case 605: {
            message.lowChangePercent10Day = reader.double();
            break;
          }
          case 606: {
            message.movingAverage10Day = reader.double();
            break;
          }
          case 607: {
            message.movingAverageChangePercent10Day = reader.double();
            break;
          }
          case 610: {
            message.averageVolume20Day = reader.int64();
            break;
          }
          case 611: {
            message.averageVolumeChangePercent20Day = reader.double();
            break;
          }
          case 612: {
            message.high20Day = reader.double();
            break;
          }
          case 613: {
            message.highChangePercent20Day = reader.double();
            break;
          }
          case 614: {
            message.low20Day = reader.double();
            break;
          }
          case 615: {
            message.lowChangePercent20Day = reader.double();
            break;
          }
          case 616: {
            message.movingAverage20Day = reader.double();
            break;
          }
          case 617: {
            message.movingAverageChangePercent20Day = reader.double();
            break;
          }
          case 620: {
            message.averageVolume50Day = reader.int64();
            break;
          }
          case 621: {
            message.averageVolumeChangePercent50Day = reader.double();
            break;
          }
          case 622: {
            message.high50Day = reader.double();
            break;
          }
          case 623: {
            message.highChangePercent50Day = reader.double();
            break;
          }
          case 624: {
            message.low50Day = reader.double();
            break;
          }
          case 625: {
            message.lowChangePercent50Day = reader.double();
            break;
          }
          case 626: {
            message.movingAverage50Day = reader.double();
            break;
          }
          case 627: {
            message.movingAverageChangePercent50Day = reader.double();
            break;
          }
          case 630: {
            message.averageVolume100Day = reader.int64();
            break;
          }
          case 631: {
            message.averageVolumeChangePercent100Day = reader.double();
            break;
          }
          case 632: {
            message.high100Day = reader.double();
            break;
          }
          case 633: {
            message.highChangePercent100Day = reader.double();
            break;
          }
          case 634: {
            message.low100Day = reader.double();
            break;
          }
          case 635: {
            message.lowChangePercent100Day = reader.double();
            break;
          }
          case 636: {
            message.movingAverage100Day = reader.double();
            break;
          }
          case 637: {
            message.movingAverageChangePercent100Day = reader.double();
            break;
          }
          case 640: {
            message.averageVolume200Day = reader.int64();
            break;
          }
          case 641: {
            message.averageVolumeChangePercent200Day = reader.double();
            break;
          }
          case 642: {
            message.high200Day = reader.double();
            break;
          }
          case 643: {
            message.highChangePercent200Day = reader.double();
            break;
          }
          case 644: {
            message.low200Day = reader.double();
            break;
          }
          case 645: {
            message.lowChangePercent200Day = reader.double();
            break;
          }
          case 646: {
            message.movingAverage200Day = reader.double();
            break;
          }
          case 647: {
            message.movingAverageChangePercent200Day = reader.double();
            break;
          }
          case 648: {
            message.movingAverage250Day = reader.double();
            break;
          }
          case 649: {
            message.movingAverageChangePercent250Day = reader.double();
            break;
          }
          case 650: {
            message.averageVolume90Day = reader.int64();
            break;
          }
          case 400: {
            message.nextEarningsDate = reader.int32();
            break;
          }
          case 401: {
            message.dividend = reader.double();
            break;
          }
          case 402: {
            message.dividendYield = reader.double();
            break;
          }
          case 403: {
            message.dividendExDate = reader.int32();
            break;
          }
          case 404: {
            message.dividendFrequency = reader.int64();
            break;
          }
          case 405: {
            message.forwardDividendYield = reader.double();
            break;
          }
          case 501: {
            message.roe = reader.double();
            break;
          }
          case 502: {
            message.roa = reader.double();
            break;
          }
          case 503: {
            message.roic = reader.double();
            break;
          }
          case 504: {
            message.currentRatio = reader.double();
            break;
          }
          case 505: {
            message.grossMargin = reader.double();
            break;
          }
          case 506: {
            message.netMargin = reader.double();
            break;
          }
          case 507: {
            message.operationMargin = reader.double();
            break;
          }
          case 508: {
            message.epsMrq = reader.double();
            break;
          }
          case 509: {
            message.epsTtm = reader.double();
            break;
          }
          case 510: {
            message.dilutedEpsMrq = reader.double();
            break;
          }
          case 511: {
            message.dilutedEpsTtm = reader.double();
            break;
          }
          case 512: {
            message.low52Week = reader.double();
            break;
          }
          case 513: {
            message.high52Week = reader.double();
            break;
          }
          case 514: {
            message.revenueTtm = reader.double();
            break;
          }
          case 515: {
            message.earningsAsOf = reader.int32();
            break;
          }
          case 800: {
            message.price1Week = reader.double();
            break;
          }
          case 801: {
            message.priceChangePercent1Week = reader.double();
            break;
          }
          case 802: {
            message.price1Month = reader.double();
            break;
          }
          case 803: {
            message.priceChangePercent1Month = reader.double();
            break;
          }
          case 804: {
            message.priceHalfYear = reader.double();
            break;
          }
          case 805: {
            message.priceChangePercentHalfYear = reader.double();
            break;
          }
          case 806: {
            message.priceQuarter = reader.double();
            break;
          }
          case 807: {
            message.priceChangePercentQuarter = reader.double();
            break;
          }
          case 808: {
            message.price1Year = reader.double();
            break;
          }
          case 809: {
            message.priceChangePercent1Year = reader.double();
            break;
          }
          case 810: {
            message.priceYearToDate = reader.double();
            break;
          }
          case 811: {
            message.priceChangePercentYearToDate = reader.double();
            break;
          }
          case 520: {
            message.roeMrq = reader.double();
            break;
          }
          case 521: {
            message.roaMrq = reader.double();
            break;
          }
          case 522: {
            message.roicMrq = reader.double();
            break;
          }
          case 523: {
            message.currentRatioMrq = reader.double();
            break;
          }
          case 524: {
            message.grossMarginMrq = reader.double();
            break;
          }
          case 525: {
            message.netMarginMrq = reader.double();
            break;
          }
          case 526: {
            message.operationMarginMrq = reader.double();
            break;
          }
          case 527: {
            message.previousDayVolume = reader.int64();
            break;
          }
          case 528: {
            message.previousDayAtr = reader.double();
            break;
          }
          case 529: {
            message.previousDayAdx = reader.double();
            break;
          }
          case 530: {
            message.previousDayPlusDMSmoothed = reader.double();
            break;
          }
          case 531: {
            message.previousDayMinusDMSmoothed = reader.double();
            break;
          }
          case 532: {
            message.previousDayHigh = reader.double();
            break;
          }
          case 533: {
            message.previousDayLow = reader.double();
            break;
          }
          case 534: {
            message.adx = reader.double();
            break;
          }
          case 535: {
            message.percentInstitutionalOwnership = reader.double();
            break;
          }
          case 700: {
            message.wiim = reader.string();
            break;
          }
          case 701: {
            message.wiimAsOf = reader.int64();
            break;
          }
          case 702: {
            message.vwap = reader.double();
            break;
          }
          case 704: {
            message.vwapChangePercent = reader.double();
            break;
          }
          case 705: {
            message.vwapChange = reader.double();
            break;
          }
          case 706: {
            message.rsiAvgGain = reader.double();
            break;
          }
          case 707: {
            message.rsiAvgLoss = reader.double();
            break;
          }
          case 708: {
            message.halted = reader.string();
            break;
          }
          case 709: {
            message.tradeCount = reader.int64();
            break;
          }
          case 710: {
            message.regularHighCount = reader.int64();
            break;
          }
          case 711: {
            message.regularLowCount = reader.int64();
            break;
          }
          case 712: {
            message.preMarketHighCount = reader.int64();
            break;
          }
          case 713: {
            message.preMarketLowCount = reader.int64();
            break;
          }
          case 714: {
            message.afterMarketHighCount = reader.int64();
            break;
          }
          case 715: {
            message.afterMarketLowCount = reader.int64();
            break;
          }
          case 716: {
            message.dayHighCount = reader.int64();
            break;
          }
          case 717: {
            message.dayLowCount = reader.int64();
            break;
          }
          case 720: {
            message.dayHigh = reader.double();
            break;
          }
          case 721: {
            message.dayLow = reader.double();
            break;
          }
          case 722: {
            message.preMarketHigh = reader.double();
            break;
          }
          case 723: {
            message.preMarketLow = reader.double();
            break;
          }
          case 724: {
            message.afterMarketHigh = reader.double();
            break;
          }
          case 725: {
            message.afterMarketLow = reader.double();
            break;
          }
          case 726: {
            message.regularHigh = reader.double();
            break;
          }
          case 727: {
            message.regularLow = reader.double();
            break;
          }
          case 728: {
            message.priceSpikeUpCount = reader.int64();
            break;
          }
          case 729: {
            message.priceSpikeDownCount = reader.int64();
            break;
          }
          case 730: {
            message.haltedCount = reader.int64();
            break;
          }
          case 731: {
            message.usCongressTotal = reader.double();
            break;
          }
          case 732: {
            message.usCongressRepublicansTotal = reader.double();
            break;
          }
          case 733: {
            message.usCongressDemocratsTotal = reader.double();
            break;
          }
          case 734: {
            message.usCongressOtherTotal = reader.double();
            break;
          }
          case 735: {
            message.volumeFloatRatio = reader.double();
            break;
          }
          case 736: {
            message.atrp = reader.double();
            break;
          }
          case 737: {
            message.ytdGainLoss = reader.double();
            break;
          }
          case 738: {
            message.mtdGainLoss = reader.double();
            break;
          }
          case 739: {
            message.yearOpen = reader.double();
            break;
          }
          case 753: {
            message.monthOpen = reader.double();
            break;
          }
          case 754: {
            message.volumeFloatPercent = reader.double();
            break;
          }
          case 695: {
            message.ytdChange = reader.double();
            break;
          }
          case 694: {
            message.mtdChange = reader.double();
            break;
          }
          case 740: {
            message.rsi1m = reader.double();
            break;
          }
          case 741: {
            message.rsi2m = reader.double();
            break;
          }
          case 742: {
            message.rsi5m = reader.double();
            break;
          }
          case 743: {
            message.rsi15m = reader.double();
            break;
          }
          case 745: {
            message.rsi30m = reader.double();
            break;
          }
          case 746: {
            message.rsi60m = reader.double();
            break;
          }
          case 747: {
            message.rsiEth1m = reader.double();
            break;
          }
          case 748: {
            message.rsiEth2m = reader.double();
            break;
          }
          case 749: {
            message.rsiEth5m = reader.double();
            break;
          }
          case 750: {
            message.rsiEth15m = reader.double();
            break;
          }
          case 751: {
            message.rsiEth30m = reader.double();
            break;
          }
          case 752: {
            message.rsiEth60m = reader.double();
            break;
          }
          case 755: {
            message.averageDollarVolume10Day = reader.double();
            break;
          }
          case 756: {
            message.averageVolume60Day = reader.int64();
            break;
          }
          case 757: {
            message.relativeVolumePercent60Day = reader.double();
            break;
          }
          case 718: {
            message.ema12d = reader.double();
            break;
          }
          case 719: {
            message.ema26d = reader.double();
            break;
          }
          case 699: {
            message.macd = reader.double();
            break;
          }
          case 698: {
            message.macdSignalLine = reader.double();
            break;
          }
          case 697: {
            message.macdHistogram = reader.double();
            break;
          }
          case 696: {
            message.macdSignalLineBase = reader.double();
            break;
          }
          case 679: {
            message.dividendGrowthRate1Year = reader.double();
            break;
          }
          case 678: {
            message.dividendGrowthRate3Year = reader.double();
            break;
          }
          case 677: {
            message.dividendGrowthRate5Year = reader.double();
            break;
          }
          case 680: {
            message.newsBzWireTitle = reader.string();
            break;
          }
          case 681: {
            message.newsBzWireNodeId = reader.string();
            break;
          }
          case 682: {
            message.newsBzWireTimestamp = reader.int64();
            break;
          }
          case 683: {
            message.newsPRTitle = reader.string();
            break;
          }
          case 684: {
            message.newsPRNodeId = reader.string();
            break;
          }
          case 685: {
            message.newsPRTimestamp = reader.int64();
            break;
          }
          case 686: {
            message.newsSecTitle = reader.string();
            break;
          }
          case 687: {
            message.newsSecNodeId = reader.string();
            break;
          }
          case 688: {
            message.newsSecTimestamp = reader.int64();
            break;
          }
          case 675: {
            message.gapChange = reader.double();
            break;
          }
          case 674: {
            message.gapChangePercent = reader.double();
            break;
          }
          case 673: {
            message.adr14d = reader.double();
            break;
          }
          case 676: {
            message.movingAverage500Day = reader.double();
            break;
          }
          case 672: {
            message.dilutedEpsMrqSurprisePercent = reader.double();
            break;
          }
          case 671: {
            message.dilutedEpsTtmSurprisePercent = reader.double();
            break;
          }
          case 670: {
            message.dilutedRevenueMrqSurprisePercent = reader.double();
            break;
          }
          case 669: {
            message.dilutedRevenueTtmSurprisePercent = reader.double();
            break;
          }
          case 668: {
            message.epsGrowthTtm = reader.double();
            break;
          }
          case 667: {
            message.epsGrowthY2Y = reader.double();
            break;
          }
          case 666: {
            message.epsGrowthQ2Q = reader.double();
            break;
          }
          case 665: {
            message.epsGrowth5Year = reader.double();
            break;
          }
          case 659: {
            message.epsGrowthYearAgoQ = reader.double();
            break;
          }
          case 664: {
            message.revenueGrowthTtm = reader.double();
            break;
          }
          case 663: {
            message.revenueGrowthY2Y = reader.double();
            break;
          }
          case 662: {
            message.revenueGrowthQ2Q = reader.double();
            break;
          }
          case 661: {
            message.revenueGrowth5Year = reader.double();
            break;
          }
          case 660: {
            message.revenueGrowthYearAgoQ = reader.double();
            break;
          }
          case 658: {
            message.ltDebtEquity = reader.double();
            break;
          }
          case 812: {
            message.bullsSay = reader.string();
            break;
          }
          case 813: {
            message.bearsSay = reader.string();
            break;
          }
          case 657: {
            message.ipoDateNumber = reader.int64();
            break;
          }
          case 656: {
            message.ffoPerShare = reader.double();
            break;
          }
          case 655: {
            message.quickRatioMrq = reader.double();
            break;
          }
          case 654: {
            message.highAllTime = reader.double();
            break;
          }
          case 653: {
            message.lowAllTime = reader.double();
            break;
          }
          case 907: {
            message.totalDebtEquityRatio = reader.double();
            break;
          }
          case 908: {
            message.dividendPayoutRatio = reader.double();
            break;
          }
          case 909: {
            message.operatingCashFlowPerShare = reader.double();
            break;
          }
          case 910: {
            message.insiderPercentage = reader.double();
            break;
          }
          case 911: {
            message.priceToCashFlowRatio = reader.double();
            break;
          }
          case 516: {
            message.netProfitMargin = reader.double();
            break;
          }
          case 912: {
            message.regularHoursChange = reader.double();
            break;
          }
          case 913: {
            message.regularHoursPercentChange = reader.double();
            break;
          }
          case 914: {
            message.postToPreHoursChange = reader.double();
            break;
          }
          case 915: {
            message.postToPreHoursPercentChange = reader.double();
            break;
          }
          case 916: {
            message.scannerClose = reader.double();
            break;
          }
          case 917: {
            message.scannerChange = reader.double();
            break;
          }
          case 918: {
            message.scannerChangePercent = reader.double();
            break;
          }
          case 919: {
            message.scannerChangePercentClose = reader.double();
            break;
          }
          case 920: {
            message.scannerPreviousClose = reader.double();
            break;
          }
          case 921: {
            message.freeCashFlow = reader.double();
            break;
          }
          case 922: {
            message.minPriceTarget = reader.double();
            break;
          }
          case 923: {
            message.maxPriceTarget = reader.double();
            break;
          }
          case 924: {
            message.meanPriceTarget = reader.double();
            break;
          }
          case 925: {
            message.totalNumberOfAnalyst = reader.double();
            break;
          }
          case 926: {
            message.averageAnalystRecommendation = reader.string();
            break;
          }
          case 927: {
            message.pegRatio = reader.double();
            break;
          }
          case 928: {
            message.priceToFreeCashFlowRatio = reader.double();
            break;
          }
          case 929: {
            message.distanceToMaxPriceTarget = reader.double();
            break;
          }
          case 930: {
            message.distanceToMinPriceTarget = reader.double();
            break;
          }
          case 931: {
            message.distanceToMeanPriceTarget = reader.double();
            break;
          }
          case 932: {
            message.shortTermTrend = reader.string();
            break;
          }
          case 933: {
            message.mediumTermTrend = reader.string();
            break;
          }
          case 934: {
            message.longTermTrend = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a Quote message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LastProtos.Quote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LastProtos.Quote} Quote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Quote.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Quote message.
     * @function verify
     * @memberof LastProtos.Quote
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Quote.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.symbol != null && message.hasOwnProperty('symbol'))
        if (!$util.isString(message.symbol)) return 'symbol: string expected';
      if (message.opol != null && message.hasOwnProperty('opol'))
        if (!$util.isString(message.opol)) return 'opol: string expected';
      if (message.previousClose != null && message.hasOwnProperty('previousClose'))
        if (typeof message.previousClose !== 'number') return 'previousClose: number expected';
      if (message.close != null && message.hasOwnProperty('close'))
        if (typeof message.close !== 'number') return 'close: number expected';
      if (message.change != null && message.hasOwnProperty('change'))
        if (typeof message.change !== 'number') return 'change: number expected';
      if (message.changePercent != null && message.hasOwnProperty('changePercent'))
        if (typeof message.changePercent !== 'number') return 'changePercent: number expected';
      if (message.name != null && message.hasOwnProperty('name'))
        if (!$util.isString(message.name)) return 'name: string expected';
      if (message.ipoDate != null && message.hasOwnProperty('ipoDate'))
        if (!$util.isString(message.ipoDate)) return 'ipoDate: string expected';
      if (message.exchange != null && message.hasOwnProperty('exchange'))
        if (!$util.isString(message.exchange)) return 'exchange: string expected';
      if (message.tradeExchange != null && message.hasOwnProperty('tradeExchange'))
        if (!$util.isString(message.tradeExchange)) return 'tradeExchange: string expected';
      if (message.preMarketOpen != null && message.hasOwnProperty('preMarketOpen'))
        if (typeof message.preMarketOpen !== 'number') return 'preMarketOpen: number expected';
      if (message.preMarketOpenTime != null && message.hasOwnProperty('preMarketOpenTime'))
        if (
          !$util.isInteger(message.preMarketOpenTime) &&
          !(
            message.preMarketOpenTime &&
            $util.isInteger(message.preMarketOpenTime.low) &&
            $util.isInteger(message.preMarketOpenTime.high)
          )
        )
          return 'preMarketOpenTime: integer|Long expected';
      if (message.preMarketVolume != null && message.hasOwnProperty('preMarketVolume'))
        if (
          !$util.isInteger(message.preMarketVolume) &&
          !(
            message.preMarketVolume &&
            $util.isInteger(message.preMarketVolume.low) &&
            $util.isInteger(message.preMarketVolume.high)
          )
        )
          return 'preMarketVolume: integer|Long expected';
      if (message.preMarketOpenChange != null && message.hasOwnProperty('preMarketOpenChange'))
        if (typeof message.preMarketOpenChange !== 'number') return 'preMarketOpenChange: number expected';
      if (message.preMarketOpenChangePercent != null && message.hasOwnProperty('preMarketOpenChangePercent'))
        if (typeof message.preMarketOpenChangePercent !== 'number')
          return 'preMarketOpenChangePercent: number expected';
      if (message.source != null && message.hasOwnProperty('source'))
        switch (message.source) {
          default:
            return 'source: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      if (message.clearFieldNumbers != null && message.hasOwnProperty('clearFieldNumbers')) {
        if (!Array.isArray(message.clearFieldNumbers)) return 'clearFieldNumbers: array expected';
        for (let i = 0; i < message.clearFieldNumbers.length; ++i)
          if (!$util.isInteger(message.clearFieldNumbers[i])) return 'clearFieldNumbers: integer[] expected';
      }
      if (message.marketCap != null && message.hasOwnProperty('marketCap'))
        if (
          !$util.isInteger(message.marketCap) &&
          !(message.marketCap && $util.isInteger(message.marketCap.low) && $util.isInteger(message.marketCap.high))
        )
          return 'marketCap: integer|Long expected';
      if (message.rsi != null && message.hasOwnProperty('rsi'))
        if (typeof message.rsi !== 'number') return 'rsi: number expected';
      if (message.atr != null && message.hasOwnProperty('atr'))
        if (typeof message.atr !== 'number') return 'atr: number expected';
      if (message.priceToEarnings != null && message.hasOwnProperty('priceToEarnings'))
        if (typeof message.priceToEarnings !== 'number') return 'priceToEarnings: number expected';
      if (message.averageVolume != null && message.hasOwnProperty('averageVolume'))
        if (
          !$util.isInteger(message.averageVolume) &&
          !(
            message.averageVolume &&
            $util.isInteger(message.averageVolume.low) &&
            $util.isInteger(message.averageVolume.high)
          )
        )
          return 'averageVolume: integer|Long expected';
      if (message.sharesOutstanding != null && message.hasOwnProperty('sharesOutstanding'))
        if (
          !$util.isInteger(message.sharesOutstanding) &&
          !(
            message.sharesOutstanding &&
            $util.isInteger(message.sharesOutstanding.low) &&
            $util.isInteger(message.sharesOutstanding.high)
          )
        )
          return 'sharesOutstanding: integer|Long expected';
      if (message.sector != null && message.hasOwnProperty('sector'))
        if (!$util.isString(message.sector)) return 'sector: string expected';
      if (message.sectorCode != null && message.hasOwnProperty('sectorCode'))
        if (!$util.isInteger(message.sectorCode)) return 'sectorCode: integer expected';
      if (message.industry != null && message.hasOwnProperty('industry'))
        if (!$util.isString(message.industry)) return 'industry: string expected';
      if (message.industryCode != null && message.hasOwnProperty('industryCode'))
        if (!$util.isInteger(message.industryCode)) return 'industryCode: integer expected';
      if (message.forwardPERatio != null && message.hasOwnProperty('forwardPERatio'))
        if (typeof message.forwardPERatio !== 'number') return 'forwardPERatio: number expected';
      if (message.pricetoEBITDA != null && message.hasOwnProperty('pricetoEBITDA'))
        if (typeof message.pricetoEBITDA !== 'number') return 'pricetoEBITDA: number expected';
      if (message.trailingDividendYield != null && message.hasOwnProperty('trailingDividendYield'))
        if (typeof message.trailingDividendYield !== 'number') return 'trailingDividendYield: number expected';
      if (message.PBRatio != null && message.hasOwnProperty('PBRatio'))
        if (typeof message.PBRatio !== 'number') return 'PBRatio: number expected';
      if (message.priceToSales != null && message.hasOwnProperty('priceToSales'))
        if (typeof message.priceToSales !== 'number') return 'priceToSales: number expected';
      if (message.FCFPerShare != null && message.hasOwnProperty('FCFPerShare'))
        if (typeof message.FCFPerShare !== 'number') return 'FCFPerShare: number expected';
      if (message.buyBackYield != null && message.hasOwnProperty('buyBackYield'))
        if (typeof message.buyBackYield !== 'number') return 'buyBackYield: number expected';
      if (message.open != null && message.hasOwnProperty('open'))
        if (typeof message.open !== 'number') return 'open: number expected';
      if (message.price != null && message.hasOwnProperty('price'))
        if (typeof message.price !== 'number') return 'price: number expected';
      if (message.high != null && message.hasOwnProperty('high'))
        if (typeof message.high !== 'number') return 'high: number expected';
      if (message.low != null && message.hasOwnProperty('low'))
        if (typeof message.low !== 'number') return 'low: number expected';
      if (message.time != null && message.hasOwnProperty('time'))
        if (
          !$util.isInteger(message.time) &&
          !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high))
        )
          return 'time: integer|Long expected';
      if (message.size != null && message.hasOwnProperty('size'))
        if (!$util.isInteger(message.size)) return 'size: integer expected';
      if (message.type != null && message.hasOwnProperty('type'))
        if (!$util.isString(message.type)) return 'type: string expected';
      if (message.dayVolume != null && message.hasOwnProperty('dayVolume'))
        if (
          !$util.isInteger(message.dayVolume) &&
          !(message.dayVolume && $util.isInteger(message.dayVolume.low) && $util.isInteger(message.dayVolume.high))
        )
          return 'dayVolume: integer|Long expected';
      if (message.askPrice != null && message.hasOwnProperty('askPrice'))
        if (typeof message.askPrice !== 'number') return 'askPrice: number expected';
      if (message.bidPrice != null && message.hasOwnProperty('bidPrice'))
        if (typeof message.bidPrice !== 'number') return 'bidPrice: number expected';
      if (message.shareFloatDate != null && message.hasOwnProperty('shareFloatDate'))
        if (!$util.isString(message.shareFloatDate)) return 'shareFloatDate: string expected';
      if (message.sharesOutstandingDate != null && message.hasOwnProperty('sharesOutstandingDate'))
        if (!$util.isString(message.sharesOutstandingDate)) return 'sharesOutstandingDate: string expected';
      if (message.shareFloat != null && message.hasOwnProperty('shareFloat'))
        if (
          !$util.isInteger(message.shareFloat) &&
          !(message.shareFloat && $util.isInteger(message.shareFloat.low) && $util.isInteger(message.shareFloat.high))
        )
          return 'shareFloat: integer|Long expected';
      if (message.updateType != null && message.hasOwnProperty('updateType'))
        switch (message.updateType) {
          default:
            return 'updateType: enum value expected';
          case 0:
          case 1:
          case 2:
            break;
        }
      if (message.subtype != null && message.hasOwnProperty('subtype'))
        if (!$util.isString(message.subtype)) return 'subtype: string expected';
      if (message.sessionType != null && message.hasOwnProperty('sessionType'))
        switch (message.sessionType) {
          default:
            return 'sessionType: enum value expected';
          case 0:
          case 1:
          case 2:
          case 3:
            break;
        }
      if (message.volume != null && message.hasOwnProperty('volume'))
        if (
          !$util.isInteger(message.volume) &&
          !(message.volume && $util.isInteger(message.volume.low) && $util.isInteger(message.volume.high))
        )
          return 'volume: integer|Long expected';
      if (message.changePercent1Minute != null && message.hasOwnProperty('changePercent1Minute'))
        if (typeof message.changePercent1Minute !== 'number') return 'changePercent1Minute: number expected';
      if (message.changePercentClose != null && message.hasOwnProperty('changePercentClose'))
        if (typeof message.changePercentClose !== 'number') return 'changePercentClose: number expected';
      if (message.changePercent5Minute != null && message.hasOwnProperty('changePercent5Minute'))
        if (typeof message.changePercent5Minute !== 'number') return 'changePercent5Minute: number expected';
      if (message.volume1Minute != null && message.hasOwnProperty('volume1Minute'))
        if (
          !$util.isInteger(message.volume1Minute) &&
          !(
            message.volume1Minute &&
            $util.isInteger(message.volume1Minute.low) &&
            $util.isInteger(message.volume1Minute.high)
          )
        )
          return 'volume1Minute: integer|Long expected';
      if (message.relativeVolume1Minute != null && message.hasOwnProperty('relativeVolume1Minute'))
        if (typeof message.relativeVolume1Minute !== 'number') return 'relativeVolume1Minute: number expected';
      if (message.change15Minute != null && message.hasOwnProperty('change15Minute'))
        if (typeof message.change15Minute !== 'number') return 'change15Minute: number expected';
      if (message.changePercent15Minute != null && message.hasOwnProperty('changePercent15Minute'))
        if (typeof message.changePercent15Minute !== 'number') return 'changePercent15Minute: number expected';
      if (message.change30Minute != null && message.hasOwnProperty('change30Minute'))
        if (typeof message.change30Minute !== 'number') return 'change30Minute: number expected';
      if (message.changePercent30Minute != null && message.hasOwnProperty('changePercent30Minute'))
        if (typeof message.changePercent30Minute !== 'number') return 'changePercent30Minute: number expected';
      if (message.change60Minute != null && message.hasOwnProperty('change60Minute'))
        if (typeof message.change60Minute !== 'number') return 'change60Minute: number expected';
      if (message.changePercent60Minute != null && message.hasOwnProperty('changePercent60Minute'))
        if (typeof message.changePercent60Minute !== 'number') return 'changePercent60Minute: number expected';
      if (message.changePercentOpen != null && message.hasOwnProperty('changePercentOpen'))
        if (typeof message.changePercentOpen !== 'number') return 'changePercentOpen: number expected';
      if (message.changeOpen != null && message.hasOwnProperty('changeOpen'))
        if (typeof message.changeOpen !== 'number') return 'changeOpen: number expected';
      if (message.gics != null && message.hasOwnProperty('gics'))
        if (!$util.isInteger(message.gics)) return 'gics: integer expected';
      if (message.gicsSector != null && message.hasOwnProperty('gicsSector'))
        if (!$util.isInteger(message.gicsSector)) return 'gicsSector: integer expected';
      if (message.gicsSectorName != null && message.hasOwnProperty('gicsSectorName'))
        if (!$util.isString(message.gicsSectorName)) return 'gicsSectorName: string expected';
      if (message.gicsIndustryGroup != null && message.hasOwnProperty('gicsIndustryGroup'))
        if (!$util.isInteger(message.gicsIndustryGroup)) return 'gicsIndustryGroup: integer expected';
      if (message.gicsIndustryGroupName != null && message.hasOwnProperty('gicsIndustryGroupName'))
        if (!$util.isString(message.gicsIndustryGroupName)) return 'gicsIndustryGroupName: string expected';
      if (message.gicsIndustry != null && message.hasOwnProperty('gicsIndustry'))
        if (!$util.isInteger(message.gicsIndustry)) return 'gicsIndustry: integer expected';
      if (message.gicsIndustryName != null && message.hasOwnProperty('gicsIndustryName'))
        if (!$util.isString(message.gicsIndustryName)) return 'gicsIndustryName: string expected';
      if (message.gicsSubIndustry != null && message.hasOwnProperty('gicsSubIndustry'))
        if (!$util.isInteger(message.gicsSubIndustry)) return 'gicsSubIndustry: integer expected';
      if (message.gicsSubIndustryName != null && message.hasOwnProperty('gicsSubIndustryName'))
        if (!$util.isString(message.gicsSubIndustryName)) return 'gicsSubIndustryName: string expected';
      if (message.optionable != null && message.hasOwnProperty('optionable'))
        if (!$util.isInteger(message.optionable)) return 'optionable: integer expected';
      if (message.cik != null && message.hasOwnProperty('cik'))
        if (!$util.isInteger(message.cik)) return 'cik: integer expected';
      if (message.signalName != null && message.hasOwnProperty('signalName'))
        if (!$util.isString(message.signalName)) return 'signalName: string expected';
      if (message.lastTradeTime != null && message.hasOwnProperty('lastTradeTime'))
        if (
          !$util.isInteger(message.lastTradeTime) &&
          !(
            message.lastTradeTime &&
            $util.isInteger(message.lastTradeTime.low) &&
            $util.isInteger(message.lastTradeTime.high)
          )
        )
          return 'lastTradeTime: integer|Long expected';
      if (message.country != null && message.hasOwnProperty('country'))
        if (!$util.isString(message.country)) return 'country: string expected';
      if (message.sharesShort != null && message.hasOwnProperty('sharesShort'))
        if (
          !$util.isInteger(message.sharesShort) &&
          !(
            message.sharesShort &&
            $util.isInteger(message.sharesShort.low) &&
            $util.isInteger(message.sharesShort.high)
          )
        )
          return 'sharesShort: integer|Long expected';
      if (message.sharesShortPercentOfFloat != null && message.hasOwnProperty('sharesShortPercentOfFloat'))
        if (typeof message.sharesShortPercentOfFloat !== 'number') return 'sharesShortPercentOfFloat: number expected';
      if (message.sharesShortChangePercent != null && message.hasOwnProperty('sharesShortChangePercent'))
        if (typeof message.sharesShortChangePercent !== 'number') return 'sharesShortChangePercent: number expected';
      if (message.sharesShortReceiptDate != null && message.hasOwnProperty('sharesShortReceiptDate'))
        if (
          !$util.isInteger(message.sharesShortReceiptDate) &&
          !(
            message.sharesShortReceiptDate &&
            $util.isInteger(message.sharesShortReceiptDate.low) &&
            $util.isInteger(message.sharesShortReceiptDate.high)
          )
        )
          return 'sharesShortReceiptDate: integer|Long expected';
      if (message.sharesShortSettlementDate != null && message.hasOwnProperty('sharesShortSettlementDate'))
        if (
          !$util.isInteger(message.sharesShortSettlementDate) &&
          !(
            message.sharesShortSettlementDate &&
            $util.isInteger(message.sharesShortSettlementDate.low) &&
            $util.isInteger(message.sharesShortSettlementDate.high)
          )
        )
          return 'sharesShortSettlementDate: integer|Long expected';
      if (message.shortInterestRatio != null && message.hasOwnProperty('shortInterestRatio'))
        if (typeof message.shortInterestRatio !== 'number') return 'shortInterestRatio: number expected';
      if (message.sharesShortValue != null && message.hasOwnProperty('sharesShortValue'))
        if (typeof message.sharesShortValue !== 'number') return 'sharesShortValue: number expected';
      if (message.sharesShortPrevious != null && message.hasOwnProperty('sharesShortPrevious'))
        if (
          !$util.isInteger(message.sharesShortPrevious) &&
          !(
            message.sharesShortPrevious &&
            $util.isInteger(message.sharesShortPrevious.low) &&
            $util.isInteger(message.sharesShortPrevious.high)
          )
        )
          return 'sharesShortPrevious: integer|Long expected';
      if (message.sharesShortPreviousValue != null && message.hasOwnProperty('sharesShortPreviousValue'))
        if (typeof message.sharesShortPreviousValue !== 'number') return 'sharesShortPreviousValue: number expected';
      if (
        message.sharesShortPreviousPercentOfFloat != null &&
        message.hasOwnProperty('sharesShortPreviousPercentOfFloat')
      )
        if (typeof message.sharesShortPreviousPercentOfFloat !== 'number')
          return 'sharesShortPreviousPercentOfFloat: number expected';
      if (message.sharesShortChange != null && message.hasOwnProperty('sharesShortChange'))
        if (
          !$util.isInteger(message.sharesShortChange) &&
          !(
            message.sharesShortChange &&
            $util.isInteger(message.sharesShortChange.low) &&
            $util.isInteger(message.sharesShortChange.high)
          )
        )
          return 'sharesShortChange: integer|Long expected';
      if (message.sentTime != null && message.hasOwnProperty('sentTime'))
        if (
          !$util.isInteger(message.sentTime) &&
          !(message.sentTime && $util.isInteger(message.sentTime.low) && $util.isInteger(message.sentTime.high))
        )
          return 'sentTime: integer|Long expected';
      if (message.volume5Minute != null && message.hasOwnProperty('volume5Minute'))
        if (
          !$util.isInteger(message.volume5Minute) &&
          !(
            message.volume5Minute &&
            $util.isInteger(message.volume5Minute.low) &&
            $util.isInteger(message.volume5Minute.high)
          )
        )
          return 'volume5Minute: integer|Long expected';
      if (message.volume15Minute != null && message.hasOwnProperty('volume15Minute'))
        if (
          !$util.isInteger(message.volume15Minute) &&
          !(
            message.volume15Minute &&
            $util.isInteger(message.volume15Minute.low) &&
            $util.isInteger(message.volume15Minute.high)
          )
        )
          return 'volume15Minute: integer|Long expected';
      if (message.volume30Minute != null && message.hasOwnProperty('volume30Minute'))
        if (
          !$util.isInteger(message.volume30Minute) &&
          !(
            message.volume30Minute &&
            $util.isInteger(message.volume30Minute.low) &&
            $util.isInteger(message.volume30Minute.high)
          )
        )
          return 'volume30Minute: integer|Long expected';
      if (message.volume60Minute != null && message.hasOwnProperty('volume60Minute'))
        if (
          !$util.isInteger(message.volume60Minute) &&
          !(
            message.volume60Minute &&
            $util.isInteger(message.volume60Minute.low) &&
            $util.isInteger(message.volume60Minute.high)
          )
        )
          return 'volume60Minute: integer|Long expected';
      if (message.relativeVolume5Minute != null && message.hasOwnProperty('relativeVolume5Minute'))
        if (typeof message.relativeVolume5Minute !== 'number') return 'relativeVolume5Minute: number expected';
      if (message.relativeVolume90Day != null && message.hasOwnProperty('relativeVolume90Day'))
        if (typeof message.relativeVolume90Day !== 'number') return 'relativeVolume90Day: number expected';
      if (message.rvol1m10d != null && message.hasOwnProperty('rvol1m10d'))
        if (typeof message.rvol1m10d !== 'number') return 'rvol1m10d: number expected';
      if (message.rvol5m10d != null && message.hasOwnProperty('rvol5m10d'))
        if (typeof message.rvol5m10d !== 'number') return 'rvol5m10d: number expected';
      if (message.rvol5m30d != null && message.hasOwnProperty('rvol5m30d'))
        if (typeof message.rvol5m30d !== 'number') return 'rvol5m30d: number expected';
      if (message.rvol5m90d != null && message.hasOwnProperty('rvol5m90d'))
        if (typeof message.rvol5m90d !== 'number') return 'rvol5m90d: number expected';
      if (message.averageVolume10Day != null && message.hasOwnProperty('averageVolume10Day'))
        if (
          !$util.isInteger(message.averageVolume10Day) &&
          !(
            message.averageVolume10Day &&
            $util.isInteger(message.averageVolume10Day.low) &&
            $util.isInteger(message.averageVolume10Day.high)
          )
        )
          return 'averageVolume10Day: integer|Long expected';
      if (message.averageVolumeChangePercent10Day != null && message.hasOwnProperty('averageVolumeChangePercent10Day'))
        if (typeof message.averageVolumeChangePercent10Day !== 'number')
          return 'averageVolumeChangePercent10Day: number expected';
      if (message.high10Day != null && message.hasOwnProperty('high10Day'))
        if (typeof message.high10Day !== 'number') return 'high10Day: number expected';
      if (message.highChangePercent10Day != null && message.hasOwnProperty('highChangePercent10Day'))
        if (typeof message.highChangePercent10Day !== 'number') return 'highChangePercent10Day: number expected';
      if (message.low10Day != null && message.hasOwnProperty('low10Day'))
        if (typeof message.low10Day !== 'number') return 'low10Day: number expected';
      if (message.lowChangePercent10Day != null && message.hasOwnProperty('lowChangePercent10Day'))
        if (typeof message.lowChangePercent10Day !== 'number') return 'lowChangePercent10Day: number expected';
      if (message.movingAverage10Day != null && message.hasOwnProperty('movingAverage10Day'))
        if (typeof message.movingAverage10Day !== 'number') return 'movingAverage10Day: number expected';
      if (message.movingAverageChangePercent10Day != null && message.hasOwnProperty('movingAverageChangePercent10Day'))
        if (typeof message.movingAverageChangePercent10Day !== 'number')
          return 'movingAverageChangePercent10Day: number expected';
      if (message.averageVolume20Day != null && message.hasOwnProperty('averageVolume20Day'))
        if (
          !$util.isInteger(message.averageVolume20Day) &&
          !(
            message.averageVolume20Day &&
            $util.isInteger(message.averageVolume20Day.low) &&
            $util.isInteger(message.averageVolume20Day.high)
          )
        )
          return 'averageVolume20Day: integer|Long expected';
      if (message.averageVolumeChangePercent20Day != null && message.hasOwnProperty('averageVolumeChangePercent20Day'))
        if (typeof message.averageVolumeChangePercent20Day !== 'number')
          return 'averageVolumeChangePercent20Day: number expected';
      if (message.high20Day != null && message.hasOwnProperty('high20Day'))
        if (typeof message.high20Day !== 'number') return 'high20Day: number expected';
      if (message.highChangePercent20Day != null && message.hasOwnProperty('highChangePercent20Day'))
        if (typeof message.highChangePercent20Day !== 'number') return 'highChangePercent20Day: number expected';
      if (message.low20Day != null && message.hasOwnProperty('low20Day'))
        if (typeof message.low20Day !== 'number') return 'low20Day: number expected';
      if (message.lowChangePercent20Day != null && message.hasOwnProperty('lowChangePercent20Day'))
        if (typeof message.lowChangePercent20Day !== 'number') return 'lowChangePercent20Day: number expected';
      if (message.movingAverage20Day != null && message.hasOwnProperty('movingAverage20Day'))
        if (typeof message.movingAverage20Day !== 'number') return 'movingAverage20Day: number expected';
      if (message.movingAverageChangePercent20Day != null && message.hasOwnProperty('movingAverageChangePercent20Day'))
        if (typeof message.movingAverageChangePercent20Day !== 'number')
          return 'movingAverageChangePercent20Day: number expected';
      if (message.averageVolume50Day != null && message.hasOwnProperty('averageVolume50Day'))
        if (
          !$util.isInteger(message.averageVolume50Day) &&
          !(
            message.averageVolume50Day &&
            $util.isInteger(message.averageVolume50Day.low) &&
            $util.isInteger(message.averageVolume50Day.high)
          )
        )
          return 'averageVolume50Day: integer|Long expected';
      if (message.averageVolumeChangePercent50Day != null && message.hasOwnProperty('averageVolumeChangePercent50Day'))
        if (typeof message.averageVolumeChangePercent50Day !== 'number')
          return 'averageVolumeChangePercent50Day: number expected';
      if (message.high50Day != null && message.hasOwnProperty('high50Day'))
        if (typeof message.high50Day !== 'number') return 'high50Day: number expected';
      if (message.highChangePercent50Day != null && message.hasOwnProperty('highChangePercent50Day'))
        if (typeof message.highChangePercent50Day !== 'number') return 'highChangePercent50Day: number expected';
      if (message.low50Day != null && message.hasOwnProperty('low50Day'))
        if (typeof message.low50Day !== 'number') return 'low50Day: number expected';
      if (message.lowChangePercent50Day != null && message.hasOwnProperty('lowChangePercent50Day'))
        if (typeof message.lowChangePercent50Day !== 'number') return 'lowChangePercent50Day: number expected';
      if (message.movingAverage50Day != null && message.hasOwnProperty('movingAverage50Day'))
        if (typeof message.movingAverage50Day !== 'number') return 'movingAverage50Day: number expected';
      if (message.movingAverageChangePercent50Day != null && message.hasOwnProperty('movingAverageChangePercent50Day'))
        if (typeof message.movingAverageChangePercent50Day !== 'number')
          return 'movingAverageChangePercent50Day: number expected';
      if (message.averageVolume100Day != null && message.hasOwnProperty('averageVolume100Day'))
        if (
          !$util.isInteger(message.averageVolume100Day) &&
          !(
            message.averageVolume100Day &&
            $util.isInteger(message.averageVolume100Day.low) &&
            $util.isInteger(message.averageVolume100Day.high)
          )
        )
          return 'averageVolume100Day: integer|Long expected';
      if (
        message.averageVolumeChangePercent100Day != null &&
        message.hasOwnProperty('averageVolumeChangePercent100Day')
      )
        if (typeof message.averageVolumeChangePercent100Day !== 'number')
          return 'averageVolumeChangePercent100Day: number expected';
      if (message.high100Day != null && message.hasOwnProperty('high100Day'))
        if (typeof message.high100Day !== 'number') return 'high100Day: number expected';
      if (message.highChangePercent100Day != null && message.hasOwnProperty('highChangePercent100Day'))
        if (typeof message.highChangePercent100Day !== 'number') return 'highChangePercent100Day: number expected';
      if (message.low100Day != null && message.hasOwnProperty('low100Day'))
        if (typeof message.low100Day !== 'number') return 'low100Day: number expected';
      if (message.lowChangePercent100Day != null && message.hasOwnProperty('lowChangePercent100Day'))
        if (typeof message.lowChangePercent100Day !== 'number') return 'lowChangePercent100Day: number expected';
      if (message.movingAverage100Day != null && message.hasOwnProperty('movingAverage100Day'))
        if (typeof message.movingAverage100Day !== 'number') return 'movingAverage100Day: number expected';
      if (
        message.movingAverageChangePercent100Day != null &&
        message.hasOwnProperty('movingAverageChangePercent100Day')
      )
        if (typeof message.movingAverageChangePercent100Day !== 'number')
          return 'movingAverageChangePercent100Day: number expected';
      if (message.averageVolume200Day != null && message.hasOwnProperty('averageVolume200Day'))
        if (
          !$util.isInteger(message.averageVolume200Day) &&
          !(
            message.averageVolume200Day &&
            $util.isInteger(message.averageVolume200Day.low) &&
            $util.isInteger(message.averageVolume200Day.high)
          )
        )
          return 'averageVolume200Day: integer|Long expected';
      if (
        message.averageVolumeChangePercent200Day != null &&
        message.hasOwnProperty('averageVolumeChangePercent200Day')
      )
        if (typeof message.averageVolumeChangePercent200Day !== 'number')
          return 'averageVolumeChangePercent200Day: number expected';
      if (message.high200Day != null && message.hasOwnProperty('high200Day'))
        if (typeof message.high200Day !== 'number') return 'high200Day: number expected';
      if (message.highChangePercent200Day != null && message.hasOwnProperty('highChangePercent200Day'))
        if (typeof message.highChangePercent200Day !== 'number') return 'highChangePercent200Day: number expected';
      if (message.low200Day != null && message.hasOwnProperty('low200Day'))
        if (typeof message.low200Day !== 'number') return 'low200Day: number expected';
      if (message.lowChangePercent200Day != null && message.hasOwnProperty('lowChangePercent200Day'))
        if (typeof message.lowChangePercent200Day !== 'number') return 'lowChangePercent200Day: number expected';
      if (message.movingAverage200Day != null && message.hasOwnProperty('movingAverage200Day'))
        if (typeof message.movingAverage200Day !== 'number') return 'movingAverage200Day: number expected';
      if (
        message.movingAverageChangePercent200Day != null &&
        message.hasOwnProperty('movingAverageChangePercent200Day')
      )
        if (typeof message.movingAverageChangePercent200Day !== 'number')
          return 'movingAverageChangePercent200Day: number expected';
      if (message.movingAverage250Day != null && message.hasOwnProperty('movingAverage250Day'))
        if (typeof message.movingAverage250Day !== 'number') return 'movingAverage250Day: number expected';
      if (
        message.movingAverageChangePercent250Day != null &&
        message.hasOwnProperty('movingAverageChangePercent250Day')
      )
        if (typeof message.movingAverageChangePercent250Day !== 'number')
          return 'movingAverageChangePercent250Day: number expected';
      if (message.averageVolume90Day != null && message.hasOwnProperty('averageVolume90Day'))
        if (
          !$util.isInteger(message.averageVolume90Day) &&
          !(
            message.averageVolume90Day &&
            $util.isInteger(message.averageVolume90Day.low) &&
            $util.isInteger(message.averageVolume90Day.high)
          )
        )
          return 'averageVolume90Day: integer|Long expected';
      if (message.nextEarningsDate != null && message.hasOwnProperty('nextEarningsDate'))
        if (!$util.isInteger(message.nextEarningsDate)) return 'nextEarningsDate: integer expected';
      if (message.dividend != null && message.hasOwnProperty('dividend'))
        if (typeof message.dividend !== 'number') return 'dividend: number expected';
      if (message.dividendYield != null && message.hasOwnProperty('dividendYield'))
        if (typeof message.dividendYield !== 'number') return 'dividendYield: number expected';
      if (message.dividendExDate != null && message.hasOwnProperty('dividendExDate'))
        if (!$util.isInteger(message.dividendExDate)) return 'dividendExDate: integer expected';
      if (message.dividendFrequency != null && message.hasOwnProperty('dividendFrequency'))
        if (
          !$util.isInteger(message.dividendFrequency) &&
          !(
            message.dividendFrequency &&
            $util.isInteger(message.dividendFrequency.low) &&
            $util.isInteger(message.dividendFrequency.high)
          )
        )
          return 'dividendFrequency: integer|Long expected';
      if (message.forwardDividendYield != null && message.hasOwnProperty('forwardDividendYield'))
        if (typeof message.forwardDividendYield !== 'number') return 'forwardDividendYield: number expected';
      if (message.roe != null && message.hasOwnProperty('roe'))
        if (typeof message.roe !== 'number') return 'roe: number expected';
      if (message.roa != null && message.hasOwnProperty('roa'))
        if (typeof message.roa !== 'number') return 'roa: number expected';
      if (message.roic != null && message.hasOwnProperty('roic'))
        if (typeof message.roic !== 'number') return 'roic: number expected';
      if (message.currentRatio != null && message.hasOwnProperty('currentRatio'))
        if (typeof message.currentRatio !== 'number') return 'currentRatio: number expected';
      if (message.grossMargin != null && message.hasOwnProperty('grossMargin'))
        if (typeof message.grossMargin !== 'number') return 'grossMargin: number expected';
      if (message.netMargin != null && message.hasOwnProperty('netMargin'))
        if (typeof message.netMargin !== 'number') return 'netMargin: number expected';
      if (message.operationMargin != null && message.hasOwnProperty('operationMargin'))
        if (typeof message.operationMargin !== 'number') return 'operationMargin: number expected';
      if (message.epsMrq != null && message.hasOwnProperty('epsMrq'))
        if (typeof message.epsMrq !== 'number') return 'epsMrq: number expected';
      if (message.epsTtm != null && message.hasOwnProperty('epsTtm'))
        if (typeof message.epsTtm !== 'number') return 'epsTtm: number expected';
      if (message.dilutedEpsMrq != null && message.hasOwnProperty('dilutedEpsMrq'))
        if (typeof message.dilutedEpsMrq !== 'number') return 'dilutedEpsMrq: number expected';
      if (message.dilutedEpsTtm != null && message.hasOwnProperty('dilutedEpsTtm'))
        if (typeof message.dilutedEpsTtm !== 'number') return 'dilutedEpsTtm: number expected';
      if (message.low52Week != null && message.hasOwnProperty('low52Week'))
        if (typeof message.low52Week !== 'number') return 'low52Week: number expected';
      if (message.high52Week != null && message.hasOwnProperty('high52Week'))
        if (typeof message.high52Week !== 'number') return 'high52Week: number expected';
      if (message.revenueTtm != null && message.hasOwnProperty('revenueTtm'))
        if (typeof message.revenueTtm !== 'number') return 'revenueTtm: number expected';
      if (message.earningsAsOf != null && message.hasOwnProperty('earningsAsOf'))
        if (!$util.isInteger(message.earningsAsOf)) return 'earningsAsOf: integer expected';
      if (message.price1Week != null && message.hasOwnProperty('price1Week'))
        if (typeof message.price1Week !== 'number') return 'price1Week: number expected';
      if (message.priceChangePercent1Week != null && message.hasOwnProperty('priceChangePercent1Week'))
        if (typeof message.priceChangePercent1Week !== 'number') return 'priceChangePercent1Week: number expected';
      if (message.price1Month != null && message.hasOwnProperty('price1Month'))
        if (typeof message.price1Month !== 'number') return 'price1Month: number expected';
      if (message.priceChangePercent1Month != null && message.hasOwnProperty('priceChangePercent1Month'))
        if (typeof message.priceChangePercent1Month !== 'number') return 'priceChangePercent1Month: number expected';
      if (message.priceHalfYear != null && message.hasOwnProperty('priceHalfYear'))
        if (typeof message.priceHalfYear !== 'number') return 'priceHalfYear: number expected';
      if (message.priceChangePercentHalfYear != null && message.hasOwnProperty('priceChangePercentHalfYear'))
        if (typeof message.priceChangePercentHalfYear !== 'number')
          return 'priceChangePercentHalfYear: number expected';
      if (message.priceQuarter != null && message.hasOwnProperty('priceQuarter'))
        if (typeof message.priceQuarter !== 'number') return 'priceQuarter: number expected';
      if (message.priceChangePercentQuarter != null && message.hasOwnProperty('priceChangePercentQuarter'))
        if (typeof message.priceChangePercentQuarter !== 'number') return 'priceChangePercentQuarter: number expected';
      if (message.price1Year != null && message.hasOwnProperty('price1Year'))
        if (typeof message.price1Year !== 'number') return 'price1Year: number expected';
      if (message.priceChangePercent1Year != null && message.hasOwnProperty('priceChangePercent1Year'))
        if (typeof message.priceChangePercent1Year !== 'number') return 'priceChangePercent1Year: number expected';
      if (message.priceYearToDate != null && message.hasOwnProperty('priceYearToDate'))
        if (typeof message.priceYearToDate !== 'number') return 'priceYearToDate: number expected';
      if (message.priceChangePercentYearToDate != null && message.hasOwnProperty('priceChangePercentYearToDate'))
        if (typeof message.priceChangePercentYearToDate !== 'number')
          return 'priceChangePercentYearToDate: number expected';
      if (message.roeMrq != null && message.hasOwnProperty('roeMrq'))
        if (typeof message.roeMrq !== 'number') return 'roeMrq: number expected';
      if (message.roaMrq != null && message.hasOwnProperty('roaMrq'))
        if (typeof message.roaMrq !== 'number') return 'roaMrq: number expected';
      if (message.roicMrq != null && message.hasOwnProperty('roicMrq'))
        if (typeof message.roicMrq !== 'number') return 'roicMrq: number expected';
      if (message.currentRatioMrq != null && message.hasOwnProperty('currentRatioMrq'))
        if (typeof message.currentRatioMrq !== 'number') return 'currentRatioMrq: number expected';
      if (message.grossMarginMrq != null && message.hasOwnProperty('grossMarginMrq'))
        if (typeof message.grossMarginMrq !== 'number') return 'grossMarginMrq: number expected';
      if (message.netMarginMrq != null && message.hasOwnProperty('netMarginMrq'))
        if (typeof message.netMarginMrq !== 'number') return 'netMarginMrq: number expected';
      if (message.operationMarginMrq != null && message.hasOwnProperty('operationMarginMrq'))
        if (typeof message.operationMarginMrq !== 'number') return 'operationMarginMrq: number expected';
      if (message.previousDayVolume != null && message.hasOwnProperty('previousDayVolume'))
        if (
          !$util.isInteger(message.previousDayVolume) &&
          !(
            message.previousDayVolume &&
            $util.isInteger(message.previousDayVolume.low) &&
            $util.isInteger(message.previousDayVolume.high)
          )
        )
          return 'previousDayVolume: integer|Long expected';
      if (message.previousDayAtr != null && message.hasOwnProperty('previousDayAtr'))
        if (typeof message.previousDayAtr !== 'number') return 'previousDayAtr: number expected';
      if (message.previousDayAdx != null && message.hasOwnProperty('previousDayAdx'))
        if (typeof message.previousDayAdx !== 'number') return 'previousDayAdx: number expected';
      if (message.previousDayPlusDMSmoothed != null && message.hasOwnProperty('previousDayPlusDMSmoothed'))
        if (typeof message.previousDayPlusDMSmoothed !== 'number') return 'previousDayPlusDMSmoothed: number expected';
      if (message.previousDayMinusDMSmoothed != null && message.hasOwnProperty('previousDayMinusDMSmoothed'))
        if (typeof message.previousDayMinusDMSmoothed !== 'number')
          return 'previousDayMinusDMSmoothed: number expected';
      if (message.previousDayHigh != null && message.hasOwnProperty('previousDayHigh'))
        if (typeof message.previousDayHigh !== 'number') return 'previousDayHigh: number expected';
      if (message.previousDayLow != null && message.hasOwnProperty('previousDayLow'))
        if (typeof message.previousDayLow !== 'number') return 'previousDayLow: number expected';
      if (message.adx != null && message.hasOwnProperty('adx'))
        if (typeof message.adx !== 'number') return 'adx: number expected';
      if (message.percentInstitutionalOwnership != null && message.hasOwnProperty('percentInstitutionalOwnership'))
        if (typeof message.percentInstitutionalOwnership !== 'number')
          return 'percentInstitutionalOwnership: number expected';
      if (message.wiim != null && message.hasOwnProperty('wiim'))
        if (!$util.isString(message.wiim)) return 'wiim: string expected';
      if (message.wiimAsOf != null && message.hasOwnProperty('wiimAsOf'))
        if (
          !$util.isInteger(message.wiimAsOf) &&
          !(message.wiimAsOf && $util.isInteger(message.wiimAsOf.low) && $util.isInteger(message.wiimAsOf.high))
        )
          return 'wiimAsOf: integer|Long expected';
      if (message.vwap != null && message.hasOwnProperty('vwap'))
        if (typeof message.vwap !== 'number') return 'vwap: number expected';
      if (message.vwapChangePercent != null && message.hasOwnProperty('vwapChangePercent'))
        if (typeof message.vwapChangePercent !== 'number') return 'vwapChangePercent: number expected';
      if (message.vwapChange != null && message.hasOwnProperty('vwapChange'))
        if (typeof message.vwapChange !== 'number') return 'vwapChange: number expected';
      if (message.rsiAvgGain != null && message.hasOwnProperty('rsiAvgGain'))
        if (typeof message.rsiAvgGain !== 'number') return 'rsiAvgGain: number expected';
      if (message.rsiAvgLoss != null && message.hasOwnProperty('rsiAvgLoss'))
        if (typeof message.rsiAvgLoss !== 'number') return 'rsiAvgLoss: number expected';
      if (message.halted != null && message.hasOwnProperty('halted'))
        if (!$util.isString(message.halted)) return 'halted: string expected';
      if (message.tradeCount != null && message.hasOwnProperty('tradeCount'))
        if (
          !$util.isInteger(message.tradeCount) &&
          !(message.tradeCount && $util.isInteger(message.tradeCount.low) && $util.isInteger(message.tradeCount.high))
        )
          return 'tradeCount: integer|Long expected';
      if (message.regularHighCount != null && message.hasOwnProperty('regularHighCount'))
        if (
          !$util.isInteger(message.regularHighCount) &&
          !(
            message.regularHighCount &&
            $util.isInteger(message.regularHighCount.low) &&
            $util.isInteger(message.regularHighCount.high)
          )
        )
          return 'regularHighCount: integer|Long expected';
      if (message.regularLowCount != null && message.hasOwnProperty('regularLowCount'))
        if (
          !$util.isInteger(message.regularLowCount) &&
          !(
            message.regularLowCount &&
            $util.isInteger(message.regularLowCount.low) &&
            $util.isInteger(message.regularLowCount.high)
          )
        )
          return 'regularLowCount: integer|Long expected';
      if (message.preMarketHighCount != null && message.hasOwnProperty('preMarketHighCount'))
        if (
          !$util.isInteger(message.preMarketHighCount) &&
          !(
            message.preMarketHighCount &&
            $util.isInteger(message.preMarketHighCount.low) &&
            $util.isInteger(message.preMarketHighCount.high)
          )
        )
          return 'preMarketHighCount: integer|Long expected';
      if (message.preMarketLowCount != null && message.hasOwnProperty('preMarketLowCount'))
        if (
          !$util.isInteger(message.preMarketLowCount) &&
          !(
            message.preMarketLowCount &&
            $util.isInteger(message.preMarketLowCount.low) &&
            $util.isInteger(message.preMarketLowCount.high)
          )
        )
          return 'preMarketLowCount: integer|Long expected';
      if (message.afterMarketHighCount != null && message.hasOwnProperty('afterMarketHighCount'))
        if (
          !$util.isInteger(message.afterMarketHighCount) &&
          !(
            message.afterMarketHighCount &&
            $util.isInteger(message.afterMarketHighCount.low) &&
            $util.isInteger(message.afterMarketHighCount.high)
          )
        )
          return 'afterMarketHighCount: integer|Long expected';
      if (message.afterMarketLowCount != null && message.hasOwnProperty('afterMarketLowCount'))
        if (
          !$util.isInteger(message.afterMarketLowCount) &&
          !(
            message.afterMarketLowCount &&
            $util.isInteger(message.afterMarketLowCount.low) &&
            $util.isInteger(message.afterMarketLowCount.high)
          )
        )
          return 'afterMarketLowCount: integer|Long expected';
      if (message.dayHighCount != null && message.hasOwnProperty('dayHighCount'))
        if (
          !$util.isInteger(message.dayHighCount) &&
          !(
            message.dayHighCount &&
            $util.isInteger(message.dayHighCount.low) &&
            $util.isInteger(message.dayHighCount.high)
          )
        )
          return 'dayHighCount: integer|Long expected';
      if (message.dayLowCount != null && message.hasOwnProperty('dayLowCount'))
        if (
          !$util.isInteger(message.dayLowCount) &&
          !(
            message.dayLowCount &&
            $util.isInteger(message.dayLowCount.low) &&
            $util.isInteger(message.dayLowCount.high)
          )
        )
          return 'dayLowCount: integer|Long expected';
      if (message.dayHigh != null && message.hasOwnProperty('dayHigh'))
        if (typeof message.dayHigh !== 'number') return 'dayHigh: number expected';
      if (message.dayLow != null && message.hasOwnProperty('dayLow'))
        if (typeof message.dayLow !== 'number') return 'dayLow: number expected';
      if (message.preMarketHigh != null && message.hasOwnProperty('preMarketHigh'))
        if (typeof message.preMarketHigh !== 'number') return 'preMarketHigh: number expected';
      if (message.preMarketLow != null && message.hasOwnProperty('preMarketLow'))
        if (typeof message.preMarketLow !== 'number') return 'preMarketLow: number expected';
      if (message.afterMarketHigh != null && message.hasOwnProperty('afterMarketHigh'))
        if (typeof message.afterMarketHigh !== 'number') return 'afterMarketHigh: number expected';
      if (message.afterMarketLow != null && message.hasOwnProperty('afterMarketLow'))
        if (typeof message.afterMarketLow !== 'number') return 'afterMarketLow: number expected';
      if (message.regularHigh != null && message.hasOwnProperty('regularHigh'))
        if (typeof message.regularHigh !== 'number') return 'regularHigh: number expected';
      if (message.regularLow != null && message.hasOwnProperty('regularLow'))
        if (typeof message.regularLow !== 'number') return 'regularLow: number expected';
      if (message.priceSpikeUpCount != null && message.hasOwnProperty('priceSpikeUpCount'))
        if (
          !$util.isInteger(message.priceSpikeUpCount) &&
          !(
            message.priceSpikeUpCount &&
            $util.isInteger(message.priceSpikeUpCount.low) &&
            $util.isInteger(message.priceSpikeUpCount.high)
          )
        )
          return 'priceSpikeUpCount: integer|Long expected';
      if (message.priceSpikeDownCount != null && message.hasOwnProperty('priceSpikeDownCount'))
        if (
          !$util.isInteger(message.priceSpikeDownCount) &&
          !(
            message.priceSpikeDownCount &&
            $util.isInteger(message.priceSpikeDownCount.low) &&
            $util.isInteger(message.priceSpikeDownCount.high)
          )
        )
          return 'priceSpikeDownCount: integer|Long expected';
      if (message.haltedCount != null && message.hasOwnProperty('haltedCount'))
        if (
          !$util.isInteger(message.haltedCount) &&
          !(
            message.haltedCount &&
            $util.isInteger(message.haltedCount.low) &&
            $util.isInteger(message.haltedCount.high)
          )
        )
          return 'haltedCount: integer|Long expected';
      if (message.usCongressTotal != null && message.hasOwnProperty('usCongressTotal'))
        if (typeof message.usCongressTotal !== 'number') return 'usCongressTotal: number expected';
      if (message.usCongressRepublicansTotal != null && message.hasOwnProperty('usCongressRepublicansTotal'))
        if (typeof message.usCongressRepublicansTotal !== 'number')
          return 'usCongressRepublicansTotal: number expected';
      if (message.usCongressDemocratsTotal != null && message.hasOwnProperty('usCongressDemocratsTotal'))
        if (typeof message.usCongressDemocratsTotal !== 'number') return 'usCongressDemocratsTotal: number expected';
      if (message.usCongressOtherTotal != null && message.hasOwnProperty('usCongressOtherTotal'))
        if (typeof message.usCongressOtherTotal !== 'number') return 'usCongressOtherTotal: number expected';
      if (message.volumeFloatRatio != null && message.hasOwnProperty('volumeFloatRatio'))
        if (typeof message.volumeFloatRatio !== 'number') return 'volumeFloatRatio: number expected';
      if (message.atrp != null && message.hasOwnProperty('atrp'))
        if (typeof message.atrp !== 'number') return 'atrp: number expected';
      if (message.ytdGainLoss != null && message.hasOwnProperty('ytdGainLoss'))
        if (typeof message.ytdGainLoss !== 'number') return 'ytdGainLoss: number expected';
      if (message.mtdGainLoss != null && message.hasOwnProperty('mtdGainLoss'))
        if (typeof message.mtdGainLoss !== 'number') return 'mtdGainLoss: number expected';
      if (message.yearOpen != null && message.hasOwnProperty('yearOpen'))
        if (typeof message.yearOpen !== 'number') return 'yearOpen: number expected';
      if (message.monthOpen != null && message.hasOwnProperty('monthOpen'))
        if (typeof message.monthOpen !== 'number') return 'monthOpen: number expected';
      if (message.volumeFloatPercent != null && message.hasOwnProperty('volumeFloatPercent'))
        if (typeof message.volumeFloatPercent !== 'number') return 'volumeFloatPercent: number expected';
      if (message.ytdChange != null && message.hasOwnProperty('ytdChange'))
        if (typeof message.ytdChange !== 'number') return 'ytdChange: number expected';
      if (message.mtdChange != null && message.hasOwnProperty('mtdChange'))
        if (typeof message.mtdChange !== 'number') return 'mtdChange: number expected';
      if (message.rsi1m != null && message.hasOwnProperty('rsi1m'))
        if (typeof message.rsi1m !== 'number') return 'rsi1m: number expected';
      if (message.rsi2m != null && message.hasOwnProperty('rsi2m'))
        if (typeof message.rsi2m !== 'number') return 'rsi2m: number expected';
      if (message.rsi5m != null && message.hasOwnProperty('rsi5m'))
        if (typeof message.rsi5m !== 'number') return 'rsi5m: number expected';
      if (message.rsi15m != null && message.hasOwnProperty('rsi15m'))
        if (typeof message.rsi15m !== 'number') return 'rsi15m: number expected';
      if (message.rsi30m != null && message.hasOwnProperty('rsi30m'))
        if (typeof message.rsi30m !== 'number') return 'rsi30m: number expected';
      if (message.rsi60m != null && message.hasOwnProperty('rsi60m'))
        if (typeof message.rsi60m !== 'number') return 'rsi60m: number expected';
      if (message.rsiEth1m != null && message.hasOwnProperty('rsiEth1m'))
        if (typeof message.rsiEth1m !== 'number') return 'rsiEth1m: number expected';
      if (message.rsiEth2m != null && message.hasOwnProperty('rsiEth2m'))
        if (typeof message.rsiEth2m !== 'number') return 'rsiEth2m: number expected';
      if (message.rsiEth5m != null && message.hasOwnProperty('rsiEth5m'))
        if (typeof message.rsiEth5m !== 'number') return 'rsiEth5m: number expected';
      if (message.rsiEth15m != null && message.hasOwnProperty('rsiEth15m'))
        if (typeof message.rsiEth15m !== 'number') return 'rsiEth15m: number expected';
      if (message.rsiEth30m != null && message.hasOwnProperty('rsiEth30m'))
        if (typeof message.rsiEth30m !== 'number') return 'rsiEth30m: number expected';
      if (message.rsiEth60m != null && message.hasOwnProperty('rsiEth60m'))
        if (typeof message.rsiEth60m !== 'number') return 'rsiEth60m: number expected';
      if (message.averageDollarVolume10Day != null && message.hasOwnProperty('averageDollarVolume10Day'))
        if (typeof message.averageDollarVolume10Day !== 'number') return 'averageDollarVolume10Day: number expected';
      if (message.averageVolume60Day != null && message.hasOwnProperty('averageVolume60Day'))
        if (
          !$util.isInteger(message.averageVolume60Day) &&
          !(
            message.averageVolume60Day &&
            $util.isInteger(message.averageVolume60Day.low) &&
            $util.isInteger(message.averageVolume60Day.high)
          )
        )
          return 'averageVolume60Day: integer|Long expected';
      if (message.relativeVolumePercent60Day != null && message.hasOwnProperty('relativeVolumePercent60Day'))
        if (typeof message.relativeVolumePercent60Day !== 'number')
          return 'relativeVolumePercent60Day: number expected';
      if (message.ema12d != null && message.hasOwnProperty('ema12d'))
        if (typeof message.ema12d !== 'number') return 'ema12d: number expected';
      if (message.ema26d != null && message.hasOwnProperty('ema26d'))
        if (typeof message.ema26d !== 'number') return 'ema26d: number expected';
      if (message.macd != null && message.hasOwnProperty('macd'))
        if (typeof message.macd !== 'number') return 'macd: number expected';
      if (message.macdSignalLine != null && message.hasOwnProperty('macdSignalLine'))
        if (typeof message.macdSignalLine !== 'number') return 'macdSignalLine: number expected';
      if (message.macdHistogram != null && message.hasOwnProperty('macdHistogram'))
        if (typeof message.macdHistogram !== 'number') return 'macdHistogram: number expected';
      if (message.macdSignalLineBase != null && message.hasOwnProperty('macdSignalLineBase'))
        if (typeof message.macdSignalLineBase !== 'number') return 'macdSignalLineBase: number expected';
      if (message.dividendGrowthRate1Year != null && message.hasOwnProperty('dividendGrowthRate1Year'))
        if (typeof message.dividendGrowthRate1Year !== 'number') return 'dividendGrowthRate1Year: number expected';
      if (message.dividendGrowthRate3Year != null && message.hasOwnProperty('dividendGrowthRate3Year'))
        if (typeof message.dividendGrowthRate3Year !== 'number') return 'dividendGrowthRate3Year: number expected';
      if (message.dividendGrowthRate5Year != null && message.hasOwnProperty('dividendGrowthRate5Year'))
        if (typeof message.dividendGrowthRate5Year !== 'number') return 'dividendGrowthRate5Year: number expected';
      if (message.newsBzWireTitle != null && message.hasOwnProperty('newsBzWireTitle'))
        if (!$util.isString(message.newsBzWireTitle)) return 'newsBzWireTitle: string expected';
      if (message.newsBzWireNodeId != null && message.hasOwnProperty('newsBzWireNodeId'))
        if (!$util.isString(message.newsBzWireNodeId)) return 'newsBzWireNodeId: string expected';
      if (message.newsBzWireTimestamp != null && message.hasOwnProperty('newsBzWireTimestamp'))
        if (
          !$util.isInteger(message.newsBzWireTimestamp) &&
          !(
            message.newsBzWireTimestamp &&
            $util.isInteger(message.newsBzWireTimestamp.low) &&
            $util.isInteger(message.newsBzWireTimestamp.high)
          )
        )
          return 'newsBzWireTimestamp: integer|Long expected';
      if (message.newsPRTitle != null && message.hasOwnProperty('newsPRTitle'))
        if (!$util.isString(message.newsPRTitle)) return 'newsPRTitle: string expected';
      if (message.newsPRNodeId != null && message.hasOwnProperty('newsPRNodeId'))
        if (!$util.isString(message.newsPRNodeId)) return 'newsPRNodeId: string expected';
      if (message.newsPRTimestamp != null && message.hasOwnProperty('newsPRTimestamp'))
        if (
          !$util.isInteger(message.newsPRTimestamp) &&
          !(
            message.newsPRTimestamp &&
            $util.isInteger(message.newsPRTimestamp.low) &&
            $util.isInteger(message.newsPRTimestamp.high)
          )
        )
          return 'newsPRTimestamp: integer|Long expected';
      if (message.newsSecTitle != null && message.hasOwnProperty('newsSecTitle'))
        if (!$util.isString(message.newsSecTitle)) return 'newsSecTitle: string expected';
      if (message.newsSecNodeId != null && message.hasOwnProperty('newsSecNodeId'))
        if (!$util.isString(message.newsSecNodeId)) return 'newsSecNodeId: string expected';
      if (message.newsSecTimestamp != null && message.hasOwnProperty('newsSecTimestamp'))
        if (
          !$util.isInteger(message.newsSecTimestamp) &&
          !(
            message.newsSecTimestamp &&
            $util.isInteger(message.newsSecTimestamp.low) &&
            $util.isInteger(message.newsSecTimestamp.high)
          )
        )
          return 'newsSecTimestamp: integer|Long expected';
      if (message.gapChange != null && message.hasOwnProperty('gapChange'))
        if (typeof message.gapChange !== 'number') return 'gapChange: number expected';
      if (message.gapChangePercent != null && message.hasOwnProperty('gapChangePercent'))
        if (typeof message.gapChangePercent !== 'number') return 'gapChangePercent: number expected';
      if (message.adr14d != null && message.hasOwnProperty('adr14d'))
        if (typeof message.adr14d !== 'number') return 'adr14d: number expected';
      if (message.movingAverage500Day != null && message.hasOwnProperty('movingAverage500Day'))
        if (typeof message.movingAverage500Day !== 'number') return 'movingAverage500Day: number expected';
      if (message.dilutedEpsMrqSurprisePercent != null && message.hasOwnProperty('dilutedEpsMrqSurprisePercent'))
        if (typeof message.dilutedEpsMrqSurprisePercent !== 'number')
          return 'dilutedEpsMrqSurprisePercent: number expected';
      if (message.dilutedEpsTtmSurprisePercent != null && message.hasOwnProperty('dilutedEpsTtmSurprisePercent'))
        if (typeof message.dilutedEpsTtmSurprisePercent !== 'number')
          return 'dilutedEpsTtmSurprisePercent: number expected';
      if (
        message.dilutedRevenueMrqSurprisePercent != null &&
        message.hasOwnProperty('dilutedRevenueMrqSurprisePercent')
      )
        if (typeof message.dilutedRevenueMrqSurprisePercent !== 'number')
          return 'dilutedRevenueMrqSurprisePercent: number expected';
      if (
        message.dilutedRevenueTtmSurprisePercent != null &&
        message.hasOwnProperty('dilutedRevenueTtmSurprisePercent')
      )
        if (typeof message.dilutedRevenueTtmSurprisePercent !== 'number')
          return 'dilutedRevenueTtmSurprisePercent: number expected';
      if (message.epsGrowthTtm != null && message.hasOwnProperty('epsGrowthTtm'))
        if (typeof message.epsGrowthTtm !== 'number') return 'epsGrowthTtm: number expected';
      if (message.epsGrowthY2Y != null && message.hasOwnProperty('epsGrowthY2Y'))
        if (typeof message.epsGrowthY2Y !== 'number') return 'epsGrowthY2Y: number expected';
      if (message.epsGrowthQ2Q != null && message.hasOwnProperty('epsGrowthQ2Q'))
        if (typeof message.epsGrowthQ2Q !== 'number') return 'epsGrowthQ2Q: number expected';
      if (message.epsGrowth5Year != null && message.hasOwnProperty('epsGrowth5Year'))
        if (typeof message.epsGrowth5Year !== 'number') return 'epsGrowth5Year: number expected';
      if (message.epsGrowthYearAgoQ != null && message.hasOwnProperty('epsGrowthYearAgoQ'))
        if (typeof message.epsGrowthYearAgoQ !== 'number') return 'epsGrowthYearAgoQ: number expected';
      if (message.revenueGrowthTtm != null && message.hasOwnProperty('revenueGrowthTtm'))
        if (typeof message.revenueGrowthTtm !== 'number') return 'revenueGrowthTtm: number expected';
      if (message.revenueGrowthY2Y != null && message.hasOwnProperty('revenueGrowthY2Y'))
        if (typeof message.revenueGrowthY2Y !== 'number') return 'revenueGrowthY2Y: number expected';
      if (message.revenueGrowthQ2Q != null && message.hasOwnProperty('revenueGrowthQ2Q'))
        if (typeof message.revenueGrowthQ2Q !== 'number') return 'revenueGrowthQ2Q: number expected';
      if (message.revenueGrowth5Year != null && message.hasOwnProperty('revenueGrowth5Year'))
        if (typeof message.revenueGrowth5Year !== 'number') return 'revenueGrowth5Year: number expected';
      if (message.revenueGrowthYearAgoQ != null && message.hasOwnProperty('revenueGrowthYearAgoQ'))
        if (typeof message.revenueGrowthYearAgoQ !== 'number') return 'revenueGrowthYearAgoQ: number expected';
      if (message.ltDebtEquity != null && message.hasOwnProperty('ltDebtEquity'))
        if (typeof message.ltDebtEquity !== 'number') return 'ltDebtEquity: number expected';
      if (message.bullsSay != null && message.hasOwnProperty('bullsSay'))
        if (!$util.isString(message.bullsSay)) return 'bullsSay: string expected';
      if (message.bearsSay != null && message.hasOwnProperty('bearsSay'))
        if (!$util.isString(message.bearsSay)) return 'bearsSay: string expected';
      if (message.ipoDateNumber != null && message.hasOwnProperty('ipoDateNumber'))
        if (
          !$util.isInteger(message.ipoDateNumber) &&
          !(
            message.ipoDateNumber &&
            $util.isInteger(message.ipoDateNumber.low) &&
            $util.isInteger(message.ipoDateNumber.high)
          )
        )
          return 'ipoDateNumber: integer|Long expected';
      if (message.ffoPerShare != null && message.hasOwnProperty('ffoPerShare'))
        if (typeof message.ffoPerShare !== 'number') return 'ffoPerShare: number expected';
      if (message.quickRatioMrq != null && message.hasOwnProperty('quickRatioMrq'))
        if (typeof message.quickRatioMrq !== 'number') return 'quickRatioMrq: number expected';
      if (message.highAllTime != null && message.hasOwnProperty('highAllTime'))
        if (typeof message.highAllTime !== 'number') return 'highAllTime: number expected';
      if (message.lowAllTime != null && message.hasOwnProperty('lowAllTime'))
        if (typeof message.lowAllTime !== 'number') return 'lowAllTime: number expected';
      if (message.totalDebtEquityRatio != null && message.hasOwnProperty('totalDebtEquityRatio'))
        if (typeof message.totalDebtEquityRatio !== 'number') return 'totalDebtEquityRatio: number expected';
      if (message.dividendPayoutRatio != null && message.hasOwnProperty('dividendPayoutRatio'))
        if (typeof message.dividendPayoutRatio !== 'number') return 'dividendPayoutRatio: number expected';
      if (message.operatingCashFlowPerShare != null && message.hasOwnProperty('operatingCashFlowPerShare'))
        if (typeof message.operatingCashFlowPerShare !== 'number') return 'operatingCashFlowPerShare: number expected';
      if (message.insiderPercentage != null && message.hasOwnProperty('insiderPercentage'))
        if (typeof message.insiderPercentage !== 'number') return 'insiderPercentage: number expected';
      if (message.priceToCashFlowRatio != null && message.hasOwnProperty('priceToCashFlowRatio'))
        if (typeof message.priceToCashFlowRatio !== 'number') return 'priceToCashFlowRatio: number expected';
      if (message.netProfitMargin != null && message.hasOwnProperty('netProfitMargin'))
        if (typeof message.netProfitMargin !== 'number') return 'netProfitMargin: number expected';
      if (message.regularHoursChange != null && message.hasOwnProperty('regularHoursChange'))
        if (typeof message.regularHoursChange !== 'number') return 'regularHoursChange: number expected';
      if (message.regularHoursPercentChange != null && message.hasOwnProperty('regularHoursPercentChange'))
        if (typeof message.regularHoursPercentChange !== 'number') return 'regularHoursPercentChange: number expected';
      if (message.postToPreHoursChange != null && message.hasOwnProperty('postToPreHoursChange'))
        if (typeof message.postToPreHoursChange !== 'number') return 'postToPreHoursChange: number expected';
      if (message.postToPreHoursPercentChange != null && message.hasOwnProperty('postToPreHoursPercentChange'))
        if (typeof message.postToPreHoursPercentChange !== 'number')
          return 'postToPreHoursPercentChange: number expected';
      if (message.scannerClose != null && message.hasOwnProperty('scannerClose'))
        if (typeof message.scannerClose !== 'number') return 'scannerClose: number expected';
      if (message.scannerChange != null && message.hasOwnProperty('scannerChange'))
        if (typeof message.scannerChange !== 'number') return 'scannerChange: number expected';
      if (message.scannerChangePercent != null && message.hasOwnProperty('scannerChangePercent'))
        if (typeof message.scannerChangePercent !== 'number') return 'scannerChangePercent: number expected';
      if (message.scannerChangePercentClose != null && message.hasOwnProperty('scannerChangePercentClose'))
        if (typeof message.scannerChangePercentClose !== 'number') return 'scannerChangePercentClose: number expected';
      if (message.scannerPreviousClose != null && message.hasOwnProperty('scannerPreviousClose'))
        if (typeof message.scannerPreviousClose !== 'number') return 'scannerPreviousClose: number expected';
      if (message.freeCashFlow != null && message.hasOwnProperty('freeCashFlow'))
        if (typeof message.freeCashFlow !== 'number') return 'freeCashFlow: number expected';
      if (message.minPriceTarget != null && message.hasOwnProperty('minPriceTarget'))
        if (typeof message.minPriceTarget !== 'number') return 'minPriceTarget: number expected';
      if (message.maxPriceTarget != null && message.hasOwnProperty('maxPriceTarget'))
        if (typeof message.maxPriceTarget !== 'number') return 'maxPriceTarget: number expected';
      if (message.meanPriceTarget != null && message.hasOwnProperty('meanPriceTarget'))
        if (typeof message.meanPriceTarget !== 'number') return 'meanPriceTarget: number expected';
      if (message.totalNumberOfAnalyst != null && message.hasOwnProperty('totalNumberOfAnalyst'))
        if (typeof message.totalNumberOfAnalyst !== 'number') return 'totalNumberOfAnalyst: number expected';
      if (message.averageAnalystRecommendation != null && message.hasOwnProperty('averageAnalystRecommendation'))
        if (!$util.isString(message.averageAnalystRecommendation))
          return 'averageAnalystRecommendation: string expected';
      if (message.pegRatio != null && message.hasOwnProperty('pegRatio'))
        if (typeof message.pegRatio !== 'number') return 'pegRatio: number expected';
      if (message.priceToFreeCashFlowRatio != null && message.hasOwnProperty('priceToFreeCashFlowRatio'))
        if (typeof message.priceToFreeCashFlowRatio !== 'number') return 'priceToFreeCashFlowRatio: number expected';
      if (message.distanceToMaxPriceTarget != null && message.hasOwnProperty('distanceToMaxPriceTarget'))
        if (typeof message.distanceToMaxPriceTarget !== 'number') return 'distanceToMaxPriceTarget: number expected';
      if (message.distanceToMinPriceTarget != null && message.hasOwnProperty('distanceToMinPriceTarget'))
        if (typeof message.distanceToMinPriceTarget !== 'number') return 'distanceToMinPriceTarget: number expected';
      if (message.distanceToMeanPriceTarget != null && message.hasOwnProperty('distanceToMeanPriceTarget'))
        if (typeof message.distanceToMeanPriceTarget !== 'number') return 'distanceToMeanPriceTarget: number expected';
      if (message.shortTermTrend != null && message.hasOwnProperty('shortTermTrend'))
        if (!$util.isString(message.shortTermTrend)) return 'shortTermTrend: string expected';
      if (message.mediumTermTrend != null && message.hasOwnProperty('mediumTermTrend'))
        if (!$util.isString(message.mediumTermTrend)) return 'mediumTermTrend: string expected';
      if (message.longTermTrend != null && message.hasOwnProperty('longTermTrend'))
        if (!$util.isString(message.longTermTrend)) return 'longTermTrend: string expected';
      return null;
    };

    /**
     * Creates a Quote message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LastProtos.Quote
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LastProtos.Quote} Quote
     */
    Quote.fromObject = function fromObject(object) {
      if (object instanceof $root.LastProtos.Quote) return object;
      let message = new $root.LastProtos.Quote();
      if (object.symbol != null) message.symbol = String(object.symbol);
      if (object.opol != null) message.opol = String(object.opol);
      if (object.previousClose != null) message.previousClose = Number(object.previousClose);
      if (object.close != null) message.close = Number(object.close);
      if (object.change != null) message.change = Number(object.change);
      if (object.changePercent != null) message.changePercent = Number(object.changePercent);
      if (object.name != null) message.name = String(object.name);
      if (object.ipoDate != null) message.ipoDate = String(object.ipoDate);
      if (object.exchange != null) message.exchange = String(object.exchange);
      if (object.tradeExchange != null) message.tradeExchange = String(object.tradeExchange);
      if (object.preMarketOpen != null) message.preMarketOpen = Number(object.preMarketOpen);
      if (object.preMarketOpenTime != null)
        if ($util.Long) (message.preMarketOpenTime = $util.Long.fromValue(object.preMarketOpenTime)).unsigned = false;
        else if (typeof object.preMarketOpenTime === 'string')
          message.preMarketOpenTime = parseInt(object.preMarketOpenTime, 10);
        else if (typeof object.preMarketOpenTime === 'number') message.preMarketOpenTime = object.preMarketOpenTime;
        else if (typeof object.preMarketOpenTime === 'object')
          message.preMarketOpenTime = new $util.LongBits(
            object.preMarketOpenTime.low >>> 0,
            object.preMarketOpenTime.high >>> 0,
          ).toNumber();
      if (object.preMarketVolume != null)
        if ($util.Long) (message.preMarketVolume = $util.Long.fromValue(object.preMarketVolume)).unsigned = false;
        else if (typeof object.preMarketVolume === 'string')
          message.preMarketVolume = parseInt(object.preMarketVolume, 10);
        else if (typeof object.preMarketVolume === 'number') message.preMarketVolume = object.preMarketVolume;
        else if (typeof object.preMarketVolume === 'object')
          message.preMarketVolume = new $util.LongBits(
            object.preMarketVolume.low >>> 0,
            object.preMarketVolume.high >>> 0,
          ).toNumber();
      if (object.preMarketOpenChange != null) message.preMarketOpenChange = Number(object.preMarketOpenChange);
      if (object.preMarketOpenChangePercent != null)
        message.preMarketOpenChangePercent = Number(object.preMarketOpenChangePercent);
      switch (object.source) {
        default:
          if (typeof object.source === 'number') {
            message.source = object.source;
            break;
          }
          break;
        case 'UNKNOWN_SOURCE':
        case 0:
          message.source = 0;
          break;
        case 'QUOTE_STORE':
        case 1:
          message.source = 1;
          break;
        case 'QUOTE_CALCULATOR':
        case 2:
          message.source = 2;
          break;
        case 'POLLED_DATA':
        case 3:
          message.source = 3;
          break;
        case 'ROLLING_FIELDS':
        case 4:
          message.source = 4;
          break;
        case 'RSI_FIELDS':
        case 5:
          message.source = 5;
          break;
        case 'CONTENT_EVENT_PUBLISHER':
        case 6:
          message.source = 6;
          break;
      }
      if (object.clearFieldNumbers) {
        if (!Array.isArray(object.clearFieldNumbers))
          throw TypeError('.LastProtos.Quote.clearFieldNumbers: array expected');
        message.clearFieldNumbers = [];
        for (let i = 0; i < object.clearFieldNumbers.length; ++i)
          message.clearFieldNumbers[i] = object.clearFieldNumbers[i] | 0;
      }
      if (object.marketCap != null)
        if ($util.Long) (message.marketCap = $util.Long.fromValue(object.marketCap)).unsigned = false;
        else if (typeof object.marketCap === 'string') message.marketCap = parseInt(object.marketCap, 10);
        else if (typeof object.marketCap === 'number') message.marketCap = object.marketCap;
        else if (typeof object.marketCap === 'object')
          message.marketCap = new $util.LongBits(object.marketCap.low >>> 0, object.marketCap.high >>> 0).toNumber();
      if (object.rsi != null) message.rsi = Number(object.rsi);
      if (object.atr != null) message.atr = Number(object.atr);
      if (object.priceToEarnings != null) message.priceToEarnings = Number(object.priceToEarnings);
      if (object.averageVolume != null)
        if ($util.Long) (message.averageVolume = $util.Long.fromValue(object.averageVolume)).unsigned = false;
        else if (typeof object.averageVolume === 'string') message.averageVolume = parseInt(object.averageVolume, 10);
        else if (typeof object.averageVolume === 'number') message.averageVolume = object.averageVolume;
        else if (typeof object.averageVolume === 'object')
          message.averageVolume = new $util.LongBits(
            object.averageVolume.low >>> 0,
            object.averageVolume.high >>> 0,
          ).toNumber();
      if (object.sharesOutstanding != null)
        if ($util.Long) (message.sharesOutstanding = $util.Long.fromValue(object.sharesOutstanding)).unsigned = false;
        else if (typeof object.sharesOutstanding === 'string')
          message.sharesOutstanding = parseInt(object.sharesOutstanding, 10);
        else if (typeof object.sharesOutstanding === 'number') message.sharesOutstanding = object.sharesOutstanding;
        else if (typeof object.sharesOutstanding === 'object')
          message.sharesOutstanding = new $util.LongBits(
            object.sharesOutstanding.low >>> 0,
            object.sharesOutstanding.high >>> 0,
          ).toNumber();
      if (object.sector != null) message.sector = String(object.sector);
      if (object.sectorCode != null) message.sectorCode = object.sectorCode | 0;
      if (object.industry != null) message.industry = String(object.industry);
      if (object.industryCode != null) message.industryCode = object.industryCode | 0;
      if (object.forwardPERatio != null) message.forwardPERatio = Number(object.forwardPERatio);
      if (object.pricetoEBITDA != null) message.pricetoEBITDA = Number(object.pricetoEBITDA);
      if (object.trailingDividendYield != null) message.trailingDividendYield = Number(object.trailingDividendYield);
      if (object.PBRatio != null) message.PBRatio = Number(object.PBRatio);
      if (object.priceToSales != null) message.priceToSales = Number(object.priceToSales);
      if (object.FCFPerShare != null) message.FCFPerShare = Number(object.FCFPerShare);
      if (object.buyBackYield != null) message.buyBackYield = Number(object.buyBackYield);
      if (object.open != null) message.open = Number(object.open);
      if (object.price != null) message.price = Number(object.price);
      if (object.high != null) message.high = Number(object.high);
      if (object.low != null) message.low = Number(object.low);
      if (object.time != null)
        if ($util.Long) (message.time = $util.Long.fromValue(object.time)).unsigned = false;
        else if (typeof object.time === 'string') message.time = parseInt(object.time, 10);
        else if (typeof object.time === 'number') message.time = object.time;
        else if (typeof object.time === 'object')
          message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
      if (object.size != null) message.size = object.size | 0;
      if (object.type != null) message.type = String(object.type);
      if (object.dayVolume != null)
        if ($util.Long) (message.dayVolume = $util.Long.fromValue(object.dayVolume)).unsigned = false;
        else if (typeof object.dayVolume === 'string') message.dayVolume = parseInt(object.dayVolume, 10);
        else if (typeof object.dayVolume === 'number') message.dayVolume = object.dayVolume;
        else if (typeof object.dayVolume === 'object')
          message.dayVolume = new $util.LongBits(object.dayVolume.low >>> 0, object.dayVolume.high >>> 0).toNumber();
      if (object.askPrice != null) message.askPrice = Number(object.askPrice);
      if (object.bidPrice != null) message.bidPrice = Number(object.bidPrice);
      if (object.shareFloatDate != null) message.shareFloatDate = String(object.shareFloatDate);
      if (object.sharesOutstandingDate != null) message.sharesOutstandingDate = String(object.sharesOutstandingDate);
      if (object.shareFloat != null)
        if ($util.Long) (message.shareFloat = $util.Long.fromValue(object.shareFloat)).unsigned = false;
        else if (typeof object.shareFloat === 'string') message.shareFloat = parseInt(object.shareFloat, 10);
        else if (typeof object.shareFloat === 'number') message.shareFloat = object.shareFloat;
        else if (typeof object.shareFloat === 'object')
          message.shareFloat = new $util.LongBits(object.shareFloat.low >>> 0, object.shareFloat.high >>> 0).toNumber();
      switch (object.updateType) {
        default:
          if (typeof object.updateType === 'number') {
            message.updateType = object.updateType;
            break;
          }
          break;
        case 'UNKNOWN':
        case 0:
          message.updateType = 0;
          break;
        case 'VALID':
        case 1:
          message.updateType = 1;
          break;
        case 'IN_VALID':
        case 2:
          message.updateType = 2;
          break;
      }
      if (object.subtype != null) message.subtype = String(object.subtype);
      switch (object.sessionType) {
        default:
          if (typeof object.sessionType === 'number') {
            message.sessionType = object.sessionType;
            break;
          }
          break;
        case 'NA':
        case 0:
          message.sessionType = 0;
          break;
        case 'PRE_MARKET':
        case 1:
          message.sessionType = 1;
          break;
        case 'REGULAR':
        case 2:
          message.sessionType = 2;
          break;
        case 'AFTER_MARKET':
        case 3:
          message.sessionType = 3;
          break;
      }
      if (object.volume != null)
        if ($util.Long) (message.volume = $util.Long.fromValue(object.volume)).unsigned = false;
        else if (typeof object.volume === 'string') message.volume = parseInt(object.volume, 10);
        else if (typeof object.volume === 'number') message.volume = object.volume;
        else if (typeof object.volume === 'object')
          message.volume = new $util.LongBits(object.volume.low >>> 0, object.volume.high >>> 0).toNumber();
      if (object.changePercent1Minute != null) message.changePercent1Minute = Number(object.changePercent1Minute);
      if (object.changePercentClose != null) message.changePercentClose = Number(object.changePercentClose);
      if (object.changePercent5Minute != null) message.changePercent5Minute = Number(object.changePercent5Minute);
      if (object.volume1Minute != null)
        if ($util.Long) (message.volume1Minute = $util.Long.fromValue(object.volume1Minute)).unsigned = false;
        else if (typeof object.volume1Minute === 'string') message.volume1Minute = parseInt(object.volume1Minute, 10);
        else if (typeof object.volume1Minute === 'number') message.volume1Minute = object.volume1Minute;
        else if (typeof object.volume1Minute === 'object')
          message.volume1Minute = new $util.LongBits(
            object.volume1Minute.low >>> 0,
            object.volume1Minute.high >>> 0,
          ).toNumber();
      if (object.relativeVolume1Minute != null) message.relativeVolume1Minute = Number(object.relativeVolume1Minute);
      if (object.change15Minute != null) message.change15Minute = Number(object.change15Minute);
      if (object.changePercent15Minute != null) message.changePercent15Minute = Number(object.changePercent15Minute);
      if (object.change30Minute != null) message.change30Minute = Number(object.change30Minute);
      if (object.changePercent30Minute != null) message.changePercent30Minute = Number(object.changePercent30Minute);
      if (object.change60Minute != null) message.change60Minute = Number(object.change60Minute);
      if (object.changePercent60Minute != null) message.changePercent60Minute = Number(object.changePercent60Minute);
      if (object.changePercentOpen != null) message.changePercentOpen = Number(object.changePercentOpen);
      if (object.changeOpen != null) message.changeOpen = Number(object.changeOpen);
      if (object.gics != null) message.gics = object.gics | 0;
      if (object.gicsSector != null) message.gicsSector = object.gicsSector | 0;
      if (object.gicsSectorName != null) message.gicsSectorName = String(object.gicsSectorName);
      if (object.gicsIndustryGroup != null) message.gicsIndustryGroup = object.gicsIndustryGroup | 0;
      if (object.gicsIndustryGroupName != null) message.gicsIndustryGroupName = String(object.gicsIndustryGroupName);
      if (object.gicsIndustry != null) message.gicsIndustry = object.gicsIndustry | 0;
      if (object.gicsIndustryName != null) message.gicsIndustryName = String(object.gicsIndustryName);
      if (object.gicsSubIndustry != null) message.gicsSubIndustry = object.gicsSubIndustry | 0;
      if (object.gicsSubIndustryName != null) message.gicsSubIndustryName = String(object.gicsSubIndustryName);
      if (object.optionable != null) message.optionable = object.optionable | 0;
      if (object.cik != null) message.cik = object.cik | 0;
      if (object.signalName != null) message.signalName = String(object.signalName);
      if (object.lastTradeTime != null)
        if ($util.Long) (message.lastTradeTime = $util.Long.fromValue(object.lastTradeTime)).unsigned = false;
        else if (typeof object.lastTradeTime === 'string') message.lastTradeTime = parseInt(object.lastTradeTime, 10);
        else if (typeof object.lastTradeTime === 'number') message.lastTradeTime = object.lastTradeTime;
        else if (typeof object.lastTradeTime === 'object')
          message.lastTradeTime = new $util.LongBits(
            object.lastTradeTime.low >>> 0,
            object.lastTradeTime.high >>> 0,
          ).toNumber();
      if (object.country != null) message.country = String(object.country);
      if (object.sharesShort != null)
        if ($util.Long) (message.sharesShort = $util.Long.fromValue(object.sharesShort)).unsigned = false;
        else if (typeof object.sharesShort === 'string') message.sharesShort = parseInt(object.sharesShort, 10);
        else if (typeof object.sharesShort === 'number') message.sharesShort = object.sharesShort;
        else if (typeof object.sharesShort === 'object')
          message.sharesShort = new $util.LongBits(
            object.sharesShort.low >>> 0,
            object.sharesShort.high >>> 0,
          ).toNumber();
      if (object.sharesShortPercentOfFloat != null)
        message.sharesShortPercentOfFloat = Number(object.sharesShortPercentOfFloat);
      if (object.sharesShortChangePercent != null)
        message.sharesShortChangePercent = Number(object.sharesShortChangePercent);
      if (object.sharesShortReceiptDate != null)
        if ($util.Long)
          (message.sharesShortReceiptDate = $util.Long.fromValue(object.sharesShortReceiptDate)).unsigned = false;
        else if (typeof object.sharesShortReceiptDate === 'string')
          message.sharesShortReceiptDate = parseInt(object.sharesShortReceiptDate, 10);
        else if (typeof object.sharesShortReceiptDate === 'number')
          message.sharesShortReceiptDate = object.sharesShortReceiptDate;
        else if (typeof object.sharesShortReceiptDate === 'object')
          message.sharesShortReceiptDate = new $util.LongBits(
            object.sharesShortReceiptDate.low >>> 0,
            object.sharesShortReceiptDate.high >>> 0,
          ).toNumber();
      if (object.sharesShortSettlementDate != null)
        if ($util.Long)
          (message.sharesShortSettlementDate = $util.Long.fromValue(object.sharesShortSettlementDate)).unsigned = false;
        else if (typeof object.sharesShortSettlementDate === 'string')
          message.sharesShortSettlementDate = parseInt(object.sharesShortSettlementDate, 10);
        else if (typeof object.sharesShortSettlementDate === 'number')
          message.sharesShortSettlementDate = object.sharesShortSettlementDate;
        else if (typeof object.sharesShortSettlementDate === 'object')
          message.sharesShortSettlementDate = new $util.LongBits(
            object.sharesShortSettlementDate.low >>> 0,
            object.sharesShortSettlementDate.high >>> 0,
          ).toNumber();
      if (object.shortInterestRatio != null) message.shortInterestRatio = Number(object.shortInterestRatio);
      if (object.sharesShortValue != null) message.sharesShortValue = Number(object.sharesShortValue);
      if (object.sharesShortPrevious != null)
        if ($util.Long)
          (message.sharesShortPrevious = $util.Long.fromValue(object.sharesShortPrevious)).unsigned = false;
        else if (typeof object.sharesShortPrevious === 'string')
          message.sharesShortPrevious = parseInt(object.sharesShortPrevious, 10);
        else if (typeof object.sharesShortPrevious === 'number')
          message.sharesShortPrevious = object.sharesShortPrevious;
        else if (typeof object.sharesShortPrevious === 'object')
          message.sharesShortPrevious = new $util.LongBits(
            object.sharesShortPrevious.low >>> 0,
            object.sharesShortPrevious.high >>> 0,
          ).toNumber();
      if (object.sharesShortPreviousValue != null)
        message.sharesShortPreviousValue = Number(object.sharesShortPreviousValue);
      if (object.sharesShortPreviousPercentOfFloat != null)
        message.sharesShortPreviousPercentOfFloat = Number(object.sharesShortPreviousPercentOfFloat);
      if (object.sharesShortChange != null)
        if ($util.Long) (message.sharesShortChange = $util.Long.fromValue(object.sharesShortChange)).unsigned = false;
        else if (typeof object.sharesShortChange === 'string')
          message.sharesShortChange = parseInt(object.sharesShortChange, 10);
        else if (typeof object.sharesShortChange === 'number') message.sharesShortChange = object.sharesShortChange;
        else if (typeof object.sharesShortChange === 'object')
          message.sharesShortChange = new $util.LongBits(
            object.sharesShortChange.low >>> 0,
            object.sharesShortChange.high >>> 0,
          ).toNumber();
      if (object.sentTime != null)
        if ($util.Long) (message.sentTime = $util.Long.fromValue(object.sentTime)).unsigned = false;
        else if (typeof object.sentTime === 'string') message.sentTime = parseInt(object.sentTime, 10);
        else if (typeof object.sentTime === 'number') message.sentTime = object.sentTime;
        else if (typeof object.sentTime === 'object')
          message.sentTime = new $util.LongBits(object.sentTime.low >>> 0, object.sentTime.high >>> 0).toNumber();
      if (object.volume5Minute != null)
        if ($util.Long) (message.volume5Minute = $util.Long.fromValue(object.volume5Minute)).unsigned = false;
        else if (typeof object.volume5Minute === 'string') message.volume5Minute = parseInt(object.volume5Minute, 10);
        else if (typeof object.volume5Minute === 'number') message.volume5Minute = object.volume5Minute;
        else if (typeof object.volume5Minute === 'object')
          message.volume5Minute = new $util.LongBits(
            object.volume5Minute.low >>> 0,
            object.volume5Minute.high >>> 0,
          ).toNumber();
      if (object.volume15Minute != null)
        if ($util.Long) (message.volume15Minute = $util.Long.fromValue(object.volume15Minute)).unsigned = false;
        else if (typeof object.volume15Minute === 'string')
          message.volume15Minute = parseInt(object.volume15Minute, 10);
        else if (typeof object.volume15Minute === 'number') message.volume15Minute = object.volume15Minute;
        else if (typeof object.volume15Minute === 'object')
          message.volume15Minute = new $util.LongBits(
            object.volume15Minute.low >>> 0,
            object.volume15Minute.high >>> 0,
          ).toNumber();
      if (object.volume30Minute != null)
        if ($util.Long) (message.volume30Minute = $util.Long.fromValue(object.volume30Minute)).unsigned = false;
        else if (typeof object.volume30Minute === 'string')
          message.volume30Minute = parseInt(object.volume30Minute, 10);
        else if (typeof object.volume30Minute === 'number') message.volume30Minute = object.volume30Minute;
        else if (typeof object.volume30Minute === 'object')
          message.volume30Minute = new $util.LongBits(
            object.volume30Minute.low >>> 0,
            object.volume30Minute.high >>> 0,
          ).toNumber();
      if (object.volume60Minute != null)
        if ($util.Long) (message.volume60Minute = $util.Long.fromValue(object.volume60Minute)).unsigned = false;
        else if (typeof object.volume60Minute === 'string')
          message.volume60Minute = parseInt(object.volume60Minute, 10);
        else if (typeof object.volume60Minute === 'number') message.volume60Minute = object.volume60Minute;
        else if (typeof object.volume60Minute === 'object')
          message.volume60Minute = new $util.LongBits(
            object.volume60Minute.low >>> 0,
            object.volume60Minute.high >>> 0,
          ).toNumber();
      if (object.relativeVolume5Minute != null) message.relativeVolume5Minute = Number(object.relativeVolume5Minute);
      if (object.relativeVolume90Day != null) message.relativeVolume90Day = Number(object.relativeVolume90Day);
      if (object.rvol1m10d != null) message.rvol1m10d = Number(object.rvol1m10d);
      if (object.rvol5m10d != null) message.rvol5m10d = Number(object.rvol5m10d);
      if (object.rvol5m30d != null) message.rvol5m30d = Number(object.rvol5m30d);
      if (object.rvol5m90d != null) message.rvol5m90d = Number(object.rvol5m90d);
      if (object.averageVolume10Day != null)
        if ($util.Long) (message.averageVolume10Day = $util.Long.fromValue(object.averageVolume10Day)).unsigned = false;
        else if (typeof object.averageVolume10Day === 'string')
          message.averageVolume10Day = parseInt(object.averageVolume10Day, 10);
        else if (typeof object.averageVolume10Day === 'number') message.averageVolume10Day = object.averageVolume10Day;
        else if (typeof object.averageVolume10Day === 'object')
          message.averageVolume10Day = new $util.LongBits(
            object.averageVolume10Day.low >>> 0,
            object.averageVolume10Day.high >>> 0,
          ).toNumber();
      if (object.averageVolumeChangePercent10Day != null)
        message.averageVolumeChangePercent10Day = Number(object.averageVolumeChangePercent10Day);
      if (object.high10Day != null) message.high10Day = Number(object.high10Day);
      if (object.highChangePercent10Day != null) message.highChangePercent10Day = Number(object.highChangePercent10Day);
      if (object.low10Day != null) message.low10Day = Number(object.low10Day);
      if (object.lowChangePercent10Day != null) message.lowChangePercent10Day = Number(object.lowChangePercent10Day);
      if (object.movingAverage10Day != null) message.movingAverage10Day = Number(object.movingAverage10Day);
      if (object.movingAverageChangePercent10Day != null)
        message.movingAverageChangePercent10Day = Number(object.movingAverageChangePercent10Day);
      if (object.averageVolume20Day != null)
        if ($util.Long) (message.averageVolume20Day = $util.Long.fromValue(object.averageVolume20Day)).unsigned = false;
        else if (typeof object.averageVolume20Day === 'string')
          message.averageVolume20Day = parseInt(object.averageVolume20Day, 10);
        else if (typeof object.averageVolume20Day === 'number') message.averageVolume20Day = object.averageVolume20Day;
        else if (typeof object.averageVolume20Day === 'object')
          message.averageVolume20Day = new $util.LongBits(
            object.averageVolume20Day.low >>> 0,
            object.averageVolume20Day.high >>> 0,
          ).toNumber();
      if (object.averageVolumeChangePercent20Day != null)
        message.averageVolumeChangePercent20Day = Number(object.averageVolumeChangePercent20Day);
      if (object.high20Day != null) message.high20Day = Number(object.high20Day);
      if (object.highChangePercent20Day != null) message.highChangePercent20Day = Number(object.highChangePercent20Day);
      if (object.low20Day != null) message.low20Day = Number(object.low20Day);
      if (object.lowChangePercent20Day != null) message.lowChangePercent20Day = Number(object.lowChangePercent20Day);
      if (object.movingAverage20Day != null) message.movingAverage20Day = Number(object.movingAverage20Day);
      if (object.movingAverageChangePercent20Day != null)
        message.movingAverageChangePercent20Day = Number(object.movingAverageChangePercent20Day);
      if (object.averageVolume50Day != null)
        if ($util.Long) (message.averageVolume50Day = $util.Long.fromValue(object.averageVolume50Day)).unsigned = false;
        else if (typeof object.averageVolume50Day === 'string')
          message.averageVolume50Day = parseInt(object.averageVolume50Day, 10);
        else if (typeof object.averageVolume50Day === 'number') message.averageVolume50Day = object.averageVolume50Day;
        else if (typeof object.averageVolume50Day === 'object')
          message.averageVolume50Day = new $util.LongBits(
            object.averageVolume50Day.low >>> 0,
            object.averageVolume50Day.high >>> 0,
          ).toNumber();
      if (object.averageVolumeChangePercent50Day != null)
        message.averageVolumeChangePercent50Day = Number(object.averageVolumeChangePercent50Day);
      if (object.high50Day != null) message.high50Day = Number(object.high50Day);
      if (object.highChangePercent50Day != null) message.highChangePercent50Day = Number(object.highChangePercent50Day);
      if (object.low50Day != null) message.low50Day = Number(object.low50Day);
      if (object.lowChangePercent50Day != null) message.lowChangePercent50Day = Number(object.lowChangePercent50Day);
      if (object.movingAverage50Day != null) message.movingAverage50Day = Number(object.movingAverage50Day);
      if (object.movingAverageChangePercent50Day != null)
        message.movingAverageChangePercent50Day = Number(object.movingAverageChangePercent50Day);
      if (object.averageVolume100Day != null)
        if ($util.Long)
          (message.averageVolume100Day = $util.Long.fromValue(object.averageVolume100Day)).unsigned = false;
        else if (typeof object.averageVolume100Day === 'string')
          message.averageVolume100Day = parseInt(object.averageVolume100Day, 10);
        else if (typeof object.averageVolume100Day === 'number')
          message.averageVolume100Day = object.averageVolume100Day;
        else if (typeof object.averageVolume100Day === 'object')
          message.averageVolume100Day = new $util.LongBits(
            object.averageVolume100Day.low >>> 0,
            object.averageVolume100Day.high >>> 0,
          ).toNumber();
      if (object.averageVolumeChangePercent100Day != null)
        message.averageVolumeChangePercent100Day = Number(object.averageVolumeChangePercent100Day);
      if (object.high100Day != null) message.high100Day = Number(object.high100Day);
      if (object.highChangePercent100Day != null)
        message.highChangePercent100Day = Number(object.highChangePercent100Day);
      if (object.low100Day != null) message.low100Day = Number(object.low100Day);
      if (object.lowChangePercent100Day != null) message.lowChangePercent100Day = Number(object.lowChangePercent100Day);
      if (object.movingAverage100Day != null) message.movingAverage100Day = Number(object.movingAverage100Day);
      if (object.movingAverageChangePercent100Day != null)
        message.movingAverageChangePercent100Day = Number(object.movingAverageChangePercent100Day);
      if (object.averageVolume200Day != null)
        if ($util.Long)
          (message.averageVolume200Day = $util.Long.fromValue(object.averageVolume200Day)).unsigned = false;
        else if (typeof object.averageVolume200Day === 'string')
          message.averageVolume200Day = parseInt(object.averageVolume200Day, 10);
        else if (typeof object.averageVolume200Day === 'number')
          message.averageVolume200Day = object.averageVolume200Day;
        else if (typeof object.averageVolume200Day === 'object')
          message.averageVolume200Day = new $util.LongBits(
            object.averageVolume200Day.low >>> 0,
            object.averageVolume200Day.high >>> 0,
          ).toNumber();
      if (object.averageVolumeChangePercent200Day != null)
        message.averageVolumeChangePercent200Day = Number(object.averageVolumeChangePercent200Day);
      if (object.high200Day != null) message.high200Day = Number(object.high200Day);
      if (object.highChangePercent200Day != null)
        message.highChangePercent200Day = Number(object.highChangePercent200Day);
      if (object.low200Day != null) message.low200Day = Number(object.low200Day);
      if (object.lowChangePercent200Day != null) message.lowChangePercent200Day = Number(object.lowChangePercent200Day);
      if (object.movingAverage200Day != null) message.movingAverage200Day = Number(object.movingAverage200Day);
      if (object.movingAverageChangePercent200Day != null)
        message.movingAverageChangePercent200Day = Number(object.movingAverageChangePercent200Day);
      if (object.movingAverage250Day != null) message.movingAverage250Day = Number(object.movingAverage250Day);
      if (object.movingAverageChangePercent250Day != null)
        message.movingAverageChangePercent250Day = Number(object.movingAverageChangePercent250Day);
      if (object.averageVolume90Day != null)
        if ($util.Long) (message.averageVolume90Day = $util.Long.fromValue(object.averageVolume90Day)).unsigned = false;
        else if (typeof object.averageVolume90Day === 'string')
          message.averageVolume90Day = parseInt(object.averageVolume90Day, 10);
        else if (typeof object.averageVolume90Day === 'number') message.averageVolume90Day = object.averageVolume90Day;
        else if (typeof object.averageVolume90Day === 'object')
          message.averageVolume90Day = new $util.LongBits(
            object.averageVolume90Day.low >>> 0,
            object.averageVolume90Day.high >>> 0,
          ).toNumber();
      if (object.nextEarningsDate != null) message.nextEarningsDate = object.nextEarningsDate | 0;
      if (object.dividend != null) message.dividend = Number(object.dividend);
      if (object.dividendYield != null) message.dividendYield = Number(object.dividendYield);
      if (object.dividendExDate != null) message.dividendExDate = object.dividendExDate | 0;
      if (object.dividendFrequency != null)
        if ($util.Long) (message.dividendFrequency = $util.Long.fromValue(object.dividendFrequency)).unsigned = false;
        else if (typeof object.dividendFrequency === 'string')
          message.dividendFrequency = parseInt(object.dividendFrequency, 10);
        else if (typeof object.dividendFrequency === 'number') message.dividendFrequency = object.dividendFrequency;
        else if (typeof object.dividendFrequency === 'object')
          message.dividendFrequency = new $util.LongBits(
            object.dividendFrequency.low >>> 0,
            object.dividendFrequency.high >>> 0,
          ).toNumber();
      if (object.forwardDividendYield != null) message.forwardDividendYield = Number(object.forwardDividendYield);
      if (object.roe != null) message.roe = Number(object.roe);
      if (object.roa != null) message.roa = Number(object.roa);
      if (object.roic != null) message.roic = Number(object.roic);
      if (object.currentRatio != null) message.currentRatio = Number(object.currentRatio);
      if (object.grossMargin != null) message.grossMargin = Number(object.grossMargin);
      if (object.netMargin != null) message.netMargin = Number(object.netMargin);
      if (object.operationMargin != null) message.operationMargin = Number(object.operationMargin);
      if (object.epsMrq != null) message.epsMrq = Number(object.epsMrq);
      if (object.epsTtm != null) message.epsTtm = Number(object.epsTtm);
      if (object.dilutedEpsMrq != null) message.dilutedEpsMrq = Number(object.dilutedEpsMrq);
      if (object.dilutedEpsTtm != null) message.dilutedEpsTtm = Number(object.dilutedEpsTtm);
      if (object.low52Week != null) message.low52Week = Number(object.low52Week);
      if (object.high52Week != null) message.high52Week = Number(object.high52Week);
      if (object.revenueTtm != null) message.revenueTtm = Number(object.revenueTtm);
      if (object.earningsAsOf != null) message.earningsAsOf = object.earningsAsOf | 0;
      if (object.price1Week != null) message.price1Week = Number(object.price1Week);
      if (object.priceChangePercent1Week != null)
        message.priceChangePercent1Week = Number(object.priceChangePercent1Week);
      if (object.price1Month != null) message.price1Month = Number(object.price1Month);
      if (object.priceChangePercent1Month != null)
        message.priceChangePercent1Month = Number(object.priceChangePercent1Month);
      if (object.priceHalfYear != null) message.priceHalfYear = Number(object.priceHalfYear);
      if (object.priceChangePercentHalfYear != null)
        message.priceChangePercentHalfYear = Number(object.priceChangePercentHalfYear);
      if (object.priceQuarter != null) message.priceQuarter = Number(object.priceQuarter);
      if (object.priceChangePercentQuarter != null)
        message.priceChangePercentQuarter = Number(object.priceChangePercentQuarter);
      if (object.price1Year != null) message.price1Year = Number(object.price1Year);
      if (object.priceChangePercent1Year != null)
        message.priceChangePercent1Year = Number(object.priceChangePercent1Year);
      if (object.priceYearToDate != null) message.priceYearToDate = Number(object.priceYearToDate);
      if (object.priceChangePercentYearToDate != null)
        message.priceChangePercentYearToDate = Number(object.priceChangePercentYearToDate);
      if (object.roeMrq != null) message.roeMrq = Number(object.roeMrq);
      if (object.roaMrq != null) message.roaMrq = Number(object.roaMrq);
      if (object.roicMrq != null) message.roicMrq = Number(object.roicMrq);
      if (object.currentRatioMrq != null) message.currentRatioMrq = Number(object.currentRatioMrq);
      if (object.grossMarginMrq != null) message.grossMarginMrq = Number(object.grossMarginMrq);
      if (object.netMarginMrq != null) message.netMarginMrq = Number(object.netMarginMrq);
      if (object.operationMarginMrq != null) message.operationMarginMrq = Number(object.operationMarginMrq);
      if (object.previousDayVolume != null)
        if ($util.Long) (message.previousDayVolume = $util.Long.fromValue(object.previousDayVolume)).unsigned = false;
        else if (typeof object.previousDayVolume === 'string')
          message.previousDayVolume = parseInt(object.previousDayVolume, 10);
        else if (typeof object.previousDayVolume === 'number') message.previousDayVolume = object.previousDayVolume;
        else if (typeof object.previousDayVolume === 'object')
          message.previousDayVolume = new $util.LongBits(
            object.previousDayVolume.low >>> 0,
            object.previousDayVolume.high >>> 0,
          ).toNumber();
      if (object.previousDayAtr != null) message.previousDayAtr = Number(object.previousDayAtr);
      if (object.previousDayAdx != null) message.previousDayAdx = Number(object.previousDayAdx);
      if (object.previousDayPlusDMSmoothed != null)
        message.previousDayPlusDMSmoothed = Number(object.previousDayPlusDMSmoothed);
      if (object.previousDayMinusDMSmoothed != null)
        message.previousDayMinusDMSmoothed = Number(object.previousDayMinusDMSmoothed);
      if (object.previousDayHigh != null) message.previousDayHigh = Number(object.previousDayHigh);
      if (object.previousDayLow != null) message.previousDayLow = Number(object.previousDayLow);
      if (object.adx != null) message.adx = Number(object.adx);
      if (object.percentInstitutionalOwnership != null)
        message.percentInstitutionalOwnership = Number(object.percentInstitutionalOwnership);
      if (object.wiim != null) message.wiim = String(object.wiim);
      if (object.wiimAsOf != null)
        if ($util.Long) (message.wiimAsOf = $util.Long.fromValue(object.wiimAsOf)).unsigned = false;
        else if (typeof object.wiimAsOf === 'string') message.wiimAsOf = parseInt(object.wiimAsOf, 10);
        else if (typeof object.wiimAsOf === 'number') message.wiimAsOf = object.wiimAsOf;
        else if (typeof object.wiimAsOf === 'object')
          message.wiimAsOf = new $util.LongBits(object.wiimAsOf.low >>> 0, object.wiimAsOf.high >>> 0).toNumber();
      if (object.vwap != null) message.vwap = Number(object.vwap);
      if (object.vwapChangePercent != null) message.vwapChangePercent = Number(object.vwapChangePercent);
      if (object.vwapChange != null) message.vwapChange = Number(object.vwapChange);
      if (object.rsiAvgGain != null) message.rsiAvgGain = Number(object.rsiAvgGain);
      if (object.rsiAvgLoss != null) message.rsiAvgLoss = Number(object.rsiAvgLoss);
      if (object.halted != null) message.halted = String(object.halted);
      if (object.tradeCount != null)
        if ($util.Long) (message.tradeCount = $util.Long.fromValue(object.tradeCount)).unsigned = false;
        else if (typeof object.tradeCount === 'string') message.tradeCount = parseInt(object.tradeCount, 10);
        else if (typeof object.tradeCount === 'number') message.tradeCount = object.tradeCount;
        else if (typeof object.tradeCount === 'object')
          message.tradeCount = new $util.LongBits(object.tradeCount.low >>> 0, object.tradeCount.high >>> 0).toNumber();
      if (object.regularHighCount != null)
        if ($util.Long) (message.regularHighCount = $util.Long.fromValue(object.regularHighCount)).unsigned = false;
        else if (typeof object.regularHighCount === 'string')
          message.regularHighCount = parseInt(object.regularHighCount, 10);
        else if (typeof object.regularHighCount === 'number') message.regularHighCount = object.regularHighCount;
        else if (typeof object.regularHighCount === 'object')
          message.regularHighCount = new $util.LongBits(
            object.regularHighCount.low >>> 0,
            object.regularHighCount.high >>> 0,
          ).toNumber();
      if (object.regularLowCount != null)
        if ($util.Long) (message.regularLowCount = $util.Long.fromValue(object.regularLowCount)).unsigned = false;
        else if (typeof object.regularLowCount === 'string')
          message.regularLowCount = parseInt(object.regularLowCount, 10);
        else if (typeof object.regularLowCount === 'number') message.regularLowCount = object.regularLowCount;
        else if (typeof object.regularLowCount === 'object')
          message.regularLowCount = new $util.LongBits(
            object.regularLowCount.low >>> 0,
            object.regularLowCount.high >>> 0,
          ).toNumber();
      if (object.preMarketHighCount != null)
        if ($util.Long) (message.preMarketHighCount = $util.Long.fromValue(object.preMarketHighCount)).unsigned = false;
        else if (typeof object.preMarketHighCount === 'string')
          message.preMarketHighCount = parseInt(object.preMarketHighCount, 10);
        else if (typeof object.preMarketHighCount === 'number') message.preMarketHighCount = object.preMarketHighCount;
        else if (typeof object.preMarketHighCount === 'object')
          message.preMarketHighCount = new $util.LongBits(
            object.preMarketHighCount.low >>> 0,
            object.preMarketHighCount.high >>> 0,
          ).toNumber();
      if (object.preMarketLowCount != null)
        if ($util.Long) (message.preMarketLowCount = $util.Long.fromValue(object.preMarketLowCount)).unsigned = false;
        else if (typeof object.preMarketLowCount === 'string')
          message.preMarketLowCount = parseInt(object.preMarketLowCount, 10);
        else if (typeof object.preMarketLowCount === 'number') message.preMarketLowCount = object.preMarketLowCount;
        else if (typeof object.preMarketLowCount === 'object')
          message.preMarketLowCount = new $util.LongBits(
            object.preMarketLowCount.low >>> 0,
            object.preMarketLowCount.high >>> 0,
          ).toNumber();
      if (object.afterMarketHighCount != null)
        if ($util.Long)
          (message.afterMarketHighCount = $util.Long.fromValue(object.afterMarketHighCount)).unsigned = false;
        else if (typeof object.afterMarketHighCount === 'string')
          message.afterMarketHighCount = parseInt(object.afterMarketHighCount, 10);
        else if (typeof object.afterMarketHighCount === 'number')
          message.afterMarketHighCount = object.afterMarketHighCount;
        else if (typeof object.afterMarketHighCount === 'object')
          message.afterMarketHighCount = new $util.LongBits(
            object.afterMarketHighCount.low >>> 0,
            object.afterMarketHighCount.high >>> 0,
          ).toNumber();
      if (object.afterMarketLowCount != null)
        if ($util.Long)
          (message.afterMarketLowCount = $util.Long.fromValue(object.afterMarketLowCount)).unsigned = false;
        else if (typeof object.afterMarketLowCount === 'string')
          message.afterMarketLowCount = parseInt(object.afterMarketLowCount, 10);
        else if (typeof object.afterMarketLowCount === 'number')
          message.afterMarketLowCount = object.afterMarketLowCount;
        else if (typeof object.afterMarketLowCount === 'object')
          message.afterMarketLowCount = new $util.LongBits(
            object.afterMarketLowCount.low >>> 0,
            object.afterMarketLowCount.high >>> 0,
          ).toNumber();
      if (object.dayHighCount != null)
        if ($util.Long) (message.dayHighCount = $util.Long.fromValue(object.dayHighCount)).unsigned = false;
        else if (typeof object.dayHighCount === 'string') message.dayHighCount = parseInt(object.dayHighCount, 10);
        else if (typeof object.dayHighCount === 'number') message.dayHighCount = object.dayHighCount;
        else if (typeof object.dayHighCount === 'object')
          message.dayHighCount = new $util.LongBits(
            object.dayHighCount.low >>> 0,
            object.dayHighCount.high >>> 0,
          ).toNumber();
      if (object.dayLowCount != null)
        if ($util.Long) (message.dayLowCount = $util.Long.fromValue(object.dayLowCount)).unsigned = false;
        else if (typeof object.dayLowCount === 'string') message.dayLowCount = parseInt(object.dayLowCount, 10);
        else if (typeof object.dayLowCount === 'number') message.dayLowCount = object.dayLowCount;
        else if (typeof object.dayLowCount === 'object')
          message.dayLowCount = new $util.LongBits(
            object.dayLowCount.low >>> 0,
            object.dayLowCount.high >>> 0,
          ).toNumber();
      if (object.dayHigh != null) message.dayHigh = Number(object.dayHigh);
      if (object.dayLow != null) message.dayLow = Number(object.dayLow);
      if (object.preMarketHigh != null) message.preMarketHigh = Number(object.preMarketHigh);
      if (object.preMarketLow != null) message.preMarketLow = Number(object.preMarketLow);
      if (object.afterMarketHigh != null) message.afterMarketHigh = Number(object.afterMarketHigh);
      if (object.afterMarketLow != null) message.afterMarketLow = Number(object.afterMarketLow);
      if (object.regularHigh != null) message.regularHigh = Number(object.regularHigh);
      if (object.regularLow != null) message.regularLow = Number(object.regularLow);
      if (object.priceSpikeUpCount != null)
        if ($util.Long) (message.priceSpikeUpCount = $util.Long.fromValue(object.priceSpikeUpCount)).unsigned = false;
        else if (typeof object.priceSpikeUpCount === 'string')
          message.priceSpikeUpCount = parseInt(object.priceSpikeUpCount, 10);
        else if (typeof object.priceSpikeUpCount === 'number') message.priceSpikeUpCount = object.priceSpikeUpCount;
        else if (typeof object.priceSpikeUpCount === 'object')
          message.priceSpikeUpCount = new $util.LongBits(
            object.priceSpikeUpCount.low >>> 0,
            object.priceSpikeUpCount.high >>> 0,
          ).toNumber();
      if (object.priceSpikeDownCount != null)
        if ($util.Long)
          (message.priceSpikeDownCount = $util.Long.fromValue(object.priceSpikeDownCount)).unsigned = false;
        else if (typeof object.priceSpikeDownCount === 'string')
          message.priceSpikeDownCount = parseInt(object.priceSpikeDownCount, 10);
        else if (typeof object.priceSpikeDownCount === 'number')
          message.priceSpikeDownCount = object.priceSpikeDownCount;
        else if (typeof object.priceSpikeDownCount === 'object')
          message.priceSpikeDownCount = new $util.LongBits(
            object.priceSpikeDownCount.low >>> 0,
            object.priceSpikeDownCount.high >>> 0,
          ).toNumber();
      if (object.haltedCount != null)
        if ($util.Long) (message.haltedCount = $util.Long.fromValue(object.haltedCount)).unsigned = false;
        else if (typeof object.haltedCount === 'string') message.haltedCount = parseInt(object.haltedCount, 10);
        else if (typeof object.haltedCount === 'number') message.haltedCount = object.haltedCount;
        else if (typeof object.haltedCount === 'object')
          message.haltedCount = new $util.LongBits(
            object.haltedCount.low >>> 0,
            object.haltedCount.high >>> 0,
          ).toNumber();
      if (object.usCongressTotal != null) message.usCongressTotal = Number(object.usCongressTotal);
      if (object.usCongressRepublicansTotal != null)
        message.usCongressRepublicansTotal = Number(object.usCongressRepublicansTotal);
      if (object.usCongressDemocratsTotal != null)
        message.usCongressDemocratsTotal = Number(object.usCongressDemocratsTotal);
      if (object.usCongressOtherTotal != null) message.usCongressOtherTotal = Number(object.usCongressOtherTotal);
      if (object.volumeFloatRatio != null) message.volumeFloatRatio = Number(object.volumeFloatRatio);
      if (object.atrp != null) message.atrp = Number(object.atrp);
      if (object.ytdGainLoss != null) message.ytdGainLoss = Number(object.ytdGainLoss);
      if (object.mtdGainLoss != null) message.mtdGainLoss = Number(object.mtdGainLoss);
      if (object.yearOpen != null) message.yearOpen = Number(object.yearOpen);
      if (object.monthOpen != null) message.monthOpen = Number(object.monthOpen);
      if (object.volumeFloatPercent != null) message.volumeFloatPercent = Number(object.volumeFloatPercent);
      if (object.ytdChange != null) message.ytdChange = Number(object.ytdChange);
      if (object.mtdChange != null) message.mtdChange = Number(object.mtdChange);
      if (object.rsi1m != null) message.rsi1m = Number(object.rsi1m);
      if (object.rsi2m != null) message.rsi2m = Number(object.rsi2m);
      if (object.rsi5m != null) message.rsi5m = Number(object.rsi5m);
      if (object.rsi15m != null) message.rsi15m = Number(object.rsi15m);
      if (object.rsi30m != null) message.rsi30m = Number(object.rsi30m);
      if (object.rsi60m != null) message.rsi60m = Number(object.rsi60m);
      if (object.rsiEth1m != null) message.rsiEth1m = Number(object.rsiEth1m);
      if (object.rsiEth2m != null) message.rsiEth2m = Number(object.rsiEth2m);
      if (object.rsiEth5m != null) message.rsiEth5m = Number(object.rsiEth5m);
      if (object.rsiEth15m != null) message.rsiEth15m = Number(object.rsiEth15m);
      if (object.rsiEth30m != null) message.rsiEth30m = Number(object.rsiEth30m);
      if (object.rsiEth60m != null) message.rsiEth60m = Number(object.rsiEth60m);
      if (object.averageDollarVolume10Day != null)
        message.averageDollarVolume10Day = Number(object.averageDollarVolume10Day);
      if (object.averageVolume60Day != null)
        if ($util.Long) (message.averageVolume60Day = $util.Long.fromValue(object.averageVolume60Day)).unsigned = false;
        else if (typeof object.averageVolume60Day === 'string')
          message.averageVolume60Day = parseInt(object.averageVolume60Day, 10);
        else if (typeof object.averageVolume60Day === 'number') message.averageVolume60Day = object.averageVolume60Day;
        else if (typeof object.averageVolume60Day === 'object')
          message.averageVolume60Day = new $util.LongBits(
            object.averageVolume60Day.low >>> 0,
            object.averageVolume60Day.high >>> 0,
          ).toNumber();
      if (object.relativeVolumePercent60Day != null)
        message.relativeVolumePercent60Day = Number(object.relativeVolumePercent60Day);
      if (object.ema12d != null) message.ema12d = Number(object.ema12d);
      if (object.ema26d != null) message.ema26d = Number(object.ema26d);
      if (object.macd != null) message.macd = Number(object.macd);
      if (object.macdSignalLine != null) message.macdSignalLine = Number(object.macdSignalLine);
      if (object.macdHistogram != null) message.macdHistogram = Number(object.macdHistogram);
      if (object.macdSignalLineBase != null) message.macdSignalLineBase = Number(object.macdSignalLineBase);
      if (object.dividendGrowthRate1Year != null)
        message.dividendGrowthRate1Year = Number(object.dividendGrowthRate1Year);
      if (object.dividendGrowthRate3Year != null)
        message.dividendGrowthRate3Year = Number(object.dividendGrowthRate3Year);
      if (object.dividendGrowthRate5Year != null)
        message.dividendGrowthRate5Year = Number(object.dividendGrowthRate5Year);
      if (object.newsBzWireTitle != null) message.newsBzWireTitle = String(object.newsBzWireTitle);
      if (object.newsBzWireNodeId != null) message.newsBzWireNodeId = String(object.newsBzWireNodeId);
      if (object.newsBzWireTimestamp != null)
        if ($util.Long)
          (message.newsBzWireTimestamp = $util.Long.fromValue(object.newsBzWireTimestamp)).unsigned = false;
        else if (typeof object.newsBzWireTimestamp === 'string')
          message.newsBzWireTimestamp = parseInt(object.newsBzWireTimestamp, 10);
        else if (typeof object.newsBzWireTimestamp === 'number')
          message.newsBzWireTimestamp = object.newsBzWireTimestamp;
        else if (typeof object.newsBzWireTimestamp === 'object')
          message.newsBzWireTimestamp = new $util.LongBits(
            object.newsBzWireTimestamp.low >>> 0,
            object.newsBzWireTimestamp.high >>> 0,
          ).toNumber();
      if (object.newsPRTitle != null) message.newsPRTitle = String(object.newsPRTitle);
      if (object.newsPRNodeId != null) message.newsPRNodeId = String(object.newsPRNodeId);
      if (object.newsPRTimestamp != null)
        if ($util.Long) (message.newsPRTimestamp = $util.Long.fromValue(object.newsPRTimestamp)).unsigned = false;
        else if (typeof object.newsPRTimestamp === 'string')
          message.newsPRTimestamp = parseInt(object.newsPRTimestamp, 10);
        else if (typeof object.newsPRTimestamp === 'number') message.newsPRTimestamp = object.newsPRTimestamp;
        else if (typeof object.newsPRTimestamp === 'object')
          message.newsPRTimestamp = new $util.LongBits(
            object.newsPRTimestamp.low >>> 0,
            object.newsPRTimestamp.high >>> 0,
          ).toNumber();
      if (object.newsSecTitle != null) message.newsSecTitle = String(object.newsSecTitle);
      if (object.newsSecNodeId != null) message.newsSecNodeId = String(object.newsSecNodeId);
      if (object.newsSecTimestamp != null)
        if ($util.Long) (message.newsSecTimestamp = $util.Long.fromValue(object.newsSecTimestamp)).unsigned = false;
        else if (typeof object.newsSecTimestamp === 'string')
          message.newsSecTimestamp = parseInt(object.newsSecTimestamp, 10);
        else if (typeof object.newsSecTimestamp === 'number') message.newsSecTimestamp = object.newsSecTimestamp;
        else if (typeof object.newsSecTimestamp === 'object')
          message.newsSecTimestamp = new $util.LongBits(
            object.newsSecTimestamp.low >>> 0,
            object.newsSecTimestamp.high >>> 0,
          ).toNumber();
      if (object.gapChange != null) message.gapChange = Number(object.gapChange);
      if (object.gapChangePercent != null) message.gapChangePercent = Number(object.gapChangePercent);
      if (object.adr14d != null) message.adr14d = Number(object.adr14d);
      if (object.movingAverage500Day != null) message.movingAverage500Day = Number(object.movingAverage500Day);
      if (object.dilutedEpsMrqSurprisePercent != null)
        message.dilutedEpsMrqSurprisePercent = Number(object.dilutedEpsMrqSurprisePercent);
      if (object.dilutedEpsTtmSurprisePercent != null)
        message.dilutedEpsTtmSurprisePercent = Number(object.dilutedEpsTtmSurprisePercent);
      if (object.dilutedRevenueMrqSurprisePercent != null)
        message.dilutedRevenueMrqSurprisePercent = Number(object.dilutedRevenueMrqSurprisePercent);
      if (object.dilutedRevenueTtmSurprisePercent != null)
        message.dilutedRevenueTtmSurprisePercent = Number(object.dilutedRevenueTtmSurprisePercent);
      if (object.epsGrowthTtm != null) message.epsGrowthTtm = Number(object.epsGrowthTtm);
      if (object.epsGrowthY2Y != null) message.epsGrowthY2Y = Number(object.epsGrowthY2Y);
      if (object.epsGrowthQ2Q != null) message.epsGrowthQ2Q = Number(object.epsGrowthQ2Q);
      if (object.epsGrowth5Year != null) message.epsGrowth5Year = Number(object.epsGrowth5Year);
      if (object.epsGrowthYearAgoQ != null) message.epsGrowthYearAgoQ = Number(object.epsGrowthYearAgoQ);
      if (object.revenueGrowthTtm != null) message.revenueGrowthTtm = Number(object.revenueGrowthTtm);
      if (object.revenueGrowthY2Y != null) message.revenueGrowthY2Y = Number(object.revenueGrowthY2Y);
      if (object.revenueGrowthQ2Q != null) message.revenueGrowthQ2Q = Number(object.revenueGrowthQ2Q);
      if (object.revenueGrowth5Year != null) message.revenueGrowth5Year = Number(object.revenueGrowth5Year);
      if (object.revenueGrowthYearAgoQ != null) message.revenueGrowthYearAgoQ = Number(object.revenueGrowthYearAgoQ);
      if (object.ltDebtEquity != null) message.ltDebtEquity = Number(object.ltDebtEquity);
      if (object.bullsSay != null) message.bullsSay = String(object.bullsSay);
      if (object.bearsSay != null) message.bearsSay = String(object.bearsSay);
      if (object.ipoDateNumber != null)
        if ($util.Long) (message.ipoDateNumber = $util.Long.fromValue(object.ipoDateNumber)).unsigned = false;
        else if (typeof object.ipoDateNumber === 'string') message.ipoDateNumber = parseInt(object.ipoDateNumber, 10);
        else if (typeof object.ipoDateNumber === 'number') message.ipoDateNumber = object.ipoDateNumber;
        else if (typeof object.ipoDateNumber === 'object')
          message.ipoDateNumber = new $util.LongBits(
            object.ipoDateNumber.low >>> 0,
            object.ipoDateNumber.high >>> 0,
          ).toNumber();
      if (object.ffoPerShare != null) message.ffoPerShare = Number(object.ffoPerShare);
      if (object.quickRatioMrq != null) message.quickRatioMrq = Number(object.quickRatioMrq);
      if (object.highAllTime != null) message.highAllTime = Number(object.highAllTime);
      if (object.lowAllTime != null) message.lowAllTime = Number(object.lowAllTime);
      if (object.totalDebtEquityRatio != null) message.totalDebtEquityRatio = Number(object.totalDebtEquityRatio);
      if (object.dividendPayoutRatio != null) message.dividendPayoutRatio = Number(object.dividendPayoutRatio);
      if (object.operatingCashFlowPerShare != null)
        message.operatingCashFlowPerShare = Number(object.operatingCashFlowPerShare);
      if (object.insiderPercentage != null) message.insiderPercentage = Number(object.insiderPercentage);
      if (object.priceToCashFlowRatio != null) message.priceToCashFlowRatio = Number(object.priceToCashFlowRatio);
      if (object.netProfitMargin != null) message.netProfitMargin = Number(object.netProfitMargin);
      if (object.regularHoursChange != null) message.regularHoursChange = Number(object.regularHoursChange);
      if (object.regularHoursPercentChange != null)
        message.regularHoursPercentChange = Number(object.regularHoursPercentChange);
      if (object.postToPreHoursChange != null) message.postToPreHoursChange = Number(object.postToPreHoursChange);
      if (object.postToPreHoursPercentChange != null)
        message.postToPreHoursPercentChange = Number(object.postToPreHoursPercentChange);
      if (object.scannerClose != null) message.scannerClose = Number(object.scannerClose);
      if (object.scannerChange != null) message.scannerChange = Number(object.scannerChange);
      if (object.scannerChangePercent != null) message.scannerChangePercent = Number(object.scannerChangePercent);
      if (object.scannerChangePercentClose != null)
        message.scannerChangePercentClose = Number(object.scannerChangePercentClose);
      if (object.scannerPreviousClose != null) message.scannerPreviousClose = Number(object.scannerPreviousClose);
      if (object.freeCashFlow != null) message.freeCashFlow = Number(object.freeCashFlow);
      if (object.minPriceTarget != null) message.minPriceTarget = Number(object.minPriceTarget);
      if (object.maxPriceTarget != null) message.maxPriceTarget = Number(object.maxPriceTarget);
      if (object.meanPriceTarget != null) message.meanPriceTarget = Number(object.meanPriceTarget);
      if (object.totalNumberOfAnalyst != null) message.totalNumberOfAnalyst = Number(object.totalNumberOfAnalyst);
      if (object.averageAnalystRecommendation != null)
        message.averageAnalystRecommendation = String(object.averageAnalystRecommendation);
      if (object.pegRatio != null) message.pegRatio = Number(object.pegRatio);
      if (object.priceToFreeCashFlowRatio != null)
        message.priceToFreeCashFlowRatio = Number(object.priceToFreeCashFlowRatio);
      if (object.distanceToMaxPriceTarget != null)
        message.distanceToMaxPriceTarget = Number(object.distanceToMaxPriceTarget);
      if (object.distanceToMinPriceTarget != null)
        message.distanceToMinPriceTarget = Number(object.distanceToMinPriceTarget);
      if (object.distanceToMeanPriceTarget != null)
        message.distanceToMeanPriceTarget = Number(object.distanceToMeanPriceTarget);
      if (object.shortTermTrend != null) message.shortTermTrend = String(object.shortTermTrend);
      if (object.mediumTermTrend != null) message.mediumTermTrend = String(object.mediumTermTrend);
      if (object.longTermTrend != null) message.longTermTrend = String(object.longTermTrend);
      return message;
    };

    /**
     * Creates a plain object from a Quote message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LastProtos.Quote
     * @static
     * @param {LastProtos.Quote} message Quote
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Quote.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.clearFieldNumbers = [];
      if (options.defaults) {
        object.symbol = '';
        object.previousClose = 0;
        object.close = 0;
        object.change = 0;
        object.changePercent = 0;
        object.name = '';
        object.ipoDate = '';
        object.exchange = '';
        object.tradeExchange = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.marketCap =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.marketCap = options.longs === String ? '0' : 0;
        object.rsi = 0;
        object.atr = 0;
        object.priceToEarnings = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.averageVolume =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.averageVolume = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sharesOutstanding =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.sharesOutstanding = options.longs === String ? '0' : 0;
        object.sector = '';
        object.sectorCode = 0;
        object.industry = '';
        object.industryCode = 0;
        object.forwardPERatio = 0;
        object.pricetoEBITDA = 0;
        object.trailingDividendYield = 0;
        object.PBRatio = 0;
        object.priceToSales = 0;
        object.FCFPerShare = 0;
        object.buyBackYield = 0;
        object.open = 0;
        object.price = 0;
        object.high = 0;
        object.low = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.time = options.longs === String ? '0' : 0;
        object.size = 0;
        object.type = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dayVolume =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.dayVolume = options.longs === String ? '0' : 0;
        object.askPrice = 0;
        object.bidPrice = 0;
        object.shareFloatDate = '';
        object.sharesOutstandingDate = '';
        object.cik = 0;
        object.updateType = options.enums === String ? 'UNKNOWN' : 0;
        object.sessionType = options.enums === String ? 'NA' : 0;
        object.changePercent1Minute = 0;
        object.changePercentClose = 0;
        object.changePercent5Minute = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.volume1Minute =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.volume1Minute = options.longs === String ? '0' : 0;
        object.relativeVolume1Minute = 0;
        object.change15Minute = 0;
        object.changePercent15Minute = 0;
        object.change30Minute = 0;
        object.changePercent30Minute = 0;
        object.change60Minute = 0;
        object.changePercent60Minute = 0;
        object.changePercentOpen = 0;
        object.changeOpen = 0;
        object.gics = 0;
        object.gicsSector = 0;
        object.gicsSectorName = '';
        object.gicsIndustryGroup = 0;
        object.gicsIndustryGroupName = '';
        object.gicsIndustry = 0;
        object.gicsIndustryName = '';
        object.gicsSubIndustry = 0;
        object.gicsSubIndustryName = '';
        object.optionable = 0;
        object.signalName = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.shareFloat =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.shareFloat = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.lastTradeTime =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.lastTradeTime = options.longs === String ? '0' : 0;
        object.country = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.volume =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.volume = options.longs === String ? '0' : 0;
        object.opol = '';
        object.subtype = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sharesShort =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.sharesShort = options.longs === String ? '0' : 0;
        object.sharesShortPercentOfFloat = 0;
        object.sharesShortChangePercent = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sharesShortReceiptDate =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.sharesShortReceiptDate = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sharesShortSettlementDate =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.sharesShortSettlementDate = options.longs === String ? '0' : 0;
        object.shortInterestRatio = 0;
        object.sharesShortValue = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sharesShortPrevious =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.sharesShortPrevious = options.longs === String ? '0' : 0;
        object.sharesShortPreviousValue = 0;
        object.sharesShortPreviousPercentOfFloat = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sharesShortChange =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.sharesShortChange = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.sentTime =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.sentTime = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.volume5Minute =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.volume5Minute = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.volume15Minute =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.volume15Minute = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.volume30Minute =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.volume30Minute = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.volume60Minute =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.volume60Minute = options.longs === String ? '0' : 0;
        object.relativeVolume5Minute = 0;
        object.relativeVolume90Day = 0;
        object.rvol1m10d = 0;
        object.rvol5m10d = 0;
        object.rvol5m30d = 0;
        object.rvol5m90d = 0;
        object.nextEarningsDate = 0;
        object.dividend = 0;
        object.dividendYield = 0;
        object.dividendExDate = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dividendFrequency =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.dividendFrequency = options.longs === String ? '0' : 0;
        object.forwardDividendYield = 0;
        object.roe = 0;
        object.roa = 0;
        object.roic = 0;
        object.currentRatio = 0;
        object.grossMargin = 0;
        object.netMargin = 0;
        object.operationMargin = 0;
        object.epsMrq = 0;
        object.epsTtm = 0;
        object.dilutedEpsMrq = 0;
        object.dilutedEpsTtm = 0;
        object.low52Week = 0;
        object.high52Week = 0;
        object.revenueTtm = 0;
        object.earningsAsOf = 0;
        object.netProfitMargin = 0;
        object.roeMrq = 0;
        object.roaMrq = 0;
        object.roicMrq = 0;
        object.currentRatioMrq = 0;
        object.grossMarginMrq = 0;
        object.netMarginMrq = 0;
        object.operationMarginMrq = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.previousDayVolume =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.previousDayVolume = options.longs === String ? '0' : 0;
        object.previousDayAtr = 0;
        object.previousDayAdx = 0;
        object.previousDayPlusDMSmoothed = 0;
        object.previousDayMinusDMSmoothed = 0;
        object.previousDayHigh = 0;
        object.previousDayLow = 0;
        object.adx = 0;
        object.percentInstitutionalOwnership = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.averageVolume10Day =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.averageVolume10Day = options.longs === String ? '0' : 0;
        object.averageVolumeChangePercent10Day = 0;
        object.high10Day = 0;
        object.highChangePercent10Day = 0;
        object.low10Day = 0;
        object.lowChangePercent10Day = 0;
        object.movingAverage10Day = 0;
        object.movingAverageChangePercent10Day = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.averageVolume20Day =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.averageVolume20Day = options.longs === String ? '0' : 0;
        object.averageVolumeChangePercent20Day = 0;
        object.high20Day = 0;
        object.highChangePercent20Day = 0;
        object.low20Day = 0;
        object.lowChangePercent20Day = 0;
        object.movingAverage20Day = 0;
        object.movingAverageChangePercent20Day = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.averageVolume50Day =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.averageVolume50Day = options.longs === String ? '0' : 0;
        object.averageVolumeChangePercent50Day = 0;
        object.high50Day = 0;
        object.highChangePercent50Day = 0;
        object.low50Day = 0;
        object.lowChangePercent50Day = 0;
        object.movingAverage50Day = 0;
        object.movingAverageChangePercent50Day = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.averageVolume100Day =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.averageVolume100Day = options.longs === String ? '0' : 0;
        object.averageVolumeChangePercent100Day = 0;
        object.high100Day = 0;
        object.highChangePercent100Day = 0;
        object.low100Day = 0;
        object.lowChangePercent100Day = 0;
        object.movingAverage100Day = 0;
        object.movingAverageChangePercent100Day = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.averageVolume200Day =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.averageVolume200Day = options.longs === String ? '0' : 0;
        object.averageVolumeChangePercent200Day = 0;
        object.high200Day = 0;
        object.highChangePercent200Day = 0;
        object.low200Day = 0;
        object.lowChangePercent200Day = 0;
        object.movingAverage200Day = 0;
        object.movingAverageChangePercent200Day = 0;
        object.movingAverage250Day = 0;
        object.movingAverageChangePercent250Day = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.averageVolume90Day =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.averageVolume90Day = options.longs === String ? '0' : 0;
        object.lowAllTime = 0;
        object.highAllTime = 0;
        object.quickRatioMrq = 0;
        object.ffoPerShare = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.ipoDateNumber =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.ipoDateNumber = options.longs === String ? '0' : 0;
        object.ltDebtEquity = 0;
        object.epsGrowthYearAgoQ = 0;
        object.revenueGrowthYearAgoQ = 0;
        object.revenueGrowth5Year = 0;
        object.revenueGrowthQ2Q = 0;
        object.revenueGrowthY2Y = 0;
        object.revenueGrowthTtm = 0;
        object.epsGrowth5Year = 0;
        object.epsGrowthQ2Q = 0;
        object.epsGrowthY2Y = 0;
        object.epsGrowthTtm = 0;
        object.dilutedRevenueTtmSurprisePercent = 0;
        object.dilutedRevenueMrqSurprisePercent = 0;
        object.dilutedEpsTtmSurprisePercent = 0;
        object.dilutedEpsMrqSurprisePercent = 0;
        object.adr14d = 0;
        object.gapChangePercent = 0;
        object.gapChange = 0;
        object.movingAverage500Day = 0;
        object.dividendGrowthRate5Year = 0;
        object.dividendGrowthRate3Year = 0;
        object.dividendGrowthRate1Year = 0;
        object.newsBzWireTitle = '';
        object.newsBzWireNodeId = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.newsBzWireTimestamp =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.newsBzWireTimestamp = options.longs === String ? '0' : 0;
        object.newsPRTitle = '';
        object.newsPRNodeId = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.newsPRTimestamp =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.newsPRTimestamp = options.longs === String ? '0' : 0;
        object.newsSecTitle = '';
        object.newsSecNodeId = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.newsSecTimestamp =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.newsSecTimestamp = options.longs === String ? '0' : 0;
        object.mtdChange = 0;
        object.ytdChange = 0;
        object.macdSignalLineBase = 0;
        object.macdHistogram = 0;
        object.macdSignalLine = 0;
        object.macd = 0;
        object.wiim = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.wiimAsOf =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.wiimAsOf = options.longs === String ? '0' : 0;
        object.vwap = 0;
        object.vwapChangePercent = 0;
        object.vwapChange = 0;
        object.rsiAvgGain = 0;
        object.rsiAvgLoss = 0;
        object.halted = '';
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.tradeCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.tradeCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.regularHighCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.regularHighCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.regularLowCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.regularLowCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.preMarketHighCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.preMarketHighCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.preMarketLowCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.preMarketLowCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.afterMarketHighCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.afterMarketHighCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.afterMarketLowCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.afterMarketLowCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dayHighCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.dayHighCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.dayLowCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.dayLowCount = options.longs === String ? '0' : 0;
        object.ema12d = 0;
        object.ema26d = 0;
        object.dayHigh = 0;
        object.dayLow = 0;
        object.preMarketHigh = 0;
        object.preMarketLow = 0;
        object.afterMarketHigh = 0;
        object.afterMarketLow = 0;
        object.regularHigh = 0;
        object.regularLow = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.priceSpikeUpCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.priceSpikeUpCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.priceSpikeDownCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.priceSpikeDownCount = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.haltedCount =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.haltedCount = options.longs === String ? '0' : 0;
        object.usCongressTotal = 0;
        object.usCongressRepublicansTotal = 0;
        object.usCongressDemocratsTotal = 0;
        object.usCongressOtherTotal = 0;
        object.volumeFloatRatio = 0;
        object.atrp = 0;
        object.ytdGainLoss = 0;
        object.mtdGainLoss = 0;
        object.yearOpen = 0;
        object.rsi1m = 0;
        object.rsi2m = 0;
        object.rsi5m = 0;
        object.rsi15m = 0;
        object.rsi30m = 0;
        object.rsi60m = 0;
        object.rsiEth1m = 0;
        object.rsiEth2m = 0;
        object.rsiEth5m = 0;
        object.rsiEth15m = 0;
        object.rsiEth30m = 0;
        object.rsiEth60m = 0;
        object.monthOpen = 0;
        object.volumeFloatPercent = 0;
        object.averageDollarVolume10Day = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.averageVolume60Day =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.averageVolume60Day = options.longs === String ? '0' : 0;
        object.relativeVolumePercent60Day = 0;
        object.price1Week = 0;
        object.priceChangePercent1Week = 0;
        object.price1Month = 0;
        object.priceChangePercent1Month = 0;
        object.priceHalfYear = 0;
        object.priceChangePercentHalfYear = 0;
        object.priceQuarter = 0;
        object.priceChangePercentQuarter = 0;
        object.price1Year = 0;
        object.priceChangePercent1Year = 0;
        object.priceYearToDate = 0;
        object.priceChangePercentYearToDate = 0;
        object.bullsSay = '';
        object.bearsSay = '';
        object.preMarketOpen = 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.preMarketOpenTime =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.preMarketOpenTime = options.longs === String ? '0' : 0;
        if ($util.Long) {
          let long = new $util.Long(0, 0, false);
          object.preMarketVolume =
            options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
        } else object.preMarketVolume = options.longs === String ? '0' : 0;
        object.preMarketOpenChange = 0;
        object.preMarketOpenChangePercent = 0;
        object.source = options.enums === String ? 'UNKNOWN_SOURCE' : 0;
        object.totalDebtEquityRatio = 0;
        object.dividendPayoutRatio = 0;
        object.operatingCashFlowPerShare = 0;
        object.insiderPercentage = 0;
        object.priceToCashFlowRatio = 0;
        object.regularHoursChange = 0;
        object.regularHoursPercentChange = 0;
        object.postToPreHoursChange = 0;
        object.postToPreHoursPercentChange = 0;
        object.scannerClose = 0;
        object.scannerChange = 0;
        object.scannerChangePercent = 0;
        object.scannerChangePercentClose = 0;
        object.scannerPreviousClose = 0;
        object.freeCashFlow = 0;
        object.minPriceTarget = 0;
        object.maxPriceTarget = 0;
        object.meanPriceTarget = 0;
        object.totalNumberOfAnalyst = 0;
        object.averageAnalystRecommendation = '';
        object.pegRatio = 0;
        object.priceToFreeCashFlowRatio = 0;
        object.distanceToMaxPriceTarget = 0;
        object.distanceToMinPriceTarget = 0;
        object.distanceToMeanPriceTarget = 0;
        object.shortTermTrend = '';
        object.mediumTermTrend = '';
        object.longTermTrend = '';
      }
      if (message.symbol != null && message.hasOwnProperty('symbol')) object.symbol = message.symbol;
      if (message.previousClose != null && message.hasOwnProperty('previousClose'))
        object.previousClose =
          options.json && !isFinite(message.previousClose) ? String(message.previousClose) : message.previousClose;
      if (message.close != null && message.hasOwnProperty('close'))
        object.close = options.json && !isFinite(message.close) ? String(message.close) : message.close;
      if (message.change != null && message.hasOwnProperty('change'))
        object.change = options.json && !isFinite(message.change) ? String(message.change) : message.change;
      if (message.changePercent != null && message.hasOwnProperty('changePercent'))
        object.changePercent =
          options.json && !isFinite(message.changePercent) ? String(message.changePercent) : message.changePercent;
      if (message.name != null && message.hasOwnProperty('name')) object.name = message.name;
      if (message.ipoDate != null && message.hasOwnProperty('ipoDate')) object.ipoDate = message.ipoDate;
      if (message.exchange != null && message.hasOwnProperty('exchange')) object.exchange = message.exchange;
      if (message.tradeExchange != null && message.hasOwnProperty('tradeExchange'))
        object.tradeExchange = message.tradeExchange;
      if (message.marketCap != null && message.hasOwnProperty('marketCap'))
        if (typeof message.marketCap === 'number')
          object.marketCap = options.longs === String ? String(message.marketCap) : message.marketCap;
        else
          object.marketCap =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.marketCap)
              : options.longs === Number
                ? new $util.LongBits(message.marketCap.low >>> 0, message.marketCap.high >>> 0).toNumber()
                : message.marketCap;
      if (message.rsi != null && message.hasOwnProperty('rsi'))
        object.rsi = options.json && !isFinite(message.rsi) ? String(message.rsi) : message.rsi;
      if (message.atr != null && message.hasOwnProperty('atr'))
        object.atr = options.json && !isFinite(message.atr) ? String(message.atr) : message.atr;
      if (message.priceToEarnings != null && message.hasOwnProperty('priceToEarnings'))
        object.priceToEarnings =
          options.json && !isFinite(message.priceToEarnings)
            ? String(message.priceToEarnings)
            : message.priceToEarnings;
      if (message.averageVolume != null && message.hasOwnProperty('averageVolume'))
        if (typeof message.averageVolume === 'number')
          object.averageVolume = options.longs === String ? String(message.averageVolume) : message.averageVolume;
        else
          object.averageVolume =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.averageVolume)
              : options.longs === Number
                ? new $util.LongBits(message.averageVolume.low >>> 0, message.averageVolume.high >>> 0).toNumber()
                : message.averageVolume;
      if (message.sharesOutstanding != null && message.hasOwnProperty('sharesOutstanding'))
        if (typeof message.sharesOutstanding === 'number')
          object.sharesOutstanding =
            options.longs === String ? String(message.sharesOutstanding) : message.sharesOutstanding;
        else
          object.sharesOutstanding =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sharesOutstanding)
              : options.longs === Number
                ? new $util.LongBits(
                    message.sharesOutstanding.low >>> 0,
                    message.sharesOutstanding.high >>> 0,
                  ).toNumber()
                : message.sharesOutstanding;
      if (message.sector != null && message.hasOwnProperty('sector')) object.sector = message.sector;
      if (message.sectorCode != null && message.hasOwnProperty('sectorCode')) object.sectorCode = message.sectorCode;
      if (message.industry != null && message.hasOwnProperty('industry')) object.industry = message.industry;
      if (message.industryCode != null && message.hasOwnProperty('industryCode'))
        object.industryCode = message.industryCode;
      if (message.forwardPERatio != null && message.hasOwnProperty('forwardPERatio'))
        object.forwardPERatio =
          options.json && !isFinite(message.forwardPERatio) ? String(message.forwardPERatio) : message.forwardPERatio;
      if (message.pricetoEBITDA != null && message.hasOwnProperty('pricetoEBITDA'))
        object.pricetoEBITDA =
          options.json && !isFinite(message.pricetoEBITDA) ? String(message.pricetoEBITDA) : message.pricetoEBITDA;
      if (message.trailingDividendYield != null && message.hasOwnProperty('trailingDividendYield'))
        object.trailingDividendYield =
          options.json && !isFinite(message.trailingDividendYield)
            ? String(message.trailingDividendYield)
            : message.trailingDividendYield;
      if (message.PBRatio != null && message.hasOwnProperty('PBRatio'))
        object.PBRatio = options.json && !isFinite(message.PBRatio) ? String(message.PBRatio) : message.PBRatio;
      if (message.priceToSales != null && message.hasOwnProperty('priceToSales'))
        object.priceToSales =
          options.json && !isFinite(message.priceToSales) ? String(message.priceToSales) : message.priceToSales;
      if (message.FCFPerShare != null && message.hasOwnProperty('FCFPerShare'))
        object.FCFPerShare =
          options.json && !isFinite(message.FCFPerShare) ? String(message.FCFPerShare) : message.FCFPerShare;
      if (message.buyBackYield != null && message.hasOwnProperty('buyBackYield'))
        object.buyBackYield =
          options.json && !isFinite(message.buyBackYield) ? String(message.buyBackYield) : message.buyBackYield;
      if (message.open != null && message.hasOwnProperty('open'))
        object.open = options.json && !isFinite(message.open) ? String(message.open) : message.open;
      if (message.price != null && message.hasOwnProperty('price'))
        object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
      if (message.high != null && message.hasOwnProperty('high'))
        object.high = options.json && !isFinite(message.high) ? String(message.high) : message.high;
      if (message.low != null && message.hasOwnProperty('low'))
        object.low = options.json && !isFinite(message.low) ? String(message.low) : message.low;
      if (message.time != null && message.hasOwnProperty('time'))
        if (typeof message.time === 'number')
          object.time = options.longs === String ? String(message.time) : message.time;
        else
          object.time =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.time)
              : options.longs === Number
                ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber()
                : message.time;
      if (message.size != null && message.hasOwnProperty('size')) object.size = message.size;
      if (message.type != null && message.hasOwnProperty('type')) object.type = message.type;
      if (message.dayVolume != null && message.hasOwnProperty('dayVolume'))
        if (typeof message.dayVolume === 'number')
          object.dayVolume = options.longs === String ? String(message.dayVolume) : message.dayVolume;
        else
          object.dayVolume =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.dayVolume)
              : options.longs === Number
                ? new $util.LongBits(message.dayVolume.low >>> 0, message.dayVolume.high >>> 0).toNumber()
                : message.dayVolume;
      if (message.askPrice != null && message.hasOwnProperty('askPrice'))
        object.askPrice = options.json && !isFinite(message.askPrice) ? String(message.askPrice) : message.askPrice;
      if (message.bidPrice != null && message.hasOwnProperty('bidPrice'))
        object.bidPrice = options.json && !isFinite(message.bidPrice) ? String(message.bidPrice) : message.bidPrice;
      if (message.shareFloatDate != null && message.hasOwnProperty('shareFloatDate'))
        object.shareFloatDate = message.shareFloatDate;
      if (message.sharesOutstandingDate != null && message.hasOwnProperty('sharesOutstandingDate'))
        object.sharesOutstandingDate = message.sharesOutstandingDate;
      if (message.cik != null && message.hasOwnProperty('cik')) object.cik = message.cik;
      if (message.updateType != null && message.hasOwnProperty('updateType'))
        object.updateType =
          options.enums === String
            ? $root.LastProtos.TickType[message.updateType] === undefined
              ? message.updateType
              : $root.LastProtos.TickType[message.updateType]
            : message.updateType;
      if (message.sessionType != null && message.hasOwnProperty('sessionType'))
        object.sessionType =
          options.enums === String
            ? $root.LastProtos.SessionType[message.sessionType] === undefined
              ? message.sessionType
              : $root.LastProtos.SessionType[message.sessionType]
            : message.sessionType;
      if (message.changePercent1Minute != null && message.hasOwnProperty('changePercent1Minute'))
        object.changePercent1Minute =
          options.json && !isFinite(message.changePercent1Minute)
            ? String(message.changePercent1Minute)
            : message.changePercent1Minute;
      if (message.changePercentClose != null && message.hasOwnProperty('changePercentClose'))
        object.changePercentClose =
          options.json && !isFinite(message.changePercentClose)
            ? String(message.changePercentClose)
            : message.changePercentClose;
      if (message.changePercent5Minute != null && message.hasOwnProperty('changePercent5Minute'))
        object.changePercent5Minute =
          options.json && !isFinite(message.changePercent5Minute)
            ? String(message.changePercent5Minute)
            : message.changePercent5Minute;
      if (message.volume1Minute != null && message.hasOwnProperty('volume1Minute'))
        if (typeof message.volume1Minute === 'number')
          object.volume1Minute = options.longs === String ? String(message.volume1Minute) : message.volume1Minute;
        else
          object.volume1Minute =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.volume1Minute)
              : options.longs === Number
                ? new $util.LongBits(message.volume1Minute.low >>> 0, message.volume1Minute.high >>> 0).toNumber()
                : message.volume1Minute;
      if (message.relativeVolume1Minute != null && message.hasOwnProperty('relativeVolume1Minute'))
        object.relativeVolume1Minute =
          options.json && !isFinite(message.relativeVolume1Minute)
            ? String(message.relativeVolume1Minute)
            : message.relativeVolume1Minute;
      if (message.change15Minute != null && message.hasOwnProperty('change15Minute'))
        object.change15Minute =
          options.json && !isFinite(message.change15Minute) ? String(message.change15Minute) : message.change15Minute;
      if (message.changePercent15Minute != null && message.hasOwnProperty('changePercent15Minute'))
        object.changePercent15Minute =
          options.json && !isFinite(message.changePercent15Minute)
            ? String(message.changePercent15Minute)
            : message.changePercent15Minute;
      if (message.change30Minute != null && message.hasOwnProperty('change30Minute'))
        object.change30Minute =
          options.json && !isFinite(message.change30Minute) ? String(message.change30Minute) : message.change30Minute;
      if (message.changePercent30Minute != null && message.hasOwnProperty('changePercent30Minute'))
        object.changePercent30Minute =
          options.json && !isFinite(message.changePercent30Minute)
            ? String(message.changePercent30Minute)
            : message.changePercent30Minute;
      if (message.change60Minute != null && message.hasOwnProperty('change60Minute'))
        object.change60Minute =
          options.json && !isFinite(message.change60Minute) ? String(message.change60Minute) : message.change60Minute;
      if (message.changePercent60Minute != null && message.hasOwnProperty('changePercent60Minute'))
        object.changePercent60Minute =
          options.json && !isFinite(message.changePercent60Minute)
            ? String(message.changePercent60Minute)
            : message.changePercent60Minute;
      if (message.changePercentOpen != null && message.hasOwnProperty('changePercentOpen'))
        object.changePercentOpen =
          options.json && !isFinite(message.changePercentOpen)
            ? String(message.changePercentOpen)
            : message.changePercentOpen;
      if (message.changeOpen != null && message.hasOwnProperty('changeOpen'))
        object.changeOpen =
          options.json && !isFinite(message.changeOpen) ? String(message.changeOpen) : message.changeOpen;
      if (message.gics != null && message.hasOwnProperty('gics')) object.gics = message.gics;
      if (message.gicsSector != null && message.hasOwnProperty('gicsSector')) object.gicsSector = message.gicsSector;
      if (message.gicsSectorName != null && message.hasOwnProperty('gicsSectorName'))
        object.gicsSectorName = message.gicsSectorName;
      if (message.gicsIndustryGroup != null && message.hasOwnProperty('gicsIndustryGroup'))
        object.gicsIndustryGroup = message.gicsIndustryGroup;
      if (message.gicsIndustryGroupName != null && message.hasOwnProperty('gicsIndustryGroupName'))
        object.gicsIndustryGroupName = message.gicsIndustryGroupName;
      if (message.gicsIndustry != null && message.hasOwnProperty('gicsIndustry'))
        object.gicsIndustry = message.gicsIndustry;
      if (message.gicsIndustryName != null && message.hasOwnProperty('gicsIndustryName'))
        object.gicsIndustryName = message.gicsIndustryName;
      if (message.gicsSubIndustry != null && message.hasOwnProperty('gicsSubIndustry'))
        object.gicsSubIndustry = message.gicsSubIndustry;
      if (message.gicsSubIndustryName != null && message.hasOwnProperty('gicsSubIndustryName'))
        object.gicsSubIndustryName = message.gicsSubIndustryName;
      if (message.optionable != null && message.hasOwnProperty('optionable')) object.optionable = message.optionable;
      if (message.signalName != null && message.hasOwnProperty('signalName')) object.signalName = message.signalName;
      if (message.shareFloat != null && message.hasOwnProperty('shareFloat'))
        if (typeof message.shareFloat === 'number')
          object.shareFloat = options.longs === String ? String(message.shareFloat) : message.shareFloat;
        else
          object.shareFloat =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.shareFloat)
              : options.longs === Number
                ? new $util.LongBits(message.shareFloat.low >>> 0, message.shareFloat.high >>> 0).toNumber()
                : message.shareFloat;
      if (message.lastTradeTime != null && message.hasOwnProperty('lastTradeTime'))
        if (typeof message.lastTradeTime === 'number')
          object.lastTradeTime = options.longs === String ? String(message.lastTradeTime) : message.lastTradeTime;
        else
          object.lastTradeTime =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.lastTradeTime)
              : options.longs === Number
                ? new $util.LongBits(message.lastTradeTime.low >>> 0, message.lastTradeTime.high >>> 0).toNumber()
                : message.lastTradeTime;
      if (message.country != null && message.hasOwnProperty('country')) object.country = message.country;
      if (message.volume != null && message.hasOwnProperty('volume'))
        if (typeof message.volume === 'number')
          object.volume = options.longs === String ? String(message.volume) : message.volume;
        else
          object.volume =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.volume)
              : options.longs === Number
                ? new $util.LongBits(message.volume.low >>> 0, message.volume.high >>> 0).toNumber()
                : message.volume;
      if (message.opol != null && message.hasOwnProperty('opol')) object.opol = message.opol;
      if (message.subtype != null && message.hasOwnProperty('subtype')) object.subtype = message.subtype;
      if (message.sharesShort != null && message.hasOwnProperty('sharesShort'))
        if (typeof message.sharesShort === 'number')
          object.sharesShort = options.longs === String ? String(message.sharesShort) : message.sharesShort;
        else
          object.sharesShort =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sharesShort)
              : options.longs === Number
                ? new $util.LongBits(message.sharesShort.low >>> 0, message.sharesShort.high >>> 0).toNumber()
                : message.sharesShort;
      if (message.sharesShortPercentOfFloat != null && message.hasOwnProperty('sharesShortPercentOfFloat'))
        object.sharesShortPercentOfFloat =
          options.json && !isFinite(message.sharesShortPercentOfFloat)
            ? String(message.sharesShortPercentOfFloat)
            : message.sharesShortPercentOfFloat;
      if (message.sharesShortChangePercent != null && message.hasOwnProperty('sharesShortChangePercent'))
        object.sharesShortChangePercent =
          options.json && !isFinite(message.sharesShortChangePercent)
            ? String(message.sharesShortChangePercent)
            : message.sharesShortChangePercent;
      if (message.sharesShortReceiptDate != null && message.hasOwnProperty('sharesShortReceiptDate'))
        if (typeof message.sharesShortReceiptDate === 'number')
          object.sharesShortReceiptDate =
            options.longs === String ? String(message.sharesShortReceiptDate) : message.sharesShortReceiptDate;
        else
          object.sharesShortReceiptDate =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sharesShortReceiptDate)
              : options.longs === Number
                ? new $util.LongBits(
                    message.sharesShortReceiptDate.low >>> 0,
                    message.sharesShortReceiptDate.high >>> 0,
                  ).toNumber()
                : message.sharesShortReceiptDate;
      if (message.sharesShortSettlementDate != null && message.hasOwnProperty('sharesShortSettlementDate'))
        if (typeof message.sharesShortSettlementDate === 'number')
          object.sharesShortSettlementDate =
            options.longs === String ? String(message.sharesShortSettlementDate) : message.sharesShortSettlementDate;
        else
          object.sharesShortSettlementDate =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sharesShortSettlementDate)
              : options.longs === Number
                ? new $util.LongBits(
                    message.sharesShortSettlementDate.low >>> 0,
                    message.sharesShortSettlementDate.high >>> 0,
                  ).toNumber()
                : message.sharesShortSettlementDate;
      if (message.shortInterestRatio != null && message.hasOwnProperty('shortInterestRatio'))
        object.shortInterestRatio =
          options.json && !isFinite(message.shortInterestRatio)
            ? String(message.shortInterestRatio)
            : message.shortInterestRatio;
      if (message.sharesShortValue != null && message.hasOwnProperty('sharesShortValue'))
        object.sharesShortValue =
          options.json && !isFinite(message.sharesShortValue)
            ? String(message.sharesShortValue)
            : message.sharesShortValue;
      if (message.sharesShortPrevious != null && message.hasOwnProperty('sharesShortPrevious'))
        if (typeof message.sharesShortPrevious === 'number')
          object.sharesShortPrevious =
            options.longs === String ? String(message.sharesShortPrevious) : message.sharesShortPrevious;
        else
          object.sharesShortPrevious =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sharesShortPrevious)
              : options.longs === Number
                ? new $util.LongBits(
                    message.sharesShortPrevious.low >>> 0,
                    message.sharesShortPrevious.high >>> 0,
                  ).toNumber()
                : message.sharesShortPrevious;
      if (message.sharesShortPreviousValue != null && message.hasOwnProperty('sharesShortPreviousValue'))
        object.sharesShortPreviousValue =
          options.json && !isFinite(message.sharesShortPreviousValue)
            ? String(message.sharesShortPreviousValue)
            : message.sharesShortPreviousValue;
      if (
        message.sharesShortPreviousPercentOfFloat != null &&
        message.hasOwnProperty('sharesShortPreviousPercentOfFloat')
      )
        object.sharesShortPreviousPercentOfFloat =
          options.json && !isFinite(message.sharesShortPreviousPercentOfFloat)
            ? String(message.sharesShortPreviousPercentOfFloat)
            : message.sharesShortPreviousPercentOfFloat;
      if (message.sharesShortChange != null && message.hasOwnProperty('sharesShortChange'))
        if (typeof message.sharesShortChange === 'number')
          object.sharesShortChange =
            options.longs === String ? String(message.sharesShortChange) : message.sharesShortChange;
        else
          object.sharesShortChange =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sharesShortChange)
              : options.longs === Number
                ? new $util.LongBits(
                    message.sharesShortChange.low >>> 0,
                    message.sharesShortChange.high >>> 0,
                  ).toNumber()
                : message.sharesShortChange;
      if (message.sentTime != null && message.hasOwnProperty('sentTime'))
        if (typeof message.sentTime === 'number')
          object.sentTime = options.longs === String ? String(message.sentTime) : message.sentTime;
        else
          object.sentTime =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.sentTime)
              : options.longs === Number
                ? new $util.LongBits(message.sentTime.low >>> 0, message.sentTime.high >>> 0).toNumber()
                : message.sentTime;
      if (message.volume5Minute != null && message.hasOwnProperty('volume5Minute'))
        if (typeof message.volume5Minute === 'number')
          object.volume5Minute = options.longs === String ? String(message.volume5Minute) : message.volume5Minute;
        else
          object.volume5Minute =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.volume5Minute)
              : options.longs === Number
                ? new $util.LongBits(message.volume5Minute.low >>> 0, message.volume5Minute.high >>> 0).toNumber()
                : message.volume5Minute;
      if (message.volume15Minute != null && message.hasOwnProperty('volume15Minute'))
        if (typeof message.volume15Minute === 'number')
          object.volume15Minute = options.longs === String ? String(message.volume15Minute) : message.volume15Minute;
        else
          object.volume15Minute =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.volume15Minute)
              : options.longs === Number
                ? new $util.LongBits(message.volume15Minute.low >>> 0, message.volume15Minute.high >>> 0).toNumber()
                : message.volume15Minute;
      if (message.volume30Minute != null && message.hasOwnProperty('volume30Minute'))
        if (typeof message.volume30Minute === 'number')
          object.volume30Minute = options.longs === String ? String(message.volume30Minute) : message.volume30Minute;
        else
          object.volume30Minute =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.volume30Minute)
              : options.longs === Number
                ? new $util.LongBits(message.volume30Minute.low >>> 0, message.volume30Minute.high >>> 0).toNumber()
                : message.volume30Minute;
      if (message.volume60Minute != null && message.hasOwnProperty('volume60Minute'))
        if (typeof message.volume60Minute === 'number')
          object.volume60Minute = options.longs === String ? String(message.volume60Minute) : message.volume60Minute;
        else
          object.volume60Minute =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.volume60Minute)
              : options.longs === Number
                ? new $util.LongBits(message.volume60Minute.low >>> 0, message.volume60Minute.high >>> 0).toNumber()
                : message.volume60Minute;
      if (message.relativeVolume5Minute != null && message.hasOwnProperty('relativeVolume5Minute'))
        object.relativeVolume5Minute =
          options.json && !isFinite(message.relativeVolume5Minute)
            ? String(message.relativeVolume5Minute)
            : message.relativeVolume5Minute;
      if (message.relativeVolume90Day != null && message.hasOwnProperty('relativeVolume90Day'))
        object.relativeVolume90Day =
          options.json && !isFinite(message.relativeVolume90Day)
            ? String(message.relativeVolume90Day)
            : message.relativeVolume90Day;
      if (message.rvol1m10d != null && message.hasOwnProperty('rvol1m10d'))
        object.rvol1m10d = options.json && !isFinite(message.rvol1m10d) ? String(message.rvol1m10d) : message.rvol1m10d;
      if (message.rvol5m10d != null && message.hasOwnProperty('rvol5m10d'))
        object.rvol5m10d = options.json && !isFinite(message.rvol5m10d) ? String(message.rvol5m10d) : message.rvol5m10d;
      if (message.rvol5m30d != null && message.hasOwnProperty('rvol5m30d'))
        object.rvol5m30d = options.json && !isFinite(message.rvol5m30d) ? String(message.rvol5m30d) : message.rvol5m30d;
      if (message.rvol5m90d != null && message.hasOwnProperty('rvol5m90d'))
        object.rvol5m90d = options.json && !isFinite(message.rvol5m90d) ? String(message.rvol5m90d) : message.rvol5m90d;
      if (message.nextEarningsDate != null && message.hasOwnProperty('nextEarningsDate'))
        object.nextEarningsDate = message.nextEarningsDate;
      if (message.dividend != null && message.hasOwnProperty('dividend'))
        object.dividend = options.json && !isFinite(message.dividend) ? String(message.dividend) : message.dividend;
      if (message.dividendYield != null && message.hasOwnProperty('dividendYield'))
        object.dividendYield =
          options.json && !isFinite(message.dividendYield) ? String(message.dividendYield) : message.dividendYield;
      if (message.dividendExDate != null && message.hasOwnProperty('dividendExDate'))
        object.dividendExDate = message.dividendExDate;
      if (message.dividendFrequency != null && message.hasOwnProperty('dividendFrequency'))
        if (typeof message.dividendFrequency === 'number')
          object.dividendFrequency =
            options.longs === String ? String(message.dividendFrequency) : message.dividendFrequency;
        else
          object.dividendFrequency =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.dividendFrequency)
              : options.longs === Number
                ? new $util.LongBits(
                    message.dividendFrequency.low >>> 0,
                    message.dividendFrequency.high >>> 0,
                  ).toNumber()
                : message.dividendFrequency;
      if (message.forwardDividendYield != null && message.hasOwnProperty('forwardDividendYield'))
        object.forwardDividendYield =
          options.json && !isFinite(message.forwardDividendYield)
            ? String(message.forwardDividendYield)
            : message.forwardDividendYield;
      if (message.roe != null && message.hasOwnProperty('roe'))
        object.roe = options.json && !isFinite(message.roe) ? String(message.roe) : message.roe;
      if (message.roa != null && message.hasOwnProperty('roa'))
        object.roa = options.json && !isFinite(message.roa) ? String(message.roa) : message.roa;
      if (message.roic != null && message.hasOwnProperty('roic'))
        object.roic = options.json && !isFinite(message.roic) ? String(message.roic) : message.roic;
      if (message.currentRatio != null && message.hasOwnProperty('currentRatio'))
        object.currentRatio =
          options.json && !isFinite(message.currentRatio) ? String(message.currentRatio) : message.currentRatio;
      if (message.grossMargin != null && message.hasOwnProperty('grossMargin'))
        object.grossMargin =
          options.json && !isFinite(message.grossMargin) ? String(message.grossMargin) : message.grossMargin;
      if (message.netMargin != null && message.hasOwnProperty('netMargin'))
        object.netMargin = options.json && !isFinite(message.netMargin) ? String(message.netMargin) : message.netMargin;
      if (message.operationMargin != null && message.hasOwnProperty('operationMargin'))
        object.operationMargin =
          options.json && !isFinite(message.operationMargin)
            ? String(message.operationMargin)
            : message.operationMargin;
      if (message.epsMrq != null && message.hasOwnProperty('epsMrq'))
        object.epsMrq = options.json && !isFinite(message.epsMrq) ? String(message.epsMrq) : message.epsMrq;
      if (message.epsTtm != null && message.hasOwnProperty('epsTtm'))
        object.epsTtm = options.json && !isFinite(message.epsTtm) ? String(message.epsTtm) : message.epsTtm;
      if (message.dilutedEpsMrq != null && message.hasOwnProperty('dilutedEpsMrq'))
        object.dilutedEpsMrq =
          options.json && !isFinite(message.dilutedEpsMrq) ? String(message.dilutedEpsMrq) : message.dilutedEpsMrq;
      if (message.dilutedEpsTtm != null && message.hasOwnProperty('dilutedEpsTtm'))
        object.dilutedEpsTtm =
          options.json && !isFinite(message.dilutedEpsTtm) ? String(message.dilutedEpsTtm) : message.dilutedEpsTtm;
      if (message.low52Week != null && message.hasOwnProperty('low52Week'))
        object.low52Week = options.json && !isFinite(message.low52Week) ? String(message.low52Week) : message.low52Week;
      if (message.high52Week != null && message.hasOwnProperty('high52Week'))
        object.high52Week =
          options.json && !isFinite(message.high52Week) ? String(message.high52Week) : message.high52Week;
      if (message.revenueTtm != null && message.hasOwnProperty('revenueTtm'))
        object.revenueTtm =
          options.json && !isFinite(message.revenueTtm) ? String(message.revenueTtm) : message.revenueTtm;
      if (message.earningsAsOf != null && message.hasOwnProperty('earningsAsOf'))
        object.earningsAsOf = message.earningsAsOf;
      if (message.netProfitMargin != null && message.hasOwnProperty('netProfitMargin'))
        object.netProfitMargin =
          options.json && !isFinite(message.netProfitMargin)
            ? String(message.netProfitMargin)
            : message.netProfitMargin;
      if (message.roeMrq != null && message.hasOwnProperty('roeMrq'))
        object.roeMrq = options.json && !isFinite(message.roeMrq) ? String(message.roeMrq) : message.roeMrq;
      if (message.roaMrq != null && message.hasOwnProperty('roaMrq'))
        object.roaMrq = options.json && !isFinite(message.roaMrq) ? String(message.roaMrq) : message.roaMrq;
      if (message.roicMrq != null && message.hasOwnProperty('roicMrq'))
        object.roicMrq = options.json && !isFinite(message.roicMrq) ? String(message.roicMrq) : message.roicMrq;
      if (message.currentRatioMrq != null && message.hasOwnProperty('currentRatioMrq'))
        object.currentRatioMrq =
          options.json && !isFinite(message.currentRatioMrq)
            ? String(message.currentRatioMrq)
            : message.currentRatioMrq;
      if (message.grossMarginMrq != null && message.hasOwnProperty('grossMarginMrq'))
        object.grossMarginMrq =
          options.json && !isFinite(message.grossMarginMrq) ? String(message.grossMarginMrq) : message.grossMarginMrq;
      if (message.netMarginMrq != null && message.hasOwnProperty('netMarginMrq'))
        object.netMarginMrq =
          options.json && !isFinite(message.netMarginMrq) ? String(message.netMarginMrq) : message.netMarginMrq;
      if (message.operationMarginMrq != null && message.hasOwnProperty('operationMarginMrq'))
        object.operationMarginMrq =
          options.json && !isFinite(message.operationMarginMrq)
            ? String(message.operationMarginMrq)
            : message.operationMarginMrq;
      if (message.previousDayVolume != null && message.hasOwnProperty('previousDayVolume'))
        if (typeof message.previousDayVolume === 'number')
          object.previousDayVolume =
            options.longs === String ? String(message.previousDayVolume) : message.previousDayVolume;
        else
          object.previousDayVolume =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.previousDayVolume)
              : options.longs === Number
                ? new $util.LongBits(
                    message.previousDayVolume.low >>> 0,
                    message.previousDayVolume.high >>> 0,
                  ).toNumber()
                : message.previousDayVolume;
      if (message.previousDayAtr != null && message.hasOwnProperty('previousDayAtr'))
        object.previousDayAtr =
          options.json && !isFinite(message.previousDayAtr) ? String(message.previousDayAtr) : message.previousDayAtr;
      if (message.previousDayAdx != null && message.hasOwnProperty('previousDayAdx'))
        object.previousDayAdx =
          options.json && !isFinite(message.previousDayAdx) ? String(message.previousDayAdx) : message.previousDayAdx;
      if (message.previousDayPlusDMSmoothed != null && message.hasOwnProperty('previousDayPlusDMSmoothed'))
        object.previousDayPlusDMSmoothed =
          options.json && !isFinite(message.previousDayPlusDMSmoothed)
            ? String(message.previousDayPlusDMSmoothed)
            : message.previousDayPlusDMSmoothed;
      if (message.previousDayMinusDMSmoothed != null && message.hasOwnProperty('previousDayMinusDMSmoothed'))
        object.previousDayMinusDMSmoothed =
          options.json && !isFinite(message.previousDayMinusDMSmoothed)
            ? String(message.previousDayMinusDMSmoothed)
            : message.previousDayMinusDMSmoothed;
      if (message.previousDayHigh != null && message.hasOwnProperty('previousDayHigh'))
        object.previousDayHigh =
          options.json && !isFinite(message.previousDayHigh)
            ? String(message.previousDayHigh)
            : message.previousDayHigh;
      if (message.previousDayLow != null && message.hasOwnProperty('previousDayLow'))
        object.previousDayLow =
          options.json && !isFinite(message.previousDayLow) ? String(message.previousDayLow) : message.previousDayLow;
      if (message.adx != null && message.hasOwnProperty('adx'))
        object.adx = options.json && !isFinite(message.adx) ? String(message.adx) : message.adx;
      if (message.percentInstitutionalOwnership != null && message.hasOwnProperty('percentInstitutionalOwnership'))
        object.percentInstitutionalOwnership =
          options.json && !isFinite(message.percentInstitutionalOwnership)
            ? String(message.percentInstitutionalOwnership)
            : message.percentInstitutionalOwnership;
      if (message.averageVolume10Day != null && message.hasOwnProperty('averageVolume10Day'))
        if (typeof message.averageVolume10Day === 'number')
          object.averageVolume10Day =
            options.longs === String ? String(message.averageVolume10Day) : message.averageVolume10Day;
        else
          object.averageVolume10Day =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.averageVolume10Day)
              : options.longs === Number
                ? new $util.LongBits(
                    message.averageVolume10Day.low >>> 0,
                    message.averageVolume10Day.high >>> 0,
                  ).toNumber()
                : message.averageVolume10Day;
      if (message.averageVolumeChangePercent10Day != null && message.hasOwnProperty('averageVolumeChangePercent10Day'))
        object.averageVolumeChangePercent10Day =
          options.json && !isFinite(message.averageVolumeChangePercent10Day)
            ? String(message.averageVolumeChangePercent10Day)
            : message.averageVolumeChangePercent10Day;
      if (message.high10Day != null && message.hasOwnProperty('high10Day'))
        object.high10Day = options.json && !isFinite(message.high10Day) ? String(message.high10Day) : message.high10Day;
      if (message.highChangePercent10Day != null && message.hasOwnProperty('highChangePercent10Day'))
        object.highChangePercent10Day =
          options.json && !isFinite(message.highChangePercent10Day)
            ? String(message.highChangePercent10Day)
            : message.highChangePercent10Day;
      if (message.low10Day != null && message.hasOwnProperty('low10Day'))
        object.low10Day = options.json && !isFinite(message.low10Day) ? String(message.low10Day) : message.low10Day;
      if (message.lowChangePercent10Day != null && message.hasOwnProperty('lowChangePercent10Day'))
        object.lowChangePercent10Day =
          options.json && !isFinite(message.lowChangePercent10Day)
            ? String(message.lowChangePercent10Day)
            : message.lowChangePercent10Day;
      if (message.movingAverage10Day != null && message.hasOwnProperty('movingAverage10Day'))
        object.movingAverage10Day =
          options.json && !isFinite(message.movingAverage10Day)
            ? String(message.movingAverage10Day)
            : message.movingAverage10Day;
      if (message.movingAverageChangePercent10Day != null && message.hasOwnProperty('movingAverageChangePercent10Day'))
        object.movingAverageChangePercent10Day =
          options.json && !isFinite(message.movingAverageChangePercent10Day)
            ? String(message.movingAverageChangePercent10Day)
            : message.movingAverageChangePercent10Day;
      if (message.averageVolume20Day != null && message.hasOwnProperty('averageVolume20Day'))
        if (typeof message.averageVolume20Day === 'number')
          object.averageVolume20Day =
            options.longs === String ? String(message.averageVolume20Day) : message.averageVolume20Day;
        else
          object.averageVolume20Day =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.averageVolume20Day)
              : options.longs === Number
                ? new $util.LongBits(
                    message.averageVolume20Day.low >>> 0,
                    message.averageVolume20Day.high >>> 0,
                  ).toNumber()
                : message.averageVolume20Day;
      if (message.averageVolumeChangePercent20Day != null && message.hasOwnProperty('averageVolumeChangePercent20Day'))
        object.averageVolumeChangePercent20Day =
          options.json && !isFinite(message.averageVolumeChangePercent20Day)
            ? String(message.averageVolumeChangePercent20Day)
            : message.averageVolumeChangePercent20Day;
      if (message.high20Day != null && message.hasOwnProperty('high20Day'))
        object.high20Day = options.json && !isFinite(message.high20Day) ? String(message.high20Day) : message.high20Day;
      if (message.highChangePercent20Day != null && message.hasOwnProperty('highChangePercent20Day'))
        object.highChangePercent20Day =
          options.json && !isFinite(message.highChangePercent20Day)
            ? String(message.highChangePercent20Day)
            : message.highChangePercent20Day;
      if (message.low20Day != null && message.hasOwnProperty('low20Day'))
        object.low20Day = options.json && !isFinite(message.low20Day) ? String(message.low20Day) : message.low20Day;
      if (message.lowChangePercent20Day != null && message.hasOwnProperty('lowChangePercent20Day'))
        object.lowChangePercent20Day =
          options.json && !isFinite(message.lowChangePercent20Day)
            ? String(message.lowChangePercent20Day)
            : message.lowChangePercent20Day;
      if (message.movingAverage20Day != null && message.hasOwnProperty('movingAverage20Day'))
        object.movingAverage20Day =
          options.json && !isFinite(message.movingAverage20Day)
            ? String(message.movingAverage20Day)
            : message.movingAverage20Day;
      if (message.movingAverageChangePercent20Day != null && message.hasOwnProperty('movingAverageChangePercent20Day'))
        object.movingAverageChangePercent20Day =
          options.json && !isFinite(message.movingAverageChangePercent20Day)
            ? String(message.movingAverageChangePercent20Day)
            : message.movingAverageChangePercent20Day;
      if (message.averageVolume50Day != null && message.hasOwnProperty('averageVolume50Day'))
        if (typeof message.averageVolume50Day === 'number')
          object.averageVolume50Day =
            options.longs === String ? String(message.averageVolume50Day) : message.averageVolume50Day;
        else
          object.averageVolume50Day =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.averageVolume50Day)
              : options.longs === Number
                ? new $util.LongBits(
                    message.averageVolume50Day.low >>> 0,
                    message.averageVolume50Day.high >>> 0,
                  ).toNumber()
                : message.averageVolume50Day;
      if (message.averageVolumeChangePercent50Day != null && message.hasOwnProperty('averageVolumeChangePercent50Day'))
        object.averageVolumeChangePercent50Day =
          options.json && !isFinite(message.averageVolumeChangePercent50Day)
            ? String(message.averageVolumeChangePercent50Day)
            : message.averageVolumeChangePercent50Day;
      if (message.high50Day != null && message.hasOwnProperty('high50Day'))
        object.high50Day = options.json && !isFinite(message.high50Day) ? String(message.high50Day) : message.high50Day;
      if (message.highChangePercent50Day != null && message.hasOwnProperty('highChangePercent50Day'))
        object.highChangePercent50Day =
          options.json && !isFinite(message.highChangePercent50Day)
            ? String(message.highChangePercent50Day)
            : message.highChangePercent50Day;
      if (message.low50Day != null && message.hasOwnProperty('low50Day'))
        object.low50Day = options.json && !isFinite(message.low50Day) ? String(message.low50Day) : message.low50Day;
      if (message.lowChangePercent50Day != null && message.hasOwnProperty('lowChangePercent50Day'))
        object.lowChangePercent50Day =
          options.json && !isFinite(message.lowChangePercent50Day)
            ? String(message.lowChangePercent50Day)
            : message.lowChangePercent50Day;
      if (message.movingAverage50Day != null && message.hasOwnProperty('movingAverage50Day'))
        object.movingAverage50Day =
          options.json && !isFinite(message.movingAverage50Day)
            ? String(message.movingAverage50Day)
            : message.movingAverage50Day;
      if (message.movingAverageChangePercent50Day != null && message.hasOwnProperty('movingAverageChangePercent50Day'))
        object.movingAverageChangePercent50Day =
          options.json && !isFinite(message.movingAverageChangePercent50Day)
            ? String(message.movingAverageChangePercent50Day)
            : message.movingAverageChangePercent50Day;
      if (message.averageVolume100Day != null && message.hasOwnProperty('averageVolume100Day'))
        if (typeof message.averageVolume100Day === 'number')
          object.averageVolume100Day =
            options.longs === String ? String(message.averageVolume100Day) : message.averageVolume100Day;
        else
          object.averageVolume100Day =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.averageVolume100Day)
              : options.longs === Number
                ? new $util.LongBits(
                    message.averageVolume100Day.low >>> 0,
                    message.averageVolume100Day.high >>> 0,
                  ).toNumber()
                : message.averageVolume100Day;
      if (
        message.averageVolumeChangePercent100Day != null &&
        message.hasOwnProperty('averageVolumeChangePercent100Day')
      )
        object.averageVolumeChangePercent100Day =
          options.json && !isFinite(message.averageVolumeChangePercent100Day)
            ? String(message.averageVolumeChangePercent100Day)
            : message.averageVolumeChangePercent100Day;
      if (message.high100Day != null && message.hasOwnProperty('high100Day'))
        object.high100Day =
          options.json && !isFinite(message.high100Day) ? String(message.high100Day) : message.high100Day;
      if (message.highChangePercent100Day != null && message.hasOwnProperty('highChangePercent100Day'))
        object.highChangePercent100Day =
          options.json && !isFinite(message.highChangePercent100Day)
            ? String(message.highChangePercent100Day)
            : message.highChangePercent100Day;
      if (message.low100Day != null && message.hasOwnProperty('low100Day'))
        object.low100Day = options.json && !isFinite(message.low100Day) ? String(message.low100Day) : message.low100Day;
      if (message.lowChangePercent100Day != null && message.hasOwnProperty('lowChangePercent100Day'))
        object.lowChangePercent100Day =
          options.json && !isFinite(message.lowChangePercent100Day)
            ? String(message.lowChangePercent100Day)
            : message.lowChangePercent100Day;
      if (message.movingAverage100Day != null && message.hasOwnProperty('movingAverage100Day'))
        object.movingAverage100Day =
          options.json && !isFinite(message.movingAverage100Day)
            ? String(message.movingAverage100Day)
            : message.movingAverage100Day;
      if (
        message.movingAverageChangePercent100Day != null &&
        message.hasOwnProperty('movingAverageChangePercent100Day')
      )
        object.movingAverageChangePercent100Day =
          options.json && !isFinite(message.movingAverageChangePercent100Day)
            ? String(message.movingAverageChangePercent100Day)
            : message.movingAverageChangePercent100Day;
      if (message.averageVolume200Day != null && message.hasOwnProperty('averageVolume200Day'))
        if (typeof message.averageVolume200Day === 'number')
          object.averageVolume200Day =
            options.longs === String ? String(message.averageVolume200Day) : message.averageVolume200Day;
        else
          object.averageVolume200Day =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.averageVolume200Day)
              : options.longs === Number
                ? new $util.LongBits(
                    message.averageVolume200Day.low >>> 0,
                    message.averageVolume200Day.high >>> 0,
                  ).toNumber()
                : message.averageVolume200Day;
      if (
        message.averageVolumeChangePercent200Day != null &&
        message.hasOwnProperty('averageVolumeChangePercent200Day')
      )
        object.averageVolumeChangePercent200Day =
          options.json && !isFinite(message.averageVolumeChangePercent200Day)
            ? String(message.averageVolumeChangePercent200Day)
            : message.averageVolumeChangePercent200Day;
      if (message.high200Day != null && message.hasOwnProperty('high200Day'))
        object.high200Day =
          options.json && !isFinite(message.high200Day) ? String(message.high200Day) : message.high200Day;
      if (message.highChangePercent200Day != null && message.hasOwnProperty('highChangePercent200Day'))
        object.highChangePercent200Day =
          options.json && !isFinite(message.highChangePercent200Day)
            ? String(message.highChangePercent200Day)
            : message.highChangePercent200Day;
      if (message.low200Day != null && message.hasOwnProperty('low200Day'))
        object.low200Day = options.json && !isFinite(message.low200Day) ? String(message.low200Day) : message.low200Day;
      if (message.lowChangePercent200Day != null && message.hasOwnProperty('lowChangePercent200Day'))
        object.lowChangePercent200Day =
          options.json && !isFinite(message.lowChangePercent200Day)
            ? String(message.lowChangePercent200Day)
            : message.lowChangePercent200Day;
      if (message.movingAverage200Day != null && message.hasOwnProperty('movingAverage200Day'))
        object.movingAverage200Day =
          options.json && !isFinite(message.movingAverage200Day)
            ? String(message.movingAverage200Day)
            : message.movingAverage200Day;
      if (
        message.movingAverageChangePercent200Day != null &&
        message.hasOwnProperty('movingAverageChangePercent200Day')
      )
        object.movingAverageChangePercent200Day =
          options.json && !isFinite(message.movingAverageChangePercent200Day)
            ? String(message.movingAverageChangePercent200Day)
            : message.movingAverageChangePercent200Day;
      if (message.movingAverage250Day != null && message.hasOwnProperty('movingAverage250Day'))
        object.movingAverage250Day =
          options.json && !isFinite(message.movingAverage250Day)
            ? String(message.movingAverage250Day)
            : message.movingAverage250Day;
      if (
        message.movingAverageChangePercent250Day != null &&
        message.hasOwnProperty('movingAverageChangePercent250Day')
      )
        object.movingAverageChangePercent250Day =
          options.json && !isFinite(message.movingAverageChangePercent250Day)
            ? String(message.movingAverageChangePercent250Day)
            : message.movingAverageChangePercent250Day;
      if (message.averageVolume90Day != null && message.hasOwnProperty('averageVolume90Day'))
        if (typeof message.averageVolume90Day === 'number')
          object.averageVolume90Day =
            options.longs === String ? String(message.averageVolume90Day) : message.averageVolume90Day;
        else
          object.averageVolume90Day =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.averageVolume90Day)
              : options.longs === Number
                ? new $util.LongBits(
                    message.averageVolume90Day.low >>> 0,
                    message.averageVolume90Day.high >>> 0,
                  ).toNumber()
                : message.averageVolume90Day;
      if (message.lowAllTime != null && message.hasOwnProperty('lowAllTime'))
        object.lowAllTime =
          options.json && !isFinite(message.lowAllTime) ? String(message.lowAllTime) : message.lowAllTime;
      if (message.highAllTime != null && message.hasOwnProperty('highAllTime'))
        object.highAllTime =
          options.json && !isFinite(message.highAllTime) ? String(message.highAllTime) : message.highAllTime;
      if (message.quickRatioMrq != null && message.hasOwnProperty('quickRatioMrq'))
        object.quickRatioMrq =
          options.json && !isFinite(message.quickRatioMrq) ? String(message.quickRatioMrq) : message.quickRatioMrq;
      if (message.ffoPerShare != null && message.hasOwnProperty('ffoPerShare'))
        object.ffoPerShare =
          options.json && !isFinite(message.ffoPerShare) ? String(message.ffoPerShare) : message.ffoPerShare;
      if (message.ipoDateNumber != null && message.hasOwnProperty('ipoDateNumber'))
        if (typeof message.ipoDateNumber === 'number')
          object.ipoDateNumber = options.longs === String ? String(message.ipoDateNumber) : message.ipoDateNumber;
        else
          object.ipoDateNumber =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.ipoDateNumber)
              : options.longs === Number
                ? new $util.LongBits(message.ipoDateNumber.low >>> 0, message.ipoDateNumber.high >>> 0).toNumber()
                : message.ipoDateNumber;
      if (message.ltDebtEquity != null && message.hasOwnProperty('ltDebtEquity'))
        object.ltDebtEquity =
          options.json && !isFinite(message.ltDebtEquity) ? String(message.ltDebtEquity) : message.ltDebtEquity;
      if (message.epsGrowthYearAgoQ != null && message.hasOwnProperty('epsGrowthYearAgoQ'))
        object.epsGrowthYearAgoQ =
          options.json && !isFinite(message.epsGrowthYearAgoQ)
            ? String(message.epsGrowthYearAgoQ)
            : message.epsGrowthYearAgoQ;
      if (message.revenueGrowthYearAgoQ != null && message.hasOwnProperty('revenueGrowthYearAgoQ'))
        object.revenueGrowthYearAgoQ =
          options.json && !isFinite(message.revenueGrowthYearAgoQ)
            ? String(message.revenueGrowthYearAgoQ)
            : message.revenueGrowthYearAgoQ;
      if (message.revenueGrowth5Year != null && message.hasOwnProperty('revenueGrowth5Year'))
        object.revenueGrowth5Year =
          options.json && !isFinite(message.revenueGrowth5Year)
            ? String(message.revenueGrowth5Year)
            : message.revenueGrowth5Year;
      if (message.revenueGrowthQ2Q != null && message.hasOwnProperty('revenueGrowthQ2Q'))
        object.revenueGrowthQ2Q =
          options.json && !isFinite(message.revenueGrowthQ2Q)
            ? String(message.revenueGrowthQ2Q)
            : message.revenueGrowthQ2Q;
      if (message.revenueGrowthY2Y != null && message.hasOwnProperty('revenueGrowthY2Y'))
        object.revenueGrowthY2Y =
          options.json && !isFinite(message.revenueGrowthY2Y)
            ? String(message.revenueGrowthY2Y)
            : message.revenueGrowthY2Y;
      if (message.revenueGrowthTtm != null && message.hasOwnProperty('revenueGrowthTtm'))
        object.revenueGrowthTtm =
          options.json && !isFinite(message.revenueGrowthTtm)
            ? String(message.revenueGrowthTtm)
            : message.revenueGrowthTtm;
      if (message.epsGrowth5Year != null && message.hasOwnProperty('epsGrowth5Year'))
        object.epsGrowth5Year =
          options.json && !isFinite(message.epsGrowth5Year) ? String(message.epsGrowth5Year) : message.epsGrowth5Year;
      if (message.epsGrowthQ2Q != null && message.hasOwnProperty('epsGrowthQ2Q'))
        object.epsGrowthQ2Q =
          options.json && !isFinite(message.epsGrowthQ2Q) ? String(message.epsGrowthQ2Q) : message.epsGrowthQ2Q;
      if (message.epsGrowthY2Y != null && message.hasOwnProperty('epsGrowthY2Y'))
        object.epsGrowthY2Y =
          options.json && !isFinite(message.epsGrowthY2Y) ? String(message.epsGrowthY2Y) : message.epsGrowthY2Y;
      if (message.epsGrowthTtm != null && message.hasOwnProperty('epsGrowthTtm'))
        object.epsGrowthTtm =
          options.json && !isFinite(message.epsGrowthTtm) ? String(message.epsGrowthTtm) : message.epsGrowthTtm;
      if (
        message.dilutedRevenueTtmSurprisePercent != null &&
        message.hasOwnProperty('dilutedRevenueTtmSurprisePercent')
      )
        object.dilutedRevenueTtmSurprisePercent =
          options.json && !isFinite(message.dilutedRevenueTtmSurprisePercent)
            ? String(message.dilutedRevenueTtmSurprisePercent)
            : message.dilutedRevenueTtmSurprisePercent;
      if (
        message.dilutedRevenueMrqSurprisePercent != null &&
        message.hasOwnProperty('dilutedRevenueMrqSurprisePercent')
      )
        object.dilutedRevenueMrqSurprisePercent =
          options.json && !isFinite(message.dilutedRevenueMrqSurprisePercent)
            ? String(message.dilutedRevenueMrqSurprisePercent)
            : message.dilutedRevenueMrqSurprisePercent;
      if (message.dilutedEpsTtmSurprisePercent != null && message.hasOwnProperty('dilutedEpsTtmSurprisePercent'))
        object.dilutedEpsTtmSurprisePercent =
          options.json && !isFinite(message.dilutedEpsTtmSurprisePercent)
            ? String(message.dilutedEpsTtmSurprisePercent)
            : message.dilutedEpsTtmSurprisePercent;
      if (message.dilutedEpsMrqSurprisePercent != null && message.hasOwnProperty('dilutedEpsMrqSurprisePercent'))
        object.dilutedEpsMrqSurprisePercent =
          options.json && !isFinite(message.dilutedEpsMrqSurprisePercent)
            ? String(message.dilutedEpsMrqSurprisePercent)
            : message.dilutedEpsMrqSurprisePercent;
      if (message.adr14d != null && message.hasOwnProperty('adr14d'))
        object.adr14d = options.json && !isFinite(message.adr14d) ? String(message.adr14d) : message.adr14d;
      if (message.gapChangePercent != null && message.hasOwnProperty('gapChangePercent'))
        object.gapChangePercent =
          options.json && !isFinite(message.gapChangePercent)
            ? String(message.gapChangePercent)
            : message.gapChangePercent;
      if (message.gapChange != null && message.hasOwnProperty('gapChange'))
        object.gapChange = options.json && !isFinite(message.gapChange) ? String(message.gapChange) : message.gapChange;
      if (message.movingAverage500Day != null && message.hasOwnProperty('movingAverage500Day'))
        object.movingAverage500Day =
          options.json && !isFinite(message.movingAverage500Day)
            ? String(message.movingAverage500Day)
            : message.movingAverage500Day;
      if (message.dividendGrowthRate5Year != null && message.hasOwnProperty('dividendGrowthRate5Year'))
        object.dividendGrowthRate5Year =
          options.json && !isFinite(message.dividendGrowthRate5Year)
            ? String(message.dividendGrowthRate5Year)
            : message.dividendGrowthRate5Year;
      if (message.dividendGrowthRate3Year != null && message.hasOwnProperty('dividendGrowthRate3Year'))
        object.dividendGrowthRate3Year =
          options.json && !isFinite(message.dividendGrowthRate3Year)
            ? String(message.dividendGrowthRate3Year)
            : message.dividendGrowthRate3Year;
      if (message.dividendGrowthRate1Year != null && message.hasOwnProperty('dividendGrowthRate1Year'))
        object.dividendGrowthRate1Year =
          options.json && !isFinite(message.dividendGrowthRate1Year)
            ? String(message.dividendGrowthRate1Year)
            : message.dividendGrowthRate1Year;
      if (message.newsBzWireTitle != null && message.hasOwnProperty('newsBzWireTitle'))
        object.newsBzWireTitle = message.newsBzWireTitle;
      if (message.newsBzWireNodeId != null && message.hasOwnProperty('newsBzWireNodeId'))
        object.newsBzWireNodeId = message.newsBzWireNodeId;
      if (message.newsBzWireTimestamp != null && message.hasOwnProperty('newsBzWireTimestamp'))
        if (typeof message.newsBzWireTimestamp === 'number')
          object.newsBzWireTimestamp =
            options.longs === String ? String(message.newsBzWireTimestamp) : message.newsBzWireTimestamp;
        else
          object.newsBzWireTimestamp =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.newsBzWireTimestamp)
              : options.longs === Number
                ? new $util.LongBits(
                    message.newsBzWireTimestamp.low >>> 0,
                    message.newsBzWireTimestamp.high >>> 0,
                  ).toNumber()
                : message.newsBzWireTimestamp;
      if (message.newsPRTitle != null && message.hasOwnProperty('newsPRTitle'))
        object.newsPRTitle = message.newsPRTitle;
      if (message.newsPRNodeId != null && message.hasOwnProperty('newsPRNodeId'))
        object.newsPRNodeId = message.newsPRNodeId;
      if (message.newsPRTimestamp != null && message.hasOwnProperty('newsPRTimestamp'))
        if (typeof message.newsPRTimestamp === 'number')
          object.newsPRTimestamp = options.longs === String ? String(message.newsPRTimestamp) : message.newsPRTimestamp;
        else
          object.newsPRTimestamp =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.newsPRTimestamp)
              : options.longs === Number
                ? new $util.LongBits(message.newsPRTimestamp.low >>> 0, message.newsPRTimestamp.high >>> 0).toNumber()
                : message.newsPRTimestamp;
      if (message.newsSecTitle != null && message.hasOwnProperty('newsSecTitle'))
        object.newsSecTitle = message.newsSecTitle;
      if (message.newsSecNodeId != null && message.hasOwnProperty('newsSecNodeId'))
        object.newsSecNodeId = message.newsSecNodeId;
      if (message.newsSecTimestamp != null && message.hasOwnProperty('newsSecTimestamp'))
        if (typeof message.newsSecTimestamp === 'number')
          object.newsSecTimestamp =
            options.longs === String ? String(message.newsSecTimestamp) : message.newsSecTimestamp;
        else
          object.newsSecTimestamp =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.newsSecTimestamp)
              : options.longs === Number
                ? new $util.LongBits(message.newsSecTimestamp.low >>> 0, message.newsSecTimestamp.high >>> 0).toNumber()
                : message.newsSecTimestamp;
      if (message.mtdChange != null && message.hasOwnProperty('mtdChange'))
        object.mtdChange = options.json && !isFinite(message.mtdChange) ? String(message.mtdChange) : message.mtdChange;
      if (message.ytdChange != null && message.hasOwnProperty('ytdChange'))
        object.ytdChange = options.json && !isFinite(message.ytdChange) ? String(message.ytdChange) : message.ytdChange;
      if (message.macdSignalLineBase != null && message.hasOwnProperty('macdSignalLineBase'))
        object.macdSignalLineBase =
          options.json && !isFinite(message.macdSignalLineBase)
            ? String(message.macdSignalLineBase)
            : message.macdSignalLineBase;
      if (message.macdHistogram != null && message.hasOwnProperty('macdHistogram'))
        object.macdHistogram =
          options.json && !isFinite(message.macdHistogram) ? String(message.macdHistogram) : message.macdHistogram;
      if (message.macdSignalLine != null && message.hasOwnProperty('macdSignalLine'))
        object.macdSignalLine =
          options.json && !isFinite(message.macdSignalLine) ? String(message.macdSignalLine) : message.macdSignalLine;
      if (message.macd != null && message.hasOwnProperty('macd'))
        object.macd = options.json && !isFinite(message.macd) ? String(message.macd) : message.macd;
      if (message.wiim != null && message.hasOwnProperty('wiim')) object.wiim = message.wiim;
      if (message.wiimAsOf != null && message.hasOwnProperty('wiimAsOf'))
        if (typeof message.wiimAsOf === 'number')
          object.wiimAsOf = options.longs === String ? String(message.wiimAsOf) : message.wiimAsOf;
        else
          object.wiimAsOf =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.wiimAsOf)
              : options.longs === Number
                ? new $util.LongBits(message.wiimAsOf.low >>> 0, message.wiimAsOf.high >>> 0).toNumber()
                : message.wiimAsOf;
      if (message.vwap != null && message.hasOwnProperty('vwap'))
        object.vwap = options.json && !isFinite(message.vwap) ? String(message.vwap) : message.vwap;
      if (message.vwapChangePercent != null && message.hasOwnProperty('vwapChangePercent'))
        object.vwapChangePercent =
          options.json && !isFinite(message.vwapChangePercent)
            ? String(message.vwapChangePercent)
            : message.vwapChangePercent;
      if (message.vwapChange != null && message.hasOwnProperty('vwapChange'))
        object.vwapChange =
          options.json && !isFinite(message.vwapChange) ? String(message.vwapChange) : message.vwapChange;
      if (message.rsiAvgGain != null && message.hasOwnProperty('rsiAvgGain'))
        object.rsiAvgGain =
          options.json && !isFinite(message.rsiAvgGain) ? String(message.rsiAvgGain) : message.rsiAvgGain;
      if (message.rsiAvgLoss != null && message.hasOwnProperty('rsiAvgLoss'))
        object.rsiAvgLoss =
          options.json && !isFinite(message.rsiAvgLoss) ? String(message.rsiAvgLoss) : message.rsiAvgLoss;
      if (message.halted != null && message.hasOwnProperty('halted')) object.halted = message.halted;
      if (message.tradeCount != null && message.hasOwnProperty('tradeCount'))
        if (typeof message.tradeCount === 'number')
          object.tradeCount = options.longs === String ? String(message.tradeCount) : message.tradeCount;
        else
          object.tradeCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.tradeCount)
              : options.longs === Number
                ? new $util.LongBits(message.tradeCount.low >>> 0, message.tradeCount.high >>> 0).toNumber()
                : message.tradeCount;
      if (message.regularHighCount != null && message.hasOwnProperty('regularHighCount'))
        if (typeof message.regularHighCount === 'number')
          object.regularHighCount =
            options.longs === String ? String(message.regularHighCount) : message.regularHighCount;
        else
          object.regularHighCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.regularHighCount)
              : options.longs === Number
                ? new $util.LongBits(message.regularHighCount.low >>> 0, message.regularHighCount.high >>> 0).toNumber()
                : message.regularHighCount;
      if (message.regularLowCount != null && message.hasOwnProperty('regularLowCount'))
        if (typeof message.regularLowCount === 'number')
          object.regularLowCount = options.longs === String ? String(message.regularLowCount) : message.regularLowCount;
        else
          object.regularLowCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.regularLowCount)
              : options.longs === Number
                ? new $util.LongBits(message.regularLowCount.low >>> 0, message.regularLowCount.high >>> 0).toNumber()
                : message.regularLowCount;
      if (message.preMarketHighCount != null && message.hasOwnProperty('preMarketHighCount'))
        if (typeof message.preMarketHighCount === 'number')
          object.preMarketHighCount =
            options.longs === String ? String(message.preMarketHighCount) : message.preMarketHighCount;
        else
          object.preMarketHighCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.preMarketHighCount)
              : options.longs === Number
                ? new $util.LongBits(
                    message.preMarketHighCount.low >>> 0,
                    message.preMarketHighCount.high >>> 0,
                  ).toNumber()
                : message.preMarketHighCount;
      if (message.preMarketLowCount != null && message.hasOwnProperty('preMarketLowCount'))
        if (typeof message.preMarketLowCount === 'number')
          object.preMarketLowCount =
            options.longs === String ? String(message.preMarketLowCount) : message.preMarketLowCount;
        else
          object.preMarketLowCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.preMarketLowCount)
              : options.longs === Number
                ? new $util.LongBits(
                    message.preMarketLowCount.low >>> 0,
                    message.preMarketLowCount.high >>> 0,
                  ).toNumber()
                : message.preMarketLowCount;
      if (message.afterMarketHighCount != null && message.hasOwnProperty('afterMarketHighCount'))
        if (typeof message.afterMarketHighCount === 'number')
          object.afterMarketHighCount =
            options.longs === String ? String(message.afterMarketHighCount) : message.afterMarketHighCount;
        else
          object.afterMarketHighCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.afterMarketHighCount)
              : options.longs === Number
                ? new $util.LongBits(
                    message.afterMarketHighCount.low >>> 0,
                    message.afterMarketHighCount.high >>> 0,
                  ).toNumber()
                : message.afterMarketHighCount;
      if (message.afterMarketLowCount != null && message.hasOwnProperty('afterMarketLowCount'))
        if (typeof message.afterMarketLowCount === 'number')
          object.afterMarketLowCount =
            options.longs === String ? String(message.afterMarketLowCount) : message.afterMarketLowCount;
        else
          object.afterMarketLowCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.afterMarketLowCount)
              : options.longs === Number
                ? new $util.LongBits(
                    message.afterMarketLowCount.low >>> 0,
                    message.afterMarketLowCount.high >>> 0,
                  ).toNumber()
                : message.afterMarketLowCount;
      if (message.dayHighCount != null && message.hasOwnProperty('dayHighCount'))
        if (typeof message.dayHighCount === 'number')
          object.dayHighCount = options.longs === String ? String(message.dayHighCount) : message.dayHighCount;
        else
          object.dayHighCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.dayHighCount)
              : options.longs === Number
                ? new $util.LongBits(message.dayHighCount.low >>> 0, message.dayHighCount.high >>> 0).toNumber()
                : message.dayHighCount;
      if (message.dayLowCount != null && message.hasOwnProperty('dayLowCount'))
        if (typeof message.dayLowCount === 'number')
          object.dayLowCount = options.longs === String ? String(message.dayLowCount) : message.dayLowCount;
        else
          object.dayLowCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.dayLowCount)
              : options.longs === Number
                ? new $util.LongBits(message.dayLowCount.low >>> 0, message.dayLowCount.high >>> 0).toNumber()
                : message.dayLowCount;
      if (message.ema12d != null && message.hasOwnProperty('ema12d'))
        object.ema12d = options.json && !isFinite(message.ema12d) ? String(message.ema12d) : message.ema12d;
      if (message.ema26d != null && message.hasOwnProperty('ema26d'))
        object.ema26d = options.json && !isFinite(message.ema26d) ? String(message.ema26d) : message.ema26d;
      if (message.dayHigh != null && message.hasOwnProperty('dayHigh'))
        object.dayHigh = options.json && !isFinite(message.dayHigh) ? String(message.dayHigh) : message.dayHigh;
      if (message.dayLow != null && message.hasOwnProperty('dayLow'))
        object.dayLow = options.json && !isFinite(message.dayLow) ? String(message.dayLow) : message.dayLow;
      if (message.preMarketHigh != null && message.hasOwnProperty('preMarketHigh'))
        object.preMarketHigh =
          options.json && !isFinite(message.preMarketHigh) ? String(message.preMarketHigh) : message.preMarketHigh;
      if (message.preMarketLow != null && message.hasOwnProperty('preMarketLow'))
        object.preMarketLow =
          options.json && !isFinite(message.preMarketLow) ? String(message.preMarketLow) : message.preMarketLow;
      if (message.afterMarketHigh != null && message.hasOwnProperty('afterMarketHigh'))
        object.afterMarketHigh =
          options.json && !isFinite(message.afterMarketHigh)
            ? String(message.afterMarketHigh)
            : message.afterMarketHigh;
      if (message.afterMarketLow != null && message.hasOwnProperty('afterMarketLow'))
        object.afterMarketLow =
          options.json && !isFinite(message.afterMarketLow) ? String(message.afterMarketLow) : message.afterMarketLow;
      if (message.regularHigh != null && message.hasOwnProperty('regularHigh'))
        object.regularHigh =
          options.json && !isFinite(message.regularHigh) ? String(message.regularHigh) : message.regularHigh;
      if (message.regularLow != null && message.hasOwnProperty('regularLow'))
        object.regularLow =
          options.json && !isFinite(message.regularLow) ? String(message.regularLow) : message.regularLow;
      if (message.priceSpikeUpCount != null && message.hasOwnProperty('priceSpikeUpCount'))
        if (typeof message.priceSpikeUpCount === 'number')
          object.priceSpikeUpCount =
            options.longs === String ? String(message.priceSpikeUpCount) : message.priceSpikeUpCount;
        else
          object.priceSpikeUpCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.priceSpikeUpCount)
              : options.longs === Number
                ? new $util.LongBits(
                    message.priceSpikeUpCount.low >>> 0,
                    message.priceSpikeUpCount.high >>> 0,
                  ).toNumber()
                : message.priceSpikeUpCount;
      if (message.priceSpikeDownCount != null && message.hasOwnProperty('priceSpikeDownCount'))
        if (typeof message.priceSpikeDownCount === 'number')
          object.priceSpikeDownCount =
            options.longs === String ? String(message.priceSpikeDownCount) : message.priceSpikeDownCount;
        else
          object.priceSpikeDownCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.priceSpikeDownCount)
              : options.longs === Number
                ? new $util.LongBits(
                    message.priceSpikeDownCount.low >>> 0,
                    message.priceSpikeDownCount.high >>> 0,
                  ).toNumber()
                : message.priceSpikeDownCount;
      if (message.haltedCount != null && message.hasOwnProperty('haltedCount'))
        if (typeof message.haltedCount === 'number')
          object.haltedCount = options.longs === String ? String(message.haltedCount) : message.haltedCount;
        else
          object.haltedCount =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.haltedCount)
              : options.longs === Number
                ? new $util.LongBits(message.haltedCount.low >>> 0, message.haltedCount.high >>> 0).toNumber()
                : message.haltedCount;
      if (message.usCongressTotal != null && message.hasOwnProperty('usCongressTotal'))
        object.usCongressTotal =
          options.json && !isFinite(message.usCongressTotal)
            ? String(message.usCongressTotal)
            : message.usCongressTotal;
      if (message.usCongressRepublicansTotal != null && message.hasOwnProperty('usCongressRepublicansTotal'))
        object.usCongressRepublicansTotal =
          options.json && !isFinite(message.usCongressRepublicansTotal)
            ? String(message.usCongressRepublicansTotal)
            : message.usCongressRepublicansTotal;
      if (message.usCongressDemocratsTotal != null && message.hasOwnProperty('usCongressDemocratsTotal'))
        object.usCongressDemocratsTotal =
          options.json && !isFinite(message.usCongressDemocratsTotal)
            ? String(message.usCongressDemocratsTotal)
            : message.usCongressDemocratsTotal;
      if (message.usCongressOtherTotal != null && message.hasOwnProperty('usCongressOtherTotal'))
        object.usCongressOtherTotal =
          options.json && !isFinite(message.usCongressOtherTotal)
            ? String(message.usCongressOtherTotal)
            : message.usCongressOtherTotal;
      if (message.volumeFloatRatio != null && message.hasOwnProperty('volumeFloatRatio'))
        object.volumeFloatRatio =
          options.json && !isFinite(message.volumeFloatRatio)
            ? String(message.volumeFloatRatio)
            : message.volumeFloatRatio;
      if (message.atrp != null && message.hasOwnProperty('atrp'))
        object.atrp = options.json && !isFinite(message.atrp) ? String(message.atrp) : message.atrp;
      if (message.ytdGainLoss != null && message.hasOwnProperty('ytdGainLoss'))
        object.ytdGainLoss =
          options.json && !isFinite(message.ytdGainLoss) ? String(message.ytdGainLoss) : message.ytdGainLoss;
      if (message.mtdGainLoss != null && message.hasOwnProperty('mtdGainLoss'))
        object.mtdGainLoss =
          options.json && !isFinite(message.mtdGainLoss) ? String(message.mtdGainLoss) : message.mtdGainLoss;
      if (message.yearOpen != null && message.hasOwnProperty('yearOpen'))
        object.yearOpen = options.json && !isFinite(message.yearOpen) ? String(message.yearOpen) : message.yearOpen;
      if (message.rsi1m != null && message.hasOwnProperty('rsi1m'))
        object.rsi1m = options.json && !isFinite(message.rsi1m) ? String(message.rsi1m) : message.rsi1m;
      if (message.rsi2m != null && message.hasOwnProperty('rsi2m'))
        object.rsi2m = options.json && !isFinite(message.rsi2m) ? String(message.rsi2m) : message.rsi2m;
      if (message.rsi5m != null && message.hasOwnProperty('rsi5m'))
        object.rsi5m = options.json && !isFinite(message.rsi5m) ? String(message.rsi5m) : message.rsi5m;
      if (message.rsi15m != null && message.hasOwnProperty('rsi15m'))
        object.rsi15m = options.json && !isFinite(message.rsi15m) ? String(message.rsi15m) : message.rsi15m;
      if (message.rsi30m != null && message.hasOwnProperty('rsi30m'))
        object.rsi30m = options.json && !isFinite(message.rsi30m) ? String(message.rsi30m) : message.rsi30m;
      if (message.rsi60m != null && message.hasOwnProperty('rsi60m'))
        object.rsi60m = options.json && !isFinite(message.rsi60m) ? String(message.rsi60m) : message.rsi60m;
      if (message.rsiEth1m != null && message.hasOwnProperty('rsiEth1m'))
        object.rsiEth1m = options.json && !isFinite(message.rsiEth1m) ? String(message.rsiEth1m) : message.rsiEth1m;
      if (message.rsiEth2m != null && message.hasOwnProperty('rsiEth2m'))
        object.rsiEth2m = options.json && !isFinite(message.rsiEth2m) ? String(message.rsiEth2m) : message.rsiEth2m;
      if (message.rsiEth5m != null && message.hasOwnProperty('rsiEth5m'))
        object.rsiEth5m = options.json && !isFinite(message.rsiEth5m) ? String(message.rsiEth5m) : message.rsiEth5m;
      if (message.rsiEth15m != null && message.hasOwnProperty('rsiEth15m'))
        object.rsiEth15m = options.json && !isFinite(message.rsiEth15m) ? String(message.rsiEth15m) : message.rsiEth15m;
      if (message.rsiEth30m != null && message.hasOwnProperty('rsiEth30m'))
        object.rsiEth30m = options.json && !isFinite(message.rsiEth30m) ? String(message.rsiEth30m) : message.rsiEth30m;
      if (message.rsiEth60m != null && message.hasOwnProperty('rsiEth60m'))
        object.rsiEth60m = options.json && !isFinite(message.rsiEth60m) ? String(message.rsiEth60m) : message.rsiEth60m;
      if (message.monthOpen != null && message.hasOwnProperty('monthOpen'))
        object.monthOpen = options.json && !isFinite(message.monthOpen) ? String(message.monthOpen) : message.monthOpen;
      if (message.volumeFloatPercent != null && message.hasOwnProperty('volumeFloatPercent'))
        object.volumeFloatPercent =
          options.json && !isFinite(message.volumeFloatPercent)
            ? String(message.volumeFloatPercent)
            : message.volumeFloatPercent;
      if (message.averageDollarVolume10Day != null && message.hasOwnProperty('averageDollarVolume10Day'))
        object.averageDollarVolume10Day =
          options.json && !isFinite(message.averageDollarVolume10Day)
            ? String(message.averageDollarVolume10Day)
            : message.averageDollarVolume10Day;
      if (message.averageVolume60Day != null && message.hasOwnProperty('averageVolume60Day'))
        if (typeof message.averageVolume60Day === 'number')
          object.averageVolume60Day =
            options.longs === String ? String(message.averageVolume60Day) : message.averageVolume60Day;
        else
          object.averageVolume60Day =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.averageVolume60Day)
              : options.longs === Number
                ? new $util.LongBits(
                    message.averageVolume60Day.low >>> 0,
                    message.averageVolume60Day.high >>> 0,
                  ).toNumber()
                : message.averageVolume60Day;
      if (message.relativeVolumePercent60Day != null && message.hasOwnProperty('relativeVolumePercent60Day'))
        object.relativeVolumePercent60Day =
          options.json && !isFinite(message.relativeVolumePercent60Day)
            ? String(message.relativeVolumePercent60Day)
            : message.relativeVolumePercent60Day;
      if (message.price1Week != null && message.hasOwnProperty('price1Week'))
        object.price1Week =
          options.json && !isFinite(message.price1Week) ? String(message.price1Week) : message.price1Week;
      if (message.priceChangePercent1Week != null && message.hasOwnProperty('priceChangePercent1Week'))
        object.priceChangePercent1Week =
          options.json && !isFinite(message.priceChangePercent1Week)
            ? String(message.priceChangePercent1Week)
            : message.priceChangePercent1Week;
      if (message.price1Month != null && message.hasOwnProperty('price1Month'))
        object.price1Month =
          options.json && !isFinite(message.price1Month) ? String(message.price1Month) : message.price1Month;
      if (message.priceChangePercent1Month != null && message.hasOwnProperty('priceChangePercent1Month'))
        object.priceChangePercent1Month =
          options.json && !isFinite(message.priceChangePercent1Month)
            ? String(message.priceChangePercent1Month)
            : message.priceChangePercent1Month;
      if (message.priceHalfYear != null && message.hasOwnProperty('priceHalfYear'))
        object.priceHalfYear =
          options.json && !isFinite(message.priceHalfYear) ? String(message.priceHalfYear) : message.priceHalfYear;
      if (message.priceChangePercentHalfYear != null && message.hasOwnProperty('priceChangePercentHalfYear'))
        object.priceChangePercentHalfYear =
          options.json && !isFinite(message.priceChangePercentHalfYear)
            ? String(message.priceChangePercentHalfYear)
            : message.priceChangePercentHalfYear;
      if (message.priceQuarter != null && message.hasOwnProperty('priceQuarter'))
        object.priceQuarter =
          options.json && !isFinite(message.priceQuarter) ? String(message.priceQuarter) : message.priceQuarter;
      if (message.priceChangePercentQuarter != null && message.hasOwnProperty('priceChangePercentQuarter'))
        object.priceChangePercentQuarter =
          options.json && !isFinite(message.priceChangePercentQuarter)
            ? String(message.priceChangePercentQuarter)
            : message.priceChangePercentQuarter;
      if (message.price1Year != null && message.hasOwnProperty('price1Year'))
        object.price1Year =
          options.json && !isFinite(message.price1Year) ? String(message.price1Year) : message.price1Year;
      if (message.priceChangePercent1Year != null && message.hasOwnProperty('priceChangePercent1Year'))
        object.priceChangePercent1Year =
          options.json && !isFinite(message.priceChangePercent1Year)
            ? String(message.priceChangePercent1Year)
            : message.priceChangePercent1Year;
      if (message.priceYearToDate != null && message.hasOwnProperty('priceYearToDate'))
        object.priceYearToDate =
          options.json && !isFinite(message.priceYearToDate)
            ? String(message.priceYearToDate)
            : message.priceYearToDate;
      if (message.priceChangePercentYearToDate != null && message.hasOwnProperty('priceChangePercentYearToDate'))
        object.priceChangePercentYearToDate =
          options.json && !isFinite(message.priceChangePercentYearToDate)
            ? String(message.priceChangePercentYearToDate)
            : message.priceChangePercentYearToDate;
      if (message.bullsSay != null && message.hasOwnProperty('bullsSay')) object.bullsSay = message.bullsSay;
      if (message.bearsSay != null && message.hasOwnProperty('bearsSay')) object.bearsSay = message.bearsSay;
      if (message.preMarketOpen != null && message.hasOwnProperty('preMarketOpen'))
        object.preMarketOpen =
          options.json && !isFinite(message.preMarketOpen) ? String(message.preMarketOpen) : message.preMarketOpen;
      if (message.preMarketOpenTime != null && message.hasOwnProperty('preMarketOpenTime'))
        if (typeof message.preMarketOpenTime === 'number')
          object.preMarketOpenTime =
            options.longs === String ? String(message.preMarketOpenTime) : message.preMarketOpenTime;
        else
          object.preMarketOpenTime =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.preMarketOpenTime)
              : options.longs === Number
                ? new $util.LongBits(
                    message.preMarketOpenTime.low >>> 0,
                    message.preMarketOpenTime.high >>> 0,
                  ).toNumber()
                : message.preMarketOpenTime;
      if (message.preMarketVolume != null && message.hasOwnProperty('preMarketVolume'))
        if (typeof message.preMarketVolume === 'number')
          object.preMarketVolume = options.longs === String ? String(message.preMarketVolume) : message.preMarketVolume;
        else
          object.preMarketVolume =
            options.longs === String
              ? $util.Long.prototype.toString.call(message.preMarketVolume)
              : options.longs === Number
                ? new $util.LongBits(message.preMarketVolume.low >>> 0, message.preMarketVolume.high >>> 0).toNumber()
                : message.preMarketVolume;
      if (message.preMarketOpenChange != null && message.hasOwnProperty('preMarketOpenChange'))
        object.preMarketOpenChange =
          options.json && !isFinite(message.preMarketOpenChange)
            ? String(message.preMarketOpenChange)
            : message.preMarketOpenChange;
      if (message.preMarketOpenChangePercent != null && message.hasOwnProperty('preMarketOpenChangePercent'))
        object.preMarketOpenChangePercent =
          options.json && !isFinite(message.preMarketOpenChangePercent)
            ? String(message.preMarketOpenChangePercent)
            : message.preMarketOpenChangePercent;
      if (message.source != null && message.hasOwnProperty('source'))
        object.source =
          options.enums === String
            ? $root.LastProtos.QuoteSource[message.source] === undefined
              ? message.source
              : $root.LastProtos.QuoteSource[message.source]
            : message.source;
      if (message.clearFieldNumbers && message.clearFieldNumbers.length) {
        object.clearFieldNumbers = [];
        for (let j = 0; j < message.clearFieldNumbers.length; ++j)
          object.clearFieldNumbers[j] = message.clearFieldNumbers[j];
      }
      if (message.totalDebtEquityRatio != null && message.hasOwnProperty('totalDebtEquityRatio'))
        object.totalDebtEquityRatio =
          options.json && !isFinite(message.totalDebtEquityRatio)
            ? String(message.totalDebtEquityRatio)
            : message.totalDebtEquityRatio;
      if (message.dividendPayoutRatio != null && message.hasOwnProperty('dividendPayoutRatio'))
        object.dividendPayoutRatio =
          options.json && !isFinite(message.dividendPayoutRatio)
            ? String(message.dividendPayoutRatio)
            : message.dividendPayoutRatio;
      if (message.operatingCashFlowPerShare != null && message.hasOwnProperty('operatingCashFlowPerShare'))
        object.operatingCashFlowPerShare =
          options.json && !isFinite(message.operatingCashFlowPerShare)
            ? String(message.operatingCashFlowPerShare)
            : message.operatingCashFlowPerShare;
      if (message.insiderPercentage != null && message.hasOwnProperty('insiderPercentage'))
        object.insiderPercentage =
          options.json && !isFinite(message.insiderPercentage)
            ? String(message.insiderPercentage)
            : message.insiderPercentage;
      if (message.priceToCashFlowRatio != null && message.hasOwnProperty('priceToCashFlowRatio'))
        object.priceToCashFlowRatio =
          options.json && !isFinite(message.priceToCashFlowRatio)
            ? String(message.priceToCashFlowRatio)
            : message.priceToCashFlowRatio;
      if (message.regularHoursChange != null && message.hasOwnProperty('regularHoursChange'))
        object.regularHoursChange =
          options.json && !isFinite(message.regularHoursChange)
            ? String(message.regularHoursChange)
            : message.regularHoursChange;
      if (message.regularHoursPercentChange != null && message.hasOwnProperty('regularHoursPercentChange'))
        object.regularHoursPercentChange =
          options.json && !isFinite(message.regularHoursPercentChange)
            ? String(message.regularHoursPercentChange)
            : message.regularHoursPercentChange;
      if (message.postToPreHoursChange != null && message.hasOwnProperty('postToPreHoursChange'))
        object.postToPreHoursChange =
          options.json && !isFinite(message.postToPreHoursChange)
            ? String(message.postToPreHoursChange)
            : message.postToPreHoursChange;
      if (message.postToPreHoursPercentChange != null && message.hasOwnProperty('postToPreHoursPercentChange'))
        object.postToPreHoursPercentChange =
          options.json && !isFinite(message.postToPreHoursPercentChange)
            ? String(message.postToPreHoursPercentChange)
            : message.postToPreHoursPercentChange;
      if (message.scannerClose != null && message.hasOwnProperty('scannerClose'))
        object.scannerClose =
          options.json && !isFinite(message.scannerClose) ? String(message.scannerClose) : message.scannerClose;
      if (message.scannerChange != null && message.hasOwnProperty('scannerChange'))
        object.scannerChange =
          options.json && !isFinite(message.scannerChange) ? String(message.scannerChange) : message.scannerChange;
      if (message.scannerChangePercent != null && message.hasOwnProperty('scannerChangePercent'))
        object.scannerChangePercent =
          options.json && !isFinite(message.scannerChangePercent)
            ? String(message.scannerChangePercent)
            : message.scannerChangePercent;
      if (message.scannerChangePercentClose != null && message.hasOwnProperty('scannerChangePercentClose'))
        object.scannerChangePercentClose =
          options.json && !isFinite(message.scannerChangePercentClose)
            ? String(message.scannerChangePercentClose)
            : message.scannerChangePercentClose;
      if (message.scannerPreviousClose != null && message.hasOwnProperty('scannerPreviousClose'))
        object.scannerPreviousClose =
          options.json && !isFinite(message.scannerPreviousClose)
            ? String(message.scannerPreviousClose)
            : message.scannerPreviousClose;
      if (message.freeCashFlow != null && message.hasOwnProperty('freeCashFlow'))
        object.freeCashFlow =
          options.json && !isFinite(message.freeCashFlow) ? String(message.freeCashFlow) : message.freeCashFlow;
      if (message.minPriceTarget != null && message.hasOwnProperty('minPriceTarget'))
        object.minPriceTarget =
          options.json && !isFinite(message.minPriceTarget) ? String(message.minPriceTarget) : message.minPriceTarget;
      if (message.maxPriceTarget != null && message.hasOwnProperty('maxPriceTarget'))
        object.maxPriceTarget =
          options.json && !isFinite(message.maxPriceTarget) ? String(message.maxPriceTarget) : message.maxPriceTarget;
      if (message.meanPriceTarget != null && message.hasOwnProperty('meanPriceTarget'))
        object.meanPriceTarget =
          options.json && !isFinite(message.meanPriceTarget)
            ? String(message.meanPriceTarget)
            : message.meanPriceTarget;
      if (message.totalNumberOfAnalyst != null && message.hasOwnProperty('totalNumberOfAnalyst'))
        object.totalNumberOfAnalyst =
          options.json && !isFinite(message.totalNumberOfAnalyst)
            ? String(message.totalNumberOfAnalyst)
            : message.totalNumberOfAnalyst;
      if (message.averageAnalystRecommendation != null && message.hasOwnProperty('averageAnalystRecommendation'))
        object.averageAnalystRecommendation = message.averageAnalystRecommendation;
      if (message.pegRatio != null && message.hasOwnProperty('pegRatio'))
        object.pegRatio = options.json && !isFinite(message.pegRatio) ? String(message.pegRatio) : message.pegRatio;
      if (message.priceToFreeCashFlowRatio != null && message.hasOwnProperty('priceToFreeCashFlowRatio'))
        object.priceToFreeCashFlowRatio =
          options.json && !isFinite(message.priceToFreeCashFlowRatio)
            ? String(message.priceToFreeCashFlowRatio)
            : message.priceToFreeCashFlowRatio;
      if (message.distanceToMaxPriceTarget != null && message.hasOwnProperty('distanceToMaxPriceTarget'))
        object.distanceToMaxPriceTarget =
          options.json && !isFinite(message.distanceToMaxPriceTarget)
            ? String(message.distanceToMaxPriceTarget)
            : message.distanceToMaxPriceTarget;
      if (message.distanceToMinPriceTarget != null && message.hasOwnProperty('distanceToMinPriceTarget'))
        object.distanceToMinPriceTarget =
          options.json && !isFinite(message.distanceToMinPriceTarget)
            ? String(message.distanceToMinPriceTarget)
            : message.distanceToMinPriceTarget;
      if (message.distanceToMeanPriceTarget != null && message.hasOwnProperty('distanceToMeanPriceTarget'))
        object.distanceToMeanPriceTarget =
          options.json && !isFinite(message.distanceToMeanPriceTarget)
            ? String(message.distanceToMeanPriceTarget)
            : message.distanceToMeanPriceTarget;
      if (message.shortTermTrend != null && message.hasOwnProperty('shortTermTrend'))
        object.shortTermTrend = message.shortTermTrend;
      if (message.mediumTermTrend != null && message.hasOwnProperty('mediumTermTrend'))
        object.mediumTermTrend = message.mediumTermTrend;
      if (message.longTermTrend != null && message.hasOwnProperty('longTermTrend'))
        object.longTermTrend = message.longTermTrend;
      return object;
    };

    /**
     * Converts this Quote to JSON.
     * @function toJSON
     * @memberof LastProtos.Quote
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Quote.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Quote;
  })();

  LastProtos.QuoteSnapshot = (function () {
    /**
     * Properties of a QuoteSnapshot.
     * @memberof LastProtos
     * @interface IQuoteSnapshot
     * @property {string|null} [date] QuoteSnapshot date
     * @property {Array.<LastProtos.IQuote>|null} [quotes] QuoteSnapshot quotes
     */

    /**
     * Constructs a new QuoteSnapshot.
     * @memberof LastProtos
     * @classdesc Represents a QuoteSnapshot.
     * @implements IQuoteSnapshot
     * @constructor
     * @param {LastProtos.IQuoteSnapshot=} [properties] Properties to set
     */
    function QuoteSnapshot(properties) {
      this.quotes = [];
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * QuoteSnapshot date.
     * @member {string} date
     * @memberof LastProtos.QuoteSnapshot
     * @instance
     */
    QuoteSnapshot.prototype.date = '';

    /**
     * QuoteSnapshot quotes.
     * @member {Array.<LastProtos.IQuote>} quotes
     * @memberof LastProtos.QuoteSnapshot
     * @instance
     */
    QuoteSnapshot.prototype.quotes = $util.emptyArray;

    /**
     * Creates a new QuoteSnapshot instance using the specified properties.
     * @function create
     * @memberof LastProtos.QuoteSnapshot
     * @static
     * @param {LastProtos.IQuoteSnapshot=} [properties] Properties to set
     * @returns {LastProtos.QuoteSnapshot} QuoteSnapshot instance
     */
    QuoteSnapshot.create = function create(properties) {
      return new QuoteSnapshot(properties);
    };

    /**
     * Encodes the specified QuoteSnapshot message. Does not implicitly {@link LastProtos.QuoteSnapshot.verify|verify} messages.
     * @function encode
     * @memberof LastProtos.QuoteSnapshot
     * @static
     * @param {LastProtos.IQuoteSnapshot} message QuoteSnapshot message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QuoteSnapshot.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.date != null && Object.hasOwnProperty.call(message, 'date'))
        writer.uint32(/* id 10, wireType 2 =*/ 82).string(message.date);
      if (message.quotes != null && message.quotes.length)
        for (let i = 0; i < message.quotes.length; ++i)
          $root.LastProtos.Quote.encode(message.quotes[i], writer.uint32(/* id 11, wireType 2 =*/ 90).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified QuoteSnapshot message, length delimited. Does not implicitly {@link LastProtos.QuoteSnapshot.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LastProtos.QuoteSnapshot
     * @static
     * @param {LastProtos.IQuoteSnapshot} message QuoteSnapshot message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QuoteSnapshot.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a QuoteSnapshot message from the specified reader or buffer.
     * @function decode
     * @memberof LastProtos.QuoteSnapshot
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LastProtos.QuoteSnapshot} QuoteSnapshot
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QuoteSnapshot.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.LastProtos.QuoteSnapshot();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 10: {
            message.date = reader.string();
            break;
          }
          case 11: {
            if (!(message.quotes && message.quotes.length)) message.quotes = [];
            message.quotes.push($root.LastProtos.Quote.decode(reader, reader.uint32()));
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a QuoteSnapshot message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LastProtos.QuoteSnapshot
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LastProtos.QuoteSnapshot} QuoteSnapshot
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QuoteSnapshot.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a QuoteSnapshot message.
     * @function verify
     * @memberof LastProtos.QuoteSnapshot
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    QuoteSnapshot.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.date != null && message.hasOwnProperty('date'))
        if (!$util.isString(message.date)) return 'date: string expected';
      if (message.quotes != null && message.hasOwnProperty('quotes')) {
        if (!Array.isArray(message.quotes)) return 'quotes: array expected';
        for (let i = 0; i < message.quotes.length; ++i) {
          let error = $root.LastProtos.Quote.verify(message.quotes[i]);
          if (error) return 'quotes.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a QuoteSnapshot message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LastProtos.QuoteSnapshot
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LastProtos.QuoteSnapshot} QuoteSnapshot
     */
    QuoteSnapshot.fromObject = function fromObject(object) {
      if (object instanceof $root.LastProtos.QuoteSnapshot) return object;
      let message = new $root.LastProtos.QuoteSnapshot();
      if (object.date != null) message.date = String(object.date);
      if (object.quotes) {
        if (!Array.isArray(object.quotes)) throw TypeError('.LastProtos.QuoteSnapshot.quotes: array expected');
        message.quotes = [];
        for (let i = 0; i < object.quotes.length; ++i) {
          if (typeof object.quotes[i] !== 'object')
            throw TypeError('.LastProtos.QuoteSnapshot.quotes: object expected');
          message.quotes[i] = $root.LastProtos.Quote.fromObject(object.quotes[i]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a QuoteSnapshot message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LastProtos.QuoteSnapshot
     * @static
     * @param {LastProtos.QuoteSnapshot} message QuoteSnapshot
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    QuoteSnapshot.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.arrays || options.defaults) object.quotes = [];
      if (options.defaults) object.date = '';
      if (message.date != null && message.hasOwnProperty('date')) object.date = message.date;
      if (message.quotes && message.quotes.length) {
        object.quotes = [];
        for (let j = 0; j < message.quotes.length; ++j)
          object.quotes[j] = $root.LastProtos.Quote.toObject(message.quotes[j], options);
      }
      return object;
    };

    /**
     * Converts this QuoteSnapshot to JSON.
     * @function toJSON
     * @memberof LastProtos.QuoteSnapshot
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    QuoteSnapshot.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return QuoteSnapshot;
  })();

  LastProtos.QuoteSnapshotResponse = (function () {
    /**
     * Properties of a QuoteSnapshotResponse.
     * @memberof LastProtos
     * @interface IQuoteSnapshotResponse
     * @property {Object.<string,LastProtos.IQuoteSnapshot>|null} [snapshotData] QuoteSnapshotResponse snapshotData
     */

    /**
     * Constructs a new QuoteSnapshotResponse.
     * @memberof LastProtos
     * @classdesc Represents a QuoteSnapshotResponse.
     * @implements IQuoteSnapshotResponse
     * @constructor
     * @param {LastProtos.IQuoteSnapshotResponse=} [properties] Properties to set
     */
    function QuoteSnapshotResponse(properties) {
      this.snapshotData = {};
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * QuoteSnapshotResponse snapshotData.
     * @member {Object.<string,LastProtos.IQuoteSnapshot>} snapshotData
     * @memberof LastProtos.QuoteSnapshotResponse
     * @instance
     */
    QuoteSnapshotResponse.prototype.snapshotData = $util.emptyObject;

    /**
     * Creates a new QuoteSnapshotResponse instance using the specified properties.
     * @function create
     * @memberof LastProtos.QuoteSnapshotResponse
     * @static
     * @param {LastProtos.IQuoteSnapshotResponse=} [properties] Properties to set
     * @returns {LastProtos.QuoteSnapshotResponse} QuoteSnapshotResponse instance
     */
    QuoteSnapshotResponse.create = function create(properties) {
      return new QuoteSnapshotResponse(properties);
    };

    /**
     * Encodes the specified QuoteSnapshotResponse message. Does not implicitly {@link LastProtos.QuoteSnapshotResponse.verify|verify} messages.
     * @function encode
     * @memberof LastProtos.QuoteSnapshotResponse
     * @static
     * @param {LastProtos.IQuoteSnapshotResponse} message QuoteSnapshotResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QuoteSnapshotResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.snapshotData != null && Object.hasOwnProperty.call(message, 'snapshotData'))
        for (let keys = Object.keys(message.snapshotData), i = 0; i < keys.length; ++i) {
          writer.uint32(/* id 10, wireType 2 =*/ 82).fork().uint32(/* id 1, wireType 2 =*/ 10).string(keys[i]);
          $root.LastProtos.QuoteSnapshot.encode(
            message.snapshotData[keys[i]],
            writer.uint32(/* id 2, wireType 2 =*/ 18).fork(),
          )
            .ldelim()
            .ldelim();
        }
      return writer;
    };

    /**
     * Encodes the specified QuoteSnapshotResponse message, length delimited. Does not implicitly {@link LastProtos.QuoteSnapshotResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LastProtos.QuoteSnapshotResponse
     * @static
     * @param {LastProtos.IQuoteSnapshotResponse} message QuoteSnapshotResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    QuoteSnapshotResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a QuoteSnapshotResponse message from the specified reader or buffer.
     * @function decode
     * @memberof LastProtos.QuoteSnapshotResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LastProtos.QuoteSnapshotResponse} QuoteSnapshotResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QuoteSnapshotResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.LastProtos.QuoteSnapshotResponse(),
        key,
        value;
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 10: {
            if (message.snapshotData === $util.emptyObject) message.snapshotData = {};
            let end2 = reader.uint32() + reader.pos;
            key = '';
            value = null;
            while (reader.pos < end2) {
              let tag2 = reader.uint32();
              switch (tag2 >>> 3) {
                case 1:
                  key = reader.string();
                  break;
                case 2:
                  value = $root.LastProtos.QuoteSnapshot.decode(reader, reader.uint32());
                  break;
                default:
                  reader.skipType(tag2 & 7);
                  break;
              }
            }
            message.snapshotData[key] = value;
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes a QuoteSnapshotResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LastProtos.QuoteSnapshotResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LastProtos.QuoteSnapshotResponse} QuoteSnapshotResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    QuoteSnapshotResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a QuoteSnapshotResponse message.
     * @function verify
     * @memberof LastProtos.QuoteSnapshotResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    QuoteSnapshotResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.snapshotData != null && message.hasOwnProperty('snapshotData')) {
        if (!$util.isObject(message.snapshotData)) return 'snapshotData: object expected';
        let key = Object.keys(message.snapshotData);
        for (let i = 0; i < key.length; ++i) {
          let error = $root.LastProtos.QuoteSnapshot.verify(message.snapshotData[key[i]]);
          if (error) return 'snapshotData.' + error;
        }
      }
      return null;
    };

    /**
     * Creates a QuoteSnapshotResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LastProtos.QuoteSnapshotResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LastProtos.QuoteSnapshotResponse} QuoteSnapshotResponse
     */
    QuoteSnapshotResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.LastProtos.QuoteSnapshotResponse) return object;
      let message = new $root.LastProtos.QuoteSnapshotResponse();
      if (object.snapshotData) {
        if (typeof object.snapshotData !== 'object')
          throw TypeError('.LastProtos.QuoteSnapshotResponse.snapshotData: object expected');
        message.snapshotData = {};
        for (let keys = Object.keys(object.snapshotData), i = 0; i < keys.length; ++i) {
          if (typeof object.snapshotData[keys[i]] !== 'object')
            throw TypeError('.LastProtos.QuoteSnapshotResponse.snapshotData: object expected');
          message.snapshotData[keys[i]] = $root.LastProtos.QuoteSnapshot.fromObject(object.snapshotData[keys[i]]);
        }
      }
      return message;
    };

    /**
     * Creates a plain object from a QuoteSnapshotResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LastProtos.QuoteSnapshotResponse
     * @static
     * @param {LastProtos.QuoteSnapshotResponse} message QuoteSnapshotResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    QuoteSnapshotResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.objects || options.defaults) object.snapshotData = {};
      let keys2;
      if (message.snapshotData && (keys2 = Object.keys(message.snapshotData)).length) {
        object.snapshotData = {};
        for (let j = 0; j < keys2.length; ++j)
          object.snapshotData[keys2[j]] = $root.LastProtos.QuoteSnapshot.toObject(
            message.snapshotData[keys2[j]],
            options,
          );
      }
      return object;
    };

    /**
     * Converts this QuoteSnapshotResponse to JSON.
     * @function toJSON
     * @memberof LastProtos.QuoteSnapshotResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    QuoteSnapshotResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return QuoteSnapshotResponse;
  })();

  return LastProtos;
})());

export const CommonProtos = ($root.CommonProtos = (() => {
  /**
   * Namespace CommonProtos.
   * @exports CommonProtos
   * @namespace
   */
  const CommonProtos = {};

  CommonProtos.Err = (function () {
    /**
     * Properties of an Err.
     * @memberof CommonProtos
     * @interface IErr
     * @property {number|null} [code] Err code
     * @property {string|null} [message] Err message
     * @property {string|null} [detail] Err detail
     */

    /**
     * Constructs a new Err.
     * @memberof CommonProtos
     * @classdesc Represents an Err.
     * @implements IErr
     * @constructor
     * @param {CommonProtos.IErr=} [properties] Properties to set
     */
    function Err(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * Err code.
     * @member {number} code
     * @memberof CommonProtos.Err
     * @instance
     */
    Err.prototype.code = 0;

    /**
     * Err message.
     * @member {string} message
     * @memberof CommonProtos.Err
     * @instance
     */
    Err.prototype.message = '';

    /**
     * Err detail.
     * @member {string} detail
     * @memberof CommonProtos.Err
     * @instance
     */
    Err.prototype.detail = '';

    /**
     * Creates a new Err instance using the specified properties.
     * @function create
     * @memberof CommonProtos.Err
     * @static
     * @param {CommonProtos.IErr=} [properties] Properties to set
     * @returns {CommonProtos.Err} Err instance
     */
    Err.create = function create(properties) {
      return new Err(properties);
    };

    /**
     * Encodes the specified Err message. Does not implicitly {@link CommonProtos.Err.verify|verify} messages.
     * @function encode
     * @memberof CommonProtos.Err
     * @static
     * @param {CommonProtos.IErr} message Err message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Err.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.code != null && Object.hasOwnProperty.call(message, 'code'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.code);
      if (message.message != null && Object.hasOwnProperty.call(message, 'message'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.message);
      if (message.detail != null && Object.hasOwnProperty.call(message, 'detail'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.detail);
      return writer;
    };

    /**
     * Encodes the specified Err message, length delimited. Does not implicitly {@link CommonProtos.Err.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CommonProtos.Err
     * @static
     * @param {CommonProtos.IErr} message Err message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Err.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Err message from the specified reader or buffer.
     * @function decode
     * @memberof CommonProtos.Err
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CommonProtos.Err} Err
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Err.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.CommonProtos.Err();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.code = reader.int32();
            break;
          }
          case 2: {
            message.message = reader.string();
            break;
          }
          case 3: {
            message.detail = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an Err message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CommonProtos.Err
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CommonProtos.Err} Err
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Err.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Err message.
     * @function verify
     * @memberof CommonProtos.Err
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Err.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.code != null && message.hasOwnProperty('code'))
        if (!$util.isInteger(message.code)) return 'code: integer expected';
      if (message.message != null && message.hasOwnProperty('message'))
        if (!$util.isString(message.message)) return 'message: string expected';
      if (message.detail != null && message.hasOwnProperty('detail'))
        if (!$util.isString(message.detail)) return 'detail: string expected';
      return null;
    };

    /**
     * Creates an Err message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CommonProtos.Err
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CommonProtos.Err} Err
     */
    Err.fromObject = function fromObject(object) {
      if (object instanceof $root.CommonProtos.Err) return object;
      let message = new $root.CommonProtos.Err();
      if (object.code != null) message.code = object.code | 0;
      if (object.message != null) message.message = String(object.message);
      if (object.detail != null) message.detail = String(object.detail);
      return message;
    };

    /**
     * Creates a plain object from an Err message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CommonProtos.Err
     * @static
     * @param {CommonProtos.Err} message Err
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Err.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.code = 0;
        object.message = '';
        object.detail = '';
      }
      if (message.code != null && message.hasOwnProperty('code')) object.code = message.code;
      if (message.message != null && message.hasOwnProperty('message')) object.message = message.message;
      if (message.detail != null && message.hasOwnProperty('detail')) object.detail = message.detail;
      return object;
    };

    /**
     * Converts this Err to JSON.
     * @function toJSON
     * @memberof CommonProtos.Err
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Err.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Err;
  })();

  CommonProtos.ApiError = (function () {
    /**
     * Properties of an ApiError.
     * @memberof CommonProtos
     * @interface IApiError
     * @property {number|null} [code] ApiError code
     * @property {string|null} [description] ApiError description
     * @property {string|null} [detail] ApiError detail
     * @property {number|null} [httpStatus] ApiError httpStatus
     */

    /**
     * Constructs a new ApiError.
     * @memberof CommonProtos
     * @classdesc Represents an ApiError.
     * @implements IApiError
     * @constructor
     * @param {CommonProtos.IApiError=} [properties] Properties to set
     */
    function ApiError(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApiError code.
     * @member {number} code
     * @memberof CommonProtos.ApiError
     * @instance
     */
    ApiError.prototype.code = 0;

    /**
     * ApiError description.
     * @member {string} description
     * @memberof CommonProtos.ApiError
     * @instance
     */
    ApiError.prototype.description = '';

    /**
     * ApiError detail.
     * @member {string} detail
     * @memberof CommonProtos.ApiError
     * @instance
     */
    ApiError.prototype.detail = '';

    /**
     * ApiError httpStatus.
     * @member {number} httpStatus
     * @memberof CommonProtos.ApiError
     * @instance
     */
    ApiError.prototype.httpStatus = 0;

    /**
     * Creates a new ApiError instance using the specified properties.
     * @function create
     * @memberof CommonProtos.ApiError
     * @static
     * @param {CommonProtos.IApiError=} [properties] Properties to set
     * @returns {CommonProtos.ApiError} ApiError instance
     */
    ApiError.create = function create(properties) {
      return new ApiError(properties);
    };

    /**
     * Encodes the specified ApiError message. Does not implicitly {@link CommonProtos.ApiError.verify|verify} messages.
     * @function encode
     * @memberof CommonProtos.ApiError
     * @static
     * @param {CommonProtos.IApiError} message ApiError message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiError.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.code != null && Object.hasOwnProperty.call(message, 'code'))
        writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.code);
      if (message.description != null && Object.hasOwnProperty.call(message, 'description'))
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.description);
      if (message.detail != null && Object.hasOwnProperty.call(message, 'detail'))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.detail);
      if (message.httpStatus != null && Object.hasOwnProperty.call(message, 'httpStatus'))
        writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.httpStatus);
      return writer;
    };

    /**
     * Encodes the specified ApiError message, length delimited. Does not implicitly {@link CommonProtos.ApiError.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CommonProtos.ApiError
     * @static
     * @param {CommonProtos.IApiError} message ApiError message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiError.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApiError message from the specified reader or buffer.
     * @function decode
     * @memberof CommonProtos.ApiError
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CommonProtos.ApiError} ApiError
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiError.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.CommonProtos.ApiError();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.code = reader.int32();
            break;
          }
          case 2: {
            message.description = reader.string();
            break;
          }
          case 3: {
            message.detail = reader.string();
            break;
          }
          case 4: {
            message.httpStatus = reader.int32();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an ApiError message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CommonProtos.ApiError
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CommonProtos.ApiError} ApiError
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiError.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApiError message.
     * @function verify
     * @memberof CommonProtos.ApiError
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApiError.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.code != null && message.hasOwnProperty('code'))
        if (!$util.isInteger(message.code)) return 'code: integer expected';
      if (message.description != null && message.hasOwnProperty('description'))
        if (!$util.isString(message.description)) return 'description: string expected';
      if (message.detail != null && message.hasOwnProperty('detail'))
        if (!$util.isString(message.detail)) return 'detail: string expected';
      if (message.httpStatus != null && message.hasOwnProperty('httpStatus'))
        if (!$util.isInteger(message.httpStatus)) return 'httpStatus: integer expected';
      return null;
    };

    /**
     * Creates an ApiError message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CommonProtos.ApiError
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CommonProtos.ApiError} ApiError
     */
    ApiError.fromObject = function fromObject(object) {
      if (object instanceof $root.CommonProtos.ApiError) return object;
      let message = new $root.CommonProtos.ApiError();
      if (object.code != null) message.code = object.code | 0;
      if (object.description != null) message.description = String(object.description);
      if (object.detail != null) message.detail = String(object.detail);
      if (object.httpStatus != null) message.httpStatus = object.httpStatus | 0;
      return message;
    };

    /**
     * Creates a plain object from an ApiError message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CommonProtos.ApiError
     * @static
     * @param {CommonProtos.ApiError} message ApiError
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApiError.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) {
        object.code = 0;
        object.description = '';
        object.detail = '';
        object.httpStatus = 0;
      }
      if (message.code != null && message.hasOwnProperty('code')) object.code = message.code;
      if (message.description != null && message.hasOwnProperty('description'))
        object.description = message.description;
      if (message.detail != null && message.hasOwnProperty('detail')) object.detail = message.detail;
      if (message.httpStatus != null && message.hasOwnProperty('httpStatus')) object.httpStatus = message.httpStatus;
      return object;
    };

    /**
     * Converts this ApiError to JSON.
     * @function toJSON
     * @memberof CommonProtos.ApiError
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApiError.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ApiError;
  })();

  CommonProtos.ApiErrorResponse = (function () {
    /**
     * Properties of an ApiErrorResponse.
     * @memberof CommonProtos
     * @interface IApiErrorResponse
     * @property {CommonProtos.IApiError|null} [error] ApiErrorResponse error
     */

    /**
     * Constructs a new ApiErrorResponse.
     * @memberof CommonProtos
     * @classdesc Represents an ApiErrorResponse.
     * @implements IApiErrorResponse
     * @constructor
     * @param {CommonProtos.IApiErrorResponse=} [properties] Properties to set
     */
    function ApiErrorResponse(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApiErrorResponse error.
     * @member {CommonProtos.IApiError|null|undefined} error
     * @memberof CommonProtos.ApiErrorResponse
     * @instance
     */
    ApiErrorResponse.prototype.error = null;

    /**
     * Creates a new ApiErrorResponse instance using the specified properties.
     * @function create
     * @memberof CommonProtos.ApiErrorResponse
     * @static
     * @param {CommonProtos.IApiErrorResponse=} [properties] Properties to set
     * @returns {CommonProtos.ApiErrorResponse} ApiErrorResponse instance
     */
    ApiErrorResponse.create = function create(properties) {
      return new ApiErrorResponse(properties);
    };

    /**
     * Encodes the specified ApiErrorResponse message. Does not implicitly {@link CommonProtos.ApiErrorResponse.verify|verify} messages.
     * @function encode
     * @memberof CommonProtos.ApiErrorResponse
     * @static
     * @param {CommonProtos.IApiErrorResponse} message ApiErrorResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiErrorResponse.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.error != null && Object.hasOwnProperty.call(message, 'error'))
        $root.CommonProtos.ApiError.encode(message.error, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
      return writer;
    };

    /**
     * Encodes the specified ApiErrorResponse message, length delimited. Does not implicitly {@link CommonProtos.ApiErrorResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CommonProtos.ApiErrorResponse
     * @static
     * @param {CommonProtos.IApiErrorResponse} message ApiErrorResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiErrorResponse.encodeDelimited = function encodeDelimited(message, writer) {
      return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApiErrorResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CommonProtos.ApiErrorResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CommonProtos.ApiErrorResponse} ApiErrorResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiErrorResponse.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.CommonProtos.ApiErrorResponse();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.error = $root.CommonProtos.ApiError.decode(reader, reader.uint32());
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    /**
     * Decodes an ApiErrorResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CommonProtos.ApiErrorResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CommonProtos.ApiErrorResponse} ApiErrorResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiErrorResponse.decodeDelimited = function decodeDelimited(reader) {
      if (!(reader instanceof $Reader)) reader = new $Reader(reader);
      return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApiErrorResponse message.
     * @function verify
     * @memberof CommonProtos.ApiErrorResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApiErrorResponse.verify = function verify(message) {
      if (typeof message !== 'object' || message === null) return 'object expected';
      if (message.error != null && message.hasOwnProperty('error')) {
        let error = $root.CommonProtos.ApiError.verify(message.error);
        if (error) return 'error.' + error;
      }
      return null;
    };

    /**
     * Creates an ApiErrorResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CommonProtos.ApiErrorResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CommonProtos.ApiErrorResponse} ApiErrorResponse
     */
    ApiErrorResponse.fromObject = function fromObject(object) {
      if (object instanceof $root.CommonProtos.ApiErrorResponse) return object;
      let message = new $root.CommonProtos.ApiErrorResponse();
      if (object.error != null) {
        if (typeof object.error !== 'object') throw TypeError('.CommonProtos.ApiErrorResponse.error: object expected');
        message.error = $root.CommonProtos.ApiError.fromObject(object.error);
      }
      return message;
    };

    /**
     * Creates a plain object from an ApiErrorResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CommonProtos.ApiErrorResponse
     * @static
     * @param {CommonProtos.ApiErrorResponse} message ApiErrorResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApiErrorResponse.toObject = function toObject(message, options) {
      if (!options) options = {};
      let object = {};
      if (options.defaults) object.error = null;
      if (message.error != null && message.hasOwnProperty('error'))
        object.error = $root.CommonProtos.ApiError.toObject(message.error, options);
      return object;
    };

    /**
     * Converts this ApiErrorResponse to JSON.
     * @function toJSON
     * @memberof CommonProtos.ApiErrorResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApiErrorResponse.prototype.toJSON = function toJSON() {
      return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ApiErrorResponse;
  })();

  return CommonProtos;
})());

export { $root as default };
